var _excluded = ["fontSize", "icon", "weight", "zIndex", "hoverColor"],
    _excluded2 = ["type", "url", "children", "adaptive"],
    _excluded3 = ["type", "url", "children", "adaptive"],
    _excluded4 = ["loading", "disabled", "children", "icon"],
    _excluded5 = ["blink", "sad", "width"],
    _excluded6 = ["children", "isCloseButton", "icon", "isOpen", "label"],
    _excluded7 = ["size"],
    _excluded8 = ["color", "size"],
    _excluded9 = ["color", "size"],
    _excluded10 = ["size"],
    _excluded11 = ["size"],
    _excluded12 = ["size"],
    _excluded13 = ["size"],
    _excluded14 = ["width"],
    _excluded15 = ["size"],
    _excluded16 = ["size"],
    _excluded17 = ["size"],
    _excluded18 = ["size"],
    _excluded19 = ["size"],
    _excluded20 = ["width"],
    _excluded21 = ["width"],
    _excluded22 = ["height"],
    _excluded23 = ["size"],
    _excluded24 = ["size"],
    _excluded25 = ["size"],
    _excluded26 = ["size"],
    _excluded27 = ["size"],
    _excluded28 = ["size"],
    _excluded29 = ["size"],
    _excluded30 = ["size"],
    _excluded31 = ["size"],
    _excluded32 = ["size"],
    _excluded33 = ["size"],
    _excluded34 = ["adaptive", "checked", "hideOutline", "onChange", "onBlur", "name", "small", "value", "icon", "disabled"],
    _excluded35 = ["children", "limitIconHeight"],
    _excluded36 = ["children", "error", "icon", "iconRight", "label", "limitIconHeight"],
    _excluded37 = ["disabled", "error", "icon", "iconRight", "label", "type"],
    _excluded38 = ["min", "max", "step", "onChange", "value"],
    _excluded39 = ["children", "disabled", "error", "icon", "label", "placeholder", "value", "secondary", "pill"],
    _excluded40 = ["disabled", "error", "getOptionText", "getOptionValue", "icon", "label", "placeholder", "onChange", "options", "value"],
    _excluded41 = ["disabled", "error", "icon", "label", "rows", "wrapperProps"],
    _excluded42 = ["value", "onValue", "offValue", "onChange", "sliderBackground"],
    _excluded43 = ["scope", "children"],
    _excluded44 = ["children"],
    _excluded45 = ["children"],
    _excluded46 = ["asChild"],
    _excluded47 = ["scope", "children"],
    _excluded48 = ["name", "min", "max", "step", "orientation", "disabled", "minStepsBetweenThumbs", "defaultValue", "value", "onValueChange", "onValueCommit", "inverted"],
    _excluded49 = ["min", "max", "dir", "inverted", "onSlideStart", "onSlideMove", "onSlideEnd", "onStepKeyDown"],
    _excluded50 = ["min", "max", "inverted", "onSlideStart", "onSlideMove", "onSlideEnd", "onStepKeyDown"],
    _excluded51 = ["__scopeSlider", "onSlideStart", "onSlideMove", "onSlideEnd", "onHomeKeyDown", "onEndKeyDown", "onStepKeyDown"],
    _excluded52 = ["__scopeSlider"],
    _excluded53 = ["__scopeSlider"],
    _excluded54 = ["__scopeSlider", "index"],
    _excluded55 = ["value"],
    _excluded56 = ["showCurrentTime", "showRemainingTime", "src", "variant", "handleAudioDeletion", "limit", "pausable", "currentPlayedTimes", "onPlay", "onPause"],
    _excluded57 = ["bg", "width", "height"],
    _excluded58 = ["duration", "isDarkBackground", "isAutoplay", "size", "onClick"],
    _excluded59 = ["children", "currentIndex", "setIndex", "isDarkBackground"],
    _excluded60 = ["children", "infinite", "allowSwipe", "navigationType", "autoplay"],
    _excluded61 = ["label", "disabled", "selected", "icon"],
    _excluded62 = ["choices"],
    _excluded63 = ["message", "action", "isOpen"],
    _excluded64 = ["as"],
    _excluded65 = ["children"],
    _excluded66 = ["open", "defaultOpen", "disabled", "onOpenChange"],
    _excluded67 = ["as", "onClick"],
    _excluded68 = ["forceMount"],
    _excluded69 = ["present", "children"],
    _excluded70 = ["children"],
    _excluded71 = ["children"],
    _excluded72 = ["asChild"],
    _excluded73 = ["disableOutsidePointerEvents", "onEscapeKeyDown", "onPointerDownOutside", "onFocusOutside", "onInteractOutside", "onDismiss"],
    _excluded74 = ["loop", "trapped", "onMountAutoFocus", "onUnmountAutoFocus"],
    _excluded75 = ["container"],
    _excluded76 = ["scope", "children"],
    _excluded77 = ["__scopeDialog"],
    _excluded78 = ["forceMount"],
    _excluded79 = ["__scopeDialog"],
    _excluded80 = ["forceMount"],
    _excluded81 = ["__scopeDialog", "trapFocus", "onOpenAutoFocus", "onCloseAutoFocus"],
    _excluded82 = ["__scopeDialog"],
    _excluded83 = ["__scopeDialog"],
    _excluded84 = ["__scopeDialog"],
    _excluded85 = ["children", "noCloseButton"],
    _excluded86 = ["children"],
    _excluded87 = ["onOpenAutoFocus", "onPointerDownOutside", "onAnimationEnd", "style"],
    _excluded88 = ["onDrag", "onOpenChange"],
    _excluded89 = ["shouldScaleBackground"],
    _excluded90 = ["children", "direction"],
    _excluded91 = ["dragIndicator"],
    _excluded92 = ["children"],
    _excluded93 = ["children"],
    _excluded94 = ["asChild"],
    _excluded95 = ["scope", "children"],
    _excluded96 = ["scope", "children"],
    _excluded97 = ["__scopeRovingFocusGroup", "orientation", "dir", "loop", "currentTabStopId", "defaultCurrentTabStopId", "onCurrentTabStopIdChange", "onEntryFocus"],
    _excluded98 = ["__scopeRovingFocusGroup", "focusable", "active"],
    _excluded99 = ["containerRef", "style"],
    _excluded100 = ["children", "width", "height"],
    _excluded101 = ["__scopePopper", "virtualRef"],
    _excluded102 = ["__scopePopper", "side", "sideOffset", "align", "alignOffset", "collisionTolerance", "avoidCollisions"],
    _excluded103 = ["__scopePopper", "offset"],
    _excluded104 = ["loop", "trapped", "onMountAutoFocus", "onUnmountAutoFocus"],
    _excluded105 = ["disableOutsidePointerEvents", "onEscapeKeyDown", "onPointerDownOutside", "onFocusOutside", "onInteractOutside", "onDismiss"],
    _excluded106 = ["__scopeMenu"],
    _excluded107 = ["forceMount"],
    _excluded108 = ["__scopeMenu", "loop", "trapFocus", "onOpenAutoFocus", "onCloseAutoFocus", "disableOutsidePointerEvents", "onEscapeKeyDown", "onPointerDownOutside", "onFocusOutside", "onInteractOutside", "onDismiss", "disableOutsideScroll", "allowPinchZoom", "portalled"],
    _excluded109 = ["disabled", "onSelect"],
    _excluded110 = ["__scopeMenu", "disabled", "textValue"],
    _excluded111 = ["__scopeDropdownMenu", "disabled"],
    _excluded112 = ["__scopeDropdownMenu"],
    _excluded113 = ["__scopeDropdownMenu", "portalled"],
    _excluded114 = ["__scopeDropdownMenu"],
    _excluded115 = ["__scopeHoverCard"],
    _excluded116 = ["forceMount"],
    _excluded117 = ["__scopeHoverCard", "portalled", "onEscapeKeyDown", "onPointerDownOutside", "onFocusOutside", "onInteractOutside"],
    _excluded118 = ["__scopeHoverCard"],
    _excluded119 = ["level", "activeColor", "inactiveColor", "outline", "size"],
    _excluded120 = ["size"],
    _excluded121 = ["component"],
    _excluded122 = ["currentPage", "totalPages", "onPageButtonClicked"],
    _excluded123 = ["__scopePopover"],
    _excluded124 = ["__scopePopover"],
    _excluded125 = ["forceMount"],
    _excluded126 = ["allowPinchZoom", "portalled"],
    _excluded127 = ["portalled"],
    _excluded128 = ["__scopePopover", "trapFocus", "onOpenAutoFocus", "onCloseAutoFocus", "disableOutsidePointerEvents", "onEscapeKeyDown", "onPointerDownOutside", "onFocusOutside", "onInteractOutside"],
    _excluded129 = ["__scopePopover"],
    _excluded130 = ["progress", "total"],
    _excluded131 = ["children"],
    _excluded132 = ["children"],
    _excluded133 = ["asChild"],
    _excluded134 = ["decorative", "orientation"],
    _excluded135 = ["scope", "children"],
    _excluded136 = ["children"],
    _excluded137 = ["children"],
    _excluded138 = ["asChild"],
    _excluded139 = ["scope", "children"],
    _excluded140 = ["__scopeRovingFocusGroup", "orientation", "loop", "dir", "currentTabStopId", "defaultCurrentTabStopId", "onCurrentTabStopIdChange", "onEntryFocus"],
    _excluded141 = ["__scopeRovingFocusGroup", "focusable", "active", "tabStopId"],
    _excluded142 = ["children"],
    _excluded143 = ["children"],
    _excluded144 = ["asChild"],
    _excluded145 = ["pressed", "defaultPressed", "onPressedChange"],
    _excluded146 = ["type"],
    _excluded147 = ["value", "defaultValue", "onValueChange"],
    _excluded148 = ["value", "defaultValue", "onValueChange"],
    _excluded149 = ["__scopeToggleGroup", "disabled", "rovingFocus", "orientation", "dir", "loop"],
    _excluded150 = ["__scopeToggleGroup", "value"],
    _excluded151 = ["disabled", "label", "onClick", "value", "isSelected"],
    _excluded152 = ["onClose", "onInfo", "showInfo", "children"],
    _excluded153 = ["__scopeTooltip"],
    _excluded154 = ["forceMount"],
    _excluded155 = ["__scopeTooltip", "children", "aria-label", "portalled"],
    _excluded156 = ["__scopeTooltip"],
    _excluded157 = ["src", "name", "withName", "size"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;

function _readOnlyError(name) { throw new TypeError("\"" + name + "\" is read-only"); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e52) { throw _e52; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e53) { didErr = true; err = _e53; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? t(exports, require("styled-components"), require("styled-system"), require("prop-types"), require("react"), require("ramda/src/equals"), require("ramda/src/cond"), require("react/jsx-runtime"), require("ramda/src/identity"), require("react-dom"), require("ramda/src/propEq"), require("ramda/src/none"), require("ramda/src/inc"), require("ramda/src/without"), require("ramda/src/find"), require("punycode"), require("ramda/src/dec"), require("ramda/src/mergeRight"), require("ramda/src/append"), require("ramda/src/T"), require("ramda/src/always"), require("ramda/src/evolve"), require("ramda/src/assoc"), require("ramda/src/includes"), require("ramda/src/isEmpty")) : "function" == typeof define && define.amd ? define(["exports", "styled-components", "styled-system", "prop-types", "react", "ramda/src/equals", "ramda/src/cond", "react/jsx-runtime", "ramda/src/identity", "react-dom", "ramda/src/propEq", "ramda/src/none", "ramda/src/inc", "ramda/src/without", "ramda/src/find", "punycode", "ramda/src/dec", "ramda/src/mergeRight", "ramda/src/append", "ramda/src/T", "ramda/src/always", "ramda/src/evolve", "ramda/src/assoc", "ramda/src/includes", "ramda/src/isEmpty"], t) : t((e = "undefined" != typeof globalThis ? globalThis : e || self)["@redriverpress/system"] = {}, e.styled, e.styledSystem, e.PropTypes, e.E$3, e._equals, e._cond, e.jsxRuntime, e._identity, e.e$2, e._propEq, e._none, e._inc, e._without, e._find, e.require$$8, e._dec, e._mergeRight, e._append, e._T, e._always, e._evolve, e._assoc, e._includes, e._isEmpty);
}(this, function (e, t, n, r, o, i, a, s, l, c, u, d, f, p, h, m, g, y, b, v, x, w, k, C, M) {
  "use strict";

  function j(e) {
    return e && "object" == _typeof(e) && "default" in e ? e : {
      "default": e
    };
  }

  function E(e) {
    if (e && e.__esModule) return e;
    var t = Object.create(null);
    return e && Object.keys(e).forEach(function (n) {
      if ("default" !== n) {
        var r = Object.getOwnPropertyDescriptor(e, n);
        Object.defineProperty(t, n, r.get ? r : {
          enumerable: !0,
          get: function get() {
            return e[n];
          }
        });
      }
    }), t["default"] = e, Object.freeze(t);
  }

  var _ = j(t),
      T = j(r),
      S = j(o),
      L = E(o),
      D = j(i),
      A = j(a),
      N = j(l),
      I = j(c),
      z = j(u),
      O = j(d),
      R = j(f),
      P = j(p),
      F = j(h),
      B = j(m),
      q = j(g),
      U = j(y),
      V = j(b),
      H = j(v),
      Z = j(x),
      W = j(w),
      $ = j(k),
      G = j(C),
      Y = j(M);

  var Q = t.keyframes(["0%{opacity:0}100%{opacity:1;}"]),
      X = t.keyframes(["0%{transform:rotate(0deg) translateZ(0);}100%{transform:rotate(360deg) translateZ(0);}"]),
      K = function K(e) {
    return t.css(["animation:", " ", " infinite linear;"], e, X);
  },
      J = t.keyframes(["0%{opacity:0;}50%{opacity:1;}100%{opacity:0;}"]),
      ee = _["default"].br.withConfig({
    displayName: "BR",
    componentId: "sc-87nup8-0"
  })(["", ""], n.layout);

  var te,
      ne,
      re = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/,
      oe = (te = function te(e) {
    return re.test(e) || 111 === e.charCodeAt(0) && 110 === e.charCodeAt(1) && e.charCodeAt(2) < 91;
  }, ne = {}, function (e) {
    return void 0 === ne[e] && (ne[e] = te(e)), ne[e];
  }),
      ie = n.compose(n.space, n.typography, n.color, n.layout, n.flexbox, n.border, n.background, n.position, n.grid, n.shadow, n.buttonStyle, n.textStyle, n.colorStyle).propNames;
  !function (e) {
    var t = new RegExp("^(" + e.join("|") + ")$");

    (function (e) {
      var t = Object.create(null);
    })(function (e) {
      return oe(e) && !t.test(e);
    });
  }(ie);

  var ae = [].concat(_toConsumableArray(ie), ["active", "adaptive", "animate", "blacklist", "cursor", "custom", "dragConstraints", "dragElastic", "direction", "exit", "gradientStepColor", "hasBorder", "hasTimeout", "hideLabel", "hideOutline", "hoverBg", "icon", "initial", "isArmed", "isDragging", "isMatched", "isNew", "larger", "layout", "light", "matched", "measure", "reset", "reverse", "rowDirectionStartingAt", "secondary", "showScroll", "small", "subheading", "textOverflow", "transition", "translateBy", "trunclipse", "variants", "weight", "when", "zIndex"]),
      se = function se(e) {
    return !ae.includes(e);
  },
      le = n.system({
    cursor: !0
  }),
      ce = n.system({
    dropShadow: {
      property: "filter",
      scale: "dropShadows"
    }
  }),
      ue = n.system({
    font: {
      property: "font-family",
      scale: "fonts"
    }
  }),
      de = n.system({
    transition: !0
  }),
      fe = _["default"].div.withConfig({
    shouldForwardProp: se,
    displayName: "Box",
    componentId: "sc-e8cex7-0"
  })(n.compose(n.background, n.border, n.boxShadow, n.color, le, n.display, ce, n.flexbox, ue, n.grid, n.layout, n.opacity, n.overflow, n.position, n.space, n.typography, de));

  fe.defaultProps = {
    as: "div"
  }, fe.displayName = "Box", fe.propTypes = {
    as: T["default"].oneOf(["address", "article", "aside", "dd", "div", "dl", "dt", "figure", "footer", "header", "hgroup", "label", "li", "main", "span", "table", "tbody", "thead", "tr", "td", "nav", "section", "span", "ul"])
  };

  var pe = _["default"].hr.withConfig({
    displayName: "HR",
    componentId: "sc-49qd3b-0"
  })(["border:none;border-top:2px solid;", ""], n.compose(n.border, n.space, n.layout));

  pe.defaultProps = {
    borderColor: "gray50",
    my: 0
  };

  var he = _["default"]("img").withConfig({
    displayName: "Image",
    componentId: "sc-q3yels-0"
  })(n.compose(n.border, n.flexbox, n.layout, n.opacity, n.overflow, n.position, n.space));

  he.displayName = "Image", he.propTypes = {
    alt: T["default"].string.isRequired,
    src: T["default"].string.isRequired
  };
  /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.
  
    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.
  
    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

  var _me = function me(e, t) {
    return _me = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var n in t) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }
    }, _me(e, t);
  };

  function ge(e, t) {
    function n() {
      this.constructor = e;
    }

    _me(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
  }

  var _ye = function ye() {
    return _ye = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) {
        for (var o in t = arguments[n]) {
          Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        }
      }

      return e;
    }, _ye.apply(this, arguments);
  };

  function be(e, t) {
    var n = {};

    for (var r in e) {
      Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
    }

    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
      var o = 0;

      for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
        t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
      }
    }

    return n;
  }

  function ve(e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var r,
        o,
        i = n.call(e),
        a = [];

    try {
      for (; (void 0 === t || t-- > 0) && !(r = i.next()).done;) {
        a.push(r.value);
      }
    } catch (e) {
      o = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (n = i["return"]) && n.call(i);
      } finally {
        if (o) throw o.error;
      }
    }

    return a;
  }

  function xe() {
    for (var e = [], t = 0; t < arguments.length; t++) {
      e = e.concat(ve(arguments[t]));
    }

    return e;
  }

  var we = o.createContext({
    transformPagePoint: function transformPagePoint(e) {
      return e;
    },
    features: [],
    isStatic: !1
  }),
      ke = o.createContext(null);

  function Ce(e) {
    var t = o.useRef(null);
    return null === t.current && (t.current = e()), t.current;
  }

  function Me() {
    var e = o.useContext(ke);
    if (null === e) return [!0, null];
    var t = e.isPresent,
        n = e.onExitComplete,
        r = e.register,
        i = Se();
    o.useEffect(function () {
      return r(i);
    }, []);
    return !t && n ? [!1, function () {
      return null == n ? void 0 : n(i);
    }] : [!0];
  }

  var je,
      Ee,
      _e = 0,
      Te = function Te() {
    return _e++;
  },
      Se = function Se() {
    return Ce(Te);
  },
      Le = o.createContext(null);

  !function (e) {
    e[e.Entering = 0] = "Entering", e[e.Present = 1] = "Present", e[e.Exiting = 2] = "Exiting";
  }(je || (je = {})), function (e) {
    e[e.Hide = 0] = "Hide", e[e.Show = 1] = "Show";
  }(Ee || (Ee = {}));
  var De = {
    measureLayout: function measureLayout(e) {
      return e.updateLayoutMeasurement();
    },
    layoutReady: function layoutReady(e) {
      return e.notifyLayoutReady();
    }
  };

  function Ae() {
    var e = new Set();
    return {
      add: function add(t) {
        return e.add(t);
      },
      flush: function flush(t) {
        var n = void 0 === t ? De : t,
            r = n.measureLayout,
            o = n.layoutReady,
            i = n.parent,
            a = Array.from(e).sort(function (e, t) {
          return e.depth - t.depth;
        }),
            s = function s() {
          a.forEach(function (e) {
            return e.resetTransform();
          }), a.forEach(r);
        };

        i ? i.withoutTransform(s) : s(), a.forEach(o), a.forEach(function (e) {
          e.isPresent && (e.presence = je.Present);
        }), e.clear();
      }
    };
  }

  var Ne = o.createContext(Ae()),
      Ie = o.createContext(Ae());

  function ze(e) {
    return !!e.forceUpdate;
  }

  var Oe = o.createContext({});
  var Re = "undefined" != typeof window ? o.useLayoutEffect : o.useEffect;

  function Pe(e, t, n, r) {
    var i = o.useContext(we),
        a = o.useContext(Oe).visualElement,
        s = o.useContext(ke),
        l = function (e) {
      var t = e.layoutId,
          n = o.useContext(Le);
      return n && void 0 !== t ? n + "-" + t : t;
    }(r),
        c = Ce(function () {
      return n(e, {
        visualState: t,
        parent: a,
        props: _ye(_ye({}, r), {
          layoutId: l
        }),
        presenceId: null == s ? void 0 : s.id,
        blockInitialAnimation: !1 === (null == s ? void 0 : s.initial)
      });
    });

    return Re(function () {
      var e;
      c.setProps(_ye(_ye(_ye({}, i), r), {
        layoutId: l
      })), c.isPresent = null === (e = s) || e.isPresent, c.isPresenceRoot = !a || a.presenceId !== (null == s ? void 0 : s.id), c.syncRender();
    }), o.useEffect(function () {
      var e;
      null === (e = c.animationState) || void 0 === e || e.animateChanges();
    }), function (e) {
      var t = o.useContext(Ne),
          n = o.useContext(Ie);
      Re(function () {
        return function () {
          ze(t) && t.remove(e), ze(n) && n.remove(e);
        };
      }, []);
    }(c), c;
  }

  function Fe(e) {
    return "object" == _typeof(e) && Object.prototype.hasOwnProperty.call(e, "current");
  }

  function Be(e) {
    return Array.isArray(e);
  }

  function qe(e) {
    return "string" == typeof e || Be(e);
  }

  function Ue(e, t, n, r, o) {
    var i;
    return void 0 === r && (r = {}), void 0 === o && (o = {}), "string" == typeof t && (t = null === (i = e.variants) || void 0 === i ? void 0 : i[t]), "function" == typeof t ? t(null != n ? n : e.custom, r, o) : t;
  }

  function Ve(e, t, n) {
    var r = e.getProps();
    return Ue(r, t, null != n ? n : r.custom, function (e) {
      var t = {};
      return e.forEachValue(function (e, n) {
        return t[n] = e.get();
      }), t;
    }(e), function (e) {
      var t = {};
      return e.forEachValue(function (e, n) {
        return t[n] = e.getVelocity();
      }), t;
    }(e));
  }

  function He(e) {
    var t;
    return "function" == typeof (null === (t = e.animate) || void 0 === t ? void 0 : t.start) || qe(e.initial) || qe(e.animate) || qe(e.whileHover) || qe(e.whileDrag) || qe(e.whileTap) || qe(e.whileFocus) || qe(e.exit);
  }

  function Ze(e) {
    return Boolean(He(e) || e.variants);
  }

  function We(e, t) {
    var n = function (e, t) {
      if (He(e)) {
        var n = e.initial,
            r = e.animate;
        return {
          initial: !1 === n || qe(n) ? n : void 0,
          animate: qe(r) ? r : void 0
        };
      }

      return !1 !== e.inherit ? t : {};
    }(e, o.useContext(Oe)),
        r = n.initial,
        i = n.animate;

    return o.useMemo(function () {
      return {
        initial: r,
        animate: i
      };
    }, t ? [$e(r), $e(i)] : []);
  }

  function $e(e) {
    return Array.isArray(e) ? e.join(" ") : e;
  }

  function Ge(e) {
    var t = e.defaultFeatures,
        n = e.createVisualElement,
        r = e.useRender,
        i = e.useVisualState;
    return o.forwardRef(function (e, a) {
      var s = o.useContext(we).isStatic,
          l = null,
          c = We(e, s),
          u = i(e, s);
      return s || "undefined" == typeof window || (c.visualElement = Pe(s, u, n, e), l = function (e, t, n) {
        for (var r = xe(e, o.useContext(we).features), i = r.length, a = [], s = 0; s < i; s++) {
          var l = r[s],
              c = l.shouldRender,
              u = l.key,
              d = l.getComponent;

          if (c(n)) {
            var f = d(n);
            f && a.push(o.createElement(f, _ye({
              key: u
            }, n, {
              visualElement: t
            })));
          }
        }

        return a;
      }(t, c.visualElement, e)), o.createElement(o.Fragment, null, o.createElement(Oe.Provider, {
        value: c
      }, r(e, function (e, t, n) {
        return o.useCallback(function (r) {
          var o;
          r && (null === (o = e.mount) || void 0 === o || o.call(e, r)), t && (r ? t.mount(r) : t.unmount()), n && ("function" == typeof n ? n(r) : Fe(n) && (n.current = r));
        }, []);
      }(u, c.visualElement, a), u, s)), l);
    });
  }

  function Ye(e, t, n, r) {
    return e.addEventListener(t, n, r), function () {
      return e.removeEventListener(t, n, r);
    };
  }

  function Qe(e, t, n, r) {
    o.useEffect(function () {
      var o = e.current;
      if (n && o) return Ye(o, t, n, r);
    }, [e, t, n, r]);
  }

  var Xe = function Xe() {},
      Ke = function Ke() {};

  "production" !== process.env.NODE_ENV && (Xe = function Xe(e, t) {
    e || "undefined" == typeof console || console.warn(t);
  }, Ke = function Ke(e, t) {
    if (!e) throw new Error(t);
  })
  /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.
  
    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.
  
    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
  ;

  var _Je = function Je() {
    return _Je = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) {
        for (var o in t = arguments[n]) {
          Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        }
      }

      return e;
    }, _Je.apply(this, arguments);
  };

  function et(e, t) {
    var n = {};

    for (var r in e) {
      Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
    }

    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
      var o = 0;

      for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
        t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
      }
    }

    return n;
  }

  var tt = function tt(e, t, n) {
    return Math.min(Math.max(n, e), t);
  },
      nt = .001;

  function rt(e) {
    var t,
        n,
        r = e.duration,
        o = void 0 === r ? 800 : r,
        i = e.bounce,
        a = void 0 === i ? .25 : i,
        s = e.velocity,
        l = void 0 === s ? 0 : s,
        c = e.mass,
        u = void 0 === c ? 1 : c;
    Xe(o <= 1e4, "Spring duration must be 10 seconds or less");
    var d = 1 - a;
    d = tt(.05, 1, d), o = tt(.01, 10, o / 1e3), d < 1 ? (t = function t(e) {
      var t = e * d,
          n = t * o,
          r = t - l,
          i = ot(e, d),
          a = Math.exp(-n);
      return nt - r / i * a;
    }, n = function n(e) {
      var n = e * d * o,
          r = n * l + l,
          i = Math.pow(d, 2) * Math.pow(e, 2) * o,
          a = Math.exp(-n),
          s = ot(Math.pow(e, 2), d);
      return (-t(e) + nt > 0 ? -1 : 1) * ((r - i) * a) / s;
    }) : (t = function t(e) {
      return Math.exp(-e * o) * ((e - l) * o + 1) - .001;
    }, n = function n(e) {
      return Math.exp(-e * o) * (o * o * (l - e));
    });

    var f = function (e, t, n) {
      for (var r = n, o = 1; o < 12; o++) {
        r -= e(r) / t(r);
      }

      return r;
    }(t, n, 5 / o);

    if (isNaN(f)) return {
      stiffness: 100,
      damping: 10
    };
    var p = Math.pow(f, 2) * u;
    return {
      stiffness: p,
      damping: 2 * d * Math.sqrt(u * p)
    };
  }

  function ot(e, t) {
    return e * Math.sqrt(1 - t * t);
  }

  var it = ["duration", "bounce"],
      at = ["stiffness", "damping", "mass"];

  function st(e, t) {
    return t.some(function (t) {
      return void 0 !== e[t];
    });
  }

  function lt(e) {
    var t = e.from,
        n = void 0 === t ? 0 : t,
        r = e.to,
        o = void 0 === r ? 1 : r,
        i = e.restSpeed,
        a = void 0 === i ? 2 : i,
        s = e.restDelta,
        l = et(e, ["from", "to", "restSpeed", "restDelta"]),
        c = {
      done: !1,
      value: n
    },
        u = function (e) {
      var t = _Je({
        velocity: 0,
        stiffness: 100,
        damping: 10,
        mass: 1,
        isResolvedFromDuration: !1
      }, e);

      if (!st(e, at) && st(e, it)) {
        var n = rt(e);
        (t = _Je(_Je(_Je({}, t), n), {
          velocity: 0,
          mass: 1
        })).isResolvedFromDuration = !0;
      }

      return t;
    }(l),
        d = u.stiffness,
        f = u.damping,
        p = u.mass,
        h = u.velocity,
        m = u.isResolvedFromDuration,
        g = ct,
        y = ct;

    function b() {
      var e = h ? -h / 1e3 : 0,
          t = o - n,
          r = f / (2 * Math.sqrt(d * p)),
          i = Math.sqrt(d / p) / 1e3;

      if (null != s || (s = Math.abs(o - n) <= 1 ? .01 : .4), r < 1) {
        var a = ot(i, r);
        g = function g(n) {
          var s = Math.exp(-r * i * n);
          return o - s * ((e + r * i * t) / a * Math.sin(a * n) + t * Math.cos(a * n));
        }, y = function y(n) {
          var o = Math.exp(-r * i * n);
          return r * i * o * (Math.sin(a * n) * (e + r * i * t) / a + t * Math.cos(a * n)) - o * (Math.cos(a * n) * (e + r * i * t) - a * t * Math.sin(a * n));
        };
      } else if (1 === r) g = function g(n) {
        return o - Math.exp(-i * n) * (t + (e + i * t) * n);
      };else {
        var l = i * Math.sqrt(r * r - 1);

        g = function g(n) {
          var a = Math.exp(-r * i * n),
              s = Math.min(l * n, 300);
          return o - a * ((e + r * i * t) * Math.sinh(s) + l * t * Math.cosh(s)) / l;
        };
      }
    }

    return b(), {
      next: function next(e) {
        var t = g(e);
        if (m) c.done = e >= l.duration;else {
          var n = 1e3 * y(e),
              r = Math.abs(n) <= a,
              i = Math.abs(o - t) <= s;
          c.done = r && i;
        }
        return c.value = c.done ? o : t, c;
      },
      flipTarget: function flipTarget() {
        var e;
        h = -h, n = (e = [o, n])[0], o = e[1], b();
      }
    };
  }

  lt.needsInterpolation = function (e, t) {
    return "string" == typeof e || "string" == typeof t;
  };

  var ct = function ct(e) {
    return 0;
  },
      ut = function ut(e, t, n) {
    var r = t - e;
    return 0 === r ? 1 : (n - e) / r;
  },
      dt = function dt(e, t, n) {
    return -n * e + n * t + e;
  },
      _ft = function ft() {
    return _ft = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) {
        for (var o in t = arguments[n]) {
          Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        }
      }

      return e;
    }, _ft.apply(this, arguments);
  },
      pt = function pt(e, t) {
    return function (n) {
      return Math.max(Math.min(n, t), e);
    };
  },
      ht = function ht(e) {
    return e % 1 ? Number(e.toFixed(5)) : e;
  },
      mt = /(-)?([\d]*\.?[\d])+/g,
      gt = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi,
      yt = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;

  function bt(e) {
    return "string" == typeof e;
  }

  var vt = {
    test: function test(e) {
      return "number" == typeof e;
    },
    parse: parseFloat,
    transform: function transform(e) {
      return e;
    }
  },
      xt = _ft(_ft({}, vt), {
    transform: pt(0, 1)
  }),
      wt = _ft(_ft({}, vt), {
    "default": 1
  }),
      kt = function kt(e) {
    return {
      test: function test(t) {
        return bt(t) && t.endsWith(e) && 1 === t.split(" ").length;
      },
      parse: parseFloat,
      transform: function transform(t) {
        return "" + t + e;
      }
    };
  },
      Ct = kt("deg"),
      Mt = kt("%"),
      jt = kt("px"),
      Et = kt("vh"),
      _t = kt("vw"),
      Tt = _ft(_ft({}, Mt), {
    parse: function parse(e) {
      return Mt.parse(e) / 100;
    },
    transform: function transform(e) {
      return Mt.transform(100 * e);
    }
  }),
      St = function St(e, t) {
    return function (n) {
      return bt(n) && yt.test(n) && n.startsWith(e) || t && Object.prototype.hasOwnProperty.call(n, t);
    };
  },
      Lt = function Lt(e, t, n) {
    return function (r) {
      var o;
      if (!bt(r)) return r;
      var i = r.match(mt),
          a = i[0],
          s = i[1],
          l = i[2],
          c = i[3];
      return (o = {})[e] = parseFloat(a), o[t] = parseFloat(s), o[n] = parseFloat(l), o.alpha = void 0 !== c ? parseFloat(c) : 1, o;
    };
  },
      Dt = {
    test: St("hsl", "hue"),
    parse: Lt("hue", "saturation", "lightness"),
    transform: function transform(e) {
      var t = e.hue,
          n = e.saturation,
          r = e.lightness,
          o = e.alpha,
          i = void 0 === o ? 1 : o;
      return "hsla(" + Math.round(t) + ", " + Mt.transform(ht(n)) + ", " + Mt.transform(ht(r)) + ", " + ht(xt.transform(i)) + ")";
    }
  },
      At = pt(0, 255),
      Nt = _ft(_ft({}, vt), {
    transform: function transform(e) {
      return Math.round(At(e));
    }
  }),
      It = {
    test: St("rgb", "red"),
    parse: Lt("red", "green", "blue"),
    transform: function transform(e) {
      var t = e.red,
          n = e.green,
          r = e.blue,
          o = e.alpha,
          i = void 0 === o ? 1 : o;
      return "rgba(" + Nt.transform(t) + ", " + Nt.transform(n) + ", " + Nt.transform(r) + ", " + ht(xt.transform(i)) + ")";
    }
  };

  var zt = {
    test: St("#"),
    parse: function parse(e) {
      var t = "",
          n = "",
          r = "",
          o = "";
      return e.length > 5 ? (t = e.substr(1, 2), n = e.substr(3, 2), r = e.substr(5, 2), o = e.substr(7, 2)) : (t = e.substr(1, 1), n = e.substr(2, 1), r = e.substr(3, 1), o = e.substr(4, 1), t += t, n += n, r += r, o += o), {
        red: parseInt(t, 16),
        green: parseInt(n, 16),
        blue: parseInt(r, 16),
        alpha: o ? parseInt(o, 16) / 255 : 1
      };
    },
    transform: It.transform
  },
      Ot = {
    test: function test(e) {
      return It.test(e) || zt.test(e) || Dt.test(e);
    },
    parse: function parse(e) {
      return It.test(e) ? It.parse(e) : Dt.test(e) ? Dt.parse(e) : zt.parse(e);
    },
    transform: function transform(e) {
      return bt(e) ? e : e.hasOwnProperty("red") ? It.transform(e) : Dt.transform(e);
    }
  },
      Rt = "${c}",
      Pt = "${n}";

  function Ft(e) {
    var t = [],
        n = 0,
        r = e.match(gt);
    r && (n = r.length, e = e.replace(gt, Rt), t.push.apply(t, r.map(Ot.parse)));
    var o = e.match(mt);
    return o && (e = e.replace(mt, Pt), t.push.apply(t, o.map(vt.parse))), {
      values: t,
      numColors: n,
      tokenised: e
    };
  }

  function Bt(e) {
    return Ft(e).values;
  }

  function qt(e) {
    var t = Ft(e),
        n = t.values,
        r = t.numColors,
        o = t.tokenised,
        i = n.length;
    return function (e) {
      for (var t = o, n = 0; n < i; n++) {
        t = t.replace(n < r ? Rt : Pt, n < r ? Ot.transform(e[n]) : ht(e[n]));
      }

      return t;
    };
  }

  var Ut = function Ut(e) {
    return "number" == typeof e ? 0 : e;
  };

  var Vt = {
    test: function test(e) {
      var t, n, r, o;
      return isNaN(e) && bt(e) && (null !== (n = null === (t = e.match(mt)) || void 0 === t ? void 0 : t.length) && void 0 !== n ? n : 0) + (null !== (o = null === (r = e.match(gt)) || void 0 === r ? void 0 : r.length) && void 0 !== o ? o : 0) > 0;
    },
    parse: Bt,
    createTransformer: qt,
    getAnimatableNone: function getAnimatableNone(e) {
      var t = Bt(e);
      return qt(e)(t.map(Ut));
    }
  },
      Ht = new Set(["brightness", "contrast", "saturate", "opacity"]);

  function Zt(e) {
    var t = e.slice(0, -1).split("("),
        n = t[0],
        r = t[1];
    if ("drop-shadow" === n) return e;
    var o = (r.match(mt) || [])[0];
    if (!o) return e;
    var i = r.replace(o, ""),
        a = Ht.has(n) ? 1 : 0;
    return o !== r && (a *= 100), n + "(" + a + i + ")";
  }

  var Wt = /([a-z-]*)\(.*?\)/g,
      $t = _ft(_ft({}, Vt), {
    getAnimatableNone: function getAnimatableNone(e) {
      var t = e.match(Wt);
      return t ? t.map(Zt).join(" ") : e;
    }
  }),
      Gt = function Gt(e, t, n) {
    var r = e * e,
        o = t * t;
    return Math.sqrt(Math.max(0, n * (o - r) + r));
  },
      Yt = [zt, It, Dt],
      Qt = function Qt(e) {
    return Yt.find(function (t) {
      return t.test(e);
    });
  },
      Xt = function Xt(e) {
    return "'" + e + "' is not an animatable color. Use the equivalent color code instead.";
  },
      Kt = function Kt(e, t) {
    var n = Qt(e),
        r = Qt(t);
    Ke(!!n, Xt(e)), Ke(!!r, Xt(t)), Ke(n.transform === r.transform, "Both colors must be hex/RGBA, OR both must be HSLA.");

    var o = n.parse(e),
        i = r.parse(t),
        a = _Je({}, o),
        s = n === Dt ? dt : Gt;

    return function (e) {
      for (var t in a) {
        "alpha" !== t && (a[t] = s(o[t], i[t], e));
      }

      return a.alpha = dt(o.alpha, i.alpha, e), n.transform(a);
    };
  },
      Jt = function Jt(e) {
    return "number" == typeof e;
  },
      en = function en(e, t) {
    return function (n) {
      return t(e(n));
    };
  },
      tn = function tn() {
    for (var e = [], t = 0; t < arguments.length; t++) {
      e[t] = arguments[t];
    }

    return e.reduce(en);
  };

  function nn(e, t) {
    return Jt(e) ? function (n) {
      return dt(e, t, n);
    } : Ot.test(e) ? Kt(e, t) : sn(e, t);
  }

  var rn = function rn(e, t) {
    var n = function () {
      for (var e = 0, t = 0, n = arguments.length; t < n; t++) {
        e += arguments[t].length;
      }

      var r = Array(e),
          o = 0;

      for (t = 0; t < n; t++) {
        for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++) {
          r[o] = i[a];
        }
      }

      return r;
    }(e),
        r = n.length,
        o = e.map(function (e, n) {
      return nn(e, t[n]);
    });

    return function (e) {
      for (var t = 0; t < r; t++) {
        n[t] = o[t](e);
      }

      return n;
    };
  },
      on = function on(e, t) {
    var n = _Je(_Je({}, e), t),
        r = {};

    for (var o in n) {
      void 0 !== e[o] && void 0 !== t[o] && (r[o] = nn(e[o], t[o]));
    }

    return function (e) {
      for (var t in r) {
        n[t] = r[t](e);
      }

      return n;
    };
  };

  function an(e) {
    for (var t = Vt.parse(e), n = t.length, r = 0, o = 0, i = 0, a = 0; a < n; a++) {
      r || "number" == typeof t[a] ? r++ : void 0 !== t[a].hue ? i++ : o++;
    }

    return {
      parsed: t,
      numNumbers: r,
      numRGB: o,
      numHSL: i
    };
  }

  var sn = function sn(e, t) {
    var n = Vt.createTransformer(t),
        r = an(e),
        o = an(t);
    return Ke(r.numHSL === o.numHSL && r.numRGB === o.numRGB && r.numNumbers >= o.numNumbers, "Complex values '" + e + "' and '" + t + "' too different to mix. Ensure all colors are of the same type."), tn(rn(r.parsed, o.parsed), n);
  },
      ln = function ln(e, t) {
    return function (n) {
      return dt(e, t, n);
    };
  };

  function cn(e, t, n) {
    for (var r = [], o = n || function (e) {
      return "number" == typeof e ? ln : "string" == typeof e ? Ot.test(e) ? Kt : sn : Array.isArray(e) ? rn : "object" == _typeof(e) ? on : void 0;
    }(e[0]), i = e.length - 1, a = 0; a < i; a++) {
      var s = o(e[a], e[a + 1]);

      if (t) {
        var l = Array.isArray(t) ? t[a] : t;
        s = tn(l, s);
      }

      r.push(s);
    }

    return r;
  }

  function un(e, t, n) {
    var r = void 0 === n ? {} : n,
        o = r.clamp,
        i = void 0 === o || o,
        a = r.ease,
        s = r.mixer,
        l = e.length;
    Ke(l === t.length, "Both input and output ranges must be the same length"), Ke(!a || !Array.isArray(a) || a.length === l - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values."), e[0] > e[l - 1] && (e = [].concat(e), t = [].concat(t), e.reverse(), t.reverse());
    var c = cn(t, a, s),
        u = 2 === l ? function (e, t) {
      var n = e[0],
          r = e[1],
          o = t[0];
      return function (e) {
        return o(ut(n, r, e));
      };
    }(e, c) : function (e, t) {
      var n = e.length,
          r = n - 1;
      return function (o) {
        var i = 0,
            a = !1;

        if (o <= e[0] ? a = !0 : o >= e[r] && (i = r - 1, a = !0), !a) {
          for (var s = 1; s < n && !(e[s] > o || s === r); s++) {
            ;
          }

          i = s - 1;
        }

        var l = ut(e[i], e[i + 1], o);
        return t[i](l);
      };
    }(e, c);
    return i ? function (t) {
      return u(tt(e[0], e[l - 1], t));
    } : u;
  }

  var dn,
      fn = function fn(e) {
    return function (t) {
      return 1 - e(1 - t);
    };
  },
      pn = function pn(e) {
    return function (t) {
      return t <= .5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2;
    };
  },
      hn = function hn(e) {
    return function (t) {
      return t * t * ((e + 1) * t - e);
    };
  },
      mn = function mn(e) {
    return e;
  },
      gn = (dn = 2, function (e) {
    return Math.pow(e, dn);
  }),
      yn = fn(gn),
      bn = pn(gn),
      vn = function vn(e) {
    return 1 - Math.sin(Math.acos(e));
  },
      xn = fn(vn),
      wn = pn(xn),
      kn = hn(1.525),
      Cn = fn(kn),
      Mn = pn(kn),
      jn = function (e) {
    var t = hn(e);
    return function (e) {
      return (e *= 2) < 1 ? .5 * t(e) : .5 * (2 - Math.pow(2, -10 * (e - 1)));
    };
  }(1.525),
      En = function En(e) {
    if (1 === e || 0 === e) return e;
    var t = e * e;
    return e < .36363636363636365 ? 7.5625 * t : e < .7272727272727273 ? 9.075 * t - 9.9 * e + 3.4 : e < .9 ? 12.066481994459833 * t - 19.63545706371191 * e + 8.898060941828255 : 10.8 * e * e - 20.52 * e + 10.72;
  },
      _n = fn(En);

  function Tn(e, t) {
    return e.map(function () {
      return t || bn;
    }).splice(0, e.length - 1);
  }

  function Sn(e) {
    var t = e.from,
        n = void 0 === t ? 0 : t,
        r = e.to,
        o = void 0 === r ? 1 : r,
        i = e.ease,
        a = e.offset,
        s = e.duration,
        l = void 0 === s ? 300 : s,
        c = {
      done: !1,
      value: n
    },
        u = Array.isArray(o) ? o : [n, o],
        d = function (e, t) {
      return e.map(function (e) {
        return e * t;
      });
    }(a && a.length === u.length ? a : function (e) {
      var t = e.length;
      return e.map(function (e, n) {
        return 0 !== n ? n / (t - 1) : 0;
      });
    }(u), l);

    function f() {
      return un(d, u, {
        ease: Array.isArray(i) ? i : Tn(u, i)
      });
    }

    var p = f();
    return {
      next: function next(e) {
        return c.value = p(e), c.done = e >= l, c;
      },
      flipTarget: function flipTarget() {
        u.reverse(), p = f();
      }
    };
  }

  var Ln = {
    keyframes: Sn,
    spring: lt,
    decay: function decay(e) {
      var t = e.velocity,
          n = void 0 === t ? 0 : t,
          r = e.from,
          o = void 0 === r ? 0 : r,
          i = e.power,
          a = void 0 === i ? .8 : i,
          s = e.timeConstant,
          l = void 0 === s ? 350 : s,
          c = e.restDelta,
          u = void 0 === c ? .5 : c,
          d = e.modifyTarget,
          f = {
        done: !1,
        value: o
      },
          p = a * n,
          h = o + p,
          m = void 0 === d ? h : d(h);
      return m !== h && (p = m - o), {
        next: function next(e) {
          var t = -p * Math.exp(-e / l);
          return f.done = !(t > u || t < -u), f.value = f.done ? m : m + t, f;
        },
        flipTarget: function flipTarget() {}
      };
    }
  };
  var Dn = 1 / 60 * 1e3,
      An = "undefined" != typeof performance ? function () {
    return performance.now();
  } : function () {
    return Date.now();
  },
      Nn = "undefined" != typeof window ? function (e) {
    return window.requestAnimationFrame(e);
  } : function (e) {
    return setTimeout(function () {
      return e(An());
    }, Dn);
  };

  var In = !0,
      zn = !1,
      On = !1,
      Rn = {
    delta: 0,
    timestamp: 0
  },
      Pn = ["read", "update", "preRender", "render", "postRender"],
      Fn = Pn.reduce(function (e, t) {
    return e[t] = function (e) {
      var t = [],
          n = [],
          r = 0,
          o = !1,
          i = new WeakSet(),
          a = {
        schedule: function schedule(e, a, s) {
          void 0 === a && (a = !1), void 0 === s && (s = !1);
          var l = s && o,
              c = l ? t : n;
          return a && i.add(e), -1 === c.indexOf(e) && (c.push(e), l && o && (r = t.length)), e;
        },
        cancel: function cancel(e) {
          var t = n.indexOf(e);
          -1 !== t && n.splice(t, 1), i["delete"](e);
        },
        process: function process(s) {
          var l;
          if (o = !0, t = (l = [n, t])[0], (n = l[1]).length = 0, r = t.length) for (var c = 0; c < r; c++) {
            var u = t[c];
            u(s), i.has(u) && (a.schedule(u), e());
          }
          o = !1;
        }
      };
      return a;
    }(function () {
      return zn = !0;
    }), e;
  }, {}),
      Bn = Pn.reduce(function (e, t) {
    var n = Fn[t];
    return e[t] = function (e, t, r) {
      return void 0 === t && (t = !1), void 0 === r && (r = !1), zn || Hn(), n.schedule(e, t, r);
    }, e;
  }, {}),
      qn = Pn.reduce(function (e, t) {
    return e[t] = Fn[t].cancel, e;
  }, {}),
      Un = function Un(e) {
    return Fn[e].process(Rn);
  },
      Vn = function Vn(e) {
    zn = !1, Rn.delta = In ? Dn : Math.max(Math.min(e - Rn.timestamp, 40), 1), Rn.timestamp = e, On = !0, Pn.forEach(Un), On = !1, zn && (In = !1, Nn(Vn));
  },
      Hn = function Hn() {
    zn = !0, In = !0, On || Nn(Vn);
  },
      Zn = function Zn() {
    return Rn;
  };

  function Wn(e, t, n) {
    return void 0 === n && (n = 0), e - t - n;
  }

  var $n = function $n(e) {
    var t = function t(_t2) {
      var n = _t2.delta;
      return e(n);
    };

    return {
      start: function start() {
        return Bn.update(t, !0);
      },
      stop: function stop() {
        return qn.update(t);
      }
    };
  };

  function Gn(e) {
    var t,
        n,
        r,
        o,
        i,
        a = e.from,
        s = e.autoplay,
        l = void 0 === s || s,
        c = e.driver,
        u = void 0 === c ? $n : c,
        d = e.elapsed,
        f = void 0 === d ? 0 : d,
        p = e.repeat,
        h = void 0 === p ? 0 : p,
        m = e.repeatType,
        g = void 0 === m ? "loop" : m,
        y = e.repeatDelay,
        b = void 0 === y ? 0 : y,
        v = e.onPlay,
        x = e.onStop,
        w = e.onComplete,
        k = e.onRepeat,
        C = e.onUpdate,
        M = et(e, ["from", "autoplay", "driver", "elapsed", "repeat", "repeatType", "repeatDelay", "onPlay", "onStop", "onComplete", "onRepeat", "onUpdate"]),
        j = M.to,
        E = 0,
        _ = M.duration,
        T = !1,
        S = !0,
        L = function (e) {
      if (Array.isArray(e.to)) return Sn;
      if (Ln[e.type]) return Ln[e.type];
      var t = new Set(Object.keys(e));
      return t.has("ease") || t.has("duration") && !t.has("dampingRatio") ? Sn : t.has("dampingRatio") || t.has("stiffness") || t.has("mass") || t.has("damping") || t.has("restSpeed") || t.has("restDelta") ? lt : Sn;
    }(M);

    (null === (n = (t = L).needsInterpolation) || void 0 === n ? void 0 : n.call(t, a, j)) && (i = un([0, 100], [a, j], {
      clamp: !1
    }), a = 0, j = 100);
    var D = L(_Je(_Je({}, M), {
      from: a,
      to: j
    }));

    function A() {
      E++, "reverse" === g ? f = function (e, t, n, r) {
        return void 0 === n && (n = 0), void 0 === r && (r = !0), r ? Wn(t + -e, t, n) : t - (e - t) + n;
      }(f, _, b, S = E % 2 == 0) : (f = Wn(f, _, b), "mirror" === g && D.flipTarget()), T = !1, k && k();
    }

    function N(e) {
      if (S || (e = -e), f += e, !T) {
        var t = D.next(Math.max(0, f));
        o = t.value, i && (o = i(o)), T = S ? t.done : f <= 0;
      }

      null == C || C(o), T && (0 === E && (null != _ || (_ = f)), E < h ? function (e, t, n, r) {
        return r ? e >= t + n : e <= -n;
      }(f, _, b, S) && A() : (r.stop(), w && w()));
    }

    return l && (null == v || v(), (r = u(N)).start()), {
      stop: function stop() {
        null == x || x(), r.stop();
      }
    };
  }

  function Yn(e, t) {
    return t ? e * (1e3 / t) : 0;
  }

  var Qn = function Qn(e) {
    return e.hasOwnProperty("x") && e.hasOwnProperty("y");
  },
      Xn = function Xn(e) {
    return Qn(e) && e.hasOwnProperty("z");
  },
      Kn = function Kn(e, t) {
    return Math.abs(e - t);
  };

  function Jn(e, t) {
    if (Jt(e) && Jt(t)) return Kn(e, t);

    if (Qn(e) && Qn(t)) {
      var n = Kn(e.x, t.x),
          r = Kn(e.y, t.y),
          o = Xn(e) && Xn(t) ? Kn(e.z, t.z) : 0;
      return Math.sqrt(Math.pow(n, 2) + Math.pow(r, 2) + Math.pow(o, 2));
    }
  }

  var er = function er(e, t) {
    return 1 - 3 * t + 3 * e;
  },
      tr = function tr(e, t) {
    return 3 * t - 6 * e;
  },
      nr = function nr(e) {
    return 3 * e;
  },
      rr = function rr(e, t, n) {
    return ((er(t, n) * e + tr(t, n)) * e + nr(t)) * e;
  },
      or = function or(e, t, n) {
    return 3 * er(t, n) * e * e + 2 * tr(t, n) * e + nr(t);
  };

  var ir = .1;

  function ar(e, t, n, r) {
    if (e === t && n === r) return mn;

    for (var o = new Float32Array(11), i = 0; i < 11; ++i) {
      o[i] = rr(i * ir, e, n);
    }

    function a(t) {
      for (var r = 0, i = 1; 10 !== i && o[i] <= t; ++i) {
        r += ir;
      }

      --i;
      var a = r + (t - o[i]) / (o[i + 1] - o[i]) * ir,
          s = or(a, e, n);
      return s >= .001 ? function (e, t, n, r) {
        for (var o = 0; o < 8; ++o) {
          var i = or(t, n, r);
          if (0 === i) return t;
          t -= (rr(t, n, r) - e) / i;
        }

        return t;
      }(t, a, e, n) : 0 === s ? a : function (e, t, n, r, o) {
        var i,
            a,
            s = 0;

        do {
          (i = rr(a = t + (n - t) / 2, r, o) - e) > 0 ? n = a : t = a;
        } while (Math.abs(i) > 1e-7 && ++s < 10);

        return a;
      }(t, r, r + ir, e, n);
    }

    return function (e) {
      return 0 === e || 1 === e ? e : rr(a(e), t, r);
    };
  }

  function sr(e) {
    return "undefined" != typeof PointerEvent && e instanceof PointerEvent ? !("mouse" !== e.pointerType) : e instanceof MouseEvent;
  }

  function lr(e) {
    return !!e.touches;
  }

  var cr = {
    pageX: 0,
    pageY: 0
  };

  function ur(e, t) {
    void 0 === t && (t = "page");
    var n = e.touches[0] || e.changedTouches[0] || cr;
    return {
      x: n[t + "X"],
      y: n[t + "Y"]
    };
  }

  function dr(e, t) {
    return void 0 === t && (t = "page"), {
      x: e[t + "X"],
      y: e[t + "Y"]
    };
  }

  function fr(e, t) {
    return void 0 === t && (t = "page"), {
      point: lr(e) ? ur(e, t) : dr(e, t)
    };
  }

  function pr(e) {
    return fr(e, "client");
  }

  var hr = function hr(e, t) {
    void 0 === t && (t = !1);

    var n,
        r = function r(t) {
      return e(t, fr(t));
    };

    return t ? (n = r, function (e) {
      var t = e instanceof MouseEvent;
      (!t || t && 0 === e.button) && n(e);
    }) : r;
  },
      mr = "undefined" != typeof window,
      gr = {
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointercancel: "mousecancel",
    pointerover: "mouseover",
    pointerout: "mouseout",
    pointerenter: "mouseenter",
    pointerleave: "mouseleave"
  },
      yr = {
    pointerdown: "touchstart",
    pointermove: "touchmove",
    pointerup: "touchend",
    pointercancel: "touchcancel"
  };

  function br(e) {
    return mr && null === window.onpointerdown ? e : mr && null === window.ontouchstart ? yr[e] : mr && null === window.onmousedown ? gr[e] : e;
  }

  function vr(e, t, n, r) {
    return Ye(e, br(t), hr(n, "pointerdown" === t), r);
  }

  function xr(e, t, n, r) {
    return Qe(e, br(t), n && hr(n, "pointerdown" === t), r);
  }

  var wr = function wr(e) {
    return 1e3 * e;
  },
      kr = function () {
    function e(e, t, n) {
      var r = this,
          o = (void 0 === n ? {} : n).transformPagePoint;

      if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.updatePoint = function () {
        if (r.lastMoveEvent && r.lastMoveEventInfo) {
          var e = jr(r.lastMoveEventInfo, r.history),
              t = null !== r.startEvent,
              n = Jn(e.offset, {
            x: 0,
            y: 0
          }) >= 3;

          if (t || n) {
            var o = e.point,
                i = Zn().timestamp;
            r.history.push(_ye(_ye({}, o), {
              timestamp: i
            }));
            var a = r.handlers,
                s = a.onStart,
                l = a.onMove;
            t || (s && s(r.lastMoveEvent, e), r.startEvent = r.lastMoveEvent), l && l(r.lastMoveEvent, e);
          }
        }
      }, this.handlePointerMove = function (e, t) {
        r.lastMoveEvent = e, r.lastMoveEventInfo = Cr(t, r.transformPagePoint), sr(e) && 0 === e.buttons ? r.handlePointerUp(e, t) : Bn.update(r.updatePoint, !0);
      }, this.handlePointerUp = function (e, t) {
        r.end();
        var n = r.handlers.onEnd;

        if (n && r.startEvent) {
          var o = jr(Cr(t, r.transformPagePoint), r.history);
          n && n(e, o);
        }
      }, !(lr(e) && e.touches.length > 1)) {
        this.handlers = t, this.transformPagePoint = o;
        var i = Cr(fr(e), this.transformPagePoint),
            a = i.point,
            s = Zn().timestamp;
        this.history = [_ye(_ye({}, a), {
          timestamp: s
        })];
        var l = t.onSessionStart;
        l && l(e, jr(i, this.history)), this.removeListeners = tn(vr(window, "pointermove", this.handlePointerMove), vr(window, "pointerup", this.handlePointerUp), vr(window, "pointercancel", this.handlePointerUp));
      }
    }

    return e.prototype.updateHandlers = function (e) {
      this.handlers = e;
    }, e.prototype.end = function () {
      this.removeListeners && this.removeListeners(), qn.update(this.updatePoint);
    }, e;
  }();

  function Cr(e, t) {
    return t ? {
      point: t(e.point)
    } : e;
  }

  function Mr(e, t) {
    return {
      x: e.x - t.x,
      y: e.y - t.y
    };
  }

  function jr(e, t) {
    var n = e.point;
    return {
      point: n,
      delta: Mr(n, _r(t)),
      offset: Mr(n, Er(t)),
      velocity: Tr(t, .1)
    };
  }

  function Er(e) {
    return e[0];
  }

  function _r(e) {
    return e[e.length - 1];
  }

  function Tr(e, t) {
    if (e.length < 2) return {
      x: 0,
      y: 0
    };

    for (var n = e.length - 1, r = null, o = _r(e); n >= 0 && (r = e[n], !(o.timestamp - r.timestamp > wr(t)));) {
      n--;
    }

    if (!r) return {
      x: 0,
      y: 0
    };
    var i = (o.timestamp - r.timestamp) / 1e3;
    if (0 === i) return {
      x: 0,
      y: 0
    };
    var a = {
      x: (o.x - r.x) / i,
      y: (o.y - r.y) / i
    };
    return a.x === 1 / 0 && (a.x = 0), a.y === 1 / 0 && (a.y = 0), a;
  }

  function Sr(e) {
    var t = null;
    return function () {
      return null === t && (t = e, function () {
        t = null;
      });
    };
  }

  var Lr = Sr("dragHorizontal"),
      Dr = Sr("dragVertical");

  function Ar(e) {
    var t = !1;
    if ("y" === e) t = Dr();else if ("x" === e) t = Lr();else {
      var n = Lr(),
          r = Dr();
      n && r ? t = function t() {
        n(), r();
      } : (n && n(), r && r());
    }
    return t;
  }

  function Nr(e) {
    return e;
  }

  function Ir(e) {
    var t = e.top;
    return {
      x: {
        min: e.left,
        max: e.right
      },
      y: {
        min: t,
        max: e.bottom
      }
    };
  }

  function zr() {
    return {
      x: {
        min: 0,
        max: 1
      },
      y: {
        min: 0,
        max: 1
      }
    };
  }

  var Or = {
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0
  };

  function Rr() {
    return {
      x: _ye({}, Or),
      y: _ye({}, Or)
    };
  }

  function Pr(e) {
    return [e("x"), e("y")];
  }

  function Fr(e, t, n) {
    return void 0 === t && (t = 0), void 0 === n && (n = .01), Jn(e, t) < n;
  }

  function Br(e) {
    return e.max - e.min;
  }

  function qr(e, t) {
    var n = .5,
        r = Br(e),
        o = Br(t);
    return o > r ? n = ut(t.min, t.max - r, e.min) : r > o && (n = ut(e.min, e.max - o, t.min)), function (e) {
      return tt(0, 1, e);
    }(n);
  }

  function Ur(e, t, n, r) {
    void 0 === r && (r = .5), e.origin = r, e.originPoint = dt(t.min, t.max, e.origin), e.scale = Br(n) / Br(t), Fr(e.scale, 1, 1e-4) && (e.scale = 1), e.translate = dt(n.min, n.max, e.origin) - e.originPoint, Fr(e.translate) && (e.translate = 0);
  }

  function Vr(e, t, n, r) {
    Ur(e.x, t.x, n.x, Hr(r.originX)), Ur(e.y, t.y, n.y, Hr(r.originY));
  }

  function Hr(e) {
    return "number" == typeof e ? e : .5;
  }

  function Zr(e, t, n) {
    var r = t.min,
        o = t.max;
    return void 0 !== r && e < r ? e = n ? dt(r, e, n.min) : Math.max(e, r) : void 0 !== o && e > o && (e = n ? dt(o, e, n.max) : Math.min(e, o)), e;
  }

  function Wr(e, t, n) {
    return {
      min: void 0 !== t ? e.min + t : void 0,
      max: void 0 !== n ? e.max + n - (e.max - e.min) : void 0
    };
  }

  function $r(e, t) {
    var n,
        r = t.min - e.min,
        o = t.max - e.max;
    return t.max - t.min < e.max - e.min && (r = (n = ve([o, r], 2))[0], o = n[1]), {
      min: e.min + r,
      max: e.min + o
    };
  }

  function Gr(e, t, n) {
    return {
      min: Yr(e, t),
      max: Yr(e, n)
    };
  }

  function Yr(e, t) {
    var n;
    return "number" == typeof e ? e : null !== (n = e[t]) && void 0 !== n ? n : 0;
  }

  function Qr(e, t) {
    return Ir(function (e, t) {
      var n = e.top,
          r = e.left,
          o = e.bottom,
          i = e.right;
      void 0 === t && (t = Nr);
      var a = t({
        x: r,
        y: n
      }),
          s = t({
        x: i,
        y: o
      });
      return {
        top: a.y,
        left: a.x,
        bottom: s.y,
        right: s.x
      };
    }(e.getBoundingClientRect(), t));
  }

  var Xr = {
    linear: mn,
    easeIn: gn,
    easeInOut: bn,
    easeOut: yn,
    circIn: vn,
    circInOut: wn,
    circOut: xn,
    backIn: kn,
    backInOut: Mn,
    backOut: Cn,
    anticipate: jn,
    bounceIn: _n,
    bounceInOut: function bounceInOut(e) {
      return e < .5 ? .5 * (1 - En(1 - 2 * e)) : .5 * En(2 * e - 1) + .5;
    },
    bounceOut: En
  },
      Kr = function Kr(e) {
    if (Array.isArray(e)) {
      Ke(4 === e.length, "Cubic bezier arrays must contain four numerical values.");
      var t = ve(e, 4);
      return ar(t[0], t[1], t[2], t[3]);
    }

    return "string" == typeof e ? (Ke(void 0 !== Xr[e], "Invalid easing type '" + e + "'"), Xr[e]) : e;
  },
      Jr = function Jr(e, t) {
    return "zIndex" !== e && (!("number" != typeof t && !Array.isArray(t)) || !("string" != typeof t || !Vt.test(t) || t.startsWith("url(")));
  },
      eo = function eo(e) {
    return Array.isArray(e);
  },
      to = function to() {
    return {
      type: "spring",
      stiffness: 500,
      damping: 25,
      restDelta: .5,
      restSpeed: 10
    };
  },
      no = function no(e) {
    return {
      type: "spring",
      stiffness: 550,
      damping: 0 === e ? 2 * Math.sqrt(550) : 30,
      restDelta: .01,
      restSpeed: 10
    };
  },
      ro = function ro() {
    return {
      type: "keyframes",
      ease: "linear",
      duration: .3
    };
  },
      oo = function oo(e) {
    return {
      type: "keyframes",
      duration: .8,
      values: e
    };
  },
      io = {
    x: to,
    y: to,
    z: to,
    rotate: to,
    rotateX: to,
    rotateY: to,
    rotateZ: to,
    scaleX: no,
    scaleY: no,
    scale: no,
    opacity: ro,
    backgroundColor: ro,
    color: ro,
    "default": no
  },
      ao = _ye(_ye({}, vt), {
    transform: Math.round
  }),
      so = {
    color: Ot,
    backgroundColor: Ot,
    outlineColor: Ot,
    fill: Ot,
    stroke: Ot,
    borderColor: Ot,
    borderTopColor: Ot,
    borderRightColor: Ot,
    borderBottomColor: Ot,
    borderLeftColor: Ot,
    borderWidth: jt,
    borderTopWidth: jt,
    borderRightWidth: jt,
    borderBottomWidth: jt,
    borderLeftWidth: jt,
    borderRadius: jt,
    radius: jt,
    borderTopLeftRadius: jt,
    borderTopRightRadius: jt,
    borderBottomRightRadius: jt,
    borderBottomLeftRadius: jt,
    width: jt,
    maxWidth: jt,
    height: jt,
    maxHeight: jt,
    size: jt,
    top: jt,
    right: jt,
    bottom: jt,
    left: jt,
    padding: jt,
    paddingTop: jt,
    paddingRight: jt,
    paddingBottom: jt,
    paddingLeft: jt,
    margin: jt,
    marginTop: jt,
    marginRight: jt,
    marginBottom: jt,
    marginLeft: jt,
    rotate: Ct,
    rotateX: Ct,
    rotateY: Ct,
    rotateZ: Ct,
    scale: wt,
    scaleX: wt,
    scaleY: wt,
    scaleZ: wt,
    skew: Ct,
    skewX: Ct,
    skewY: Ct,
    distance: jt,
    translateX: jt,
    translateY: jt,
    translateZ: jt,
    x: jt,
    y: jt,
    z: jt,
    perspective: jt,
    transformPerspective: jt,
    opacity: xt,
    originX: Tt,
    originY: Tt,
    originZ: jt,
    zIndex: ao,
    filter: $t,
    WebkitFilter: $t,
    fillOpacity: xt,
    strokeOpacity: xt,
    numOctaves: ao
  },
      lo = [vt, jt, Mt, Ct, _t, Et, {
    test: function test(e) {
      return "auto" === e;
    },
    parse: function parse(e) {
      return e;
    }
  }],
      co = function co(e) {
    return function (t) {
      return t.test(e);
    };
  },
      uo = function uo(e) {
    return lo.find(co(e));
  },
      fo = xe(lo, [Ot, Vt]),
      po = function po(e) {
    return fo.find(co(e));
  },
      ho = function ho(e) {
    return so[e];
  },
      mo = function mo(e, t) {
    return t && "number" == typeof e ? t.transform(e) : e;
  };

  function go(e, t) {
    var n,
        r = ho(e);
    return r !== $t && (r = Vt), null === (n = r.getAnimatableNone) || void 0 === n ? void 0 : n.call(r, t);
  }

  var yo,
      bo = !1;

  function vo(e) {
    var t = e.ease,
        n = e.times,
        r = e.yoyo,
        o = e.flip,
        i = e.loop,
        a = be(e, ["ease", "times", "yoyo", "flip", "loop"]),
        s = _ye({}, a);

    return n && (s.offset = n), a.duration && (s.duration = wr(a.duration)), a.repeatDelay && (s.repeatDelay = wr(a.repeatDelay)), t && (s.ease = function (e) {
      return Array.isArray(e) && "number" != typeof e[0];
    }(t) ? t.map(Kr) : Kr(t)), "tween" === a.type && (s.type = "keyframes"), (r || i || o) && (Xe(!bo, "yoyo, loop and flip have been removed from the API. Replace with repeat and repeatType options."), bo = !0, r ? s.repeatType = "reverse" : i ? s.repeatType = "loop" : o && (s.repeatType = "mirror"), s.repeat = i || r || o || a.repeat), "spring" !== a.type && (s.type = "keyframes"), s;
  }

  function xo(e, t, n) {
    var r, o, i, a;
    return Array.isArray(t.to) && (null !== (r = e.duration) && void 0 !== r || (e.duration = .8)), function (e) {
      Array.isArray(e.to) && null === e.to[0] && (e.to = xe(e.to), e.to[0] = e.from);
    }(t), function (e) {
      e.when, e.delay, e.delayChildren, e.staggerChildren, e.staggerDirection, e.repeat, e.repeatType, e.repeatDelay, e.from;
      var t = be(e, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from"]);
      return !!Object.keys(t).length;
    }(e) || (e = _ye(_ye({}, e), (o = n, i = t.to, a = eo(i) ? oo : io[o] || io["default"], _ye({
      to: i
    }, a(i))))), _ye(_ye({}, t), vo(e));
  }

  function wo(e, t, n, r, o) {
    var i,
        a = ko(r, e),
        s = null !== (i = a.from) && void 0 !== i ? i : t.get(),
        l = Jr(e, n);
    "none" === s && l && "string" == typeof n && (s = go(e, n));
    var c = Jr(e, s);
    return Xe(c === l, "You are trying to animate " + e + ' from "' + s + '" to "' + n + '". ' + s + " is not an animatable value - to enable this animation set " + s + " to a value animatable to " + n + " via the `style` property."), c && l && !1 !== a.type ? function () {
      var r = {
        from: s,
        to: n,
        velocity: t.getVelocity(),
        onComplete: o,
        onUpdate: function onUpdate(e) {
          return t.set(e);
        }
      };
      return "inertia" === a.type || "decay" === a.type ? function (e) {
        var t,
            n = e.from,
            r = void 0 === n ? 0 : n,
            o = e.velocity,
            i = void 0 === o ? 0 : o,
            a = e.min,
            s = e.max,
            l = e.power,
            c = void 0 === l ? .8 : l,
            u = e.timeConstant,
            d = void 0 === u ? 750 : u,
            f = e.bounceStiffness,
            p = void 0 === f ? 500 : f,
            h = e.bounceDamping,
            m = void 0 === h ? 10 : h,
            g = e.restDelta,
            y = void 0 === g ? 1 : g,
            b = e.modifyTarget,
            v = e.driver,
            x = e.onUpdate,
            w = e.onComplete;

        function k(e) {
          return void 0 !== a && e < a || void 0 !== s && e > s;
        }

        function C(e) {
          return void 0 === a ? s : void 0 === s || Math.abs(a - e) < Math.abs(s - e) ? a : s;
        }

        function M(e) {
          null == t || t.stop(), t = Gn(_Je(_Je({}, e), {
            driver: v,
            onUpdate: function onUpdate(t) {
              var n;
              null == x || x(t), null === (n = e.onUpdate) || void 0 === n || n.call(e, t);
            },
            onComplete: w
          }));
        }

        function j(e) {
          M(_Je({
            type: "spring",
            stiffness: p,
            damping: m,
            restDelta: y
          }, e));
        }

        if (k(r)) j({
          from: r,
          velocity: i,
          to: C(r)
        });else {
          var E = c * i + r;
          void 0 !== b && (E = b(E));

          var _,
              T,
              S = C(E),
              L = S === a ? -1 : 1;

          M({
            type: "decay",
            from: r,
            velocity: i,
            timeConstant: d,
            power: c,
            restDelta: y,
            modifyTarget: b,
            onUpdate: k(E) ? function (e) {
              _ = T, T = e, i = Yn(e - _, Zn().delta), (1 === L && e > S || -1 === L && e < S) && j({
                from: e,
                to: S,
                velocity: i
              });
            } : void 0
          });
        }
        return {
          stop: function stop() {
            return null == t ? void 0 : t.stop();
          }
        };
      }(_ye(_ye({}, r), a)) : Gn(_ye(_ye({}, xo(a, r, e)), {
        onUpdate: function onUpdate(e) {
          var t;
          r.onUpdate(e), null === (t = a.onUpdate) || void 0 === t || t.call(a, e);
        },
        onComplete: function onComplete() {
          var e;
          r.onComplete(), null === (e = a.onComplete) || void 0 === e || e.call(a);
        }
      }));
    } : function () {
      var e;
      return t.set(n), o(), null === (e = null == a ? void 0 : a.onComplete) || void 0 === e || e.call(a), {
        stop: function stop() {}
      };
    };
  }

  function ko(e, t) {
    return e[t] || e["default"] || e;
  }

  function Co(e, t, n, r) {
    return void 0 === r && (r = {}), t.start(function (o) {
      var i,
          a,
          s = wo(e, t, n, r, o),
          l = function (e, t) {
        var n;
        return null !== (n = (ko(e, t) || {}).delay) && void 0 !== n ? n : 0;
      }(r, e),
          c = function c() {
        return a = s();
      };

      return l ? i = setTimeout(c, wr(l)) : c(), function () {
        clearTimeout(i), null == a || a.stop();
      };
    });
  }

  !function (e) {
    e.Animate = "animate", e.Hover = "whileHover", e.Tap = "whileTap", e.Drag = "whileDrag", e.Focus = "whileFocus", e.Exit = "exit";
  }(yo || (yo = {}));

  var Mo,
      jo = new WeakMap(),
      Eo = function () {
    function e(e) {
      var t = e.visualElement;
      this.isDragging = !1, this.currentDirection = null, this.constraints = !1, this.elastic = {
        x: {
          min: 0,
          max: 1
        },
        y: {
          min: 0,
          max: 1
        }
      }, this.props = {}, this.hasMutatedConstraints = !1, this.cursorProgress = {
        x: .5,
        y: .5
      }, this.originPoint = {}, this.openGlobalLock = null, this.panSession = null, this.visualElement = t, this.visualElement.enableLayoutProjection(), jo.set(t, this);
    }

    return e.prototype.start = function (e, t) {
      var n = this,
          r = void 0 === t ? {} : t,
          o = r.snapToCursor,
          i = void 0 !== o && o,
          a = r.cursorProgress;
      i && this.snapToCursor(e);
      var s = this.props.transformPagePoint;
      this.panSession = new kr(e, {
        onSessionStart: function onSessionStart() {
          n.stopMotion();
        },
        onStart: function onStart(e, t) {
          var r,
              o,
              i,
              s = n.props,
              l = s.drag,
              c = s.dragPropagation;

          if (!l || c || (n.openGlobalLock && n.openGlobalLock(), n.openGlobalLock = Ar(l), n.openGlobalLock)) {
            n.prepareBoundingBox(), n.visualElement.lockProjectionTarget(), n.resolveDragConstraints();
            var u = pr(e).point;
            Pr(function (e) {
              var t = n.visualElement.projection.target[e],
                  r = t.min,
                  o = t.max;
              n.cursorProgress[e] = a ? a[e] : ut(r, o, u[e]);
              var i = n.getAxisMotionValue(e);
              i && (n.originPoint[e] = i.get());
            }), n.isDragging = !0, n.currentDirection = null, null === (o = (r = n.props).onDragStart) || void 0 === o || o.call(r, e, t), null === (i = n.visualElement.animationState) || void 0 === i || i.setActive(yo.Drag, !0);
          }
        },
        onMove: function onMove(e, t) {
          var r,
              o,
              i,
              a,
              s = n.props,
              l = s.dragPropagation,
              c = s.dragDirectionLock;

          if (l || n.openGlobalLock) {
            var u = t.offset;
            if (c && null === n.currentDirection) return n.currentDirection = function (e, t) {
              void 0 === t && (t = 10);
              var n = null;
              Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x");
              return n;
            }(u), void (null !== n.currentDirection && (null === (o = (r = n.props).onDirectionLock) || void 0 === o || o.call(r, n.currentDirection)));
            n.updateAxis("x", e, u), n.updateAxis("y", e, u), null === (a = (i = n.props).onDrag) || void 0 === a || a.call(i, e, t), Mo = e;
          }
        },
        onEnd: function onEnd(e, t) {
          return n.stop(e, t);
        }
      }, {
        transformPagePoint: s
      });
    }, e.prototype.prepareBoundingBox = function () {
      var e = this.visualElement;
      e.withoutTransform(function () {
        e.updateLayoutMeasurement();
      }), e.rebaseProjectionTarget(!0, e.measureViewportBox(!1));
    }, e.prototype.resolveDragConstraints = function () {
      var e = this,
          t = this.props,
          n = t.dragConstraints,
          r = t.dragElastic;
      this.constraints = !!n && (Fe(n) ? this.resolveRefConstraints(this.visualElement.getLayoutState().layout, n) : function (e, t) {
        var n = t.top,
            r = t.left,
            o = t.bottom,
            i = t.right;
        return {
          x: Wr(e.x, r, i),
          y: Wr(e.y, n, o)
        };
      }(this.visualElement.getLayoutState().layout, n)), this.elastic = function (e) {
        return !1 === e ? e = 0 : !0 === e && (e = .35), {
          x: Gr(e, "left", "right"),
          y: Gr(e, "top", "bottom")
        };
      }(r), this.constraints && !this.hasMutatedConstraints && Pr(function (t) {
        var n, r, o;
        e.getAxisMotionValue(t) && (e.constraints[t] = (n = e.visualElement.getLayoutState().layout[t], r = e.constraints[t], o = {}, void 0 !== r.min && (o.min = r.min - n.min), void 0 !== r.max && (o.max = r.max - n.min), o));
      });
    }, e.prototype.resolveRefConstraints = function (e, t) {
      var n = this.props,
          r = n.onMeasureDragConstraints,
          o = n.transformPagePoint,
          i = t.current;
      Ke(null !== i, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop."), this.constraintsBox = Qr(i, o);

      var a = function (e, t) {
        return {
          x: $r(e.x, t.x),
          y: $r(e.y, t.y)
        };
      }(e, this.constraintsBox);

      if (r) {
        var s = r(function (e) {
          var t = e.x,
              n = e.y;
          return {
            top: n.min,
            bottom: n.max,
            left: t.min,
            right: t.max
          };
        }(a));
        this.hasMutatedConstraints = !!s, s && (a = Ir(s));
      }

      return a;
    }, e.prototype.cancelDrag = function () {
      var e;
      this.isDragging = !1, this.panSession && this.panSession.end(), this.panSession = null, !this.props.dragPropagation && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), null === (e = this.visualElement.animationState) || void 0 === e || e.setActive(yo.Drag, !1);
    }, e.prototype.stop = function (e, t) {
      var n;
      this.visualElement.unlockProjectionTarget(), null === (n = this.panSession) || void 0 === n || n.end(), this.panSession = null;
      var r = this.isDragging;

      if (this.cancelDrag(), r) {
        var o = this.props,
            i = o.dragMomentum,
            a = o.onDragEnd;

        if (i || this.elastic) {
          var s = t.velocity;
          this.animateDragEnd(s);
        }

        null == a || a(e, t);
      }
    }, e.prototype.snapToCursor = function (e) {
      var t = this;
      this.prepareBoundingBox(), Pr(function (n) {
        if (_o(n, t.props.drag, t.currentDirection)) {
          var r = t.getAxisMotionValue(n);

          if (r) {
            var o = pr(e).point,
                i = t.visualElement.getLayoutState().layout,
                a = i[n].max - i[n].min,
                s = i[n].min + a / 2,
                l = o[n] - s;
            t.originPoint[n] = o[n], r.set(l);
          } else t.cursorProgress[n] = .5, t.updateVisualElementAxis(n, e);
        }
      });
    }, e.prototype.updateAxis = function (e, t, n) {
      if (_o(e, this.props.drag, this.currentDirection)) return this.getAxisMotionValue(e) ? this.updateAxisMotionValue(e, n) : this.updateVisualElementAxis(e, t);
    }, e.prototype.updateAxisMotionValue = function (e, t) {
      var n = this.getAxisMotionValue(e);

      if (t && n) {
        var r = this.originPoint[e] + t[e],
            o = this.constraints ? Zr(r, this.constraints[e], this.elastic[e]) : r;
        n.set(o);
      }
    }, e.prototype.updateVisualElementAxis = function (e, t) {
      var n,
          r = this.visualElement.getLayoutState().layout[e],
          o = r.max - r.min,
          i = this.cursorProgress[e],
          a = function (e, t, n, r, o) {
        var i = e - t * n;
        return r ? Zr(i, r, o) : i;
      }(pr(t).point[e], o, i, null === (n = this.constraints) || void 0 === n ? void 0 : n[e], this.elastic[e]);

      this.visualElement.setProjectionTargetAxis(e, a, a + o);
    }, e.prototype.setProps = function (e) {
      var t = e.drag,
          n = void 0 !== t && t,
          r = e.dragDirectionLock,
          o = void 0 !== r && r,
          i = e.dragPropagation,
          a = void 0 !== i && i,
          s = e.dragConstraints,
          l = void 0 !== s && s,
          c = e.dragElastic,
          u = void 0 === c ? .35 : c,
          d = e.dragMomentum,
          f = void 0 === d || d,
          p = be(e, ["drag", "dragDirectionLock", "dragPropagation", "dragConstraints", "dragElastic", "dragMomentum"]);
      this.props = _ye({
        drag: n,
        dragDirectionLock: o,
        dragPropagation: a,
        dragConstraints: l,
        dragElastic: u,
        dragMomentum: f
      }, p);
    }, e.prototype.getAxisMotionValue = function (e) {
      var t = this.props,
          n = t.layout,
          r = t.layoutId,
          o = "_drag" + e.toUpperCase();
      return this.props[o] ? this.props[o] : n || void 0 !== r ? void 0 : this.visualElement.getValue(e, 0);
    }, e.prototype.animateDragEnd = function (e) {
      var t = this,
          n = this.props,
          r = n.drag,
          o = n.dragMomentum,
          i = n.dragElastic,
          a = n.dragTransition,
          s = Pr(function (n) {
        if (_o(n, r, t.currentDirection)) {
          var s = t.constraints ? t.constraints[n] : {},
              l = i ? 200 : 1e6,
              c = i ? 40 : 1e7,
              u = _ye(_ye({
            type: "inertia",
            velocity: o ? e[n] : 0,
            bounceStiffness: l,
            bounceDamping: c,
            timeConstant: 750,
            restDelta: 1,
            restSpeed: 10
          }, a), s);

          return t.getAxisMotionValue(n) ? t.startAxisValueAnimation(n, u) : t.visualElement.startLayoutAnimation(n, u);
        }
      });
      return Promise.all(s).then(function () {
        var e, n;
        null === (n = (e = t.props).onDragTransitionEnd) || void 0 === n || n.call(e);
      });
    }, e.prototype.stopMotion = function () {
      var e = this;
      Pr(function (t) {
        var n = e.getAxisMotionValue(t);
        n ? n.stop() : e.visualElement.stopLayoutAnimation();
      });
    }, e.prototype.startAxisValueAnimation = function (e, t) {
      var n = this.getAxisMotionValue(e);

      if (n) {
        var r = n.get();
        return n.set(r), n.set(r), Co(e, n, 0, t);
      }
    }, e.prototype.scalePoint = function () {
      var e = this,
          t = this.props,
          n = t.drag;

      if (Fe(t.dragConstraints) && this.constraintsBox) {
        this.stopMotion();
        var r = {
          x: 0,
          y: 0
        };
        Pr(function (t) {
          r[t] = qr(e.visualElement.projection.target[t], e.constraintsBox[t]);
        }), this.prepareBoundingBox(), this.resolveDragConstraints(), Pr(function (t) {
          if (_o(t, n, null)) {
            var o = function (e, t, n) {
              var r = e.max - e.min,
                  o = dt(t.min, t.max - r, n);
              return {
                min: o,
                max: o + r
              };
            }(e.visualElement.projection.target[t], e.constraintsBox[t], r[t]),
                i = o.min,
                a = o.max;

            e.visualElement.setProjectionTargetAxis(t, i, a);
          }
        });
      }
    }, e.prototype.mount = function (e) {
      var t = this,
          n = vr(e.getInstance(), "pointerdown", function (e) {
        var n = t.props,
            r = n.drag,
            o = n.dragListener;
        r && (void 0 === o || o) && t.start(e);
      }),
          r = Ye(window, "resize", function () {
        t.scalePoint();
      }),
          o = e.onLayoutUpdate(function () {
        t.isDragging && t.resolveDragConstraints();
      }),
          i = e.prevDragCursor;
      return i && this.start(Mo, {
        cursorProgress: i
      }), function () {
        null == n || n(), null == r || r(), null == o || o(), t.cancelDrag();
      };
    }, e;
  }();

  function _o(e, t, n) {
    return !(!0 !== t && t !== e || null !== n && n !== e);
  }

  var To = function To(e) {
    return function (t) {
      return e(t), null;
    };
  },
      So = To(function (e) {
    var t = e.visualElement;
    return function (e, t) {
      var n = e.dragControls,
          r = o.useContext(we).transformPagePoint,
          i = Ce(function () {
        return new Eo({
          visualElement: t
        });
      });
      i.setProps(_ye(_ye({}, e), {
        transformPagePoint: r
      })), o.useEffect(function () {
        return n && n.subscribe(i);
      }, [i]), o.useEffect(function () {
        return i.mount(t);
      }, []);
    }(be(e, ["visualElement"]), t);
  }),
      Lo = {
    key: "drag",
    shouldRender: function shouldRender(e) {
      return !!e.drag || !!e.dragControls;
    },
    getComponent: function getComponent() {
      return So;
    }
  };

  function Do(e) {
    return o.useEffect(function () {
      return function () {
        return e();
      };
    }, []);
  }

  var Ao = function Ao(e, t) {
    return !!t && (e === t || Ao(e, t.parentElement));
  };

  function No(e, t) {
    var n = e.onTap,
        r = e.onTapStart,
        i = e.onTapCancel,
        a = e.whileTap,
        s = n || r || i || a,
        l = o.useRef(!1),
        c = o.useRef(null);

    function u() {
      var e;
      null === (e = c.current) || void 0 === e || e.call(c), c.current = null;
    }

    function d() {
      var e, n;
      return u(), l.current = !1, null === (e = t.animationState) || void 0 === e || e.setActive(yo.Tap, !1), !(!(n = Ar(!0)) || (n(), 0));
    }

    function f(e, r) {
      d() && (Ao(t.getInstance(), e.target) ? null == n || n(e, r) : null == i || i(e, r));
    }

    function p(e, t) {
      d() && (null == i || i(e, t));
    }

    xr(t, "pointerdown", s ? function (e, n) {
      var o;
      u(), l.current || (l.current = !0, c.current = tn(vr(window, "pointerup", f), vr(window, "pointercancel", p)), null == r || r(e, n), null === (o = t.animationState) || void 0 === o || o.setActive(yo.Tap, !0));
    } : void 0), Do(u);
  }

  function Io(e, t, n) {
    return function (r, o) {
      var i;
      sr(r) && e.isHoverEventsEnabled && (null == n || n(r, o), null === (i = e.animationState) || void 0 === i || i.setActive(yo.Hover, t));
    };
  }

  function zo(e, t) {
    var n, r, i, a, s, l, c, u, d, f;
    r = t, i = (n = e).onPan, a = n.onPanStart, s = n.onPanEnd, l = n.onPanSessionStart, c = i || a || s || l, u = o.useRef(null), d = o.useContext(we).transformPagePoint, f = {
      onSessionStart: l,
      onStart: a,
      onMove: i,
      onEnd: function onEnd(e, t) {
        u.current = null, s && s(e, t);
      }
    }, o.useEffect(function () {
      null !== u.current && u.current.updateHandlers(f);
    }), xr(r, "pointerdown", c && function (e) {
      u.current = new kr(e, f, {
        transformPagePoint: d
      });
    }), Do(function () {
      return u.current && u.current.end();
    }), No(e, t), function (e, t) {
      var n = e.onHoverStart,
          r = e.onHoverEnd,
          o = e.whileHover;
      xr(t, "pointerenter", n || o ? Io(t, !0, n) : void 0), xr(t, "pointerleave", r || o ? Io(t, !1, r) : void 0);
    }(e, t), function (e, t) {
      var n = e.whileFocus;
      Qe(t, "focus", n ? function () {
        var e;
        null === (e = t.animationState) || void 0 === e || e.setActive(yo.Focus, !0);
      } : void 0), Qe(t, "blur", n ? function () {
        var e;
        null === (e = t.animationState) || void 0 === e || e.setActive(yo.Focus, !1);
      } : void 0);
    }(e, t);
  }

  var Oo = ["onPan", "onPanStart", "onPanEnd", "onPanSessionStart", "onTap", "onTapStart", "onTapCancel", "onHoverStart", "onHoverEnd", "whileFocus", "whileTap", "whileHover"],
      Ro = To(function (e) {
    var t = e.visualElement;
    zo(be(e, ["visualElement"]), t);
  }),
      Po = {
    key: "gestures",
    shouldRender: function shouldRender(e) {
      return Oo.some(function (t) {
        return e.hasOwnProperty(t);
      });
    },
    getComponent: function getComponent() {
      return Ro;
    }
  };
  var Fo = To(function (e) {
    var t = e.custom,
        n = e.visualElement,
        r = ve(Me(), 2),
        i = r[0],
        a = r[1],
        s = o.useContext(ke);
    o.useEffect(function () {
      var e,
          r,
          o = null === (e = n.animationState) || void 0 === e ? void 0 : e.setActive(yo.Exit, !i, {
        custom: null !== (r = null == s ? void 0 : s.custom) && void 0 !== r ? r : t
      });
      !i && (null == o || o.then(a));
    }, [i]);
  }),
      Bo = {
    key: "exit",
    shouldRender: function shouldRender(e) {
      return !!e.exit && !function (e) {
        var t = e.animate,
            n = e.variants,
            r = e.inherit;
        return null != r ? r : !!n && !t;
      }(e);
    },
    getComponent: function getComponent() {
      return Fo;
    }
  };

  var qo = function () {
    function e() {
      this.subscriptions = [];
    }

    return e.prototype.add = function (e) {
      var t,
          n,
          r = this;
      return t = this.subscriptions, n = e, -1 === t.indexOf(n) && t.push(n), function () {
        return function (e, t) {
          var n = e.indexOf(t);
          n > -1 && e.splice(n, 1);
        }(r.subscriptions, e);
      };
    }, e.prototype.notify = function (e, t, n) {
      var r = this.subscriptions.length;
      if (r) if (1 === r) this.subscriptions[0](e, t, n);else for (var o = 0; o < r; o++) {
        var i = this.subscriptions[o];
        i && i(e, t, n);
      }
    }, e.prototype.getSize = function () {
      return this.subscriptions.length;
    }, e.prototype.clear = function () {
      this.subscriptions.length = 0;
    }, e;
  }(),
      Uo = function () {
    function e(e) {
      var t,
          n = this;
      this.timeDelta = 0, this.lastUpdated = 0, this.updateSubscribers = new qo(), this.velocityUpdateSubscribers = new qo(), this.renderSubscribers = new qo(), this.canTrackVelocity = !1, this.updateAndNotify = function (e, t) {
        void 0 === t && (t = !0), n.prev = n.current, n.current = e;
        var r = Zn(),
            o = r.delta,
            i = r.timestamp;
        n.lastUpdated !== i && (n.timeDelta = o, n.lastUpdated = i, Bn.postRender(n.scheduleVelocityCheck)), n.prev !== n.current && n.updateSubscribers.notify(n.current), n.velocityUpdateSubscribers.getSize() && n.velocityUpdateSubscribers.notify(n.getVelocity()), t && n.renderSubscribers.notify(n.current);
      }, this.scheduleVelocityCheck = function () {
        return Bn.postRender(n.velocityCheck);
      }, this.velocityCheck = function (e) {
        e.timestamp !== n.lastUpdated && (n.prev = n.current, n.velocityUpdateSubscribers.notify(n.getVelocity()));
      }, this.hasAnimated = !1, this.prev = this.current = e, this.canTrackVelocity = (t = this.current, !isNaN(parseFloat(t)));
    }

    return e.prototype.onChange = function (e) {
      return this.updateSubscribers.add(e);
    }, e.prototype.clearListeners = function () {
      this.updateSubscribers.clear();
    }, e.prototype.onRenderRequest = function (e) {
      return e(this.get()), this.renderSubscribers.add(e);
    }, e.prototype.attach = function (e) {
      this.passiveEffect = e;
    }, e.prototype.set = function (e, t) {
      void 0 === t && (t = !0), t && this.passiveEffect ? this.passiveEffect(e, this.updateAndNotify) : this.updateAndNotify(e, t);
    }, e.prototype.get = function () {
      return this.current;
    }, e.prototype.getPrevious = function () {
      return this.prev;
    }, e.prototype.getVelocity = function () {
      return this.canTrackVelocity ? Yn(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
    }, e.prototype.start = function (e) {
      var t = this;
      return this.stop(), new Promise(function (n) {
        t.hasAnimated = !0, t.stopAnimation = e(n);
      }).then(function () {
        return t.clearAnimation();
      });
    }, e.prototype.stop = function () {
      this.stopAnimation && this.stopAnimation(), this.clearAnimation();
    }, e.prototype.isAnimating = function () {
      return !!this.stopAnimation;
    }, e.prototype.clearAnimation = function () {
      this.stopAnimation = null;
    }, e.prototype.destroy = function () {
      this.updateSubscribers.clear(), this.renderSubscribers.clear(), this.stop();
    }, e;
  }();

  function Vo(e) {
    return new Uo(e);
  }

  var Ho = function Ho(e) {
    return /^\-?\d*\.?\d+$/.test(e);
  },
      Zo = function Zo(e) {
    return eo(e) ? e[e.length - 1] || 0 : e;
  };

  function Wo(e, t, n) {
    e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, Vo(n));
  }

  function $o(e, t, n) {
    var r,
        o,
        i,
        a,
        s = Object.keys(t).filter(function (t) {
      return !e.hasValue(t);
    }),
        l = s.length;
    if (l) for (var c = 0; c < l; c++) {
      var u = s[c],
          d = t[u],
          f = null;
      Array.isArray(d) && (f = d[0]), null === f && (f = null !== (o = null !== (r = n[u]) && void 0 !== r ? r : e.readValue(u)) && void 0 !== o ? o : t[u]), null != f && ("string" == typeof f && Ho(f) ? f = parseFloat(f) : !po(f) && Vt.test(d) && (f = go(u, d)), e.addValue(u, Vo(f)), null !== (i = (a = n)[u]) && void 0 !== i || (a[u] = f), e.setBaseTarget(u, f));
    }
  }

  function Go(e, t) {
    if (t) return (t[e] || t["default"] || t).from;
  }

  function Yo(e, t, n) {
    var r,
        o,
        i = {};

    for (var a in e) {
      i[a] = null !== (r = Go(a, t)) && void 0 !== r ? r : null === (o = n.getValue(a)) || void 0 === o ? void 0 : o.get();
    }

    return i;
  }

  function Qo(e, t, n) {
    var r;
    void 0 === n && (n = {});
    var o = Ve(e, t, n.custom),
        i = (o || {}).transition,
        a = void 0 === i ? e.getDefaultTransition() || {} : i;
    n.transitionOverride && (a = n.transitionOverride);
    var s = o ? function () {
      return Xo(e, o, n);
    } : function () {
      return Promise.resolve();
    },
        l = (null === (r = e.variantChildren) || void 0 === r ? void 0 : r.size) ? function (r) {
      void 0 === r && (r = 0);
      var o = a.delayChildren,
          i = void 0 === o ? 0 : o,
          s = a.staggerChildren,
          l = a.staggerDirection;
      return function (e, t, n, r, o, i) {
        void 0 === n && (n = 0);
        void 0 === r && (r = 0);
        void 0 === o && (o = 1);
        var a = [],
            s = (e.variantChildren.size - 1) * r,
            l = 1 === o ? function (e) {
          return void 0 === e && (e = 0), e * r;
        } : function (e) {
          return void 0 === e && (e = 0), s - e * r;
        };
        return Array.from(e.variantChildren).sort(Ko).forEach(function (e, r) {
          a.push(Qo(e, t, _ye(_ye({}, i), {
            delay: n + l(r)
          })).then(function () {
            return e.notifyAnimationComplete(t);
          }));
        }), Promise.all(a);
      }(e, t, i + r, s, l, n);
    } : function () {
      return Promise.resolve();
    },
        c = a.when;

    if (c) {
      var u = ve("beforeChildren" === c ? [s, l] : [l, s], 2),
          d = u[0],
          f = u[1];
      return d().then(f);
    }

    return Promise.all([s(), l(n.delay)]);
  }

  function Xo(e, t, n) {
    var r,
        o = void 0 === n ? {} : n,
        i = o.delay,
        a = void 0 === i ? 0 : i,
        s = o.transitionOverride,
        l = o.type,
        c = e.makeTargetAnimatable(t),
        u = c.transition,
        d = void 0 === u ? e.getDefaultTransition() : u,
        f = c.transitionEnd,
        p = be(c, ["transition", "transitionEnd"]);
    s && (d = s);
    var h = [],
        m = l && (null === (r = e.animationState) || void 0 === r ? void 0 : r.getState()[l]);

    for (var g in p) {
      var y = e.getValue(g),
          b = p[g];

      if (!(!y || void 0 === b || m && Jo(m, g))) {
        var v = Co(g, y, b, _ye({
          delay: a
        }, d));
        h.push(v);
      }
    }

    return Promise.all(h).then(function () {
      f && function (e, t) {
        var n = Ve(e, t),
            r = n ? e.makeTargetAnimatable(n, !1) : {},
            o = r.transitionEnd,
            i = void 0 === o ? {} : o;
        r.transition;
        var a = be(r, ["transitionEnd", "transition"]);

        for (var s in a = _ye(_ye({}, a), i)) {
          Wo(e, s, Zo(a[s]));
        }
      }(e, f);
    });
  }

  function Ko(e, t) {
    return e.sortNodePosition(t);
  }

  function Jo(e, t) {
    var n = e.protectedKeys,
        r = e.needsAnimating,
        o = n.hasOwnProperty(t) && !0 !== r[t];
    return r[t] = !1, o;
  }

  function ei(e) {
    return "object" == _typeof(e) && "function" == typeof e.start;
  }

  function ti(e, t) {
    if (!Array.isArray(t)) return !1;
    var n = t.length;
    if (n !== e.length) return !1;

    for (var r = 0; r < n; r++) {
      if (t[r] !== e[r]) return !1;
    }

    return !0;
  }

  var ni = [yo.Animate, yo.Hover, yo.Tap, yo.Drag, yo.Focus, yo.Exit],
      ri = xe(ni).reverse(),
      oi = ni.length;

  function ii(e) {
    return function (t) {
      return Promise.all(t.map(function (t) {
        var n = t.animation,
            r = t.options;
        return function (e, t, n) {
          var r;

          if (void 0 === n && (n = {}), e.notifyAnimationStart(), Array.isArray(t)) {
            var o = t.map(function (t) {
              return Qo(e, t, n);
            });
            r = Promise.all(o);
          } else if ("string" == typeof t) r = Qo(e, t, n);else {
            var i = "function" == typeof t ? Ve(e, t, n.custom) : t;
            r = Xo(e, i, n);
          }

          return r.then(function () {
            return e.notifyAnimationComplete(t);
          });
        }(e, n, r);
      }));
    };
  }

  function ai(e) {
    var t,
        n = ii(e),
        r = ((t = {})[yo.Animate] = si(!0), t[yo.Hover] = si(), t[yo.Tap] = si(), t[yo.Drag] = si(), t[yo.Focus] = si(), t[yo.Exit] = si(), t),
        o = {},
        i = !0,
        a = function a(t, n) {
      var r = Ve(e, n);

      if (r) {
        r.transition;
        var o = r.transitionEnd,
            i = be(r, ["transition", "transitionEnd"]);
        t = _ye(_ye(_ye({}, t), i), o);
      }

      return t;
    };

    function s(t, s) {
      for (var l = e.getProps(), c = e.getVariantContext(!0) || {}, u = [], d = new Set(), f = {}, p = 1 / 0, h = function h(n) {
        var o = ri[n],
            h = r[o],
            m = null !== (k = l[o]) && void 0 !== k ? k : c[o],
            g = qe(m),
            y = o === s ? h.isActive : null;
        !1 === y && (p = n);
        var b = m === c[o] && m !== l[o] && g;
        if (b && i && e.manuallyAnimateOnMount && (b = !1), h.protectedKeys = _ye({}, f), !h.isActive && null === y || !m && !h.prevProp || ei(m) || "boolean" == typeof m) return "continue";

        var v = function (e, t) {
          if ("string" == typeof t) return t !== e;
          if (Be(t)) return !ti(t, e);
          return !1;
        }(h.prevProp, m) || o === s && h.isActive && !b && g || n > p && g,
            x = Array.isArray(m) ? m : [m],
            w = x.reduce(a, {});

        !1 === y && (w = {});

        var k = h.prevResolvedValues,
            C = void 0 === k ? {} : k,
            M = _ye(_ye({}, C), w),
            j = function j(e) {
          v = !0, d["delete"](e), h.needsAnimating[e] = !0;
        };

        for (var E in M) {
          var _ = w[E],
              T = C[E];
          f.hasOwnProperty(E) || (_ !== T ? eo(_) && eo(T) ? ti(_, T) ? h.protectedKeys[E] = !0 : j(E) : void 0 !== _ ? j(E) : d.add(E) : void 0 !== _ && d.has(E) ? j(E) : h.protectedKeys[E] = !0);
        }

        h.prevProp = m, h.prevResolvedValues = w, h.isActive && (f = _ye(_ye({}, f), w)), i && e.blockInitialAnimation && (v = !1), v && !b && u.push.apply(u, xe(x.map(function (e) {
          return {
            animation: e,
            options: _ye({
              type: o
            }, t)
          };
        })));
      }, m = 0; m < oi; m++) {
        h(m);
      }

      if (o = _ye({}, f), d.size) {
        var g = {};
        d.forEach(function (t) {
          var n = e.getBaseTarget(t);
          void 0 !== n && (g[t] = n);
        }), u.push({
          animation: g
        });
      }

      var y = Boolean(u.length);
      return i && !1 === l.initial && !e.manuallyAnimateOnMount && (y = !1), i = !1, y ? n(u) : Promise.resolve();
    }

    return {
      isAnimated: function isAnimated(e) {
        return void 0 !== o[e];
      },
      animateChanges: s,
      setActive: function setActive(t, n, o) {
        var i;
        return r[t].isActive === n ? Promise.resolve() : (null === (i = e.variantChildren) || void 0 === i || i.forEach(function (e) {
          var r;
          return null === (r = e.animationState) || void 0 === r ? void 0 : r.setActive(t, n);
        }), r[t].isActive = n, s(o, t));
      },
      setAnimateFunction: function setAnimateFunction(t) {
        n = t(e);
      },
      getState: function getState() {
        return r;
      }
    };
  }

  function si(e) {
    return void 0 === e && (e = !1), {
      isActive: e,
      protectedKeys: {},
      needsAnimating: {},
      prevResolvedValues: {}
    };
  }

  var li = To(function (e) {
    var t = e.visualElement,
        n = e.animate;
    t.animationState || (t.animationState = ai(t)), ei(n) && o.useEffect(function () {
      return n.subscribe(t);
    }, [n]);
  }),
      ci = {
    key: "animation",
    shouldRender: function shouldRender() {
      return !0;
    },
    getComponent: function getComponent(e) {
      var t = e.animate,
          n = e.whileHover,
          r = e.whileFocus,
          o = e.whileTap,
          i = e.whileDrag,
          a = e.exit,
          s = e.variants;
      return t || n || r || o || i || a || s ? li : void 0;
    }
  };

  var ui = function (e) {
    function t() {
      var t = null !== e && e.apply(this, arguments) || this;
      return t.frameTarget = {
        x: {
          min: 0,
          max: 1
        },
        y: {
          min: 0,
          max: 1
        }
      }, t.currentAnimationTarget = {
        x: {
          min: 0,
          max: 1
        },
        y: {
          min: 0,
          max: 1
        }
      }, t.isAnimating = {
        x: !1,
        y: !1
      }, t.stopAxisAnimation = {
        x: void 0,
        y: void 0
      }, t.isAnimatingTree = !1, t.animate = function (e, n, r) {
        void 0 === r && (r = {});
        var o = r.originBox,
            i = r.targetBox,
            a = r.visibilityAction,
            s = r.shouldStackAnimate,
            l = r.onComplete,
            c = be(r, ["originBox", "targetBox", "visibilityAction", "shouldStackAnimate", "onComplete"]),
            u = t.props,
            d = u.visualElement,
            f = u.layout;
        if (!1 === s) return t.isAnimatingTree = !1, t.safeToRemove();

        if (!t.isAnimatingTree || !0 === s) {
          s && (t.isAnimatingTree = !0);
          var p = fi(n = o || n, e = i || e),
              h = Pr(function (r) {
            if ("position" === f) {
              var o = e[r].max - e[r].min;
              n[r].max = n[r].min + o;
            }

            if (!d.projection.isTargetLocked) return void 0 === a ? p ? t.animateAxis(r, e[r], n[r], c) : d.setProjectionTargetAxis(r, e[r].min, e[r].max) : void d.setVisibility(a === Ee.Show);
          });
          return d.syncRender(), Promise.all(h).then(function () {
            t.isAnimatingTree = !1, l && l(), d.notifyLayoutAnimationComplete();
          });
        }
      }, t;
    }

    return ge(t, e), t.prototype.componentDidMount = function () {
      var e = this,
          t = this.props.visualElement;
      t.animateMotionValue = Co, t.enableLayoutProjection(), this.unsubLayoutReady = t.onLayoutUpdate(this.animate), t.layoutSafeToRemove = function () {
        return e.safeToRemove();
      };
    }, t.prototype.componentWillUnmount = function () {
      var e = this;
      this.unsubLayoutReady(), Pr(function (t) {
        var n, r;
        return null === (r = (n = e.stopAxisAnimation)[t]) || void 0 === r ? void 0 : r.call(n);
      });
    }, t.prototype.animateAxis = function (e, t, n, r) {
      var o,
          i,
          a = this,
          s = (void 0 === r ? {} : r).transition;

      if (!this.isAnimating[e] || !mi(t, this.currentAnimationTarget[e])) {
        null === (i = (o = this.stopAxisAnimation)[e]) || void 0 === i || i.call(o), this.isAnimating[e] = !0;
        var l = this.props.visualElement,
            c = this.frameTarget[e],
            u = l.getProjectionAnimationProgress()[e];
        u.clearListeners(), u.set(0), u.set(0);

        var d = function d() {
          var r = u.get() / 1e3;
          !function (e, t, n, r) {
            e.min = dt(t.min, n.min, r), e.max = dt(t.max, n.max, r);
          }(c, n, t, r), l.setProjectionTargetAxis(e, c.min, c.max);
        };

        d(), l.updateLayoutProjection();
        var f = u.onChange(d);
        return this.stopAxisAnimation[e] = function () {
          a.isAnimating[e] = !1, u.stop(), f();
        }, this.currentAnimationTarget[e] = t, Co("x" === e ? "layoutX" : "layoutY", u, 1e3, s || this.props.transition || gi).then(this.stopAxisAnimation[e]);
      }
    }, t.prototype.safeToRemove = function () {
      var e, t;
      null === (t = (e = this.props).safeToRemove) || void 0 === t || t.call(e);
    }, t.prototype.render = function () {
      return null;
    }, t;
  }(o.Component);

  function di(e) {
    var t = ve(Me(), 2)[1];
    return o.createElement(ui, _ye({}, e, {
      safeToRemove: t
    }));
  }

  function fi(e, t) {
    return !(hi(e) || hi(t) || mi(e.x, t.x) && mi(e.y, t.y));
  }

  var pi = {
    min: 0,
    max: 0
  };

  function hi(e) {
    return mi(e.x, pi) && mi(e.y, pi);
  }

  function mi(e, t) {
    return e.min === t.min && e.max === t.max;
  }

  var gi = {
    duration: .45,
    ease: [.4, 0, .1, 1]
  },
      yi = {
    key: "animate-layout",
    shouldRender: function shouldRender(e) {
      return !!e.layout || void 0 !== e.layoutId;
    },
    getComponent: function getComponent() {
      return di;
    }
  };

  function bi(e) {
    return "string" == typeof e && e.startsWith("var(--");
  }

  var vi = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;

  function xi(e, t, n) {
    void 0 === n && (n = 1), Ke(n <= 4, 'Max CSS variable fallback depth detected in property "' + e + '". This may indicate a circular fallback dependency.');
    var r = ve(function (e) {
      var t = vi.exec(e);
      if (!t) return [,];
      var n = ve(t, 3);
      return [n[1], n[2]];
    }(e), 2),
        o = r[0],
        i = r[1];

    if (o) {
      var a = window.getComputedStyle(t).getPropertyValue(o);
      return a ? a.trim() : bi(i) ? xi(i, t, n + 1) : i;
    }
  }

  function wi(e, t) {
    return e / (t.max - t.min) * 100;
  }

  var ki = "_$css";
  var Ci = {
    process: function process(e, t, n) {
      var r = n.target;

      if ("string" == typeof e) {
        if (!jt.test(e)) return e;
        e = parseFloat(e);
      }

      return wi(e, r.x) + "% " + wi(e, r.y) + "%";
    }
  },
      Mi = {
    borderRadius: _ye(_ye({}, Ci), {
      applyTo: ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomLeftRadius", "borderBottomRightRadius"]
    }),
    borderTopLeftRadius: Ci,
    borderTopRightRadius: Ci,
    borderBottomLeftRadius: Ci,
    borderBottomRightRadius: Ci,
    boxShadow: {
      process: function process(e, t) {
        var n = t.delta,
            r = t.treeScale,
            o = e,
            i = e.includes("var("),
            a = [];
        i && (e = e.replace(vi, function (e) {
          return a.push(e), ki;
        }));
        var s = Vt.parse(e);
        if (s.length > 5) return o;
        var l = Vt.createTransformer(e),
            c = "number" != typeof s[0] ? 1 : 0,
            u = n.x.scale * r.x,
            d = n.y.scale * r.y;
        s[0 + c] /= u, s[1 + c] /= d;
        var f = dt(u, d, .5);
        "number" == typeof s[2 + c] && (s[2 + c] /= f), "number" == typeof s[3 + c] && (s[3 + c] /= f);
        var p = l(s);

        if (i) {
          var h = 0;
          p = p.replace(ki, function () {
            var e = a[h];
            return h++, e;
          });
        }

        return p;
      }
    }
  },
      ji = new Set(xe(["initial", "animate", "exit", "style", "variants", "transition", "transformTemplate", "transformValues", "custom", "inherit", "layout", "layoutId", "onLayoutAnimationComplete", "onViewportBoxUpdate", "onLayoutMeasure", "onBeforeLayoutMeasure", "onAnimationStart", "onAnimationComplete", "onUpdate", "onDragStart", "onDrag", "onDragEnd", "onMeasureDragConstraints", "onDirectionLock", "onDragTransitionEnd", "drag", "dragControls", "dragListener", "dragConstraints", "dragDirectionLock", "_dragX", "_dragY", "dragElastic", "dragMomentum", "dragPropagation", "dragTransition", "whileDrag"], Oo));

  function Ei(e) {
    return ji.has(e);
  }

  var _i = function _i(e) {
    return e instanceof Uo;
  };

  function Ti() {
    return {
      isHydrated: !1,
      layout: {
        x: {
          min: 0,
          max: 1
        },
        y: {
          min: 0,
          max: 1
        }
      },
      layoutCorrected: {
        x: {
          min: 0,
          max: 1
        },
        y: {
          min: 0,
          max: 1
        }
      },
      treeScale: {
        x: 1,
        y: 1
      },
      delta: Rr(),
      deltaFinal: Rr(),
      deltaTransform: ""
    };
  }

  var Si = Ti(),
      Li = ["", "X", "Y", "Z"],
      Di = ["transformPerspective", "x", "y", "z"];

  function Ai(e, t) {
    return Di.indexOf(e) - Di.indexOf(t);
  }

  ["translate", "scale", "rotate", "skew"].forEach(function (e) {
    return Li.forEach(function (t) {
      return Di.push(e + t);
    });
  });
  var Ni = new Set(Di);

  function Ii(e) {
    return Ni.has(e);
  }

  var zi = new Set(["originX", "originY", "originZ"]);

  function Oi(e) {
    return zi.has(e);
  }

  var Ri = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
  };

  function Pi(e, t, n) {
    var r = e.x,
        o = e.y,
        i = "translate3d(" + r.translate / t.x + "px, " + o.translate / t.y + "px, 0) ";

    if (n) {
      var a = n.rotate,
          s = n.rotateX,
          l = n.rotateY;
      a && (i += "rotate(" + a + ") "), s && (i += "rotateX(" + s + ") "), l && (i += "rotateY(" + l + ") ");
    }

    return i += "scale(" + r.scale + ", " + o.scale + ")", n || i !== Fi ? i : "";
  }

  var Fi = Pi(Si.delta, Si.treeScale, {
    x: 1,
    y: 1
  });

  function Bi(e, t) {
    e.min = t.min, e.max = t.max;
  }

  function qi(e, t, n) {
    return n + t * (e - n);
  }

  function Ui(e, t, n, r, o) {
    return void 0 !== o && (e = qi(e, o, r)), qi(e, n, r) + t;
  }

  function Vi(e, t, n, r, o) {
    void 0 === t && (t = 0), void 0 === n && (n = 1), e.min = Ui(e.min, t, n, r, o), e.max = Ui(e.max, t, n, r, o);
  }

  function Hi(e, t) {
    var n = t.x,
        r = t.y;
    Vi(e.x, n.translate, n.scale, n.originPoint), Vi(e.y, r.translate, r.scale, r.originPoint);
  }

  function Zi(e, t, n, r) {
    var o = ve(r, 3),
        i = o[0],
        a = o[1],
        s = o[2];
    e.min = t.min, e.max = t.max;
    var l = void 0 !== n[s] ? n[s] : .5,
        c = dt(t.min, t.max, l);
    Vi(e, n[i], n[a], c, n.scale);
  }

  var Wi = ["x", "scaleX", "originX"],
      $i = ["y", "scaleY", "originY"];

  function Gi(e, t, n, r, o) {
    return e = qi(e -= t, 1 / n, r), void 0 !== o && (e = qi(e, 1 / o, r)), e;
  }

  function Yi(e, t, n) {
    var r = ve(n, 3),
        o = r[0],
        i = r[1],
        a = r[2];
    !function (e, t, n, r, o) {
      void 0 === t && (t = 0), void 0 === n && (n = 1), void 0 === r && (r = .5);
      var i = dt(e.min, e.max, r) - t;
      e.min = Gi(e.min, t, n, i, o), e.max = Gi(e.max, t, n, i, o);
    }(e, t[o], t[i], t[a], t.scale);
  }

  var Qi = ["LayoutMeasure", "BeforeLayoutMeasure", "LayoutUpdate", "ViewportBoxUpdate", "Update", "Render", "AnimationComplete", "LayoutAnimationComplete", "AnimationStart", "SetAxisTarget"];

  function Xi(e, t, n, r) {
    var o,
        i,
        a = e.delta,
        s = e.layout,
        l = e.layoutCorrected,
        c = e.treeScale,
        u = t.target;
    i = s, Bi((o = l).x, i.x), Bi(o.y, i.y), function (e, t, n) {
      var r = n.length;

      if (r) {
        t.x = t.y = 1;

        for (var o = 0; o < r; o++) {
          var i = n[o].getLayoutState().delta;
          t.x *= i.x.scale, t.y *= i.y.scale, Hi(e, i);
        }
      }
    }(l, c, n), Vr(a, l, u, r);
  }

  var Ki = function Ki(e) {
    var t = e.treeType,
        n = void 0 === t ? "" : t,
        r = e.build,
        o = e.getBaseTarget,
        i = e.makeTargetAnimatable,
        a = e.measureViewportBox,
        s = e.render,
        l = e.readValueFromInstance,
        c = e.resetTransform,
        u = e.restoreTransform,
        d = e.removeValueFromRenderState,
        f = e.sortNodePosition,
        p = e.scrapeMotionValuesFromProps;
    return function (e, t) {
      var h = e.parent,
          m = e.props,
          g = e.presenceId,
          y = e.blockInitialAnimation,
          b = e.visualState;
      void 0 === t && (t = {});

      var v,
          x,
          w,
          k,
          C,
          M,
          j = b.latestValues,
          E = b.renderState,
          _ = new Set(),
          T = function () {
        var e = Qi.map(function () {
          return new qo();
        }),
            t = {},
            n = {
          clearAllListeners: function clearAllListeners() {
            return e.forEach(function (e) {
              return e.clear();
            });
          },
          updatePropListeners: function updatePropListeners(e) {
            return Qi.forEach(function (r) {
              var o;
              null === (o = t[r]) || void 0 === o || o.call(t);
              var i = "on" + r,
                  a = e[i];
              a && (t[r] = n[i](a));
            });
          }
        };
        return e.forEach(function (e, t) {
          n["on" + Qi[t]] = function (t) {
            return e.add(t);
          }, n["notify" + Qi[t]] = function () {
            for (var t = [], n = 0; n < arguments.length; n++) {
              t[n] = arguments[n];
            }

            return e.notify.apply(e, xe(t));
          };
        }), n;
      }(),
          S = {
        isEnabled: !1,
        isTargetLocked: !1,
        target: {
          x: {
            min: 0,
            max: 1
          },
          y: {
            min: 0,
            max: 1
          }
        },
        targetFinal: {
          x: {
            min: 0,
            max: 1
          },
          y: {
            min: 0,
            max: 1
          }
        }
      },
          L = S,
          D = j,
          A = Ti(),
          N = !1,
          I = new Map(),
          z = new Map(),
          O = {},
          R = _ye({}, j);

      function P() {
        return S.isEnabled && A.isHydrated;
      }

      function F() {
        var e, t, n;
        v && (P() && (e = L.targetFinal, t = L.target, n = D, Zi(e.x, t.x, n, Wi), Zi(e.y, t.y, n, $i), Vr(A.deltaFinal, A.layoutCorrected, L.targetFinal, j)), B(), s(v, E));
      }

      function B() {
        var e = j;

        if (w && w.isActive()) {
          var n = w.getCrossfadeState($);
          n && (e = n);
        }

        r($, E, e, L, A, t, m);
      }

      function q() {
        T.notifyUpdate(j);
      }

      var U = p(m);

      for (var V in U) {
        var H = U[V];
        void 0 !== j[V] && _i(H) && H.set(j[V], !1);
      }

      var Z = He(m),
          W = Ze(m),
          $ = _ye(_ye({
        treeType: n,
        current: null,
        depth: h ? h.depth + 1 : 0,
        path: h ? xe(h.path, [h]) : [],
        presenceId: g,
        projection: S,
        variantChildren: W ? new Set() : void 0,
        isVisible: void 0,
        manuallyAnimateOnMount: Boolean(null == h ? void 0 : h.isMounted()),
        blockInitialAnimation: y,
        isHoverEventsEnabled: !0,
        isMounted: function isMounted() {
          return Boolean(v);
        },
        mount: function mount(e) {
          v = $.current = e, $.pointTo($), C = null == h ? void 0 : h.addChild($), W && h && !Z && (M = null == h ? void 0 : h.addVariantChild($));
        },
        unmount: function unmount() {
          qn.update(q), qn.render(F), qn.preRender($.updateLayoutProjection), z.forEach(function (e) {
            return e();
          }), $.stopLayoutAnimation(), null == C || C(), null == M || M(), null == x || x(), T.clearAllListeners();
        },
        addChild: function addChild(e) {
          return _.add(e), function () {
            return _["delete"](e);
          };
        },
        addVariantChild: function addVariantChild(e) {
          var t,
              n = $.getClosestVariantNode();
          if (n) return null === (t = n.variantChildren) || void 0 === t || t.add(e), function () {
            return n.variantChildren["delete"](e);
          };
        },
        sortNodePosition: function sortNodePosition(e) {
          return f && n === e.treeType ? f($.getInstance(), e.getInstance()) : 0;
        },
        getClosestVariantNode: function getClosestVariantNode() {
          return W ? $ : null == h ? void 0 : h.getClosestVariantNode();
        },
        scheduleUpdateLayoutProjection: h ? h.scheduleUpdateLayoutProjection : function () {
          return Bn.preRender($.updateLayoutProjection, !1, !0);
        },
        getLayoutId: function getLayoutId() {
          return m.layoutId;
        },
        getInstance: function getInstance() {
          return v;
        },
        getStaticValue: function getStaticValue(e) {
          return j[e];
        },
        setStaticValue: function setStaticValue(e, t) {
          return j[e] = t;
        },
        getLatestValues: function getLatestValues() {
          return j;
        },
        setVisibility: function setVisibility(e) {
          $.isVisible !== e && ($.isVisible = e, $.scheduleRender());
        },
        makeTargetAnimatable: function makeTargetAnimatable(e, t) {
          return void 0 === t && (t = !0), i($, e, m, t);
        },
        suspendHoverEvents: function suspendHoverEvents() {
          $.isHoverEventsEnabled = !1, Bn.postRender(function () {
            return setTimeout(function () {
              return $.isHoverEventsEnabled = !0;
            }, 10);
          });
        },
        addValue: function addValue(e, t) {
          $.hasValue(e) && $.removeValue(e), I.set(e, t), j[e] = t.get(), function (e, t) {
            var n = t.onChange(function (t) {
              j[e] = t, m.onUpdate && Bn.update(q, !1, !0);
            }),
                r = t.onRenderRequest($.scheduleRender);
            z.set(e, function () {
              n(), r();
            });
          }(e, t);
        },
        removeValue: function removeValue(e) {
          var t;
          I["delete"](e), null === (t = z.get(e)) || void 0 === t || t(), z["delete"](e), delete j[e], d(e, E);
        },
        hasValue: function hasValue(e) {
          return I.has(e);
        },
        getValue: function getValue(e, t) {
          var n = I.get(e);
          return void 0 === n && void 0 !== t && (n = Vo(t), $.addValue(e, n)), n;
        },
        forEachValue: function forEachValue(e) {
          return I.forEach(e);
        },
        readValue: function readValue(e) {
          var n;
          return null !== (n = j[e]) && void 0 !== n ? n : l(v, e, t);
        },
        setBaseTarget: function setBaseTarget(e, t) {
          R[e] = t;
        },
        getBaseTarget: function getBaseTarget(e) {
          if (o) {
            var t = o(m, e);
            if (void 0 !== t && !_i(t)) return t;
          }

          return R[e];
        }
      }, T), {
        build: function build() {
          return B(), E;
        },
        scheduleRender: function scheduleRender() {
          Bn.render(F, !1, !0);
        },
        syncRender: F,
        setProps: function setProps(e) {
          m = e, T.updatePropListeners(e), O = function (e, t, n) {
            var r;

            for (var o in t) {
              var i = t[o],
                  a = n[o];
              if (_i(i)) e.addValue(o, i);else if (_i(a)) e.addValue(o, Vo(i));else if (a !== i) if (e.hasValue(o)) {
                var s = e.getValue(o);
                !s.hasAnimated && s.set(i);
              } else e.addValue(o, Vo(null !== (r = e.getStaticValue(o)) && void 0 !== r ? r : i));
            }

            for (var o in n) {
              void 0 === t[o] && e.removeValue(o);
            }

            return t;
          }($, p(m), O);
        },
        getProps: function getProps() {
          return m;
        },
        getVariant: function getVariant(e) {
          var t;
          return null === (t = m.variants) || void 0 === t ? void 0 : t[e];
        },
        getDefaultTransition: function getDefaultTransition() {
          return m.transition;
        },
        getVariantContext: function getVariantContext(e) {
          if (void 0 === e && (e = !1), e) return null == h ? void 0 : h.getVariantContext();

          if (!Z) {
            var t = (null == h ? void 0 : h.getVariantContext()) || {};
            return void 0 !== m.initial && (t.initial = m.initial), t;
          }

          for (var n = {}, r = 0; r < ta; r++) {
            var o = ea[r],
                i = m[o];
            (qe(i) || !1 === i) && (n[o] = i);
          }

          return n;
        },
        enableLayoutProjection: function enableLayoutProjection() {
          S.isEnabled = !0;
        },
        lockProjectionTarget: function lockProjectionTarget() {
          S.isTargetLocked = !0;
        },
        unlockProjectionTarget: function unlockProjectionTarget() {
          $.stopLayoutAnimation(), S.isTargetLocked = !1;
        },
        snapshotViewportBox: function snapshotViewportBox() {
          $.prevViewportBox = $.measureViewportBox(!1), $.rebaseProjectionTarget(!1, $.prevViewportBox);
        },
        getLayoutState: function getLayoutState() {
          return A;
        },
        setCrossfader: function setCrossfader(e) {
          w = e;
        },
        startLayoutAnimation: function startLayoutAnimation(e, t) {
          var n = $.getProjectionAnimationProgress()[e],
              r = S.target[e],
              o = r.min,
              i = r.max - o;
          return n.clearListeners(), n.set(o), n.set(o), n.onChange(function (t) {
            return $.setProjectionTargetAxis(e, t, t + i);
          }), $.animateMotionValue(e, n, 0, t);
        },
        stopLayoutAnimation: function stopLayoutAnimation() {
          Pr(function (e) {
            return $.getProjectionAnimationProgress()[e].stop();
          });
        },
        measureViewportBox: function measureViewportBox(e) {
          void 0 === e && (e = !0);
          var n,
              r,
              o = a(v, t);
          return e || (r = j, Yi((n = o).x, r, Wi), Yi(n.y, r, $i)), o;
        },
        updateLayoutMeasurement: function updateLayoutMeasurement() {
          var e;
          $.notifyBeforeLayoutMeasure(A.layout), A.isHydrated = !0, A.layout = $.measureViewportBox(), A.layoutCorrected = (e = A.layout, {
            x: _ye({}, e.x),
            y: _ye({}, e.y)
          }), $.notifyLayoutMeasure(A.layout, $.prevViewportBox || A.layout), Bn.update(function () {
            return $.rebaseProjectionTarget();
          });
        },
        getProjectionAnimationProgress: function getProjectionAnimationProgress() {
          return k || (k = {
            x: Vo(0),
            y: Vo(0)
          }), k;
        },
        setProjectionTargetAxis: function setProjectionTargetAxis(e, t, n) {
          var r = S.target[e];
          r.min = t, r.max = n, N = !0, T.notifySetAxisTarget();
        },
        rebaseProjectionTarget: function rebaseProjectionTarget(e, t) {
          void 0 === t && (t = A.layout);
          var n = $.getProjectionAnimationProgress(),
              r = n.x,
              o = n.y,
              i = !S.isTargetLocked && !r.isAnimating() && !o.isAnimating();
          (e || i) && Pr(function (e) {
            var n = t[e],
                r = n.min,
                o = n.max;
            $.setProjectionTargetAxis(e, r, o);
          });
        },
        notifyLayoutReady: function notifyLayoutReady(e) {
          $.notifyLayoutUpdate(A.layout, $.prevViewportBox || A.layout, e);
        },
        resetTransform: function resetTransform() {
          return c($, v, m);
        },
        withoutTransform: function withoutTransform(e) {
          var t = S.isEnabled;
          t && $.resetTransform(), h ? h.withoutTransform(e) : e(), t && u(v, E);
        },
        updateLayoutProjection: function updateLayoutProjection() {
          P() && function () {
            var e = A.delta,
                t = A.treeScale,
                n = t.x,
                r = t.x,
                o = A.deltaTransform;
            Xi(A, L, $.path, j), N && $.notifyViewportBoxUpdate(L.target, e), N = !1;
            var i = Pi(e, t);
            i === o && n === t.x && r === t.y || $.scheduleRender(), A.deltaTransform = i;
          }(), _.forEach(Ji);
        },
        pointTo: function pointTo(e) {
          L = e.projection, D = e.getLatestValues(), null == x || x(), x = tn(e.onSetAxisTarget($.scheduleUpdateLayoutProjection), e.onLayoutAnimationComplete(function () {
            var e;
            $.isPresent ? $.presence = je.Present : null === (e = $.layoutSafeToRemove) || void 0 === e || e.call($);
          }));
        },
        isPresent: !0,
        presence: je.Entering
      });

      return $;
    };
  };

  function Ji(e) {
    e.updateLayoutProjection();
  }

  var ea = xe(["initial"], ni),
      ta = ea.length;

  function na(e) {
    var t = e instanceof Uo ? e.get() : e;
    return function (e) {
      return Boolean(e && "object" == _typeof(e) && e.mix && e.toValue);
    }(t) ? t.toValue() : t;
  }

  var ra = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }

    return ge(t, e), t.prototype.componentDidMount = function () {
      var e = this.props,
          t = e.syncLayout,
          n = e.framerSyncLayout,
          r = e.visualElement;
      ze(t) && t.register(r), ze(n) && n.register(r);
    }, t.prototype.getSnapshotBeforeUpdate = function () {
      var e = this.props,
          t = e.syncLayout,
          n = e.visualElement;
      return ze(t) ? t.syncUpdate() : (n.snapshotViewportBox(), t.add(n)), null;
    }, t.prototype.componentDidUpdate = function () {
      var e = this.props,
          t = e.syncLayout,
          n = e.visualElement;
      ze(t) || t.flush(), n.rebaseProjectionTarget();
    }, t.prototype.render = function () {
      return null;
    }, t;
  }(S["default"].Component);

  function oa(e) {
    var t = o.useContext(Ne),
        n = o.useContext(Ie);
    return S["default"].createElement(ra, _ye({}, e, {
      syncLayout: t,
      framerSyncLayout: n
    }));
  }

  var ia = {
    key: "measure-layout",
    shouldRender: function shouldRender(e) {
      return !!e.drag || !!e.layout || void 0 !== e.layoutId;
    },
    getComponent: function getComponent() {
      return oa;
    }
  },
      aa = ["animate", "circle", "defs", "desc", "ellipse", "g", "image", "line", "filter", "marker", "mask", "metadata", "path", "pattern", "polygon", "polyline", "rect", "stop", "svg", "switch", "symbol", "text", "tspan", "use", "view"];

  function sa(e) {
    return "string" == typeof e && !e.includes("-") && (aa.indexOf(e) > -1 || !!/[A-Z]/.test(e) || void 0);
  }

  function la(e, t) {
    var n = t.layout,
        r = t.layoutId;
    return Ii(e) || Oi(e) || (n || void 0 !== r) && !!Mi[e];
  }

  function ca(e) {
    return e.startsWith("--");
  }

  function ua(e, t, n, r, o, i) {
    var a,
        s = e.style,
        l = e.vars,
        c = e.transform,
        u = e.transformKeys,
        d = e.transformOrigin;
    u.length = 0;
    var f = !1,
        p = !1,
        h = !0;

    for (var m in t) {
      var g = t[m];
      if (ca(m)) l[m] = g;else {
        var y = ho(m),
            b = mo(g, y);

        if (Ii(m)) {
          if (f = !0, c[m] = b, u.push(m), !h) continue;
          g !== (null !== (a = y["default"]) && void 0 !== a ? a : 0) && (h = !1);
        } else if (Oi(m)) d[m] = b, p = !0;else if (r && n && r.isHydrated && Mi[m]) {
          var v = Mi[m].process(g, r, n),
              x = Mi[m].applyTo;
          if (x) for (var w = x.length, k = 0; k < w; k++) {
            s[x[k]] = v;
          } else s[m] = v;
        } else s[m] = b;
      }
    }

    r && n && n.isEnabled && r.isHydrated ? (s.transform = Pi(r.deltaFinal, r.treeScale, f ? c : void 0), i && (s.transform = i(c, s.transform)), s.transformOrigin = function (e) {
      var t = e.deltaFinal;
      return 100 * t.x.origin + "% " + 100 * t.y.origin + "% 0";
    }(r)) : (f && (s.transform = function (e, t, n, r) {
      var o = e.transform,
          i = e.transformKeys,
          a = t.enableHardwareAcceleration,
          s = void 0 === a || a,
          l = t.allowTransformNone,
          c = void 0 === l || l,
          u = "";
      i.sort(Ai);

      for (var d = !1, f = i.length, p = 0; p < f; p++) {
        var h = i[p];
        u += (Ri[h] || h) + "(" + o[h] + ") ", "z" === h && (d = !0);
      }

      return !d && s ? u += "translateZ(0)" : u = u.trim(), r ? u = r(o, n ? "" : u) : c && n && (u = "none"), u;
    }(e, o, h, i)), p && (s.transformOrigin = function (e) {
      var t = e.originX,
          n = void 0 === t ? "50%" : t,
          r = e.originY,
          o = void 0 === r ? "50%" : r,
          i = e.originZ;
      return n + " " + o + " " + (void 0 === i ? 0 : i);
    }(d)));
  }

  var da = function da() {
    return {
      style: {},
      transform: {},
      transformKeys: [],
      transformOrigin: {},
      vars: {}
    };
  };

  function fa(e, t, n) {
    for (var r in t) {
      _i(t[r]) || la(r, n) || (e[r] = t[r]);
    }
  }

  function pa(e, t, n) {
    var r = {};
    return fa(r, e.style || {}, e), Object.assign(r, function (e, t, n) {
      var r = e.transformTemplate;
      return o.useMemo(function () {
        var e = {
          style: {},
          transform: {},
          transformKeys: [],
          transformOrigin: {},
          vars: {}
        };
        ua(e, t, void 0, void 0, {
          enableHardwareAcceleration: !n
        }, r);
        var o = e.style;
        return _ye(_ye({}, e.vars), o);
      }, [t]);
    }(e, t, n)), e.transformValues && (r = e.transformValues(r)), r;
  }

  function ha(e, t, n) {
    var r = {},
        o = pa(e, t, n);
    return Boolean(e.drag) && (r.draggable = !1, o.userSelect = o.WebkitUserSelect = o.WebkitTouchCallout = "none", o.touchAction = !0 === e.drag ? "none" : "pan-" + ("x" === e.drag ? "y" : "x")), r.style = o, r;
  }

  var ma = function ma(e) {
    return !Ei(e);
  };

  try {
    var ga = require("@emotion/is-prop-valid")["default"];

    ma = function ma(e) {
      return e.startsWith("on") ? !Ei(e) : ga(e);
    };
  } catch (e) {}

  function ya(e, t, n) {
    return "string" == typeof e ? e : jt.transform(t + n * e);
  }

  var ba = function ba(e, t) {
    return jt.transform(e * t);
  },
      va = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
  },
      xa = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
  };

  function wa(e, t, n, r, o, i) {
    var a = t.attrX,
        s = t.attrY,
        l = t.originX,
        c = t.originY,
        u = t.pathLength,
        d = t.pathSpacing,
        f = void 0 === d ? 1 : d,
        p = t.pathOffset,
        h = void 0 === p ? 0 : p;
    ua(e, be(t, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]), n, r, o, i), e.attrs = e.style, e.style = {};
    var m = e.attrs,
        g = e.style,
        y = e.dimensions,
        b = e.totalPathLength;
    m.transform && (y && (g.transform = m.transform), delete m.transform), y && (void 0 !== l || void 0 !== c || g.transform) && (g.transformOrigin = function (e, t, n) {
      return ya(t, e.x, e.width) + " " + ya(n, e.y, e.height);
    }(y, void 0 !== l ? l : .5, void 0 !== c ? c : .5)), void 0 !== a && (m.x = a), void 0 !== s && (m.y = s), void 0 !== b && void 0 !== u && function (e, t, n, r, o, i) {
      void 0 === r && (r = 1), void 0 === o && (o = 0), void 0 === i && (i = !0);
      var a = i ? va : xa;
      e[a.offset] = ba(-o, t);
      var s = ba(n, t),
          l = ba(r, t);
      e[a.array] = s + " " + l;
    }(m, b, u, f, h, !1);
  }

  var ka = function ka() {
    return _ye(_ye({}, {
      style: {},
      transform: {},
      transformKeys: [],
      transformOrigin: {},
      vars: {}
    }), {
      attrs: {}
    });
  };

  function Ca(e, t) {
    var n = o.useMemo(function () {
      var n = ka();
      return wa(n, t, void 0, void 0, {
        enableHardwareAcceleration: !1
      }, e.transformTemplate), _ye(_ye({}, n.attrs), {
        style: _ye({}, n.style)
      });
    }, [t]);

    if (e.style) {
      var r = {};
      fa(r, e.style, e), n.style = _ye(_ye({}, r), n.style);
    }

    return n;
  }

  function Ma(e, t) {
    void 0 === t && (t = !1);
    return function (n, r, i, a) {
      var s = i.latestValues,
          l = (sa(e) ? Ca : ha)(n, s, a),
          c = function (e, t, n) {
        var r = {};

        for (var o in e) {
          (ma(o) || !0 === n && Ei(o) || !t && !Ei(o)) && (r[o] = e[o]);
        }

        return r;
      }(n, "string" == typeof e, t),
          u = _ye(_ye(_ye({}, c), l), {
        ref: r
      });

      return o.createElement(e, u);
    };
  }

  function ja(e) {
    var t = e.style,
        n = {};

    for (var r in t) {
      (_i(t[r]) || la(r, e)) && (n[r] = t[r]);
    }

    return n;
  }

  function Ea(e) {
    var t = ja(e);

    for (var n in e) {
      if (_i(e[n])) t["x" === n || "y" === n ? "attr" + n.toUpperCase() : n] = e[n];
    }

    return t;
  }

  var _a,
      Ta = new Set(["width", "height", "top", "left", "right", "bottom", "x", "y"]),
      Sa = function Sa(e) {
    return Ta.has(e);
  },
      La = function La(e, t) {
    e.set(t, !1), e.set(t);
  },
      Da = function Da(e) {
    return e === vt || e === jt;
  };

  !function (e) {
    e.width = "width", e.height = "height", e.left = "left", e.right = "right", e.top = "top", e.bottom = "bottom";
  }(_a || (_a = {}));

  var Aa = function Aa(e, t) {
    return parseFloat(e.split(", ")[t]);
  },
      Na = function Na(e, t) {
    return function (n, r) {
      var o = r.transform;
      if ("none" === o || !o) return 0;
      var i = o.match(/^matrix3d\((.+)\)$/);
      if (i) return Aa(i[1], t);
      var a = o.match(/^matrix\((.+)\)$/);
      return a ? Aa(a[1], e) : 0;
    };
  },
      Ia = new Set(["x", "y", "z"]),
      za = Di.filter(function (e) {
    return !Ia.has(e);
  });

  var Oa = {
    width: function width(e) {
      var t = e.x;
      return t.max - t.min;
    },
    height: function height(e) {
      var t = e.y;
      return t.max - t.min;
    },
    top: function top(e, t) {
      var n = t.top;
      return parseFloat(n);
    },
    left: function left(e, t) {
      var n = t.left;
      return parseFloat(n);
    },
    bottom: function bottom(e, t) {
      var n = e.y,
          r = t.top;
      return parseFloat(r) + (n.max - n.min);
    },
    right: function right(e, t) {
      var n = e.x,
          r = t.left;
      return parseFloat(r) + (n.max - n.min);
    },
    x: Na(4, 13),
    y: Na(5, 14)
  },
      Ra = function Ra(e, t, n, r) {
    void 0 === n && (n = {}), void 0 === r && (r = {}), t = _ye({}, t), r = _ye({}, r);
    var o = Object.keys(t).filter(Sa),
        i = [],
        a = !1,
        s = [];

    if (o.forEach(function (o) {
      var l = e.getValue(o);

      if (e.hasValue(o)) {
        var c,
            u = n[o],
            d = t[o],
            f = uo(u);
        if (eo(d)) for (var p = d.length, h = null === d[0] ? 1 : 0; h < p; h++) {
          c ? Ke(uo(d[h]) === c, "All keyframes must be of the same type") : (c = uo(d[h]), Ke(c === f || Da(f) && Da(c), "Keyframes must be of the same dimension as the current value"));
        } else c = uo(d);
        if (f !== c) if (Da(f) && Da(c)) {
          var m = l.get();
          "string" == typeof m && l.set(parseFloat(m)), "string" == typeof d ? t[o] = parseFloat(d) : Array.isArray(d) && c === jt && (t[o] = d.map(parseFloat));
        } else (null == f ? void 0 : f.transform) && (null == c ? void 0 : c.transform) && (0 === u || 0 === d) ? 0 === u ? l.set(c.transform(u)) : t[o] = f.transform(d) : (a || (i = function (e) {
          var t = [];
          return za.forEach(function (n) {
            var r = e.getValue(n);
            void 0 !== r && (t.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
          }), t.length && e.syncRender(), t;
        }(e), a = !0), s.push(o), r[o] = void 0 !== r[o] ? r[o] : t[o], La(l, d));
      }
    }), s.length) {
      var l = function (e, t, n) {
        var r = t.measureViewportBox(),
            o = t.getInstance(),
            i = getComputedStyle(o),
            a = i.display,
            s = {
          top: i.top,
          left: i.left,
          bottom: i.bottom,
          right: i.right,
          transform: i.transform
        };
        "none" === a && t.setStaticValue("display", e.display || "block"), t.syncRender();
        var l = t.measureViewportBox();
        return n.forEach(function (n) {
          var o = t.getValue(n);
          La(o, Oa[n](r, s)), e[n] = Oa[n](l, i);
        }), e;
      }(t, e, s);

      return i.length && i.forEach(function (t) {
        var n = ve(t, 2),
            r = n[0],
            o = n[1];
        e.getValue(r).set(o);
      }), e.syncRender(), {
        target: l,
        transitionEnd: r
      };
    }

    return {
      target: t,
      transitionEnd: r
    };
  };

  function Pa(e, t, n, r) {
    return function (e) {
      return Object.keys(e).some(Sa);
    }(t) ? Ra(e, t, n, r) : {
      target: t,
      transitionEnd: r
    };
  }

  var Fa = function Fa(e, t, n, r) {
    var o = function (e, t, n) {
      var r,
          o = be(t, []),
          i = e.getInstance();
      if (!(i instanceof HTMLElement)) return {
        target: o,
        transitionEnd: n
      };

      for (var a in n && (n = _ye({}, n)), e.forEachValue(function (e) {
        var t = e.get();

        if (bi(t)) {
          var n = xi(t, i);
          n && e.set(n);
        }
      }), o) {
        var s = o[a];

        if (bi(s)) {
          var l = xi(s, i);
          l && (o[a] = l, n && (null !== (r = n[a]) && void 0 !== r || (n[a] = s)));
        }
      }

      return {
        target: o,
        transitionEnd: n
      };
    }(e, t, r);

    return Pa(e, t = o.target, n, r = o.transitionEnd);
  };

  var Ba = {
    treeType: "dom",
    readValueFromInstance: function readValueFromInstance(e, t) {
      if (Ii(t)) {
        var n = ho(t);
        return n && n["default"] || 0;
      }

      var r,
          o = (r = e, window.getComputedStyle(r));
      return (ca(t) ? o.getPropertyValue(t) : o[t]) || 0;
    },
    sortNodePosition: function sortNodePosition(e, t) {
      return 2 & e.compareDocumentPosition(t) ? 1 : -1;
    },
    getBaseTarget: function getBaseTarget(e, t) {
      var n;
      return null === (n = e.style) || void 0 === n ? void 0 : n[t];
    },
    measureViewportBox: function measureViewportBox(e, t) {
      return Qr(e, t.transformPagePoint);
    },
    resetTransform: function resetTransform(e, t, n) {
      e.suspendHoverEvents();
      var r = n.transformTemplate;
      t.style.transform = r ? r({}, "") : "none", e.scheduleRender();
    },
    restoreTransform: function restoreTransform(e, t) {
      e.style.transform = t.style.transform;
    },
    removeValueFromRenderState: function removeValueFromRenderState(e, t) {
      var n = t.vars,
          r = t.style;
      delete n[e], delete r[e];
    },
    makeTargetAnimatable: function makeTargetAnimatable(e, t, n, r) {
      var o = n.transformValues;
      void 0 === r && (r = !0);
      var i = t.transition,
          a = t.transitionEnd,
          s = be(t, ["transition", "transitionEnd"]),
          l = Yo(s, i || {}, e);

      if (o && (a && (a = o(a)), s && (s = o(s)), l && (l = o(l))), r) {
        $o(e, s, l);
        var c = Fa(e, s, l, a);
        a = c.transitionEnd, s = c.target;
      }

      return _ye({
        transition: i,
        transitionEnd: a
      }, s);
    },
    scrapeMotionValuesFromProps: ja,
    build: function build(e, t, n, r, o, i, a) {
      void 0 !== e.isVisible && (t.style.visibility = e.isVisible ? "visible" : "hidden"), ua(t, n, r, o, i, a.transformTemplate);
    },
    render: function render(e, t) {
      var n = t.style,
          r = t.vars;

      for (var o in Object.assign(e.style, n), r) {
        e.style.setProperty(o, r[o]);
      }
    }
  },
      qa = Ki(Ba),
      Ua = /([a-z])([A-Z])/g,
      Va = function Va(e) {
    return e.replace(Ua, "$1-$2").toLowerCase();
  },
      Ha = new Set(["baseFrequency", "diffuseConstant", "kernelMatrix", "kernelUnitLength", "keySplines", "keyTimes", "limitingConeAngle", "markerHeight", "markerWidth", "numOctaves", "targetX", "targetY", "surfaceScale", "specularConstant", "specularExponent", "stdDeviation", "tableValues", "viewBox"]);

  function Za(e, t) {
    for (var n in Ba.render(e, t), t.attrs) {
      e.setAttribute(Ha.has(n) ? n : Va(n), t.attrs[n]);
    }
  }

  var Wa = Ki(_ye(_ye({}, Ba), {
    getBaseTarget: function getBaseTarget(e, t) {
      return e[t];
    },
    readValueFromInstance: function readValueFromInstance(e, t) {
      var n;
      return Ii(t) ? (null === (n = ho(t)) || void 0 === n ? void 0 : n["default"]) || 0 : (t = Ha.has(t) ? t : Va(t), e.getAttribute(t));
    },
    scrapeMotionValuesFromProps: Ea,
    build: function build(e, t, n, r, o, i, a) {
      wa(t, n, r, o, i, a.transformTemplate);
    },
    render: Za
  }));

  function $a(e, t, n, r) {
    var o = e.scrapeMotionValuesFromProps,
        i = e.createRenderState,
        a = e.onMount,
        s = {
      latestValues: Ya(t, n, r, o),
      renderState: i()
    };
    return a && (s.mount = function (e) {
      return a(t, e, s);
    }), s;
  }

  var Ga = function Ga(e) {
    return function (t, n) {
      var r = o.useContext(Oe),
          i = o.useContext(ke);
      return n ? $a(e, t, r, i) : Ce(function () {
        return $a(e, t, r, i);
      });
    };
  };

  function Ya(e, t, n, r) {
    var o = {},
        i = !1 === (null == n ? void 0 : n.initial),
        a = r(e);

    for (var s in a) {
      o[s] = na(a[s]);
    }

    var l = e.initial,
        c = e.animate,
        u = He(e),
        d = Ze(e);
    t && d && !u && !1 !== e.inherit && (null != l || (l = t.initial), null != c || (c = t.animate));
    var f = i || !1 === l ? c : l;
    f && "boolean" != typeof f && !ei(f) && (Array.isArray(f) ? f : [f]).forEach(function (t) {
      var n = Ue(e, t);

      if (n) {
        var r = n.transitionEnd;
        n.transition;
        var i = be(n, ["transitionEnd", "transition"]);

        for (var a in i) {
          o[a] = i[a];
        }

        for (var a in r) {
          o[a] = r[a];
        }
      }
    });
    return o;
  }

  var Qa = {
    createVisualElement: function createVisualElement(e, t) {
      return Wa(t, {
        enableHardwareAcceleration: !1
      });
    },
    useVisualState: Ga({
      scrapeMotionValuesFromProps: Ea,
      createRenderState: ka,
      onMount: function onMount(e, t, n) {
        var r = n.renderState,
            o = n.latestValues;

        try {
          r.dimensions = "function" == typeof t.getBBox ? t.getBBox() : t.getBoundingClientRect();
        } catch (e) {
          r.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
          };
        }

        "path" === t.tagName && (r.totalPathLength = t.getTotalLength()), wa(r, o, void 0, void 0, {
          enableHardwareAcceleration: !1
        }, e.transformTemplate), Za(t, r);
      }
    })
  };
  var Xa = {
    createVisualElement: function createVisualElement(e, t) {
      return qa(t, {
        enableHardwareAcceleration: !e
      });
    },
    useVisualState: Ga({
      scrapeMotionValuesFromProps: ja,
      createRenderState: da
    })
  };

  function Ka(e) {
    function t(t, n) {
      var r = (void 0 === n ? {} : n).forwardMotionProps;
      return Ge(function (e, t, n) {
        var r = sa(t) ? Qa : Xa;
        return _ye(_ye({}, r), {
          defaultFeatures: e,
          useRender: Ma(t, n)
        });
      }(e, t, void 0 !== r && r));
    }

    function n(e) {
      return Xe(!1, "motion.custom() is deprecated. Use motion() instead."), t(e, {
        forwardMotionProps: !0
      });
    }

    var r = new Map();
    return new Proxy(t, {
      get: function get(e, o) {
        return "custom" === o ? n : (r.has(o) || r.set(o, t(o)), r.get(o));
      }
    });
  }

  var Ja = Ka([ia, ci, Lo, Po, Bo, yi]);
  Ka([ia]);
  var es = 0;

  function ts() {
    var e = es;
    return es++, e;
  }

  var ns = function ns(e) {
    var t = e.children,
        n = e.initial,
        r = e.isPresent,
        i = e.onExitComplete,
        a = e.custom,
        s = e.presenceAffectsLayout,
        l = Ce(rs),
        c = Ce(ts),
        u = o.useMemo(function () {
      return {
        id: c,
        initial: n,
        isPresent: r,
        custom: a,
        onExitComplete: function onExitComplete(e) {
          l.set(e, !0);
          var t = !0;
          l.forEach(function (e) {
            e || (t = !1);
          }), t && (null == i || i());
        },
        register: function register(e) {
          return l.set(e, !1), function () {
            return l["delete"](e);
          };
        }
      };
    }, s ? void 0 : [r]);
    return o.useMemo(function () {
      l.forEach(function (e, t) {
        return l.set(t, !1);
      });
    }, [r]), o.useEffect(function () {
      !r && !l.size && (null == i || i());
    }, [r]), o.createElement(ke.Provider, {
      value: u
    }, t);
  };

  function rs() {
    return new Map();
  }

  function os(e) {
    return e.key || "";
  }

  var is = function is(e) {
    var t = e.children,
        n = e.custom,
        r = e.initial,
        i = void 0 === r || r,
        a = e.onExitComplete,
        s = e.exitBeforeEnter,
        l = e.presenceAffectsLayout,
        c = void 0 === l || l,
        u = function () {
      var e = o.useRef(!1),
          t = ve(o.useState(0), 2),
          n = t[0],
          r = t[1];
      return Do(function () {
        return e.current = !0;
      }), o.useCallback(function () {
        !e.current && r(n + 1);
      }, [n]);
    }(),
        d = o.useContext(Ne);

    ze(d) && (u = d.forceUpdate);

    var f = o.useRef(!0),
        p = function (e) {
      var t = [];
      return o.Children.forEach(e, function (e) {
        o.isValidElement(e) && t.push(e);
      }), t;
    }(t),
        h = o.useRef(p),
        m = o.useRef(new Map()).current,
        g = o.useRef(new Set()).current;

    if (function (e, t) {
      var n = "production" !== process.env.NODE_ENV ? new Set() : null;
      e.forEach(function (e) {
        var r = os(e);
        "production" !== process.env.NODE_ENV && n && (n.has(r) && console.warn('Children of AnimatePresence require unique keys. "' + r + '" is a duplicate.'), n.add(r)), t.set(r, e);
      });
    }(p, m), f.current) return f.current = !1, o.createElement(o.Fragment, null, p.map(function (e) {
      return o.createElement(ns, {
        key: os(e),
        isPresent: !0,
        initial: !!i && void 0,
        presenceAffectsLayout: c
      }, e);
    }));

    for (var y = xe(p), b = h.current.map(os), v = p.map(os), x = b.length, w = 0; w < x; w++) {
      var k = b[w];
      -1 === v.indexOf(k) ? g.add(k) : g["delete"](k);
    }

    return s && g.size && (y = []), g.forEach(function (e) {
      if (-1 === v.indexOf(e)) {
        var t = m.get(e);

        if (t) {
          var r = b.indexOf(e);
          y.splice(r, 0, o.createElement(ns, {
            key: os(t),
            isPresent: !1,
            onExitComplete: function onExitComplete() {
              m["delete"](e), g["delete"](e);
              var t = h.current.findIndex(function (t) {
                return t.key === e;
              });
              h.current.splice(t, 1), g.size || (h.current = p, u(), a && a());
            },
            custom: n,
            presenceAffectsLayout: c
          }, t));
        }
      }
    }), y = y.map(function (e) {
      var t = e.key;
      return g.has(t) ? e : o.createElement(ns, {
        key: os(e),
        isPresent: !0,
        presenceAffectsLayout: c
      }, e);
    }), h.current = y, "production" !== process.env.NODE_ENV && s && y.length > 1 && console.warn("You're attempting to animate multiple children within AnimatePresence, but its exitBeforeEnter prop is set to true. This will lead to odd visual behaviour."), o.createElement(o.Fragment, null, g.size ? y : y.map(function (e) {
      return o.cloneElement(e);
    }));
  };

  function as() {
    var e = Vo(1),
        t = {
      lead: void 0,
      follow: void 0,
      crossfadeOpacity: !1,
      preserveFollowOpacity: !1
    },
        n = {},
        r = {},
        o = !1,
        i = null,
        a = 0;

    function s(n, r) {
      var a = t.lead,
          s = t.follow;
      return o = !0, i = null, function (e, t, n) {
        void 0 === n && (n = {});
        var r = _i(e) ? e : Vo(e);
        return Co("", r, t, n), {
          stop: function stop() {
            return r.stop();
          }
        };
      }(e, n, _ye(_ye({}, r), {
        onUpdate: function onUpdate() {
          a && a.scheduleRender(), s && s.scheduleRender();
        },
        onComplete: function onComplete() {
          o = !1, i = Zn().timestamp;
        }
      }));
    }

    function l() {
      var o,
          i,
          s = Zn().timestamp,
          l = t.lead,
          c = t.follow;

      if (s !== a && l) {
        a = s;
        var u = l.getLatestValues();
        Object.assign(n, u);
        var d = c ? c.getLatestValues() : t.prevValues;
        Object.assign(r, d);
        var f = e.get(),
            p = null !== (o = u.opacity) && void 0 !== o ? o : 1,
            h = null !== (i = null == d ? void 0 : d.opacity) && void 0 !== i ? i : 1;
        t.crossfadeOpacity && c ? (n.opacity = dt(0, p, ss(f)), r.opacity = t.preserveFollowOpacity ? h : dt(h, 0, ls(f))) : c || (n.opacity = dt(h, p, f)), function (e, t, n, r, o, i) {
          for (var a = 0; a < ds; a++) {
            var s = "border" + us[a] + "Radius",
                l = fs(r, s),
                c = fs(n, s);

            if ((void 0 !== l || void 0 !== c) && (l || (l = 0), c || (c = 0), "number" == typeof l && "number" == typeof c)) {
              var u = dt(l, c, i);
              e[s] = t[s] = u;
            }
          }

          if (r.rotate || n.rotate) {
            var d = dt(r.rotate || 0, n.rotate || 0, i);
            e.rotate = t.rotate = d;
          }

          !o && n.backgroundColor && r.backgroundColor && (e.backgroundColor = t.backgroundColor = Kt(r.backgroundColor, n.backgroundColor)(i));
        }(n, r, u, d || {}, Boolean(c), f);
      }
    }

    return {
      isActive: function isActive() {
        return n && (o || Zn().timestamp === i);
      },
      fromLead: function fromLead(e) {
        return s(0, e);
      },
      toLead: function toLead(n) {
        return e.set(t.follow ? 1 - e.get() : 0), s(1, n);
      },
      reset: function reset() {
        return e.set(1);
      },
      stop: function stop() {
        return e.stop();
      },
      getCrossfadeState: function getCrossfadeState(e) {
        return l(), e === t.lead ? n : e === t.follow ? r : void 0;
      },
      setOptions: function setOptions(e) {
        t = e, n = {}, r = {};
      },
      getLatestValues: function getLatestValues() {
        return n;
      }
    };
  }

  var ss = cs(0, .5, xn),
      ls = cs(.5, .95, mn);

  function cs(e, t, n) {
    return function (r) {
      return r < e ? 0 : r > t ? 1 : n(ut(e, t, r));
    };
  }

  var us = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"],
      ds = us.length;

  function fs(e, t) {
    var n;
    return null !== (n = e[t]) && void 0 !== n ? n : e.borderRadius;
  }

  function ps() {
    var e,
        t,
        n,
        r = new Set(),
        o = {
      leadIsExiting: !1
    },
        i = _ye({}, o),
        a = as(),
        s = !1;

    return {
      add: function add(e) {
        e.setCrossfader(a), r.add(e), n && (e.prevDragCursor = n), o.lead || (o.lead = e);
      },
      remove: function remove(e) {
        r["delete"](e);
      },
      getLead: function getLead() {
        return o.lead;
      },
      updateSnapshot: function updateSnapshot() {
        if (o.lead) {
          e = a.isActive() ? a.getLatestValues() : o.lead.getLatestValues(), t = o.lead.prevViewportBox;
          var r = jo.get(o.lead);
          r && r.isDragging && (n = r.cursorProgress);
        }
      },
      clearSnapshot: function clearSnapshot() {
        n = t = void 0;
      },
      updateLeadAndFollow: function updateLeadAndFollow() {
        var t, n, l;
        i = _ye({}, o);

        for (var c = Array.from(r), u = c.length; u--; u >= 0) {
          var d = c[u];
          if (n && (null != l || (l = d)), null != n || (n = d), n && l) break;
        }

        o.lead = n, o.follow = l, o.leadIsExiting = (null === (t = o.lead) || void 0 === t ? void 0 : t.presence) === je.Exiting, a.setOptions({
          lead: n,
          follow: l,
          prevValues: e,
          crossfadeOpacity: (null == l ? void 0 : l.isPresenceRoot) || (null == n ? void 0 : n.isPresenceRoot)
        }), i.lead === o.lead && i.leadIsExiting === o.leadIsExiting || (s = !0);
      },
      animate: function animate(e, n) {
        if (void 0 === n && (n = !1), e === o.lead) {
          n ? e.pointTo(o.lead) : e.setVisibility(!0);
          var r = {};

          if (e.presence === je.Entering ? r.originBox = o.follow ? o.follow.prevViewportBox : t : e.presence === je.Exiting && (r.targetBox = null === (l = o.follow) || void 0 === l ? void 0 : l.getLayoutState().layout), s) {
            s = !1;
            var i = e.getDefaultTransition();
            e.presence === je.Entering ? a.toLead(i) : a.fromLead(i);
          }

          e.notifyLayoutReady(r);
        } else n ? o.lead && e.pointTo(o.lead) : e.setVisibility(!1);

        var l;
      }
    };
  }

  !function (e) {
    function t() {
      var t = null !== e && e.apply(this, arguments) || this;
      return t.children = new Set(), t.stacks = new Map(), t.hasMounted = !1, t.updateScheduled = !1, t.renderScheduled = !1, t.syncContext = _ye(_ye({}, Ae()), {
        syncUpdate: function syncUpdate(e) {
          return t.scheduleUpdate(e);
        },
        forceUpdate: function forceUpdate() {
          t.syncContext = _ye({}, t.syncContext), t.scheduleUpdate(!0);
        },
        register: function register(e) {
          return t.addChild(e);
        },
        remove: function remove(e) {
          return t.removeChild(e);
        }
      }), t;
    }

    ge(t, e), t.prototype.componentDidMount = function () {
      this.hasMounted = !0;
    }, t.prototype.componentDidUpdate = function () {
      this.startLayoutAnimation();
    }, t.prototype.shouldComponentUpdate = function () {
      return this.renderScheduled = !0, !0;
    }, t.prototype.startLayoutAnimation = function () {
      var e = this;
      this.renderScheduled = this.updateScheduled = !1;
      var t = this.props.type;
      this.children.forEach(function (e) {
        e.isPresent ? e.presence !== je.Entering && (e.presence = e.presence === je.Exiting ? je.Entering : je.Present) : e.presence = je.Exiting;
      }), this.updateStacks();
      var n = {
        measureLayout: function measureLayout(e) {
          return e.updateLayoutMeasurement();
        },
        layoutReady: function layoutReady(n) {
          void 0 !== n.getLayoutId() ? e.getStack(n).animate(n, "crossfade" === t) : n.notifyLayoutReady();
        },
        parent: this.context.visualElement
      };
      this.children.forEach(function (t) {
        return e.syncContext.add(t);
      }), this.syncContext.flush(n), this.stacks.forEach(function (e) {
        return e.clearSnapshot();
      });
    }, t.prototype.updateStacks = function () {
      this.stacks.forEach(function (e) {
        return e.updateLeadAndFollow();
      });
    }, t.prototype.scheduleUpdate = function (e) {
      void 0 === e && (e = !1), !e && this.updateScheduled || (this.updateScheduled = !0, this.children.forEach(function (e) {
        return function (e) {
          for (var t = !1, n = {}, r = 0; r < Li.length; r++) {
            var o = "rotate" + Li[r];
            e.hasValue(o) && 0 !== e.getStaticValue(o) && (t = !0, n[o] = e.getStaticValue(o), e.setStaticValue(o, 0));
          }

          if (t) {
            for (var o in e.syncRender(), n) {
              e.setStaticValue(o, n[o]);
            }

            e.scheduleRender();
          }
        }(e);
      }), this.children.forEach(function (e) {
        return e.snapshotViewportBox();
      }), this.stacks.forEach(function (e) {
        return e.updateSnapshot();
      }), !e && this.renderScheduled || (this.renderScheduled = !0, this.forceUpdate()));
    }, t.prototype.addChild = function (e) {
      this.children.add(e), this.addToStack(e), e.presence = this.hasMounted ? je.Entering : je.Present;
    }, t.prototype.removeChild = function (e) {
      this.scheduleUpdate(), this.children["delete"](e), this.removeFromStack(e);
    }, t.prototype.addToStack = function (e) {
      var t = this.getStack(e);
      null == t || t.add(e);
    }, t.prototype.removeFromStack = function (e) {
      var t = this.getStack(e);
      null == t || t.remove(e);
    }, t.prototype.getStack = function (e) {
      var t = e.getLayoutId();
      if (void 0 !== t) return !this.stacks.has(t) && this.stacks.set(t, ps()), this.stacks.get(t);
    }, t.prototype.render = function () {
      return o.createElement(Ne.Provider, {
        value: this.syncContext
      }, this.props.children);
    }, t.contextType = Oe;
  }(o.Component);
  Ki({
    build: function build() {},
    measureViewportBox: zr,
    resetTransform: function resetTransform() {},
    restoreTransform: function restoreTransform() {},
    removeValueFromRenderState: function removeValueFromRenderState() {},
    render: function render() {},
    scrapeMotionValuesFromProps: function scrapeMotionValuesFromProps() {
      return {};
    },
    readValueFromInstance: function readValueFromInstance(e, t, n) {
      return n.initialState[t] || 0;
    },
    makeTargetAnimatable: function makeTargetAnimatable(e, t) {
      var n = t.transition,
          r = t.transitionEnd,
          o = be(t, ["transition", "transitionEnd"]);
      return $o(e, o, Yo(o, n || {}, e)), _ye({
        transition: n,
        transitionEnd: r
      }, o);
    }
  });
  var hs = Ja(fe);
  hs.displayName = "MotionBox";

  var ms = _["default"].svg.withConfig({
    shouldForwardProp: se,
    displayName: "Svg",
    componentId: "sc-1ybfxfa-0"
  })(n.compose(n.color, n.layout, n.opacity, n.position, n.space));

  ms.displayName = "Svg", ms.propTypes = {
    as: T["default"].oneOf(["svg"])
  };

  var gs = n.compose(n.color, le, n.flexbox, ue, n.layout, n.position, n.space, n.typography, n.border),
      ys = _["default"].p.withConfig({
    shouldForwardProp: se
  }).withConfig({
    displayName: "Text",
    componentId: "sc-9bppn5-0"
  })(["", ";", ";", ";"], gs, function (e) {
    return e.measure && "max-width: 60ch;";
  }, function (e) {
    return e.trunclipse && "\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n";
  });

  ys.displayName = "Text", ys.defaultProps = {
    as: "p",
    measure: !1,
    trunclipse: !1
  }, ys.propTypes = {
    as: T["default"].oneOf(["a", "address", "dd", "dl", "dt", "label", "li", "p", "ol", "span", "ul"]),
    measure: T["default"].bool,
    trunclipse: T["default"].bool
  };

  var bs = _["default"]("video").withConfig({
    displayName: "Video",
    componentId: "sc-fgc14q-0"
  })(n.compose(n.border, n.flexbox, n.layout, n.opacity, n.overflow, n.position, n.space));

  bs.displayName = "Video", bs.propTypes = {
    alt: T["default"].string.isRequired,
    src: T["default"].string.isRequired
  };

  var vs = .5,
      xs = t.css(["appearance:none;border:none;border-radius:", ";display:inline-block;cursor:", ";opacity:", ";font-weight:600;line-height:1.4;text-decoration:none;transition:0.3s ease-out;", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], function (e) {
    return e.theme.radii.rounded;
  }, function (e) {
    return e.disabled ? "not-allowed" : "pointer";
  }, function (e) {
    return e.disabled ? vs : 1;
  }, n.border, n.bottom, n.color, n.layout, n.left, n.position, n.right, n.shadow, n.space, n.top, n.typography, n.verticalAlign, n.zIndex),
      ws = t.css(["background:", ";color:white;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;&:hover,&:focus{background:", ";color:white;}&:focus-visible{box-shadow:0 0 0 2px ", ";z-index:1;}&:focus{outline:none;}"], function (e) {
    return e.theme.colors.blue500;
  }, function (e) {
    return e.theme.colors.blue700;
  }, function (e) {
    return e.theme.colors.blue700;
  }),
      ks = t.css(["background:transparent;box-shadow:inset 0 0 0 2px ", ";color:", ";&:hover,&:focus{box-shadow:inset 0 0 0 3px ", ";color:", ";}&:focus-visible{box-shadow:0 0 0 2px ", ";z-index:1;}&:focus{outline:none;}"], function (e) {
    return e.theme.colors.black;
  }, function (e) {
    return e.theme.colors.black;
  }, function (e) {
    return e.theme.colors.black;
  }, function (e) {
    return e.theme.colors.black;
  }, function (e) {
    return e.theme.colors.blue700;
  }),
      Cs = t.css(["background:", ";box-shadow:inset 0 0 0 1px ", ";color:", ";&:hover,&:focus{background:", ";box-shadow:inset 0 0 0 3px ", ";color:", ";}&:focus-visible{box-shadow:0 0 0 2px ", ";z-index:1;}&:focus{outline:none;}"], function (e) {
    return e.theme.colors.white;
  }, function (e) {
    return e.theme.colors.gray600;
  }, function (e) {
    return e.theme.colors.black;
  }, function (e) {
    return e.theme.colors.white;
  }, function (e) {
    return e.theme.colors.gray600;
  }, function (e) {
    return e.theme.colors.black;
  }, function (e) {
    return e.theme.colors.blue700;
  }),
      Ms = _["default"].button.withConfig({
    shouldForwardProp: se
  }).attrs(function (e) {
    return function (e) {
      return e.small ? {
        fontSize: 0,
        px: 3,
        py: 2
      } : e.adaptive ? {
        fontSize: [0, null, 1],
        px: [3, null, 4],
        py: [2, null, 3]
      } : {
        fontSize: 1,
        px: 4,
        py: 3
      };
    }(e);
  }).withConfig({
    displayName: "buttons__BaseButton",
    componentId: "sc-yk6f6r-0"
  })(["", ""], xs),
      js = _["default"](Ms).withConfig({
    displayName: "buttons__Button",
    componentId: "sc-yk6f6r-1"
  })(["", ";"], function (e) {
    return e.secondary ? ks : e.light ? Cs : ws;
  });

  function Es(e) {
    var t = e.secondary,
        n = e.reverse,
        r = e.theme;
    return t ? "transparent" : n ? "white" : "".concat(r.colors.black);
  }

  function _s(e) {
    var t = e.secondary,
        n = e.reverse,
        r = e.theme;
    return t ? n ? "white" : "".concat(r.colors.black) : n ? "".concat(r.colors.black) : "white";
  }

  js.displayName = "Button", js.defaultProps = {
    adaptive: !1,
    light: !1,
    secondary: !1,
    small: !1
  }, js.propTypes = {
    adaptive: T["default"].bool,
    light: T["default"].bool,
    secondary: T["default"].bool,
    small: T["default"].bool
  };

  var Ts = _["default"](js).withConfig({
    displayName: "MonoButton",
    componentId: "sc-1y7uphi-0"
  })(["background-color:", ";color:", ";&:hover,&:focus{background-color:", ";color:", ";opacity:0.8;}", ""], function (e) {
    return Es(e);
  }, function (e) {
    return _s(e);
  }, function (e) {
    return Es(e);
  }, function (e) {
    return _s(e);
  }, function (e) {
    return e.secondary && function (e) {
      var n = e.reverse,
          r = e.theme;
      var o = n ? "white" : r.colors.black;
      return t.css(["box-shadow:inset 0 0 0 2px ", ";&:hover,&:focus{box-shadow:inset 0 0 0 2px ", ";}"], o, o);
    }(e);
  }),
      Ss = _["default"].button.withConfig({
    displayName: "TransparentButton",
    componentId: "sc-1du7572-0"
  })(["appearance:none;background:none;border:none;color:", ";cursor:", ";opacity:", ";line-height:", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";&:hover{", ";}&:focus-visible{outline:2px auto ", ";outline:2px auto Highlight;outline:2px auto -webkit-focus-ring-color;outline-offset:2px;}"], function (e) {
    return e.theme.colors[e.color || "black"];
  }, function (e) {
    return e.disabled ? "not-allowed" : "pointer";
  }, function (e) {
    return e.disabled ? vs : 1;
  }, function (e) {
    return e.theme.lineHeights.body;
  }, n.border, n.bottom, n.boxShadow, n.layout, n.left, n.position, n.right, n.space, n.top, n.typography, n.verticalAlign, n.zIndex, n.color, n.border, n.flexbox, function (e) {
    return e.hoverColor && "color: ".concat(e.theme.colors[e.hoverColor]);
  }, function (e) {
    return e.theme.colors.blue500;
  });
  /*!
     * Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com
     * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
     */


  function Ls(e) {
    return Ls = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
      return _typeof(e);
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
    }, Ls(e);
  }

  function Ds(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function As(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  function Ns(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {},
          r = Object.keys(n);
      "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
        return Object.getOwnPropertyDescriptor(n, e).enumerable;
      }))), r.forEach(function (t) {
        As(e, t, n[t]);
      });
    }

    return e;
  }

  function Is(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      var n = [],
          r = !0,
          o = !1,
          i = void 0;

      try {
        for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
          ;
        }
      } catch (e) {
        o = !0, i = e;
      } finally {
        try {
          r || null == s["return"] || s["return"]();
        } finally {
          if (o) throw i;
        }
      }

      return n;
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }();
  }

  Ss.displayName = "TransparentButton";

  var zs = function zs() {},
      Os = {},
      Rs = {},
      Ps = {
    mark: zs,
    measure: zs
  };

  try {
    "undefined" != typeof window && (Os = window), "undefined" != typeof document && (Rs = document), "undefined" != typeof MutationObserver && MutationObserver, "undefined" != typeof performance && (Ps = performance);
  } catch (xv) {}

  var Fs = (Os.navigator || {}).userAgent,
      Bs = void 0 === Fs ? "" : Fs,
      qs = Os,
      Us = Rs,
      Vs = Ps;
  qs.document;
  var Hs = !!Us.documentElement && !!Us.head && "function" == typeof Us.addEventListener && "function" == typeof Us.createElement;
  ~Bs.indexOf("MSIE") || Bs.indexOf("Trident/");
  var Zs = "svg-inline--fa";
  !function () {
    try {
      process.env.NODE_ENV;
    } catch (e) {
      return !1;
    }
  }();
  var Ws = "group",
      $s = "primary",
      Gs = "secondary",
      Ys = qs.FontAwesomeConfig || {};

  if (Us && "function" == typeof Us.querySelector) {
    [["data-family-prefix", "familyPrefix"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]].forEach(function (e) {
      var t = Is(e, 2),
          n = t[0],
          r = t[1],
          o = function (e) {
        return "" === e || "false" !== e && ("true" === e || e);
      }(function (e) {
        var t = Us.querySelector("script[" + e + "]");
        if (t) return t.getAttribute(e);
      }(n));

      null != o && (Ys[r] = o);
    });
  }

  var Qs = Ns({}, {
    familyPrefix: "fa",
    replacementClass: Zs,
    autoReplaceSvg: !0,
    autoAddCss: !0,
    autoA11y: !0,
    searchPseudoElements: !1,
    observeMutations: !0,
    mutateApproach: "async",
    keepOriginalSource: !0,
    measurePerformance: !1,
    showMissingIcons: !0
  }, Ys);
  Qs.autoReplaceSvg || (Qs.observeMutations = !1);
  var Xs = Ns({}, Qs);
  qs.FontAwesomeConfig = Xs;
  var Ks = qs || {};
  Ks.___FONT_AWESOME___ || (Ks.___FONT_AWESOME___ = {}), Ks.___FONT_AWESOME___.styles || (Ks.___FONT_AWESOME___.styles = {}), Ks.___FONT_AWESOME___.hooks || (Ks.___FONT_AWESOME___.hooks = {}), Ks.___FONT_AWESOME___.shims || (Ks.___FONT_AWESOME___.shims = []);
  var Js = Ks.___FONT_AWESOME___,
      el = [];
  Hs && ((Us.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(Us.readyState) || Us.addEventListener("DOMContentLoaded", function e() {
    Us.removeEventListener("DOMContentLoaded", e), 1, el.map(function (e) {
      return e();
    });
  }));

  var tl,
      nl = "pending",
      rl = "settled",
      ol = "fulfilled",
      il = "rejected",
      al = function al() {},
      sl = "undefined" != typeof global && void 0 !== global.process && "function" == typeof global.process.emit,
      ll = "undefined" == typeof setImmediate ? setTimeout : setImmediate,
      cl = [];

  function ul() {
    for (var e = 0; e < cl.length; e++) {
      cl[e][0](cl[e][1]);
    }

    cl = [], tl = !1;
  }

  function dl(e, t) {
    cl.push([e, t]), tl || (tl = !0, ll(ul, 0));
  }

  function fl(e) {
    var t = e.owner,
        n = t._state,
        r = t._data,
        o = e[n],
        i = e.then;

    if ("function" == typeof o) {
      n = ol;

      try {
        r = o(r);
      } catch (e) {
        gl(i, e);
      }
    }

    pl(i, r) || (n === ol && hl(i, r), n === il && gl(i, r));
  }

  function pl(e, t) {
    var n;

    try {
      if (e === t) throw new TypeError("A promises callback cannot return that same promise.");

      if (t && ("function" == typeof t || "object" === Ls(t))) {
        var r = t.then;
        if ("function" == typeof r) return r.call(t, function (r) {
          n || (n = !0, t === r ? ml(e, r) : hl(e, r));
        }, function (t) {
          n || (n = !0, gl(e, t));
        }), !0;
      }
    } catch (t) {
      return n || gl(e, t), !0;
    }

    return !1;
  }

  function hl(e, t) {
    e !== t && pl(e, t) || ml(e, t);
  }

  function ml(e, t) {
    e._state === nl && (e._state = rl, e._data = t, dl(bl, e));
  }

  function gl(e, t) {
    e._state === nl && (e._state = rl, e._data = t, dl(vl, e));
  }

  function yl(e) {
    e._then = e._then.forEach(fl);
  }

  function bl(e) {
    e._state = ol, yl(e);
  }

  function vl(e) {
    e._state = il, yl(e), !e._handled && sl && global.process.emit("unhandledRejection", e._data, e);
  }

  function xl(e) {
    global.process.emit("rejectionHandled", e);
  }

  function wl(e) {
    if ("function" != typeof e) throw new TypeError("Promise resolver " + e + " is not a function");
    if (this instanceof wl == !1) throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
    this._then = [], function (e, t) {
      function n(e) {
        gl(t, e);
      }

      try {
        e(function (e) {
          hl(t, e);
        }, n);
      } catch (e) {
        n(e);
      }
    }(e, this);
  }

  wl.prototype = {
    constructor: wl,
    _state: nl,
    _then: null,
    _data: void 0,
    _handled: !1,
    then: function then(e, t) {
      var n = {
        owner: this,
        then: new this.constructor(al),
        fulfilled: e,
        rejected: t
      };
      return !t && !e || this._handled || (this._handled = !0, this._state === il && sl && dl(xl, this)), this._state === ol || this._state === il ? dl(fl, n) : this._then.push(n), n.then;
    },
    "catch": function _catch(e) {
      return this.then(null, e);
    }
  }, wl.all = function (e) {
    if (!Array.isArray(e)) throw new TypeError("You must pass an array to Promise.all().");
    return new wl(function (t, n) {
      var r = [],
          o = 0;

      function i(e) {
        return o++, function (n) {
          r[e] = n, --o || t(r);
        };
      }

      for (var a, s = 0; s < e.length; s++) {
        (a = e[s]) && "function" == typeof a.then ? a.then(i(s), n) : r[s] = a;
      }

      o || t(r);
    });
  }, wl.race = function (e) {
    if (!Array.isArray(e)) throw new TypeError("You must pass an array to Promise.race().");
    return new wl(function (t, n) {
      for (var r, o = 0; o < e.length; o++) {
        (r = e[o]) && "function" == typeof r.then ? r.then(t, n) : t(r);
      }
    });
  }, wl.resolve = function (e) {
    return e && "object" === Ls(e) && e.constructor === wl ? e : new wl(function (t) {
      t(e);
    });
  }, wl.reject = function (e) {
    return new wl(function (t, n) {
      n(e);
    });
  };
  var kl = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: !1,
    flipY: !1
  };

  function Cl() {
    for (var e = 12, t = ""; e-- > 0;) {
      t += "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[62 * Math.random() | 0];
    }

    return t;
  }

  function Ml(e) {
    return "".concat(e).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }

  function jl(e) {
    return Object.keys(e || {}).reduce(function (t, n) {
      return t + "".concat(n, ": ").concat(e[n], ";");
    }, "");
  }

  function El(e) {
    return e.size !== kl.size || e.x !== kl.x || e.y !== kl.y || e.rotate !== kl.rotate || e.flipX || e.flipY;
  }

  function _l(e) {
    var t = e.transform,
        n = e.containerWidth,
        r = e.iconWidth,
        o = {
      transform: "translate(".concat(n / 2, " 256)")
    },
        i = "translate(".concat(32 * t.x, ", ").concat(32 * t.y, ") "),
        a = "scale(".concat(t.size / 16 * (t.flipX ? -1 : 1), ", ").concat(t.size / 16 * (t.flipY ? -1 : 1), ") "),
        s = "rotate(".concat(t.rotate, " 0 0)");
    return {
      outer: o,
      inner: {
        transform: "".concat(i, " ").concat(a, " ").concat(s)
      },
      path: {
        transform: "translate(".concat(r / 2 * -1, " -256)")
      }
    };
  }

  var Tl = {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  };

  function Sl(e) {
    var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
    return e.attributes && (e.attributes.fill || t) && (e.attributes.fill = "black"), e;
  }

  function Ll(e) {
    var t = e.icons,
        n = t.main,
        r = t.mask,
        o = e.prefix,
        i = e.iconName,
        a = e.transform,
        s = e.symbol,
        l = e.title,
        c = e.maskId,
        u = e.titleId,
        d = e.extra,
        f = e.watchable,
        p = void 0 !== f && f,
        h = r.found ? r : n,
        m = h.width,
        g = h.height,
        y = "fak" === o,
        b = y ? "" : "fa-w-".concat(Math.ceil(m / g * 16)),
        v = [Xs.replacementClass, i ? "".concat(Xs.familyPrefix, "-").concat(i) : "", b].filter(function (e) {
      return -1 === d.classes.indexOf(e);
    }).filter(function (e) {
      return "" !== e || !!e;
    }).concat(d.classes).join(" "),
        x = {
      children: [],
      attributes: Ns({}, d.attributes, {
        "data-prefix": o,
        "data-icon": i,
        "class": v,
        role: d.attributes.role || "img",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 ".concat(m, " ").concat(g)
      })
    },
        w = y && !~d.classes.indexOf("fa-fw") ? {
      width: "".concat(m / g * 16 * .0625, "em")
    } : {};
    p && (x.attributes["data-fa-i2svg"] = ""), l && x.children.push({
      tag: "title",
      attributes: {
        id: x.attributes["aria-labelledby"] || "title-".concat(u || Cl())
      },
      children: [l]
    });
    var k = Ns({}, x, {
      prefix: o,
      iconName: i,
      main: n,
      mask: r,
      maskId: c,
      transform: a,
      symbol: s,
      styles: Ns({}, w, d.styles)
    }),
        C = r.found && n.found ? function (e) {
      var t,
          n = e.children,
          r = e.attributes,
          o = e.main,
          i = e.mask,
          a = e.maskId,
          s = e.transform,
          l = o.width,
          c = o.icon,
          u = i.width,
          d = i.icon,
          f = _l({
        transform: s,
        containerWidth: u,
        iconWidth: l
      }),
          p = {
        tag: "rect",
        attributes: Ns({}, Tl, {
          fill: "white"
        })
      },
          h = c.children ? {
        children: c.children.map(Sl)
      } : {},
          m = {
        tag: "g",
        attributes: Ns({}, f.inner),
        children: [Sl(Ns({
          tag: c.tag,
          attributes: Ns({}, c.attributes, f.path)
        }, h))]
      },
          g = {
        tag: "g",
        attributes: Ns({}, f.outer),
        children: [m]
      },
          y = "mask-".concat(a || Cl()),
          b = "clip-".concat(a || Cl()),
          v = {
        tag: "mask",
        attributes: Ns({}, Tl, {
          id: y,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [p, g]
      },
          x = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: b
          },
          children: (t = d, "g" === t.tag ? t.children : [t])
        }, v]
      };

      return n.push(x, {
        tag: "rect",
        attributes: Ns({
          fill: "currentColor",
          "clip-path": "url(#".concat(b, ")"),
          mask: "url(#".concat(y, ")")
        }, Tl)
      }), {
        children: n,
        attributes: r
      };
    }(k) : function (e) {
      var t = e.children,
          n = e.attributes,
          r = e.main,
          o = e.transform,
          i = jl(e.styles);

      if (i.length > 0 && (n.style = i), El(o)) {
        var a = _l({
          transform: o,
          containerWidth: r.width,
          iconWidth: r.width
        });

        t.push({
          tag: "g",
          attributes: Ns({}, a.outer),
          children: [{
            tag: "g",
            attributes: Ns({}, a.inner),
            children: [{
              tag: r.icon.tag,
              children: r.icon.children,
              attributes: Ns({}, r.icon.attributes, a.path)
            }]
          }]
        });
      } else t.push(r.icon);

      return {
        children: t,
        attributes: n
      };
    }(k),
        M = C.children,
        j = C.attributes;
    return k.children = M, k.attributes = j, s ? function (e) {
      var t = e.prefix,
          n = e.iconName,
          r = e.children,
          o = e.attributes,
          i = e.symbol;
      return [{
        tag: "svg",
        attributes: {
          style: "display: none;"
        },
        children: [{
          tag: "symbol",
          attributes: Ns({}, o, {
            id: !0 === i ? "".concat(t, "-").concat(Xs.familyPrefix, "-").concat(n) : i
          }),
          children: r
        }]
      }];
    }(k) : function (e) {
      var t = e.children,
          n = e.main,
          r = e.mask,
          o = e.attributes,
          i = e.styles,
          a = e.transform;

      if (El(a) && n.found && !r.found) {
        var s = {
          x: n.width / n.height / 2,
          y: .5
        };
        o.style = jl(Ns({}, i, {
          "transform-origin": "".concat(s.x + a.x / 16, "em ").concat(s.y + a.y / 16, "em")
        }));
      }

      return [{
        tag: "svg",
        attributes: o,
        children: t
      }];
    }(k);
  }

  Xs.measurePerformance && Vs && Vs.mark && Vs.measure;

  var Dl = function Dl(e, t, n, r) {
    var o,
        i,
        a,
        s = Object.keys(e),
        l = s.length,
        c = void 0 !== r ? function (e, t) {
      return function (n, r, o, i) {
        return e.call(t, n, r, o, i);
      };
    }(t, r) : t;

    for (void 0 === n ? (o = 1, a = e[s[0]]) : (o = 0, a = n); o < l; o++) {
      a = c(a, e[i = s[o]], i, e);
    }

    return a;
  };

  function Al(e, t) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
        r = n.skipHooks,
        o = void 0 !== r && r,
        i = Object.keys(t).reduce(function (e, n) {
      var r = t[n];
      return !!r.icon ? e[r.iconName] = r.icon : e[n] = r, e;
    }, {});
    "function" != typeof Js.hooks.addPack || o ? Js.styles[e] = Ns({}, Js.styles[e] || {}, i) : Js.hooks.addPack(e, i), "fas" === e && Al("fa", t);
  }

  var Nl = Js.styles,
      Il = Js.shims,
      zl = function zl() {
    var e = function e(_e2) {
      return Dl(Nl, function (t, n, r) {
        return t[r] = Dl(n, _e2, {}), t;
      }, {});
    };

    e(function (e, t, n) {
      return t[3] && (e[t[3]] = n), e;
    }), e(function (e, t, n) {
      var r = t[2];
      return e[n] = n, r.forEach(function (t) {
        e[t] = n;
      }), e;
    });
    var t = ("far" in Nl);
    Dl(Il, function (e, n) {
      var r = n[0],
          o = n[1],
          i = n[2];
      return "far" !== o || t || (o = "fas"), e[r] = {
        prefix: o,
        iconName: i
      }, e;
    }, {});
  };

  function Ol(e, t, n) {
    if (e && e[t] && e[t][n]) return {
      prefix: t,
      iconName: n,
      icon: e[t][n]
    };
  }

  function Rl(e) {
    var t = e.tag,
        n = e.attributes,
        r = void 0 === n ? {} : n,
        o = e.children,
        i = void 0 === o ? [] : o;
    return "string" == typeof e ? Ml(e) : "<".concat(t, " ").concat(function (e) {
      return Object.keys(e || {}).reduce(function (t, n) {
        return t + "".concat(n, '="').concat(Ml(e[n]), '" ');
      }, "").trim();
    }(r), ">").concat(i.map(Rl).join(""), "</").concat(t, ">");
  }

  zl(), Js.styles;

  function Pl(e) {
    this.name = "MissingIcon", this.message = e || "Icon unavailable", this.stack = new Error().stack;
  }

  Pl.prototype = Object.create(Error.prototype), Pl.prototype.constructor = Pl;
  var Fl = {
    fill: "currentColor"
  },
      Bl = {
    attributeType: "XML",
    repeatCount: "indefinite",
    dur: "2s"
  };
  Ns({}, Fl, {
    d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
  });
  var ql = Ns({}, Bl, {
    attributeName: "opacity"
  });

  function Ul(e) {
    var t = e[0],
        n = e[1],
        r = Is(e.slice(4), 1)[0];
    return {
      found: !0,
      width: t,
      height: n,
      icon: Array.isArray(r) ? {
        tag: "g",
        attributes: {
          "class": "".concat(Xs.familyPrefix, "-").concat(Ws)
        },
        children: [{
          tag: "path",
          attributes: {
            "class": "".concat(Xs.familyPrefix, "-").concat(Gs),
            fill: "currentColor",
            d: r[0]
          }
        }, {
          tag: "path",
          attributes: {
            "class": "".concat(Xs.familyPrefix, "-").concat($s),
            fill: "currentColor",
            d: r[1]
          }
        }]
      } : {
        tag: "path",
        attributes: {
          fill: "currentColor",
          d: r
        }
      }
    };
  }

  Ns({}, Fl, {
    cx: "256",
    cy: "364",
    r: "28"
  }), Ns({}, Bl, {
    attributeName: "r",
    values: "28;14;28;28;14;28;"
  }), Ns({}, ql, {
    values: "1;0;1;1;0;1;"
  }), Ns({}, Fl, {
    opacity: "1",
    d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
  }), Ns({}, ql, {
    values: "1;0;0;0;0;1;"
  }), Ns({}, Fl, {
    opacity: "0",
    d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
  }), Ns({}, ql, {
    values: "0;0;1;1;0;0;"
  }), Js.styles, Js.styles;

  var Vl = function () {
    function e() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.definitions = {};
    }

    var t, n, r;
    return t = e, n = [{
      key: "add",
      value: function value() {
        for (var e = this, t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
          n[r] = arguments[r];
        }

        var o = n.reduce(this._pullDefinitions, {});
        Object.keys(o).forEach(function (t) {
          e.definitions[t] = Ns({}, e.definitions[t] || {}, o[t]), Al(t, o[t]), zl();
        });
      }
    }, {
      key: "reset",
      value: function value() {
        this.definitions = {};
      }
    }, {
      key: "_pullDefinitions",
      value: function value(e, t) {
        var n = t.prefix && t.iconName && t.icon ? {
          0: t
        } : t;
        return Object.keys(n).map(function (t) {
          var r = n[t],
              o = r.prefix,
              i = r.iconName,
              a = r.icon;
          e[o] || (e[o] = {}), e[o][i] = a;
        }), e;
      }
    }], n && Ds(t.prototype, n), r && Ds(t, r), e;
  }();

  function Hl() {
    Xs.autoAddCss && !Yl && (!function (e) {
      if (e && Hs) {
        var t = Us.createElement("style");
        t.setAttribute("type", "text/css"), t.innerHTML = e;

        for (var n = Us.head.childNodes, r = null, o = n.length - 1; o > -1; o--) {
          var i = n[o],
              a = (i.tagName || "").toUpperCase();
          ["STYLE", "LINK"].indexOf(a) > -1 && (r = i);
        }

        Us.head.insertBefore(t, r);
      }
    }(function () {
      var e = "fa",
          t = Zs,
          n = Xs.familyPrefix,
          r = Xs.replacementClass,
          o = 'svg:not(:root).svg-inline--fa {\n  overflow: visible;\n}\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.225em;\n}\n.svg-inline--fa.fa-w-1 {\n  width: 0.0625em;\n}\n.svg-inline--fa.fa-w-2 {\n  width: 0.125em;\n}\n.svg-inline--fa.fa-w-3 {\n  width: 0.1875em;\n}\n.svg-inline--fa.fa-w-4 {\n  width: 0.25em;\n}\n.svg-inline--fa.fa-w-5 {\n  width: 0.3125em;\n}\n.svg-inline--fa.fa-w-6 {\n  width: 0.375em;\n}\n.svg-inline--fa.fa-w-7 {\n  width: 0.4375em;\n}\n.svg-inline--fa.fa-w-8 {\n  width: 0.5em;\n}\n.svg-inline--fa.fa-w-9 {\n  width: 0.5625em;\n}\n.svg-inline--fa.fa-w-10 {\n  width: 0.625em;\n}\n.svg-inline--fa.fa-w-11 {\n  width: 0.6875em;\n}\n.svg-inline--fa.fa-w-12 {\n  width: 0.75em;\n}\n.svg-inline--fa.fa-w-13 {\n  width: 0.8125em;\n}\n.svg-inline--fa.fa-w-14 {\n  width: 0.875em;\n}\n.svg-inline--fa.fa-w-15 {\n  width: 0.9375em;\n}\n.svg-inline--fa.fa-w-16 {\n  width: 1em;\n}\n.svg-inline--fa.fa-w-17 {\n  width: 1.0625em;\n}\n.svg-inline--fa.fa-w-18 {\n  width: 1.125em;\n}\n.svg-inline--fa.fa-w-19 {\n  width: 1.1875em;\n}\n.svg-inline--fa.fa-w-20 {\n  width: 1.25em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-border {\n  height: 1.5em;\n}\n.svg-inline--fa.fa-li {\n  width: 2em;\n}\n.svg-inline--fa.fa-fw {\n  width: 1.25em;\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: #ff253a;\n  border-radius: 1em;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #fff;\n  height: 1.5em;\n  line-height: 1;\n  max-width: 5em;\n  min-width: 1.5em;\n  overflow: hidden;\n  padding: 0.25em;\n  right: 0;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: 0;\n  left: 0;\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  right: 0;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: 0;\n  right: auto;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-lg {\n  font-size: 1.3333333333em;\n  line-height: 0.75em;\n  vertical-align: -0.0667em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit;\n}\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: 0.1em;\n  padding: 0.2em 0.25em 0.15em;\n}\n\n.fa-pull-left {\n  float: left;\n}\n\n.fa-pull-right {\n  float: right;\n}\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: 0.3em;\n}\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: 0.3em;\n}\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear;\n}\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8);\n}\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical,\n:root .fa-flip-both {\n  -webkit-filter: none;\n          filter: none;\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: #fff;\n}\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse {\n  color: #fff;\n}';

      if (n !== e || r !== t) {
        var i = new RegExp("\\.".concat(e, "\\-"), "g"),
            a = new RegExp("\\--".concat(e, "\\-"), "g"),
            s = new RegExp("\\.".concat(t), "g");
        o = o.replace(i, ".".concat(n, "-")).replace(a, "--".concat(n, "-")).replace(s, ".".concat(r));
      }

      return o;
    }()), Yl = !0);
  }

  function Zl(e, t) {
    return Object.defineProperty(e, "abstract", {
      get: t
    }), Object.defineProperty(e, "html", {
      get: function get() {
        return e["abstract"].map(function (e) {
          return Rl(e);
        });
      }
    }), Object.defineProperty(e, "node", {
      get: function get() {
        if (Hs) {
          var t = Us.createElement("div");
          return t.innerHTML = e.html, t.children;
        }
      }
    }), e;
  }

  function Wl(e) {
    var t = e.prefix,
        n = void 0 === t ? "fa" : t,
        r = e.iconName;
    if (r) return Ol(Gl.definitions, n, r) || Ol(Js.styles, n, r);
  }

  var $l,
      Gl = new Vl(),
      Yl = !1,
      Ql = {
    transform: function transform(e) {
      return function (e) {
        var t = {
          size: 16,
          x: 0,
          y: 0,
          flipX: !1,
          flipY: !1,
          rotate: 0
        };
        return e ? e.toLowerCase().split(" ").reduce(function (e, t) {
          var n = t.toLowerCase().split("-"),
              r = n[0],
              o = n.slice(1).join("-");
          if (r && "h" === o) return e.flipX = !0, e;
          if (r && "v" === o) return e.flipY = !0, e;
          if (o = parseFloat(o), isNaN(o)) return e;

          switch (r) {
            case "grow":
              e.size = e.size + o;
              break;

            case "shrink":
              e.size = e.size - o;
              break;

            case "left":
              e.x = e.x - o;
              break;

            case "right":
              e.x = e.x + o;
              break;

            case "up":
              e.y = e.y - o;
              break;

            case "down":
              e.y = e.y + o;
              break;

            case "rotate":
              e.rotate = e.rotate + o;
          }

          return e;
        }, t) : t;
      }(e);
    }
  },
      Xl = ($l = function $l(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        n = t.transform,
        r = void 0 === n ? kl : n,
        o = t.symbol,
        i = void 0 !== o && o,
        a = t.mask,
        s = void 0 === a ? null : a,
        l = t.maskId,
        c = void 0 === l ? null : l,
        u = t.title,
        d = void 0 === u ? null : u,
        f = t.titleId,
        p = void 0 === f ? null : f,
        h = t.classes,
        m = void 0 === h ? [] : h,
        g = t.attributes,
        y = void 0 === g ? {} : g,
        b = t.styles,
        v = void 0 === b ? {} : b;

    if (e) {
      var x = e.prefix,
          w = e.iconName,
          k = e.icon;
      return Zl(Ns({
        type: "icon"
      }, e), function () {
        return Hl(), Xs.autoA11y && (d ? y["aria-labelledby"] = "".concat(Xs.replacementClass, "-title-").concat(p || Cl()) : (y["aria-hidden"] = "true", y.focusable = "false")), Ll({
          icons: {
            main: Ul(k),
            mask: s ? Ul(s.icon) : {
              found: !1,
              width: null,
              height: null,
              icon: {}
            }
          },
          prefix: x,
          iconName: w,
          transform: Ns({}, kl, r),
          symbol: i,
          title: d,
          maskId: c,
          titleId: p,
          extra: {
            attributes: y,
            styles: v,
            classes: m
          }
        });
      });
    }
  }, function (e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        n = (e || {}).icon ? e : Wl(e || {}),
        r = t.mask;
    return r && (r = (r || {}).icon ? r : Wl(r || {})), $l(n, Ns({}, t, {
      mask: r
    }));
  });

  function Kl(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function Jl(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Kl(Object(n), !0).forEach(function (t) {
        tc(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Kl(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function ec(e) {
    return ec = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
      return _typeof(e);
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
    }, ec(e);
  }

  function tc(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  function nc(e, t) {
    if (null == e) return {};

    var n,
        r,
        o = function (e, t) {
      if (null == e) return {};
      var n,
          r,
          o = {},
          i = Object.keys(e);

      for (r = 0; r < i.length; r++) {
        n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
      }

      return o;
    }(e, t);

    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);

      for (r = 0; r < i.length; r++) {
        n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
      }
    }

    return o;
  }

  function rc(e) {
    return function (e) {
      if (Array.isArray(e)) return oc(e);
    }(e) || function (e) {
      if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
    }(e) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return oc(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === n && e.constructor && (n = e.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(e);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return oc(e, t);
    }(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function oc(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }

    return r;
  }

  function ic(e) {
    return t = e, (t -= 0) == t ? e : (e = e.replace(/[\-_\s]+(.)?/g, function (e, t) {
      return t ? t.toUpperCase() : "";
    })).substr(0, 1).toLowerCase() + e.substr(1);
    var t;
  }

  var ac = ["style"];

  function sc(e) {
    return e.split(";").map(function (e) {
      return e.trim();
    }).filter(function (e) {
      return e;
    }).reduce(function (e, t) {
      var n,
          r = t.indexOf(":"),
          o = ic(t.slice(0, r)),
          i = t.slice(r + 1).trim();
      return o.startsWith("webkit") ? e[(n = o, n.charAt(0).toUpperCase() + n.slice(1))] = i : e[o] = i, e;
    }, {});
  }

  var lc = !1;

  try {
    lc = "production" === process.env.NODE_ENV;
  } catch (xv) {}

  function cc(e) {
    return e && "object" === ec(e) && e.prefix && e.iconName && e.icon ? e : Ql.icon ? Ql.icon(e) : null === e ? null : e && "object" === ec(e) && e.prefix && e.iconName ? e : Array.isArray(e) && 2 === e.length ? {
      prefix: e[0],
      iconName: e[1]
    } : "string" == typeof e ? {
      prefix: "fas",
      iconName: e
    } : void 0;
  }

  function uc(e, t) {
    return Array.isArray(t) && t.length > 0 || !Array.isArray(t) && t ? tc({}, e, t) : {};
  }

  var dc = S["default"].forwardRef(function (e, t) {
    var n = e.icon,
        r = e.mask,
        o = e.symbol,
        i = e.className,
        a = e.title,
        s = e.titleId,
        l = e.maskId,
        c = cc(n),
        u = uc("classes", [].concat(rc(function (e) {
      var t,
          n = e.beat,
          r = e.fade,
          o = e.beatFade,
          i = e.bounce,
          a = e.shake,
          s = e.flash,
          l = e.spin,
          c = e.spinPulse,
          u = e.spinReverse,
          d = e.pulse,
          f = e.fixedWidth,
          p = e.inverse,
          h = e.border,
          m = e.listItem,
          g = e.flip,
          y = e.size,
          b = e.rotation,
          v = e.pull,
          x = (tc(t = {
        "fa-beat": n,
        "fa-fade": r,
        "fa-beat-fade": o,
        "fa-bounce": i,
        "fa-shake": a,
        "fa-flash": s,
        "fa-spin": l,
        "fa-spin-reverse": u,
        "fa-spin-pulse": c,
        "fa-pulse": d,
        "fa-fw": f,
        "fa-inverse": p,
        "fa-border": h,
        "fa-li": m,
        "fa-flip": !0 === g,
        "fa-flip-horizontal": "horizontal" === g || "both" === g,
        "fa-flip-vertical": "vertical" === g || "both" === g
      }, "fa-".concat(y), null != y), tc(t, "fa-rotate-".concat(b), null != b && 0 !== b), tc(t, "fa-pull-".concat(v), null != v), tc(t, "fa-swap-opacity", e.swapOpacity), t);
      return Object.keys(x).map(function (e) {
        return x[e] ? e : null;
      }).filter(function (e) {
        return e;
      });
    }(e)), rc(i.split(" ")))),
        d = uc("transform", "string" == typeof e.transform ? Ql.transform(e.transform) : e.transform),
        f = uc("mask", cc(r)),
        p = Xl(c, Jl(Jl(Jl(Jl({}, u), d), f), {}, {
      symbol: o,
      title: a,
      titleId: s,
      maskId: l
    }));
    if (!p) return function () {
      var e;
      !lc && console && "function" == typeof console.error && (e = console).error.apply(e, arguments);
    }("Could not find icon", c), null;
    var h = p["abstract"],
        m = {
      ref: t
    };
    return Object.keys(e).forEach(function (t) {
      dc.defaultProps.hasOwnProperty(t) || (m[t] = e[t]);
    }), fc(h[0], m);
  });
  dc.displayName = "FontAwesomeIcon", dc.propTypes = {
    beat: T["default"].bool,
    border: T["default"].bool,
    beatFade: T["default"].bool,
    bounce: T["default"].bool,
    className: T["default"].string,
    fade: T["default"].bool,
    flash: T["default"].bool,
    mask: T["default"].oneOfType([T["default"].object, T["default"].array, T["default"].string]),
    maskId: T["default"].string,
    fixedWidth: T["default"].bool,
    inverse: T["default"].bool,
    flip: T["default"].oneOf([!0, !1, "horizontal", "vertical", "both"]),
    icon: T["default"].oneOfType([T["default"].object, T["default"].array, T["default"].string]),
    listItem: T["default"].bool,
    pull: T["default"].oneOf(["right", "left"]),
    pulse: T["default"].bool,
    rotation: T["default"].oneOf([0, 90, 180, 270]),
    shake: T["default"].bool,
    size: T["default"].oneOf(["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
    spin: T["default"].bool,
    spinPulse: T["default"].bool,
    spinReverse: T["default"].bool,
    symbol: T["default"].oneOfType([T["default"].bool, T["default"].string]),
    title: T["default"].string,
    titleId: T["default"].string,
    transform: T["default"].oneOfType([T["default"].string, T["default"].object]),
    swapOpacity: T["default"].bool
  }, dc.defaultProps = {
    border: !1,
    className: "",
    mask: null,
    maskId: null,
    fixedWidth: !1,
    inverse: !1,
    flip: !1,
    icon: null,
    listItem: !1,
    pull: null,
    pulse: !1,
    rotation: null,
    size: null,
    spin: !1,
    spinPulse: !1,
    spinReverse: !1,
    beat: !1,
    fade: !1,
    beatFade: !1,
    bounce: !1,
    shake: !1,
    symbol: !1,
    title: "",
    titleId: null,
    transform: null,
    swapOpacity: !1
  };

  var fc = function e(t, n) {
    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
    if ("string" == typeof n) return n;
    var o = (n.children || []).map(function (n) {
      return e(t, n);
    }),
        i = Object.keys(n.attributes || {}).reduce(function (e, t) {
      var r = n.attributes[t];

      switch (t) {
        case "class":
          e.attrs.className = r, delete n.attributes["class"];
          break;

        case "style":
          e.attrs.style = sc(r);
          break;

        default:
          0 === t.indexOf("aria-") || 0 === t.indexOf("data-") ? e.attrs[t.toLowerCase()] = r : e.attrs[ic(t)] = r;
      }

      return e;
    }, {
      attrs: {}
    }),
        a = r.style,
        s = void 0 === a ? {} : a,
        l = nc(r, ac);
    return i.attrs.style = Jl(Jl({}, i.attrs.style), s), t.apply(void 0, [n.tag, Jl(Jl({}, i.attrs), l)].concat(rc(o)));
  }.bind(null, S["default"].createElement);

  Xs.autoAddCss = !1;

  var pc = n.compose(n.color, ue, le, n.flexbox, n.layout, n.position, n.space, n.typography),
      hc = [].concat(_toConsumableArray(ie), ["active", "adaptive", "animate", "blacklist", "cursor", "custom", "dragConstraints", "dragElastic", "exit", "gradientStepColor", "hasBorder", "hasTimeout", "hideLabel", "hideOutline", "hoverBg", "initial", "isArmed", "isDragging", "isMatched", "isNew", "larger", "layout", "matched", "measure", "reset", "reverse", "rowDirectionStartingAt", "secondary", "showScroll", "small", "subheading", "textOverflow", "transition", "translateBy", "trunclipse", "variants", "when", "zIndex"]),
      mc = _["default"](dc).attrs(function (e) {
    return {
      "aria-hidden": !0,
      icon: e.weight ? [A["default"]([[D["default"]("solid"), function () {
        return "fas";
      }], [D["default"]("regular"), function () {
        return "far";
      }], [D["default"]("light"), function () {
        return "fal";
      }], [D["default"]("brands"), function () {
        return "fab";
      }]])(e.weight), e.icon] : e.icon
    };
  }).withConfig({
    shouldForwardProp: function shouldForwardProp(e) {
      return !hc.includes(e);
    }
  }).withConfig({
    displayName: "Icon",
    componentId: "sc-aroaon-0"
  })(["", ";"], pc);

  mc.displayName = "Icon", mc.defaultProps = {
    weight: "light"
  }, mc.propTypes = {
    icon: T["default"].string.isRequired,
    weight: T["default"].oneOf(["solid", "regular", "light", "brands"])
  };

  var gc = {
    breakpoints: ["22.5em", "40em", "64em", "90em"],
    colors: {
      white: "#fff",
      gray50: "#f9f9f9",
      gray100: "#f6f6f6",
      gray150: "#f0f0f0",
      gray200: "#ebebeb",
      gray300: "#d9d9d9",
      gray400: "#cbcaca",
      gray500: "#adabab",
      gray600: "#949494",
      gray700: "#7A7979",
      gray800: "#616060",
      gray900: "#474747",
      black: "#231f20",
      blackAt90: "rgba(35,31,32,0.9)",
      blue50: "#f3f5fd",
      blue100: "#e9edff",
      blue200: "#d9e0ff",
      blue300: "#c7d1fe",
      blue400: "#98abff",
      blue500: "#5774fc",
      blue600: "#4d6af5",
      blue700: "#425fe6",
      blue800: "#3851c7",
      blue900: "#384ca3",
      green50: "#d1f3e3",
      green100: "#90eac6",
      green300: "#5dd4a4",
      green500: "#3eb988",
      green700: "#29946a",
      green900: "#1d6648",
      red50: "#ffe9e6",
      red100: "#ffd8d3",
      red300: "#ff9688",
      red500: "#ff634e",
      red700: "#e9412b",
      red900: "#c02b17",
      yellow100: "#fffced",
      yellow200: "#fff6c9",
      yellow300: "#fff0a4",
      yellow400: "#fee35c",
      yellow500: "#fed502",
      yellow600: "#feb702",
      yellow700: "#f59a08",
      yellow800: "#e68222",
      yellow900: "#c07214",
      purple100: "#E4DAF2",
      purple200: "#C8B5E5",
      purple300: "#AD8FD7",
      purple400: "#916ACA",
      purple500: "#7645BD",
      purple600: "#58338D",
      purple700: "#3D2264",
      darkPurple25: "#F4F4F6",
      darkPurple50: "#EAE8ED",
      darkPurple100: "#E0DDE4",
      darkPurple150: "#D5D1DA",
      darkPurple200: "#ABA4B6",
      darkPurple300: "#817691",
      darkPurple400: "#57496D",
      darkPurple500: "#2D1B48",
      darkPurple600: "#1A0F29",
      pink: "#ed59a5",
      jellybeans: {
        darkPink: "#FF5259",
        orange: "#FF9800",
        yellow: "#E6D420",
        lime: "#00E13E",
        teal: "#00B6B8",
        lightBlue: "#6FBEFF",
        purple: "#D87FFF",
        pink: "#FF91CE"
      }
    },
    dropShadows: ["drop-shadow(0 0 0 transparent)", "drop-shadow(0 1px 2px rgba(0,0,0,0.2)) drop-shadow(0 2px 6px rgba(0,0,0,0.04))", "drop-shadow(0 2px 4px rgba(0,0,0,0.2)) drop-shadow(0 4px 8px rgba(0,0,0,0.04))"],
    fontSizes: ["0.875rem", "1rem", "1.125rem", "1.25rem", "1.777rem", "2.369rem", "3.157rem", "3.653rem", "4.209rem"],
    letterSpacings: {
      compressed: "-0.05em",
      condensed: "-0.025em",
      narrow: "-0.0125em",
      medium: "0.0125em",
      wide: "0.125em",
      extended: "0.25em"
    },
    lineHeights: {
      none: "0",
      single: "1",
      heading: "1.2",
      body: "1.6",
      "double": "2"
    },
    radii: {
      rounded: "4px",
      small: "4px",
      medium: "0.5rem",
      large: "1rem",
      largePlus: "2rem",
      extraLarge: "3rem",
      circular: "50%"
    },
    shadows: ["0 0 0 transparent", "0 1px 6px rgba(0,0,0,0.1), 0 0 2px rgba(0,0,0,0.125)", "0 1px 2px -3px rgba(0,0,0,0.1), 0 2px 8px -1px rgba(0,0,0,0.175)", "0 2px 3px -4px rgba(0,0,0,0.05), 0 2px 14px 1px rgba(0,0,0,0.125)", "0 5px 5px rgba(0,0,0,0.2), 0 10px 20px rgba(0,0,0,0.2)"],
    space: ["0em", "0.25rem", "0.5rem", "1rem", "2rem", "4rem", "8rem", "16rem"],
    fonts: {
      standard: "Open Sans",
      literacy: "Quicksand"
    }
  },
      _gc$breakpoints$map = gc.breakpoints.map(function (e) {
    return "@media screen and (min-width: ".concat(e, ")");
  }),
      _gc$breakpoints$map2 = _slicedToArray(_gc$breakpoints$map, 4),
      yc = _gc$breakpoints$map2[0],
      bc = _gc$breakpoints$map2[1],
      vc = _gc$breakpoints$map2[2],
      xc = _gc$breakpoints$map2[3],
      wc = {
    sm: function sm() {
      return t.css(["", "{", "}"], yc, t.css.apply(t, arguments));
    },
    md: function md() {
      return t.css(["", "{", "}"], bc, t.css.apply(t, arguments));
    },
    lg: function lg() {
      return t.css(["", "{", "}"], vc, t.css.apply(t, arguments));
    },
    xl: function xl() {
      return t.css(["", "{", "}"], xc, t.css.apply(t, arguments));
    }
  },
      kc = {
    sm: yc.replace("@media ", ""),
    md: bc.replace("@media ", ""),
    lg: vc.replace("@media ", ""),
    xl: xc.replace("@media ", "")
  },
      Cc = {
    sm: Number(gc.breakpoints[0].slice(0, -2)),
    md: Number(gc.breakpoints[1].slice(0, -2)),
    lg: Number(gc.breakpoints[2].slice(0, -2)),
    xl: Number(gc.breakpoints[3].slice(0, -2))
  },
      Mc = t.css(["background:transparent;color:", ";&:not([disabled]):hover,&:focus{background-color:", ";color:", ";}&:focus{outline:none;}&:focus:after{opacity:1;box-shadow:0 0 0 2px ", ";}"], function (e) {
    return e.theme.colors.black;
  }, function (e) {
    return e.theme.colors[e.$hoverColor];
  }, function (e) {
    return e.theme.colors[e.color];
  }, function (e) {
    return e.theme.colors.blue500;
  }),
      jc = t.css(["background:", ";color:", ";-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;&:hover,&:focus{background:", ";color:", ";}&:focus{outline:none;}"], function (e) {
    return e.theme.colors.blue500;
  }, function (e) {
    return e.theme.colors.white;
  }, function (e) {
    return e.theme.colors.blue700;
  }, function (e) {
    return e.theme.colors.white;
  }),
      Ec = {
    "default": Mc,
    primary: jc
  },
      _c = _["default"].button.withConfig({
    shouldForwardProp: se
  }).withConfig({
    displayName: "IconButton__IconButtonBase",
    componentId: "sc-1l4kqg8-0"
  })(["appearance:none;border:none;border-radius:", ";cursor:", ";display:inline-block;height:", ";width:", ";padding:0;opacity:", ";text-align:center;vertical-align:middle;line-height:", ";position:relative;", " ", " ", " ", " &:after{content:'';position:absolute;inset:-2px;border-radius:50%;opacity:0;}", " ", ""], function (e) {
    return e.theme.radii.circular;
  }, function (e) {
    return e.disabled ? "not-allowed" : "pointer";
  }, function (e) {
    return e.size ? "".concat(e.size, "rem") : "2rem";
  }, function (e) {
    return e.size ? "".concat(e.size, "rem") : "2rem";
  }, function (e) {
    return e.disabled ? .333 : 1;
  }, function (e) {
    return e.size ? "".concat(e.size, "rem") : "2rem";
  }, n.space, n.position, n.zIndex, wc.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    height: ", ";\n    width: ", ";\n    line-height: ", ";\n  "])), function (e) {
    return e.size ? "".concat(e.size, "rem") : "2.5rem";
  }, function (e) {
    return e.size ? "".concat(e.size, "rem") : "2.5rem";
  }, function (e) {
    return e.size ? "".concat(e.size, "rem") : "2.5rem";
  }), function (e) {
    return Ec[e.variant];
  }, n.color);

  function Tc(e) {
    var t = e.fontSize,
        n = e.icon,
        r = e.weight,
        o = e.zIndex,
        i = e.hoverColor,
        a = _objectWithoutProperties(e, _excluded);

    return s.jsx(_c, _objectSpread(_objectSpread({
      zIndex: o,
      $hoverColor: i
    }, a), {}, {
      children: s.jsx(mc, {
        icon: n,
        fontSize: t,
        weight: r
      })
    }));
  }

  Tc.defaultProps = {
    fontSize: 1,
    icon: "times",
    weight: "light",
    zIndex: 1,
    variant: "default",
    hoverColor: "gray200"
  }, Tc.propTypes = {
    fontSize: T["default"].number,
    icon: T["default"].string,
    weight: T["default"].oneOf(["solid", "regular", "light", "brands"]),
    zIndex: T["default"].number,
    variant: T["default"].oneOf(["default", "primary"]),
    hoverColor: T["default"].string
  };

  var Sc = {
    Google: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjEuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IlNTT19Hb29nbGVfTG9nbyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiCgkgdmlld0JveD0iMCAwIDU0NC4zMTggNTQ0LjMxOCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTQ0LjMxOCA1NDQuMzE4OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6IzQyODVGNDt9Cgkuc3Qxe2ZpbGw6IzM0QTg1Mzt9Cgkuc3Qye2ZpbGw6I0ZCQkMwNDt9Cgkuc3Qze2ZpbGw6I0VBNDMzNTt9Cjwvc3R5bGU+CjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik01MzguOTM0LDI3OC40MThjMC0xOC41LTEuNS0zNy4xLTQuNy01NS4zaC0yNTYuN3YxMDQuOGgxNDdjLTYuMSwzMy44LTI1LjcsNjMuNy01NC40LDgyLjd2NjhoODcuNwoJQzUwOS4zMzQsNDMxLjIxOCw1MzguOTM0LDM2MS4yMTgsNTM4LjkzNCwyNzguNDE4TDUzOC45MzQsMjc4LjQxOHoiLz4KPHBhdGggY2xhc3M9InN0MSIgZD0iTTI3Ny41MzQsNTQ0LjMxOGM3My40LDAsMTM1LjMtMjQuMSwxODAuNC02NS43bC04Ny43LTY4Yy0yNC40LDE2LjYtNTUuOSwyNi05Mi42LDI2CgljLTcxLDAtMTMxLjItNDcuOS0xNTIuOC0xMTIuM2gtOTAuNXY3MC4xQzgwLjUzNCw0ODYuMzE4LDE3NC42MzQsNTQ0LjMxOCwyNzcuNTM0LDU0NC4zMTh6Ii8+CjxwYXRoIGNsYXNzPSJzdDIiIGQ9Ik0xMjQuNzM0LDMyNC4zMThjLTExLjQtMzMuOC0xMS40LTcwLjQsMC0xMDQuMnYtNzAuMWgtOTAuNGMtMzguNiw3Ni45LTM4LjYsMTY3LjUsMCwyNDQuNEwxMjQuNzM0LDMyNC4zMTh6Ii8+CjxwYXRoIGNsYXNzPSJzdDMiIGQ9Ik0yNzcuNTM0LDEwNy43MThjMzguOC0wLjYsNzYuMywxNCwxMDQuNCw0MC44bDc3LjctNzcuN2MtNDkuMi00Ni4yLTExNC41LTcxLjYtMTgyLjEtNzAuOAoJYy0xMDIuOSwwLTE5Nyw1OC0yNDMuMiwxNTBsOTAuNCw3MC4xQzE0Ni4yMzQsMTU1LjYxOCwyMDYuNTM0LDEwNy43MTgsMjc3LjUzNCwxMDcuNzE4eiIvPgo8L3N2Zz4K",
    Clever: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjEuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkNsZXZlcl9TU09fTG9nbyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiCgkgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMTAyNCAxMDI0OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkO2ZpbGw6IzQyNzRGNjt9Cjwvc3R5bGU+CjxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgo8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMTAwNi41MDcsMTQ3LjQ4MmMtMjEuOTktNjAuNDE2LTY5LjU3Mi0xMDcuOTk4LTEyOS45ODgtMTI5Ljk4OEM4MjEuMTgsMCw3NjkuNzkyLDAsNjY2Ljk5MSwwSDM1Ny4wMDkKCUMyNTQuMjA4LDAsMjAyLjgxMiwwLDE0Ny40ODIsMTcuNDkzQzg3LjA2NiwzOS40ODQsMzkuNDg0LDg3LjA2NiwxNy40OTMsMTQ3LjQ4MkMwLDIwMi44MTIsMCwyNTQuMjE3LDAsMzU3LjAwOXYzMDkuOTgyCglDMCw3NjkuNzkyLDAsODIxLjE4LDE3LjQ5Myw4NzYuNTE4YzIxLjk5LDYwLjQxNiw2OS41NzIsMTA3Ljk5OCwxMjkuOTg4LDEyOS45OEMyMDIuODEyLDEwMjQsMjU0LjIwOCwxMDI0LDM1Ny4wMDksMTAyNGgzMDkuOTgyCgljMTAyLjgwMSwwLDE1NC4xODksMCwyMDkuNTI3LTE3LjUwMmM2MC40MTYtMjEuOTgyLDEwNy45OTgtNjkuNTY0LDEyOS45ODgtMTI5Ljk4QzEwMjQsODIxLjE4LDEwMjQsNzY5Ljc5MiwxMDI0LDY2Ni45OTFWMzU3LjAwOQoJQzEwMjQsMjU0LjIxNywxMDI0LDIwMi44MTIsMTAwNi41MDcsMTQ3LjQ4MnogTTU0NS40MzcsODQ3LjEwM0MzNTQuMTA1LDg0Ny4xMDMsMjEyLDY5OS45MzMsMjEyLDUxMy45MDR2LTEuODU3CglDMjEyLDMyNy44NiwzNTEuMzIyLDE3Nyw1NTEuMDEyLDE3N2MxMjIuNiwwLDE5NS45NzMsNDAuNzI2LDI1Ni4zNDEsOTkuOTU3TDcxNi4zMzQsMzgxLjU1CgljLTUwLjE1Ni00NS4zNTEtMTAxLjIzNy03My4xMTctMTY2LjI1MS03My4xMTdjLTEwOS42LDAtMTg4LjU0OSw5MC43MDItMTg4LjU0OSwyMDEuNzYydjEuODUyCgljMCwxMTEuMDY1LDc3LjA5LDIwMy42MjQsMTg4LjU0OSwyMDMuNjI0Yzc0LjMwMiwwLDExOS44MTItMjkuNjEzLDE3MC44OTgtNzUuODlMODEyLDczMS40MDMKCUM3NDUuMTI3LDgwMi42NjgsNjcwLjgyNCw4NDcuMTAzLDU0NS40MzcsODQ3LjEwM3oiLz4KPC9zdmc+Cg==",
    Apple: "data:image/svg+xml;base64,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"
  },
      Lc = _["default"](fe).attrs(function () {
    return {
      bg: "white",
      color: "black",
      display: "flex",
      width: "calc(3rem - 2px)",
      alignItems: "center",
      justifyContent: "center",
      my: ["calc(-0.5rem + 2px)", null, "calc(-1rem + 2px)"],
      ml: ["calc(-1rem + 2px)", null, "calc(-2rem + 2px)"]
    };
  }).withConfig({
    displayName: "SSOButton__IconBox",
    componentId: "sc-hb1cd1-0"
  })(["border-top-left-radius:2px;border-bottom-left-radius:2px;margin-top:calc(", " + 2px);margin-bottom:calc( ", " + 2px );margin-left:calc(", " + 2px);", ";"], function (e) {
    return e.adaptive ? " -0.5rem" : "-1rem";
  }, function (e) {
    return e.adaptive ? " -0.5rem" : "-1rem";
  }, function (e) {
    return e.adaptive ? " -1rem" : "-2rem";
  }, wc.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    margin-top: calc(-1rem + 2px);\n    margin-bottom: calc(-1rem + 2px);\n    margin-left: calc(-2rem + 2px);\n  "]))));

  function Dc(e) {
    var t = e.type,
        n = e.url,
        r = e.children,
        o = e.adaptive,
        i = _objectWithoutProperties(e, _excluded2);

    return s.jsxs(js, _objectSpread(_objectSpread({
      display: "flex",
      as: "a",
      href: n,
      width: 1,
      adaptive: o
    }, i), {}, {
      children: [s.jsx(Lc, {
        adaptive: o,
        children: s.jsx(he, {
          src: Sc[t],
          width: "1.5rem",
          alt: "".concat(t, " logo")
        })
      }), s.jsx(ys, {
        as: "span",
        flex: "1",
        textAlign: "center",
        mr: -4,
        pl: [0, null, 3],
        pr: 3,
        children: r
      })]
    }));
  }

  Dc.defaultProps = {
    adaptive: !1
  }, Dc.propTypes = {
    adaptive: T["default"].bool,
    children: T["default"].node.isRequired,
    type: T["default"].oneOf(["Google", "Clever", "Apple"]).isRequired,
    url: T["default"].string.isRequired
  };

  var Ac = {
    Google: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjEuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IlNTT19Hb29nbGVfTG9nbyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiCgkgdmlld0JveD0iMCAwIDU0NC4zMTggNTQ0LjMxOCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTQ0LjMxOCA1NDQuMzE4OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6IzQyODVGNDt9Cgkuc3Qxe2ZpbGw6IzM0QTg1Mzt9Cgkuc3Qye2ZpbGw6I0ZCQkMwNDt9Cgkuc3Qze2ZpbGw6I0VBNDMzNTt9Cjwvc3R5bGU+CjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik01MzguOTM0LDI3OC40MThjMC0xOC41LTEuNS0zNy4xLTQuNy01NS4zaC0yNTYuN3YxMDQuOGgxNDdjLTYuMSwzMy44LTI1LjcsNjMuNy01NC40LDgyLjd2NjhoODcuNwoJQzUwOS4zMzQsNDMxLjIxOCw1MzguOTM0LDM2MS4yMTgsNTM4LjkzNCwyNzguNDE4TDUzOC45MzQsMjc4LjQxOHoiLz4KPHBhdGggY2xhc3M9InN0MSIgZD0iTTI3Ny41MzQsNTQ0LjMxOGM3My40LDAsMTM1LjMtMjQuMSwxODAuNC02NS43bC04Ny43LTY4Yy0yNC40LDE2LjYtNTUuOSwyNi05Mi42LDI2CgljLTcxLDAtMTMxLjItNDcuOS0xNTIuOC0xMTIuM2gtOTAuNXY3MC4xQzgwLjUzNCw0ODYuMzE4LDE3NC42MzQsNTQ0LjMxOCwyNzcuNTM0LDU0NC4zMTh6Ii8+CjxwYXRoIGNsYXNzPSJzdDIiIGQ9Ik0xMjQuNzM0LDMyNC4zMThjLTExLjQtMzMuOC0xMS40LTcwLjQsMC0xMDQuMnYtNzAuMWgtOTAuNGMtMzguNiw3Ni45LTM4LjYsMTY3LjUsMCwyNDQuNEwxMjQuNzM0LDMyNC4zMTh6Ii8+CjxwYXRoIGNsYXNzPSJzdDMiIGQ9Ik0yNzcuNTM0LDEwNy43MThjMzguOC0wLjYsNzYuMywxNCwxMDQuNCw0MC44bDc3LjctNzcuN2MtNDkuMi00Ni4yLTExNC41LTcxLjYtMTgyLjEtNzAuOAoJYy0xMDIuOSwwLTE5Nyw1OC0yNDMuMiwxNTBsOTAuNCw3MC4xQzE0Ni4yMzQsMTU1LjYxOCwyMDYuNTM0LDEwNy43MTgsMjc3LjUzNCwxMDcuNzE4eiIvPgo8L3N2Zz4K",
    Clever: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjEuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkNsZXZlcl9TU09fTG9nbyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiCgkgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMTAyNCAxMDI0OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkO2ZpbGw6IzQyNzRGNjt9Cjwvc3R5bGU+CjxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgo8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMTAwNi41MDcsMTQ3LjQ4MmMtMjEuOTktNjAuNDE2LTY5LjU3Mi0xMDcuOTk4LTEyOS45ODgtMTI5Ljk4OEM4MjEuMTgsMCw3NjkuNzkyLDAsNjY2Ljk5MSwwSDM1Ny4wMDkKCUMyNTQuMjA4LDAsMjAyLjgxMiwwLDE0Ny40ODIsMTcuNDkzQzg3LjA2NiwzOS40ODQsMzkuNDg0LDg3LjA2NiwxNy40OTMsMTQ3LjQ4MkMwLDIwMi44MTIsMCwyNTQuMjE3LDAsMzU3LjAwOXYzMDkuOTgyCglDMCw3NjkuNzkyLDAsODIxLjE4LDE3LjQ5Myw4NzYuNTE4YzIxLjk5LDYwLjQxNiw2OS41NzIsMTA3Ljk5OCwxMjkuOTg4LDEyOS45OEMyMDIuODEyLDEwMjQsMjU0LjIwOCwxMDI0LDM1Ny4wMDksMTAyNGgzMDkuOTgyCgljMTAyLjgwMSwwLDE1NC4xODksMCwyMDkuNTI3LTE3LjUwMmM2MC40MTYtMjEuOTgyLDEwNy45OTgtNjkuNTY0LDEyOS45ODgtMTI5Ljk4QzEwMjQsODIxLjE4LDEwMjQsNzY5Ljc5MiwxMDI0LDY2Ni45OTFWMzU3LjAwOQoJQzEwMjQsMjU0LjIxNywxMDI0LDIwMi44MTIsMTAwNi41MDcsMTQ3LjQ4MnogTTU0NS40MzcsODQ3LjEwM0MzNTQuMTA1LDg0Ny4xMDMsMjEyLDY5OS45MzMsMjEyLDUxMy45MDR2LTEuODU3CglDMjEyLDMyNy44NiwzNTEuMzIyLDE3Nyw1NTEuMDEyLDE3N2MxMjIuNiwwLDE5NS45NzMsNDAuNzI2LDI1Ni4zNDEsOTkuOTU3TDcxNi4zMzQsMzgxLjU1CgljLTUwLjE1Ni00NS4zNTEtMTAxLjIzNy03My4xMTctMTY2LjI1MS03My4xMTdjLTEwOS42LDAtMTg4LjU0OSw5MC43MDItMTg4LjU0OSwyMDEuNzYydjEuODUyCgljMCwxMTEuMDY1LDc3LjA5LDIwMy42MjQsMTg4LjU0OSwyMDMuNjI0Yzc0LjMwMiwwLDExOS44MTItMjkuNjEzLDE3MC44OTgtNzUuODlMODEyLDczMS40MDMKCUM3NDUuMTI3LDgwMi42NjgsNjcwLjgyNCw4NDcuMTAzLDU0NS40MzcsODQ3LjEwM3oiLz4KPC9zdmc+Cg==",
    Apple: "data:image/svg+xml;base64,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"
  },
      Nc = _["default"](fe).attrs(function () {
    return {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      my: ["calc(-0.5rem + 2px)", null, "calc(-1rem + 2px)"]
    };
  }).withConfig({
    displayName: "SSOButtonLight__IconBox",
    componentId: "sc-1tr7tqi-0"
  })(["width:'calc(3rem - 2px)';"]),
      Ic = _["default"](Ms).withConfig({
    displayName: "SSOButtonLight__SSOButton",
    componentId: "sc-1tr7tqi-1"
  })(["background-image:unset;display:flex;justify-content:center;align-items:center;box-shadow:inset 0 0 0 0 ", ";transition:0.3s ease-out;color:black;border:solid 1px;border-color:", ";&:hover,&:focus{box-shadow:inset 0 0 0 2px ", ";}&:focus-visible{box-shadow:0 0 0 2px ", ",0 0 0 4px ", ";z-index:1;}&:focus{outline:none;}"], function (e) {
    return e.theme.colors.black;
  }, function (e) {
    return e.theme.colors.gray600;
  }, function (e) {
    return e.theme.colors.gray600;
  }, function (e) {
    return e.theme.colors.white;
  }, function (e) {
    return e.theme.colors.blue700;
  });

  function zc(e) {
    var t = e.type,
        n = e.url,
        r = e.children,
        o = e.adaptive,
        i = _objectWithoutProperties(e, _excluded3);

    return s.jsxs(Ic, _objectSpread(_objectSpread({
      bg: "white",
      border: "solid 1px",
      width: 1,
      borderRadius: "rounded",
      py: 3,
      px: 4,
      as: "a",
      href: n,
      adaptive: o
    }, i), {}, {
      children: [s.jsx(Nc, {
        adaptive: o,
        children: s.jsx(he, {
          src: Ac[t],
          width: "1.5rem",
          alt: "".concat(t, " logo")
        })
      }), s.jsx(ys, {
        as: "span",
        textAlign: "center",
        mr: -2,
        pl: 3,
        pr: 3,
        children: r
      })]
    }));
  }

  zc.defaultProps = {
    adaptive: !1
  }, zc.propTypes = {
    adaptive: T["default"].bool,
    children: T["default"].node.isRequired,
    type: T["default"].oneOf(["Google", "Clever", "Apple"]).isRequired,
    url: T["default"].string.isRequired
  };

  var Oc = _["default"](fe).withConfig({
    displayName: "LoadingSpinner__SpinContainer",
    componentId: "sc-4y0dec-0"
  })(["height:1.5ch;width:1.5ch;display:inline-flex;align-items:center;justify-content:center;"]),
      Rc = _["default"].svg.withConfig({
    displayName: "LoadingSpinner__SpinSvg",
    componentId: "sc-4y0dec-1"
  })(["fill:currentColor;", ";"], K("1200ms"));

  function Pc(e) {
    return s.jsx(Oc, _objectSpread(_objectSpread({}, e), {}, {
      children: s.jsx(Rc, {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        style: {
          fill: "currentColor"
        },
        children: s.jsx("path", {
          d: "M296 48c0 22.091-17.909 40-40 40s-40-17.909-40-40 17.909-40 40-40 40 17.909 40 40zm-40 376c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm248-168c0-22.091-17.909-40-40-40s-40 17.909-40 40 17.909 40 40 40 40-17.909 40-40zm-416 0c0-22.091-17.909-40-40-40S8 233.909 8 256s17.909 40 40 40 40-17.909 40-40zm20.922-187.078c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40c0-22.092-17.909-40-40-40zm294.156 294.156c-22.091 0-40 17.909-40 40s17.909 40 40 40c22.092 0 40-17.909 40-40s-17.908-40-40-40zm-294.156 0c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40z"
        })
      })
    }));
  }

  function Fc(e) {
    var t = e.loading,
        n = e.disabled,
        r = e.children,
        o = e.icon,
        i = _objectWithoutProperties(e, _excluded4);

    return s.jsxs(js, _objectSpread(_objectSpread({
      disabled: t || n
    }, i), {}, {
      children: [r, t && s.jsx(Pc, {
        ml: 2
      }), !t && o && s.jsx(mc, {
        pl: 2,
        icon: o
      })]
    }));
  }

  Fc.defaultProps = {
    loading: !1,
    disabled: !1,
    icon: null
  }, Fc.propTypes = {
    children: T["default"].node.isRequired,
    icon: T["default"].string,
    loading: T["default"].bool,
    disabled: T["default"].bool
  };

  var Bc = t.keyframes(["0%{opacity:1;}20%{opacity:0;}21%{opacity:1;}80%{opacity:0;}81%{opacity:1;}85%{opacity:0;}86%{opacity:1;}100%{opacity:1;}"]),
      qc = _["default"].path.withConfig({
    displayName: "YumiBasic__Mouth",
    componentId: "sc-16dj172-0"
  })(["", ""], function (e) {
    return e.sad && "transform: scaleY(-1); transform-origin: 50% 60.5%;";
  }),
      Uc = _["default"].circle.withConfig({
    displayName: "YumiBasic__Eye",
    componentId: "sc-16dj172-1"
  })(["", ""], function (e) {
    return e.blink && t.css(["animation:", " 10s steps(1) forwards infinite;"], Bc);
  });

  function Vc(e) {
    var t = e.blink,
        n = e.sad,
        r = e.width,
        o = _objectWithoutProperties(e, _excluded5);

    return s.jsxs(ms, _objectSpread(_objectSpread({
      version: "1.1",
      id: "waving-bear",
      xmlns: "http://www.w3.org/2000/svg",
      x: "0px",
      y: "0px",
      viewBox: "0 0 165 240",
      width: r
    }, o), {}, {
      children: [s.jsx("path", {
        id: "bear-head",
        fill: "#fffef0",
        d: "M137.2,0c-15.1,0-27.4,12.3-27.4,27.4c0,0.1,0,0.3,0,0.4c-8.6-3-17.8-4.7-27.5-4.7 c-9.6,0-18.9,1.7-27.5,4.7c0-0.1,0-0.3,0-0.4C54.9,12.3,42.6,0,27.4,0S0,12.3,0,27.4V174v76h164.6v-63.1V27.4 C164.6,12.3,152.3,0,137.2,0z"
      }), s.jsxs("g", {
        id: "bear-face",
        children: [s.jsx(qc, {
          sad: n,
          d: "M82.2,147.1c-4.7,0-8.5-3.8-8.5-8.5l2,0c0,3.6,2.9,6.5,6.5,6.5c3.6,0,6.5-2.9,6.5-6.5l2,0 C90.7,143.3,86.9,147.1,82.2,147.1z"
        }), s.jsx("path", {
          d: "M101.2,105.7c0,8.6-8.5,15.5-18.9,15.4c-10.4,0-18.9-7-18.8-15.6c0-8.6,8.5-15.5,18.9-15.4 C92.8,90.2,101.2,97.2,101.2,105.7z"
        }), s.jsx("rect", {
          x: "62.3",
          y: "124.5",
          transform: "matrix(2.940183e-03 -1 1 2.940183e-03 -43.4222 207.3775)",
          width: "40",
          height: "2"
        })]
      }), s.jsxs("g", {
        id: "bear-eyes",
        children: [s.jsx(Uc, {
          blink: t,
          cx: "116.9",
          cy: "84.5",
          r: "8.8"
        }), s.jsx(Uc, {
          blink: t,
          cx: "47.7",
          cy: "84.5",
          r: "8.8"
        })]
      }), s.jsxs("g", {
        id: "bear-wink",
        children: [s.jsx("path", {
          d: "M54.5,84c0,0.2,0,0.3,0,0.5c0,3.7-3,6.8-6.8,6.8c-3.7,0-6.8-3-6.8-6.8c0-0.2,0-0.3,0-0.5h-2c0,0.2,0,0.3,0,0.5 c0,4.9,3.9,8.8,8.8,8.8c4.8,0,8.8-3.9,8.8-8.8c0-0.2,0-0.3,0-0.5H54.5z"
        }), s.jsx("path", {
          d: "M123.6,84c0,0.2,0,0.3,0,0.5c0,3.7-3,6.8-6.8,6.8c-3.7,0-6.8-3-6.8-6.8c0-0.2,0-0.3,0-0.5h-2c0,0.2,0,0.3,0,0.5 c0,4.9,3.9,8.8,8.8,8.8c4.8,0,8.8-3.9,8.8-8.8c0-0.2,0-0.3,0-0.5H123.6z"
        })]
      })]
    }));
  }

  Vc.defaultProps = {
    blink: !1,
    sad: !1,
    width: 1
  }, Vc.propTypes = {
    blink: T["default"].bool,
    sad: T["default"].bool,
    width: T["default"].number
  };

  var Hc = .5,
      Zc = _["default"](fe).attrs(function () {
    return {
      mx: "auto",
      px: ["1rem", null, null, "2rem"]
    };
  }).withConfig({
    displayName: "flexGrid__Container",
    componentId: "sc-1dtn1s7-0"
  })(["body:not(.matchLexis) &{", ";", ";", ";}body.matchLexis &{padding-left:", "rem;padding-right:", "rem;@media screen and (min-width:768px){max-width:750px;}@media screen and (min-width:992px){max-width:970px;padding-left:", "rem;padding-right:", "rem;}@media screen and (min-width:1200px){max-width:1170px;}}"], wc.md(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["max-width: 56rem"]))), wc.lg(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["max-width: 68rem"]))), wc.xl(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["max-width: 72rem"]))), 1, 1, Hc, Hc);

  Zc.displayName = "Container";

  var Wc = _["default"](fe).attrs(function (e) {
    return {
      display: e.display || "flex",
      flexWrap: e.flexWrap || "wrap",
      ml: e.ml || e.mx || "-0.5rem",
      mr: e.mr || e.mx || "-0.5rem"
    };
  }).withConfig({
    displayName: "flexGrid__Columns",
    componentId: "sc-1dtn1s7-1"
  })([""]);

  Wc.displayName = "Columns";

  var $c = _["default"](fe).attrs(function (e) {
    return {
      pl: e.pl || e.px || "0.5rem",
      pr: e.pr || e.px || "0.5rem",
      width: e.width || "auto"
    };
  }).withConfig({
    displayName: "flexGrid__Col",
    componentId: "sc-1dtn1s7-2"
  })([""]);

  $c.displayName = "Col";

  var Gc = _["default"](hs).attrs({
    variants: {
      hidden: {
        opacity: 0
      },
      show: {
        opacity: 1,
        transition: {
          delayChildren: .25,
          staggerChildren: .125
        }
      }
    },
    initial: "hidden",
    animate: "show"
  }).withConfig({
    displayName: "AnimatedGrid__AnimatedColumnsContainer",
    componentId: "sc-3pvgmo-0"
  })([""]),
      Yc = Ja(Wc),
      Qc = _["default"](Yc).attrs({
    variants: {
      hidden: {
        opacity: 0
      },
      show: {
        opacity: 1
      }
    }
  }).withConfig({
    displayName: "AnimatedGrid__AnimatedColumns",
    componentId: "sc-3pvgmo-1"
  })([""]),
      Xc = _["default"](Tc).attrs(function () {
    return {
      icon: "bars",
      mt: 1,
      ml: 1
    };
  }).withConfig({
    displayName: "Sidebar__SidebarButton",
    componentId: "sc-1epr843-0"
  })(["pointer-events:", ";opacity:", ";"], function (e) {
    return e.open ? "none" : "auto";
  }, function (e) {
    return e.open ? 0 : 1;
  }),
      Kc = {
    open: {
      x: 0,
      width: "auto",
      opacity: 1
    },
    closed: {
      x: "-100vw",
      width: 0,
      opacity: 0
    }
  },
      Jc = _["default"](hs).attrs(function (e) {
    return {
      variants: e.variants || Kc,
      transition: {
        type: "spring",
        stiffness: 400,
        damping: 25,
        mass: .5
      },
      initial: !1,
      display: "block",
      overflow: "hidden",
      position: "relative",
      boxShadow: 2
    };
  }).withConfig({
    displayName: "Sidebar__SidebarWrapper",
    componentId: "sc-1epr843-1"
  })([""]);

  Jc.displayName = "MenuWrapper";

  var eu = _["default"](fe).attrs(function () {
    return {
      as: "nav",
      display: "flex",
      flexDirection: "column",
      width: ["100vw", null, null, "320px", "375px"],
      height: "100%"
    };
  }).withConfig({
    displayName: "Sidebar__SidebarBody",
    componentId: "sc-1epr843-2"
  })([""]);

  eu.displayName = "MenuBody";

  var tu = _["default"].div.withConfig({
    displayName: "SidebarGrid",
    componentId: "sc-15nbrq-0"
  })(["display:grid;grid-template-columns:auto minmax(0,1fr);grid-template-rows:1fr;width:100vw;position:relative;overflow:hidden;"]);

  tu.displayName = "SidebarGrid";

  var nu = _["default"](Ss).attrs(function () {
    return {
      py: 3,
      px: 0,
      textAlign: "left"
    };
  }).withConfig({
    displayName: "SidebarItem__MenuButton",
    componentId: "sc-d2x695-0"
  })(["flex-shrink:0;background:white;&:hover{background:", ";}&:focus{outline:none;}"], function (e) {
    return e.theme.colors.gray100;
  }),
      ru = Ja(mc);

  function ou(e) {
    var t = e.children,
        n = e.isCloseButton,
        r = e.icon,
        o = e.isOpen,
        i = e.label,
        a = _objectWithoutProperties(e, _excluded6);

    return s.jsxs(s.Fragment, {
      children: [s.jsx(nu, _objectSpread(_objectSpread({}, a), {}, {
        children: s.jsxs(fe, {
          display: "flex",
          alignItems: "center",
          px: [3, null, null, 4],
          color: o ? "blue700" : "black",
          children: [s.jsx(fe, {
            width: "2rem",
            children: s.jsx(mc, {
              icon: n ? "bars" : r,
              position: "relative",
              top: ["1px", null, null, null, "2px"]
            })
          }), s.jsx(ys, {
            display: "inline-block",
            as: "span",
            fontWeight: "600",
            mr: 2,
            children: i
          }), !n && s.jsx(ru, {
            icon: "chevron-down",
            animate: {
              rotate: o ? 180 : 0
            },
            ml: "auto"
          })]
        })
      })), t && s.jsx(hs, {
        animate: {
          height: o ? "100%" : 0
        },
        initial: !1,
        as: "section",
        overflowY: o ? "scroll" : "hidden",
        transition: {
          type: "tween",
          duration: .2
        },
        bg: "gray50",
        px: [3, null, null, 4],
        fontSize: 0,
        boxShadow: "inset 0 2px 4px -2px rgba(0,0,0,0.1)",
        children: t
      })]
    });
  }

  function iu(e) {
    var t = e.size,
        n = _objectWithoutProperties(e, _excluded7);

    return s.jsxs(ms, _objectSpread(_objectSpread({
      width: t,
      height: t,
      viewBox: "0 0 32 32",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg"
    }, n), {}, {
      children: [s.jsx("title", {
        children: "Pause icon"
      }), s.jsx("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        children: s.jsxs("g", {
          fill: "currentColor",
          children: [s.jsx("circle", {
            cx: "16",
            cy: "4",
            r: "2"
          }), s.jsx("circle", {
            cx: "16",
            cy: "28",
            r: "2"
          }), s.jsx("circle", {
            cx: "7",
            cy: "24",
            r: "2"
          }), s.jsx("circle", {
            cx: "4",
            cy: "16",
            r: "2"
          }), s.jsx("circle", {
            cx: "28",
            cy: "16",
            r: "2"
          }), s.jsx("circle", {
            cx: "24",
            cy: "7",
            r: "2"
          }), s.jsx("circle", {
            cx: "25",
            cy: "24",
            r: "2"
          })]
        })
      })]
    }));
  }

  function au(e) {
    var t = e.color,
        n = e.size,
        r = _objectWithoutProperties(e, _excluded8);

    return s.jsxs(ms, _objectSpread(_objectSpread({
      color: t,
      width: n,
      height: n,
      viewBox: "0 0 16 20",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg"
    }, r), {}, {
      children: [s.jsx("title", {
        children: "Pause icon"
      }), s.jsx("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        children: s.jsxs("g", {
          fill: "currentColor",
          children: [s.jsx("rect", {
            x: "0",
            y: "0",
            width: "6",
            height: "20",
            rx: "2"
          }), s.jsx("rect", {
            x: "10",
            y: "0",
            width: "6",
            height: "20",
            rx: "2"
          })]
        })
      })]
    }));
  }

  function su(e) {
    var t = e.color,
        n = e.size,
        r = _objectWithoutProperties(e, _excluded9);

    return s.jsxs(ms, _objectSpread(_objectSpread({
      color: t,
      width: n,
      height: n,
      viewBox: "0 0 18 20",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg"
    }, r), {}, {
      children: [s.jsx("title", {
        children: "Play icon"
      }), s.jsx("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        children: s.jsx("g", {
          fill: "currentColor",
          children: s.jsx("path", {
            d: "m17.21878,10.75767l-15.32676,8.66338c-1.04493,0.52247 -1.89202,-0.00209 -1.89202,-1.15535l0,-16.90808c0,-1.16055 0.85372,-1.6745 1.89202,-1.15535l15.32676,8.66338c1.04494,0.52247 1.03831,1.37287 0,1.89202z"
          })
        })
      })]
    }));
  }

  ou.defaultProps = {
    children: null,
    isCloseButton: !1,
    icon: null,
    isOpen: !1
  }, ou.propTypes = {
    children: T["default"].node,
    isCloseButton: T["default"].bool,
    icon: T["default"].string,
    isOpen: T["default"].bool,
    label: T["default"].string.isRequired
  }, iu.defaultProps = {
    size: "32px"
  }, au.defaultProps = {
    size: "32px"
  }, su.defaultProps = {
    size: "32px"
  };
  var lu = gc.colors;

  function cu(e) {
    var t = e.size,
        n = _objectWithoutProperties(e, _excluded10);

    return s.jsxs(ms, _objectSpread(_objectSpread({
      size: t,
      version: "1.1",
      viewBox: "0 0 66 66",
      xmlns: "http://www.w3.org/2000/svg"
    }, n), {}, {
      children: [s.jsx("title", {
        children: "Illustration of an open book"
      }), s.jsx("path", {
        fill: lu.yellow500,
        d: "M33.77,65.81c9.75-.59,17.68-2,25-9.83h0c5.52-5.95,7.9-14.13,7.9-22.12,0-7.57-3.12-16-7.5-22.27C53.11,3,43.89,1,33.8,1h0C27.52,1,21.48,3.9,15.94,6.39c-5.39,2.42-10.18,7.82-12.81,13h0C.78,24.05.06,30.54.49,35.64c.59,7,.59,11.38,5.48,17,6.55,7.48,15.27,13.85,25.52,13.34l2.28-.13",
        transform: "translate(-0.37 -1.03)"
      }), s.jsx("polygon", {
        fill: lu.white,
        stroke: lu.white,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        points: "52.6 44.05 33.2 50.88 13.8 44.05 13.8 18.55 33.2 25.39 52.6 18.55 52.6 44.05"
      }), s.jsx("line", {
        fill: "none",
        stroke: lu.black,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        x1: "33.2",
        y1: "25.39",
        x2: "33.2",
        y2: "50.88"
      }), s.jsx("line", {
        fill: "none",
        stroke: lu.black,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        x1: "38.09",
        y1: "30.01",
        x2: "48.38",
        y2: "26.38"
      }), s.jsx("line", {
        fill: "none",
        stroke: lu.black,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        x1: "38.09",
        y1: "34.36",
        x2: "48.38",
        y2: "30.73"
      }), s.jsx("line", {
        fill: "none",
        stroke: lu.black,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        x1: "38.09",
        y1: "38.7",
        x2: "48.38",
        y2: "35.08"
      }), s.jsx("line", {
        fill: "none",
        stroke: lu.black,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        x1: "38.09",
        y1: "43.05",
        x2: "48.38",
        y2: "39.43"
      }), s.jsx("line", {
        fill: "none",
        stroke: lu.black,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        x1: "28.31",
        y1: "30.01",
        x2: "18.02",
        y2: "26.38"
      }), s.jsx("line", {
        fill: "none",
        stroke: lu.black,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        x1: "28.31",
        y1: "34.36",
        x2: "18.02",
        y2: "30.73"
      }), s.jsx("line", {
        fill: "none",
        stroke: lu.black,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        x1: "28.31",
        y1: "38.7",
        x2: "18.02",
        y2: "35.08"
      }), s.jsx("line", {
        fill: "none",
        stroke: lu.black,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        x1: "28.31",
        y1: "43.05",
        x2: "18.02",
        y2: "39.43"
      })]
    }));
  }

  cu.defaultProps = {
    size: 66
  }, cu.propTypes = {
    size: T["default"].oneOfType([T["default"].array, T["default"].number, T["default"].string])
  };
  var uu = gc.colors;

  function du(e) {
    var t = e.size,
        n = _objectWithoutProperties(e, _excluded11);

    return s.jsxs(ms, _objectSpread(_objectSpread({
      size: t,
      version: "1.1",
      viewBox: "0 0 42.47 41.62",
      xmlns: "http://www.w3.org/2000/svg"
    }, n), {}, {
      children: [s.jsx("title", {
        children: "Illustration of an ear listening to sound"
      }), s.jsx("path", {
        fill: uu.yellow500,
        d: "M21.41,41.52c6.24-.38,11.33-1.27,16-6.3h0c3.54-3.81,5.07-9.06,5.07-14.18A26.31,26.31,0,0,0,37.66,6.77C33.8,1.26,27.89,0,21.42,0h0C17.4,0,13.53,1.84,10,3.44a18.56,18.56,0,0,0-8.21,8.34h0A20.73,20.73,0,0,0,.08,22.18c.37,4.47.37,7.29,3.51,10.87,4.2,4.8,9.79,8.88,16.35,8.55l1.47-.08"
      }), s.jsx("path", {
        fill: uu.white,
        stroke: uu.white,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M25.23,9.26a6,6,0,0,0-5.13.05c-2,1-2.69,3.27-3.31,5.27a22.58,22.58,0,0,0-1.4,7.79,10.39,10.39,0,0,0,1.28,4.86c.81,1.28,2.12,2,3.28,2.85a11.34,11.34,0,0,1,2.35,3,3.72,3.72,0,0,0,3.45,1.42,4.23,4.23,0,0,0,1.9-.62c2.48-1.57,2.73-4.62,2.6-7.28-.06-1.44.29-3.16-.17-4.54s-1.34-2.17-1.34-3.6c0-1.17.55-2.26.49-3.46A7,7,0,0,0,25.23,9.26Z"
      }), s.jsx("path", {
        fill: "none",
        stroke: uu.black,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M18.9,25.46c-.16-1-.59-1.25-1-2-.87-1.7-.45-3.47.15-5.17.41-1.16.85-2.32,1.25-3.46a5.17,5.17,0,0,1,1.38-2.62c.86-.75,2.27-.62,3.33-.38a3.16,3.16,0,0,1,2.22,1.7,6.49,6.49,0,0,1,.16,4.41c-.34,1.18-.91,2.53-2.36,2.62"
      }), s.jsx("path", {
        fill: "none",
        stroke: uu.black,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M27.51,22.28c-1.2.28,0,1.93-.22,2.73-.18.57-.71.82-.47,1.37s.75.74.9,1.33c.42,1.69-1.23,1.23-2,.38a6.26,6.26,0,0,1-.94-1.7c-.69-1.36-3.12-1.76-4.22-2.83-.88-.86-.83-2.15-.83-3.31a2.78,2.78,0,0,1,2.35-2.83c1.52-.36,3.36.46,4.59-.78"
      }), s.jsx("line", {
        fill: "none",
        stroke: uu.black,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        x1: "9.99",
        y1: "12.67",
        x2: "14.38",
        y2: "16.01"
      }), s.jsx("line", {
        fill: "none",
        stroke: uu.black,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        x1: "13.49",
        y1: "18.61",
        x2: "6.49",
        y2: "18.04"
      }), s.jsx("line", {
        fill: "none",
        stroke: uu.black,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        x1: "13.5",
        y1: "21.54",
        x2: "8.56",
        y2: "23.44"
      })]
    }));
  }

  du.defaultProps = {
    size: 66
  }, du.propTypes = {
    size: T["default"].oneOfType([T["default"].array, T["default"].number, T["default"].string])
  };
  var fu = gc.colors;

  function pu(e) {
    var t = e.size,
        n = _objectWithoutProperties(e, _excluded12);

    return s.jsxs(ms, _objectSpread(_objectSpread({
      size: t,
      version: "1.1",
      viewBox: "0 0 42.47 41.63",
      xmlns: "http://www.w3.org/2000/svg"
    }, n), {}, {
      children: [s.jsx("title", {
        children: "Asset 33"
      }), s.jsx("g", {
        id: "Layer_2",
        "data-name": "Layer 2",
        children: s.jsxs("g", {
          id: "Layer_3",
          "data-name": "Layer 3",
          children: [s.jsx("path", {
            fill: fu.yellow500,
            d: "M21.55,41.52c6.24-.42,11.32-1.35,16-6.41h0c3.51-3.83,5-9.09,5-14.21a26.34,26.34,0,0,0-4.9-14.24C33.67,1.18,27.76,0,21.29,0h0c-4,0-7.88,1.89-11.42,3.51a18.68,18.68,0,0,0-8.16,8.4h0A20.85,20.85,0,0,0,.09,22.32c.41,4.47.43,7.29,3.58,10.85C7.9,37.94,13.52,42,20.09,41.61l1.46-.09"
          }), s.jsx("line", {
            fill: "none",
            stroke: fu.black,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            x1: "11.85",
            y1: "28.84",
            x2: "16.49",
            y2: "28.84"
          }), s.jsx("line", {
            fill: "none",
            stroke: fu.black,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            x1: "18.91",
            y1: "28.84",
            x2: "23.56",
            y2: "28.84"
          }), s.jsx("line", {
            fill: "none",
            stroke: fu.black,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            x1: "25.98",
            y1: "28.84",
            x2: "30.62",
            y2: "28.84"
          }), s.jsx("line", {
            fill: "none",
            stroke: fu.black,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            x1: "29.76",
            y1: "16.19",
            x2: "32.04",
            y2: "14.45"
          }), s.jsx("line", {
            fill: "none",
            stroke: fu.black,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            x1: "28.21",
            y1: "14.45",
            x2: "30.38",
            y2: "12.63"
          }), s.jsx("line", {
            fill: "none",
            stroke: fu.black,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            x1: "26.85",
            y1: "12.89",
            x2: "28.62",
            y2: "10.88"
          }), s.jsx("path", {
            fill: fu.white,
            stroke: fu.white,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M29.76,16.19s-3.88,5.3-8.67,5.3-8.66-5.3-8.66-5.3,3.88-5.31,8.66-5.31S29.76,16.19,29.76,16.19Z"
          }), s.jsx("circle", {
            fill: fu.yellow500,
            cx: "21.09",
            cy: "16.19",
            r: "4.99"
          }), s.jsx("circle", {
            stroke: fu.black,
            fill: fu.black,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            cx: "21.09",
            cy: "16.19",
            r: "1.74"
          }), s.jsx("circle", {
            fill: fu.white,
            stroke: fu.white,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            cx: "19.71",
            cy: "15.07",
            r: "0.68"
          })]
        })
      })]
    }));
  }

  pu.defaultProps = {
    size: 66
  }, pu.propTypes = {
    size: T["default"].oneOfType([T["default"].array, T["default"].number, T["default"].string])
  };
  var hu = gc.colors;

  function mu(e) {
    var t = e.size,
        n = _objectWithoutProperties(e, _excluded13);

    return s.jsxs(ms, _objectSpread(_objectSpread({
      size: t,
      version: "1.1",
      viewBox: "0 0 98 96",
      xmlns: "http://www.w3.org/2000/svg"
    }, n), {}, {
      children: [s.jsx("path", {
        d: "M 49.346 95.769 C 63.642 94.846 75.402 92.769 86.24 81.231 C 94.311 72.462 98 60.231 98 48.462 C 98 37.154 93.388 24.692 86.932 15.462 C 77.939 3 64.334 0 49.346 0 C 40.122 0 31.129 4.154 23.059 7.846 C 15.219 11.308 8.071 19.385 4.151 27 C 0.692 33.923 -0.461 43.385 0.231 51 C 1.153 61.385 1.153 67.846 8.301 76.154 C 17.986 87.231 30.899 96.692 46.118 95.769 C 47.04 96 48.193 95.769 49.346 95.769",
        fill: hu.yellow500
      }), s.jsxs("g", {
        transform: "translate(27.901 19.615)",
        children: [s.jsx("path", {
          d: "M 34.127 56.769 L 7.609 56.538 C 3.459 56.538 0 53.077 0 48.692 L 0.231 7.846 C 0.231 3.462 3.689 0 8.071 0 L 33.896 0 C 38.508 0 42.198 3.692 42.198 8.308 L 41.967 48.923 C 41.967 53.308 38.508 56.769 34.127 56.769 Z",
          fill: hu.white,
          stroke: hu.white,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), s.jsx("path", {
          d: "M 11.068 47.308 L 31.591 47.308",
          fill: "transparent",
          stroke: hu.black,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })]
      }), s.jsx("path", {
        d: "M 58.569 41.308 L 47.962 59.769 C 47.732 60.231 47.271 60.462 46.809 60.462 C 45.887 60.462 45.195 59.538 45.426 58.615 L 48.193 46.846 L 41.045 46.846 C 40.122 46.846 39.431 46.154 39.661 45.231 L 41.506 30.692 C 41.506 30 42.198 29.538 42.889 29.538 L 51.652 29.538 C 52.574 29.538 53.266 30.462 53.035 31.385 L 50.499 39.231 L 57.416 39.231 C 58.339 39 59.031 40.154 58.569 41.308 Z",
        fill: "rgb(228,215,0)"
      })]
    }));
  }

  mu.defaultProps = {
    size: 66
  }, mu.propTypes = {
    size: T["default"].oneOfType([T["default"].array, T["default"].number, T["default"].string])
  };

  var gu = function gu(e, t, n) {
    return Array.isArray(e) ? e.map(function (e) {
      return null !== e && parseInt(e, 10) * (t / n);
    }) : parseInt(e, 10) * (t / n);
  },
      yu = gc.colors;

  function bu(e) {
    var t = e.width,
        n = _objectWithoutProperties(e, _excluded14);

    return s.jsxs(ms, _objectSpread(_objectSpread({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 17 22",
      width: t,
      height: gu(t, 22, 17)
    }, n), {}, {
      children: [s.jsx("path", {
        d: "M 14.036 19.881 L 5.868 19.819 C 5.868 19.819 5.263 18.074 4.537 17.45 C 3.872 16.827 2.601 16.079 2.601 16.079 L 2.662 2.992 C 2.662 1.496 3.872 0.249 5.324 0.312 L 14.096 0.374 C 15.548 0.374 16.758 1.62 16.698 3.116 L 16.637 17.201 C 16.698 18.635 15.488 19.881 14.036 19.881 Z",
        fill: "rgb(255,255,255)",
        strokeWidth: "0.57",
        stroke: yu.white,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), s.jsx("path", {
        d: "M 6.352 16.578 L 13.249 16.64",
        fill: "transparent",
        strokeWidth: "0.57",
        stroke: yu.black,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), s.jsx("path", {
        d: "M 13.854 9.286 C 13.854 11.093 12.826 12.652 11.434 13.337 C 10.95 13.586 10.406 13.025 9.801 13.025 C 9.135 13.025 8.53 13.524 7.986 13.212 C 6.655 12.465 5.808 10.969 5.808 9.286 C 5.808 7.977 6.352 6.669 7.683 6.295 C 8.47 6.045 8.833 6.419 9.498 6.544 C 10.406 6.731 11.192 5.983 12.1 6.232 C 12.886 6.482 13.431 7.292 13.673 8.04 C 13.794 8.476 13.854 8.912 13.854 9.286 Z",
        fill: yu.yellow500
      }), s.jsx("path", {
        d: "M 9.801 7.79 C 9.801 7.79 9.196 5.921 10.769 4.986",
        fill: "transparent",
        strokeWidth: "0.57",
        stroke: yu.black,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), s.jsx("path", {
        d: "M 9.075 3.739 C 9.619 4.113 9.74 5.048 9.74 5.048 C 9.74 5.048 8.893 5.422 8.288 5.11 C 7.744 4.737 7.623 3.739 7.623 3.739 C 7.623 3.739 8.47 3.365 9.075 3.739 Z",
        fill: "rgb(35,31,32)"
      }), s.jsx("path", {
        d: "M 8.651 7.603 C 8.651 7.603 9.801 8.04 11.011 7.603",
        fill: "transparent",
        strokeWidth: "0.57",
        stroke: yu.black,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), s.jsx("path", {
        d: "M 6.171 22 C 5.929 22 5.687 21.813 5.687 21.501 C 5.687 18.51 3.327 16.079 0.423 16.079 C 0.181 16.079 -0.06 15.892 -0.06 15.581 C -0.06 15.269 0.121 15.082 0.423 15.082 C 3.811 15.082 6.594 17.949 6.594 21.439 C 6.594 21.813 6.413 22 6.171 22 Z",
        fill: yu.black
      }), s.jsx("path", {
        d: "M 3.993 21.938 C 3.751 21.938 3.509 21.751 3.509 21.439 C 3.509 19.756 2.178 18.385 0.544 18.385 C 0.302 18.385 0.06 18.198 0.06 17.887 C 0.06 17.575 0.242 17.388 0.544 17.388 C 2.662 17.388 4.416 19.195 4.416 21.377 C 4.477 21.751 4.235 21.938 3.993 21.938 Z",
        fill: yu.black
      }), s.jsx("path", {
        d: "M 0.363 20.691 C 0.363 20.209 0.742 19.819 1.21 19.819 C 1.678 19.819 2.057 20.209 2.057 20.691 C 2.057 21.173 1.678 21.564 1.21 21.564 C 0.742 21.564 0.363 21.173 0.363 20.691 Z",
        fill: yu.black
      })]
    }));
  }

  bu.defaultProps = {
    width: 17
  }, bu.propTypes = {
    width: T["default"].oneOfType([T["default"].number, T["default"].array])
  };
  var vu = gc.colors;

  function xu(e) {
    var t = e.size,
        n = _objectWithoutProperties(e, _excluded15);

    return s.jsxs(ms, _objectSpread(_objectSpread({
      size: t,
      version: "1.1",
      viewBox: "0 0 42.47 41.62",
      xmlns: "http://www.w3.org/2000/svg"
    }, n), {}, {
      children: [s.jsx("title", {
        children: "Illustration of a card with letters on it"
      }), s.jsx("path", {
        fill: vu.yellow500,
        d: "M21.41,41.52c6.24-.38,11.33-1.27,16-6.3h0c3.54-3.81,5.07-9.06,5.07-14.18A26.31,26.31,0,0,0,37.66,6.77C33.8,1.26,27.89,0,21.42,0h0C17.4,0,13.53,1.84,10,3.44a18.56,18.56,0,0,0-8.21,8.34h0A20.73,20.73,0,0,0,.08,22.18c.37,4.47.37,7.29,3.51,10.87,4.2,4.8,9.79,8.88,16.35,8.55l1.47-.08"
      }), s.jsx("rect", {
        fill: vu.white,
        x: "9.73",
        y: "8.52",
        width: "19.45",
        height: "23.87",
        rx: "4.36",
        transform: "translate(-5.09 6.52) rotate(-16.86)"
      }), s.jsx("path", {
        fill: vu.black,
        d: "M19.17,17.63l3.67,4a1.12,1.12,0,0,1,.27.38c.06.2-.05.43-.32.69a1.07,1.07,0,0,1-.4.27.42.42,0,0,1-.29,0,.62.62,0,0,1-.2-.11l-.2-.21L21,21.85l-2.31.71-.15,1a1.81,1.81,0,0,1-.06.28.62.62,0,0,1-.1.2.43.43,0,0,1-.24.16,1.16,1.16,0,0,1-.49,0c-.37,0-.59-.18-.65-.38a1.11,1.11,0,0,1,0-.47L17.83,18a.77.77,0,0,1,.18-.39.88.88,0,0,1,.36-.24A.75.75,0,0,1,19.17,17.63Zm-.06,2.21-.2,1.3L20,20.8Z"
      }), s.jsx("path", {
        fill: vu.white,
        d: "M19.16,34.67A4.83,4.83,0,0,1,14.31,30l-.46-15.14a4.85,4.85,0,0,1,4.71-5l10.87-.32a4.83,4.83,0,0,1,4.85,4.71l.46,15.13a4.87,4.87,0,0,1-4.71,5Z"
      }), s.jsx("path", {
        fill: vu.yellow500,
        d: "M29.43,10a4.36,4.36,0,0,1,4.35,4.23l.46,15.14A4.35,4.35,0,0,1,30,33.84l-10.72.33h-.14a4.36,4.36,0,0,1-4.35-4.23L14.34,14.8a4.37,4.37,0,0,1,4.23-4.49L29.29,10h.14m0-1h-.17l-10.72.32A5.37,5.37,0,0,0,14.8,11a5.28,5.28,0,0,0-1.45,3.83L13.81,30a5.33,5.33,0,0,0,5.35,5.2h.17l10.72-.33a5.35,5.35,0,0,0,5.19-5.52l-.46-15.14A5.34,5.34,0,0,0,29.43,9Z"
      }), s.jsx("path", {
        fill: vu.yellow500,
        d: "M29.61,22.88A5.68,5.68,0,0,1,26.42,28c-.65.3-1.37-.41-2.13-.41s-1.68.65-2.4.26A5.72,5.72,0,0,1,19,22.84c0-1.68.71-3.34,2.5-3.82,1.07-.29,1.54.13,2.41.32,1.18.26,2.26-.69,3.43-.38a3.18,3.18,0,0,1,2.06,2.33A6,6,0,0,1,29.61,22.88Z"
      }), s.jsx("path", {
        fill: "none",
        stroke: vu.black,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M24.31,20.94a3.16,3.16,0,0,1,1.25-3.61"
      }), s.jsx("path", {
        fill: vu.black,
        stroke: "none",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M23.31,15.73a2.39,2.39,0,0,1,.86,1.67,2.39,2.39,0,0,1-1.88.05,2.42,2.42,0,0,1-.86-1.68A2.36,2.36,0,0,1,23.31,15.73Z"
      }), s.jsx("path", {
        fill: "none",
        stroke: vu.black,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M22.79,20.71a5,5,0,0,0,3.15,0"
      })]
    }));
  }

  xu.defaultProps = {
    size: 66
  }, xu.propTypes = {
    size: T["default"].oneOfType([T["default"].array, T["default"].number, T["default"].string])
  };
  var wu = gc.colors;

  function ku(e) {
    var t = e.size,
        n = _objectWithoutProperties(e, _excluded16);

    return s.jsxs(ms, _objectSpread(_objectSpread({
      size: t,
      version: "1.1",
      viewBox: "0 0 42.47 41.62",
      xmlns: "http://www.w3.org/2000/svg"
    }, n), {}, {
      children: [s.jsx("title", {
        children: "Illustration of a keyboard"
      }), s.jsx("defs", {
        children: s.jsx("clipPath", {
          id: "clipPath",
          children: s.jsx("path", {
            fill: wu.yellow500,
            d: "M21.41,41.52c6.24-.38,11.33-1.27,16-6.3h0c3.54-3.81,5.07-9.06,5.07-14.18A26.31,26.31,0,0,0,37.66,6.77C33.8,1.26,27.89,0,21.42,0h0C17.4,0,13.53,1.84,10,3.44a18.56,18.56,0,0,0-8.21,8.34h0A20.73,20.73,0,0,0,.08,22.18c.37,4.47.37,7.29,3.51,10.87,4.2,4.8,9.79,8.88,16.35,8.55l1.47-.08"
          })
        })
      }), s.jsx("path", {
        fill: wu.yellow500,
        d: "M21.41,41.52c6.24-.38,11.33-1.27,16-6.3h0c3.54-3.81,5.07-9.06,5.07-14.18A26.31,26.31,0,0,0,37.66,6.77C33.8,1.26,27.89,0,21.42,0h0C17.4,0,13.53,1.84,10,3.44a18.56,18.56,0,0,0-8.21,8.34h0A20.73,20.73,0,0,0,.08,22.18c.37,4.47.37,7.29,3.51,10.87,4.2,4.8,9.79,8.88,16.35,8.55l1.47-.08"
      }), s.jsxs("g", {
        clipPath: "url(#clipPath)",
        children: [s.jsx("path", {
          fill: "none",
          stroke: wu.black,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M20.84,13.9a2.56,2.56,0,0,0,.92-4.42c-1.31-1.09-3.23-.65-4.93-.68A5.69,5.69,0,0,1,11.75,6a5.89,5.89,0,0,1-.38-4"
        }), s.jsx("rect", {
          fill: wu.white,
          x: "6.98",
          y: "13.52",
          width: "28.92",
          height: "15.78",
          rx: "3.32"
        }), s.jsx("line", {
          fill: "none",
          stroke: wu.black,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          x1: "9.87",
          y1: "19.7",
          x2: "33.01",
          y2: "19.7"
        }), s.jsx("line", {
          fill: "none",
          stroke: wu.black,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          x1: "9.87",
          y1: "23.29",
          x2: "33.01",
          y2: "23.29"
        }), s.jsx("rect", {
          fill: "none",
          stroke: wu.black,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          x: "9.87",
          y: "16.09",
          width: "23.13",
          height: "10.64"
        }), s.jsx("line", {
          fill: "none",
          stroke: wu.black,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          x1: "13.25",
          y1: "16.21",
          x2: "13.25",
          y2: "26.73"
        }), s.jsx("line", {
          fill: "none",
          stroke: wu.black,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          x1: "16.48",
          y1: "16.21",
          x2: "16.48",
          y2: "26.73"
        }), s.jsx("line", {
          fill: "none",
          stroke: wu.black,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          x1: "19.71",
          y1: "16.21",
          x2: "19.71",
          y2: "23.26"
        }), s.jsx("line", {
          fill: "none",
          stroke: wu.black,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          x1: "22.94",
          y1: "16.21",
          x2: "22.94",
          y2: "23.26"
        }), s.jsx("line", {
          fill: "none",
          stroke: wu.black,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          x1: "26.17",
          y1: "16.21",
          x2: "26.17",
          y2: "26.73"
        }), s.jsx("line", {
          fill: "none",
          stroke: wu.black,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          x1: "29.39",
          y1: "16.21",
          x2: "29.39",
          y2: "26.73"
        })]
      })]
    }));
  }

  function Cu(e) {
    var t = e.size,
        n = _objectWithoutProperties(e, _excluded17);

    return s.jsxs(ms, _objectSpread(_objectSpread({
      size: t,
      version: "1.1",
      viewBox: "0 0 42.47 41.62",
      xmlns: "http://www.w3.org/2000/svg"
    }, n), {}, {
      children: [s.jsx("title", {
        children: "Illustration of a card with letters on it"
      }), s.jsx("path", {
        fill: gc.colors.yellow500,
        d: "M21.41,41.52c6.24-.38,11.33-1.27,16-6.3h0c3.54-3.81,5.07-9.06,5.07-14.18A26.31,26.31,0,0,0,37.66,6.77C33.8,1.26,27.89,0,21.42,0h0C17.4,0,13.53,1.84,10,3.44a18.56,18.56,0,0,0-8.21,8.34h0A20.73,20.73,0,0,0,.08,22.18c.37,4.47.37,7.29,3.51,10.87,4.2,4.8,9.79,8.88,16.35,8.55l1.47-.08"
      }), s.jsx("rect", {
        fill: gc.colors.white,
        x: "9.73",
        y: "8.52",
        width: "19.45",
        height: "23.87",
        rx: "4.36",
        transform: "translate(-5.09 6.52) rotate(-16.86)"
      }), s.jsx("path", {
        fill: gc.colors.black,
        d: "M19.17,17.63l3.67,4a1.12,1.12,0,0,1,.27.38c.06.2-.05.43-.32.69a1.07,1.07,0,0,1-.4.27.42.42,0,0,1-.29,0,.62.62,0,0,1-.2-.11l-.2-.21L21,21.85l-2.31.71-.15,1a1.81,1.81,0,0,1-.06.28.62.62,0,0,1-.1.2.43.43,0,0,1-.24.16,1.16,1.16,0,0,1-.49,0c-.37,0-.59-.18-.65-.38a1.11,1.11,0,0,1,0-.47L17.83,18a.77.77,0,0,1,.18-.39.88.88,0,0,1,.36-.24A.75.75,0,0,1,19.17,17.63Zm-.06,2.21-.2,1.3L20,20.8Z"
      }), s.jsx("path", {
        fill: gc.colors.white,
        d: "M19.16,34.67A4.83,4.83,0,0,1,14.31,30l-.47-15.14a4.87,4.87,0,0,1,4.72-5l10.87-.33a4.84,4.84,0,0,1,4.85,4.72l.46,15.13a4.87,4.87,0,0,1-4.71,5Z"
      }), s.jsx("path", {
        fill: gc.colors.yellow500,
        d: "M29.43,10a4.36,4.36,0,0,1,4.35,4.23l.46,15.14A4.35,4.35,0,0,1,30,33.84l-10.72.33h-.14a4.36,4.36,0,0,1-4.35-4.23L14.34,14.8a4.37,4.37,0,0,1,4.23-4.49L29.29,10h.14m0-1h-.17l-10.72.32a5.37,5.37,0,0,0-5.19,5.52L13.81,30a5.33,5.33,0,0,0,5.35,5.2h.17l10.72-.33a5.37,5.37,0,0,0,5.19-5.52l-.46-15.14A5.34,5.34,0,0,0,29.43,9Z"
      }), s.jsx("path", {
        fill: gc.colors.black,
        d: "M25,18.17l3.51,6.67a1.68,1.68,0,0,1,.23.61c0,.3-.22.57-.68.82a1.85,1.85,0,0,1-.64.23.72.72,0,0,1-.4-.1.66.66,0,0,1-.22-.22c-.05-.08-.12-.2-.2-.36l-.68-1.29-3.37.11L22,26a3.27,3.27,0,0,1-.17.36.86.86,0,0,1-.21.23.61.61,0,0,1-.39.13,1.64,1.64,0,0,1-.66-.18c-.47-.22-.72-.47-.73-.76a1.59,1.59,0,0,1,.19-.62L23,18.22a1.15,1.15,0,0,1,1-.65A1,1,0,0,1,25,18.17Zm-.89,2.95-.74,1.69,1.61,0Z"
      })]
    }));
  }

  ku.defaultProps = {
    size: 66
  }, ku.propTypes = {
    size: T["default"].oneOfType([T["default"].array, T["default"].number, T["default"].string])
  }, Cu.defaultProps = {
    size: 66
  }, Cu.propTypes = {
    size: T["default"].oneOfType([T["default"].array, T["default"].number, T["default"].string])
  };
  var Mu = gc.colors;

  function ju(e) {
    var t = e.size,
        n = _objectWithoutProperties(e, _excluded18);

    return s.jsxs(ms, _objectSpread(_objectSpread({
      size: t,
      version: "1.1",
      viewBox: "0 0 42.47 41.63",
      xmlns: "http://www.w3.org/2000/svg"
    }, n), {}, {
      children: [s.jsx("title", {
        children: "Illustration of a numbered list"
      }), s.jsx("path", {
        fill: Mu.yellow500,
        d: "M21.55,41.52c6.24-.42,11.32-1.35,16-6.41h0c3.51-3.83,5-9.09,5-14.21a26.34,26.34,0,0,0-4.9-14.24C33.67,1.18,27.76,0,21.29,0h0c-4,0-7.88,1.89-11.42,3.51a18.68,18.68,0,0,0-8.16,8.4h0A20.85,20.85,0,0,0,.09,22.32c.41,4.47.43,7.29,3.58,10.85C7.9,37.94,13.52,42,20.09,41.61l1.46-.09"
      }), s.jsx("path", {
        fill: Mu.white,
        d: "M11.24,7.9a.59.59,0,0,1,.44-.21,1.25,1.25,0,0,1,.38,0l.21.09a.32.32,0,0,1,.11.17,1.47,1.47,0,0,1,0,.42v4.43a1.94,1.94,0,0,1,0,.27.8.8,0,0,1-.08.21c-.07.15-.28.22-.62.22s-.53-.07-.61-.21a.52.52,0,0,1-.07-.21,2.07,2.07,0,0,1,0-.29V10l-.11.09a.94.94,0,0,1-.55.25.65.65,0,0,1-.48-.28.77.77,0,0,1-.25-.49.68.68,0,0,1,.28-.47l1.3-1.18Z"
      }), s.jsx("path", {
        fill: Mu.white,
        d: "M13.14,21.17a.94.94,0,0,1,.46.06.41.41,0,0,1,.2.23,1.45,1.45,0,0,1,0,.4,1.14,1.14,0,0,1,0,.4.33.33,0,0,1-.17.22,1.06,1.06,0,0,1-.49.1l-3.1.07a.68.68,0,0,1-.5-.2.74.74,0,0,1-.22-.5,1.28,1.28,0,0,1,.28-.8,3.08,3.08,0,0,1,.71-.63l.83-.53a3.45,3.45,0,0,0,.71-.58,1,1,0,0,0,.28-.69.58.58,0,0,0-.06-.2,1.07,1.07,0,0,0-.13-.21,1,1,0,0,0-.21-.15,1.09,1.09,0,0,0-.4-.06.59.59,0,0,0-.44.2.62.62,0,0,0-.2.37l0,.18v.31a.64.64,0,0,1-.08.2c-.07.13-.28.2-.61.21s-.59-.09-.67-.29a1.63,1.63,0,0,1-.05-.4,2.19,2.19,0,0,1,.56-1.5,2,2,0,0,1,1.54-.69,2,2,0,0,1,1.57.63,2.2,2.2,0,0,1,.62,1.5,2,2,0,0,1-.17.86,2.16,2.16,0,0,1-.47.67,4,4,0,0,1-1,.73l-.2.08v0Z"
      }), s.jsx("path", {
        fill: Mu.white,
        d: "M12.83,26.73A1.74,1.74,0,0,1,13.39,28a1,1,0,0,1-.62,1V29a1.42,1.42,0,0,1,.23.17,1.5,1.5,0,0,1,.25.26,1.23,1.23,0,0,1,.26.76,1.74,1.74,0,0,1-.64,1.4,2.34,2.34,0,0,1-1.6.55,2.07,2.07,0,0,1-2-1.12,1.19,1.19,0,0,1-.08-.21l0-.08a1.36,1.36,0,0,1-.08-.43c0-.31.26-.46.78-.46a.78.78,0,0,1,.42.08.81.81,0,0,1,.23.42.66.66,0,0,0,.44.38,1.14,1.14,0,0,0,.33,0,1,1,0,0,0,.62-.17.49.49,0,0,0,.2-.39.46.46,0,0,0-.19-.37.69.69,0,0,0-.46-.17,1.53,1.53,0,0,1-.36,0,.5.5,0,0,1-.21-.08c-.14-.06-.21-.27-.21-.61s.1-.59.29-.66a2,2,0,0,1,.42,0c.4,0,.6-.1.6-.3a.42.42,0,0,0-.16-.32.6.6,0,0,0-.44-.15,1,1,0,0,0-.45.09.41.41,0,0,0-.2.19l-.05.1a.57.57,0,0,1-.53.39.9.9,0,0,1-.43-.14c-.27-.16-.4-.34-.4-.54a1.78,1.78,0,0,1,.19-.54,2.2,2.2,0,0,1,.17-.25,1.93,1.93,0,0,1,.33-.31,1.89,1.89,0,0,1,.53-.24,2.19,2.19,0,0,1,.75-.11A2.11,2.11,0,0,1,12.83,26.73Z"
      }), s.jsx("path", {
        fill: Mu.black,
        d: "M33.86,11.52H16.8a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5H33.86a.5.5,0,0,1,.5.5A.5.5,0,0,1,33.86,11.52Z"
      }), s.jsx("path", {
        fill: Mu.black,
        d: "M30.79,20.65h-14a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h14a.5.5,0,0,1,.5.5A.5.5,0,0,1,30.79,20.65Z"
      }), s.jsx("path", {
        fill: Mu.black,
        d: "M36.25,29.79H16.8a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5H36.25a.5.5,0,0,1,.5.5A.5.5,0,0,1,36.25,29.79Z"
      })]
    }));
  }

  function Eu(e) {
    var t = e.size,
        n = _objectWithoutProperties(e, _excluded19);

    return s.jsxs(ms, _objectSpread(_objectSpread({
      size: t,
      version: "1.1",
      viewBox: "0 0 42.46 41.58",
      xmlns: "http://www.w3.org/2000/svg"
    }, n), {}, {
      children: [s.jsx("title", {
        children: "Illustration of a form with multiple choices"
      }), s.jsx("path", {
        fill: gc.colors.yellow500,
        d: "M21.1,41.51c6.25-.28,11.35-1.1,16.09-6.07h0c3.59-3.76,5.19-9,5.26-14.1A26.33,26.33,0,0,0,37.85,7C34.07,1.43,28.18.09,21.72,0h0c-4-.06-7.91,1.73-11.49,3.27S3.63,8.19,1.89,11.5h0A20.89,20.89,0,0,0,.05,21.87c.32,4.47.28,7.3,3.36,10.92,4.13,4.86,9.66,9,16.23,8.78.49,0,1,0,1.46-.06"
      }), s.jsx("circle", {
        fill: gc.colors.white,
        cx: "11.25",
        cy: "13.91",
        r: "2.66"
      }), s.jsx("line", {
        fill: "none",
        stroke: gc.colors.black,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        x1: "33.23",
        y1: "13.91",
        x2: "16.19",
        y2: "13.91"
      }), s.jsx("circle", {
        fill: gc.colors.white,
        cx: "11.25",
        cy: "20.75",
        r: "2.66"
      }), s.jsx("line", {
        fill: "none",
        stroke: gc.colors.black,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        x1: "30.16",
        y1: "20.75",
        x2: "16.19",
        y2: "20.75"
      }), s.jsx("circle", {
        fill: gc.colors.white,
        cx: "11.25",
        cy: "27.6",
        r: "2.66"
      }), s.jsx("line", {
        fill: "none",
        stroke: gc.colors.black,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        x1: "35.61",
        y1: "27.6",
        x2: "16.19",
        y2: "27.6"
      })]
    }));
  }

  ju.defaultProps = {
    size: 66
  }, ju.propTypes = {
    size: T["default"].oneOfType([T["default"].array, T["default"].number, T["default"].string])
  }, Eu.defaultProps = {
    size: 66
  }, Eu.propTypes = {
    size: T["default"].oneOfType([T["default"].array, T["default"].number, T["default"].string])
  };
  var _u = gc.colors;

  function Tu(e) {
    var t = e.width,
        n = _objectWithoutProperties(e, _excluded20);

    return s.jsxs(ms, _objectSpread(_objectSpread({
      width: t,
      height: gu(t, 46.02, 150.33),
      version: "1.1",
      viewBox: "0 0 150.33 46.02",
      xmlns: "http://www.w3.org/2000/svg"
    }, n), {}, {
      children: [s.jsx("title", {
        children: "Illustration of a paper plane"
      }), s.jsx("polygon", {
        fill: _u.yellow500,
        points: "104.86 13.59 150.33 0 129.22 29.5 122.53 25.13 115.47 28.97 117.72 21.98 104.86 13.59"
      }), s.jsx("polygon", {
        fill: _u.black,
        points: "113.87 19.47 150.33 0 117.72 21.98 115.47 28.97 113.87 19.47"
      }), s.jsx("line", {
        fill: "none",
        stroke: _u.black,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        x1: "129.22",
        y1: "29.5",
        x2: "128.18",
        y2: "14.93"
      }), s.jsx("line", {
        fill: "none",
        stroke: _u.black,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        x1: "127.27",
        y1: "13.04",
        x2: "104.86",
        y2: "13.59"
      }), s.jsx("polygon", {
        fill: _u.yellow500,
        points: "122.53 25.13 117.72 21.98 115.47 28.97 122.53 25.13"
      }), s.jsx("path", {
        fill: "none",
        stroke: _u.black,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeDasharray: "1 3",
        d: "M1.59,40.47A48.48,48.48,0,0,0,42,38.21a8.39,8.39,0,0,0,3-2.35c1.83-2.58.1-6.71-3-7.54s-6.47,1.46-7.2,4.54a7.61,7.61,0,0,0,3.73,8,14.42,14.42,0,0,0,5.52,1.55c8.53,1,16.4-.52,24.44-3.22,6.21-2.08,12.32-6.07,19.12-4.49,2.54.59,5.13,1.69,6.62,3.82s1.43,5.51-.7,7-5.36.4-6.69-1.83a8.07,8.07,0,0,1,0-7.48,16.1,16.1,0,0,1,8.62-7.58c5.39-2.22,11.23-1.07,16.42-3.9",
        transform: "translate(-1.09 -0.74)"
      })]
    }));
  }

  Tu.defaultProps = {
    width: 150
  }, Tu.propTypes = {
    width: T["default"].oneOfType([T["default"].number, T["default"].array])
  };
  var Su = gc.colors;

  function Lu(e) {
    var t = e.width,
        n = _objectWithoutProperties(e, _excluded21);

    return s.jsxs(ms, _objectSpread(_objectSpread({
      width: t,
      height: gu(t, 65.76, 263.78),
      version: "1.1",
      viewBox: "0 0 263.78 65.76",
      xmlns: "http://www.w3.org/2000/svg"
    }, n), {}, {
      children: [s.jsx("title", {
        children: "Illustration of a paper plane"
      }), s.jsx("g", {
        children: s.jsxs("g", {
          children: [s.jsx("polygon", {
            fill: Su.yellow500,
            points: "92.7 1.06 0 7.16 58.9 46.96 68.2 34.36 83.8 36.56 74.9 25.26 92.7 1.06"
          }), s.jsx("polygon", {
            fill: Su.black,
            points: "80.2 18.06 0 7.16 74.9 25.26 83.8 36.56 80.2 18.06"
          }), s.jsx("path", {
            fill: Su.black,
            d: "M58.9,48a1.2,1.2,0,0,1-1-.7l-8-27.4a.89.89,0,0,1,.7-1.2,1,1,0,0,1,1.2.7l8,27.4a.89.89,0,0,1-.7,1.2C59.1,47.86,59,48,58.9,48Z"
          }), s.jsx("path", {
            fill: Su.black,
            d: "M53.7,15.46a1,1,0,0,1-.9-.7,1,1,0,0,1,.6-1.3L92.4.06a1,1,0,0,1,1.3.6A1,1,0,0,1,93.1,2l-39,13.4C54,15.46,53.9,15.46,53.7,15.46Z"
          }), s.jsx("polygon", {
            fill: Su.yellow500,
            points: "68.2 34.36 74.9 25.26 83.8 36.56 68.2 34.36"
          }), s.jsx("path", {
            fill: Su.black,
            d: "M163.8,65.76h-.2a16,16,0,0,1-2.1-.5,1,1,0,0,1,.7-1.9,12.09,12.09,0,0,0,1.8.5,1,1,0,0,1,.8,1.2A1.2,1.2,0,0,1,163.8,65.76Zm5.9-.1a1.2,1.2,0,0,1-1-.7,1,1,0,0,1,.7-1.2c.4-.1.7-.2,1-.3s.5-.2.7-.3a1,1,0,0,1,.8,1.8c-.3.1-.5.2-.8.3a5.64,5.64,0,0,1-1.2.4Zm-13.1-3.3a1.85,1.85,0,0,1-.7-.2,7.52,7.52,0,0,1-1.5-1.6,1,1,0,1,1,1.6-1.2,8,8,0,0,0,1.3,1.3,1,1,0,0,1,.1,1.4A1.14,1.14,0,0,1,156.6,62.36Zm19.6-1.1c-.2,0-.4,0-.5-.2a1,1,0,0,1-.3-1.4,4.59,4.59,0,0,0,.7-1.6,1,1,0,0,1,1.9.7,7.22,7.22,0,0,1-.9,2A1.38,1.38,0,0,1,176.2,61.26Zm71-4.9h0c-.8-.1-1.5-.1-2.1-.2a1,1,0,1,1,.3-1.9,12.25,12.25,0,0,0,1.9.2.9.9,0,0,1,.9,1.1A1.08,1.08,0,0,1,247.2,56.36Zm5.9-.1a1.06,1.06,0,0,1-1-.9,1,1,0,0,1,.9-1.1l1.9-.3a.94.94,0,0,1,1.1.8c0,.5-.3,1.1-.8,1.1a15.52,15.52,0,0,0-2.1.4Zm-100.2-.8a1,1,0,0,1-1-.8,10.87,10.87,0,0,1-.1-1.8v-.4a1,1,0,0,1,2,0v.3a7.57,7.57,0,0,0,.1,1.5.94.94,0,0,1-.8,1.1A.31.31,0,0,1,152.9,55.46Zm86.4-.8a.37.37,0,0,1-.3-.1c-.7-.2-1.3-.5-1.9-.7a1,1,0,1,1,.8-1.8,13.36,13.36,0,0,0,1.8.7,1,1,0,0,1,.6,1.3A1,1,0,0,1,239.3,54.66Zm21.6-.2a1,1,0,0,1-.9-.7,1,1,0,0,1,.6-1.3c.6-.2,1.2-.5,1.8-.7a1,1,0,0,1,.8,1.8c-.6.3-1.3.5-1.9.8A.6.6,0,0,1,260.9,54.46Zm-83.9-.9a1.2,1.2,0,0,1-1-.7l-.6-1.8a1,1,0,1,1,1.8-.8,15.87,15.87,0,0,1,.7,2,1,1,0,0,1-.7,1.2A.31.31,0,0,1,177,53.56Zm55.1-2.3a.9.9,0,0,1-.5-.1c-.6-.3-1.2-.7-1.7-1a1,1,0,0,1,1-1.8c.6.3,1.1.7,1.7,1a1.11,1.11,0,0,1,.4,1.4A1.05,1.05,0,0,1,232.1,51.26Zm-77.2-3.2a1.42,1.42,0,0,1-.6-.2,1.08,1.08,0,0,1-.2-1.4,11,11,0,0,1,1.5-1.6,1,1,0,1,1,1.4,1.4,8.64,8.64,0,0,0-1.3,1.4A1.23,1.23,0,0,1,154.9,48.06Zm70.3-.8a.9.9,0,0,1-.5-.1l-1.8-.9a1,1,0,1,1,.8-1.8l1.8.9a.92.92,0,0,1,.4,1.3C225.9,47.16,225.5,47.26,225.2,47.26Zm-52-.7a.91.91,0,0,1-.8-.4,2.65,2.65,0,0,1-.5-.6,3,3,0,0,0-.8-.8,1,1,0,0,1,1.4-1.4c.3.3.5.6.8.9a4.35,4.35,0,0,1,.6.7,1,1,0,0,1-.1,1.4A1.42,1.42,0,0,1,173.2,46.56ZM217.9,44a.76.76,0,0,1-.4-.1c-.6-.2-1.2-.5-1.8-.7a1,1,0,0,1,.7-1.9c.6.2,1.3.5,1.9.7a1,1,0,0,1-.4,2Zm-56.7-.8a1,1,0,0,1-.9-.6,1.05,1.05,0,0,1,.4-1.3c.6-.3,1.2-.6,1.9-.9a1,1,0,0,1,.8,1.8c-.6.3-1.2.5-1.8.8A.4.4,0,0,1,161.2,43.16Zm49.1-1.7H210c-.6-.2-1.3-.3-1.9-.5a1,1,0,0,1-.7-1.2,1,1,0,0,1,1.2-.7c.7.2,1.3.3,2,.5a1,1,0,0,1,.7,1.2A1,1,0,0,1,210.3,41.46ZM167.4,41a1.42,1.42,0,0,1-.6-.2c-.5-.4-1-.8-1.6-1.2a1,1,0,1,1,1.2-1.6c.5.3.9.7,1.4,1a.75.75,0,0,1,.7-.5c.7-.2,1.3-.3,2-.5a1,1,0,0,1,.4,2,13.32,13.32,0,0,0-1.9.5c-.2.1-.4,0-.6,0,0,.1-.1.2-.1.3A2.92,2.92,0,0,1,167.4,41Zm35.1-1.1h-.2l-2-.3a1.17,1.17,0,0,1-.9-1.1c0-.5.6-.9,1.1-.9l2,.3a1,1,0,0,1,.8,1.1A.77.77,0,0,1,202.5,39.86ZM176.6,39a1.06,1.06,0,0,1-1-.9c-.1-.5.4-1,.9-1.1s.7-.1,1.1-.1l.9-.1a1,1,0,0,1,.2,2l-.9.1a4.87,4.87,0,0,1-1.2.1Zm17.9,0h0a14.08,14.08,0,0,0-2-.1,1,1,0,0,1,.2-2c.7,0,1.3.1,2,.1a.9.9,0,0,1,.9,1.1A1.09,1.09,0,0,1,194.5,39Zm-9.9-.3a1,1,0,0,1-1-1,.94.94,0,0,1,1-1h2a1,1,0,0,1,0,2h-2Zm-23.8-2.1a.9.9,0,0,1-.5-.1c-.6-.3-1.1-.6-1.7-.9a1,1,0,1,1,.9-1.7,16.18,16.18,0,0,1,1.8,1,1.11,1.11,0,0,1,.4,1.4A2.39,2.39,0,0,1,160.8,36.56Zm-7.2-3.5a.6.6,0,0,1-.4-.1,13.36,13.36,0,0,0-1.8-.7,1,1,0,0,1,.7-1.9,15.39,15.39,0,0,1,1.9.8.92.92,0,0,1,.5,1.3A.87.87,0,0,1,153.6,33.06Zm-7.5-2.7h-.3c-.6-.2-1.3-.4-1.9-.6a1,1,0,1,1,.5-1.9c.6.2,1.3.4,1.9.6a1.15,1.15,0,0,1,.7,1.3A1,1,0,0,1,146.1,30.36Zm-7.8-2.1h-.2a12.86,12.86,0,0,0-1.9-.4,1,1,0,0,1,.4-2,14.62,14.62,0,0,1,2,.5,1,1,0,0,1,.7,1.2A1,1,0,0,1,138.3,28.26Zm-7.8-1.6h-.2l-2-.3a1,1,0,1,1,.3-1.9l2,.3a1,1,0,0,1,.8,1.2A.89.89,0,0,1,130.5,26.66Zm-33.8-1a1,1,0,0,1-1-.9,1.09,1.09,0,0,1,.9-1.1c.7,0,1.3-.1,2-.1a1,1,0,0,1,.2,2,14.77,14.77,0,0,0-2.1.1Zm-6-.1h0c-.7-.1-1.4-.1-2-.2a1,1,0,0,1,.3-1.9,11,11,0,0,0,1.8.2.9.9,0,0,1,.9,1.1A1.08,1.08,0,0,1,90.7,25.56Zm31.9-.1h0a16.46,16.46,0,0,0-2.1-.2,1.09,1.09,0,0,1-.9-1.1,1.17,1.17,0,0,1,1.1-.9c.7.1,1.3.1,2,.2a1.17,1.17,0,0,1,.9,1.1A1.06,1.06,0,0,1,122.6,25.46Zm-18-.5a1,1,0,0,1-1-.9,1.17,1.17,0,0,1,.9-1.1c.7-.1,1.3-.1,2-.2a1.17,1.17,0,0,1,1.1.9c.1.5-.4,1-.9,1.1-.7.1-1.3.1-2.1.2Zm10-.2h0c-.6,0-1.2-.1-1.7-.1h-.3a1,1,0,0,1,0-2h.3c.6,0,1.1.1,1.7.1a.9.9,0,0,1,.9,1.1C115.6,24.36,115.2,24.76,114.6,24.76Z"
          })]
        })
      })]
    }));
  }

  Lu.defaultProps = {
    width: 150
  }, Lu.propTypes = {
    width: T["default"].oneOfType([T["default"].number, T["default"].array])
  };
  var Du = gc.colors;

  function Au(e) {
    var t = e.height,
        n = _objectWithoutProperties(e, _excluded22);

    return s.jsxs(ms, _objectSpread(_objectSpread({
      height: t,
      version: "1.1",
      viewBox: "0 0 63.95 86.97",
      xmlns: "http://www.w3.org/2000/svg",
      enableBackground: "new 0 0 63.95 86.97"
    }, n), {}, {
      children: [s.jsx("title", {
        children: "Illustration of a paper plane"
      }), s.jsx("g", {
        id: "Layer_2_1_",
        children: s.jsxs("g", {
          id: "Layer_1-2",
          children: [s.jsx("polygon", {
            fill: Du.yellow500,
            points: "37.496,16.3 35.566,21.69 41.156,18.87 46.266,22.44 63.446,0 27.686,9.44 \t\t"
          }), s.jsx("polygon", {
            fill: Du.black,
            points: "35.566,21.69 37.496,16.3 63.446,0 34.556,14.24 \t\t"
          }), s.jsx("line", {
            fill: "none",
            stroke: Du.black,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            x1: "45.816",
            y1: "11.07",
            x2: "46.266",
            y2: "22.44"
          }), s.jsx("line", {
            fill: "none",
            stroke: Du.black,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            x1: "27.696",
            y1: "9.44",
            x2: "44.096",
            y2: "9.54"
          }), s.jsx("polygon", {
            fill: Du.yellow500,
            points: "35.566,21.69 37.496,16.3 41.156,18.87 \t\t"
          }), s.jsx("path", {
            fill: "none",
            stroke: Du.black,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeDasharray: "1,3",
            d: "M2.786,86.47c-4.602-8.185-3.42-18.402,2.93-25.32c2.61-2.72,5.94-4.72,8.25-7.72 c4.635-6.388,3.827-15.22-1.89-20.66c-1.85-1.65-4.3-2.88-6.76-2.51s-4.66,2.8-4.11,5.22c0.536,1.632,1.771,2.941,3.37,3.57 c5.374,2.424,11.708,0.878,15.36-3.75c2.07-2.76,2.89-6.22,4.32-9.36s3.89-6.23,7.31-6.66"
          })]
        })
      })]
    }));
  }

  Au.defaultProps = {
    height: "6rem"
  }, Au.propTypes = {
    height: T["default"].oneOfType([T["default"].number, T["default"].array, T["default"].string])
  };
  var Nu = gc.colors;

  function Iu(e) {
    var t = e.size,
        n = _objectWithoutProperties(e, _excluded23);

    return s.jsxs(ms, _objectSpread(_objectSpread({
      size: t,
      version: "1.1",
      viewBox: "0 0 42.47 41.62",
      xmlns: "http://www.w3.org/2000/svg"
    }, n), {}, {
      children: [s.jsx("title", {
        children: "Illustration of pencil"
      }), s.jsx("defs", {
        children: s.jsx("clipPath", {
          id: "clipPath",
          children: s.jsx("path", {
            fill: Nu.yellow500,
            d: "M21.41,41.52c6.24-.38,11.33-1.27,16-6.3h0c3.54-3.81,5.07-9.06,5.07-14.18A26.31,26.31,0,0,0,37.66,6.77C33.8,1.26,27.89,0,21.42,0h0C17.4,0,13.53,1.84,10,3.44a18.56,18.56,0,0,0-8.21,8.34h0A20.73,20.73,0,0,0,.08,22.18c.37,4.47.37,7.29,3.51,10.87,4.2,4.8,9.79,8.88,16.35,8.55l1.47-.08"
          })
        })
      }), s.jsx("g", {
        id: "Layer_2",
        "data-name": "Layer 2",
        children: s.jsxs("g", {
          id: "Layer_1-2",
          "data-name": "Layer 1",
          children: [s.jsx("path", {
            fill: Nu.yellow500,
            d: "M21.41,41.52c6.24-.38,11.33-1.27,16-6.3h0c3.54-3.81,5.07-9.06,5.07-14.18A26.31,26.31,0,0,0,37.66,6.77C33.8,1.26,27.89,0,21.42,0h0C17.4,0,13.53,1.84,10,3.44a18.56,18.56,0,0,0-8.21,8.34h0A20.73,20.73,0,0,0,.08,22.18c.37,4.47.37,7.29,3.51,10.87,4.2,4.8,9.79,8.88,16.35,8.55l1.47-.08"
          }), s.jsxs("g", {
            clipPath: "url(#clipPath)",
            children: [s.jsx("polygon", {
              fill: Nu.white,
              stroke: Nu.white,
              strokeLinecap: "round",
              strokeLinejoin: "round",
              points: "15.44 13.98 16.94 24.38 20.13 26.18 26.03 20.85 25.29 17.63 15.44 13.98"
            }), s.jsx("polygon", {
              fill: Nu.white,
              stroke: Nu.white,
              strokeLinecap: "round",
              strokeLinejoin: "round",
              points: "25.5 20.74 22.5 19.88 22.5 19.88 22.5 19.88 22.5 19.88 22.5 19.88 22.71 22.99 19.72 22.13 19.93 25.24 16.94 24.38 30.01 40.37 35.95 39.02 39.12 34.56 25.29 17.63 25.5 20.74"
            }), s.jsx("polygon", {
              fill: Nu.black,
              stroke: Nu.black,
              strokeLinecap: "round",
              strokeLinejoin: "round",
              points: "20.36 15.81 15.44 13.98 16.19 19.18 20.36 15.81"
            }), s.jsx("polyline", {
              fill: "none",
              stroke: Nu.black,
              strokeLinecap: "round",
              strokeLinejoin: "round",
              points: "25.29 17.63 25.5 20.74 22.5 19.88 22.5 19.88 22.5 19.88 22.5 19.88 22.5 19.88 22.71 22.99 19.72 22.13 19.93 25.24 16.94 24.38"
            }), s.jsx("line", {
              fill: "none",
              stroke: Nu.black,
              strokeLinecap: "round",
              strokeLinejoin: "round",
              x1: "25.5",
              y1: "20.74",
              x2: "38.26",
              y2: "36.38"
            }), s.jsx("line", {
              fill: "none",
              stroke: Nu.black,
              strokeLinecap: "round",
              strokeLinejoin: "round",
              x1: "22.62",
              y1: "23",
              x2: "35.33",
              y2: "38.33"
            }), s.jsx("line", {
              fill: "none",
              stroke: Nu.black,
              strokeLinecap: "round",
              strokeLinejoin: "round",
              x1: "19.61",
              y1: "25.19",
              x2: "31.68",
              y2: "39.88"
            })]
          })]
        })
      })]
    }));
  }

  Iu.defaultProps = {
    size: 66
  }, Iu.propTypes = {
    size: T["default"].oneOfType([T["default"].array, T["default"].number, T["default"].string])
  };
  var zu = gc.colors;

  function Ou(e) {
    var t = e.size,
        n = _objectWithoutProperties(e, _excluded24);

    return s.jsxs(ms, _objectSpread(_objectSpread({
      size: t,
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 66.26 64.83"
    }, n), {}, {
      children: [s.jsx("path", {
        fill: zu.yellow500,
        d: "M32.34,64.78c9.75-.27,17.74-1.4,25.28-9h0C63.34,50,66,41.91,66.26,33.92a41.13,41.13,0,0,0-6.78-22.51C53.74,2.62,44.59.35,34.49,0h0c-6.27-.21-12.4,2.46-18,4.78A29,29,0,0,0,3.26,17.37h0A32.4,32.4,0,0,0,.06,33.51C.41,40.5.26,44.9,5,50.65,11.28,58.35,19.79,65,30,64.83l2.3,0",
        transform: "translate(0 0)"
      }), s.jsx("path", {
        d: "M50.22,18V19a.47.47,0,0,1-.47.48H48.32V36.52a1.9,1.9,0,0,1-1.9,1.9H34.08v2.92l5.08,5.1a.47.47,0,0,1,0,.67l-.67.67a.47.47,0,0,1-.67,0l-4.69-4.7-4.69,4.7a.54.54,0,0,1-.34.14.5.5,0,0,1-.33-.14l-.68-.67a.48.48,0,0,1,0-.67l5.09-5.1V38.42H19.83a1.9,1.9,0,0,1-1.9-1.9V19.44H16.51A.49.49,0,0,1,16,19V18a.49.49,0,0,1,.48-.48H49.75A.48.48,0,0,1,50.22,18Zm-3.8,1.42H19.83v17.1H46.42Z",
        transform: "translate(0 0)"
      }), s.jsx("rect", {
        fill: "white",
        x: "22",
        y: "21.94",
        width: "22",
        height: "12",
        rx: "1.27"
      })]
    }));
  }

  Ou.defaultProps = {
    size: 66
  }, Ou.propTypes = {
    size: T["default"].oneOfType([T["default"].array, T["default"].number, T["default"].string])
  };
  var Ru = gc.colors;

  function Pu(e) {
    var t = e.size,
        n = _objectWithoutProperties(e, _excluded25);

    return s.jsxs(ms, _objectSpread(_objectSpread({
      size: t,
      version: "1.1",
      viewBox: "0 0 42.6 41.5",
      xmlns: "http://www.w3.org/2000/svg"
    }, n), {}, {
      children: [s.jsx("title", {
        children: "Illustration of shuffled lines"
      }), s.jsx("g", {
        children: s.jsxs("g", {
          id: "Layer_1-2",
          children: [s.jsx("path", {
            fill: Ru.yellow500,
            d: "M21,41.5c6.3-0.2,11.4-1,16.2-5.8l0,0c3.7-3.7,5.3-8.9,5.5-14c0-5.1-1.6-10.2-4.4-14.4c-3.7-5.6-9.6-7-16-7.2 l0,0c-4-0.1-7.9,1.6-11.5,3.1S4,7.9,2.2,11.2l0,0c-1.5,3.2-2.2,6.8-2,10.3c0.2,4.5,0.2,7.3,3.2,11c4.1,4.9,9.5,9.2,16.1,9L21,41.5"
          }), s.jsxs("g", {
            children: [s.jsx("defs", {
              children: s.jsx("path", {
                id: "SVGID_1_",
                d: "M21,41.5c6.3-0.2,11.4-1,16.2-5.8l0,0c3.7-3.7,5.3-8.9,5.5-14c0-5.1-1.6-10.2-4.4-14.4 c-3.7-5.6-9.6-7-16-7.2l0,0c-4-0.1-7.9,1.6-11.5,3.1S4,7.9,2.2,11.2l0,0c-1.5,3.2-2.2,6.8-2,10.3c0.2,4.5,0.2,7.3,3.2,11 c4.1,4.9,9.5,9.2,16.1,9L21,41.5"
              })
            }), s.jsx("clipPath", {
              id: "SVGID_2_",
              children: s.jsx("use", {
                xlinkHref: "#SVGID_1_",
                style: {
                  overflow: "visible"
                }
              })
            }), s.jsxs("g", {
              style: {
                clipPath: "url(#SVGID_2_)"
              },
              children: [s.jsx("path", {
                fill: "none",
                stroke: Ru.white,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M0.6,27.8c3.1-0.4,9.1-2.1,12.9-8c5.5-8.3,17.7-7.3,17.7-7.3"
              }), s.jsx("polyline", {
                fill: "none",
                stroke: Ru.white,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                points: "26.7,7.6 32.6,12.4 27.4,17.8"
              }), s.jsx("path", {
                fill: "none",
                stroke: Ru.white,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M1.3,12.9c3.2,0.5,8.8,2.2,12.6,7.9c5.5,8.3,17.7,7.2,17.7,7.2"
              }), s.jsx("polyline", {
                fill: "none",
                stroke: Ru.white,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                points: "27,33.1 32.9,28.2 27.7,22.8"
              })]
            })]
          })]
        })
      })]
    }));
  }

  Pu.defaultProps = {
    size: 66
  }, Pu.propTypes = {
    size: T["default"].oneOfType([T["default"].array, T["default"].number, T["default"].string])
  };
  var Fu = gc.colors;

  function Bu(e) {
    var t = e.size,
        n = _objectWithoutProperties(e, _excluded26);

    return s.jsxs(ms, _objectSpread(_objectSpread({
      size: t,
      version: "1.1",
      viewBox: "0 0 42.47 41.62",
      xmlns: "http://www.w3.org/2000/svg"
    }, n), {}, {
      children: [s.jsx("title", {
        children: "Illustration of two speech bubbles"
      }), s.jsx("g", {
        children: s.jsxs("g", {
          children: [s.jsx("path", {
            fill: Fu.yellow500,
            d: "M21.41,41.52c6.24-.38,11.33-1.27,16-6.3h0c3.54-3.81,5.07-9.06,5.07-14.18A26.31,26.31,0,0,0,37.66,6.77C33.8,1.26,27.89,0,21.42,0h0C17.4,0,13.53,1.84,10,3.44a18.56,18.56,0,0,0-8.21,8.34h0A20.73,20.73,0,0,0,.08,22.18c.37,4.47.37,7.29,3.51,10.87,4.2,4.8,9.79,8.88,16.35,8.55l1.47-.08"
          }), s.jsx("path", {
            fill: Fu.white,
            stroke: Fu.white,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M15.36,8c-4.46,0-8.07,2.74-8.07,6.12a5.65,5.65,0,0,0,2.83,4.65,3.71,3.71,0,0,1-1.9,2.08s3.1.31,4.68-.91a10.3,10.3,0,0,0,2.46.29c4.46,0,8.08-2.74,8.08-6.11S19.82,8,15.36,8Z"
          }), s.jsx("circle", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            fill: Fu.black,
            stroke: Fu.black,
            cx: "15.36",
            cy: "14.19",
            r: "0.88"
          }), s.jsx("circle", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            fill: Fu.black,
            stroke: Fu.black,
            cx: "11.96",
            cy: "14.19",
            r: "0.88"
          }), s.jsx("circle", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            fill: Fu.black,
            stroke: Fu.black,
            cx: "18.75",
            cy: "14.19",
            r: "0.88"
          }), s.jsx("path", {
            fill: Fu.white,
            stroke: Fu.white,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M26.58,19.72c4.46,0,8.07,2.74,8.07,6.12a5.65,5.65,0,0,1-2.83,4.65,3.71,3.71,0,0,0,1.9,2.08s-3.1.31-4.68-.91a10.3,10.3,0,0,1-2.46.29c-4.46,0-8.08-2.74-8.08-6.11S22.12,19.72,26.58,19.72Z"
          }), s.jsx("circle", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            fill: Fu.black,
            stroke: Fu.black,
            cx: "26.58",
            cy: "25.89",
            r: "0.88"
          }), s.jsx("circle", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            fill: Fu.black,
            stroke: Fu.black,
            cx: "29.98",
            cy: "25.89",
            r: "0.88"
          }), s.jsx("circle", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            fill: Fu.black,
            stroke: Fu.black,
            cx: "23.19",
            cy: "25.89",
            r: "0.88"
          })]
        })
      })]
    }));
  }

  Bu.defaultProps = {
    size: 66
  }, Bu.propTypes = {
    size: T["default"].oneOfType([T["default"].array, T["default"].number, T["default"].string])
  };
  var qu = gc.colors;

  function Uu(e) {
    var t = e.size,
        n = _objectWithoutProperties(e, _excluded27);

    return s.jsxs(ms, _objectSpread(_objectSpread({
      size: t,
      version: "1.1",
      viewBox: "0 0 96 95",
      xmlns: "http://www.w3.org/2000/svg"
    }, n), {}, {
      children: [s.jsx("title", {
        children: "Illustration of only one speech bubbles"
      }), s.jsxs("g", {
        clipPath: "url(#clip0)",
        children: [s.jsx("path", {
          d: "M48.3957 93.8526C62.5007 92.9936 74.0062 90.9819 84.5624 79.612C92.5643 70.9998 96.0227 59.1326 96.0227 47.5592C95.612 35.9751 91.8251 24.7636 85.1275 15.303C76.4023 2.84813 63.0432 0 48.4183 0C39.3314 0 30.5836 4.15917 22.6043 7.77584C14.5471 11.894 8.03739 18.5069 4.04626 26.6277C0.754028 34 -0.577445 42.0978 0.180939 50.1361C1.01729 60.2402 1.01729 66.6145 8.11501 74.7068C17.6088 85.5569 30.2445 94.7794 45.0729 94.0334L48.3957 93.8526Z",
          fill: qu.yellow500
        }), s.jsx("path", {
          d: "M48.7574 22.9885C32.505 22.9885 19.3719 32.9569 19.3719 45.2762C19.3719 52.0575 23.3729 58.1154 29.6795 62.2067C28.278 65.2809 26.0176 68.7393 22.74 69.7791C22.74 69.7791 34.0421 70.932 39.8061 66.4789C42.7643 67.209 45.8009 67.5734 48.8478 67.5639C65.1002 67.5639 78.2333 57.5729 78.2333 45.2762C78.2333 32.9795 65.0098 22.9885 48.7574 22.9885Z",
          fill: qu.white,
          stroke: qu.white,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), s.jsx("path", {
          d: "M48.7573 48.6894C50.53 48.6894 51.9671 47.2524 51.9671 45.4796C51.9671 43.7069 50.53 42.2698 48.7573 42.2698C46.9846 42.2698 45.5475 43.7069 45.5475 45.4796C45.5475 47.2524 46.9846 48.6894 48.7573 48.6894Z",
          fill: qu.black,
          stroke: qu.black,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), s.jsx("path", {
          d: "M36.3929 48.6894C38.1656 48.6894 39.6027 47.2524 39.6027 45.4796C39.6027 43.7069 38.1656 42.2698 36.3929 42.2698C34.6202 42.2698 33.1831 43.7069 33.1831 45.4796C33.1831 47.2524 34.6202 48.6894 36.3929 48.6894Z",
          fill: qu.black,
          stroke: qu.black,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), s.jsx("path", {
          d: "M61.1219 48.6894C62.8946 48.6894 64.3317 47.2524 64.3317 45.4796C64.3317 43.7069 62.8946 42.2698 61.1219 42.2698C59.3492 42.2698 57.9121 43.7069 57.9121 45.4796C57.9121 47.2524 59.3492 48.6894 61.1219 48.6894Z",
          fill: qu.black,
          stroke: qu.black,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })]
      })]
    }));
  }

  Uu.defaultProps = {
    size: 66
  }, Uu.propTypes = {
    size: T["default"].oneOfType([T["default"].array, T["default"].number, T["default"].string])
  };
  var Vu = gc.colors;

  function Hu(e) {
    var t = e.size,
        n = _objectWithoutProperties(e, _excluded28);

    return s.jsxs(ms, _objectSpread(_objectSpread({
      size: t,
      version: "1.1",
      viewBox: "0 0 72 72",
      xmlns: "http://www.w3.org/2000/svg"
    }, n), {}, {
      children: [s.jsx("title", {
        children: "Illustration of the Sun"
      }), s.jsxs("g", {
        children: [s.jsx("circle", {
          fill: Vu.yellow400,
          cx: "36",
          cy: "35.4",
          r: "19.9"
        }), s.jsxs("g", {
          children: [s.jsx("line", {
            fill: "none",
            stroke: Vu.yellow400,
            strokeWidth: 4,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            x1: "36",
            y1: "10",
            x2: "36",
            y2: "2.3"
          }), s.jsx("line", {
            fill: "none",
            stroke: Vu.yellow400,
            strokeWidth: 4,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            x1: "36",
            y1: "69.7",
            x2: "36",
            y2: "62"
          }), s.jsx("line", {
            fill: "none",
            stroke: Vu.yellow400,
            strokeWidth: 4,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            x1: "62",
            y1: "36",
            x2: "69.7",
            y2: "36"
          }), s.jsx("line", {
            fill: "none",
            stroke: Vu.yellow400,
            strokeWidth: 4,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            x1: "2.3",
            y1: "36",
            x2: "10",
            y2: "36"
          })]
        }), s.jsxs("g", {
          children: [s.jsx("line", {
            fill: "none",
            stroke: Vu.yellow400,
            strokeWidth: 4,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            x1: "54.4",
            y1: "17.6",
            x2: "59.8",
            y2: "12.2"
          }), s.jsx("line", {
            fill: "none",
            stroke: Vu.yellow400,
            strokeWidth: 4,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            x1: "12.2",
            y1: "59.8",
            x2: "17.6",
            y2: "54.4"
          }), s.jsx("line", {
            fill: "none",
            stroke: Vu.yellow400,
            strokeWidth: 4,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            x1: "54.4",
            y1: "54.4",
            x2: "59.8",
            y2: "59.8"
          }), s.jsx("line", {
            fill: "none",
            stroke: Vu.yellow400,
            strokeWidth: 4,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: "10",
            x1: "12.2",
            y1: "12.2",
            x2: "17.6",
            y2: "17.6"
          })]
        })]
      })]
    }));
  }

  Hu.defaultProps = {
    size: 72
  }, Hu.propTypes = {
    size: T["default"].oneOfType([T["default"].array, T["default"].number, T["default"].string])
  };
  var Zu = gc.colors;

  function Wu(e) {
    var t = e.size,
        n = _objectWithoutProperties(e, _excluded29);

    return s.jsxs(ms, _objectSpread(_objectSpread({
      size: t,
      version: "1.1",
      viewBox: "0 0 42.47 41.62",
      xmlns: "http://www.w3.org/2000/svg"
    }, n), {}, {
      children: [s.jsx("path", {
        fill: Zu.yellow500,
        d: "M21.41,41.52c6.24-.38,11.33-1.27,16-6.3h0c3.54-3.81,5.07-9.06,5.07-14.18A26.31,26.31,0,0,0,37.66,6.77C33.8,1.26,27.89,0,21.42,0h0C17.4,0,13.53,1.84,10,3.44a18.56,18.56,0,0,0-8.21,8.34h0A20.73,20.73,0,0,0,.08,22.18c.37,4.47.37,7.29,3.51,10.87,4.2,4.8,9.79,8.88,16.35,8.55l1.47-.08"
      }), s.jsx("circle", {
        fill: Zu.white,
        cx: "13.61",
        cy: "16.25",
        r: "7.44"
      }), s.jsx("circle", {
        fill: Zu.white,
        cx: "28.68",
        cy: "25.49",
        r: "7.44"
      }), s.jsx("path", {
        fill: Zu.black,
        d: "M15.07,20.15A1.31,1.31,0,0,1,14,19.61L9.87,14A1.31,1.31,0,0,1,12,12.42l2.79,3.79a76.18,76.18,0,0,1,5-9.61A1.31,1.31,0,1,1,22,8a75.6,75.6,0,0,0-5.72,11.37,1.3,1.3,0,0,1-1.05.81Z"
      }), s.jsx("path", {
        fill: Zu.black,
        d: "M23.87,29.52A1.34,1.34,0,0,1,23,27.17c2.7-2.34,5.37-4.81,7.92-7.36a1.32,1.32,0,0,1,1.89,0,1.34,1.34,0,0,1,0,1.89c-2.59,2.6-5.31,5.12-8.06,7.49A1.32,1.32,0,0,1,23.87,29.52Z"
      }), s.jsx("path", {
        fill: Zu.black,
        d: "M32.25,30.44a1.34,1.34,0,0,1-.93-.37L22.07,21.2A1.33,1.33,0,0,1,22,19.31a1.35,1.35,0,0,1,1.9,0l9.25,8.87a1.33,1.33,0,0,1,0,1.89A1.37,1.37,0,0,1,32.25,30.44Z"
      })]
    }));
  }

  Wu.defaultProps = {
    size: 66
  }, Wu.propTypes = {
    size: T["default"].oneOfType([T["default"].array, T["default"].number, T["default"].string])
  };
  var $u = gc.colors;

  function Gu(e) {
    var t = e.size,
        n = _objectWithoutProperties(e, _excluded30);

    return s.jsxs(ms, _objectSpread(_objectSpread({
      size: t,
      viewBox: "0 0 143 103",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg"
    }, n), {}, {
      children: [s.jsx("title", {
        children: "Illustration of a Computer"
      }), s.jsx("defs", {
        children: s.jsx("polygon", {
          id: "path-1",
          points: "0 0.781824598 100.345642 0.781824598 100.345642 69.0024873 0 69.0024873"
        })
      }), s.jsx("g", {
        id: "07_studentDashboard",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd",
        children: s.jsx("g", {
          id: "07_studentDashboard_toDo_empty",
          transform: "translate(-648.000000, -492.000000)",
          children: s.jsxs("g", {
            id: "Group-90",
            transform: "translate(648.000000, 491.000000)",
            children: [s.jsx("path", {
              d: "M132.238042,91.6449891 C132.054253,92.9478255 130.847305,93.8554618 129.543726,93.6720436 L78.5430947,86.5244073 C77.2395158,86.3409891 76.3281474,85.1383709 76.5119368,83.8355345 L86.3626737,12.0717527 C86.5464632,10.7689164 87.7515158,9.86128 89.0569895,10.0446982 L140.267937,17.2225891 C141.575305,17.4041164 142.482884,18.6086255 142.300989,19.9114618 L132.238042,91.6449891 Z",
              id: "Fill-1",
              fill: $u.white
            }), s.jsx("path", {
              d: "M132.238042,91.6449891 C132.054253,92.9478255 130.847305,93.8554618 129.543726,93.6720436 L78.5430947,86.5244073 C77.2395158,86.3409891 76.3281474,85.1383709 76.5119368,83.8355345 L86.3626737,12.0717527 C86.5464632,10.7689164 87.7515158,9.86128 89.0569895,10.0446982 L140.267937,17.2225891 C141.575305,17.4041164 142.482884,18.6086255 142.300989,19.9114618 L132.238042,91.6449891 Z",
              id: "Stroke-3",
              stroke: $u.gray200,
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }), s.jsx("path", {
              d: "M107.500926,84.2318691 C107.315242,85.5460509 106.100716,86.45936 104.783874,86.2759418 C103.467032,86.0906327 102.549979,84.8766691 102.735663,83.5624873 C102.919453,82.2501964 104.137768,81.3349964 105.452716,81.5203055 C106.769558,81.7056145 107.686611,82.9176873 107.500926,84.2318691",
              id: "Fill-5",
              fill: $u.white
            }), s.jsx("path", {
              d: "M117.868358,18.5365818 C117.855095,18.5365818 117.841832,18.5346909 117.826674,18.5328 L112.820779,17.8293818 C112.5252,17.7877818 112.316779,17.5154909 112.358463,17.2186182 C112.400147,16.9217455 112.6692,16.7137455 112.972358,16.7572364 L117.978253,17.4587636 C118.275726,17.5003636 118.484147,17.7745455 118.440568,18.0695273 C118.400779,18.3531636 118.148779,18.5554909 117.868358,18.5365818",
              id: "Fill-7",
              fill: $u.black
            }), s.jsx("path", {
              d: "M111.231095,17.06016 C111.189411,17.3627055 110.908989,17.5744873 110.603937,17.5328873 C110.300779,17.4893964 110.088568,17.2095418 110.130253,16.9051055 C110.173832,16.60256 110.454253,16.3907782 110.759305,16.4342691 C111.062463,16.4758691 111.274674,16.7576145 111.231095,17.06016",
              id: "Fill-9",
              fill: $u.black
            }), s.jsx("polygon", {
              id: "Fill-11",
              fill: $u.white,
              points: "82.0985684 75.0201164 90.1398316 17.8730618 137.097095 24.4553164 129.055832 81.6023709"
            }), s.jsx("polygon", {
              id: "Stroke-13",
              stroke: $u.gray200,
              strokeLinecap: "round",
              strokeLinejoin: "round",
              points: "82.0985684 75.0201164 90.1398316 17.8730618 137.097095 24.4553164 129.055832 81.6023709"
            }), s.jsx("line", {
              x1: "92.5834737",
              y1: "46.1680582",
              x2: "126.787263",
              y2: "51.4077673",
              id: "Stroke-15",
              stroke: $u.black,
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }), s.jsx("line", {
              x1: "92.0108842",
              y1: "49.8916364",
              x2: "126.214674",
              y2: "55.1332364",
              id: "Stroke-17",
              stroke: $u.black,
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }), s.jsx("line", {
              x1: "91.4381053",
              y1: "53.61616",
              x2: "125.641895",
              y2: "58.85776",
              id: "Stroke-19",
              stroke: $u.black,
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }), s.jsx("line", {
              x1: "90.8655158",
              y1: "57.3408727",
              x2: "125.069305",
              y2: "62.5805818",
              id: "Stroke-21",
              stroke: $u.black,
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }), s.jsx("line", {
              x1: "90.2919789",
              y1: "61.0653964",
              x2: "124.495768",
              y2: "66.3051055",
              id: "Stroke-23",
              stroke: $u.black,
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }), s.jsx("line", {
              x1: "89.7192",
              y1: "64.78992",
              x2: "123.922989",
              y2: "70.0296291",
              id: "Stroke-25",
              stroke: $u.black,
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }), s.jsx("line", {
              x1: "89.1466105",
              y1: "68.5136873",
              x2: "123.3504",
              y2: "73.7552873",
              id: "Stroke-27",
              stroke: $u.black,
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }), s.jsx("path", {
              d: "M94.6447579,36.4179636 C94.6447579,36.4179636 93.8470737,36.2950545 93.7258105,37.0911273 L93.4093895,39.1389818 C93.4093895,39.1389818 93.2881263,39.9350545 94.0858105,40.0579636 L99.0538105,40.8181091 C99.0538105,40.8181091 99.8514947,40.9410182 99.9746526,40.1449455 L100.289179,38.0970909 C100.289179,38.0970909 100.412337,37.3010182 99.6146526,37.18 L94.6447579,36.4179636 Z",
              id: "Fill-29",
              fill: $u.yellow500
            }), s.jsx("path", {
              d: "M102.803874,37.6682327 C102.803874,37.6682327 102.006189,37.5453236 101.884926,38.3413964 L101.568505,40.3892509 C101.568505,40.3892509 101.447242,41.1853236 102.244926,41.3082327 L107.212926,42.0683782 C107.212926,42.0683782 108.010611,42.1912873 108.133768,41.3952145 L108.448295,39.34736 C108.448295,39.34736 108.571453,38.5512873 107.773768,38.4302691 L102.803874,37.6682327 Z",
              id: "Fill-31",
              fill: $u.yellow500
            }), s.jsx("path", {
              d: "M120.941621,35.0922473 C120.941621,35.0922473 120.143937,34.9712291 120.020779,35.7654109 L119.706253,37.8132655 C119.706253,37.8132655 119.583095,38.6093382 120.380779,38.7322473 L125.350674,39.4923927 C125.350674,39.4923927 126.148358,39.6153018 126.271516,38.8192291 L126.586042,36.7713745 C126.586042,36.7713745 126.707305,35.9753018 125.911516,35.8542836 L120.941621,35.0922473 Z",
              id: "Fill-33",
              fill: $u.yellow500
            }), s.jsx("path", {
              d: "M110.948968,38.9154764 C110.948968,38.9154764 110.151284,38.7944582 110.030021,39.58864 L109.7136,41.6364945 C109.7136,41.6364945 109.592337,42.4325673 110.390021,42.5554764 L115.358021,43.3156218 C115.358021,43.3156218 116.155705,43.4385309 116.278863,42.6424582 L116.593389,40.5946036 C116.593389,40.5946036 116.716547,39.7985309 115.918863,39.6775127 L110.948968,38.9154764 Z",
              id: "Fill-35",
              fill: $u.yellow500
            }), s.jsx("path", {
              d: "M107.401832,33.0175418 C107.401832,33.0175418 106.604147,32.8965236 106.482884,33.6907055 L106.166463,35.73856 C106.166463,35.73856 106.0452,36.5346327 106.842884,36.6575418 L117.191937,38.2421236 C117.191937,38.2421236 117.987726,38.3650327 118.110884,37.56896 L118.425411,35.5229964 C118.425411,35.5229964 118.548568,34.7250327 117.750884,34.6040145 L107.401832,33.0175418 Z",
              id: "Fill-37",
              fill: $u.yellow500
            }), s.jsx("path", {
              d: "M98.3241474,31.6269673 C98.3241474,31.6269673 97.5264632,31.5040582 97.4033053,32.3001309 L97.0887789,34.3479855 C97.0887789,34.3479855 96.9656211,35.1440582 97.7652,35.2669673 L103.646463,36.16704 C103.646463,36.16704 104.444147,36.2899491 104.567305,35.4938764 L104.881832,33.4460218 C104.881832,33.4460218 105.004989,32.65184 104.207305,32.5289309 L98.3241474,31.6269673 Z",
              id: "Fill-39",
              fill: $u.yellow500
            }), s.jsx("path", {
              d: "M119.109032,40.1657455 C119.109032,40.1657455 118.311347,40.0447273 118.188189,40.8389091 L117.873663,42.8867636 C117.873663,42.8867636 117.750505,43.6828364 118.548189,43.8057455 L127.275347,45.1426182 C127.275347,45.1426182 128.073032,45.2655273 128.196189,44.4694545 L128.510716,42.4216 C128.510716,42.4216 128.633874,41.6255273 127.834295,41.5026182 L119.109032,40.1657455 Z",
              id: "Fill-41",
              fill: $u.yellow500
            }), s.jsx("path", {
              d: "M4.55968421,68.2200291 L5.01442105,75.6929018 C5.24747368,78.5406109 7.74663158,80.6565382 10.5982105,80.4258473 L49.7055789,77.24912 C50.1830526,80.9987927 50.2891579,89.2110109 42.1853684,89.8690473 L42.4184211,92.7299927 L66.3281053,90.78992 L66.0950526,87.9270836 C58.3607368,88.5548655 57.1727368,80.43152 57.0325263,76.6534836 L96.0603158,73.4824291 C98.91,73.2517382 101.034,70.7576291 100.800947,67.90992 L100.346211,60.4389382 L4.55968421,68.2200291 Z",
              id: "Fill-43",
              fill: $u.yellow500
            }), s.jsxs("g", {
              id: "Group-47",
              transform: "translate(0.000000, 1.109585)",
              children: [s.jsx("mask", {
                id: "mask-2",
                fill: "white",
                children: s.jsx("use", {
                  xlinkHref: "#path-1"
                })
              }), s.jsx("g", {
                id: "Clip-46"
              }), s.jsx("path", {
                d: "M95.8039579,5.53223273 C95.5709053,2.68452364 93.0736421,0.566705455 90.2220632,0.799287273 L4.75995789,7.74081455 C1.90648421,7.97339636 -0.215621053,10.4656145 0.0174315789,13.3133236 L4.55911579,69.0024873 L100.345642,61.2213964 L95.8039579,5.53223273 Z",
                id: "Fill-45",
                fill: $u.black,
                mask: "url(#mask-2)"
              })]
            }), s.jsx("polygon", {
              id: "Fill-48",
              fill: $u.white,
              points: "94.3597895 56.8080145 9.49073684 63.7022691 5.48147368 14.5556509 90.3505263 7.66139636"
            }), s.jsx("path", {
              d: "M31.1508,26.58032 C33.0000632,26.4290473 34.3756421,24.81232 34.2259579,22.9667927 C34.0743789,21.1231564 32.4543789,19.7484655 30.6051158,19.8978473 C28.7577474,20.04912 27.3802737,21.6658473 27.5299579,23.5113745 C27.6815368,25.3569018 29.3015368,26.7297018 31.1508,26.58032",
              id: "Fill-50",
              fill: $u.black
            }), s.jsx("path", {
              d: "M32.6643158,45.1403491 C34.5135789,44.9890764 35.8910526,43.3723491 35.7394737,41.5268218 C35.5878947,39.6831855 33.9678947,38.3084945 32.1186316,38.4578764 C30.2712632,38.6091491 28.8937895,40.2258764 29.0434737,42.0714036 C29.1950526,43.9169309 30.8150526,45.2916218 32.6643158,45.1403491",
              id: "Fill-52",
              fill: $u.black
            }), s.jsx("path", {
              d: "M68.8141895,32.8624873 C66.9649263,33.0118691 65.3430316,31.6390691 65.1933474,29.7935418 C65.0436632,27.9480145 66.4211368,26.3312873 68.2685053,26.1800145 C70.1158737,26.0306327 71.7377684,27.4053236 71.8893474,29.24896 C72.0390316,31.0944873 70.6615579,32.7112145 68.8141895,32.8624873",
              id: "Fill-54",
              fill: $u.black
            }), s.jsx("path", {
              d: "M70.3277053,51.4225164 C68.4784421,51.5718982 66.8584421,50.1990982 66.7068632,48.3535709 C66.5571789,46.5080436 67.9346526,44.8913164 69.7820211,44.7400436 C71.6312842,44.5906618 73.2512842,45.9653527 73.4028632,47.8089891 C73.5525474,49.6545164 72.1769684,51.2712436 70.3277053,51.4225164",
              id: "Fill-56",
              fill: $u.black
            }), s.jsx("path", {
              d: "M38.9804211,19.2178764 C38.9804211,19.2178764 36.9151579,19.3861673 37.0837895,21.4491491 L37.2903158,24.0056582 C37.2903158,24.0056582 37.4589474,26.06864 39.5261053,25.9003491 L69.3378947,23.4780945 C69.3378947,23.4780945 71.4050526,23.3098036 71.2364211,21.2487127 L71.028,18.6903127 C71.028,18.6903127 70.8593684,16.6273309 68.7922105,16.7956218 L38.9804211,19.2178764 Z",
              id: "Fill-58",
              fill: $u.yellow500
            }), s.jsx("path", {
              d: "M40.4948842,37.7780945 C40.4948842,37.7780945 38.4277263,37.9463855 38.5963579,40.0093673 L38.8047789,42.5658764 C38.8047789,42.5658764 38.9734105,44.6288582 41.0405684,44.4605673 L70.8504632,42.0383127 C70.8504632,42.0383127 72.9176211,41.8700218 72.7489895,39.8089309 L72.5424632,37.2505309 C72.5424632,37.2505309 72.3738316,35.1875491 70.3066737,35.35584 L40.4948842,37.7780945 Z",
              id: "Fill-60",
              fill: $u.yellow500
            }), s.jsx("path", {
              d: "M59.8937684,26.8609309 C59.8937684,26.8609309 61.9590316,26.69264 62.1276632,28.7556218 L62.3379789,31.3121309 C62.3379789,31.3121309 62.5047158,33.3751127 60.4394526,33.5434036 L30.6257684,35.9637673 C30.6257684,35.9637673 28.5605053,36.1320582 28.3918737,34.0709673 L28.1834526,31.5125673 C28.1834526,31.5125673 28.0148211,29.4514764 30.0819789,29.2831855 L59.8937684,26.8609309 Z",
              id: "Fill-62",
              fill: $u.yellow500
            }), s.jsx("path", {
              d: "M61.4072842,45.4211491 C61.4072842,45.4211491 63.4744421,45.2528582 63.6430737,47.31584 L63.8514947,49.8723491 C63.8514947,49.8723491 64.0182316,51.9353309 61.9529684,52.1036218 L32.1411789,54.5239855 C32.1411789,54.5239855 30.0740211,54.6922764 29.9053895,52.6311855 L29.6969684,50.0727855 C29.6969684,50.0727855 29.5283368,48.0116945 31.5954947,47.8434036 L61.4072842,45.4211491 Z",
              id: "Fill-64",
              fill: $u.yellow500
            }), s.jsx("path", {
              d: "M99.8626737,103.193527 L78.3176211,101.053018 C75.6005684,100.784509 73.6186737,98.3679273 73.8896211,95.6582545 L78.6454105,47.9903273 C78.9163579,45.2806545 81.3359368,43.3027636 84.0510947,43.5712727 L105.598042,45.7136727 C108.311305,45.9840727 110.2932,48.3987636 110.024147,51.1084364 L105.268358,98.7763636 C104.997411,101.486036 102.577832,103.463927 99.8626737,103.193527",
              id: "Fill-66",
              fill: $u.yellow500
            }), s.jsx("polygon", {
              id: "Fill-68",
              fill: $u.white,
              points: "103.5144 94.8967855 76.2984 92.1927855 80.4421895 50.6570764 107.658189 53.3610764"
            }), s.jsx("path", {
              d: "M91.9665474,97.8171055 C91.8358105,99.1218327 90.6705474,100.074851 89.3631789,99.9443782 C88.0577053,99.8139055 87.1027579,98.6509964 87.2316,97.3462691 C87.3623368,96.0415418 88.5276,95.0904145 89.8349684,95.2189964 C91.1423368,95.3494691 92.0972842,96.5123782 91.9665474,97.8171055",
              id: "Fill-70",
              fill: $u.white
            }), s.jsx("path", {
              d: "M98.1881053,49.2776582 L92.2481053,48.6876945 C92.0055789,48.6631127 91.8293684,48.4475491 91.8521053,48.2055127 C91.8767368,47.9634764 92.0927368,47.7876218 92.3352632,47.8122036 L98.2752632,48.4021673 C98.5177895,48.4248582 98.694,48.6404218 98.6693684,48.8843491 C98.6466316,49.1244945 98.4306316,49.30224 98.1881053,49.2776582",
              id: "Fill-72",
              fill: $u.black
            }), s.jsx("path", {
              d: "M90.4916842,48.5131636 L89.9801053,48.4621091 C89.7375789,48.4375273 89.5613684,48.2238545 89.5841053,47.9799273 C89.6087368,47.7378909 89.8247368,47.5620364 90.0672632,47.5866182 L90.5788421,47.6376727 C90.8213684,47.6603636 90.9994737,47.8759273 90.9748421,48.1198545 C90.9502105,48.36 90.7342105,48.5358545 90.4916842,48.5131636",
              id: "Fill-74",
              fill: $u.black
            }), s.jsx("line", {
              x1: "82.5557684",
              y1: "67.2220073",
              x2: "102.156821",
              y2: "69.1696436",
              id: "Stroke-76",
              stroke: $u.black,
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }), s.jsx("line", {
              x1: "82.1883789",
              y1: "70.9049309",
              x2: "100.866695",
              y2: "72.7599127",
              id: "Stroke-78",
              stroke: $u.black,
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }), s.jsx("line", {
              x1: "81.8202316",
              y1: "74.5889891",
              x2: "99.4014947",
              y2: "76.3361891",
              id: "Stroke-80",
              stroke: $u.black,
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }), s.jsx("line", {
              x1: "81.4528421",
              y1: "78.2728582",
              x2: "97.1867368",
              y2: "79.83664",
              id: "Stroke-82",
              stroke: $u.black,
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }), s.jsx("line", {
              x1: "81.0856421",
              y1: "81.9567273",
              x2: "100.686695",
              y2: "83.9043636",
              id: "Stroke-84",
              stroke: $u.black,
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }), s.jsx("line", {
              x1: "80.7182526",
              y1: "85.6407855",
              x2: "95.7056211",
              y2: "87.1308218",
              id: "Stroke-86",
              stroke: $u.black,
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }), s.jsx("path", {
              d: "M85.2406105,63.5721745 C86.8928211,63.7366836 88.3631368,62.5340655 88.5279789,60.8870836 C88.6928211,59.2382109 87.4877684,57.7689745 85.8355579,57.6044655 C84.1833474,57.4399564 82.7130316,58.6425745 82.5481895,60.2914473 C82.3833474,61.9384291 83.5884,63.4095564 85.2406105,63.5721745",
              id: "Fill-88",
              fill: $u.black
            })]
          })
        })
      })]
    }));
  }

  Gu.defaultProps = {
    size: 150
  }, Gu.propTypes = {
    size: T["default"].oneOfType([T["default"].array, T["default"].number, T["default"].string])
  };
  var Yu = gc.colors;

  function Qu(e) {
    var t = e.size,
        n = _objectWithoutProperties(e, _excluded31);

    return s.jsxs(ms, _objectSpread(_objectSpread({
      size: t,
      version: "1.1",
      id: "blog-pencil",
      xmlns: "http://www.w3.org/2000/svg",
      x: "0px",
      y: "0px",
      viewBox: "0 0 60.593 42.962",
      style: {
        enableBackground: "new 0 0 60.593 42.962"
      }
    }, n), {}, {
      children: [s.jsx("path", {
        fill: Yu.yellow500,
        d: "M60.399,2.241c0.621,1.751-0.295,3.674-2.046,4.295c-1.751,0.621-3.674-0.295-4.295-2.046 s0.295-3.674,2.046-4.295C57.854-0.427,59.777,0.489,60.399,2.241z"
      }), s.jsx("polygon", {
        fill: Yu.white,
        points: "12.393,42.962 19.67,41.617 20.846,39.321 16.931,35.314 14.691,35.928 "
      }), s.jsx("polygon", {
        fill: Yu.yellow500,
        points: "16.872,35.693 16.351,37.824 16.351,37.824 16.351,37.824 16.351,37.824 16.351,37.824 18.531,37.59 18.01,39.72 20.192,39.485 19.67,41.617 55.484,9.782 53.823,7.886 52.165,5.99 52.165,5.99 50.504,4.093 14.691,35.928 "
      }), s.jsx("polygon", {
        fill: Yu.white,
        points: "58.227,4.022 56.568,2.126 54.907,0.229 50.51,4.1 55.49,9.789 59.887,5.918 "
      }), s.jsx("polygon", {
        fill: Yu.black,
        points: "13.542,39.445 12.393,42.962 16.032,42.289 "
      }), s.jsx("path", {
        fill: Yu.black,
        d: "M56.714,9.153c-0.141,0-0.28-0.059-0.38-0.174L51.411,3.24c-0.18-0.209-0.155-0.525,0.055-0.705 c0.209-0.179,0.524-0.156,0.705,0.054l4.924,5.739c0.18,0.209,0.155,0.525-0.055,0.705C56.946,9.113,56.83,9.153,56.714,9.153z"
      }), s.jsx("path", {
        fill: Yu.black,
        d: "M58.584,7.631c-0.141,0-0.28-0.059-0.38-0.174L53.28,1.718c-0.18-0.209-0.155-0.525,0.055-0.705 c0.209-0.179,0.524-0.156,0.705,0.054l4.924,5.739c0.18,0.209,0.155,0.525-0.055,0.705C58.815,7.591,58.699,7.631,58.584,7.631z"
      }), s.jsx("path", {
        fill: Yu.black,
        d: "M12.393,42.962H0.579c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h12.186 C13.042,41.962,12.393,42.962,12.393,42.962z"
      })]
    }));
  }

  Qu.defaultProps = {
    size: 160
  }, Qu.propTypes = {
    size: T["default"].oneOfType([T["default"].array, T["default"].number, T["default"].string])
  };
  var Xu = gc.colors;

  function Ku(e) {
    var t = e.size,
        n = _objectWithoutProperties(e, _excluded32);

    return s.jsxs(ms, _objectSpread(_objectSpread({
      size: t,
      x: "0px",
      y: "0px",
      viewBox: "0 0 118.183 56.397"
    }, n), {}, {
      children: [s.jsx("path", {
        fill: "none",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        stroke: Xu.yellow500,
        d: "M85.05,56.482c-.4-10.1-.9-23.2-1-23.8-.1-.3-.1-.5-.2-.8-.3-.9-1.2-1.2-1.9-1.9a21.976,21.976,0,0,1-2-2.3,23.293,23.293,0,0,1-2.6-3.8c-.6-1.1-3.3-3.2-4.1-3.7s-2.2-.6-2.1-1.5c0-.9,2.9-2.1,5.9.6,2.9,2.7,5,2.5,5.8,1.8s1.3-2.8,1.4-4.4a32.055,32.055,0,0,0-.1-5.4c-.2-1.6,0-4.4-.2-6.9-.2-2.4.4-2.7,1.3-3s1,.4,1.3,1.3.3,3.3.6,5.4.5,5.4.6,6.1,1.3.8,1.6,0c.3-.9.1-3.9.6-5.4.4-1.5.3-2.3,1-4.8.7-2.6,1.5-3.6,2.6-3.2,1.2.3.7,1.5.4,2.8-.3,1.2-.4,2.7-.7,4.6-.4,1.9-.4,3.1-.8,4.6s-.3,2.1.3,2.2c.6,0,1.6-1.8,2-2.8a10.377,10.377,0,0,1,1-2.1c.4-.7,1.3-2.8,1.9-3.9s1.3-2,2-1.9,1,.3,1.1,1.1a10.251,10.251,0,0,1-1.2,3.3c-.6,1-1,2.5-1.9,4.4s-2.2,4.2-1.9,4.9,1.1,0,2-.7,1.1-.8,2.5-1.9,1.6-1.5,2.9-2.6c1.3-1.2,1.6-.8,2.1,0,.5.7-2.5,3.7-4.2,5.4a12.81,12.81,0,0,0-3.2,4c-.9,1.8-1.8,5.7-2.4,7.1-.3.8-1.1,1.8-1.4,2.7a1.268,1.268,0,0,0-.1.6c0,.3,1.1,13.9,2,24"
      }), s.jsx("path", {
        fill: Xu.yellow500,
        d: "M46.928,56.4c.7-10.6,1.622-23.915,1.522-24.215a1.421,1.421,0,0,0-.2-.6,27.965,27.965,0,0,0-1.4-2.5c-.6-1.3-1.6-5-2.5-6.7a13.31,13.31,0,0,0-3.1-3.8c-1.6-1.6-4.6-4.4-4.1-5,.4-.7.7-1.1,2,0a21.722,21.722,0,0,0,2.9,2.4c1.4,1,1.6,1.2,2.4,1.8s1.6,1.3,1.9.6-1-2.7-2-4.6-1.4-3.3-2-4.2a7.936,7.936,0,0,1-1.3-3.1c0-.7.3-1,1-1.1s1.3.7,1.9,1.8c.6,1,1.5,3.1,1.9,3.7a6.194,6.194,0,0,1,1,2c.4.9,1.3,2.7,1.9,2.6q.9,0,.3-2.1c-.4-1.4-.5-2.6-.9-4.3-.4-1.8-.5-3.2-.8-4.3-.3-1.2-.8-2.3.3-2.6s1.9.6,2.6,3,.7,3.1,1.1,4.6c.4,1.4.4,4.3.7,5.1a.78.78,0,0,0,1.5,0c.1-.7.2-3.8.4-5.8s.2-4.2.4-5.1.3-1.5,1.2-1.3,1.4.5,1.3,2.8.2,5.1,0,6.5a22.724,22.724,0,0,0,.1,5.2c.1,1.6.7,3.6,1.5,4.2s2.7.8,5.5-1.9c2.7-2.7,5.5-1.6,5.5-.7s-1.3,1-2,1.5-3.3,2.5-3.8,3.6a23.486,23.486,0,0,1-2.4,3.7,20,20,0,0,1-1.9,2.2c-.7.6-1.5,1-1.8,1.8a1.483,1.483,0,0,1,.1.7c-.1.5-.376,13.615-.676,24.115Z"
      }), s.jsx("path", {
        fill: "none",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        stroke: Xu.yellow500,
        d: "M11.728,56.4c.376-5.7.65-10.087.593-10.258a1.421,1.421,0,0,0-.2-.6,27.965,27.965,0,0,0-1.4-2.5c-.6-1.3-1.6-5-2.5-6.7a13.31,13.31,0,0,0-3.1-3.8c-1.6-1.6-4.6-4.4-4.1-5,.4-.7.7-1.1,2,0a21.722,21.722,0,0,0,2.9,2.4c1.4,1,1.6,1.2,2.4,1.8s1.6,1.3,1.9.6-1-2.7-2-4.6-1.4-3.3-2-4.2a7.936,7.936,0,0,1-1.3-3.1c0-.7.3-1,1-1.1s1.3.7,1.9,1.8c.6,1,1.5,3.1,1.9,3.7a6.194,6.194,0,0,1,1,2c.4.9,1.3,2.7,1.9,2.6q.9,0,.3-2.1c-.4-1.4-.5-2.6-.9-4.3-.4-1.8-.5-3.2-.8-4.3-.3-1.2-.8-2.3.3-2.6s1.9.6,2.6,3,.7,3.1,1.1,4.6c.4,1.4.4,4.3.7,5.1a.78.78,0,0,0,1.5,0c.1-.7.2-3.8.4-5.8s.2-4.2.4-5.1.3-1.5,1.2-1.3,1.4.5,1.3,2.8.2,5.1,0,6.5a22.724,22.724,0,0,0,.1,5.2c.1,1.6.7,3.6,1.5,4.2s2.7.8,5.5-1.9c2.7-2.7,5.5-1.6,5.5-.7s-1.3,1-2,1.5-3.3,2.5-3.8,3.6a23.486,23.486,0,0,1-2.4,3.7,20,20,0,0,1-1.9,2.2c-.7.6-1.5,1-1.8,1.8a1.483,1.483,0,0,1,.1.7c-.057.285-.171,4.675-.315,10.343"
      }), s.jsx("path", {
        fill: Xu.black,
        d: "M73.95,43.482c0-.2.1-.4.1-.6.3-.9,1.1-1.9,1.4-2.7.6-1.4,1.5-5.3,2.4-7.1a11.78,11.78,0,0,1,3.2-4c1.7-1.7,4.7-4.7,4.2-5.4s-.8-1.1-2.1,0a23.484,23.484,0,0,1-2.9,2.6c-1.4,1-1.6,1.3-2.5,1.9-.9.7-1.6,1.4-2,.7-.3-.7.9-2.9,1.9-4.9s1.4-3.5,1.9-4.4a7.026,7.026,0,0,0,1.2-3.3c0-.8-.4-1-1.1-1.1s-1.4.8-2,1.9-1.5,3.3-1.9,3.9a8.222,8.222,0,0,0-1,2.1c-.3,1-1.3,2.9-2,2.8-.6,0-.7-.7-.3-2.2s.4-2.7.8-4.6.4-3.4.7-4.6.8-2.4-.4-2.8c-1.2-.3-1.9.7-2.6,3.2-.7,2.6-.6,3.3-1,4.8s-.3,4.5-.6,5.4a.82.82,0,0,1-1.6,0c-.2-.8-.3-4-.6-6.1s-.3-4.4-.6-5.4c-.3-.9-.4-1.6-1.3-1.3s-1.5.6-1.3,3-.1,5.3.2,6.9a32.269,32.269,0,0,1,.1,5.4c-.1,1.7-.6,3.8-1.4,4.4-.8.7-2.9.9-5.8-1.8s-5.8-1.5-5.9-.6c0,.9,1.3,1.1,2.1,1.5.8.5,3.5,2.6,4.1,3.7a23.293,23.293,0,0,0,2.6,3.8,21.976,21.976,0,0,0,2,2.3c.7.7,1.6,1,1.9,1.9.1.3.1.5.2.8s.632,12.815.632,12.815H74.945S73.95,43.782,73.95,43.482Z"
      }), s.jsx("path", {
        fill: "none",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        stroke: Xu.black,
        d: "M31.25,56.482c.4-3.3.8-5.7.8-5.8a1.268,1.268,0,0,0-.1-.6c-.3-.9-.9-1.9-1.2-2.6-.5-1.3-1.2-5.1-1.9-6.8a11.948,11.948,0,0,0-2.7-3.9c-1.5-1.6-4-4.6-3.6-5.3.5-.7.8-1,1.9.1a15.987,15.987,0,0,0,2.6,2.6c1.3,1.1,1.4,1.3,2.2,1.9.7.7,1.4,1.4,1.7.8s-.7-2.8-1.5-4.7-1.1-3.3-1.6-4.3a9,9,0,0,1-1-3.2c0-.8.4-1,1-1,.7-.1,1.2.8,1.7,1.9s1.2,3.2,1.6,3.8a7.475,7.475,0,0,1,.9,2c.3,1,1.1,2.8,1.6,2.7.6,0,.7-.7.4-2-.3-1.4-.3-2.6-.5-4.4a34.217,34.217,0,0,0-.5-4.3c-.2-1.2-.6-2.3.5-2.6s1.7.7,2.3,3.2.4,3.1.7,4.6c.3,1.4,0,4.2.3,5.1.2.8,1.3.8,1.4.1.2-.7.5-3.8.9-5.7s.5-4.2.8-5c.3-.9.4-1.4,1.2-1.2.8.3,1.3.6,1.1,2.9-.3,2.3-.2,5-.5,6.5a28.545,28.545,0,0,0-.3,5.1c0,1.6.4,3.6,1.1,4.2.7.7,2.6,1,5.4-1.4s5.4-1.2,5.4-.3-1.3.9-2,1.3a16.71,16.71,0,0,0-3.9,3.3,21.14,21.14,0,0,1-2.6,3.5,18.883,18.883,0,0,1-2,2c-.7.6-1.5.8-1.9,1.7a2.353,2.353,0,0,0-.2.8c0,.2-.2,2.2-.5,5.1"
      }), s.jsx("path", {
        fill: "none",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        stroke: Xu.black,
        d: "M107.8,56.582c-.079-1.107-.122-1.791-.122-1.881,0-.167.083-.333.083-.5.25-.749.915-1.581,1.165-2.247.5-1.165,1.248-4.41,2-5.908a9.8,9.8,0,0,1,2.663-3.328c1.414-1.414,3.91-3.911,3.494-4.493s-.665-.915-1.747,0a19.585,19.585,0,0,1-2.413,2.163c-1.165.832-1.331,1.082-2.08,1.581-.749.583-1.332,1.165-1.664.583-.25-.583.748-2.413,1.58-4.077s1.165-2.913,1.581-3.661a5.848,5.848,0,0,0,1-2.746c0-.666-.333-.832-.915-.916s-1.165.666-1.664,1.581-1.249,2.746-1.581,3.245a6.83,6.83,0,0,0-.832,1.748c-.25.832-1.082,2.413-1.665,2.33-.5,0-.582-.583-.249-1.831s.333-2.247.665-3.827.333-2.83.583-3.828.666-2-.333-2.33c-1-.249-1.581.583-2.163,2.663-.583,2.163-.5,2.746-.832,3.994s-.25,3.744-.5,4.493a.682.682,0,0,1-1.331,0c-.166-.666-.25-3.328-.5-5.076s-.25-3.661-.5-4.493c-.25-.749-.333-1.331-1.082-1.082s-1.248.5-1.082,2.5-.083,4.41.167,5.741a26.915,26.915,0,0,1,.083,4.493c-.083,1.415-.5,3.162-1.165,3.661-.666.583-2.413.749-4.826-1.5s-4.826-1.248-4.909-.5c0,.749,1.081.915,1.747,1.248a14.69,14.69,0,0,1,3.412,3.079,19.365,19.365,0,0,0,2.163,3.162A18.321,18.321,0,0,0,97.7,52.537c.583.583,1.331.833,1.581,1.581.083.25.083.416.166.666.02.059.058.687.105,1.613"
      })]
    }));
  }

  Ku.defaultProps = {
    size: 150
  }, Ku.propTypes = {
    size: T["default"].oneOfType([T["default"].array, T["default"].number, T["default"].string])
  };
  var Ju = gc.colors;

  function ed(e) {
    var t = e.size,
        n = _objectWithoutProperties(e, _excluded33);

    return s.jsxs(ms, _objectSpread(_objectSpread({
      size: t,
      x: "0px",
      y: "0px",
      viewBox: "0 0 118.183 56.397"
    }, n), {}, {
      children: [s.jsx("path", {
        fill: Ju.yellow500,
        d: "M74.807,56.4c-.3-10.5-.576-23.615-.676-24.115a1.483,1.483,0,0,1,.1-.7c-.3-.8-1.1-1.2-1.8-1.8a20,20,0,0,1-1.9-2.2,23.486,23.486,0,0,1-2.4-3.7c-.5-1.1-3.1-3.1-3.8-3.6s-2-.6-2-1.5,2.8-2,5.5.7c2.8,2.7,4.7,2.5,5.5,1.9s1.4-2.6,1.5-4.2a22.724,22.724,0,0,0,.1-5.2c-.2-1.4.1-4.2,0-6.5s.4-2.6,1.3-2.8,1,.4,1.2,1.3.2,3.1.4,5.1.3,5.1.4,5.8a.78.78,0,0,0,1.5,0c.3-.8.3-3.7.7-5.1.4-1.5.4-2.2,1.1-4.6s1.5-3.3,2.6-3,.6,1.4.3,2.6c-.3,1.1-.4,2.5-.8,4.3-.4,1.7-.5,2.9-.9,4.3s-.3,2.1.3,2.1c.6.1,1.5-1.7,1.9-2.6a6.194,6.194,0,0,1,1-2c.4-.6,1.3-2.7,1.9-3.7.6-1.1,1.2-1.9,1.9-1.8s1,.4,1,1.1a7.936,7.936,0,0,1-1.3,3.1c-.6.9-1,2.3-2,4.2s-2.3,3.9-2,4.6,1.1,0,1.9-.6,1-.8,2.4-1.8a21.722,21.722,0,0,0,2.9-2.4c1.3-1.1,1.6-.7,2,0,.5.6-2.5,3.4-4.1,5a13.31,13.31,0,0,0-3.1,3.8c-.9,1.7-1.9,5.4-2.5,6.7a27.965,27.965,0,0,0-1.4,2.5,1.421,1.421,0,0,0-.2.6c-.1.3.823,13.615,1.523,24.215Z"
      }), s.jsx("path", {
        fill: "none",
        stroke: Ju.black,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M30.239,56.482c.4-3.3.8-5.7.8-5.8a1.268,1.268,0,0,0-.1-.6c-.3-.9-.9-1.9-1.2-2.6-.5-1.3-1.2-5.1-1.9-6.8a11.948,11.948,0,0,0-2.7-3.9c-1.5-1.6-4-4.6-3.6-5.3.5-.7.8-1,1.9.1a15.987,15.987,0,0,0,2.6,2.6c1.3,1.1,1.4,1.3,2.2,1.9.7.7,1.4,1.4,1.7.8s-.7-2.8-1.5-4.7-1.1-3.3-1.6-4.3a9,9,0,0,1-1-3.2c0-.8.4-1,1-1,.7-.1,1.2.8,1.7,1.9s1.2,3.2,1.6,3.8a7.475,7.475,0,0,1,.9,2c.3,1,1.1,2.8,1.6,2.7.6,0,.7-.7.4-2-.3-1.4-.3-2.6-.5-4.4a34.217,34.217,0,0,0-.5-4.3c-.2-1.2-.6-2.3.5-2.6s1.7.7,2.3,3.2.4,3.1.7,4.6c.3,1.4,0,4.2.3,5.1.2.8,1.3.8,1.4.1.2-.7.5-3.8.9-5.7s.5-4.2.8-5c.3-.9.4-1.4,1.2-1.2.8.3,1.3.6,1.1,2.9-.3,2.3-.2,5-.5,6.5a28.545,28.545,0,0,0-.3,5.1c0,1.6.4,3.6,1.1,4.2.7.7,2.6,1,5.4-1.4s5.4-1.2,5.4-.3-1.3.9-2,1.3a16.71,16.71,0,0,0-3.9,3.3,21.14,21.14,0,0,1-2.6,3.5,18.883,18.883,0,0,1-2,2c-.7.6-1.5.8-1.9,1.7a2.353,2.353,0,0,0-.2.8c0,.2-.2,2.2-.5,5.1"
      })]
    }));
  }

  ed.defaultProps = {
    size: 150
  }, ed.propTypes = {
    size: T["default"].oneOfType([T["default"].array, T["default"].number, T["default"].string])
  };

  var td = _["default"].input.withConfig({
    displayName: "HiddenInput",
    componentId: "sc-11j8qxt-0"
  })(["border:0;cursor:pointer;margin:0;opacity:0;outline:0;padding:0;position:absolute;"]),
      nd = function nd(e) {
    return e.adaptive ? ["24px", null, "2rem"] : e.small ? "24px" : "2rem";
  },
      rd = _["default"](fe).attrs(function (e) {
    return {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      size: nd(e),
      bg: "white",
      borderRadius: "rounded",
      flexShrink: 0
    };
  }).withConfig({
    displayName: "CheckboxControl__CheckboxOutline",
    componentId: "sc-j3rrwj-0"
  })(["box-shadow:0 0 0 1px ", ";cursor:", ";transition:box-shadow 0.3s linear;input:focus + &{box-shadow:0 0 0 2px ", ";}"], function (e) {
    return e.hideOutline ? "transparent" : e.theme.colors.gray600;
  }, function (e) {
    return e.disabled ? "not-allowed" : "pointer";
  }, function (e) {
    return e.theme.colors.blue500;
  });

  rd.displayName = "CheckboxOutline";

  var od = function od(e) {
    return e.adaptive ? [0, null, 1] : e.small ? 0 : 1;
  },
      id = _["default"](Ja(mc)).attrs(function (e) {
    return {
      icon: e.icon,
      weight: "solid",
      fontSize: od(e),
      position: "relative",
      top: "1px"
    };
  }).withConfig({
    displayName: "CheckboxControl__Check",
    componentId: "sc-j3rrwj-1"
  })([""]);

  function ad(e) {
    var t = e.adaptive,
        n = e.checked,
        r = e.hideOutline,
        o = e.onChange,
        i = e.onBlur,
        a = e.name,
        l = e.small,
        c = e.value,
        u = e.icon,
        d = e.disabled,
        f = _objectWithoutProperties(e, _excluded34);

    return s.jsxs(s.Fragment, {
      children: [s.jsx(td, _objectSpread({
        type: "checkbox",
        checked: n,
        onChange: o,
        onBlur: i,
        name: a,
        value: c,
        disabled: d
      }, f)), s.jsx(rd, {
        adaptive: t,
        small: l,
        hideOutline: r,
        disabled: d,
        children: s.jsx(id, {
          adaptive: t,
          small: l,
          icon: u,
          initial: !1,
          animate: {
            opacity: n ? 1 : 0,
            scale: n ? 1 : .5
          },
          transition: {
            type: "spring",
            stiffness: 500,
            damping: 30,
            mass: .5
          }
        }, "check-".concat(c))
      })]
    });
  }

  function sd(e) {
    var t = e.adaptive,
        n = e.checked,
        r = e.hideOutline,
        o = e.label,
        i = e.name,
        a = e.onBlur,
        l = e.onChange,
        c = e.small,
        u = e.value,
        d = e.icon,
        f = e.disabled;
    var p = od({
      adaptive: t,
      small: c
    });
    return s.jsx(ys, {
      as: "label",
      cursor: f ? "not-allowed" : "pointer",
      display: "inline-block",
      children: s.jsxs(fe, {
        display: "flex",
        children: [s.jsx(fe, {
          display: "inline-block",
          pr: 2,
          flex: "1 0 auto",
          children: s.jsx(ad, {
            checked: n,
            onChange: l,
            onBlur: a,
            name: i,
            value: u,
            adaptive: t,
            small: c,
            hideOutline: r,
            icon: d,
            disabled: f
          })
        }), s.jsx(ys, {
          as: "span",
          position: "relative",
          top: t ? ["1px", null, "0.25rem"] : c ? "1px" : "0.25rem",
          fontSize: p,
          children: o
        })]
      })
    });
  }

  id.displayName = "Check", ad.defaultProps = {
    adaptive: !1,
    checked: !1,
    hideOutline: !1,
    small: !1,
    onBlur: void 0,
    disabled: !1,
    icon: "check"
  }, ad.propTypes = {
    adaptive: T["default"].bool,
    checked: T["default"].bool,
    hideOutline: T["default"].bool,
    icon: T["default"].string,
    onChange: T["default"].func.isRequired,
    onBlur: T["default"].func,
    name: T["default"].string.isRequired,
    small: T["default"].bool,
    disabled: T["default"].bool,
    value: T["default"].oneOfType([T["default"].string, T["default"].number, T["default"].object, T["default"].bool]).isRequired
  }, sd.defaultProps = {
    adaptive: !1,
    checked: !1,
    hideOutline: !1,
    onBlur: void 0,
    small: !1,
    disabled: !1,
    icon: "check"
  }, sd.propTypes = {
    adaptive: T["default"].bool,
    checked: T["default"].bool,
    disabled: T["default"].bool,
    hideOutline: T["default"].bool,
    label: T["default"].oneOfType([T["default"].string, T["default"].node]).isRequired,
    onChange: T["default"].func.isRequired,
    onBlur: T["default"].func,
    name: T["default"].string.isRequired,
    small: T["default"].bool,
    icon: T["default"].string,
    value: T["default"].oneOfType([T["default"].string, T["default"].number, T["default"].object, T["default"].bool]).isRequired
  };

  var ld = "3rem",
      cd = t.css(["appearance:none;background:", ";color:", ";border:none;border-radius:", ";cursor:", ";display:block;filter:none;font-family:inherit;font-size:", ";width:100%;box-shadow:", ";::placeholder{color:rgba(35,31,32,0.5);}::-moz-placeholder{color:rgba(35,31,32,0.5);opacity:1;}&:focus{box-shadow:0 0 0 2px ", ";outline:none;}transition:box-shadow 0.125s linear;", ""], function (e) {
    return e.secondary ? e.theme.colors.blue500 : e.theme.colors.white;
  }, function (e) {
    return e.secondary ? e.theme.colors.white : e.theme.colors.black;
  }, function (e) {
    return e.pill ? e.theme.radii.extraLarge : e.theme.radii.rounded;
  }, function (e) {
    return e.disabled ? "not-allowed" : "initial";
  }, function (e) {
    return e.theme.fontSizes[1];
  }, function (e) {
    return e.error ? "0 0 0 2px ".concat(e.theme.colors.red700) : "0 0 0 1px ".concat(e.theme.colors.gray600);
  }, function (e) {
    return e.theme.colors.blue500;
  }, n.space),
      ud = _["default"](ys).attrs(function () {
    return {
      as: "span",
      fontWeight: 600,
      fontSize: "12px",
      position: "absolute",
      top: "0.25rem"
    };
  }).withConfig({
    displayName: "setup__LabelText",
    componentId: "sc-1sxeqq2-0"
  })([""]);

  function dd(e) {
    var t = e.children;
    return s.jsx(fe, {
      role: "alert",
      mt: 1,
      fontSize: 0,
      color: "red900",
      children: t
    });
  }

  function fd(e) {
    var t = e.children,
        n = e.limitIconHeight,
        r = _objectWithoutProperties(e, _excluded35);

    return s.jsx(fe, _objectSpread(_objectSpread({
      position: "absolute",
      top: 0,
      bottom: 0,
      maxHeight: n ? "3.375rem" : "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: ld
    }, r), {}, {
      children: t
    }));
  }

  function pd(e) {
    var t = e.children,
        n = e.error,
        r = e.icon,
        o = e.iconRight,
        i = e.label,
        a = e.limitIconHeight,
        l = _objectWithoutProperties(e, _excluded36);

    return s.jsxs(s.Fragment, {
      children: [s.jsxs(fe, _objectSpread(_objectSpread({
        as: "label",
        display: "block",
        position: "relative"
      }, l), {}, {
        children: [r && s.jsx(fd, {
          left: 0,
          style: {
            pointerEvents: "none"
          },
          zIndex: 1,
          limitIconHeight: a,
          children: "string" == typeof r ? s.jsx(mc, {
            icon: r
          }) : r
        }), o && s.jsx(fd, {
          right: 0,
          zIndex: 1,
          limitIconHeight: a,
          children: "string" == typeof o ? s.jsx(mc, {
            icon: o
          }) : o
        }), i && s.jsx(ud, {
          zIndex: 1,
          left: r ? ld : 3,
          children: i
        }), t]
      })), "boolean" != typeof n && s.jsx(dd, {
        children: n
      })]
    });
  }

  dd.propTypes = {
    children: T["default"].node.isRequired
  }, fd.defaultProps = {
    limitIconHeight: !1
  }, fd.propTypes = {
    children: T["default"].node.isRequired,
    limitIconHeight: T["default"].bool
  }, pd.defaultProps = {
    error: !1,
    icon: null,
    iconRight: null,
    label: null,
    limitIconHeight: !1
  }, pd.propTypes = {
    children: T["default"].node.isRequired,
    error: T["default"].oneOfType([T["default"].string, T["default"].bool, T["default"].node]),
    icon: T["default"].oneOfType([T["default"].string, T["default"].node]),
    iconRight: T["default"].oneOfType([T["default"].string, T["default"].node]),
    limitIconHeight: T["default"].bool,
    label: T["default"].string
  };

  var hd = _["default"].input.withConfig({
    displayName: "Input__StyledInput",
    componentId: "sc-1gh4ef5-0"
  })(["", " ", ";line-height:1.4;"], cd, n.border);

  function md(e, t) {
    var n = e.disabled,
        r = e.error,
        o = e.icon,
        i = e.iconRight,
        a = e.label,
        l = e.type,
        c = _objectWithoutProperties(e, _excluded37);

    return s.jsx(pd, {
      icon: o,
      iconRight: i,
      label: a,
      error: r,
      children: s.jsx(hd, _objectSpread({
        disabled: n,
        type: l || "text",
        error: Boolean(r),
        pt: a ? "1.5rem" : 2,
        pl: o ? ld : 3,
        pr: i ? ld : 3,
        pb: 2,
        ref: t
      }, c))
    });
  }

  var gd = o.forwardRef(md);
  md.defaultProps = {
    disabled: !1,
    error: !1,
    icon: null,
    label: null,
    type: "text",
    iconRight: null
  }, md.propTypes = {
    disabled: T["default"].bool,
    error: T["default"].oneOfType([T["default"].string, T["default"].bool, T["default"].node]),
    icon: T["default"].oneOfType([T["default"].string, T["default"].node]),
    iconRight: T["default"].oneOfType([T["default"].string, T["default"].node]),
    label: T["default"].string,
    type: T["default"].oneOf(["date", "email", "text", "tel", "number", "password"])
  };

  var yd = _["default"](fe).attrs(function () {
    return {
      display: "inline-block",
      position: "relative",
      width: "100%",
      borderRadius: "rounded"
    };
  }).withConfig({
    displayName: "NumberPicker__Wrapper",
    componentId: "sc-1y3lm9a-0"
  })([""]),
      bd = _["default"](js).attrs(function () {
    return {
      display: "flex",
      position: "absolute",
      width: "3.75rem",
      padding: "0"
    };
  }).withConfig({
    displayName: "NumberPicker__StyledButton",
    componentId: "sc-1y3lm9a-1"
  })(["justify-content:center;align-items:center;"]),
      vd = _["default"].input.withConfig({
    displayName: "NumberPicker__BigInput",
    componentId: "sc-1y3lm9a-2"
  })(["", " width:100%;height:3.625rem;text-align:center;border-radius:", ";-moz-appearance:textfield;&:focus{box-shadow:0 0 0 2px ", ";}&::-webkit-outer-spin-button,&::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}"], cd, function (e) {
    return e.theme.radii.rounded;
  }, function (e) {
    return e.theme.colors.blue500;
  });

  function xd(e) {
    var t = e.value,
        n = e.onChange,
        r = e.minNumber,
        i = e.maxNumber;
    if (i < r) throw new Error("minNumber must be less than maxNumber");

    var _o$useState = o.useState(t),
        _o$useState2 = _slicedToArray(_o$useState, 2),
        a = _o$useState2[0],
        l = _o$useState2[1],
        c = function c(e) {
      l(e), n(e);
    };

    return s.jsxs(yd, {
      children: [s.jsx(bd, {
        borderRadius: "4px 0px 0px 4px",
        top: "-1px",
        left: "-1px",
        bottom: "-1px",
        disabled: a <= r,
        "data-testid": "subtract-button",
        onClick: function onClick() {
          c(a - 1);
        },
        children: s.jsx(mc, {
          icon: "minus"
        })
      }), s.jsx(vd, {
        "data-testid": "input-value",
        type: "number",
        onBlur: function onBlur(e) {
          var t;
          (t = e).target.value > i ? c(i) : t.target.value < r ? c(r) : c(Number(t.target.value));
        },
        onChange: function onChange(e) {
          return c(e.target.value);
        },
        onWheel: function onWheel() {},
        value: a,
        px: "4.6rem"
      }), s.jsx(bd, {
        borderRadius: "0px 4px 4px 0px",
        top: "-1px",
        right: "-1px",
        bottom: "-1px",
        disabled: a >= i,
        "data-testid": "addition-button",
        onClick: function onClick() {
          c(a + 1);
        },
        children: s.jsx(mc, {
          icon: "plus",
          fontSize: 3
        })
      })]
    });
  }

  xd.propTypes = {
    value: T["default"].number.isRequired,
    onChange: T["default"].func.isRequired,
    minNumber: T["default"].number,
    maxNumber: T["default"].number
  }, xd.defaultProps = {
    minNumber: -1 / 0,
    maxNumber: 1 / 0
  };

  var wd = _["default"](fe).attrs(function (e) {
    return {
      position: "relative",
      size: e.small ? "24px" : "2rem",
      bg: "white",
      borderRadius: "circular"
    };
  }).withConfig({
    displayName: "RadioControl__RadioOutline",
    componentId: "sc-fbrumr-0"
  })(["box-shadow:0 0 0 1px ", ";transition:box-shadow 0.3s linear;input:focus + &{box-shadow:0 0 0 2px ", ";}cursor:", ";"], function (e) {
    return e.hideOutline ? "transparent" : e.theme.colors.gray600;
  }, function (e) {
    return e.theme.colors.blue500;
  }, function (e) {
    return e.disabled ? "not-allowed" : "pointer";
  });

  wd.displayName = "RadioOutline";

  var kd = _["default"](Ja(fe)).attrs(function (e) {
    return {
      size: e.small ? "12px" : "20px",
      borderRadius: "circular",
      bg: "black",
      position: "absolute",
      m: "auto",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    };
  }).withConfig({
    displayName: "RadioControl__RadioDot",
    componentId: "sc-fbrumr-1"
  })([""]);

  function Cd(e) {
    var t = e.checked,
        n = e.hideOutline,
        r = e.onChange,
        o = e.name,
        i = e.small,
        a = e.value,
        l = e.disabled;
    return s.jsxs(s.Fragment, {
      children: [s.jsx(td, {
        type: "radio",
        checked: t,
        onChange: r,
        name: o,
        value: a,
        disabled: l
      }), s.jsx(wd, {
        small: i,
        hideOutline: n,
        disabled: l,
        children: s.jsx(kd, {
          small: i,
          initial: !1,
          animate: {
            opacity: t ? 1 : 0,
            scale: t ? 1 : .5
          },
          transition: {
            type: "spring",
            stiffness: 500,
            damping: 30,
            mass: .5
          }
        }, "radioDot-".concat(a))
      })]
    });
  }

  function Md(e) {
    var t = e.checked,
        n = e.label,
        r = e.onChange,
        o = e.name,
        i = e.value,
        a = e.small,
        l = e.disabled;
    return s.jsx(ys, {
      as: "label",
      cursor: l ? "not-allowed" : "pointer",
      display: "inline-block",
      children: s.jsxs(fe, {
        display: "flex",
        children: [s.jsx(fe, {
          pr: 2,
          flex: "1 0 auto",
          children: s.jsx(Cd, {
            checked: t,
            onChange: r,
            name: o,
            value: i,
            small: a,
            disabled: l
          })
        }), s.jsx(ys, {
          as: "span",
          position: "relative",
          top: a ? "1px" : "0.25rem",
          children: n
        })]
      })
    });
  }

  kd.displayName = "RadioDot", Cd.defaultProps = {
    checked: !1,
    disabled: !1,
    hideOutline: !1,
    small: !1
  }, Cd.propTypes = {
    checked: T["default"].bool,
    disabled: T["default"].bool,
    hideOutline: T["default"].bool,
    onChange: T["default"].func.isRequired,
    name: T["default"].string.isRequired,
    small: T["default"].bool,
    value: T["default"].oneOfType([T["default"].string, T["default"].number, T["default"].object]).isRequired
  }, Md.defaultProps = {
    checked: !1,
    small: !1,
    disabled: !1
  }, Md.propTypes = {
    checked: T["default"].bool,
    small: T["default"].bool,
    disabled: T["default"].bool,
    label: T["default"].oneOfType([T["default"].node, T["default"].string]).isRequired,
    onChange: T["default"].func.isRequired,
    name: T["default"].string.isRequired,
    value: T["default"].oneOfType([T["default"].string, T["default"].number, T["default"].object]).isRequired
  };

  var jd = function jd(e) {
    return t.css(["", "{appearance:none;background-color:black;background-image:", ";border:none;border-radius:50%;box-shadow:0 0 0 3px ", ";cursor:grab;height:25px;position:relative;width:25px;&:active{cursor:grabbing;}}"], e, function (e) {
      return "\n      radial-gradient(circle at center, ".concat(e.theme.colors.black, " 4px, ").concat(e.theme.colors.yellow500, " 4.5px)\n    ");
    }, function (e) {
      return e.theme.colors.white;
    });
  },
      Ed = _["default"].input.attrs(function () {
    return {
      type: "range"
    };
  }).withConfig({
    displayName: "Range__RangeTrack",
    componentId: "sc-3g216e-0"
  })(["appearance:none;background-image:linear-gradient(", ",", ");background-color:", ";background-repeat:no-repeat;background-size:", "% 100%;border-radius:0.75rem;cursor:pointer;display:inline-block;height:0.75rem;width:100%;&:focus{outline:none;}", " ", " ", ""], function (e) {
    return e.theme.colors.yellow500;
  }, function (e) {
    return e.theme.colors.yellow500;
  }, function (e) {
    return e.theme.colors.gray400;
  }, function (e) {
    return e.value;
  }, jd("&::-webkit-slider-thumb"), jd("&::-moz-range-thumb"), jd("&::-ms-thumb"));

  function _d(e) {
    var t = e.min,
        n = e.max,
        r = e.step,
        i = e.onChange,
        a = e.value,
        l = _objectWithoutProperties(e, _excluded38);

    return s.jsx(o.Fragment, {
      children: s.jsx(fe, _objectSpread(_objectSpread({
        display: "flex",
        alignItems: "center"
      }, l), {}, {
        children: s.jsx(Ed, {
          min: t,
          max: n,
          onInput: function onInput(e) {
            return t = e.target.value, void i(t);
            var t;
          },
          step: r,
          style: {
            backgroundSize: "".concat(a, "% 100%")
          },
          value: a
        })
      }))
    });
  }

  Ed.displayName = "RangeTrack", _d.propTypes = {
    value: T["default"].string.isRequired,
    min: T["default"].number,
    max: T["default"].number,
    step: T["default"].number,
    onChange: T["default"].func.isRequired
  }, _d.defaultProps = {
    min: 0,
    max: 100,
    step: 1
  };

  var Td = _["default"].select.withConfig({
    displayName: "SelectUI__StyledSelect",
    componentId: "sc-e32zm1-0"
  })(["", " ", " ", " cursor:", ";line-height:1.4;", " &::ms-expand{display:none;}"], cd, n.layout, n.color, function (e) {
    return e.disabled ? "not-allowed" : "pointer";
  }, wc.xl(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    line-height: 1.38;\n  "]))));

  function Sd(e) {
    var t = e.children,
        n = e.disabled,
        r = e.error,
        o = e.icon,
        i = e.label,
        a = e.placeholder,
        l = e.value,
        c = e.secondary,
        u = e.pill,
        d = _objectWithoutProperties(e, _excluded39);

    return s.jsxs(pd, {
      icon: o,
      label: i,
      error: r,
      children: [s.jsx(Td, _objectSpread(_objectSpread({
        disabled: n,
        error: Boolean(r),
        pt: i ? "1.5rem" : 2,
        pl: o ? ld : 3,
        pr: ld,
        pb: 2,
        value: l,
        pill: u,
        secondary: c,
        style: {
          boxShadow: c && "none"
        }
      }, d), {}, {
        children: t
      })), s.jsx(fe, {
        position: "absolute",
        top: 0,
        bottom: 0,
        right: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: ld,
        style: {
          pointerEvents: "none"
        },
        children: s.jsx(mc, {
          color: c ? "white" : "black",
          icon: "chevron-down"
        })
      })]
    });
  }

  function Ld(e) {
    var t = e.disabled,
        n = e.error,
        r = e.getOptionText,
        i = e.getOptionValue,
        a = e.icon,
        l = e.label,
        c = e.placeholder,
        u = e.onChange,
        d = e.options,
        f = e.value,
        p = _objectWithoutProperties(e, _excluded40);

    var _o$useState3 = o.useState(c ? "placeholder" : function () {
      return i(f);
    }),
        _o$useState4 = _slicedToArray(_o$useState3, 2),
        h = _o$useState4[0],
        m = _o$useState4[1];

    return s.jsxs(Sd, _objectSpread(_objectSpread({
      disabled: t,
      error: n,
      icon: a,
      label: l,
      onChange: function onChange(e) {
        var t = d.find(function (t) {
          return "".concat(i(t)) == "".concat(e.target.value);
        });
        m(i(t)), u(t, e);
      },
      value: h,
      "data-testid": "Select"
    }, p), {}, {
      children: [c && s.jsx("option", {
        value: "placeholder",
        disabled: !0,
        children: c
      }), d.map(function (e, t) {
        return s.jsx("option", {
          value: i(e),
          "data-testid": "option",
          disabled: e.disabled,
          children: r(e, t)
        }, function (e) {
          return e.key || i(e);
        }(e));
      })]
    }));
  }

  Sd.defaultProps = {
    disabled: !1,
    error: !1,
    icon: null,
    placeholder: null,
    secondary: !1,
    pill: !1,
    label: null
  }, Sd.propTypes = {
    children: T["default"].node.isRequired,
    disabled: T["default"].bool,
    error: T["default"].oneOfType([T["default"].string, T["default"].bool, T["default"].node]),
    icon: T["default"].oneOfType([T["default"].string, T["default"].node]),
    label: T["default"].string,
    placeholder: T["default"].string,
    value: T["default"].oneOfType([T["default"].string, T["default"].number]).isRequired,
    secondary: T["default"].bool,
    pill: T["default"].bool
  }, Ld.defaultProps = {
    disabled: !1,
    error: !1,
    getOptionText: N["default"],
    getOptionValue: N["default"],
    icon: null,
    placeholder: null
  }, Ld.propTypes = {
    disabled: T["default"].bool,
    error: T["default"].oneOfType([T["default"].string, T["default"].bool, T["default"].node]),
    getOptionText: T["default"].func,
    getOptionValue: T["default"].func,
    icon: T["default"].oneOfType([T["default"].string, T["default"].node]),
    label: T["default"].string.isRequired,
    onChange: T["default"].func.isRequired,
    options: T["default"].arrayOf(T["default"].oneOfType([T["default"].object, T["default"].string])).isRequired,
    placeholder: T["default"].string,
    value: T["default"].oneOfType([T["default"].object, T["default"].string]).isRequired
  };

  var Dd = _["default"].input.withConfig({
    displayName: "SimpleInput",
    componentId: "sc-r857c3-0"
  })(["", " appearance:none;background:transparent;border:none;border-bottom:2px solid;border-color:", ";border-radius:0;flex-grow:1;flex-shrink:0;line-height:", ";margin-top:2px;overflow:hidden;text-overflow:ellipsis;padding:", " 0;&:focus{outline:none;border-color:", ";color:", ";}"], n.space, function (e) {
    return e.theme.colors.gray400;
  }, function (e) {
    return e.theme.lineHeights.body;
  }, function (e) {
    return e.theme.space[1];
  }, function (e) {
    return e.theme.colors.blue500;
  }, function (e) {
    return e.theme.colors.blue700;
  }),
      Ad = _["default"].textarea.withConfig({
    displayName: "Textarea__StyledTextarea",
    componentId: "sc-15bs4vp-0"
  })(["", " ", " ", " line-height:", ";min-height:", ";resize:", ";"], cd, n.border, n.layout, function (e) {
    return e.theme.lineHeights.body;
  }, function (e) {
    return e.minHeight || e.theme.space[5];
  }, function (e) {
    return e.resize || "vertical";
  });

  function Nd(e, t) {
    var n = e.disabled,
        r = e.error,
        o = e.icon,
        i = e.label,
        a = e.rows,
        l = e.wrapperProps,
        c = _objectWithoutProperties(e, _excluded41);

    return s.jsx(pd, _objectSpread(_objectSpread({
      limitIconHeight: !0,
      icon: o,
      label: i,
      error: r
    }, l), {}, {
      children: s.jsx(Ad, _objectSpread({
        disabled: n,
        error: Boolean(r),
        borderTop: i ? "1.5rem solid transparent" : "0.5rem solid transparent",
        pl: o ? ld : 3,
        pr: 3,
        pb: 2,
        rows: a,
        ref: t
      }, c))
    }));
  }

  var Id = o.forwardRef(Nd);
  Nd.defaultProps = {
    disabled: !1,
    error: !1,
    icon: null,
    label: null,
    rows: 3,
    wrapperProps: {}
  }, Nd.propTypes = {
    disabled: T["default"].bool,
    error: T["default"].oneOfType([T["default"].string, T["default"].node, T["default"].bool]),
    icon: T["default"].oneOfType([T["default"].string, T["default"].node]),
    rows: T["default"].number,
    label: T["default"].string,
    wrapperProps: T["default"].object
  };

  var zd = _["default"](fe).attrs(function () {
    return {
      position: "absolute",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    };
  }).withConfig({
    displayName: "SwitchInput__Slider",
    componentId: "sc-lhaor3-0"
  })(["cursor:pointer;transition:0.4s;border-radius:20px;&:before{position:absolute;content:'';height:calc(100% - 6px);width:calc((100% - 8px) / 2);left:4px;bottom:3px;background-color:", ";transition:0.4s;border-radius:50%;}", " input:checked + &{background-color:", ";}input:focus + &{box-shadow:0 0 1px ", ";}input:checked + &:before{transform:translateX(100%);}"], function (e) {
    var t = e.theme;
    return t.colors.white;
  }, wc.md(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    &:before {\n      height: calc(100% - 8px);\n      bottom: 4px;\n    }\n  "]))), function (e) {
    var t = e.theme;
    return t.colors.blue500;
  }, function (e) {
    var t = e.theme;
    return t.colors.blue500;
  }),
      Od = _["default"].label.withConfig({
    displayName: "SwitchInput__Switch",
    componentId: "sc-lhaor3-1"
  })(["", " position:relative;display:inline-block;input{opacity:0;width:0;height:0;}"], n.compose(n.layout, n.space));

  function Rd(e) {
    var t = e.value,
        n = e.onValue,
        r = e.offValue,
        o = e.onChange,
        i = e.sliderBackground,
        a = _objectWithoutProperties(e, _excluded42);

    return s.jsxs(Od, _objectSpread(_objectSpread({
      height: ["24px", null, "32px", null, "40px"],
      width: ["44px", null, "56px", null, "72px"]
    }, a), {}, {
      children: [s.jsx("input", {
        type: "checkbox",
        value: n,
        checked: t === n,
        onChange: function onChange(e) {
          return o(e.target.checked ? n : r);
        }
      }), s.jsx(zd, {
        bg: i
      })]
    }));
  }

  var Pd = T["default"].oneOfType([T["default"].string, T["default"].number, T["default"].bool, T["default"].array]);

  function Fd() {
    return Fd = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }, Fd.apply(this, arguments);
  }

  function Bd(e, t) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref$checkForDefaultP = _ref.checkForDefaultPrevented,
        n = _ref$checkForDefaultP === void 0 ? !0 : _ref$checkForDefaultP;

    return function (r) {
      if (null == e || e(r), !1 === n || !r.defaultPrevented) return null == t ? void 0 : t(r);
    };
  }

  function qd() {
    for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
      e[_key] = arguments[_key];
    }

    return function (t) {
      return e.forEach(function (e) {
        return function (e, t) {
          "function" == typeof e ? e(t) : null != e && (e.current = t);
        }(e, t);
      });
    };
  }

  function Ud() {
    for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      e[_key2] = arguments[_key2];
    }

    return o.useCallback(qd.apply(void 0, e), e);
  }

  function Vd(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var n = [];

    var r = function r() {
      var t = n.map(function (e) {
        return o.createContext(e);
      });
      return function (n) {
        var r = (null == n ? void 0 : n[e]) || t;
        return o.useMemo(function () {
          return _defineProperty({}, "__scope".concat(e), _objectSpread(_objectSpread({}, n), {}, _defineProperty({}, e, r)));
        }, [n, r]);
      };
    };

    return r.scopeName = e, [function (t, r) {
      var i = o.createContext(r),
          a = n.length;

      function s(t) {
        var n = t.scope,
            r = t.children,
            s = _objectWithoutProperties(t, _excluded43),
            l = (null == n ? void 0 : n[e][a]) || i,
            c = o.useMemo(function () {
          return s;
        }, Object.values(s));

        return o.createElement(l.Provider, {
          value: c
        }, r);
      }

      return n = [].concat(_toConsumableArray(n), [r]), s.displayName = t + "Provider", [s, function (n, s) {
        var l = (null == s ? void 0 : s[e][a]) || i,
            c = o.useContext(l);
        if (c) return c;
        if (void 0 !== r) return r;
        throw new Error("`".concat(n, "` must be used within `").concat(t, "`"));
      }];
    }, Hd.apply(void 0, [r].concat(_toConsumableArray(t)))];
  }

  function Hd() {
    for (var _len3 = arguments.length, e = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      e[_key3] = arguments[_key3];
    }

    var t = e[0];
    if (1 === e.length) return t;

    var n = function n() {
      var n = e.map(function (e) {
        return {
          useScope: e(),
          scopeName: e.scopeName
        };
      });
      return function (e) {
        var r = n.reduce(function (t, _ref3) {
          var n = _ref3.useScope,
              r = _ref3.scopeName;
          return _objectSpread(_objectSpread({}, t), n(e)["__scope".concat(r)]);
        }, {});
        return o.useMemo(function () {
          return _defineProperty({}, "__scope".concat(t.scopeName), r);
        }, [r]);
      };
    };

    return n.scopeName = t.scopeName, n;
  }

  function Zd(e) {
    var t = o.useRef(e);
    return o.useEffect(function () {
      t.current = e;
    }), o.useMemo(function () {
      return function () {
        var _n2;

        var n;

        for (var _len4 = arguments.length, e = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          e[_key4] = arguments[_key4];
        }

        return null === (n = t.current) || void 0 === n ? void 0 : (_n2 = n).call.apply(_n2, [t].concat(e));
      };
    }, []);
  }

  function Wd(_ref5) {
    var e = _ref5.prop,
        t = _ref5.defaultProp,
        _ref5$onChange = _ref5.onChange,
        n = _ref5$onChange === void 0 ? function () {} : _ref5$onChange;

    var _ref6 = function (_ref8) {
      var e = _ref8.defaultProp,
          t = _ref8.onChange;

      var n = o.useState(e),
          _n3 = _slicedToArray(n, 1),
          r = _n3[0],
          i = o.useRef(r),
          a = Zd(t);

      return o.useEffect(function () {
        i.current !== r && (a(r), i.current = r);
      }, [r, i, a]), n;
    }({
      defaultProp: t,
      onChange: n
    }),
        _ref7 = _slicedToArray(_ref6, 2),
        r = _ref7[0],
        i = _ref7[1],
        a = void 0 !== e,
        s = a ? e : r,
        l = Zd(n);

    return [s, o.useCallback(function (t) {
      if (a) {
        var _n4 = t,
            _r2 = "function" == typeof t ? _n4(e) : t;

        _r2 !== e && l(_r2);
      } else i(t);
    }, [a, e, i, l])];
  }

  Rd.propTypes = {
    onValue: Pd,
    offValue: Pd,
    value: Pd,
    onChange: T["default"].func,
    sliderBackground: T["default"].string
  }, Rd.defaultProps = {
    value: !1,
    onValue: !0,
    offValue: !1,
    onChange: void 0,
    sliderBackground: "blue300"
  };
  var $d = o.createContext(void 0);

  function Gd(e) {
    var t = o.useContext($d);
    return e || t || "ltr";
  }

  var Yd = Boolean(null === globalThis || void 0 === globalThis ? void 0 : globalThis.document) ? o.useLayoutEffect : function () {};
  var Qd = o.forwardRef(function (e, t) {
    var n = e.children,
        r = _objectWithoutProperties(e, _excluded44),
        i = o.Children.toArray(n),
        a = i.find(Jd);

    if (a) {
      var _e3 = a.props.children,
          _n5 = i.map(function (t) {
        return t === a ? o.Children.count(_e3) > 1 ? o.Children.only(null) : o.isValidElement(_e3) ? _e3.props.children : null : t;
      });

      return o.createElement(Xd, Fd({}, r, {
        ref: t
      }), o.isValidElement(_e3) ? o.cloneElement(_e3, void 0, _n5) : null);
    }

    return o.createElement(Xd, Fd({}, r, {
      ref: t
    }), n);
  });
  Qd.displayName = "Slot";
  var Xd = o.forwardRef(function (e, t) {
    var n = e.children,
        r = _objectWithoutProperties(e, _excluded45);

    return o.isValidElement(n) ? o.cloneElement(n, _objectSpread(_objectSpread({}, ef(r, n.props)), {}, {
      ref: qd(t, n.ref)
    })) : o.Children.count(n) > 1 ? o.Children.only(null) : null;
  });
  Xd.displayName = "SlotClone";

  var Kd = function Kd(_ref9) {
    var e = _ref9.children;
    return o.createElement(o.Fragment, null, e);
  };

  function Jd(e) {
    return o.isValidElement(e) && e.type === Kd;
  }

  function ef(e, t) {
    var n = _objectSpread({}, t);

    var _loop = function _loop(_r3) {
      var o = e[_r3],
          i = t[_r3];
      /^on[A-Z]/.test(_r3) ? o && i ? n[_r3] = function () {
        i.apply(void 0, arguments), o.apply(void 0, arguments);
      } : o && (n[_r3] = o) : "style" === _r3 ? n[_r3] = _objectSpread(_objectSpread({}, o), i) : "className" === _r3 && (n[_r3] = [o, i].filter(Boolean).join(" "));
    };

    for (var _r3 in t) {
      _loop(_r3);
    }

    return _objectSpread(_objectSpread({}, e), n);
  }

  var tf = ["a", "button", "div", "h2", "h3", "img", "label", "li", "nav", "ol", "p", "span", "svg", "ul"].reduce(function (e, t) {
    var n = o.forwardRef(function (e, n) {
      var r = e.asChild,
          i = _objectWithoutProperties(e, _excluded46),
          a = r ? Qd : t;

      return o.useEffect(function () {
        window[Symbol["for"]("radix-ui")] = !0;
      }, []), o.createElement(a, Fd({}, i, {
        ref: n
      }));
    });
    return n.displayName = "Primitive.".concat(t), _objectSpread(_objectSpread({}, e), {}, _defineProperty({}, t, n));
  }, {});

  var nf = ["PageUp", "PageDown"],
      rf = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"],
      of = {
    "from-left": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
    "from-right": ["Home", "PageDown", "ArrowDown", "ArrowRight"],
    "from-bottom": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
    "from-top": ["Home", "PageDown", "ArrowUp", "ArrowLeft"]
  },
      af = "Slider",
      _ref10 = function (e) {
    var t = e + "CollectionProvider",
        _Vd3 = Vd(t),
        _Vd4 = _slicedToArray(_Vd3, 2),
        n = _Vd4[0],
        r = _Vd4[1],
        _n6 = n(t, {
      collectionRef: {
        current: null
      },
      itemMap: new Map()
    }),
        _n7 = _slicedToArray(_n6, 2),
        o = _n7[0],
        i = _n7[1],
        a = e + "CollectionSlot",
        s = S["default"].forwardRef(function (e, t) {
      var n = e.scope,
          r = e.children,
          o = Ud(t, i(a, n).collectionRef);
      return S["default"].createElement(Qd, {
        ref: o
      }, r);
    }),
        l = e + "CollectionItemSlot",
        c = "data-radix-collection-item",
        u = S["default"].forwardRef(function (e, t) {
      var _S$default$createElem;

      var n = e.scope,
          r = e.children,
          o = _objectWithoutProperties(e, _excluded47),
          a = S["default"].useRef(null),
          s = Ud(t, a),
          u = i(l, n);

      return S["default"].useEffect(function () {
        return u.itemMap.set(a, _objectSpread({
          ref: a
        }, o)), function () {
          u.itemMap["delete"](a);
        };
      }), S["default"].createElement(Qd, (_S$default$createElem = {}, _defineProperty(_S$default$createElem, c, ""), _defineProperty(_S$default$createElem, "ref", s), _S$default$createElem), r);
    });

    return [{
      Provider: function Provider(e) {
        var t = e.scope,
            n = e.children,
            r = S["default"].useRef(null),
            i = S["default"].useRef(new Map()).current;
        return S["default"].createElement(o, {
          scope: t,
          itemMap: i,
          collectionRef: r
        }, n);
      },
      Slot: s,
      ItemSlot: u
    }, function (t) {
      var n = i(e + "CollectionConsumer", t),
          r = S["default"].useCallback(function () {
        var e = n.collectionRef.current;
        if (!e) return [];
        var t = Array.from(e.querySelectorAll("[".concat(c, "]"))),
            r = Array.from(n.itemMap.values()).sort(function (e, n) {
          return t.indexOf(e.ref.current) - t.indexOf(n.ref.current);
        });
        return r;
      }, [n.collectionRef, n.itemMap]);
      return r;
    }, r];
  }(af),
      _ref11 = _slicedToArray(_ref10, 3),
      sf = _ref11[0],
      lf = _ref11[1],
      cf = _ref11[2],
      _Vd = Vd(af, [cf]),
      _Vd2 = _slicedToArray(_Vd, 2),
      uf = _Vd2[0],
      df = _Vd2[1],
      _uf = uf(af),
      _uf2 = _slicedToArray(_uf, 2),
      ff = _uf2[0],
      pf = _uf2[1],
      hf = o.forwardRef(function (e, t) {
    var n = e.name,
        _e$min = e.min,
        r = _e$min === void 0 ? 0 : _e$min,
        _e$max = e.max,
        i = _e$max === void 0 ? 100 : _e$max,
        _e$step = e.step,
        a = _e$step === void 0 ? 1 : _e$step,
        _e$orientation = e.orientation,
        s = _e$orientation === void 0 ? "horizontal" : _e$orientation,
        _e$disabled = e.disabled,
        l = _e$disabled === void 0 ? !1 : _e$disabled,
        _e$minStepsBetweenThu = e.minStepsBetweenThumbs,
        c = _e$minStepsBetweenThu === void 0 ? 0 : _e$minStepsBetweenThu,
        _e$defaultValue = e.defaultValue,
        u = _e$defaultValue === void 0 ? [r] : _e$defaultValue,
        d = e.value,
        _e$onValueChange = e.onValueChange,
        f = _e$onValueChange === void 0 ? function () {} : _e$onValueChange,
        _e$onValueCommit = e.onValueCommit,
        p = _e$onValueCommit === void 0 ? function () {} : _e$onValueCommit,
        _e$inverted = e.inverted,
        h = _e$inverted === void 0 ? !1 : _e$inverted,
        m = _objectWithoutProperties(e, _excluded48),
        _o$useState5 = o.useState(null),
        _o$useState6 = _slicedToArray(_o$useState5, 2),
        g = _o$useState6[0],
        y = _o$useState6[1],
        b = Ud(t, function (e) {
      return y(e);
    }),
        v = o.useRef(new Set()),
        x = o.useRef(0),
        w = "horizontal" === s,
        k = !g || Boolean(g.closest("form")),
        C = w ? yf : bf,
        _Wd = Wd({
      prop: d,
      defaultProp: u,
      onChange: function onChange(e) {
        var t;
        null === (t = _toConsumableArray(v.current)[x.current]) || void 0 === t || t.focus(), f(e);
      }
    }),
        _Wd2 = _slicedToArray(_Wd, 2),
        _Wd2$ = _Wd2[0],
        M = _Wd2$ === void 0 ? [] : _Wd2$,
        j = _Wd2[1],
        E = o.useRef(M);

    function _(e, t) {
      var _ref12 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        commit: !1
      },
          n = _ref12.commit;

      var o = function (e) {
        return (String(e).split(".")[1] || "").length;
      }(a),
          s = function (e, t) {
        var n = Math.pow(10, t);
        return Math.round(e * n) / n;
      }(Math.round((e - r) / a) * a + r, o),
          l = function (e, _ref13) {
        var _ref14 = _slicedToArray(_ref13, 2),
            t = _ref14[0],
            n = _ref14[1];

        return Math.min(n, Math.max(t, e));
      }(s, [r, i]);

      j(function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        var r = function () {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
          var t = arguments.length > 1 ? arguments[1] : undefined;
          var n = arguments.length > 2 ? arguments[2] : undefined;

          var r = _toConsumableArray(e);

          return r[n] = t, r.sort(function (e, t) {
            return e - t;
          });
        }(e, l, t);

        if (function (e, t) {
          if (t > 0) {
            var _n8 = function (e) {
              return e.slice(0, -1).map(function (t, n) {
                return e[n + 1] - t;
              });
            }(e);

            return Math.min.apply(Math, _toConsumableArray(_n8)) >= t;
          }

          return !0;
        }(r, c * a)) {
          x.current = r.indexOf(l);

          var _t3 = String(r) !== String(e);

          return _t3 && n && p(r), _t3 ? r : e;
        }

        return e;
      });
    }

    return o.createElement(ff, {
      scope: e.__scopeSlider,
      disabled: l,
      min: r,
      max: i,
      valueIndexToChangeRef: x,
      thumbs: v.current,
      values: M,
      orientation: s
    }, o.createElement(sf.Provider, {
      scope: e.__scopeSlider
    }, o.createElement(sf.Slot, {
      scope: e.__scopeSlider
    }, o.createElement(C, Fd({
      "aria-disabled": l,
      "data-disabled": l ? "" : void 0
    }, m, {
      ref: b,
      onPointerDown: Bd(m.onPointerDown, function () {
        l || (E.current = M);
      }),
      min: r,
      max: i,
      inverted: h,
      onSlideStart: l ? void 0 : function (e) {
        var t = function (e, t) {
          if (1 === e.length) return 0;
          var n = e.map(function (e) {
            return Math.abs(e - t);
          }),
              r = Math.min.apply(Math, _toConsumableArray(n));
          return n.indexOf(r);
        }(M, e);

        _(e, t);
      },
      onSlideMove: l ? void 0 : function (e) {
        _(e, x.current);
      },
      onSlideEnd: l ? void 0 : function () {
        var e = E.current[x.current];
        M[x.current] !== e && p(M);
      },
      onHomeKeyDown: function onHomeKeyDown() {
        return !l && _(r, 0, {
          commit: !0
        });
      },
      onEndKeyDown: function onEndKeyDown() {
        return !l && _(i, M.length - 1, {
          commit: !0
        });
      },
      onStepKeyDown: function onStepKeyDown(_ref15) {
        var e = _ref15.event,
            t = _ref15.direction;

        if (!l) {
          var _n9 = nf.includes(e.key) || e.shiftKey && rf.includes(e.key) ? 10 : 1,
              _r4 = x.current;

          _(M[_r4] + a * _n9 * t, _r4, {
            commit: !0
          });
        }
      }
    })))), k && M.map(function (e, t) {
      return o.createElement(Ef, {
        key: t,
        name: n ? n + (M.length > 1 ? "[]" : "") : void 0,
        value: e
      });
    }));
  }),
      _uf3 = uf(af, {
    startEdge: "left",
    endEdge: "right",
    size: "width",
    direction: 1
  }),
      _uf4 = _slicedToArray(_uf3, 2),
      mf = _uf4[0],
      gf = _uf4[1],
      yf = o.forwardRef(function (e, t) {
    var n = e.min,
        r = e.max,
        i = e.dir,
        a = e.inverted,
        s = e.onSlideStart,
        l = e.onSlideMove,
        c = e.onSlideEnd,
        u = e.onStepKeyDown,
        d = _objectWithoutProperties(e, _excluded49),
        _o$useState7 = o.useState(null),
        _o$useState8 = _slicedToArray(_o$useState7, 2),
        f = _o$useState8[0],
        p = _o$useState8[1],
        h = Ud(t, function (e) {
      return p(e);
    }),
        m = o.useRef(),
        g = Gd(i),
        y = "ltr" === g,
        b = y && !a || !y && a;

    function v(e) {
      var t = m.current || f.getBoundingClientRect(),
          o = Tf([0, t.width], b ? [n, r] : [r, n]);
      return m.current = t, o(e - t.left);
    }

    return o.createElement(mf, {
      scope: e.__scopeSlider,
      startEdge: b ? "left" : "right",
      endEdge: b ? "right" : "left",
      direction: b ? 1 : -1,
      size: "width"
    }, o.createElement(vf, Fd({
      dir: g,
      "data-orientation": "horizontal"
    }, d, {
      ref: h,
      style: _objectSpread(_objectSpread({}, d.style), {}, {
        "--radix-slider-thumb-transform": "translateX(-50%)"
      }),
      onSlideStart: function onSlideStart(e) {
        var t = v(e.clientX);
        null == s || s(t);
      },
      onSlideMove: function onSlideMove(e) {
        var t = v(e.clientX);
        null == l || l(t);
      },
      onSlideEnd: function onSlideEnd() {
        m.current = void 0, null == c || c();
      },
      onStepKeyDown: function onStepKeyDown(e) {
        var t = of[b ? "from-left" : "from-right"].includes(e.key);
        null == u || u({
          event: e,
          direction: t ? -1 : 1
        });
      }
    })));
  }),
      bf = o.forwardRef(function (e, t) {
    var n = e.min,
        r = e.max,
        i = e.inverted,
        a = e.onSlideStart,
        s = e.onSlideMove,
        l = e.onSlideEnd,
        c = e.onStepKeyDown,
        u = _objectWithoutProperties(e, _excluded50),
        d = o.useRef(null),
        f = Ud(t, d),
        p = o.useRef(),
        h = !i;

    function m(e) {
      var t = p.current || d.current.getBoundingClientRect(),
          o = Tf([0, t.height], h ? [r, n] : [n, r]);
      return p.current = t, o(e - t.top);
    }

    return o.createElement(mf, {
      scope: e.__scopeSlider,
      startEdge: h ? "bottom" : "top",
      endEdge: h ? "top" : "bottom",
      size: "height",
      direction: h ? 1 : -1
    }, o.createElement(vf, Fd({
      "data-orientation": "vertical"
    }, u, {
      ref: f,
      style: _objectSpread(_objectSpread({}, u.style), {}, {
        "--radix-slider-thumb-transform": "translateY(50%)"
      }),
      onSlideStart: function onSlideStart(e) {
        var t = m(e.clientY);
        null == a || a(t);
      },
      onSlideMove: function onSlideMove(e) {
        var t = m(e.clientY);
        null == s || s(t);
      },
      onSlideEnd: function onSlideEnd() {
        p.current = void 0, null == l || l();
      },
      onStepKeyDown: function onStepKeyDown(e) {
        var t = of[h ? "from-bottom" : "from-top"].includes(e.key);
        null == c || c({
          event: e,
          direction: t ? -1 : 1
        });
      }
    })));
  }),
      vf = o.forwardRef(function (e, t) {
    var n = e.__scopeSlider,
        r = e.onSlideStart,
        i = e.onSlideMove,
        a = e.onSlideEnd,
        s = e.onHomeKeyDown,
        l = e.onEndKeyDown,
        c = e.onStepKeyDown,
        u = _objectWithoutProperties(e, _excluded51),
        d = pf(af, n);

    return o.createElement(tf.span, Fd({}, u, {
      ref: t,
      onKeyDown: Bd(e.onKeyDown, function (e) {
        "Home" === e.key ? (s(e), e.preventDefault()) : "End" === e.key ? (l(e), e.preventDefault()) : nf.concat(rf).includes(e.key) && (c(e), e.preventDefault());
      }),
      onPointerDown: Bd(e.onPointerDown, function (e) {
        var t = e.target;
        t.setPointerCapture(e.pointerId), e.preventDefault(), d.thumbs.has(t) ? t.focus() : r(e);
      }),
      onPointerMove: Bd(e.onPointerMove, function (e) {
        e.target.hasPointerCapture(e.pointerId) && i(e);
      }),
      onPointerUp: Bd(e.onPointerUp, function (e) {
        var t = e.target;
        t.hasPointerCapture(e.pointerId) && (t.releasePointerCapture(e.pointerId), a(e));
      })
    }));
  }),
      xf = o.forwardRef(function (e, t) {
    var n = e.__scopeSlider,
        r = _objectWithoutProperties(e, _excluded52),
        i = pf("SliderTrack", n);

    return o.createElement(tf.span, Fd({
      "data-disabled": i.disabled ? "" : void 0,
      "data-orientation": i.orientation
    }, r, {
      ref: t
    }));
  }),
      wf = "SliderRange",
      kf = o.forwardRef(function (e, t) {
    var _objectSpread4;

    var n = e.__scopeSlider,
        r = _objectWithoutProperties(e, _excluded53),
        i = pf(wf, n),
        a = gf(wf, n),
        s = Ud(t, o.useRef(null)),
        l = i.values.length,
        c = i.values.map(function (e) {
      return _f(e, i.min, i.max);
    }),
        u = l > 1 ? Math.min.apply(Math, _toConsumableArray(c)) : 0,
        d = 100 - Math.max.apply(Math, _toConsumableArray(c));

    return o.createElement(tf.span, Fd({
      "data-orientation": i.orientation,
      "data-disabled": i.disabled ? "" : void 0
    }, r, {
      ref: s,
      style: _objectSpread(_objectSpread({}, e.style), {}, (_objectSpread4 = {}, _defineProperty(_objectSpread4, a.startEdge, u + "%"), _defineProperty(_objectSpread4, a.endEdge, d + "%"), _objectSpread4))
    }));
  }),
      Cf = "SliderThumb",
      Mf = o.forwardRef(function (e, t) {
    var n = lf(e.__scopeSlider),
        _o$useState9 = o.useState(null),
        _o$useState10 = _slicedToArray(_o$useState9, 2),
        r = _o$useState10[0],
        i = _o$useState10[1],
        a = Ud(t, function (e) {
      return i(e);
    }),
        s = o.useMemo(function () {
      return r ? n().findIndex(function (e) {
        return e.ref.current === r;
      }) : -1;
    }, [n, r]);

    return o.createElement(jf, Fd({}, e, {
      ref: a,
      index: s
    }));
  }),
      jf = o.forwardRef(function (e, t) {
    var n = e.__scopeSlider,
        r = e.index,
        i = _objectWithoutProperties(e, _excluded54),
        a = pf(Cf, n),
        s = gf(Cf, n),
        _o$useState11 = o.useState(null),
        _o$useState12 = _slicedToArray(_o$useState11, 2),
        l = _o$useState12[0],
        c = _o$useState12[1],
        u = Ud(t, function (e) {
      return c(e);
    }),
        d = function (e) {
      var _o$useState13 = o.useState(void 0),
          _o$useState14 = _slicedToArray(_o$useState13, 2),
          t = _o$useState14[0],
          n = _o$useState14[1];

      return Yd(function () {
        if (e) {
          n({
            width: e.offsetWidth,
            height: e.offsetHeight
          });

          var _t4 = new ResizeObserver(function (t) {
            if (!Array.isArray(t)) return;
            if (!t.length) return;
            var r = t[0];
            var o, i;

            if ("borderBoxSize" in r) {
              var _e4 = r.borderBoxSize,
                  _t5 = Array.isArray(_e4) ? _e4[0] : _e4;

              o = _t5.inlineSize, i = _t5.blockSize;
            } else o = e.offsetWidth, i = e.offsetHeight;

            n({
              width: o,
              height: i
            });
          });

          return _t4.observe(e, {
            box: "border-box"
          }), function () {
            return _t4.unobserve(e);
          };
        }

        n(void 0);
      }, [e]), t;
    }(l),
        f = a.values[r],
        p = void 0 === f ? 0 : _f(f, a.min, a.max),
        h = function (e, t) {
      return t > 2 ? "Value ".concat(e + 1, " of ").concat(t) : 2 === t ? ["Minimum", "Maximum"][e] : void 0;
    }(r, a.values.length),
        m = null == d ? void 0 : d[s.size],
        g = m ? function (e, t, n) {
      var r = e / 2,
          o = Tf([0, 50], [0, r]);
      return (r - o(t) * n) * n;
    }(m, p, s.direction) : 0;

    return o.useEffect(function () {
      if (l) return a.thumbs.add(l), function () {
        a.thumbs["delete"](l);
      };
    }, [l, a.thumbs]), o.createElement("span", {
      style: _defineProperty({
        transform: "var(--radix-slider-thumb-transform)",
        position: "absolute"
      }, s.startEdge, "calc(".concat(p, "% + ").concat(g, "px)"))
    }, o.createElement(sf.ItemSlot, {
      scope: e.__scopeSlider
    }, o.createElement(tf.span, Fd({
      role: "slider",
      "aria-label": e["aria-label"] || h,
      "aria-valuemin": a.min,
      "aria-valuenow": f,
      "aria-valuemax": a.max,
      "aria-orientation": a.orientation,
      "data-orientation": a.orientation,
      "data-disabled": a.disabled ? "" : void 0,
      tabIndex: a.disabled ? void 0 : 0
    }, i, {
      ref: u,
      style: void 0 === f ? {
        display: "none"
      } : e.style,
      onFocus: Bd(e.onFocus, function () {
        a.valueIndexToChangeRef.current = r;
      })
    }))));
  }),
      Ef = function Ef(e) {
    var t = e.value,
        n = _objectWithoutProperties(e, _excluded55),
        r = o.useRef(null),
        i = function (e) {
      var t = o.useRef({
        value: e,
        previous: e
      });
      return o.useMemo(function () {
        return t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous;
      }, [e]);
    }(t);

    return o.useEffect(function () {
      var e = r.current,
          n = window.HTMLInputElement.prototype,
          o = Object.getOwnPropertyDescriptor(n, "value").set;

      if (i !== t && o) {
        var _n10 = new Event("input", {
          bubbles: !0
        });

        o.call(e, t), e.dispatchEvent(_n10);
      }
    }, [i, t]), o.createElement("input", Fd({
      style: {
        display: "none"
      }
    }, n, {
      ref: r,
      defaultValue: t
    }));
  };

  function _f(e, t, n) {
    return 100 / (n - t) * (e - t);
  }

  function Tf(e, t) {
    return function (n) {
      if (e[0] === e[1] || t[0] === t[1]) return t[0];
      var r = (t[1] - t[0]) / (e[1] - e[0]);
      return t[0] + r * (n - e[0]);
    };
  }

  var Sf = hf,
      Lf = xf,
      Df = kf,
      Af = Mf,
      Nf = _["default"](Sf).withConfig({
    displayName: "SliderInput__Root",
    componentId: "sc-1oqk9s6-0"
  })(["position:relative;display:flex;align-items:center;user-select:none;touch-action:none;min-height:20px;"]),
      If = _["default"](Lf).withConfig({
    displayName: "SliderInput__Track",
    componentId: "sc-1oqk9s6-1"
  })(["background-color:", ";border-radius:", ";position:relative;flex-grow:1;&[data-orientation='horizontal']{height:6px;}&[data-orientation='vertical']{width:6px;}"], function (e) {
    return e.theme.colors.blue300;
  }, function (e) {
    return e.theme.radii.rounded;
  }),
      zf = _["default"](Df).withConfig({
    displayName: "SliderInput__Range",
    componentId: "sc-1oqk9s6-2"
  })(["position:absolute;background-color:", ";border-radius:", ";height:100%;"], function (e) {
    return e.theme.colors.blue600;
  }, function (e) {
    return e.theme.radii.rounded;
  }),
      Of = _["default"](Af).withConfig({
    displayName: "SliderInput__StyledThumb",
    componentId: "sc-1oqk9s6-3"
  })(["display:flex;justify-content:center;align-items:center;position:relative;width:20px;height:20px;background-color:white;box-shadow:none !important;border-radius:10px;cursor:pointer;zindex:4;background-color:", ";& > *{display:none;}&:hover{& > *{display:block;}}&:focus{outline:none;box-shadow:0 0 0 5px black;}"], function (e) {
    return e.theme.colors.blue600;
  }),
      Rf = function Rf(e) {
    var t = e.indicator,
        n = e.position,
        r = e.showIndicator;
    return s.jsx(Of, {
      children: "number" == typeof t && r && s.jsx(fe, {
        position: "absolute",
        display: "inline-block",
        top: "0%",
        style: {
          transform: "translateY(".concat("bottom" === n ? "30px" : "-30px", ")")
        },
        borderRadius: "small",
        boxShadow: 1,
        bg: "white",
        px: 2,
        children: s.jsx(ys, {
          as: "span",
          children: t
        })
      })
    });
  };

  Rf.defaultProps = {
    position: "top",
    showIndicator: !1,
    indicator: null
  }, Rf.propTypes = {
    indicator: T["default"].oneOfType([T["default"].number, T["default"].string]),
    position: T["default"].oneOf(["top", "bottom"]),
    showIndicator: T["default"].bool
  };
  var Pf = {
    Root: Nf,
    Track: If,
    Range: zf,
    Thumb: Rf
  };

  var Ff = _["default"](Ss).withConfig({
    displayName: "StarsRating__StyledTransparentButton",
    componentId: "sc-juseju-0"
  })(["", " ", ""], function (e) {
    return e.highlight && "color: ".concat(e.theme.colors.yellow600, ";");
  }, function (e) {
    return e.readOnly ? "cursor: default;" : "\n      &:hover {\n        color: ".concat(e.theme.colors.yellow600, ";\n      }");
  }),
      Bf = {
    1: {
      halfStarMinScore: 10,
      fullStarMinScore: 20
    },
    2: {
      halfStarMinScore: 30,
      fullStarMinScore: 40
    },
    3: {
      halfStarMinScore: 50,
      fullStarMinScore: 60
    },
    4: {
      halfStarMinScore: 70,
      fullStarMinScore: 80
    },
    5: {
      halfStarMinScore: 90,
      fullStarMinScore: 96
    }
  },
      qf = Array(5).fill().map(function (e, t) {
    return t + 1;
  });

  function Uf(e) {
    var t = e.onSelect,
        n = e.value,
        r = e.readOnly,
        i = e.iconFontSize,
        a = e.iconComponent;

    var _o$useState15 = o.useState(0),
        _o$useState16 = _slicedToArray(_o$useState15, 2),
        l = _o$useState16[0],
        c = _o$useState16[1],
        u = function u(e) {
      r || c(e);
    };

    return o.useEffect(function () {
      c(0);
    }, [n]), s.jsx(fe, {
      display: "flex",
      flexWrap: "nowrap",
      children: qf.map(function (e) {
        var _Bf$e = Bf[e],
            o = _Bf$e.halfStarMinScore,
            c = _Bf$e.fullStarMinScore,
            d = e <= l || n >= o,
            f = n >= o ? "yellow500" : "gray500",
            p = n >= o && n < c && 0 === l ? "star-half-alt" : "star",
            h = d ? "solid" : "light";
        return s.jsx(Ff, {
          onClick: function onClick() {
            return t(20 * e);
          },
          color: f,
          pl: 0,
          pr: e === qf.length ? 0 : 2,
          highlight: d,
          onMouseEnter: function onMouseEnter() {
            return u(e);
          },
          onMouseLeave: function onMouseLeave() {
            return u(0);
          },
          readOnly: r,
          children: a ? a({
            shouldHighlight: d,
            value: n,
            halfStarMinScore: o,
            fullStarMinScore: c
          }) : s.jsx(mc, {
            icon: p,
            weight: h,
            fontSize: i || [22, null, null, 30]
          })
        }, e);
      })
    });
  }

  Uf.defaultProps = {
    readOnly: !1,
    onSelect: function onSelect() {},
    iconFontSize: null,
    iconComponent: null
  }, Uf.propTypes = {
    value: T["default"].number.isRequired,
    onSelect: T["default"].func,
    readOnly: T["default"].bool,
    iconFontSize: T["default"].oneOfType([T["default"].number, T["default"].string, T["default"].array]),
    iconComponent: T["default"].oneOfType([T["default"].node, T["default"].func])
  };

  var Vf = _["default"](iu).withConfig({
    displayName: "FatLoadingSpinner__FatSpinning",
    componentId: "sc-1x1tx3m-0"
  })(["", ";"], K("1200ms"));

  function Hf(e) {
    return s.jsx(Vf, _objectSpread({}, e));
  }

  var Zf = function Zf() {
    return /^(iPhone|iPad|iPod)/.test(navigator.platform) || "MacIntel" === navigator.platform && navigator.maxTouchPoints > 1;
  },
      Wf = function Wf(e) {
    return t.css(["", "{appearance:none;background-color:black;background-image:", ";border:", ";border-radius:50%;box-shadow:0 0 0 2px ", ";cursor:grab;position:relative;height:21px;width:21px;&:active{cursor:grabbing;}}"], e, function (e) {
      return "\n      radial-gradient(circle at center, ".concat(e.theme.colors.black, " 4px, ").concat(e.secondary ? e.theme.colors.white : e.theme.colors.yellow500, " 4.5px)\n    ");
    }, function (e) {
      return e.secondary ? "solid 1px" : "none";
    }, function (e) {
      return e.theme.colors.white;
    });
  },
      $f = _["default"].input.attrs(function () {
    return {
      type: "range"
    };
  }).withConfig({
    displayName: "AudioTrack",
    componentId: "sc-1tiexcf-0"
  })(["appearance:none;background-image:linear-gradient(", ",", ");background-color:", ";background-repeat:no-repeat;background-size:", "% 100%;border-radius:0.625rem;cursor:pointer;display:inline-block;flex-grow:1;margin:0 ", ";width:100%;min-width:0;height:0.625rem;flex:auto;", " &:focus{outline:none;}", " ", " ", ""], function (e) {
    return e.theme.colors.yellow500;
  }, function (e) {
    return e.theme.colors.yellow500;
  }, function (e) {
    return e.secondary ? e.theme.colors.green50 : e.theme.colors.gray400;
  }, function (e) {
    return e.progress;
  }, function (e) {
    return e.theme.space[2];
  }, wc.lg(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    flex: 1;\n  "]))), Wf("&::-webkit-slider-thumb"), Wf("&::-moz-range-thumb"), Wf("&::-ms-thumb"));

  function Gf(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e["default"] : e;
  }

  $f.displayName = "AudioTrack";

  var Yf = {
    exports: {}
  },
      Qf = {
    aliceblue: [240, 248, 255],
    antiquewhite: [250, 235, 215],
    aqua: [0, 255, 255],
    aquamarine: [127, 255, 212],
    azure: [240, 255, 255],
    beige: [245, 245, 220],
    bisque: [255, 228, 196],
    black: [0, 0, 0],
    blanchedalmond: [255, 235, 205],
    blue: [0, 0, 255],
    blueviolet: [138, 43, 226],
    brown: [165, 42, 42],
    burlywood: [222, 184, 135],
    cadetblue: [95, 158, 160],
    chartreuse: [127, 255, 0],
    chocolate: [210, 105, 30],
    coral: [255, 127, 80],
    cornflowerblue: [100, 149, 237],
    cornsilk: [255, 248, 220],
    crimson: [220, 20, 60],
    cyan: [0, 255, 255],
    darkblue: [0, 0, 139],
    darkcyan: [0, 139, 139],
    darkgoldenrod: [184, 134, 11],
    darkgray: [169, 169, 169],
    darkgreen: [0, 100, 0],
    darkgrey: [169, 169, 169],
    darkkhaki: [189, 183, 107],
    darkmagenta: [139, 0, 139],
    darkolivegreen: [85, 107, 47],
    darkorange: [255, 140, 0],
    darkorchid: [153, 50, 204],
    darkred: [139, 0, 0],
    darksalmon: [233, 150, 122],
    darkseagreen: [143, 188, 143],
    darkslateblue: [72, 61, 139],
    darkslategray: [47, 79, 79],
    darkslategrey: [47, 79, 79],
    darkturquoise: [0, 206, 209],
    darkviolet: [148, 0, 211],
    deeppink: [255, 20, 147],
    deepskyblue: [0, 191, 255],
    dimgray: [105, 105, 105],
    dimgrey: [105, 105, 105],
    dodgerblue: [30, 144, 255],
    firebrick: [178, 34, 34],
    floralwhite: [255, 250, 240],
    forestgreen: [34, 139, 34],
    fuchsia: [255, 0, 255],
    gainsboro: [220, 220, 220],
    ghostwhite: [248, 248, 255],
    gold: [255, 215, 0],
    goldenrod: [218, 165, 32],
    gray: [128, 128, 128],
    green: [0, 128, 0],
    greenyellow: [173, 255, 47],
    grey: [128, 128, 128],
    honeydew: [240, 255, 240],
    hotpink: [255, 105, 180],
    indianred: [205, 92, 92],
    indigo: [75, 0, 130],
    ivory: [255, 255, 240],
    khaki: [240, 230, 140],
    lavender: [230, 230, 250],
    lavenderblush: [255, 240, 245],
    lawngreen: [124, 252, 0],
    lemonchiffon: [255, 250, 205],
    lightblue: [173, 216, 230],
    lightcoral: [240, 128, 128],
    lightcyan: [224, 255, 255],
    lightgoldenrodyellow: [250, 250, 210],
    lightgray: [211, 211, 211],
    lightgreen: [144, 238, 144],
    lightgrey: [211, 211, 211],
    lightpink: [255, 182, 193],
    lightsalmon: [255, 160, 122],
    lightseagreen: [32, 178, 170],
    lightskyblue: [135, 206, 250],
    lightslategray: [119, 136, 153],
    lightslategrey: [119, 136, 153],
    lightsteelblue: [176, 196, 222],
    lightyellow: [255, 255, 224],
    lime: [0, 255, 0],
    limegreen: [50, 205, 50],
    linen: [250, 240, 230],
    magenta: [255, 0, 255],
    maroon: [128, 0, 0],
    mediumaquamarine: [102, 205, 170],
    mediumblue: [0, 0, 205],
    mediumorchid: [186, 85, 211],
    mediumpurple: [147, 112, 219],
    mediumseagreen: [60, 179, 113],
    mediumslateblue: [123, 104, 238],
    mediumspringgreen: [0, 250, 154],
    mediumturquoise: [72, 209, 204],
    mediumvioletred: [199, 21, 133],
    midnightblue: [25, 25, 112],
    mintcream: [245, 255, 250],
    mistyrose: [255, 228, 225],
    moccasin: [255, 228, 181],
    navajowhite: [255, 222, 173],
    navy: [0, 0, 128],
    oldlace: [253, 245, 230],
    olive: [128, 128, 0],
    olivedrab: [107, 142, 35],
    orange: [255, 165, 0],
    orangered: [255, 69, 0],
    orchid: [218, 112, 214],
    palegoldenrod: [238, 232, 170],
    palegreen: [152, 251, 152],
    paleturquoise: [175, 238, 238],
    palevioletred: [219, 112, 147],
    papayawhip: [255, 239, 213],
    peachpuff: [255, 218, 185],
    peru: [205, 133, 63],
    pink: [255, 192, 203],
    plum: [221, 160, 221],
    powderblue: [176, 224, 230],
    purple: [128, 0, 128],
    rebeccapurple: [102, 51, 153],
    red: [255, 0, 0],
    rosybrown: [188, 143, 143],
    royalblue: [65, 105, 225],
    saddlebrown: [139, 69, 19],
    salmon: [250, 128, 114],
    sandybrown: [244, 164, 96],
    seagreen: [46, 139, 87],
    seashell: [255, 245, 238],
    sienna: [160, 82, 45],
    silver: [192, 192, 192],
    skyblue: [135, 206, 235],
    slateblue: [106, 90, 205],
    slategray: [112, 128, 144],
    slategrey: [112, 128, 144],
    snow: [255, 250, 250],
    springgreen: [0, 255, 127],
    steelblue: [70, 130, 180],
    tan: [210, 180, 140],
    teal: [0, 128, 128],
    thistle: [216, 191, 216],
    tomato: [255, 99, 71],
    turquoise: [64, 224, 208],
    violet: [238, 130, 238],
    wheat: [245, 222, 179],
    white: [255, 255, 255],
    whitesmoke: [245, 245, 245],
    yellow: [255, 255, 0],
    yellowgreen: [154, 205, 50]
  },
      Xf = {
    exports: {}
  },
      Kf = function Kf(e) {
    return !(!e || "string" == typeof e) && (e instanceof Array || Array.isArray(e) || e.length >= 0 && (e.splice instanceof Function || Object.getOwnPropertyDescriptor(e, e.length - 1) && "String" !== e.constructor.name));
  },
      Jf = Array.prototype.concat,
      ep = Array.prototype.slice,
      tp = Xf.exports = function (e) {
    for (var t = [], n = 0, r = e.length; n < r; n++) {
      var o = e[n];
      Kf(o) ? t = Jf.call(t, ep.call(o)) : t.push(o);
    }

    return t;
  };

  tp.wrap = function (e) {
    return function () {
      return e(tp(arguments));
    };
  };

  var np = Qf,
      rp = Xf.exports,
      op = Object.hasOwnProperty,
      ip = Object.create(null);

  for (var ap in np) {
    op.call(np, ap) && (ip[np[ap]] = ap);
  }

  var sp = Yf.exports = {
    to: {},
    get: {}
  };

  function lp(e, t, n) {
    return Math.min(Math.max(t, e), n);
  }

  function cp(e) {
    var t = Math.round(e).toString(16).toUpperCase();
    return t.length < 2 ? "0" + t : t;
  }

  sp.get = function (e) {
    var t, n;

    switch (e.substring(0, 3).toLowerCase()) {
      case "hsl":
        t = sp.get.hsl(e), n = "hsl";
        break;

      case "hwb":
        t = sp.get.hwb(e), n = "hwb";
        break;

      default:
        t = sp.get.rgb(e), n = "rgb";
    }

    return t ? {
      model: n,
      value: t
    } : null;
  }, sp.get.rgb = function (e) {
    if (!e) return null;
    var t,
        n,
        r,
        o = [0, 0, 0, 1];

    if (t = e.match(/^#([a-f0-9]{6})([a-f0-9]{2})?$/i)) {
      for (r = t[2], t = t[1], n = 0; n < 3; n++) {
        var i = 2 * n;
        o[n] = parseInt(t.slice(i, i + 2), 16);
      }

      r && (o[3] = parseInt(r, 16) / 255);
    } else if (t = e.match(/^#([a-f0-9]{3,4})$/i)) {
      for (r = (t = t[1])[3], n = 0; n < 3; n++) {
        o[n] = parseInt(t[n] + t[n], 16);
      }

      r && (o[3] = parseInt(r + r, 16) / 255);
    } else if (t = e.match(/^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/)) {
      for (n = 0; n < 3; n++) {
        o[n] = parseInt(t[n + 1], 0);
      }

      t[4] && (t[5] ? o[3] = .01 * parseFloat(t[4]) : o[3] = parseFloat(t[4]));
    } else {
      if (!(t = e.match(/^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/))) return (t = e.match(/^(\w+)$/)) ? "transparent" === t[1] ? [0, 0, 0, 0] : op.call(np, t[1]) ? ((o = np[t[1]])[3] = 1, o) : null : null;

      for (n = 0; n < 3; n++) {
        o[n] = Math.round(2.55 * parseFloat(t[n + 1]));
      }

      t[4] && (t[5] ? o[3] = .01 * parseFloat(t[4]) : o[3] = parseFloat(t[4]));
    }

    for (n = 0; n < 3; n++) {
      o[n] = lp(o[n], 0, 255);
    }

    return o[3] = lp(o[3], 0, 1), o;
  }, sp.get.hsl = function (e) {
    if (!e) return null;
    var t = e.match(/^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/);

    if (t) {
      var n = parseFloat(t[4]);
      return [(parseFloat(t[1]) % 360 + 360) % 360, lp(parseFloat(t[2]), 0, 100), lp(parseFloat(t[3]), 0, 100), lp(isNaN(n) ? 1 : n, 0, 1)];
    }

    return null;
  }, sp.get.hwb = function (e) {
    if (!e) return null;
    var t = e.match(/^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/);

    if (t) {
      var n = parseFloat(t[4]);
      return [(parseFloat(t[1]) % 360 + 360) % 360, lp(parseFloat(t[2]), 0, 100), lp(parseFloat(t[3]), 0, 100), lp(isNaN(n) ? 1 : n, 0, 1)];
    }

    return null;
  }, sp.to.hex = function () {
    var e = rp(arguments);
    return "#" + cp(e[0]) + cp(e[1]) + cp(e[2]) + (e[3] < 1 ? cp(Math.round(255 * e[3])) : "");
  }, sp.to.rgb = function () {
    var e = rp(arguments);
    return e.length < 4 || 1 === e[3] ? "rgb(" + Math.round(e[0]) + ", " + Math.round(e[1]) + ", " + Math.round(e[2]) + ")" : "rgba(" + Math.round(e[0]) + ", " + Math.round(e[1]) + ", " + Math.round(e[2]) + ", " + e[3] + ")";
  }, sp.to.rgb.percent = function () {
    var e = rp(arguments),
        t = Math.round(e[0] / 255 * 100),
        n = Math.round(e[1] / 255 * 100),
        r = Math.round(e[2] / 255 * 100);
    return e.length < 4 || 1 === e[3] ? "rgb(" + t + "%, " + n + "%, " + r + "%)" : "rgba(" + t + "%, " + n + "%, " + r + "%, " + e[3] + ")";
  }, sp.to.hsl = function () {
    var e = rp(arguments);
    return e.length < 4 || 1 === e[3] ? "hsl(" + e[0] + ", " + e[1] + "%, " + e[2] + "%)" : "hsla(" + e[0] + ", " + e[1] + "%, " + e[2] + "%, " + e[3] + ")";
  }, sp.to.hwb = function () {
    var e = rp(arguments),
        t = "";
    return e.length >= 4 && 1 !== e[3] && (t = ", " + e[3]), "hwb(" + e[0] + ", " + e[1] + "%, " + e[2] + "%" + t + ")";
  }, sp.to.keyword = function (e) {
    return ip[e.slice(0, 3)];
  };
  var up = Qf,
      dp = {};

  for (var _i2 = 0, _Object$keys = Object.keys(up); _i2 < _Object$keys.length; _i2++) {
    var _e5 = _Object$keys[_i2];
    dp[up[_e5]] = _e5;
  }

  var fp = {
    rgb: {
      channels: 3,
      labels: "rgb"
    },
    hsl: {
      channels: 3,
      labels: "hsl"
    },
    hsv: {
      channels: 3,
      labels: "hsv"
    },
    hwb: {
      channels: 3,
      labels: "hwb"
    },
    cmyk: {
      channels: 4,
      labels: "cmyk"
    },
    xyz: {
      channels: 3,
      labels: "xyz"
    },
    lab: {
      channels: 3,
      labels: "lab"
    },
    lch: {
      channels: 3,
      labels: "lch"
    },
    hex: {
      channels: 1,
      labels: ["hex"]
    },
    keyword: {
      channels: 1,
      labels: ["keyword"]
    },
    ansi16: {
      channels: 1,
      labels: ["ansi16"]
    },
    ansi256: {
      channels: 1,
      labels: ["ansi256"]
    },
    hcg: {
      channels: 3,
      labels: ["h", "c", "g"]
    },
    apple: {
      channels: 3,
      labels: ["r16", "g16", "b16"]
    },
    gray: {
      channels: 1,
      labels: ["gray"]
    }
  };
  var pp = fp;

  for (var _i3 = 0, _Object$keys2 = Object.keys(fp); _i3 < _Object$keys2.length; _i3++) {
    var _e6 = _Object$keys2[_i3];
    if (!("channels" in fp[_e6])) throw new Error("missing channels property: " + _e6);
    if (!("labels" in fp[_e6])) throw new Error("missing channel labels property: " + _e6);
    if (fp[_e6].labels.length !== fp[_e6].channels) throw new Error("channel and label counts mismatch: " + _e6);
    var _fp$_e = fp[_e6],
        _t6 = _fp$_e.channels,
        _n11 = _fp$_e.labels;
    delete fp[_e6].channels, delete fp[_e6].labels, Object.defineProperty(fp[_e6], "channels", {
      value: _t6
    }), Object.defineProperty(fp[_e6], "labels", {
      value: _n11
    });
  }

  function hp(e, t) {
    return Math.pow(e[0] - t[0], 2) + Math.pow(e[1] - t[1], 2) + Math.pow(e[2] - t[2], 2);
  }

  fp.rgb.hsl = function (e) {
    var t = e[0] / 255,
        n = e[1] / 255,
        r = e[2] / 255,
        o = Math.min(t, n, r),
        i = Math.max(t, n, r),
        a = i - o;
    var s, l;
    i === o ? s = 0 : t === i ? s = (n - r) / a : n === i ? s = 2 + (r - t) / a : r === i && (s = 4 + (t - n) / a), s = Math.min(60 * s, 360), s < 0 && (s += 360);
    var c = (o + i) / 2;
    return l = i === o ? 0 : c <= .5 ? a / (i + o) : a / (2 - i - o), [s, 100 * l, 100 * c];
  }, fp.rgb.hsv = function (e) {
    var t, n, r, o, i;

    var a = e[0] / 255,
        s = e[1] / 255,
        l = e[2] / 255,
        c = Math.max(a, s, l),
        u = c - Math.min(a, s, l),
        d = function d(e) {
      return (c - e) / 6 / u + .5;
    };

    return 0 === u ? (o = 0, i = 0) : (i = u / c, t = d(a), n = d(s), r = d(l), a === c ? o = r - n : s === c ? o = 1 / 3 + t - r : l === c && (o = 2 / 3 + n - t), o < 0 ? o += 1 : o > 1 && (o -= 1)), [360 * o, 100 * i, 100 * c];
  }, fp.rgb.hwb = function (e) {
    var t = e[0],
        n = e[1];
    var r = e[2];
    var o = fp.rgb.hsl(e)[0],
        i = 1 / 255 * Math.min(t, Math.min(n, r));
    return r = 1 - 1 / 255 * Math.max(t, Math.max(n, r)), [o, 100 * i, 100 * r];
  }, fp.rgb.cmyk = function (e) {
    var t = e[0] / 255,
        n = e[1] / 255,
        r = e[2] / 255,
        o = Math.min(1 - t, 1 - n, 1 - r);
    return [100 * ((1 - t - o) / (1 - o) || 0), 100 * ((1 - n - o) / (1 - o) || 0), 100 * ((1 - r - o) / (1 - o) || 0), 100 * o];
  }, fp.rgb.keyword = function (e) {
    var t = dp[e];
    if (t) return t;
    var n,
        r = 1 / 0;

    for (var _i4 = 0, _Object$keys3 = Object.keys(up); _i4 < _Object$keys3.length; _i4++) {
      var _t7 = _Object$keys3[_i4];

      var _o2 = hp(e, up[_t7]);

      _o2 < r && (r = _o2, n = _t7);
    }

    return n;
  }, fp.keyword.rgb = function (e) {
    return up[e];
  }, fp.rgb.xyz = function (e) {
    var t = e[0] / 255,
        n = e[1] / 255,
        r = e[2] / 255;
    t = t > .04045 ? Math.pow((t + .055) / 1.055, 2.4) : t / 12.92, n = n > .04045 ? Math.pow((n + .055) / 1.055, 2.4) : n / 12.92, r = r > .04045 ? Math.pow((r + .055) / 1.055, 2.4) : r / 12.92;
    return [100 * (.4124 * t + .3576 * n + .1805 * r), 100 * (.2126 * t + .7152 * n + .0722 * r), 100 * (.0193 * t + .1192 * n + .9505 * r)];
  }, fp.rgb.lab = function (e) {
    var t = fp.rgb.xyz(e);
    var n = t[0],
        r = t[1],
        o = t[2];
    n /= 95.047, r /= 100, o /= 108.883, n = n > .008856 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116, r = r > .008856 ? Math.pow(r, 1 / 3) : 7.787 * r + 16 / 116, o = o > .008856 ? Math.pow(o, 1 / 3) : 7.787 * o + 16 / 116;
    return [116 * r - 16, 500 * (n - r), 200 * (r - o)];
  }, fp.hsl.rgb = function (e) {
    var t = e[0] / 360,
        n = e[1] / 100,
        r = e[2] / 100;
    var o, i, a;
    if (0 === n) return a = 255 * r, [a, a, a];
    o = r < .5 ? r * (1 + n) : r + n - r * n;
    var s = 2 * r - o,
        l = [0, 0, 0];

    for (var _e7 = 0; _e7 < 3; _e7++) {
      i = t + 1 / 3 * -(_e7 - 1), i < 0 && i++, i > 1 && i--, a = 6 * i < 1 ? s + 6 * (o - s) * i : 2 * i < 1 ? o : 3 * i < 2 ? s + (o - s) * (2 / 3 - i) * 6 : s, l[_e7] = 255 * a;
    }

    return l;
  }, fp.hsl.hsv = function (e) {
    var t = e[0];
    var n = e[1] / 100,
        r = e[2] / 100,
        o = n;
    var i = Math.max(r, .01);
    r *= 2, n *= r <= 1 ? r : 2 - r, o *= i <= 1 ? i : 2 - i;
    return [t, 100 * (0 === r ? 2 * o / (i + o) : 2 * n / (r + n)), 100 * ((r + n) / 2)];
  }, fp.hsv.rgb = function (e) {
    var t = e[0] / 60,
        n = e[1] / 100;
    var r = e[2] / 100;
    var o = Math.floor(t) % 6,
        i = t - Math.floor(t),
        a = 255 * r * (1 - n),
        s = 255 * r * (1 - n * i),
        l = 255 * r * (1 - n * (1 - i));

    switch (r *= 255, o) {
      case 0:
        return [r, l, a];

      case 1:
        return [s, r, a];

      case 2:
        return [a, r, l];

      case 3:
        return [a, s, r];

      case 4:
        return [l, a, r];

      case 5:
        return [r, a, s];
    }
  }, fp.hsv.hsl = function (e) {
    var t = e[0],
        n = e[1] / 100,
        r = e[2] / 100,
        o = Math.max(r, .01);
    var i, a;
    a = (2 - n) * r;
    var s = (2 - n) * o;
    return i = n * o, i /= s <= 1 ? s : 2 - s, i = i || 0, a /= 2, [t, 100 * i, 100 * a];
  }, fp.hwb.rgb = function (e) {
    var t = e[0] / 360;
    var n = e[1] / 100,
        r = e[2] / 100;
    var o = n + r;
    var i;
    o > 1 && (n /= o, r /= o);
    var a = Math.floor(6 * t),
        s = 1 - r;
    i = 6 * t - a, 0 != (1 & a) && (i = 1 - i);
    var l = n + i * (s - n);
    var c, u, d;

    switch (a) {
      default:
      case 6:
      case 0:
        c = s, u = l, d = n;
        break;

      case 1:
        c = l, u = s, d = n;
        break;

      case 2:
        c = n, u = s, d = l;
        break;

      case 3:
        c = n, u = l, d = s;
        break;

      case 4:
        c = l, u = n, d = s;
        break;

      case 5:
        c = s, u = n, d = l;
    }

    return [255 * c, 255 * u, 255 * d];
  }, fp.cmyk.rgb = function (e) {
    var t = e[0] / 100,
        n = e[1] / 100,
        r = e[2] / 100,
        o = e[3] / 100;
    return [255 * (1 - Math.min(1, t * (1 - o) + o)), 255 * (1 - Math.min(1, n * (1 - o) + o)), 255 * (1 - Math.min(1, r * (1 - o) + o))];
  }, fp.xyz.rgb = function (e) {
    var t = e[0] / 100,
        n = e[1] / 100,
        r = e[2] / 100;
    var o, i, a;
    return o = 3.2406 * t + -1.5372 * n + -.4986 * r, i = -.9689 * t + 1.8758 * n + .0415 * r, a = .0557 * t + -.204 * n + 1.057 * r, o = o > .0031308 ? 1.055 * Math.pow(o, 1 / 2.4) - .055 : 12.92 * o, i = i > .0031308 ? 1.055 * Math.pow(i, 1 / 2.4) - .055 : 12.92 * i, a = a > .0031308 ? 1.055 * Math.pow(a, 1 / 2.4) - .055 : 12.92 * a, o = Math.min(Math.max(0, o), 1), i = Math.min(Math.max(0, i), 1), a = Math.min(Math.max(0, a), 1), [255 * o, 255 * i, 255 * a];
  }, fp.xyz.lab = function (e) {
    var t = e[0],
        n = e[1],
        r = e[2];
    t /= 95.047, n /= 100, r /= 108.883, t = t > .008856 ? Math.pow(t, 1 / 3) : 7.787 * t + 16 / 116, n = n > .008856 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116, r = r > .008856 ? Math.pow(r, 1 / 3) : 7.787 * r + 16 / 116;
    return [116 * n - 16, 500 * (t - n), 200 * (n - r)];
  }, fp.lab.xyz = function (e) {
    var t, n, r;
    n = (e[0] + 16) / 116, t = e[1] / 500 + n, r = n - e[2] / 200;
    var o = Math.pow(n, 3),
        i = Math.pow(t, 3),
        a = Math.pow(r, 3);
    return n = o > .008856 ? o : (n - 16 / 116) / 7.787, t = i > .008856 ? i : (t - 16 / 116) / 7.787, r = a > .008856 ? a : (r - 16 / 116) / 7.787, t *= 95.047, n *= 100, r *= 108.883, [t, n, r];
  }, fp.lab.lch = function (e) {
    var t = e[0],
        n = e[1],
        r = e[2];
    var o;
    o = 360 * Math.atan2(r, n) / 2 / Math.PI, o < 0 && (o += 360);
    return [t, Math.sqrt(n * n + r * r), o];
  }, fp.lch.lab = function (e) {
    var t = e[0],
        n = e[1],
        r = e[2] / 360 * 2 * Math.PI;
    return [t, n * Math.cos(r), n * Math.sin(r)];
  }, fp.rgb.ansi16 = function (e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var _e8 = _slicedToArray(e, 3),
        n = _e8[0],
        r = _e8[1],
        o = _e8[2];

    var i = null === t ? fp.rgb.hsv(e)[2] : t;
    if (i = Math.round(i / 50), 0 === i) return 30;
    var a = 30 + (Math.round(o / 255) << 2 | Math.round(r / 255) << 1 | Math.round(n / 255));
    return 2 === i && (a += 60), a;
  }, fp.hsv.ansi16 = function (e) {
    return fp.rgb.ansi16(fp.hsv.rgb(e), e[2]);
  }, fp.rgb.ansi256 = function (e) {
    var t = e[0],
        n = e[1],
        r = e[2];
    if (t === n && n === r) return t < 8 ? 16 : t > 248 ? 231 : Math.round((t - 8) / 247 * 24) + 232;
    return 16 + 36 * Math.round(t / 255 * 5) + 6 * Math.round(n / 255 * 5) + Math.round(r / 255 * 5);
  }, fp.ansi16.rgb = function (e) {
    var t = e % 10;
    if (0 === t || 7 === t) return e > 50 && (t += 3.5), t = t / 10.5 * 255, [t, t, t];
    var n = .5 * (1 + ~~(e > 50));
    return [(1 & t) * n * 255, (t >> 1 & 1) * n * 255, (t >> 2 & 1) * n * 255];
  }, fp.ansi256.rgb = function (e) {
    if (e >= 232) {
      var _t8 = 10 * (e - 232) + 8;

      return [_t8, _t8, _t8];
    }

    var t;
    e -= 16;
    return [Math.floor(e / 36) / 5 * 255, Math.floor((t = e % 36) / 6) / 5 * 255, t % 6 / 5 * 255];
  }, fp.rgb.hex = function (e) {
    var t = (((255 & Math.round(e[0])) << 16) + ((255 & Math.round(e[1])) << 8) + (255 & Math.round(e[2]))).toString(16).toUpperCase();
    return "000000".substring(t.length) + t;
  }, fp.hex.rgb = function (e) {
    var t = e.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!t) return [0, 0, 0];
    var n = t[0];
    3 === t[0].length && (n = n.split("").map(function (e) {
      return e + e;
    }).join(""));
    var r = parseInt(n, 16);
    return [r >> 16 & 255, r >> 8 & 255, 255 & r];
  }, fp.rgb.hcg = function (e) {
    var t = e[0] / 255,
        n = e[1] / 255,
        r = e[2] / 255,
        o = Math.max(Math.max(t, n), r),
        i = Math.min(Math.min(t, n), r),
        a = o - i;
    var s, l;
    return s = a < 1 ? i / (1 - a) : 0, l = a <= 0 ? 0 : o === t ? (n - r) / a % 6 : o === n ? 2 + (r - t) / a : 4 + (t - n) / a, l /= 6, l %= 1, [360 * l, 100 * a, 100 * s];
  }, fp.hsl.hcg = function (e) {
    var t = e[1] / 100,
        n = e[2] / 100,
        r = n < .5 ? 2 * t * n : 2 * t * (1 - n);
    var o = 0;
    return r < 1 && (o = (n - .5 * r) / (1 - r)), [e[0], 100 * r, 100 * o];
  }, fp.hsv.hcg = function (e) {
    var t = e[1] / 100,
        n = e[2] / 100,
        r = t * n;
    var o = 0;
    return r < 1 && (o = (n - r) / (1 - r)), [e[0], 100 * r, 100 * o];
  }, fp.hcg.rgb = function (e) {
    var t = e[0] / 360,
        n = e[1] / 100,
        r = e[2] / 100;
    if (0 === n) return [255 * r, 255 * r, 255 * r];
    var o = [0, 0, 0],
        i = t % 1 * 6,
        a = i % 1,
        s = 1 - a;
    var l = 0;

    switch (Math.floor(i)) {
      case 0:
        o[0] = 1, o[1] = a, o[2] = 0;
        break;

      case 1:
        o[0] = s, o[1] = 1, o[2] = 0;
        break;

      case 2:
        o[0] = 0, o[1] = 1, o[2] = a;
        break;

      case 3:
        o[0] = 0, o[1] = s, o[2] = 1;
        break;

      case 4:
        o[0] = a, o[1] = 0, o[2] = 1;
        break;

      default:
        o[0] = 1, o[1] = 0, o[2] = s;
    }

    return l = (1 - n) * r, [255 * (n * o[0] + l), 255 * (n * o[1] + l), 255 * (n * o[2] + l)];
  }, fp.hcg.hsv = function (e) {
    var t = e[1] / 100,
        n = t + e[2] / 100 * (1 - t);
    var r = 0;
    return n > 0 && (r = t / n), [e[0], 100 * r, 100 * n];
  }, fp.hcg.hsl = function (e) {
    var t = e[1] / 100,
        n = e[2] / 100 * (1 - t) + .5 * t;
    var r = 0;
    return n > 0 && n < .5 ? r = t / (2 * n) : n >= .5 && n < 1 && (r = t / (2 * (1 - n))), [e[0], 100 * r, 100 * n];
  }, fp.hcg.hwb = function (e) {
    var t = e[1] / 100,
        n = t + e[2] / 100 * (1 - t);
    return [e[0], 100 * (n - t), 100 * (1 - n)];
  }, fp.hwb.hcg = function (e) {
    var t = e[1] / 100,
        n = 1 - e[2] / 100,
        r = n - t;
    var o = 0;
    return r < 1 && (o = (n - r) / (1 - r)), [e[0], 100 * r, 100 * o];
  }, fp.apple.rgb = function (e) {
    return [e[0] / 65535 * 255, e[1] / 65535 * 255, e[2] / 65535 * 255];
  }, fp.rgb.apple = function (e) {
    return [e[0] / 255 * 65535, e[1] / 255 * 65535, e[2] / 255 * 65535];
  }, fp.gray.rgb = function (e) {
    return [e[0] / 100 * 255, e[0] / 100 * 255, e[0] / 100 * 255];
  }, fp.gray.hsl = function (e) {
    return [0, 0, e[0]];
  }, fp.gray.hsv = fp.gray.hsl, fp.gray.hwb = function (e) {
    return [0, 100, e[0]];
  }, fp.gray.cmyk = function (e) {
    return [0, 0, 0, e[0]];
  }, fp.gray.lab = function (e) {
    return [e[0], 0, 0];
  }, fp.gray.hex = function (e) {
    var t = 255 & Math.round(e[0] / 100 * 255),
        n = ((t << 16) + (t << 8) + t).toString(16).toUpperCase();
    return "000000".substring(n.length) + n;
  }, fp.rgb.gray = function (e) {
    return [(e[0] + e[1] + e[2]) / 3 / 255 * 100];
  };
  var mp = pp;

  function gp(e) {
    var t = function () {
      var e = {},
          t = Object.keys(mp);

      for (var _n12 = t.length, _r5 = 0; _r5 < _n12; _r5++) {
        e[t[_r5]] = {
          distance: -1,
          parent: null
        };
      }

      return e;
    }(),
        n = [e];

    for (t[e].distance = 0; n.length;) {
      var _e9 = n.pop(),
          _r6 = Object.keys(mp[_e9]);

      for (var _o3 = _r6.length, _i5 = 0; _i5 < _o3; _i5++) {
        var _o4 = _r6[_i5],
            _a2 = t[_o4];
        -1 === _a2.distance && (_a2.distance = t[_e9].distance + 1, _a2.parent = _e9, n.unshift(_o4));
      }
    }

    return t;
  }

  function yp(e, t) {
    return function (n) {
      return t(e(n));
    };
  }

  function bp(e, t) {
    var n = [t[e].parent, e];
    var r = mp[t[e].parent][e],
        o = t[e].parent;

    for (; t[o].parent;) {
      n.unshift(t[o].parent), r = yp(mp[t[o].parent][o], r), o = t[o].parent;
    }

    return r.conversion = n, r;
  }

  var vp = pp,
      xp = function xp(e) {
    var t = gp(e),
        n = {},
        r = Object.keys(t);

    for (var _e10 = r.length, _o5 = 0; _o5 < _e10; _o5++) {
      var _e11 = r[_o5];
      null !== t[_e11].parent && (n[_e11] = bp(_e11, t));
    }

    return n;
  },
      wp = {};

  Object.keys(vp).forEach(function (e) {
    wp[e] = {}, Object.defineProperty(wp[e], "channels", {
      value: vp[e].channels
    }), Object.defineProperty(wp[e], "labels", {
      value: vp[e].labels
    });
    var t = xp(e);
    Object.keys(t).forEach(function (n) {
      var r = t[n];
      wp[e][n] = function (e) {
        var t = function t() {
          for (var _len5 = arguments.length, t = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            t[_key5] = arguments[_key5];
          }

          var n = t[0];
          if (null == n) return n;
          n.length > 1 && (t = n);
          var r = e(t);
          if ("object" == _typeof(r)) for (var _e12 = r.length, _t9 = 0; _t9 < _e12; _t9++) {
            r[_t9] = Math.round(r[_t9]);
          }
          return r;
        };

        return "conversion" in e && (t.conversion = e.conversion), t;
      }(r), wp[e][n].raw = function (e) {
        var t = function t() {
          for (var _len6 = arguments.length, t = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
            t[_key6] = arguments[_key6];
          }

          var n = t[0];
          return null == n ? n : (n.length > 1 && (t = n), e(t));
        };

        return "conversion" in e && (t.conversion = e.conversion), t;
      }(r);
    });
  });
  var kp = wp;
  var Cp = Yf.exports,
      Mp = kp,
      jp = ["keyword", "gray", "hex"],
      Ep = {};

  for (var _i6 = 0, _Object$keys4 = Object.keys(Mp); _i6 < _Object$keys4.length; _i6++) {
    var _e13 = _Object$keys4[_i6];
    Ep[_toConsumableArray(Mp[_e13].labels).sort().join("")] = _e13;
  }

  var _p = {};

  function Tp(e, t) {
    if (!(this instanceof Tp)) return new Tp(e, t);
    if (t && t in jp && (t = null), t && !(t in Mp)) throw new Error("Unknown model: " + t);
    var n, r;
    if (null == e) this.model = "rgb", this.color = [0, 0, 0], this.valpha = 1;else if (e instanceof Tp) this.model = e.model, this.color = _toConsumableArray(e.color), this.valpha = e.valpha;else if ("string" == typeof e) {
      var _t10 = Cp.get(e);

      if (null === _t10) throw new Error("Unable to parse color from string: " + e);
      this.model = _t10.model, r = Mp[this.model].channels, this.color = _t10.value.slice(0, r), this.valpha = "number" == typeof _t10.value[r] ? _t10.value[r] : 1;
    } else if (e.length > 0) {
      this.model = t || "rgb", r = Mp[this.model].channels;

      var _n13 = Array.prototype.slice.call(e, 0, r);

      this.color = Ap(_n13, r), this.valpha = "number" == typeof e[r] ? e[r] : 1;
    } else if ("number" == typeof e) this.model = "rgb", this.color = [e >> 16 & 255, e >> 8 & 255, 255 & e], this.valpha = 1;else {
      this.valpha = 1;

      var _t11 = Object.keys(e);

      "alpha" in e && (_t11.splice(_t11.indexOf("alpha"), 1), this.valpha = "number" == typeof e.alpha ? e.alpha : 0);

      var _r7 = _t11.sort().join("");

      if (!(_r7 in Ep)) throw new Error("Unable to parse color from object: " + JSON.stringify(e));
      this.model = Ep[_r7];
      var _o6 = Mp[this.model].labels,
          _i7 = [];

      for (n = 0; n < _o6.length; n++) {
        _i7.push(e[_o6[n]]);
      }

      this.color = Ap(_i7);
    }
    if (_p[this.model]) for (r = Mp[this.model].channels, n = 0; n < r; n++) {
      var _e14 = _p[this.model][n];
      _e14 && (this.color[n] = _e14(this.color[n]));
    }
    this.valpha = Math.max(0, Math.min(1, this.valpha)), Object.freeze && Object.freeze(this);
  }

  Tp.prototype = {
    toString: function toString() {
      return this.string();
    },
    toJSON: function toJSON() {
      return this[this.model]();
    },
    string: function string(e) {
      var t = this.model in Cp.to ? this : this.rgb();
      t = t.round("number" == typeof e ? e : 1);
      var n = 1 === t.valpha ? t.color : [].concat(_toConsumableArray(t.color), [this.valpha]);
      return Cp.to[t.model](n);
    },
    percentString: function percentString(e) {
      var t = this.rgb().round("number" == typeof e ? e : 1),
          n = 1 === t.valpha ? t.color : [].concat(_toConsumableArray(t.color), [this.valpha]);
      return Cp.to.rgb.percent(n);
    },
    array: function array() {
      return 1 === this.valpha ? _toConsumableArray(this.color) : [].concat(_toConsumableArray(this.color), [this.valpha]);
    },
    object: function object() {
      var e = {},
          t = Mp[this.model].channels,
          n = Mp[this.model].labels;

      for (var _r8 = 0; _r8 < t; _r8++) {
        e[n[_r8]] = this.color[_r8];
      }

      return 1 !== this.valpha && (e.alpha = this.valpha), e;
    },
    unitArray: function unitArray() {
      var e = this.rgb().color;
      return e[0] /= 255, e[1] /= 255, e[2] /= 255, 1 !== this.valpha && e.push(this.valpha), e;
    },
    unitObject: function unitObject() {
      var e = this.rgb().object();
      return e.r /= 255, e.g /= 255, e.b /= 255, 1 !== this.valpha && (e.alpha = this.valpha), e;
    },
    round: function round(e) {
      return e = Math.max(e || 0, 0), new Tp([].concat(_toConsumableArray(this.color.map(Sp(e))), [this.valpha]), this.model);
    },
    alpha: function alpha(e) {
      return void 0 !== e ? new Tp([].concat(_toConsumableArray(this.color), [Math.max(0, Math.min(1, e))]), this.model) : this.valpha;
    },
    red: Lp("rgb", 0, Dp(255)),
    green: Lp("rgb", 1, Dp(255)),
    blue: Lp("rgb", 2, Dp(255)),
    hue: Lp(["hsl", "hsv", "hsl", "hwb", "hcg"], 0, function (e) {
      return (e % 360 + 360) % 360;
    }),
    saturationl: Lp("hsl", 1, Dp(100)),
    lightness: Lp("hsl", 2, Dp(100)),
    saturationv: Lp("hsv", 1, Dp(100)),
    value: Lp("hsv", 2, Dp(100)),
    chroma: Lp("hcg", 1, Dp(100)),
    gray: Lp("hcg", 2, Dp(100)),
    white: Lp("hwb", 1, Dp(100)),
    wblack: Lp("hwb", 2, Dp(100)),
    cyan: Lp("cmyk", 0, Dp(100)),
    magenta: Lp("cmyk", 1, Dp(100)),
    yellow: Lp("cmyk", 2, Dp(100)),
    black: Lp("cmyk", 3, Dp(100)),
    x: Lp("xyz", 0, Dp(95.047)),
    y: Lp("xyz", 1, Dp(100)),
    z: Lp("xyz", 2, Dp(108.833)),
    l: Lp("lab", 0, Dp(100)),
    a: Lp("lab", 1),
    b: Lp("lab", 2),
    keyword: function keyword(e) {
      return void 0 !== e ? new Tp(e) : Mp[this.model].keyword(this.color);
    },
    hex: function hex(e) {
      return void 0 !== e ? new Tp(e) : Cp.to.hex(this.rgb().round().color);
    },
    hexa: function hexa(e) {
      if (void 0 !== e) return new Tp(e);
      var t = this.rgb().round().color;
      var n = Math.round(255 * this.valpha).toString(16).toUpperCase();
      return 1 === n.length && (n = "0" + n), Cp.to.hex(t) + n;
    },
    rgbNumber: function rgbNumber() {
      var e = this.rgb().color;
      return (255 & e[0]) << 16 | (255 & e[1]) << 8 | 255 & e[2];
    },
    luminosity: function luminosity() {
      var e = this.rgb().color,
          t = [];

      var _iterator = _createForOfIteratorHelper(e.entries()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              _n14 = _step$value[0],
              _r9 = _step$value[1];

          var _e15 = _r9 / 255;

          t[_n14] = _e15 <= .04045 ? _e15 / 12.92 : Math.pow((_e15 + .055) / 1.055, 2.4);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return .2126 * t[0] + .7152 * t[1] + .0722 * t[2];
    },
    contrast: function contrast(e) {
      var t = this.luminosity(),
          n = e.luminosity();
      return t > n ? (t + .05) / (n + .05) : (n + .05) / (t + .05);
    },
    level: function level(e) {
      var t = this.contrast(e);
      return t >= 7 ? "AAA" : t >= 4.5 ? "AA" : "";
    },
    isDark: function isDark() {
      var e = this.rgb().color;
      return (2126 * e[0] + 7152 * e[1] + 722 * e[2]) / 1e4 < 128;
    },
    isLight: function isLight() {
      return !this.isDark();
    },
    negate: function negate() {
      var e = this.rgb();

      for (var _t12 = 0; _t12 < 3; _t12++) {
        e.color[_t12] = 255 - e.color[_t12];
      }

      return e;
    },
    lighten: function lighten(e) {
      var t = this.hsl();
      return t.color[2] += t.color[2] * e, t;
    },
    darken: function darken(e) {
      var t = this.hsl();
      return t.color[2] -= t.color[2] * e, t;
    },
    saturate: function saturate(e) {
      var t = this.hsl();
      return t.color[1] += t.color[1] * e, t;
    },
    desaturate: function desaturate(e) {
      var t = this.hsl();
      return t.color[1] -= t.color[1] * e, t;
    },
    whiten: function whiten(e) {
      var t = this.hwb();
      return t.color[1] += t.color[1] * e, t;
    },
    blacken: function blacken(e) {
      var t = this.hwb();
      return t.color[2] += t.color[2] * e, t;
    },
    grayscale: function grayscale() {
      var e = this.rgb().color,
          t = .3 * e[0] + .59 * e[1] + .11 * e[2];
      return Tp.rgb(t, t, t);
    },
    fade: function fade(e) {
      return this.alpha(this.valpha - this.valpha * e);
    },
    opaquer: function opaquer(e) {
      return this.alpha(this.valpha + this.valpha * e);
    },
    rotate: function rotate(e) {
      var t = this.hsl();
      var n = t.color[0];
      return n = (n + e) % 360, n = n < 0 ? 360 + n : n, t.color[0] = n, t;
    },
    mix: function mix(e, t) {
      if (!e || !e.rgb) throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + _typeof(e));
      var n = e.rgb(),
          r = this.rgb(),
          o = void 0 === t ? .5 : t,
          i = 2 * o - 1,
          a = n.alpha() - r.alpha(),
          s = ((i * a == -1 ? i : (i + a) / (1 + i * a)) + 1) / 2,
          l = 1 - s;
      return Tp.rgb(s * n.red() + l * r.red(), s * n.green() + l * r.green(), s * n.blue() + l * r.blue(), n.alpha() * o + r.alpha() * (1 - o));
    }
  };

  var _loop2 = function _loop2() {
    var e = _Object$keys5[_i8];
    if (jp.includes(e)) return "continue";
    var t = Mp[e].channels;
    Tp.prototype[e] = function () {
      for (var _len7 = arguments.length, t = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        t[_key7] = arguments[_key7];
      }

      return this.model === e ? new Tp(this) : t.length > 0 ? new Tp(t, e) : new Tp([].concat(_toConsumableArray((n = Mp[this.model][e].raw(this.color), Array.isArray(n) ? n : [n])), [this.valpha]), e);
      var n;
    }, Tp[e] = function () {
      for (var _len8 = arguments.length, n = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        n[_key8] = arguments[_key8];
      }

      var r = n[0];
      return "number" == typeof r && (r = Ap(n, t)), new Tp(r, e);
    };
  };

  for (var _i8 = 0, _Object$keys5 = Object.keys(Mp); _i8 < _Object$keys5.length; _i8++) {
    var _ret = _loop2();

    if (_ret === "continue") continue;
  }

  function Sp(e) {
    return function (t) {
      return function (e, t) {
        return Number(e.toFixed(t));
      }(t, e);
    };
  }

  function Lp(e, t, n) {
    e = Array.isArray(e) ? e : [e];

    var _iterator2 = _createForOfIteratorHelper(e),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _r10 = _step2.value;
        (_p[_r10] || (_p[_r10] = []))[t] = n;
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    return e = e[0], function (r) {
      var o;
      return void 0 !== r ? (n && (r = n(r)), o = this[e](), o.color[t] = r, o) : (o = this[e]().color[t], n && (o = n(o)), o);
    };
  }

  function Dp(e) {
    return function (t) {
      return Math.max(0, Math.min(e, t));
    };
  }

  function Ap(e, t) {
    for (var _n15 = 0; _n15 < t; _n15++) {
      "number" != typeof e[_n15] && (e[_n15] = 0);
    }

    return e;
  }

  var Np = Tp;

  function Ip(e, t) {
    return Np(e).alpha(t).string();
  }

  var zp = _["default"].button.withConfig({
    displayName: "audioButtons__StandardButton",
    componentId: "sc-4eq8eb-0"
  })(["appearance:none;border:none;background:transparent;cursor:pointer;display:flex;flex-shrink:0;align-items:center;line-height:1;transition:opacity 0.15s ease-in-out;padding:0;height:2rem;width:1.5rem;&:hover{opacity:0.5;}&:focus{outline:none;}", ""], function (e) {
    return e.disabled && "\n    opacity: 0.25;\n    pointer-events: none;\n  ";
  });

  zp.displayName = "StandardAudioButton";

  var Op = _["default"].button.withConfig({
    displayName: "audioButtons__BigButton",
    componentId: "sc-4eq8eb-1"
  })(["appearance:none;border:none;background:", ";border-radius:", ";cursor:pointer;display:flex;flex-shrink:0;align-items:center;justify-content:center;line-height:1;transition:background 0.15s ease-in-out;padding:0;height:2.5rem;width:2.5rem;&:hover{background:", ";}", " &:focus{outline:none;}", ""], function (e) {
    return e.theme.colors.yellow500;
  }, function (e) {
    return e.theme.radii.circular;
  }, function (e) {
    return Ip(e.theme.colors.yellow500, .75);
  }, wc.lg(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    height: 3rem;\n    width: 3rem;\n  "]))), function (e) {
    return e.disabled && "\n    background: ".concat(Ip(e.theme.colors.yellow500, .5), ";\n    pointer-events: none;\n  ");
  });

  Op.displayName = "BigAudioButton";

  var Rp = _["default"].button.withConfig({
    displayName: "audioButtons__SpeakingTaskButton",
    componentId: "sc-4eq8eb-2"
  })(["background-color:", ";border-radius:", ";border:none;cursor:pointer;height:78%;width:78%;transition:background 0.15s ease-in-out;z-index:1;", " &:hover{background:", ";}&:focus{outline:none;}"], function (e) {
    return e.theme.colors.green300;
  }, function (e) {
    return e.theme.radii.circular;
  }, wc.lg(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    height: 82%;\n    width: 82%;\n  "]))), function (e) {
    return e.theme.colors.green500;
  }),
      Pp = "speaking",
      Fp = "standard",
      Bp = "tasks",
      qp = Ja(fe),
      Up = _["default"](qp).attrs(function (e) {
    var t = e.height,
        n = e.mr;
    return {
      bg: "black",
      borderRadius: "rounded",
      display: "inline-block",
      mr: n,
      height: t,
      width: "2px"
    };
  }).withConfig({
    displayName: "Audio__Bar",
    componentId: "sc-1ofzl87-0"
  })([""]);

  Up.displayName = "AudioBar";

  var Vp = [5, 20, 11, 30, 20, 11, 5],
      Hp = {
    initial: {
      scaleY: 1
    },
    animate: function animate(e) {
      return {
        scaleY: 1.25,
        transition: {
          repeat: 1 / 0,
          repeatType: "mirror",
          delay: .125 * e
        }
      };
    }
  },
      Zp = function Zp(e) {
    var t = e.variant,
        n = e.disabled,
        r = e.onClick,
        o = e.children,
        i = e.ariaLabel;

    switch (t) {
      case Bp:
        return s.jsx(Op, {
          disabled: n,
          onClick: r,
          "aria-label": i,
          children: o
        });

      case Pp:
        return s.jsxs(fe, {
          position: "relative",
          size: ["64px", null, "94px", "168px"],
          children: [s.jsx(fe, {
            background: "#fff",
            border: ["solid 4px #5DD4A4", null, "solid 6px #5DD4A4", "solid 8px #5DD4A4"],
            borderRadius: "100%",
            height: "100%",
            width: "100%"
          }), s.jsx(fe, {
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            height: "100%",
            justifyContent: "center",
            marginTop: "-100%",
            position: "absolute",
            width: "100%",
            children: s.jsx(Rp, {
              disabled: n,
              onClick: r,
              "aria-label": i,
              children: o
            })
          })]
        });

      default:
        return s.jsx(zp, {
          disabled: n,
          onClick: r,
          "aria-label": i,
          children: o
        });
    }
  };

  function Wp(e) {
    var t = e.showCurrentTime,
        n = e.showRemainingTime,
        r = e.src,
        i = e.variant,
        a = e.handleAudioDeletion,
        l = e.limit,
        c = e.pausable,
        u = e.currentPlayedTimes,
        d = e.onPlay,
        f = e.onPause,
        p = _objectWithoutProperties(e, _excluded56);

    var h = o.useRef(null),
        _o$useState17 = o.useState(!1),
        _o$useState18 = _slicedToArray(_o$useState17, 2),
        m = _o$useState18[0],
        g = _o$useState18[1],
        _o$useState19 = o.useState(0),
        _o$useState20 = _slicedToArray(_o$useState19, 2),
        y = _o$useState20[0],
        b = _o$useState20[1],
        _o$useState21 = o.useState(0),
        _o$useState22 = _slicedToArray(_o$useState21, 2),
        v = _o$useState22[0],
        x = _o$useState22[1],
        w = Math.floor(v / 60 % 60),
        k = Math.floor(v % 60),
        C = h.current ? Math.floor(h.current.duration) || 120 : 0,
        M = C - v,
        j = Math.floor(M / 60 % 60),
        E = Math.floor(M % 60),
        _o$useState23 = o.useState(!1),
        _o$useState24 = _slicedToArray(_o$useState23, 2),
        _ = _o$useState24[0],
        T = _o$useState24[1],
        _o$useState25 = o.useState(!1),
        _o$useState26 = _slicedToArray(_o$useState25, 2),
        S = _o$useState26[0],
        L = _o$useState26[1];

    function A() {
      if (m) {
        if (!c) return;
        return g(!1), f(), h.current.pause();
      }

      return d(), b(function (e) {
        return e + 1;
      }), g(!0), h.current.play();
    }

    function N() {
      m && h.current.play();
    }

    o.useEffect(function () {
      L(Zf());
    }, []);
    var I = h.current ? v / C * 100 : 0,
        z = l && (u === l || y === l) || m && !c;
    return s.jsxs(fe, {
      display: i === Pp ? "flex" : "block",
      flexDirection: i === Pp ? ["row", null, null, "column"] : null,
      alignItems: "center",
      flex: i === Pp ? [1, null, null, "none"] : 1,
      children: [s.jsx("audio", {
        onCanPlayThrough: function onCanPlayThrough() {
          return L(!0);
        },
        onPlaying: function onPlaying() {
          return T(!1);
        },
        onTimeUpdate: function onTimeUpdate() {
          return x(parseInt(h.current.currentTime, 10));
        },
        onWaiting: function onWaiting() {
          return T(!0);
        },
        onEnded: function onEnded() {
          return g(!1);
        },
        preload: "auto",
        ref: h,
        src: r
      }), i === Pp && s.jsx(fe, {
        mb: [0, null, null, 4],
        children: S && !_ ? s.jsx(Zp, {
          disabled: !(S && !_) || z,
          onClick: A,
          variant: i,
          ariaLabel: m ? "Pause audio" : "Play audio",
          children: s.jsx(mc, {
            pt: 1,
            color: "white",
            weight: "light",
            fontSize: [4, null, null, 6],
            icon: m ? "pause" : "play"
          })
        }) : s.jsx(Hf, {
          size: "90px",
          color: "gray400"
        })
      }), s.jsxs(fe, _objectSpread(_objectSpread({
        display: "flex",
        alignItems: "center",
        flex: "1"
      }, p), {}, {
        children: [i !== Pp && s.jsx(Zp, {
          disabled: !(S && !_) || z,
          onClick: A,
          variant: i,
          ariaLabel: m ? "Pause audio" : "Play audio",
          children: S && !_ ? c && m ? s.jsx(au, {
            size: "1rem"
          }) : m ? s.jsx(qp, {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "absolute",
            initial: {
              opacity: 0
            },
            animate: {
              opacity: m ? 1 : 0
            },
            style: {
              transform: "scale(0.5)"
            },
            children: Vp.map(function (e, t, n) {
              return s.jsx(Up, {
                height: e,
                mr: D["default"](t + 1, n.length) ? 0 : "4px",
                variants: Hp,
                initial: "initial",
                animate: "animate",
                custom: t + 1
              }, "".concat(e, "-").concat(t));
            })
          }) : s.jsx(su, {
            size: "1rem",
            position: "relative",
            left: "tasks" === i ? "2px" : 0
          }) : s.jsx(Hf, {
            size: "22px",
            color: "black"
          })
        }), t && s.jsxs(fe, {
          fontSize: "0.75rem",
          width: "5ch",
          ml: i === Bp ? 2 : 0,
          children: [w < 10 ? "0".concat(w) : w, ":", k < 10 ? "0".concat(k) : k]
        }), s.jsx($f, {
          min: 0,
          max: C,
          onChange: function onChange(e) {
            return t = e.target.value, void (h.current.currentTime = t);
            var t;
          },
          onMouseDown: function onMouseDown() {
            return m && h.current.pause();
          },
          onTouchStart: function onTouchStart() {
            return m && h.current.pause();
          },
          onMouseUp: function onMouseUp() {
            return N();
          },
          onTouchEnd: function onTouchEnd() {
            return N();
          },
          step: 1,
          style: {
            backgroundSize: "".concat(I, "% 100%")
          },
          value: v,
          secondary: i === Pp,
          "aria-label": "Audio track"
        }), n && s.jsxs(fe, {
          fontSize: "0.75rem",
          width: "5ch",
          children: [j < 10 ? "0".concat(j) : j, ":", E < 10 ? "0".concat(E) : E]
        }), a && s.jsx(Ss, {
          onClick: a,
          ml: 2,
          "aria-label": "Delete Audio",
          children: s.jsx(mc, {
            icon: "trash-alt",
            weight: "light"
          })
        }), l > 0 && s.jsxs(ys, {
          fontSize: 0,
          flexShrink: 0,
          children: [u > 0 ? u : y, " /", " ", l, " plays"]
        })]
      }))]
    });
  }

  Zp.propTypes = {
    children: T["default"].node.isRequired,
    disabled: T["default"].bool.isRequired,
    onClick: T["default"].func.isRequired,
    variant: T["default"].oneOf([Fp, Bp, Pp]).isRequired,
    ariaLabel: T["default"].string.isRequired
  }, Wp.defaultProps = {
    showCurrentTime: !0,
    showRemainingTime: !0,
    variant: Fp,
    handleAudioDeletion: null,
    limit: null,
    pausable: !0,
    currentPlayedTimes: 0,
    onPlay: function onPlay() {},
    onPause: function onPause() {}
  }, Wp.propTypes = {
    showCurrentTime: T["default"].bool,
    showRemainingTime: T["default"].bool,
    src: T["default"].string.isRequired,
    handleAudioDeletion: T["default"].func,
    variant: T["default"].oneOf([Fp, Bp, Pp]),
    limit: T["default"].number,
    pausable: T["default"].bool,
    currentPlayedTimes: T["default"].number,
    onPlay: T["default"].func,
    onPause: T["default"].func
  };

  var $p = _["default"].button.withConfig({
    displayName: "SimpleAudio__SimpleAudioButton",
    componentId: "sc-1v4pckc-0"
  })(["", " appearance:none;border:none;background:", ";border-radius:", ";cursor:pointer;display:flex;flex-shrink:0;align-items:center;justify-content:center;line-height:1;transition:background 0.15s ease-in-out;padding:0;position:relative;&:hover{background:", ";}&:focus{outline:none;}", ""], n.layout, function (e) {
    return e.theme.colors.yellow500;
  }, function (e) {
    return e.theme.radii.circular;
  }, function (e) {
    return Ip(e.theme.colors.yellow500, .75);
  }, function (e) {
    return e.disabled && "\n    background: ".concat(Ip(e.theme.colors.yellow500, .5), ";\n    pointer-events: none;\n  ");
  });

  $p.displayName = "SimpleAudioButton";

  var Gp = Ja(fe),
      Yp = _["default"](Gp).attrs(function (e) {
    var t = e.height,
        n = e.mr;
    return {
      bg: "black",
      borderRadius: "rounded",
      display: "inline-block",
      mr: n,
      height: t,
      width: "2px"
    };
  }).withConfig({
    displayName: "SimpleAudio__Bar",
    componentId: "sc-1v4pckc-1"
  })([""]);

  Yp.displayName = "SimpleAudioBar";
  var Qp = [5, 20, 11, 30, 20, 11, 5],
      Xp = {
    initial: {
      scaleY: 1
    },
    animate: function animate(e) {
      return {
        scaleY: 1.25,
        transition: {
          repeat: 1 / 0,
          repeatType: "mirror",
          delay: .125 * e
        }
      };
    }
  };

  function Kp(e) {
    var t = e.small,
        n = e.src;

    var r = o.useRef(null),
        _o$useState27 = o.useState(!1),
        _o$useState28 = _slicedToArray(_o$useState27, 2),
        i = _o$useState28[0],
        a = _o$useState28[1],
        _o$useState29 = o.useState(!1),
        _o$useState30 = _slicedToArray(_o$useState29, 2),
        l = _o$useState30[0],
        c = _o$useState30[1],
        _o$useState31 = o.useState(!1),
        _o$useState32 = _slicedToArray(_o$useState31, 2),
        u = _o$useState32[0],
        d = _o$useState32[1];

    o.useEffect(function () {
      d(Zf());
    }, []);
    return s.jsxs(o.Fragment, {
      children: [s.jsx("audio", {
        onCanPlayThrough: function onCanPlayThrough() {
          return d(!0);
        },
        onEnded: function onEnded() {
          return a(!1);
        },
        onPlay: function onPlay() {
          return a(!0);
        },
        onPlaying: function onPlaying() {
          return c(!1);
        },
        onWaiting: function onWaiting() {
          return c(!0);
        },
        preload: "auto",
        ref: r,
        src: n
      }), s.jsx($p, {
        size: t ? ["2.5rem", null, null, "3rem"] : "4rem",
        disabled: !(u && !l),
        onClick: function onClick() {
          r.current.play();
        },
        children: n && u && !l ? s.jsxs(o.Fragment, {
          children: [s.jsx(Gp, {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "absolute",
            initial: {
              opacity: 0
            },
            animate: {
              opacity: i ? 1 : 0
            },
            style: {
              transform: "scale(".concat(t ? .666 : 1, ")")
            },
            children: Qp.map(function (e, t, n) {
              return s.jsx(Yp, {
                height: e,
                mr: D["default"](t + 1, n.length) ? 0 : "4px",
                variants: Xp,
                initial: "initial",
                animate: "animate",
                custom: t + 1
              }, "".concat(e, "-").concat(t));
            })
          }), s.jsx(Gp, {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "absolute",
            initial: {
              opacity: 1
            },
            animate: {
              opacity: i ? 0 : 1
            },
            style: {
              transform: "scale(".concat(t ? .666 : 1, ")")
            },
            children: s.jsx(su, {
              color: "black",
              size: "2rem",
              position: "relative",
              left: "2px"
            })
          })]
        }) : s.jsx(Hf, {
          size: t ? ["16px", null, null, "22px"] : "22px",
          color: "black"
        })
      })]
    });
  }

  function Jp(e) {
    var t = e.src,
        n = e.limit,
        r = e.pausable,
        o = e.currentPlayedTimes,
        i = e.onPause,
        a = e.onPlay;
    return s.jsx(Wp, {
      variant: "tasks",
      src: t,
      showCurrentTime: !1,
      showRemainingTime: !1,
      limit: n,
      pausable: r,
      currentPlayedTimes: o,
      onPlay: a,
      onPause: i
    });
  }

  Kp.defaultProps = {
    small: !1,
    src: null
  }, Kp.propTypes = {
    small: T["default"].bool,
    src: T["default"].string
  }, Jp.defaultProps = {
    limit: null,
    pausable: !0,
    currentPlayedTimes: 0,
    onPlay: function onPlay() {},
    onPause: function onPause() {}
  }, Jp.propTypes = {
    src: T["default"].string.isRequired,
    limit: T["default"].number,
    pausable: T["default"].bool,
    currentPlayedTimes: T["default"].number,
    onPlay: T["default"].func,
    onPause: T["default"].func
  };
  var eh = o.createContext(null);

  function th(e) {
    var t = e.node,
        n = e.children;
    return s.jsx(eh.Provider, {
      value: t,
      children: n
    });
  }

  function nh(e) {
    var t = e.bg,
        n = e.width,
        r = e.height,
        o = _objectWithoutProperties(e, _excluded57);

    return s.jsx(hs, _objectSpread({
      bg: t,
      borderRadius: "rounded",
      width: n,
      height: r,
      animate: {
        opacity: [1, .2, 1]
      },
      transition: {
        duration: 1,
        ease: "easeInOut",
        times: [0, .5, 1],
        repeat: 1 / 0,
        repeatDelay: 0
      }
    }, o));
  }

  th.defaultProps = {
    node: null
  }, th.propTypes = {
    children: T["default"].node.isRequired,
    node: T["default"].oneOfType([T["default"].object, T["default"].oneOf([null])])
  }, nh.defaultProps = {
    bg: "gray200",
    width: 1,
    height: "1rem"
  }, nh.propTypes = {
    bg: T["default"].string,
    width: T["default"].oneOfType([T["default"].string, T["default"].array, T["default"].number]),
    height: T["default"].oneOfType([T["default"].string, T["default"].array, T["default"].number])
  };

  var rh = {
    "default": t.css(["background-color:", ";color:", ";"], function (e) {
      return e.theme.colors.black;
    }, function (e) {
      return e.theme.colors.white;
    }),
    success: t.css(["background-color:", ";color:", ";"], function (e) {
      return e.theme.colors.black;
    }, function (e) {
      return e.theme.colors.white;
    }),
    warning: t.css(["background-color:", ";color:", ";"], function (e) {
      return e.theme.colors.yellow500;
    }, function (e) {
      return e.theme.colors.black;
    })
  },
      oh = {
    "default": "info-circle",
    success: "check-circle"
  },
      ih = _["default"](hs).attrs(function () {
    return {
      initial: {
        opacity: 0,
        y: 32
      },
      animate: {
        opacity: 1,
        y: 0
      },
      exit: {
        opacity: 0,
        y: 32
      },
      layout: !0,
      display: "flex",
      justifyContent: "center"
    };
  }).withConfig({
    displayName: "Toast__BreadBox",
    componentId: "sc-199l617-0"
  })([""]),
      ah = _["default"](fe).attrs(function (e) {
    return {
      role: e.hasTimeout ? "alert" : "alertdialog",
      borderRadius: "rounded",
      display: "inline-flex",
      alignItems: "center",
      px: 3,
      m: 2
    };
  }).withConfig({
    displayName: "Toast__Bread",
    componentId: "sc-199l617-1"
  })(["", " pointer-events:auto;"], function (e) {
    return rh[e.type];
  });

  function sh(e) {
    var t = e.action,
        n = e.content,
        r = e.customIcon,
        o = e.iconWeight,
        i = e.id,
        a = e.onDismiss,
        l = e.timeout,
        c = e.type;
    return null !== l && setTimeout(function () {
      return a(i);
    }, l), s.jsx(ih, {
      children: s.jsxs(ah, {
        type: c,
        hasTimeout: null !== l,
        children: [l && !t && oh[c] && s.jsx(mc, {
          icon: r || oh[c],
          weight: o,
          width: "1rem",
          textAlign: "center",
          mr: [3, null, "0.75rem"]
        }), s.jsx(ys, {
          measure: !0,
          py: 3,
          pr: 2,
          fontSize: [0, null, 1],
          children: n
        }), null === l && !t && s.jsxs(Ss, {
          flexShrink: 0,
          pl: [2, null, 3],
          pr: [0, null, 2],
          py: 3,
          fontWeight: "600",
          fontSize: [0, null, 1],
          color: "currentColor",
          onClick: function onClick() {
            return a(i);
          },
          children: [s.jsx(mc, {
            icon: "times",
            pr: 2
          }), "Dismiss"]
        }), t && s.jsx(fe, {
          flexShrink: 0,
          children: t
        })]
      })
    });
  }

  sh.defaultProps = {
    action: null,
    customIcon: null,
    iconWeight: null,
    timeout: null,
    type: "default"
  }, sh.propTypes = {
    action: T["default"].node,
    content: T["default"].oneOfType([T["default"].string, T["default"].node]).isRequired,
    customIcon: T["default"].string,
    iconWeight: T["default"].string,
    id: T["default"].string.isRequired,
    onDismiss: T["default"].func.isRequired,
    timeout: T["default"].oneOfType([T["default"].number, T["default"].oneOf([null])]),
    type: T["default"].oneOf(["default", "success", "warning"])
  };
  var lh = o.createContext();

  function ch(e) {
    var t = e.children;

    var _o$useState33 = o.useState([]),
        _o$useState34 = _slicedToArray(_o$useState33, 2),
        n = _o$useState34[0],
        r = _o$useState34[1],
        i = function i(e) {
      return r(function (t) {
        return t.filter(function (t) {
          return t.id !== e;
        });
      });
    };

    return s.jsxs(lh.Provider, {
      value: {
        addToast: function addToast(e) {
          O["default"](z["default"]("id", e.id), n) && r(function (t) {
            return [].concat(_toConsumableArray(t), [e]);
          });
        },
        eatToast: i,
        feast: function feast() {
          return r([]);
        }
      },
      children: [t, s.jsx(uh, {
        position: "fixed",
        bottom: "0",
        left: "0",
        right: "0",
        top: "0",
        display: "flex",
        justifyContent: "flex-end",
        flexDirection: "column",
        zIndex: 7,
        children: s.jsx(is, {
          initial: !1,
          children: n.map(function (e) {
            return s.jsx(sh, {
              id: e.id,
              type: e.type,
              action: e.action,
              content: e.content,
              customIcon: e.customIcon,
              iconWeight: e.iconWeight,
              timeout: e.timeout,
              onDismiss: i
            }, e.id);
          })
        })
      })]
    });
  }

  ch.propTypes = {
    children: T["default"].node.isRequired
  };

  var uh = _["default"](fe).withConfig({
    displayName: "Toaster___StyledBox",
    componentId: "sc-ssiozm-0"
  })(["pointer-events:none;"]);

  var dh = _["default"](ys).attrs(function (e) {
    return {
      "aria-hidden": !0,
      className: "".concat(A["default"]([[D["default"]("solid"), function () {
        return "fas";
      }], [D["default"]("regular"), function () {
        return "far";
      }], [D["default"]("light"), function () {
        return "fal";
      }], [D["default"]("brands"), function () {
        return "fab";
      }]])(e.weight), " fa-").concat(e.icon)
    };
  }).withConfig({
    displayName: "FA",
    componentId: "sc-1dgq0i7-0"
  })([""]);

  function fh(e) {
    var t;
    return t = "h1" === e ? [5, null, 6] : "h2" === e ? [4, null, 5] : "h3" === e ? [3, null, 4] : "h4" === e ? [2, null, 3] : 1, t;
  }

  function ph(e) {
    var t;
    return t = "h1" === e ? ["condensed", null, "compressed"] : "h2" === e ? "condensed" : "h3" === e ? ["normal", null, "narrow"] : "normal", t;
  }

  function hh(e) {
    return "h5" === e || "h6" === e ? "body" : "heading";
  }

  dh.defaultProps = {
    as: "span",
    weight: "light"
  }, dh.propTypes = {
    icon: T["default"].string.isRequired,
    weight: T["default"].oneOf(["solid", "regular", "light", "brands"])
  };

  var mh = _["default"].h1.withConfig({
    shouldForwardProp: se,
    displayName: "Heading__BaseHeading",
    componentId: "sc-1my2v2b-0"
  })(n.compose(n.color, n.layout, n.overflow, n.position, n.space, ue, n.typography)),
      gh = _["default"](mh).attrs(function (e) {
    var _e$fontSize, _e$styledAs, _e$fontWeight, _e$letterSpacing, _e$styledAs2, _e$lineHeight, _e$styledAs3;

    return {
      as: e.subheading ? "p" : e.as,
      fontSize: (_e$fontSize = e.fontSize) !== null && _e$fontSize !== void 0 ? _e$fontSize : fh((_e$styledAs = e.styledAs) !== null && _e$styledAs !== void 0 ? _e$styledAs : e.as),
      fontWeight: (_e$fontWeight = e.fontWeight) !== null && _e$fontWeight !== void 0 ? _e$fontWeight : 600,
      letterSpacing: (_e$letterSpacing = e.letterSpacing) !== null && _e$letterSpacing !== void 0 ? _e$letterSpacing : ph((_e$styledAs2 = e.styledAs) !== null && _e$styledAs2 !== void 0 ? _e$styledAs2 : e.as),
      lineHeight: (_e$lineHeight = e.lineHeight) !== null && _e$lineHeight !== void 0 ? _e$lineHeight : hh((_e$styledAs3 = e.styledAs) !== null && _e$styledAs3 !== void 0 ? _e$styledAs3 : e.as)
    };
  }).withConfig({
    displayName: "Heading",
    componentId: "sc-1my2v2b-1"
  })(["text-rendering:optimizeLegibility;"]);

  gh.defaultProps = {
    as: "h1",
    mt: 0,
    mb: 4,
    subheading: !1
  }, gh.displayName = "Heading", gh.propTypes = {
    as: T["default"].oneOf(["h1", "h2", "h3", "h4", "h5", "h6"]),
    styledAs: T["default"].oneOf(["h1", "h2", "h3", "h4", "h5", "h6"]),
    subheading: T["default"].bool
  };

  var yh = t.css(["text-decoration:none;color:inherit;&:hover,&:focus{color:inherit;}background-image:none;"]),
      bh = _["default"](ys).attrs(function (e) {
    return {
      blacklist: ["reset"],
      color: e.color
    };
  }).withConfig({
    displayName: "Link",
    componentId: "sc-iymtst-0"
  })(["background-image:linear-gradient( transparent 50%,", " 50% );background-position:0 95%;background-repeat:repeat-x;background-size:2px 2px;text-decoration:none;cursor:pointer;transition:color 0.15s ease-out;&:hover,&:focus{color:", ";}", ""], function (e) {
    return e.theme.colors[e.color];
  }, function (e) {
    return e.theme.colors[e.hover];
  }, function (e) {
    return e.reset && yh;
  });

  bh.defaultProps = {
    as: "a",
    color: "blue700",
    hover: "blue500",
    reset: !1
  }, bh.propTypes = {
    color: T["default"].string,
    hover: T["default"].oneOf(Object.keys(gc.colors)),
    reset: T["default"].bool
  };

  var vh = _["default"](ys).withConfig({
    displayName: "List",
    componentId: "sc-1d2q6h6-0"
  })(["", ""], function (e) {
    return e.reset && "list-style: none; padding-left: 0;";
  });

  vh.defaultProps = {
    as: "ul",
    reset: !1
  }, vh.displayName = "List", vh.propTypes = {
    as: T["default"].oneOf(["dl", "ol", "ul"]).isRequired,
    reset: T["default"].bool
  };

  var _gc$colors = gc.colors,
      xh = _gc$colors.black,
      wh = _gc$colors.blackAt90,
      kh = _gc$colors.white,
      Ch = _gc$colors.blue100,
      Mh = _gc$colors.yellow200,
      jh = {
    primary: "blue",
    success: "green",
    critical: "red",
    secondary: "gray",
    "default": "gray"
  },
      Eh = t.css(["background-color:", ";color:", ";"], function (e) {
    return e.theme.colors["".concat(jh[e.type], "50")];
  }, function (e) {
    return e.theme.colors["".concat(jh[e.type], "900")];
  }),
      _h = {
    featured: {
      bg: "#c7d1fe",
      color: wh
    },
    new_lesson: {
      bg: "#fee35c",
      color: wh
    },
    sample_label: {
      bg: "#90eac6",
      color: wh
    },
    free: {
      bg: "#90eac6",
      color: wh
    },
    revised: {
      bg: "#9bebeb",
      color: wh
    },
    coming_soon: {
      bg: "#e8b5ff",
      color: wh
    },
    now_with_video: {
      bg: "#FFBDE2",
      color: wh
    },
    materialType: {
      bg: xh,
      color: kh
    },
    shared: {
      bg: Ch,
      color: wh
    },
    warning: {
      bg: Mh,
      color: wh
    },
    autoScoring: {
      bg: Ch,
      color: wh
    }
  },
      Th = t.css(["background-color:", ";color:", ";"], function (e) {
    var _e$bg;

    return (_e$bg = e.bg) !== null && _e$bg !== void 0 ? _e$bg : _h[e.type].bg;
  }, function (e) {
    var _e$color;

    return (_e$color = e.color) !== null && _e$color !== void 0 ? _e$color : _h[e.type].color;
  }),
      Sh = t.css(["", ";padding:", " ", ";letter-spacing:", ";font-size:0.75rem;font-weight:600;text-align:center;margin:auto;border-radius:", ";display:inline-block;"], function (e) {
    return Object.keys(_h).includes(e.type) ? Th : Eh;
  }, function (e) {
    return e.theme.space[e.compact ? 1 : 2];
  }, function (e) {
    return e.theme.space[e.compact ? 2 : 3];
  }, function (e) {
    return e.compact ? "normal" : e.theme.letterSpacings.wide;
  }, function (e) {
    return e.theme.radii.rounded;
  }),
      Lh = n.compose(n.background, n.border, n.color, n.layout, n.typography, n.space),
      Dh = _["default"].div.withConfig({
    displayName: "Label",
    componentId: "sc-1rkw31a-0"
  })(["", ";", ";"], Sh, Lh);

  Dh.displayName = "Label", Dh.defaultProps = {
    compact: !1,
    type: "default"
  }, Dh.propTypes = {
    compact: T["default"].bool,
    type: T["default"].oneOf([].concat(_toConsumableArray(Object.keys(jh)), _toConsumableArray(Object.keys(_h))))
  };

  var Ah = _["default"](fe).attrs(function () {
    return {
      blacklist: ["when"]
    };
  }).withConfig({
    displayName: "BlockClicks",
    componentId: "sc-1j93dnr-0"
  })(["", ""], function (e) {
    return e.when && "pointer-events: none;";
  });

  Ah.defaultProps = {
    when: !1
  }, Ah.propTypes = {
    when: T["default"].bool
  };

  var Nh = function Nh(e) {
    var t = e.duration,
        n = e.isDarkBackground,
        r = e.isAutoplay,
        o = e.size,
        i = e.onClick,
        a = _objectWithoutProperties(e, _excluded58);

    var l = 16 * parseFloat(o),
        c = l / 2 - 4.5,
        u = 2 * Math.PI * c;
    return s.jsx(Ss, _objectSpread(_objectSpread({
      onClick: i
    }, a), {}, {
      opacity: "0.3",
      children: s.jsx(fe, {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        children: s.jsxs(fe, {
          position: "relative",
          size: o,
          children: [s.jsx(fe, {
            position: "absolute",
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            children: s.jsx(mc, {
              fontSize: 0,
              color: n ? "gray50" : "gray800",
              icon: r ? "stop" : "play",
              weight: "solid"
            })
          }), r && s.jsxs(Ja.svg, {
            width: o,
            height: o,
            viewBox: "0 0 ".concat(l, " ").concat(l),
            style: {
              position: "absolute",
              top: 0,
              left: 0
            },
            children: [s.jsx("circle", {
              cx: l / 2,
              cy: l / 2,
              r: c,
              fill: "none",
              stroke: n ? "#f9f9f9" : "#616060",
              strokeWidth: 3,
              strokeDasharray: u,
              strokeDashoffset: u
            }), s.jsx(Ja.circle, {
              cx: l / 2,
              cy: l / 2,
              r: c,
              fill: "none",
              stroke: n ? "#f9f9f9" : "#616060",
              strokeWidth: 3,
              strokeDasharray: u,
              strokeDashoffset: u,
              initial: {
                strokeDashoffset: u
              },
              animate: {
                strokeDashoffset: 0
              },
              transition: {
                duration: t / 1e3,
                ease: "linear"
              }
            })]
          })]
        })
      })
    }));
  };

  Nh.defaultProps = {
    size: "2.5rem"
  }, Nh.propTypes = {
    duration: T["default"].number.isRequired,
    isDarkBackground: T["default"].bool.isRequired,
    isAutoplay: T["default"].bool.isRequired,
    size: T["default"].string,
    onClick: T["default"].func.isRequired
  };

  var Ih = _["default"](Ss).attrs(function (e) {
    return {
      p: 0,
      m: 1,
      width: "0.5rem",
      height: "0.5rem",
      borderRadius: "circular",
      border: e.$isDarkBackground ? "1px solid white" : "none"
    };
  }).withConfig({
    displayName: "CarouselPaginationDots__Dots",
    componentId: "sc-isexdc-0"
  })(["opacity:0.5;background:", ";&.active{opacity:1;background:", ";border:1px solid ", ";width:0.75rem;height:0.75rem;}"], function (e) {
    return e.$isDarkBackground ? e.theme.colors.gray300 : e.theme.colors.gray600;
  }, function (e) {
    return e.$isDarkBackground ? e.theme.colors.white : e.theme.colors.black;
  }, function (e) {
    return e.theme.colors.white;
  });

  function zh(e) {
    var t = e.children,
        n = e.currentIndex,
        r = e.setIndex,
        o = e.isDarkBackground,
        i = _objectWithoutProperties(e, _excluded59);

    return s.jsx(fe, _objectSpread(_objectSpread({
      display: "flex",
      alignItems: "center"
    }, i), {}, {
      children: t.map(function (e, t) {
        return s.jsx(Ih, {
          onClick: function onClick() {
            return r([t, n < t ? 1 : -1]);
          },
          className: n === t ? "active" : "",
          $isDarkBackground: o
        }, t);
      })
    }));
  }

  zh.propTypes = {
    children: T["default"].arrayOf(T["default"].node).isRequired,
    currentIndex: T["default"].number.isRequired,
    setIndex: T["default"].func.isRequired,
    isDarkBackground: T["default"].bool.isRequired
  };
  var Oh = {
    enter: function enter(e) {
      return {
        x: e > 0 ? 100 : -100,
        opacity: .5
      };
    },
    center: {
      x: 0,
      opacity: 1
    },
    exit: function exit(e) {
      return {
        x: e < 0 ? 100 : -100,
        opacity: 0
      };
    }
  },
      Rh = 8e3,
      Ph = Ja(fe);

  function Fh(e) {
    var t = e.children,
        n = e.infinite,
        r = e.allowSwipe,
        i = e.navigationType,
        a = e.autoplay,
        l = _objectWithoutProperties(e, _excluded60);

    var c = o.useRef(null),
        _o$useState35 = o.useState([0, 0]),
        _o$useState36 = _slicedToArray(_o$useState35, 2),
        _o$useState36$ = _slicedToArray(_o$useState36[0], 2),
        u = _o$useState36$[0],
        d = _o$useState36$[1],
        f = _o$useState36[1],
        _o$useState37 = o.useState(!1),
        _o$useState38 = _slicedToArray(_o$useState37, 2),
        p = _o$useState38[0],
        h = _o$useState38[1],
        _o$useState39 = o.useState(!1),
        _o$useState40 = _slicedToArray(_o$useState39, 2),
        m = _o$useState40[0],
        g = _o$useState40[1],
        _o$useState41 = o.useState(n),
        _o$useState42 = _slicedToArray(_o$useState41, 2),
        y = _o$useState42[0],
        b = _o$useState42[1],
        _o$useState43 = o.useState(a),
        _o$useState44 = _slicedToArray(_o$useState43, 2),
        v = _o$useState44[0],
        x = _o$useState44[1],
        w = function (e, t) {
      return (e % t + t) % t;
    }(u, t.length),
        k = function k(e) {
      !y && (u + e === t.length || u + e < 0) || (f([u + e, e]), h(!1));
    },
        C = p ? "grabbing" : "grab",
        M = function M() {
      if (c.current) {
        var _e16 = getComputedStyle(c.current),
            _t13 = _e16.backgroundColor,
            _n16 = _t13.match(/\d+/g);

        if (_n16) {
          var _n16$map = _n16.map(Number),
              _n16$map2 = _slicedToArray(_n16$map, 3),
              _e17 = _n16$map2[0],
              _t14 = _n16$map2[1],
              _r11 = _n16$map2[2];

          g(_e17 / 255 * .2126 + _t14 / 255 * .7152 + _r11 / 255 * .0722 < .5);
        }
      }
    },
        j = t[w],
        E = "wide" === i ? function () {
      return s.jsxs(s.Fragment, {
        children: [s.jsx(Nh, {
          duration: Rh,
          isDarkBackground: m,
          isAutoplay: v,
          onClick: function onClick() {
            return x(!v);
          },
          position: "absolute",
          right: "5px",
          top: "10px",
          size: "2.1rem"
        }), s.jsxs(fe, {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          position: "absolute",
          top: "45%",
          width: "100%",
          px: 3,
          children: [s.jsx(Ss, {
            mr: 2,
            onClick: function onClick() {
              return k(-1);
            },
            disabled: !y && 0 === u,
            children: s.jsx(mc, {
              fontSize: 1,
              color: m ? "gray50" : "gray800",
              icon: "chevron-left"
            })
          }), s.jsx(Ss, {
            ml: 2,
            onClick: function onClick() {
              return k(1);
            },
            disabled: !y && u === t.length - 1,
            children: s.jsx(mc, {
              fontSize: 1,
              color: m ? "gray50" : "gray800",
              icon: "chevron-right"
            })
          })]
        }), s.jsx(zh, {
          isDarkBackground: m,
          currentIndex: w,
          setIndex: f,
          position: "absolute",
          right: "0",
          left: "0",
          bottom: "10px",
          children: t
        })]
      });
    } : function () {
      return s.jsxs(fe, {
        display: "flex",
        alignItems: "center",
        position: "absolute",
        top: "-3.2rem",
        right: [0, null, "1rem"],
        children: [s.jsx(Ss, {
          mr: 2,
          onClick: function onClick() {
            return k(-1);
          },
          children: s.jsx(mc, {
            fontSize: 1,
            color: "gray800",
            icon: "chevron-left"
          })
        }), s.jsx(fe, {
          children: s.jsx(ys, {
            fontSize: 1,
            color: "gray800",
            children: s.jsxs("i", {
              children: [w + 1, " of ", t.length]
            })
          })
        }), s.jsx(Ss, {
          ml: 2,
          onClick: function onClick() {
            return k(1);
          },
          children: s.jsx(mc, {
            fontSize: 1,
            color: "gray800",
            icon: "chevron-right"
          })
        })]
      });
    };

    return o.useEffect(function () {
      if (c.current) return M(), window.addEventListener("resize", M), function () {
        return window.removeEventListener("resize", M);
      };
    }, [c.current, w]), o.useEffect(function () {
      if (!v) return;
      var e = setInterval(function () {
        k(1);
      }, Rh);
      return function () {
        return clearInterval(e);
      };
    }, [v, Rh, w]), o.useEffect(function () {
      n || b(!!v);
    }, [v]), s.jsx(is, {
      initial: !1,
      children: s.jsxs(fe, _objectSpread(_objectSpread({
        position: "relative"
      }, l), {}, {
        children: [s.jsx(Ph, {
          width: "100%",
          cursor: r ? C : void 0,
          onMouseDown: function onMouseDown() {
            return h(!0);
          },
          onMouseUp: function onMouseUp() {
            return h(!1);
          },
          custom: d,
          variants: Oh,
          initial: "enter",
          animate: "center",
          exit: "exit",
          drag: r ? "x" : void 0,
          dragConstraints: {
            left: 0,
            right: 0
          },
          dragElastic: 1,
          onDragEnd: function onDragEnd(e, t) {
            var n = t.offset;
            var r = n.x;
            r < -100 ? k(1) : r > 100 && k(-1);
          },
          "aria-live": "polite",
          role: "region",
          "aria-label": "Slide ".concat(w + 1, " of ").concat(t.length),
          children: o.cloneElement(j, {
            ref: c
          })
        }, u), s.jsx(E, {})]
      }))
    });
  }

  Fh.defaultProps = {
    autoplay: !1,
    infinite: !1,
    allowSwipe: !0,
    navigationType: "narrow"
  }, Fh.propTypes = {
    autoplay: T["default"].bool,
    children: T["default"].arrayOf(T["default"].node).isRequired,
    infinite: T["default"].bool,
    allowSwipe: T["default"].bool,
    navigationType: T["default"].oneOf(["wide", "narrow"])
  };

  var Bh = t.css(["appearance:none;border:1px solid ", ";border-radius:2rem;cursor:", ";color:", ";font-size:", ";opacity:", ";position:relative;transition:color 0.3s ease,background 0.3s ease;", " &:focus{outline:none;}&:after{content:'';position:absolute;inset:-3px;border-radius:2rem;box-shadow:0 0 0 2px ", ";opacity:0;}&:focus:after{opacity:1;}"], function (e) {
    return e.selected ? "transparent" : e.theme.colors.gray600;
  }, function (e) {
    return e.disabled ? "not-allowed" : "pointer";
  }, function (e) {
    return e.theme.colors[e.selected ? "white" : "black"];
  }, function (e) {
    return e.theme.fontSizes[0];
  }, function (e) {
    return e.disabled ? vs : 1;
  }, n.space, function (e) {
    return e.theme.colors.blue500;
  }),
      qh = t.css(["background:", ";&:not([disabled]):hover{background:", ";color:", ";}"], function (e) {
    return e.theme.colors[e.selected ? "blue500" : "white"];
  }, function (e) {
    return e.theme.colors[e.selected ? "blue700" : "white"];
  }, function (e) {
    return e.theme.colors[e.selected ? "white" : "blue700"];
  }),
      Uh = t.css(["background:", ";&:not([disabled]):hover{background:", ";color:", ";}"], function (e) {
    return e.theme.colors[e.selected ? "black" : "gray300"];
  }, function (e) {
    return e.theme.colors[e.selected ? "black" : "white"];
  }, function (e) {
    return e.theme.colors[e.selected ? "white" : "blue700"];
  }),
      Vh = _["default"].button.withConfig({
    shouldForwardProp: se
  }).attrs(function (e) {
    return function (e) {
      return e.larger ? {
        px: 3,
        py: 2
      } : {
        px: 2,
        py: 1
      };
    }(e);
  }).withConfig({
    displayName: "Chip__BaseChip",
    componentId: "sc-wudygp-0"
  })(["", " ", ""], Bh, function (e) {
    return e.secondary ? Uh : qh;
  });

  function Hh(e) {
    var t = e.label,
        n = e.disabled,
        r = e.selected,
        o = e.icon,
        i = _objectWithoutProperties(e, _excluded61);

    return s.jsxs(Vh, _objectSpread(_objectSpread({
      disabled: n,
      selected: r
    }, i), {}, {
      children: [o && s.jsx(mc, {
        pr: 2,
        icon: o
      }), t]
    }));
  }

  function Zh(e) {
    var t = e.choices,
        n = _objectWithoutProperties(e, _excluded62);

    var _o$useState45 = o.useState(null),
        _o$useState46 = _slicedToArray(_o$useState45, 2),
        r = _o$useState46[0],
        i = _o$useState46[1];

    return o.useEffect(function () {
      t.forEach(function (e) {
        e.selectByDefault && i(e.id);
      });
    }, []), s.jsx(fe, {
      m: -1,
      display: "flex",
      flexWrap: "wrap",
      children: t.map(function (e) {
        return s.jsx(fe, {
          "data-testid": e.id,
          onClick: function onClick() {
            return function (e) {
              i(e.id), e.onSelect && e.onSelect();
            }(e);
          },
          children: s.jsx(Hh, _objectSpread({
            m: 1,
            selected: r === e.id,
            label: e.label,
            icon: e.icon
          }, n))
        }, e.id);
      })
    });
  }

  function Wh() {
    return !("undefined" == typeof window || !window.document || !window.document.createElement);
  }

  Vh.displayName = "Chip", Hh.defaultProps = {
    disabled: !1,
    icon: null,
    selected: !1,
    secondary: !1,
    larger: !1
  }, Hh.propTypes = {
    disabled: T["default"].bool,
    icon: T["default"].string,
    label: T["default"].string.isRequired,
    selected: T["default"].bool,
    secondary: T["default"].bool,
    larger: T["default"].bool
  }, Zh.propTypes = {
    choices: T["default"].arrayOf(T["default"].shape({
      icon: T["default"].string,
      id: T["default"].string.isRequired,
      label: T["default"].string.isRequired,
      onSelect: T["default"].func,
      selectByDefault: T["default"].bool
    })).isRequired
  };
  var $h = Wh() ? o.useLayoutEffect : o.useEffect;
  var Gh = "production" === process.env.NODE_ENV;

  function Yh(e, t) {
    if (!Gh) {
      if (e) return;
      var n = "Warning: " + t;
      "undefined" != typeof console && console.warn(n);

      try {
        throw Error(n);
      } catch (e) {}
    }
  }

  var Qh = function Qh(e) {
    var t,
        n = e.children,
        r = e.type,
        i = void 0 === r ? "reach-portal" : r,
        a = e.containerRef,
        s = o.useRef(null),
        l = o.useRef(null),
        u = (t = o.useState(Object.create(null))[1], o.useCallback(function () {
      t(Object.create(null));
    }, []));
    return "production" !== process.env.NODE_ENV && o.useEffect(function () {
      null != a && ("production" !== process.env.NODE_ENV && Yh("object" == _typeof(a) && "current" in a, "@reach/portal: Invalid value passed to the `containerRef` of a `Portal`. The portal will be appended to the document body, but if you want to attach it to another DOM node you must pass a valid React ref object to `containerRef`."), "production" !== process.env.NODE_ENV && Yh(!a || null != a.current, "@reach/portal: A ref was passed to the `containerRef` prop of a `Portal`, but no DOM node was attached to it. Be sure to pass the ref to a DOM component.\n\nIf you are forwarding the ref from another component, be sure to use the React.forwardRef API. See https://reactjs.org/docs/forwarding-refs.html."));
    }, [a]), $h(function () {
      if (s.current) {
        var e = s.current.ownerDocument,
            t = (null == a ? void 0 : a.current) || e.body;
        return l.current = null == e ? void 0 : e.createElement(i), t.appendChild(l.current), u(), function () {
          l.current && t && t.removeChild(l.current);
        };
      }
    }, [i, u, a]), l.current ? c.createPortal(n, l.current) : o.createElement("span", {
      ref: s
    });
  };

  "production" !== process.env.NODE_ENV && (Qh.displayName = "Portal");

  var Xh = _["default"](hs).attrs(function () {
    return {
      key: "contextual action bar",
      initial: {
        opacity: 0,
        y: 32
      },
      animate: {
        opacity: 1,
        y: 0
      },
      exit: {
        opacity: 0,
        y: 64
      },
      width: "calc(100vw - 1rem)",
      maxWidth: "32rem",
      mx: "auto",
      position: "fixed",
      bottom: [2, null, 3],
      left: 0,
      right: 0,
      zIndex: 5,
      role: "alert",
      "aria-labelledby": "cab-message"
    };
  }).withConfig({
    displayName: "ContextualActionBar__CabWrapper",
    componentId: "sc-1gcbpyz-0"
  })([""]);

  function Kh(e) {
    var t = e.message,
        n = e.action,
        r = e.isOpen,
        o = _objectWithoutProperties(e, _excluded63);

    return s.jsx(Qh, {
      children: s.jsx(is, {
        children: r && s.jsx(Xh, {
          children: s.jsxs(fe, _objectSpread(_objectSpread({
            display: "flex",
            alignItems: "center",
            bg: "black",
            color: "white",
            boxShadow: 4,
            borderRadius: "rounded",
            p: 3
          }, o), {}, {
            children: [s.jsx(fe, {
              id: "cab-message",
              children: t
            }), s.jsx(fe, {
              ml: "auto",
              children: n
            })]
          }))
        })
      })
    });
  }

  Kh.propTypes = {
    message: T["default"].node.isRequired,
    action: T["default"].node.isRequired,
    isOpen: T["default"].bool.isRequired
  };

  var Jh = _["default"](fe).attrs(function (e) {
    return {
      "aria-label": e.alt,
      role: "img",
      bg: e.bg || "rgba(0,0,0,0.1)",
      backgroundImage: "url('".concat(e.src, "')"),
      backgroundSize: "cover",
      backgroundPosition: "center",
      borderRadius: e.borderRadius || "circular",
      flexShrink: "0"
    };
  }).withConfig({
    displayName: "CoverImage",
    componentId: "sc-1pwg6s8-0"
  })([""]),
      em = {
    prefix: Math.round(1e10 * Math.random()),
    current: 0
  },
      tm = L.createContext(em);

  function nm(e) {
    var t = L.useContext(tm);
    return Boolean(null === globalThis || void 0 === globalThis ? void 0 : globalThis.document) || t !== em || console.warn("When server rendering, you must wrap your application in an <IdProvider> to ensure consistent ids are generated between the client and server."), L.useMemo(function () {
      return e || "radix-id-".concat(t.prefix, "-").concat(++t.current);
    }, [e]);
  }

  var rm = Boolean(null === globalThis || void 0 === globalThis ? void 0 : globalThis.document) ? L.useLayoutEffect : function () {};

  function om() {
    for (var _len9 = arguments.length, e = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      e[_key9] = arguments[_key9];
    }

    return L.useCallback(function () {
      for (var _len10 = arguments.length, e = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
        e[_key10] = arguments[_key10];
      }

      return function (t) {
        return e.forEach(function (e) {
          return function (e, t) {
            "function" == typeof e ? e(t) : null != e && (e.current = t);
          }(e, t);
        });
      };
    }.apply(void 0, e), e);
  }

  var im = function im(e) {
    var t = e.present,
        n = e.children,
        r = function (e) {
      var _L$useState = L.useState(),
          _L$useState2 = _slicedToArray(_L$useState, 2),
          t = _L$useState2[0],
          n = _L$useState2[1],
          r = L.useRef({}),
          o = L.useRef(e),
          i = L.useRef(),
          a = e ? "mounted" : "unmounted",
          _ref16 = function (e, t) {
        return L.useReducer(function (e, n) {
          var r = t[e][n];
          return null != r ? r : e;
        }, e);
      }(a, {
        mounted: {
          UNMOUNT: "unmounted",
          ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
          MOUNT: "mounted",
          ANIMATION_END: "unmounted"
        },
        unmounted: {
          MOUNT: "mounted"
        }
      }),
          _ref17 = _slicedToArray(_ref16, 2),
          s = _ref17[0],
          l = _ref17[1];

      return rm(function () {
        var t = r.current,
            n = o.current;

        if (n !== e) {
          var _r12 = i.current,
              _a3 = am(t);

          if (e) l("MOUNT");else if ("none" === _a3 || "none" === (null == t ? void 0 : t.display)) l("UNMOUNT");else {
            var _e18 = _r12 !== _a3;

            l(n && _e18 ? "ANIMATION_OUT" : "UNMOUNT");
          }
          o.current = e;
        }
      }, [e, l]), rm(function () {
        if (t) {
          var _e19 = function _e19(e) {
            var n = am(r.current).includes(e.animationName);
            e.target === t && n && l("ANIMATION_END");
          },
              _n17 = function _n17(e) {
            e.target === t && (i.current = am(r.current));
          };

          return t.addEventListener("animationstart", _n17), t.addEventListener("animationcancel", _e19), t.addEventListener("animationend", _e19), function () {
            t.removeEventListener("animationstart", _n17), t.removeEventListener("animationcancel", _e19), t.removeEventListener("animationend", _e19);
          };
        }
      }, [t, l]), {
        isPresent: ["mounted", "unmountSuspended"].includes(s),
        ref: L.useCallback(function (e) {
          e && (r.current = getComputedStyle(e), n(e));
        }, [])
      };
    }(t),
        o = "function" == typeof n ? n({
      present: r.isPresent
    }) : L.Children.only(n),
        i = om(r.ref, o.ref);

    return "function" == typeof n || r.isPresent ? L.cloneElement(o, {
      ref: i
    }) : null;
  };

  function am(e) {
    return (null == e ? void 0 : e.animationName) || "none";
  }

  im.displayName = "Presence";
  var sm = "div",
      lm = L.forwardRef(function (e, t) {
    var _e$as = e.as,
        n = _e$as === void 0 ? sm : _e$as,
        r = _objectWithoutProperties(e, _excluded64);

    return L.createElement(n, Fd({}, r, {
      ref: t
    }));
  });

  function cm(e) {
    var t = L.useRef(e);
    return L.useEffect(function () {
      t.current = e;
    }), L.useCallback(function () {
      var _n18;

      var n;

      for (var _len11 = arguments.length, e = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
        e[_key11] = arguments[_key11];
      }

      return null === (n = t.current) || void 0 === n ? void 0 : (_n18 = n).call.apply(_n18, [t].concat(e));
    }, []);
  }

  function um(e, t) {
    var _ref18 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref18$checkForDefaul = _ref18.checkForDefaultPrevented,
        n = _ref18$checkForDefaul === void 0 ? !0 : _ref18$checkForDefaul;

    return function (r) {
      if (null == e || e(r), !1 === n || !r.defaultPrevented) return null == t ? void 0 : t(r);
    };
  }

  var _ref19 = function (e) {
    var t = L.createContext(null);

    function n(e) {
      var n = e.children,
          r = _objectWithoutProperties(e, _excluded65),
          o = L.useMemo(function () {
        return r;
      }, Object.values(r));

      return L.createElement(t.Provider, {
        value: o
      }, n);
    }

    return n.displayName = e + "Provider", [n, function (n) {
      var r = L.useContext(t);
      if (null === r) throw new Error("`".concat(n, "` must be used within `").concat(e, "`"));
      return r;
    }];
  }("Collapsible"),
      _ref20 = _slicedToArray(_ref19, 2),
      dm = _ref20[0],
      fm = _ref20[1],
      pm = L.forwardRef(function (e, t) {
    var n = e.open,
        r = e.defaultOpen,
        o = e.disabled,
        i = e.onOpenChange,
        a = _objectWithoutProperties(e, _excluded66),
        _ref21 = function (_ref23) {
      var e = _ref23.prop,
          t = _ref23.defaultProp,
          _ref23$onChange = _ref23.onChange,
          n = _ref23$onChange === void 0 ? function () {} : _ref23$onChange;

      var _ref24 = function (_ref26) {
        var e = _ref26.defaultProp,
            t = _ref26.onChange;

        var n = L.useState(e),
            _n19 = _slicedToArray(n, 1),
            r = _n19[0],
            o = L.useRef(r),
            i = cm(t);

        return L.useEffect(function () {
          o.current !== r && (i(r), o.current = r);
        }, [r, o, i]), n;
      }({
        defaultProp: t,
        onChange: n
      }),
          _ref25 = _slicedToArray(_ref24, 2),
          r = _ref25[0],
          o = _ref25[1],
          i = void 0 !== e,
          a = i ? e : r,
          s = cm(n);

      return [a, L.useCallback(function (t) {
        if (i) {
          var _n20 = t,
              _r13 = "function" == typeof t ? _n20(e) : t;

          _r13 !== e && s(_r13);
        } else o(t);
      }, [i, e, o, s])];
    }({
      prop: n,
      defaultProp: r,
      onChange: i
    }),
        _ref22 = _slicedToArray(_ref21, 2),
        _ref22$ = _ref22[0],
        s = _ref22$ === void 0 ? !1 : _ref22$,
        l = _ref22[1];

    return L.createElement(dm, {
      disabled: o,
      contentId: nm(),
      open: s,
      onOpenToggle: L.useCallback(function () {
        return l(function (e) {
          return !e;
        });
      }, [l])
    }, L.createElement(lm, Fd({
      "data-state": bm(s),
      "data-disabled": o ? "" : void 0
    }, a, {
      ref: t
    })));
  }),
      hm = "button",
      mm = L.forwardRef(function (e, t) {
    var _e$as2 = e.as,
        n = _e$as2 === void 0 ? hm : _e$as2,
        r = e.onClick,
        o = _objectWithoutProperties(e, _excluded67),
        i = fm("CollapsibleTrigger");

    return L.createElement(lm, Fd({
      "aria-controls": i.contentId,
      "aria-expanded": i.open || !1,
      "data-state": bm(i.open),
      "data-disabled": i.disabled ? "" : void 0,
      disabled: i.disabled
    }, o, {
      as: n,
      ref: t,
      onClick: um(r, i.onOpenToggle)
    }));
  }),
      gm = L.forwardRef(function (e, t) {
    var n = e.forceMount,
        r = _objectWithoutProperties(e, _excluded68),
        o = fm("CollapsibleContent");

    return L.createElement(im, {
      present: n || o.open
    }, function (_ref27) {
      var e = _ref27.present;
      return L.createElement(ym, Fd({}, r, {
        ref: t,
        present: e
      }));
    });
  }),
      ym = L.forwardRef(function (e, t) {
    var n = e.present,
        r = e.children,
        o = _objectWithoutProperties(e, _excluded69),
        i = fm("CollapsibleContent"),
        _L$useState3 = L.useState(n),
        _L$useState4 = _slicedToArray(_L$useState3, 2),
        a = _L$useState4[0],
        s = _L$useState4[1],
        l = L.useRef(null),
        c = om(t, l),
        u = L.useRef(0),
        d = u.current,
        f = i.open || a;

    return rm(function () {
      var e = l.current;

      if (e) {
        var _t15 = e.style.transition,
            _r14 = e.style.animation;
        e.style.transition = "none", e.style.animation = "none";

        var _o7 = e.getBoundingClientRect();

        u.current = _o7.height, e.style.transition = _t15, e.style.animation = _r14, s(n);
      }
    }, [i.open, n]), L.createElement(lm, Fd({
      "data-state": bm(i.open),
      "data-disabled": i.disabled ? "" : void 0,
      id: i.contentId,
      hidden: !f
    }, o, {
      ref: c,
      style: _objectSpread({
        "--radix-collapsible-content-height": d ? "".concat(d, "px") : void 0
      }, e.style)
    }), f && r);
  });

  function bm(e) {
    return e ? "open" : "closed";
  }

  var vm = pm,
      xm = mm,
      wm = gm,
      km = function km(e) {
    var t = e.triggerContent,
        n = e.isCollapsed,
        r = e.children;

    var _o$useState47 = o.useState(n),
        _o$useState48 = _slicedToArray(_o$useState47, 2),
        i = _o$useState48[0],
        a = _o$useState48[1];

    return o.useEffect(function () {
      a(n);
    }, [n]), s.jsxs(vm, {
      className: "CollapsiblePrimitiveRoot",
      open: i,
      onOpenChange: a,
      children: [s.jsx(xm, {
        as: Ss,
        px: 0,
        onClick: function onClick() {
          return a(function (e) {
            return !e;
          });
        },
        children: t(i)
      }), s.jsx(wm, {
        children: r
      })]
    });
  };

  function Cm(e, t) {
    var _ref28 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref28$checkForDefaul = _ref28.checkForDefaultPrevented,
        n = _ref28$checkForDefaul === void 0 ? !0 : _ref28$checkForDefaul;

    return function (r) {
      if (null == e || e(r), !1 === n || !r.defaultPrevented) return null == t ? void 0 : t(r);
    };
  }

  function Mm() {
    for (var _len12 = arguments.length, e = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
      e[_key12] = arguments[_key12];
    }

    return function (t) {
      return e.forEach(function (e) {
        return function (e, t) {
          "function" == typeof e ? e(t) : null != e && (e.current = t);
        }(e, t);
      });
    };
  }

  function jm() {
    for (var _len13 = arguments.length, e = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
      e[_key13] = arguments[_key13];
    }

    return o.useCallback(Mm.apply(void 0, e), e);
  }

  function Em() {
    for (var _len14 = arguments.length, e = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
      e[_key14] = arguments[_key14];
    }

    var t = e[0];
    if (1 === e.length) return t;

    var n = function n() {
      var n = e.map(function (e) {
        return {
          useScope: e(),
          scopeName: e.scopeName
        };
      });
      return function (e) {
        var r = n.reduce(function (t, _ref29) {
          var n = _ref29.useScope,
              r = _ref29.scopeName;
          return _objectSpread(_objectSpread({}, t), n(e)["__scope".concat(r)]);
        }, {});
        return o.useMemo(function () {
          return _defineProperty({}, "__scope".concat(t.scopeName), r);
        }, [r]);
      };
    };

    return n.scopeName = t.scopeName, n;
  }

  km.defaultProps = {
    isCollapsed: !1
  }, km.propTypes = {
    isCollapsed: T["default"].bool,
    triggerContent: T["default"].node.isRequired,
    children: T["default"].arrayOf(T["default"].node).isRequired
  };

  var _m = Boolean(null === globalThis || void 0 === globalThis ? void 0 : globalThis.document) ? o.useLayoutEffect : function () {},
      Tm = L["useId".toString()] || function () {};

  var Sm = 0;

  function Lm(e) {
    var _L$useState5 = L.useState(Tm()),
        _L$useState6 = _slicedToArray(_L$useState5, 2),
        t = _L$useState6[0],
        n = _L$useState6[1];

    return _m(function () {
      e || n(function (e) {
        return null != e ? e : String(Sm++);
      });
    }, [e]), e || (t ? "radix-".concat(t) : "");
  }

  function Dm(e) {
    var t = o.useRef(e);
    return o.useEffect(function () {
      t.current = e;
    }), o.useMemo(function () {
      return function () {
        var _n21;

        var n;

        for (var _len15 = arguments.length, e = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
          e[_key15] = arguments[_key15];
        }

        return null === (n = t.current) || void 0 === n ? void 0 : (_n21 = n).call.apply(_n21, [t].concat(e));
      };
    }, []);
  }

  function Am(_ref31) {
    var e = _ref31.prop,
        t = _ref31.defaultProp,
        _ref31$onChange = _ref31.onChange,
        n = _ref31$onChange === void 0 ? function () {} : _ref31$onChange;

    var _ref32 = function (_ref34) {
      var e = _ref34.defaultProp,
          t = _ref34.onChange;

      var n = o.useState(e),
          _n22 = _slicedToArray(n, 1),
          r = _n22[0],
          i = o.useRef(r),
          a = Dm(t);

      return o.useEffect(function () {
        i.current !== r && (a(r), i.current = r);
      }, [r, i, a]), n;
    }({
      defaultProp: t,
      onChange: n
    }),
        _ref33 = _slicedToArray(_ref32, 2),
        r = _ref33[0],
        i = _ref33[1],
        a = void 0 !== e,
        s = a ? e : r,
        l = Dm(n);

    return [s, o.useCallback(function (t) {
      if (a) {
        var _n23 = t,
            _r15 = "function" == typeof t ? _n23(e) : t;

        _r15 !== e && l(_r15);
      } else i(t);
    }, [a, e, i, l])];
  }

  var Nm = o.forwardRef(function (e, t) {
    var n = e.children,
        r = _objectWithoutProperties(e, _excluded70),
        i = o.Children.toArray(n),
        a = i.find(Om);

    if (a) {
      var _e20 = a.props.children,
          _n24 = i.map(function (t) {
        return t === a ? o.Children.count(_e20) > 1 ? o.Children.only(null) : o.isValidElement(_e20) ? _e20.props.children : null : t;
      });

      return o.createElement(Im, Fd({}, r, {
        ref: t
      }), o.isValidElement(_e20) ? o.cloneElement(_e20, void 0, _n24) : null);
    }

    return o.createElement(Im, Fd({}, r, {
      ref: t
    }), n);
  });
  Nm.displayName = "Slot";
  var Im = o.forwardRef(function (e, t) {
    var n = e.children,
        r = _objectWithoutProperties(e, _excluded71);

    return o.isValidElement(n) ? o.cloneElement(n, _objectSpread(_objectSpread({}, Rm(r, n.props)), {}, {
      ref: t ? Mm(t, n.ref) : n.ref
    })) : o.Children.count(n) > 1 ? o.Children.only(null) : null;
  });
  Im.displayName = "SlotClone";

  var zm = function zm(_ref35) {
    var e = _ref35.children;
    return o.createElement(o.Fragment, null, e);
  };

  function Om(e) {
    return o.isValidElement(e) && e.type === zm;
  }

  function Rm(e, t) {
    var n = _objectSpread({}, t);

    var _loop3 = function _loop3(_r16) {
      var o = e[_r16],
          i = t[_r16];
      /^on[A-Z]/.test(_r16) ? o && i ? n[_r16] = function () {
        i.apply(void 0, arguments), o.apply(void 0, arguments);
      } : o && (n[_r16] = o) : "style" === _r16 ? n[_r16] = _objectSpread(_objectSpread({}, o), i) : "className" === _r16 && (n[_r16] = [o, i].filter(Boolean).join(" "));
    };

    for (var _r16 in t) {
      _loop3(_r16);
    }

    return _objectSpread(_objectSpread({}, e), n);
  }

  var Pm = ["a", "button", "div", "form", "h2", "h3", "img", "input", "label", "li", "nav", "ol", "p", "span", "svg", "ul"].reduce(function (e, t) {
    var n = o.forwardRef(function (e, n) {
      var r = e.asChild,
          i = _objectWithoutProperties(e, _excluded72),
          a = r ? Nm : t;

      return o.useEffect(function () {
        window[Symbol["for"]("radix-ui")] = !0;
      }, []), o.createElement(a, Fd({}, i, {
        ref: n
      }));
    });
    return n.displayName = "Primitive.".concat(t), _objectSpread(_objectSpread({}, e), {}, _defineProperty({}, t, n));
  }, {});
  var Fm = "dismissableLayer.update",
      Bm = "dismissableLayer.pointerDownOutside",
      qm = "dismissableLayer.focusOutside";
  var Um;
  var Vm = o.createContext({
    layers: new Set(),
    layersWithOutsidePointerEventsDisabled: new Set(),
    branches: new Set()
  }),
      Hm = o.forwardRef(function (e, t) {
    var n;

    var _e$disableOutsidePoin = e.disableOutsidePointerEvents,
        r = _e$disableOutsidePoin === void 0 ? !1 : _e$disableOutsidePoin,
        i = e.onEscapeKeyDown,
        a = e.onPointerDownOutside,
        s = e.onFocusOutside,
        l = e.onInteractOutside,
        c = e.onDismiss,
        u = _objectWithoutProperties(e, _excluded73),
        d = o.useContext(Vm),
        _o$useState49 = o.useState(null),
        _o$useState50 = _slicedToArray(_o$useState49, 2),
        f = _o$useState50[0],
        p = _o$useState50[1],
        h = null !== (n = null == f ? void 0 : f.ownerDocument) && void 0 !== n ? n : null === globalThis || void 0 === globalThis ? void 0 : globalThis.document,
        _o$useState51 = o.useState({}),
        _o$useState52 = _slicedToArray(_o$useState51, 2),
        m = _o$useState52[1],
        g = jm(t, function (e) {
      return p(e);
    }),
        y = Array.from(d.layers),
        _slice = _toConsumableArray(d.layersWithOutsidePointerEventsDisabled).slice(-1),
        _slice2 = _slicedToArray(_slice, 1),
        b = _slice2[0],
        v = y.indexOf(b),
        x = f ? y.indexOf(f) : -1,
        w = d.layersWithOutsidePointerEventsDisabled.size > 0,
        k = x >= v,
        C = function (e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null === globalThis || void 0 === globalThis ? void 0 : globalThis.document;
      var n = Dm(e),
          r = o.useRef(!1),
          i = o.useRef(function () {});
      return o.useEffect(function () {
        var e = function e(_e21) {
          if (_e21.target && !r.current) {
            var _a4 = function _a4() {
              Wm(Bm, n, _o8, {
                discrete: !0
              });
            };

            var _o8 = {
              originalEvent: _e21
            };
            "touch" === _e21.pointerType ? (t.removeEventListener("click", i.current), i.current = _a4, t.addEventListener("click", i.current, {
              once: !0
            })) : _a4();
          } else t.removeEventListener("click", i.current);

          r.current = !1;
        },
            o = window.setTimeout(function () {
          t.addEventListener("pointerdown", e);
        }, 0);

        return function () {
          window.clearTimeout(o), t.removeEventListener("pointerdown", e), t.removeEventListener("click", i.current);
        };
      }, [t, n]), {
        onPointerDownCapture: function onPointerDownCapture() {
          return r.current = !0;
        }
      };
    }(function (e) {
      var t = e.target,
          n = _toConsumableArray(d.branches).some(function (e) {
        return e.contains(t);
      });

      k && !n && (null == a || a(e), null == l || l(e), e.defaultPrevented || null == c || c());
    }, h),
        M = function (e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null === globalThis || void 0 === globalThis ? void 0 : globalThis.document;
      var n = Dm(e),
          r = o.useRef(!1);
      return o.useEffect(function () {
        var e = function e(_e22) {
          if (_e22.target && !r.current) {
            Wm(qm, n, {
              originalEvent: _e22
            }, {
              discrete: !1
            });
          }
        };

        return t.addEventListener("focusin", e), function () {
          return t.removeEventListener("focusin", e);
        };
      }, [t, n]), {
        onFocusCapture: function onFocusCapture() {
          return r.current = !0;
        },
        onBlurCapture: function onBlurCapture() {
          return r.current = !1;
        }
      };
    }(function (e) {
      var t = e.target;
      _toConsumableArray(d.branches).some(function (e) {
        return e.contains(t);
      }) || (null == s || s(e), null == l || l(e), e.defaultPrevented || null == c || c());
    }, h);

    return function (e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null === globalThis || void 0 === globalThis ? void 0 : globalThis.document;
      var n = Dm(e);
      o.useEffect(function () {
        var e = function e(_e23) {
          "Escape" === _e23.key && n(_e23);
        };

        return t.addEventListener("keydown", e), function () {
          return t.removeEventListener("keydown", e);
        };
      }, [n, t]);
    }(function (e) {
      x === d.layers.size - 1 && (null == i || i(e), !e.defaultPrevented && c && (e.preventDefault(), c()));
    }, h), o.useEffect(function () {
      if (f) return r && (0 === d.layersWithOutsidePointerEventsDisabled.size && (Um = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(f)), d.layers.add(f), Zm(), function () {
        r && 1 === d.layersWithOutsidePointerEventsDisabled.size && (h.body.style.pointerEvents = Um);
      };
    }, [f, h, r, d]), o.useEffect(function () {
      return function () {
        f && (d.layers["delete"](f), d.layersWithOutsidePointerEventsDisabled["delete"](f), Zm());
      };
    }, [f, d]), o.useEffect(function () {
      var e = function e() {
        return m({});
      };

      return document.addEventListener(Fm, e), function () {
        return document.removeEventListener(Fm, e);
      };
    }, []), o.createElement(Pm.div, Fd({}, u, {
      ref: g,
      style: _objectSpread({
        pointerEvents: w ? k ? "auto" : "none" : void 0
      }, e.style),
      onFocusCapture: Cm(e.onFocusCapture, M.onFocusCapture),
      onBlurCapture: Cm(e.onBlurCapture, M.onBlurCapture),
      onPointerDownCapture: Cm(e.onPointerDownCapture, C.onPointerDownCapture)
    }));
  });

  function Zm() {
    var e = new CustomEvent(Fm);
    document.dispatchEvent(e);
  }

  function Wm(e, t, n, _ref36) {
    var r = _ref36.discrete;
    var o = n.originalEvent.target,
        i = new CustomEvent(e, {
      bubbles: !1,
      cancelable: !0,
      detail: n
    });
    t && o.addEventListener(e, t, {
      once: !0
    }), r ? function (e, t) {
      e && c.flushSync(function () {
        return e.dispatchEvent(t);
      });
    }(o, i) : o.dispatchEvent(i);
  }

  var $m = "focusScope.autoFocusOnMount",
      Gm = "focusScope.autoFocusOnUnmount",
      Ym = {
    bubbles: !1,
    cancelable: !0
  },
      Qm = o.forwardRef(function (e, t) {
    var _e$loop = e.loop,
        n = _e$loop === void 0 ? !1 : _e$loop,
        _e$trapped = e.trapped,
        r = _e$trapped === void 0 ? !1 : _e$trapped,
        i = e.onMountAutoFocus,
        a = e.onUnmountAutoFocus,
        s = _objectWithoutProperties(e, _excluded74),
        _o$useState53 = o.useState(null),
        _o$useState54 = _slicedToArray(_o$useState53, 2),
        l = _o$useState54[0],
        c = _o$useState54[1],
        u = Dm(i),
        d = Dm(a),
        f = o.useRef(null),
        p = jm(t, function (e) {
      return c(e);
    }),
        h = o.useRef({
      paused: !1,
      pause: function pause() {
        this.paused = !0;
      },
      resume: function resume() {
        this.paused = !1;
      }
    }).current;

    o.useEffect(function () {
      if (r) {
        var _e24 = function _e24(e) {
          if (h.paused || !l) return;
          var t = e.target;
          l.contains(t) ? f.current = t : eg(f.current, {
            select: !0
          });
        };

        var _t16 = function _t16(e) {
          if (h.paused || !l) return;
          var t = e.relatedTarget;
          null !== t && (l.contains(t) || eg(f.current, {
            select: !0
          }));
        };

        var _n25 = function _n25(e) {
          if (document.activeElement === document.body) {
            var _iterator3 = _createForOfIteratorHelper(e),
                _step3;

            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var _t17 = _step3.value;
                _t17.removedNodes.length > 0 && eg(l);
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          }
        };

        document.addEventListener("focusin", _e24), document.addEventListener("focusout", _t16);

        var _o9 = new MutationObserver(_n25);

        return l && _o9.observe(l, {
          childList: !0,
          subtree: !0
        }), function () {
          document.removeEventListener("focusin", _e24), document.removeEventListener("focusout", _t16), _o9.disconnect();
        };
      }
    }, [r, l, h.paused]), o.useEffect(function () {
      if (l) {
        tg.add(h);
        var _t18 = document.activeElement;

        if (!l.contains(_t18)) {
          var _n26 = new CustomEvent($m, Ym);

          l.addEventListener($m, u), l.dispatchEvent(_n26), _n26.defaultPrevented || (!function (e) {
            var _ref37 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                _ref37$select = _ref37.select,
                t = _ref37$select === void 0 ? !1 : _ref37$select;

            var n = document.activeElement;

            var _iterator4 = _createForOfIteratorHelper(e),
                _step4;

            try {
              for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                var _r17 = _step4.value;
                if (eg(_r17, {
                  select: t
                }), document.activeElement !== n) return;
              }
            } catch (err) {
              _iterator4.e(err);
            } finally {
              _iterator4.f();
            }
          }((e = Xm(l), e.filter(function (e) {
            return "A" !== e.tagName;
          })), {
            select: !0
          }), document.activeElement === _t18 && eg(l));
        }

        return function () {
          l.removeEventListener($m, u), setTimeout(function () {
            var e = new CustomEvent(Gm, Ym);
            l.addEventListener(Gm, d), l.dispatchEvent(e), e.defaultPrevented || eg(null != _t18 ? _t18 : document.body, {
              select: !0
            }), l.removeEventListener(Gm, d), tg.remove(h);
          }, 0);
        };
      }

      var e;
    }, [l, u, d, h]);
    var m = o.useCallback(function (e) {
      if (!n && !r) return;
      if (h.paused) return;
      var t = "Tab" === e.key && !e.altKey && !e.ctrlKey && !e.metaKey,
          o = document.activeElement;

      if (t && o) {
        var _t19 = e.currentTarget,
            _ref38 = function (e) {
          var t = Xm(e),
              n = Km(t, e),
              r = Km(t.reverse(), e);
          return [n, r];
        }(_t19),
            _ref39 = _slicedToArray(_ref38, 2),
            _r18 = _ref39[0],
            _i9 = _ref39[1];

        _r18 && _i9 ? e.shiftKey || o !== _i9 ? e.shiftKey && o === _r18 && (e.preventDefault(), n && eg(_i9, {
          select: !0
        })) : (e.preventDefault(), n && eg(_r18, {
          select: !0
        })) : o === _t19 && e.preventDefault();
      }
    }, [n, r, h.paused]);
    return o.createElement(Pm.div, Fd({
      tabIndex: -1
    }, s, {
      ref: p,
      onKeyDown: m
    }));
  });

  function Xm(e) {
    var t = [],
        n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
      acceptNode: function acceptNode(e) {
        var t = "INPUT" === e.tagName && "hidden" === e.type;
        return e.disabled || e.hidden || t ? NodeFilter.FILTER_SKIP : e.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });

    for (; n.nextNode();) {
      t.push(n.currentNode);
    }

    return t;
  }

  function Km(e, t) {
    var _iterator5 = _createForOfIteratorHelper(e),
        _step5;

    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var _n27 = _step5.value;
        if (!Jm(_n27, {
          upTo: t
        })) return _n27;
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  }

  function Jm(e, _ref40) {
    var t = _ref40.upTo;
    if ("hidden" === getComputedStyle(e).visibility) return !0;

    for (; e;) {
      if (void 0 !== t && e === t) return !1;
      if ("none" === getComputedStyle(e).display) return !0;
      e = e.parentElement;
    }

    return !1;
  }

  function eg(e) {
    var _ref41 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref41$select = _ref41.select,
        t = _ref41$select === void 0 ? !1 : _ref41$select;

    if (e && e.focus) {
      var _n28 = document.activeElement;
      e.focus({
        preventScroll: !0
      }), e !== _n28 && function (e) {
        return e instanceof HTMLInputElement && "select" in e;
      }(e) && t && e.select();
    }
  }

  var tg = function () {
    var e = [];
    return {
      add: function add(t) {
        var n = e[0];
        t !== n && (null == n || n.pause()), e = ng(e, t), e.unshift(t);
      },
      remove: function remove(t) {
        var n;
        e = ng(e, t), null === (n = e[0]) || void 0 === n || n.resume();
      }
    };
  }();

  function ng(e, t) {
    var n = _toConsumableArray(e),
        r = n.indexOf(t);

    return -1 !== r && n.splice(r, 1), n;
  }

  var rg = o.forwardRef(function (e, t) {
    var n;

    var _e$container = e.container,
        r = _e$container === void 0 ? null === globalThis || void 0 === globalThis || null === (n = globalThis.document) || void 0 === n ? void 0 : n.body : _e$container,
        i = _objectWithoutProperties(e, _excluded75);

    return r ? I["default"].createPortal(o.createElement(Pm.div, Fd({}, i, {
      ref: t
    })), r) : null;
  });

  var og = function og(e) {
    var t = e.present,
        n = e.children,
        r = function (e) {
      var _o$useState55 = o.useState(),
          _o$useState56 = _slicedToArray(_o$useState55, 2),
          t = _o$useState56[0],
          n = _o$useState56[1],
          r = o.useRef({}),
          i = o.useRef(e),
          a = o.useRef("none"),
          s = e ? "mounted" : "unmounted",
          _ref42 = function (e, t) {
        return o.useReducer(function (e, n) {
          var r = t[e][n];
          return null != r ? r : e;
        }, e);
      }(s, {
        mounted: {
          UNMOUNT: "unmounted",
          ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
          MOUNT: "mounted",
          ANIMATION_END: "unmounted"
        },
        unmounted: {
          MOUNT: "mounted"
        }
      }),
          _ref43 = _slicedToArray(_ref42, 2),
          l = _ref43[0],
          u = _ref43[1];

      return o.useEffect(function () {
        var e = ig(r.current);
        a.current = "mounted" === l ? e : "none";
      }, [l]), _m(function () {
        var t = r.current,
            n = i.current;

        if (n !== e) {
          var _r19 = a.current,
              _o10 = ig(t);

          if (e) u("MOUNT");else if ("none" === _o10 || "none" === (null == t ? void 0 : t.display)) u("UNMOUNT");else {
            var _e25 = _r19 !== _o10;

            u(n && _e25 ? "ANIMATION_OUT" : "UNMOUNT");
          }
          i.current = e;
        }
      }, [e, u]), _m(function () {
        if (t) {
          var _e26 = function _e26(e) {
            var n = ig(r.current).includes(e.animationName);
            e.target === t && n && c.flushSync(function () {
              return u("ANIMATION_END");
            });
          },
              _n29 = function _n29(e) {
            e.target === t && (a.current = ig(r.current));
          };

          return t.addEventListener("animationstart", _n29), t.addEventListener("animationcancel", _e26), t.addEventListener("animationend", _e26), function () {
            t.removeEventListener("animationstart", _n29), t.removeEventListener("animationcancel", _e26), t.removeEventListener("animationend", _e26);
          };
        }

        u("ANIMATION_END");
      }, [t, u]), {
        isPresent: ["mounted", "unmountSuspended"].includes(l),
        ref: o.useCallback(function (e) {
          e && (r.current = getComputedStyle(e)), n(e);
        }, [])
      };
    }(t),
        i = "function" == typeof n ? n({
      present: r.isPresent
    }) : o.Children.only(n),
        a = jm(r.ref, i.ref);

    return "function" == typeof n || r.isPresent ? o.cloneElement(i, {
      ref: a
    }) : null;
  };

  function ig(e) {
    return (null == e ? void 0 : e.animationName) || "none";
  }

  og.displayName = "Presence";
  var ag = 0;

  function sg() {
    var e = document.createElement("span");
    return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
  }

  var _lg = function lg() {
    return _lg = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) {
        for (var o in t = arguments[n]) {
          Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        }
      }

      return e;
    }, _lg.apply(this, arguments);
  };

  function cg(e, t) {
    var n = {};

    for (var r in e) {
      Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
    }

    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
      var o = 0;

      for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
        t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
      }
    }

    return n;
  }

  var ug = "right-scroll-bar-position",
      dg = "width-before-scroll-bar";

  function fg(e, t) {
    return n = t || null, r = function r(t) {
      return e.forEach(function (e) {
        return function (e, t) {
          return "function" == typeof e ? e(t) : e && (e.current = t), e;
        }(e, t);
      });
    }, (i = o.useState(function () {
      return {
        value: n,
        callback: r,
        facade: {
          get current() {
            return i.value;
          },

          set current(e) {
            var t = i.value;
            t !== e && (i.value = e, i.callback(e, t));
          }

        }
      };
    })[0]).callback = r, i.facade;
    var n, r, i;
  }

  function pg(e) {
    return e;
  }

  Object.prototype.toString.call("undefined" != typeof process ? process : 0);

  var hg = function hg(e) {
    var t = e.sideCar,
        n = cg(e, ["sideCar"]);
    if (!t) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
    var r = t.read();
    if (!r) throw new Error("Sidecar medium not found");
    return L.createElement(r, _lg({}, n));
  };

  hg.isSideCarExport = !0;

  var mg = function (e) {
    void 0 === e && (e = {});

    var t = function (e, t) {
      void 0 === t && (t = pg);
      var n = [],
          r = !1,
          o = {
        read: function read() {
          if (r) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
          return n.length ? n[n.length - 1] : e;
        },
        useMedium: function useMedium(e) {
          var o = t(e, r);
          return n.push(o), function () {
            n = n.filter(function (e) {
              return e !== o;
            });
          };
        },
        assignSyncMedium: function assignSyncMedium(e) {
          for (r = !0; n.length;) {
            var t = n;
            n = [], t.forEach(e);
          }

          n = {
            push: function push(t) {
              return e(t);
            },
            filter: function filter() {
              return n;
            }
          };
        },
        assignMedium: function assignMedium(e) {
          r = !0;
          var t = [];

          if (n.length) {
            var o = n;
            n = [], o.forEach(e), t = n;
          }

          var i = function i() {
            var n = t;
            t = [], n.forEach(e);
          },
              a = function a() {
            return Promise.resolve().then(i);
          };

          a(), n = {
            push: function push(e) {
              t.push(e), a();
            },
            filter: function filter(e) {
              return t = t.filter(e), n;
            }
          };
        }
      };
      return o;
    }(null);

    return t.options = _lg({
      async: !0,
      ssr: !1
    }, e), t;
  }(),
      gg = function gg() {},
      yg = L.forwardRef(function (e, t) {
    var n = L.useRef(null),
        r = L.useState({
      onScrollCapture: gg,
      onWheelCapture: gg,
      onTouchMoveCapture: gg
    }),
        o = r[0],
        i = r[1],
        a = e.forwardProps,
        s = e.children,
        l = e.className,
        c = e.removeScrollBar,
        u = e.enabled,
        d = e.shards,
        f = e.sideCar,
        p = e.noIsolation,
        h = e.inert,
        m = e.allowPinchZoom,
        g = e.as,
        y = void 0 === g ? "div" : g,
        b = cg(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]),
        v = f,
        x = fg([n, t]),
        w = _lg(_lg({}, b), o);

    return L.createElement(L.Fragment, null, u && L.createElement(v, {
      sideCar: mg,
      removeScrollBar: c,
      shards: d,
      noIsolation: p,
      inert: h,
      setCallbacks: i,
      allowPinchZoom: !!m,
      lockRef: n
    }), a ? L.cloneElement(L.Children.only(s), _lg(_lg({}, w), {
      ref: x
    })) : L.createElement(y, _lg({}, w, {
      className: l,
      ref: x
    }), s));
  });

  yg.defaultProps = {
    enabled: !0,
    removeScrollBar: !0,
    inert: !1
  }, yg.classNames = {
    fullWidth: dg,
    zeroRight: ug
  };

  function bg() {
    if (!document) return null;
    var e = document.createElement("style");
    e.type = "text/css";

    var t = function () {
      if ("undefined" != typeof __webpack_nonce__) return __webpack_nonce__;
    }();

    return t && e.setAttribute("nonce", t), e;
  }

  var vg = function vg() {
    var e = 0,
        t = null;
    return {
      add: function add(n) {
        var r;
        0 == e && (t = bg()) && (!function (e, t) {
          e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
        }(t, n), r = t, (document.head || document.getElementsByTagName("head")[0]).appendChild(r)), e++;
      },
      remove: function remove() {
        ! --e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
      }
    };
  },
      xg = function xg() {
    var e,
        t = (e = vg(), function (t, n) {
      L.useEffect(function () {
        return e.add(t), function () {
          e.remove();
        };
      }, [t && n]);
    });
    return function (e) {
      var n = e.styles,
          r = e.dynamic;
      return t(n, r), null;
    };
  },
      wg = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
  },
      kg = function kg(e) {
    return parseInt(e || "", 10) || 0;
  },
      Cg = function Cg(e) {
    if (void 0 === e && (e = "margin"), "undefined" == typeof window) return wg;

    var t = function (e) {
      var t = window.getComputedStyle(document.body),
          n = t["padding" === e ? "paddingLeft" : "marginLeft"],
          r = t["padding" === e ? "paddingTop" : "marginTop"],
          o = t["padding" === e ? "paddingRight" : "marginRight"];
      return [kg(n), kg(r), kg(o)];
    }(e),
        n = document.documentElement.clientWidth,
        r = window.innerWidth;

    return {
      left: t[0],
      top: t[1],
      right: t[2],
      gap: Math.max(0, r - n + t[2] - t[0])
    };
  },
      Mg = xg(),
      jg = "data-scroll-locked",
      Eg = function Eg(e, t, n, r) {
    var o = e.left,
        i = e.top,
        a = e.right,
        s = e.gap;
    return void 0 === n && (n = "margin"), "\n  .".concat("with-scroll-bars-hidden", " {\n   overflow: hidden ").concat(r, ";\n   padding-right: ").concat(s, "px ").concat(r, ";\n  }\n  body[").concat(jg, "] {\n    overflow: hidden ").concat(r, ";\n    overscroll-behavior: contain;\n    ").concat([t && "position: relative ".concat(r, ";"), "margin" === n && "\n    padding-left: ".concat(o, "px;\n    padding-top: ").concat(i, "px;\n    padding-right: ").concat(a, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(s, "px ").concat(r, ";\n    "), "padding" === n && "padding-right: ".concat(s, "px ").concat(r, ";")].filter(Boolean).join(""), "\n  }\n  \n  .").concat(ug, " {\n    right: ").concat(s, "px ").concat(r, ";\n  }\n  \n  .").concat(dg, " {\n    margin-right: ").concat(s, "px ").concat(r, ";\n  }\n  \n  .").concat(ug, " .").concat(ug, " {\n    right: 0 ").concat(r, ";\n  }\n  \n  .").concat(dg, " .").concat(dg, " {\n    margin-right: 0 ").concat(r, ";\n  }\n  \n  body[").concat(jg, "] {\n    ").concat("--removed-body-scroll-bar-size", ": ").concat(s, "px;\n  }\n");
  },
      _g = function _g() {
    var e = parseInt(document.body.getAttribute(jg) || "0", 10);
    return isFinite(e) ? e : 0;
  },
      Tg = function Tg(e) {
    var t = e.noRelative,
        n = e.noImportant,
        r = e.gapMode,
        o = void 0 === r ? "margin" : r;
    L.useEffect(function () {
      return document.body.setAttribute(jg, (_g() + 1).toString()), function () {
        var e = _g() - 1;
        e <= 0 ? document.body.removeAttribute(jg) : document.body.setAttribute(jg, e.toString());
      };
    }, []);
    var i = L.useMemo(function () {
      return Cg(o);
    }, [o]);
    return L.createElement(Mg, {
      styles: Eg(i, !t, o, n ? "" : "!important")
    });
  },
      Sg = !1;

  if ("undefined" != typeof window) try {
    var Lg = Object.defineProperty({}, "passive", {
      get: function get() {
        return Sg = !0, !0;
      }
    });
    window.addEventListener("test", Lg, Lg), window.removeEventListener("test", Lg, Lg);
  } catch (e) {
    Sg = !1;
  }

  var Dg = !!Sg && {
    passive: !1
  },
      Ag = function Ag(e, t) {
    var n = window.getComputedStyle(e);
    return "hidden" !== n[t] && !(n.overflowY === n.overflowX && !function (e) {
      return "TEXTAREA" === e.tagName;
    }(e) && "visible" === n[t]);
  },
      Ng = function Ng(e, t) {
    var n = t;

    do {
      if ("undefined" != typeof ShadowRoot && n instanceof ShadowRoot && (n = n.host), Ig(e, n)) {
        var r = zg(e, n);
        if (r[1] > r[2]) return !0;
      }

      n = n.parentNode;
    } while (n && n !== document.body);

    return !1;
  },
      Ig = function Ig(e, t) {
    return "v" === e ? function (e) {
      return Ag(e, "overflowY");
    }(t) : function (e) {
      return Ag(e, "overflowX");
    }(t);
  },
      zg = function zg(e, t) {
    return "v" === e ? [(n = t).scrollTop, n.scrollHeight, n.clientHeight] : function (e) {
      return [e.scrollLeft, e.scrollWidth, e.clientWidth];
    }(t);
    var n;
  },
      Og = function Og(e) {
    return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
  },
      Rg = function Rg(e) {
    return [e.deltaX, e.deltaY];
  },
      Pg = function Pg(e) {
    return e && "current" in e ? e.current : e;
  },
      Fg = function Fg(e) {
    return "\n  .block-interactivity-".concat(e, " {pointer-events: none;}\n  .allow-interactivity-").concat(e, " {pointer-events: all;}\n");
  },
      Bg = 0,
      qg = [];

  var Ug,
      Vg = (Ug = function Ug(e) {
    var t = L.useRef([]),
        n = L.useRef([0, 0]),
        r = L.useRef(),
        o = L.useState(Bg++)[0],
        i = L.useState(function () {
      return xg();
    })[0],
        a = L.useRef(e);
    L.useEffect(function () {
      a.current = e;
    }, [e]), L.useEffect(function () {
      if (e.inert) {
        document.body.classList.add("block-interactivity-".concat(o));

        var t = function (e, t, n) {
          if (n || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) {
            !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
          }
          return e.concat(r || Array.prototype.slice.call(t));
        }([e.lockRef.current], (e.shards || []).map(Pg), !0).filter(Boolean);

        return t.forEach(function (e) {
          return e.classList.add("allow-interactivity-".concat(o));
        }), function () {
          document.body.classList.remove("block-interactivity-".concat(o)), t.forEach(function (e) {
            return e.classList.remove("allow-interactivity-".concat(o));
          });
        };
      }
    }, [e.inert, e.lockRef.current, e.shards]);
    var s = L.useCallback(function (e, t) {
      if ("touches" in e && 2 === e.touches.length) return !a.current.allowPinchZoom;
      var o,
          i = Og(e),
          s = n.current,
          l = "deltaX" in e ? e.deltaX : s[0] - i[0],
          c = "deltaY" in e ? e.deltaY : s[1] - i[1],
          u = e.target,
          d = Math.abs(l) > Math.abs(c) ? "h" : "v";
      if ("touches" in e && "h" === d && "range" === u.type) return !1;
      var f = Ng(d, u);
      if (!f) return !0;
      if (f ? o = d : (o = "v" === d ? "h" : "v", f = Ng(d, u)), !f) return !1;
      if (!r.current && "changedTouches" in e && (l || c) && (r.current = o), !o) return !0;
      var p = r.current || o;
      return function (e, t, n, r, o) {
        var i = function (e, t) {
          return "h" === e && "rtl" === t ? -1 : 1;
        }(e, window.getComputedStyle(t).direction),
            a = i * r,
            s = n.target,
            l = t.contains(s),
            c = !1,
            u = a > 0,
            d = 0,
            f = 0;

        do {
          var p = zg(e, s),
              h = p[0],
              m = p[1] - p[2] - i * h;
          (h || m) && Ig(e, s) && (d += m, f += h), s = s.parentNode;
        } while (!l && s !== document.body || l && (t.contains(s) || t === s));

        return (u && (o && 0 === d || !o && a > d) || !u && (o && 0 === f || !o && -a > f)) && (c = !0), c;
      }(p, t, e, "h" === p ? l : c, !0);
    }, []),
        l = L.useCallback(function (e) {
      var n = e;

      if (qg.length && qg[qg.length - 1] === i) {
        var r = "deltaY" in n ? Rg(n) : Og(n),
            o = t.current.filter(function (e) {
          return e.name === n.type && e.target === n.target && function (e, t) {
            return e[0] === t[0] && e[1] === t[1];
          }(e.delta, r);
        })[0];
        if (o && o.should) n.cancelable && n.preventDefault();else if (!o) {
          var l = (a.current.shards || []).map(Pg).filter(Boolean).filter(function (e) {
            return e.contains(n.target);
          });
          (l.length > 0 ? s(n, l[0]) : !a.current.noIsolation) && n.cancelable && n.preventDefault();
        }
      }
    }, []),
        c = L.useCallback(function (e, n, r, o) {
      var i = {
        name: e,
        delta: n,
        target: r,
        should: o
      };
      t.current.push(i), setTimeout(function () {
        t.current = t.current.filter(function (e) {
          return e !== i;
        });
      }, 1);
    }, []),
        u = L.useCallback(function (e) {
      n.current = Og(e), r.current = void 0;
    }, []),
        d = L.useCallback(function (t) {
      c(t.type, Rg(t), t.target, s(t, e.lockRef.current));
    }, []),
        f = L.useCallback(function (t) {
      c(t.type, Og(t), t.target, s(t, e.lockRef.current));
    }, []);
    L.useEffect(function () {
      return qg.push(i), e.setCallbacks({
        onScrollCapture: d,
        onWheelCapture: d,
        onTouchMoveCapture: f
      }), document.addEventListener("wheel", l, Dg), document.addEventListener("touchmove", l, Dg), document.addEventListener("touchstart", u, Dg), function () {
        qg = qg.filter(function (e) {
          return e !== i;
        }), document.removeEventListener("wheel", l, Dg), document.removeEventListener("touchmove", l, Dg), document.removeEventListener("touchstart", u, Dg);
      };
    }, []);
    var p = e.removeScrollBar,
        h = e.inert;
    return L.createElement(L.Fragment, null, h ? L.createElement(i, {
      styles: Fg(o)
    }) : null, p ? L.createElement(Tg, {
      gapMode: "margin"
    }) : null);
  }, mg.useMedium(Ug), hg),
      Hg = L.forwardRef(function (e, t) {
    return L.createElement(yg, _lg({}, e, {
      ref: t,
      sideCar: Vg
    }));
  });
  Hg.classNames = yg.classNames;

  var Zg = new WeakMap(),
      Wg = new WeakMap(),
      $g = {},
      Gg = 0,
      Yg = function Yg(e, t, n) {
    void 0 === t && (t = function (e) {
      return "undefined" == typeof document ? null : (Array.isArray(e) ? e[0] : e).ownerDocument.body;
    }(e)), void 0 === n && (n = "data-aria-hidden");
    var r = Array.isArray(e) ? e : [e];
    $g[n] || ($g[n] = new WeakMap());

    var o = $g[n],
        i = [],
        a = new Set(),
        s = function s(e) {
      e && !a.has(e) && (a.add(e), s(e.parentNode));
    };

    r.forEach(s);

    var l = function l(e) {
      !e || r.indexOf(e) >= 0 || Array.prototype.forEach.call(e.children, function (e) {
        if (a.has(e)) l(e);else {
          var t = e.getAttribute("aria-hidden"),
              r = null !== t && "false" !== t,
              s = (Zg.get(e) || 0) + 1,
              c = (o.get(e) || 0) + 1;
          Zg.set(e, s), o.set(e, c), i.push(e), 1 === s && r && Wg.set(e, !0), 1 === c && e.setAttribute(n, "true"), r || e.setAttribute("aria-hidden", "true");
        }
      });
    };

    return l(t), a.clear(), Gg++, function () {
      i.forEach(function (e) {
        var t = Zg.get(e) - 1,
            r = o.get(e) - 1;
        Zg.set(e, t), o.set(e, r), t || (Wg.has(e) || e.removeAttribute("aria-hidden"), Wg["delete"](e)), r || e.removeAttribute(n);
      }), --Gg || (Zg = new WeakMap(), Zg = new WeakMap(), Wg = new WeakMap(), $g = {});
    };
  };

  var Qg = "Dialog",
      _ref44 = function (e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var n = [];

    var r = function r() {
      var t = n.map(function (e) {
        return o.createContext(e);
      });
      return function (n) {
        var r = (null == n ? void 0 : n[e]) || t;
        return o.useMemo(function () {
          return _defineProperty({}, "__scope".concat(e), _objectSpread(_objectSpread({}, n), {}, _defineProperty({}, e, r)));
        }, [n, r]);
      };
    };

    return r.scopeName = e, [function (t, r) {
      var i = o.createContext(r),
          a = n.length;

      function s(t) {
        var n = t.scope,
            r = t.children,
            s = _objectWithoutProperties(t, _excluded76),
            l = (null == n ? void 0 : n[e][a]) || i,
            c = o.useMemo(function () {
          return s;
        }, Object.values(s));

        return o.createElement(l.Provider, {
          value: c
        }, r);
      }

      return n = [].concat(_toConsumableArray(n), [r]), s.displayName = t + "Provider", [s, function (n, s) {
        var l = (null == s ? void 0 : s[e][a]) || i,
            c = o.useContext(l);
        if (c) return c;
        if (void 0 !== r) return r;
        throw new Error("`".concat(n, "` must be used within `").concat(t, "`"));
      }];
    }, Em.apply(void 0, [r].concat(_toConsumableArray(t)))];
  }(Qg),
      _ref45 = _slicedToArray(_ref44, 2),
      Xg = _ref45[0],
      Kg = _ref45[1],
      _Xg = Xg(Qg),
      _Xg2 = _slicedToArray(_Xg, 2),
      Jg = _Xg2[0],
      ey = _Xg2[1],
      ty = o.forwardRef(function (e, t) {
    var n = e.__scopeDialog,
        r = _objectWithoutProperties(e, _excluded77),
        i = ey("DialogTrigger", n),
        a = jm(t, i.triggerRef);

    return o.createElement(Pm.button, Fd({
      type: "button",
      "aria-haspopup": "dialog",
      "aria-expanded": i.open,
      "aria-controls": i.contentId,
      "data-state": gy(i.open)
    }, r, {
      ref: a,
      onClick: Cm(e.onClick, i.onOpenToggle)
    }));
  }),
      ny = "DialogPortal",
      _Xg3 = Xg(ny, {
    forceMount: void 0
  }),
      _Xg4 = _slicedToArray(_Xg3, 2),
      ry = _Xg4[0],
      oy = _Xg4[1],
      iy = "DialogOverlay",
      ay = o.forwardRef(function (e, t) {
    var n = oy(iy, e.__scopeDialog),
        _e$forceMount = e.forceMount,
        r = _e$forceMount === void 0 ? n.forceMount : _e$forceMount,
        i = _objectWithoutProperties(e, _excluded78),
        a = ey(iy, e.__scopeDialog);

    return a.modal ? o.createElement(og, {
      present: r || a.open
    }, o.createElement(sy, Fd({}, i, {
      ref: t
    }))) : null;
  }),
      sy = o.forwardRef(function (e, t) {
    var n = e.__scopeDialog,
        r = _objectWithoutProperties(e, _excluded79),
        i = ey(iy, n);

    return o.createElement(Hg, {
      as: Nm,
      allowPinchZoom: !0,
      shards: [i.contentRef]
    }, o.createElement(Pm.div, Fd({
      "data-state": gy(i.open)
    }, r, {
      ref: t,
      style: _objectSpread({
        pointerEvents: "auto"
      }, r.style)
    })));
  }),
      ly = "DialogContent",
      cy = o.forwardRef(function (e, t) {
    var n = oy(ly, e.__scopeDialog),
        _e$forceMount2 = e.forceMount,
        r = _e$forceMount2 === void 0 ? n.forceMount : _e$forceMount2,
        i = _objectWithoutProperties(e, _excluded80),
        a = ey(ly, e.__scopeDialog);

    return o.createElement(og, {
      present: r || a.open
    }, a.modal ? o.createElement(uy, Fd({}, i, {
      ref: t
    })) : o.createElement(dy, Fd({}, i, {
      ref: t
    })));
  }),
      uy = o.forwardRef(function (e, t) {
    var n = ey(ly, e.__scopeDialog),
        r = o.useRef(null),
        i = jm(t, n.contentRef, r);
    return o.useEffect(function () {
      var e = r.current;
      if (e) return Yg(e);
    }, []), o.createElement(fy, Fd({}, e, {
      ref: i,
      trapFocus: n.open,
      disableOutsidePointerEvents: !0,
      onCloseAutoFocus: Cm(e.onCloseAutoFocus, function (e) {
        var t;
        e.preventDefault(), null === (t = n.triggerRef.current) || void 0 === t || t.focus();
      }),
      onPointerDownOutside: Cm(e.onPointerDownOutside, function (e) {
        var t = e.detail.originalEvent,
            n = 0 === t.button && !0 === t.ctrlKey;
        (2 === t.button || n) && e.preventDefault();
      }),
      onFocusOutside: Cm(e.onFocusOutside, function (e) {
        return e.preventDefault();
      })
    }));
  }),
      dy = o.forwardRef(function (e, t) {
    var n = ey(ly, e.__scopeDialog),
        r = o.useRef(!1),
        i = o.useRef(!1);
    return o.createElement(fy, Fd({}, e, {
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      onCloseAutoFocus: function onCloseAutoFocus(t) {
        var o, a;
        (null === (o = e.onCloseAutoFocus) || void 0 === o || o.call(e, t), t.defaultPrevented) || (r.current || null === (a = n.triggerRef.current) || void 0 === a || a.focus(), t.preventDefault());
        r.current = !1, i.current = !1;
      },
      onInteractOutside: function onInteractOutside(t) {
        var o, a;
        null === (o = e.onInteractOutside) || void 0 === o || o.call(e, t), t.defaultPrevented || (r.current = !0, "pointerdown" === t.detail.originalEvent.type && (i.current = !0));
        var s = t.target;
        (null === (a = n.triggerRef.current) || void 0 === a ? void 0 : a.contains(s)) && t.preventDefault(), "focusin" === t.detail.originalEvent.type && i.current && t.preventDefault();
      }
    }));
  }),
      fy = o.forwardRef(function (e, t) {
    var n = e.__scopeDialog,
        r = e.trapFocus,
        i = e.onOpenAutoFocus,
        a = e.onCloseAutoFocus,
        s = _objectWithoutProperties(e, _excluded81),
        l = ey(ly, n),
        c = jm(t, o.useRef(null));

    return o.useEffect(function () {
      var e, t;
      var n = document.querySelectorAll("[data-radix-focus-guard]");
      return document.body.insertAdjacentElement("afterbegin", null !== (e = n[0]) && void 0 !== e ? e : sg()), document.body.insertAdjacentElement("beforeend", null !== (t = n[1]) && void 0 !== t ? t : sg()), ag++, function () {
        1 === ag && document.querySelectorAll("[data-radix-focus-guard]").forEach(function (e) {
          return e.remove();
        }), ag--;
      };
    }, []), o.createElement(o.Fragment, null, o.createElement(Qm, {
      asChild: !0,
      loop: !0,
      trapped: r,
      onMountAutoFocus: i,
      onUnmountAutoFocus: a
    }, o.createElement(Hm, Fd({
      role: "dialog",
      id: l.contentId,
      "aria-describedby": l.descriptionId,
      "aria-labelledby": l.titleId,
      "data-state": gy(l.open)
    }, s, {
      ref: c,
      onDismiss: function onDismiss() {
        return l.onOpenChange(!1);
      }
    }))), !1);
  }),
      py = o.forwardRef(function (e, t) {
    var n = e.__scopeDialog,
        r = _objectWithoutProperties(e, _excluded82),
        i = ey("DialogTitle", n);

    return o.createElement(Pm.h2, Fd({
      id: i.titleId
    }, r, {
      ref: t
    }));
  }),
      hy = o.forwardRef(function (e, t) {
    var n = e.__scopeDialog,
        r = _objectWithoutProperties(e, _excluded83),
        i = ey("DialogDescription", n);

    return o.createElement(Pm.p, Fd({
      id: i.descriptionId
    }, r, {
      ref: t
    }));
  }),
      my = o.forwardRef(function (e, t) {
    var n = e.__scopeDialog,
        r = _objectWithoutProperties(e, _excluded84),
        i = ey("DialogClose", n);

    return o.createElement(Pm.button, Fd({
      type: "button"
    }, r, {
      ref: t,
      onClick: Cm(e.onClick, function () {
        return i.onOpenChange(!1);
      })
    }));
  });

  function gy(e) {
    return e ? "open" : "closed";
  }

  var yy = function yy(e) {
    var t = e.__scopeDialog,
        n = e.children,
        r = e.open,
        i = e.defaultOpen,
        a = e.onOpenChange,
        _e$modal = e.modal,
        s = _e$modal === void 0 ? !0 : _e$modal,
        l = o.useRef(null),
        c = o.useRef(null),
        _Am = Am({
      prop: r,
      defaultProp: i,
      onChange: a
    }),
        _Am2 = _slicedToArray(_Am, 2),
        _Am2$ = _Am2[0],
        u = _Am2$ === void 0 ? !1 : _Am2$,
        d = _Am2[1];

    return o.createElement(Jg, {
      scope: t,
      triggerRef: l,
      contentRef: c,
      contentId: Lm(),
      titleId: Lm(),
      descriptionId: Lm(),
      open: u,
      onOpenChange: d,
      onOpenToggle: o.useCallback(function () {
        return d(function (e) {
          return !e;
        });
      }, [d]),
      modal: s
    }, n);
  },
      by = ty,
      vy = function vy(e) {
    var t = e.__scopeDialog,
        n = e.forceMount,
        r = e.children,
        i = e.container,
        a = ey(ny, t);
    return o.createElement(ry, {
      scope: t,
      forceMount: n
    }, o.Children.map(r, function (e) {
      return o.createElement(og, {
        present: n || a.open
      }, o.createElement(rg, {
        asChild: !0,
        container: i
      }, e));
    }));
  },
      xy = ay,
      wy = cy,
      ky = py,
      Cy = hy,
      My = my,
      jy = _["default"](xy).withConfig({
    displayName: "Dialog__Overlay",
    componentId: "sc-12vbdgp-0"
  })(["background:rgba(0,0,0,0.5);position:fixed;inset:0;z-index:", ";"], function (e) {
    return e.$zIndex || 6;
  });

  jy.displayName = "Dialog.Overlay";
  var Ey = o.forwardRef(function (e, t) {
    return s.jsx(_c, _objectSpread(_objectSpread({
      zIndex: 1
    }, e), {}, {
      ref: t,
      children: s.jsx(mc, {
        icon: "times"
      })
    }));
  });

  function _y(e) {
    return s.jsx(My, {
      asChild: !0,
      children: s.jsx(Ey, _objectSpread({}, e))
    });
  }

  var Ty = _["default"](wy).withConfig({
    shouldForwardProp: se
  }).withConfig({
    displayName: "Dialog__StyledContent",
    componentId: "sc-12vbdgp-1"
  })(["position:fixed;top:0;left:0;right:0;margin:", " auto;max-width:", ";max-height:80vh;background:", ";border-radius:", ";box-shadow:", ";padding:", ";padding-top:0;position:fixed;overflow-y:", ";-webkit-overflow-scrolling:touch;z-index:", ";", ""], function (e) {
    return e.theme.space[3];
  }, function (e) {
    return e.maxWidth ? e.maxWidth : "90vw";
  }, function (e) {
    return e.theme.colors.white;
  }, function (e) {
    return e.theme.radii.rounded;
  }, function (e) {
    return e.theme.shadows[4];
  }, function (e) {
    return e.theme.space[3];
  }, function (e) {
    return e.overflowY || "scroll";
  }, function (e) {
    return e.$zIndex || 6;
  }, wc.md(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n    margin-top: ", ";\n    padding-left: ", ";\n    padding-right: ", ";\n    max-width: ", ";\n  "])), function (e) {
    return e.theme.space[4];
  }, function (e) {
    return e.theme.space[4];
  }, function (e) {
    return e.theme.space[4];
  }, function (e) {
    return e.maxWidth ? e.maxWidth : "60ch";
  })),
      Sy = _["default"](fe).attrs(function (e) {
    return _objectSpread({
      bg: "gray100",
      display: "flex",
      alignItems: "center",
      boxShadow: 1,
      py: 3,
      px: [3, null, 4],
      mx: [-3, null, -4],
      mb: 3,
      position: "sticky",
      top: 0,
      zIndex: 3
    }, e);
  }).withConfig({
    displayName: "Dialog__TitleBar",
    componentId: "sc-12vbdgp-2"
  })(["border-top-left-radius:", ";border-top-right-radius:", ";"], function (e) {
    return e.theme.radii.rounded;
  }, function (e) {
    return e.theme.radii.rounded;
  });

  function Ly(e) {
    var t = e.children,
        n = e.noCloseButton,
        r = _objectWithoutProperties(e, _excluded85);

    return s.jsxs(Sy, _objectSpread(_objectSpread({}, r), {}, {
      children: [s.jsx(fe, {
        flex: 1,
        children: s.jsx(ky, {
          asChild: !0,
          children: t
        })
      }), !n && s.jsx(fe, {
        ml: "auto",
        children: s.jsx(_y, {})
      })]
    }));
  }

  Ly.defaultProps = {
    noCloseButton: !1
  }, Ly.propTypes = {
    children: T["default"].node.isRequired,
    noCloseButton: T["default"].bool
  };

  var Dy = {
    Root: yy,
    Trigger: by,
    Portal: vy,
    Overlay: jy,
    Content: wy,
    StyledContent: Ty,
    Close: _y,
    Title: ky,
    StyledTitle: Ly,
    Description: Cy
  },
      Ay = S["default"].createContext({
    drawerRef: {
      current: null
    },
    overlayRef: {
      current: null
    },
    scaleBackground: function scaleBackground() {},
    onPress: function onPress() {},
    onRelease: function onRelease() {},
    onDrag: function onDrag() {},
    onNestedDrag: function onNestedDrag() {},
    onNestedOpenChange: function onNestedOpenChange() {},
    onNestedRelease: function onNestedRelease() {},
    openProp: void 0,
    dismissible: !1,
    isOpen: !1,
    keyboardIsOpen: {
      current: !1
    },
    snapPointsOffset: null,
    snapPoints: null,
    modal: !1,
    shouldFade: !1,
    activeSnapPoint: null,
    onOpenChange: function onOpenChange() {},
    setActiveSnapPoint: function setActiveSnapPoint() {},
    visible: !1,
    closeDrawer: function closeDrawer() {},
    setVisible: function setVisible() {},
    direction: "bottom"
  }),
      Ny = function Ny() {
    return S["default"].useContext(Ay);
  };

  !function (e) {
    var _ref47 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        t = _ref47.insertAt;

    if (!e || "undefined" == typeof document) return;
    var n = document.head || document.getElementsByTagName("head")[0],
        r = document.createElement("style");
    r.type = "text/css", "top" === t && n.firstChild ? n.insertBefore(r, n.firstChild) : n.appendChild(r), r.styleSheet ? r.styleSheet.cssText = e : r.appendChild(document.createTextNode(e));
  }('[vaul-drawer]{touch-action:none;transition:transform .5s cubic-bezier(.32,.72,0,1)}[vaul-drawer][vaul-drawer-direction=bottom]{transform:translate3d(0,100%,0)}[vaul-drawer][vaul-drawer-direction=top]{transform:translate3d(0,-100%,0)}[vaul-drawer][vaul-drawer-direction=left]{transform:translate3d(-100%,0,0)}[vaul-drawer][vaul-drawer-direction=right]{transform:translate3d(100%,0,0)}.vaul-dragging .vaul-scrollable [vault-drawer-direction=top],.vaul-dragging .vaul-scrollable [vault-drawer-direction=bottom]{overflow-y:hidden!important}.vaul-dragging .vaul-scrollable [vault-drawer-direction=left],.vaul-dragging .vaul-scrollable [vault-drawer-direction=right]{overflow-x:hidden!important}[vaul-drawer][vaul-drawer-visible=true][vaul-drawer-direction=top],[vaul-drawer][vaul-drawer-visible=true][vaul-drawer-direction=bottom]{transform:translate3d(0,var(--snap-point-height, 0),0)}[vaul-drawer][vaul-drawer-visible=true][vaul-drawer-direction=left],[vaul-drawer][vaul-drawer-visible=true][vaul-drawer-direction=right]{transform:translate3d(var(--snap-point-height, 0),0,0)}[vaul-overlay]{opacity:0;transition:opacity .5s cubic-bezier(.32,.72,0,1)}[vaul-overlay][vaul-drawer-visible=true]{opacity:1}[vaul-drawer]:after{content:"";position:absolute;background:inherit;background-color:inherit}[vaul-drawer][vaul-drawer-direction=top]:after{top:initial;bottom:100%;left:0;right:0;height:200%}[vaul-drawer][vaul-drawer-direction=bottom]:after{top:100%;bottom:initial;left:0;right:0;height:200%}[vaul-drawer][vaul-drawer-direction=left]:after{left:initial;right:100%;top:0;bottom:0;width:200%}[vaul-drawer][vaul-drawer-direction=right]:after{left:100%;right:initial;top:0;bottom:0;width:200%}[vaul-overlay][vaul-snap-points=true]:not([vaul-snap-points-overlay="true"]):not([data-state="closed"]){opacity:0}[vaul-overlay][vaul-snap-points-overlay=true]:not([vaul-drawer-visible="false"]){opacity:1}@keyframes fake-animation{}@media (hover: hover) and (pointer: fine){[vaul-drawer]{user-select:none}}\n');
  var Iy = "undefined" != typeof window ? o.useLayoutEffect : o.useEffect;

  function zy() {
    for (var _len16 = arguments.length, e = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
      e[_key16] = arguments[_key16];
    }

    return function () {
      var _iterator6 = _createForOfIteratorHelper(e),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _n30 = _step6.value;
          "function" == typeof _n30 && _n30.apply(void 0, arguments);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    };
  }

  function Oy() {
    return Py(/^iPad/) || Py(/^Mac/) && navigator.maxTouchPoints > 1;
  }

  function Ry() {
    return Py(/^iPhone/) || Oy();
  }

  function Py(e) {
    return "undefined" != typeof window && null != window.navigator ? e.test(window.navigator.platform) : void 0;
  }

  var Fy = "undefined" != typeof document && window.visualViewport;

  function By(e) {
    var t = window.getComputedStyle(e);
    return /(auto|scroll)/.test(t.overflow + t.overflowX + t.overflowY);
  }

  function qy(e) {
    for (By(e) && (e = e.parentElement); e && !By(e);) {
      e = e.parentElement;
    }

    return e || document.scrollingElement || document.documentElement;
  }

  var Uy,
      Vy = new Set(["checkbox", "radio", "range", "color", "file", "image", "button", "submit", "reset"]),
      Hy = 0;

  function Zy() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var t = e.isDisabled;
    Iy(function () {
      if (!t) return 1 === ++Hy && (Uy = Ry() ? function () {
        var e,
            t = 0,
            n = function n(_n31) {
          e = qy(_n31.target), (e !== document.documentElement || e !== document.body) && (t = _n31.changedTouches[0].pageY);
        },
            r = function r(n) {
          if (!e || e === document.documentElement || e === document.body) return void n.preventDefault();
          var r = n.changedTouches[0].pageY,
              o = e.scrollTop,
              i = e.scrollHeight - e.clientHeight;
          0 !== i && ((o <= 0 && r > t || o >= i && r < t) && n.preventDefault(), t = r);
        },
            o = function o(e) {
          var t = e.target;
          Yy(t) && t !== document.activeElement && (e.preventDefault(), t.style.transform = "translateY(-2000px)", t.focus(), requestAnimationFrame(function () {
            t.style.transform = "";
          }));
        },
            i = function i(e) {
          var t = e.target;
          Yy(t) && (t.style.transform = "translateY(-2000px)", requestAnimationFrame(function () {
            t.style.transform = "", Fy && (Fy.height < window.innerHeight ? requestAnimationFrame(function () {
              Gy(t);
            }) : Fy.addEventListener("resize", function () {
              return Gy(t);
            }, {
              once: !0
            }));
          }));
        },
            a = function a() {
          window.scrollTo(0, 0);
        },
            s = window.pageXOffset,
            l = window.pageYOffset,
            c = zy(Wy(document.documentElement, "paddingRight", window.innerWidth - document.documentElement.clientWidth + "px"));

        window.scrollTo(0, 0);
        var u = zy($y(document, "touchstart", n, {
          passive: !1,
          capture: !0
        }), $y(document, "touchmove", r, {
          passive: !1,
          capture: !0
        }), $y(document, "touchend", o, {
          passive: !1,
          capture: !0
        }), $y(document, "focus", i, !0), $y(window, "scroll", a));
        return function () {
          c(), u(), window.scrollTo(s, l);
        };
      }() : zy(Wy(document.documentElement, "paddingRight", window.innerWidth - document.documentElement.clientWidth + "px"))), function () {
        0 === --Hy && Uy();
      };
    }, [t]);
  }

  function Wy(e, t, n) {
    var r = e.style[t];
    return e.style[t] = n, function () {
      e.style[t] = r;
    };
  }

  function $y(e, t, n, r) {
    return e.addEventListener(t, n, r), function () {
      e.removeEventListener(t, n, r);
    };
  }

  function Gy(e) {
    var t = document.scrollingElement || document.documentElement;

    for (; e && e !== t;) {
      var _t20 = qy(e);

      if (_t20 !== document.documentElement && _t20 !== document.body && _t20 !== e) {
        var _n32 = _t20.getBoundingClientRect().top,
            _r20 = e.getBoundingClientRect().top;

        e.getBoundingClientRect().bottom > _t20.getBoundingClientRect().bottom && (_t20.scrollTop += _r20 - _n32);
      }

      e = _t20.parentElement;
    }
  }

  function Yy(e) {
    return e instanceof HTMLInputElement && !Vy.has(e.type) || e instanceof HTMLTextAreaElement || e instanceof HTMLElement && e.isContentEditable;
  }

  function Qy() {
    for (var _len17 = arguments.length, e = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
      e[_key17] = arguments[_key17];
    }

    return L.useCallback(function () {
      for (var _len18 = arguments.length, e = new Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
        e[_key18] = arguments[_key18];
      }

      return function (t) {
        return e.forEach(function (e) {
          return function (e, t) {
            "function" == typeof e ? e(t) : null != e && (e.current = t);
          }(e, t);
        });
      };
    }.apply(void 0, e), e);
  }

  var Xy = null;
  var Ky = new WeakMap();

  function Jy(e, t) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
    if (!(e && e instanceof HTMLElement && t)) return;
    var r = {};
    Object.entries(t).forEach(function (_ref48) {
      var _ref49 = _slicedToArray(_ref48, 2),
          t = _ref49[0],
          n = _ref49[1];

      t.startsWith("--") ? e.style.setProperty(t, n) : (r[t] = e.style[t], e.style[t] = n);
    }), !n && Ky.set(e, r);
  }

  function eb(e, t) {
    if (!(e && e instanceof HTMLElement)) return;
    var n = Ky.get(e);
    n && (t ? e.style[t] = n[t] : Object.entries(n).forEach(function (_ref50) {
      var _ref51 = _slicedToArray(_ref50, 2),
          t = _ref51[0],
          n = _ref51[1];

      e.style[t] = n;
    }));
  }

  var tb = function tb(e) {
    switch (e) {
      case "top":
      case "bottom":
        return !0;

      case "left":
      case "right":
        return !1;

      default:
        return e;
    }
  };

  function nb(e, t) {
    var n = window.getComputedStyle(e),
        r = n.transform || n.webkitTransform || n.mozTransform,
        o = r.match(/^matrix3d\((.+)\)$/);
    return o ? parseFloat(o[1].split(", ")[tb(t) ? 13 : 12]) : (o = r.match(/^matrix\((.+)\)$/), o ? parseFloat(o[1].split(", ")[tb(t) ? 5 : 4]) : null);
  }

  var rb = {
    DURATION: .5,
    EASE: [.32, .72, 0, 1]
  };

  function ob(e) {
    var t = S["default"].useRef(e);
    return S["default"].useEffect(function () {
      t.current = e;
    }), S["default"].useMemo(function () {
      return function () {
        var _n33;

        var n;

        for (var _len19 = arguments.length, e = new Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
          e[_key19] = arguments[_key19];
        }

        return null == (n = t.current) ? void 0 : (_n33 = n).call.apply(_n33, [t].concat(e));
      };
    }, []);
  }

  function ib(_ref52) {
    var e = _ref52.prop,
        t = _ref52.defaultProp,
        _ref52$onChange = _ref52.onChange,
        n = _ref52$onChange === void 0 ? function () {} : _ref52$onChange;

    var _ref53 = function (_ref55) {
      var e = _ref55.defaultProp,
          t = _ref55.onChange;

      var n = S["default"].useState(e),
          _n34 = _slicedToArray(n, 1),
          r = _n34[0],
          o = S["default"].useRef(r),
          i = ob(t);

      return S["default"].useEffect(function () {
        o.current !== r && (i(r), o.current = r);
      }, [r, o, i]), n;
    }({
      defaultProp: t,
      onChange: n
    }),
        _ref54 = _slicedToArray(_ref53, 2),
        r = _ref54[0],
        o = _ref54[1],
        i = void 0 !== e,
        a = i ? e : r,
        s = ob(n),
        l = S["default"].useCallback(function (t) {
      if (i) {
        var _n35 = "function" == typeof t ? t(e) : t;

        _n35 !== e && s(_n35);
      } else o(t);
    }, [i, e, o, s]);

    return [a, l];
  }

  var ab = 16,
      sb = "vaul-dragging";

  function lb(_ref56) {
    var e = _ref56.open,
        t = _ref56.onOpenChange,
        n = _ref56.children,
        r = _ref56.shouldScaleBackground,
        o = _ref56.onDrag,
        i = _ref56.onRelease,
        a = _ref56.snapPoints,
        _ref56$nested = _ref56.nested,
        s = _ref56$nested === void 0 ? !1 : _ref56$nested,
        _ref56$closeThreshold = _ref56.closeThreshold,
        l = _ref56$closeThreshold === void 0 ? .25 : _ref56$closeThreshold,
        _ref56$scrollLockTime = _ref56.scrollLockTimeout,
        c = _ref56$scrollLockTime === void 0 ? 100 : _ref56$scrollLockTime,
        _ref56$dismissible = _ref56.dismissible,
        u = _ref56$dismissible === void 0 ? !0 : _ref56$dismissible,
        _ref56$fadeFromIndex = _ref56.fadeFromIndex,
        d = _ref56$fadeFromIndex === void 0 ? a && a.length - 1 : _ref56$fadeFromIndex,
        f = _ref56.activeSnapPoint,
        p = _ref56.setActiveSnapPoint,
        h = _ref56.fixed,
        _ref56$modal = _ref56.modal,
        m = _ref56$modal === void 0 ? !0 : _ref56$modal,
        g = _ref56.onClose,
        _ref56$direction = _ref56.direction,
        y = _ref56$direction === void 0 ? "bottom" : _ref56$direction,
        _ref56$preventScrollR = _ref56.preventScrollRestoration,
        b = _ref56$preventScrollR === void 0 ? !0 : _ref56$preventScrollR;
    var v;

    var _S$default$useState = S["default"].useState(!1),
        _S$default$useState2 = _slicedToArray(_S$default$useState, 2),
        _S$default$useState2$ = _S$default$useState2[0],
        x = _S$default$useState2$ === void 0 ? !1 : _S$default$useState2$,
        w = _S$default$useState2[1],
        _S$default$useState3 = S["default"].useState(!1),
        _S$default$useState4 = _slicedToArray(_S$default$useState3, 2),
        k = _S$default$useState4[0],
        C = _S$default$useState4[1],
        _S$default$useState5 = S["default"].useState(!1),
        _S$default$useState6 = _slicedToArray(_S$default$useState5, 2),
        M = _S$default$useState6[0],
        j = _S$default$useState6[1],
        _S$default$useState7 = S["default"].useState(!1),
        _S$default$useState8 = _slicedToArray(_S$default$useState7, 2),
        E = _S$default$useState8[0],
        _ = _S$default$useState8[1],
        _S$default$useState9 = S["default"].useState(!1),
        _S$default$useState10 = _slicedToArray(_S$default$useState9, 2),
        T = _S$default$useState10[0],
        L = _S$default$useState10[1],
        _S$default$useState11 = S["default"].useState(!1),
        _S$default$useState12 = _slicedToArray(_S$default$useState11, 2),
        D = _S$default$useState12[0],
        A = _S$default$useState12[1],
        N = S["default"].useRef(null),
        I = S["default"].useRef(null),
        z = S["default"].useRef(null),
        O = S["default"].useRef(null),
        R = S["default"].useRef(null),
        P = S["default"].useRef(!1),
        F = S["default"].useRef(null),
        B = S["default"].useRef(0),
        q = S["default"].useRef(!1),
        U = S["default"].useRef(0),
        V = S["default"].useRef(null),
        H = S["default"].useRef((null == (v = V.current) ? void 0 : v.getBoundingClientRect().height) || 0),
        Z = S["default"].useRef(0),
        W = S["default"].useCallback(function (e) {
      a && e === X.length - 1 && (I.current = new Date());
    }, []),
        _ref57 = function (_ref58) {
      var e = _ref58.activeSnapPointProp,
          t = _ref58.setActiveSnapPointProp,
          n = _ref58.snapPoints,
          r = _ref58.drawerRef,
          o = _ref58.overlayRef,
          i = _ref58.fadeFromIndex,
          a = _ref58.onSnapPointChange,
          _ref58$direction = _ref58.direction,
          s = _ref58$direction === void 0 ? "bottom" : _ref58$direction;

      var _ib = ib({
        prop: e,
        defaultProp: null == n ? void 0 : n[0],
        onChange: t
      }),
          _ib2 = _slicedToArray(_ib, 2),
          l = _ib2[0],
          c = _ib2[1],
          u = S["default"].useMemo(function () {
        return l === (null == n ? void 0 : n[n.length - 1]) || null;
      }, [n, l]),
          d = n && n.length > 0 && (i || 0 === i) && !Number.isNaN(i) && n[i] === l || !n,
          f = S["default"].useMemo(function () {
        return null == n ? void 0 : n.findIndex(function (e) {
          return e === l;
        });
      }, [n, l]),
          p = S["default"].useMemo(function () {
        var e;
        return null != (e = null == n ? void 0 : n.map(function (e) {
          var t = "undefined" != typeof window,
              n = "string" == typeof e,
              r = 0;

          if (n && (r = parseInt(e, 10)), tb(s)) {
            var _o11 = n ? r : t ? e * window.innerHeight : 0;

            return t ? "bottom" === s ? window.innerHeight - _o11 : -window.innerHeight + _o11 : _o11;
          }

          var o = n ? r : t ? e * window.innerWidth : 0;
          return t ? "right" === s ? window.innerWidth - o : -window.innerWidth + o : o;
        })) ? e : [];
      }, [n]),
          h = S["default"].useMemo(function () {
        return null !== f ? null == p ? void 0 : p[f] : null;
      }, [p, f]),
          m = S["default"].useCallback(function (e) {
        var t;
        var l = null != (t = null == p ? void 0 : p.findIndex(function (t) {
          return t === e;
        })) ? t : null;
        a(l), Jy(r.current, {
          transition: "transform ".concat(rb.DURATION, "s cubic-bezier(").concat(rb.EASE.join(","), ")"),
          transform: tb(s) ? "translate3d(0, ".concat(e, "px, 0)") : "translate3d(".concat(e, "px, 0, 0)")
        }), p && l !== p.length - 1 && l !== i ? Jy(o.current, {
          transition: "opacity ".concat(rb.DURATION, "s cubic-bezier(").concat(rb.EASE.join(","), ")"),
          opacity: "0"
        }) : Jy(o.current, {
          transition: "opacity ".concat(rb.DURATION, "s cubic-bezier(").concat(rb.EASE.join(","), ")"),
          opacity: "1"
        }), c(null !== l ? null == n ? void 0 : n[l] : null);
      }, [r.current, n, p, i, o, c]);

      return S["default"].useEffect(function () {
        var t;

        if (e) {
          var _r21 = null != (t = null == n ? void 0 : n.findIndex(function (t) {
            return t === e;
          })) ? t : -1;

          p && -1 !== _r21 && "number" == typeof p[_r21] && m(p[_r21]);
        }
      }, [e, n, p, m]), {
        isLastSnapPoint: u,
        activeSnapPoint: l,
        shouldFade: d,
        getPercentageDragged: function getPercentageDragged(e, t) {
          if (!n || "number" != typeof f || !p || void 0 === i) return null;
          var r = f === i - 1;
          if (f >= i && t) return 0;
          if (r && !t) return 1;
          if (!d && !r) return null;
          var o = r ? f + 1 : f - 1,
              a = r ? p[o] - p[o - 1] : p[o + 1] - p[o],
              s = e / Math.abs(a);
          return r ? 1 - s : s;
        },
        setActiveSnapPoint: c,
        activeSnapPointIndex: f,
        onRelease: function onRelease(_ref59) {
          var e = _ref59.draggedDistance,
              t = _ref59.closeDrawer,
              r = _ref59.velocity,
              a = _ref59.dismissible;
          if (void 0 === i) return;
          var l = "bottom" === s || "right" === s ? (null != h ? h : 0) - e : (null != h ? h : 0) + e,
              c = 0 === f,
              d = e > 0;
          if (f === i - 1 && Jy(o.current, {
            transition: "opacity ".concat(rb.DURATION, "s cubic-bezier(").concat(rb.EASE.join(","), ")")
          }), r > 2 && !d) return void (a ? t() : m(p[0]));
          if (r > 2 && d && p && n) return void m(p[n.length - 1]);
          var g = null == p ? void 0 : p.reduce(function (e, t) {
            return "number" != typeof e || "number" != typeof t ? e : Math.abs(t - l) < Math.abs(e - l) ? t : e;
          }),
              y = tb(s) ? window.innerHeight : window.innerWidth;

          if (r > .4 && Math.abs(e) < .4 * y) {
            var _e27 = d ? 1 : -1;

            if (_e27 > 0 && u) return void m(p[n.length - 1]);
            if (c && _e27 < 0 && a && t(), null === f) return;
            m(p[f + _e27]);
          } else m(g);
        },
        onDrag: function onDrag(_ref60) {
          var e = _ref60.draggedDistance;
          if (null === h) return;
          var t = "bottom" === s || "right" === s ? h - e : h + e;
          ("bottom" === s || "right" === s) && t < p[p.length - 1] || ("top" === s || "left" === s) && t > p[p.length - 1] || Jy(r.current, {
            transform: tb(s) ? "translate3d(0, ".concat(t, "px, 0)") : "translate3d(".concat(t, "px, 0, 0)")
          });
        },
        snapPointsOffset: p
      };
    }({
      snapPoints: a,
      activeSnapPointProp: f,
      setActiveSnapPointProp: p,
      drawerRef: V,
      fadeFromIndex: d,
      overlayRef: N,
      onSnapPointChange: W,
      direction: y
    }),
        $ = _ref57.activeSnapPoint,
        G = _ref57.activeSnapPointIndex,
        Y = _ref57.setActiveSnapPoint,
        Q = _ref57.onRelease,
        X = _ref57.snapPointsOffset,
        K = _ref57.onDrag,
        J = _ref57.shouldFade,
        ee = _ref57.getPercentageDragged;

    Zy({
      isDisabled: !x || T || !m || D || !k
    });

    var _ref61 = function (_ref62) {
      var e = _ref62.isOpen,
          t = _ref62.modal,
          n = _ref62.nested,
          r = _ref62.hasBeenOpened,
          o = _ref62.preventScrollRestoration;

      var _S$default$useState13 = S["default"].useState("undefined" != typeof window ? window.location.href : ""),
          _S$default$useState14 = _slicedToArray(_S$default$useState13, 2),
          i = _S$default$useState14[0],
          a = _S$default$useState14[1],
          s = S["default"].useRef(0),
          l = S["default"].useCallback(function () {
        if (null === Xy && e) {
          Xy = {
            position: document.body.style.position,
            top: document.body.style.top,
            left: document.body.style.left,
            height: document.body.style.height
          };
          var _window = window,
              _e28 = _window.scrollX,
              _t21 = _window.innerHeight;
          document.body.style.setProperty("position", "fixed", "important"), document.body.style.top = -s.current + "px", document.body.style.left = -_e28 + "px", document.body.style.right = "0px", document.body.style.height = "auto", setTimeout(function () {
            return requestAnimationFrame(function () {
              var e = _t21 - window.innerHeight;
              e && s.current >= _t21 && (document.body.style.top = -(s.current + e) + "px");
            });
          }, 300);
        }
      }, [e]),
          c = S["default"].useCallback(function () {
        if (null !== Xy) {
          var _e29 = -parseInt(document.body.style.top, 10),
              _t22 = -parseInt(document.body.style.left, 10);

          document.body.style.position = Xy.position, document.body.style.top = Xy.top, document.body.style.left = Xy.left, document.body.style.height = Xy.height, document.body.style.right = "unset", requestAnimationFrame(function () {
            o && i !== window.location.href ? a(window.location.href) : window.scrollTo(_t22, _e29);
          }), Xy = null;
        }
      }, [i]);

      return S["default"].useEffect(function () {
        function e() {
          s.current = window.scrollY;
        }

        return e(), window.addEventListener("scroll", e), function () {
          window.removeEventListener("scroll", e);
        };
      }, []), S["default"].useEffect(function () {
        n || !r || (e ? (l(), t || setTimeout(function () {
          c();
        }, 500)) : c());
      }, [e, r, i, t, n, l, c]), {
        restorePositionSetting: c
      };
    }({
      isOpen: x,
      modal: m,
      nested: s,
      hasBeenOpened: k,
      preventScrollRestoration: b
    }),
        te = _ref61.restorePositionSetting;

    function ne() {
      return (window.innerWidth - 26) / window.innerWidth;
    }

    function re(e, t) {
      var n;
      var r = e,
          o = null == (n = window.getSelection()) ? void 0 : n.toString(),
          i = V.current ? nb(V.current, y) : null,
          a = new Date();
      if (r.hasAttribute("data-vaul-no-drag")) return !1;
      if ("right" === y || "left" === y) return !0;
      if (I.current && a.getTime() - I.current.getTime() < 500) return !1;
      if (null !== i && ("bottom" === y ? i > 0 : i < 0)) return !0;
      if (o && o.length > 0) return !1;
      if (R.current && a.getTime() - R.current.getTime() < c && 0 === i || t) return R.current = a, !1;

      for (; r;) {
        if (r.scrollHeight > r.clientHeight) {
          if (0 !== r.scrollTop) return R.current = new Date(), !1;
          if ("dialog" === r.getAttribute("role")) return !0;
        }

        r = r.parentNode;
      }

      return !0;
    }

    function oe() {
      V.current && (null == g || g(), Jy(V.current, {
        transform: tb(y) ? "translate3d(0, ".concat("bottom" === y ? "100%" : "-100%", ", 0)") : "translate3d(".concat("right" === y ? "100%" : "-100%", ", 0, 0)"),
        transition: "transform ".concat(rb.DURATION, "s cubic-bezier(").concat(rb.EASE.join(","), ")")
      }), Jy(N.current, {
        opacity: "0",
        transition: "opacity ".concat(rb.DURATION, "s cubic-bezier(").concat(rb.EASE.join(","), ")")
      }), ae(!1), setTimeout(function () {
        j(!1), w(!1);
      }, 300), setTimeout(function () {
        a && Y(a[0]);
      }, 1e3 * rb.DURATION));
    }

    function ie() {
      if (!V.current) return;
      var e = document.querySelector("[vaul-drawer-wrapper]"),
          t = nb(V.current, y);
      Jy(V.current, {
        transform: "translate3d(0, 0, 0)",
        transition: "transform ".concat(rb.DURATION, "s cubic-bezier(").concat(rb.EASE.join(","), ")")
      }), Jy(N.current, {
        transition: "opacity ".concat(rb.DURATION, "s cubic-bezier(").concat(rb.EASE.join(","), ")"),
        opacity: "1"
      }), r && t && t > 0 && x && Jy(e, _objectSpread(_objectSpread({
        borderRadius: "8px",
        overflow: "hidden"
      }, tb(y) ? {
        transform: "scale(".concat(ne(), ") translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)"),
        transformOrigin: "top"
      } : {
        transform: "scale(".concat(ne(), ") translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)"),
        transformOrigin: "left"
      }), {}, {
        transitionProperty: "transform, border-radius",
        transitionDuration: "".concat(rb.DURATION, "s"),
        transitionTimingFunction: "cubic-bezier(".concat(rb.EASE.join(","), ")")
      }), !0);
    }

    function ae(e) {
      var t = document.querySelector("[vaul-drawer-wrapper]");
      !t || !r || (e ? (Jy(document.body, {
        background: document.body.style.backgroundColor || document.body.style.background
      }), Jy(document.body, {
        background: "black"
      }, !0), Jy(t, _objectSpread(_objectSpread({
        borderRadius: "8px",
        overflow: "hidden"
      }, tb(y) ? {
        transform: "scale(".concat(ne(), ") translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)"),
        transformOrigin: "top"
      } : {
        transform: "scale(".concat(ne(), ") translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)"),
        transformOrigin: "left"
      }), {}, {
        transitionProperty: "transform, border-radius",
        transitionDuration: "".concat(rb.DURATION, "s"),
        transitionTimingFunction: "cubic-bezier(".concat(rb.EASE.join(","), ")")
      }))) : (eb(t, "overflow"), eb(t, "transform"), eb(t, "borderRadius"), Jy(t, {
        transitionProperty: "transform, border-radius",
        transitionDuration: "".concat(rb.DURATION, "s"),
        transitionTimingFunction: "cubic-bezier(".concat(rb.EASE.join(","), ")")
      })));
    }

    return S["default"].useEffect(function () {
      return function () {
        ae(!1), te();
      };
    }, []), S["default"].useEffect(function () {
      var e;

      function t() {
        var e;
        if (!V.current) return;

        if (Yy(document.activeElement) || q.current) {
          var _t23 = (null == (e = window.visualViewport) ? void 0 : e.height) || 0,
              _n36 = window.innerHeight - _t23,
              _r22 = V.current.getBoundingClientRect().height || 0;

          Z.current || (Z.current = _r22);
          var _o12 = V.current.getBoundingClientRect().top;

          if (Math.abs(U.current - _n36) > 60 && (q.current = !q.current), a && a.length > 0 && X && G) {
            _n36 += X[G] || 0;
          }

          if (U.current = _n36, _r22 > _t23 || q.current) {
            var _e30 = V.current.getBoundingClientRect().height,
                _r23 = _e30;
            _e30 > _t23 && (_r23 = _t23 - 26), V.current.style.height = h ? _e30 - Math.max(_n36, 0) + "px" : "".concat(Math.max(_r23, _t23 - _o12), "px");
          } else V.current.style.height = "".concat(Z.current, "px");

          a && a.length > 0 && !q.current ? V.current.style.bottom = "0px" : V.current.style.bottom = "".concat(Math.max(_n36, 0), "px");
        }
      }

      return null == (e = window.visualViewport) || e.addEventListener("resize", t), function () {
        var e;
        return null == (e = window.visualViewport) ? void 0 : e.removeEventListener("resize", t);
      };
    }, [G, a, X]), S["default"].useEffect(function () {
      if (!x && r) {
        var _e31 = setTimeout(function () {
          eb(document.body);
        }, 200);

        return function () {
          return clearTimeout(_e31);
        };
      }
    }, [x, r]), S["default"].useEffect(function () {
      e ? (w(!0), C(!0)) : oe();
    }, [e]), S["default"].useEffect(function () {
      E && (null == t || t(x));
    }, [x]), S["default"].useEffect(function () {
      _(!0);
    }, []), S["default"].useEffect(function () {
      x && (Jy(document.documentElement, {
        scrollBehavior: "auto"
      }), I.current = new Date(), ae(!0));
    }, [x]), S["default"].useEffect(function () {
      var e;

      if (V.current && M) {
        var _t24 = null == (e = null == V ? void 0 : V.current) ? void 0 : e.querySelectorAll("*");

        null == _t24 || _t24.forEach(function (e) {
          var t = e;
          (t.scrollHeight > t.clientHeight || t.scrollWidth > t.clientWidth) && t.classList.add("vaul-scrollable");
        });
      }
    }, [M]), S["default"].createElement(yy, {
      modal: m,
      onOpenChange: function onOpenChange(n) {
        void 0 === e ? n ? (C(!0), w(n)) : oe() : null == t || t(n);
      },
      open: x
    }, S["default"].createElement(Ay.Provider, {
      value: {
        visible: M,
        activeSnapPoint: $,
        snapPoints: a,
        setActiveSnapPoint: Y,
        drawerRef: V,
        overlayRef: N,
        scaleBackground: ae,
        onOpenChange: t,
        onPress: function onPress(e) {
          var t;
          !u && !a || V.current && !V.current.contains(e.target) || (H.current = (null == (t = V.current) ? void 0 : t.getBoundingClientRect().height) || 0, L(!0), z.current = new Date(), Ry() && window.addEventListener("touchend", function () {
            return P.current = !1;
          }, {
            once: !0
          }), e.target.setPointerCapture(e.pointerId), B.current = tb(y) ? e.screenY : e.screenX);
        },
        setVisible: j,
        onRelease: function onRelease(e) {
          var t;
          if (!T || !V.current) return;
          V.current.classList.remove(sb), P.current = !1, L(!1), O.current = new Date();
          var n = nb(V.current, y);
          if (!re(e.target, !1) || !n || Number.isNaN(n) || null === z.current) return;
          var r = O.current.getTime() - z.current.getTime(),
              o = B.current - (tb(y) ? e.screenY : e.screenX),
              s = Math.abs(o) / r;
          return s > .05 && (A(!0), setTimeout(function () {
            A(!1);
          }, 200)), a ? (Q({
            draggedDistance: o * ("bottom" === y || "right" === y ? 1 : -1),
            closeDrawer: oe,
            velocity: s,
            dismissible: u
          }), void (null == i || i(e, !0))) : ("bottom" === y || "right" === y ? o > 0 : o < 0) ? (ie(), void (null == i || i(e, !0))) : s > .4 || n >= Math.min(null != (t = V.current.getBoundingClientRect().height) ? t : 0, window.innerHeight) * l ? (oe(), void (null == i || i(e, !1))) : (null == i || i(e, !0), void ie());
        },
        onDrag: function onDrag(e) {
          if (V.current && T) {
            var _t25 = "bottom" === y || "right" === y ? 1 : -1,
                _n37 = (B.current - (tb(y) ? e.screenY : e.screenX)) * _t25,
                _i10 = _n37 > 0;

            if (a && 0 === G && !u || !P.current && !re(e.target, _i10)) return;

            if (V.current.classList.add(sb), P.current = !0, Jy(V.current, {
              transition: "none"
            }), Jy(N.current, {
              transition: "none"
            }), a && K({
              draggedDistance: _n37
            }), _i10 && !a) {
              var _e32 = function (e) {
                return 8 * (Math.log(e + 1) - 2);
              }(_n37),
                  _r24 = Math.min(-1 * _e32, 0) * _t25;

              return void Jy(V.current, {
                transform: tb(y) ? "translate3d(0, ".concat(_r24, "px, 0)") : "translate3d(".concat(_r24, "px, 0, 0)")
              });
            }

            var _s2 = Math.abs(_n37),
                _l2 = document.querySelector("[vaul-drawer-wrapper]"),
                _c2 = _s2 / H.current,
                _f2 = ee(_s2, _i10);

            null !== _f2 && (_c2 = _f2);

            var _p2 = 1 - _c2;

            if ((J || d && G === d - 1) && (null == o || o(e, _c2), Jy(N.current, {
              opacity: "".concat(_p2),
              transition: "none"
            }, !0)), _l2 && N.current && r) {
              var _e33 = Math.min(ne() + _c2 * (1 - ne()), 1),
                  _t26 = 8 - 8 * _c2,
                  _n38 = Math.max(0, 14 - 14 * _c2);

              Jy(_l2, {
                borderRadius: "".concat(_t26, "px"),
                transform: tb(y) ? "scale(".concat(_e33, ") translate3d(0, ").concat(_n38, "px, 0)") : "scale(".concat(_e33, ") translate3d(").concat(_n38, "px, 0, 0)"),
                transition: "none"
              }, !0);
            }

            if (!a) {
              var _e34 = _s2 * _t25;

              Jy(V.current, {
                transform: tb(y) ? "translate3d(0, ".concat(_e34, "px, 0)") : "translate3d(".concat(_e34, "px, 0, 0)")
              });
            }
          }
        },
        dismissible: u,
        isOpen: x,
        shouldFade: J,
        closeDrawer: oe,
        onNestedDrag: function onNestedDrag(e, t) {
          if (t < 0) return;
          var n = tb(y) ? window.innerHeight : window.innerWidth,
              r = (n - ab) / n,
              o = r + t * (1 - r),
              i = t * ab - ab;
          Jy(V.current, {
            transform: tb(y) ? "scale(".concat(o, ") translate3d(0, ").concat(i, "px, 0)") : "scale(".concat(o, ") translate3d(").concat(i, "px, 0, 0)"),
            transition: "none"
          });
        },
        onNestedOpenChange: function onNestedOpenChange(e) {
          var t = e ? (window.innerWidth - ab) / window.innerWidth : 1,
              n = e ? -ab : 0;
          F.current && window.clearTimeout(F.current), Jy(V.current, {
            transition: "transform ".concat(rb.DURATION, "s cubic-bezier(").concat(rb.EASE.join(","), ")"),
            transform: "scale(".concat(t, ") translate3d(0, ").concat(n, "px, 0)")
          }), !e && V.current && (F.current = setTimeout(function () {
            var e = nb(V.current, y);
            Jy(V.current, {
              transition: "none",
              transform: tb(y) ? "translate3d(0, ".concat(e, "px, 0)") : "translate3d(".concat(e, "px, 0, 0)")
            });
          }, 500));
        },
        onNestedRelease: function onNestedRelease(e, t) {
          var n = tb(y) ? window.innerHeight : window.innerWidth,
              r = t ? (n - ab) / n : 1,
              o = t ? -ab : 0;
          t && Jy(V.current, {
            transition: "transform ".concat(rb.DURATION, "s cubic-bezier(").concat(rb.EASE.join(","), ")"),
            transform: tb(y) ? "scale(".concat(r, ") translate3d(0, ").concat(o, "px, 0)") : "scale(".concat(r, ") translate3d(").concat(o, "px, 0, 0)")
          });
        },
        keyboardIsOpen: q,
        openProp: e,
        modal: m,
        snapPointsOffset: X,
        direction: y
      }
    }, n));
  }

  var cb = S["default"].forwardRef(function (_ref63, n) {
    var e = _ref63.children,
        t = _objectWithoutProperties(_ref63, _excluded86);

    var _Ny = Ny(),
        r = _Ny.overlayRef,
        o = _Ny.snapPoints,
        i = _Ny.onRelease,
        a = _Ny.shouldFade,
        s = _Ny.isOpen,
        l = _Ny.visible,
        c = Qy(n, r),
        u = o && o.length > 0;

    return S["default"].createElement(xy, _objectSpread({
      onMouseUp: i,
      ref: c,
      "vaul-drawer-visible": l ? "true" : "false",
      "vaul-overlay": "",
      "vaul-snap-points": s && u ? "true" : "false",
      "vaul-snap-points-overlay": s && a ? "true" : "false"
    }, t));
  });
  cb.displayName = "Drawer.Overlay";
  var ub = S["default"].forwardRef(function (_ref64, i) {
    var e = _ref64.onOpenAutoFocus,
        t = _ref64.onPointerDownOutside,
        n = _ref64.onAnimationEnd,
        r = _ref64.style,
        o = _objectWithoutProperties(_ref64, _excluded87);

    var _Ny2 = Ny(),
        a = _Ny2.drawerRef,
        s = _Ny2.onPress,
        l = _Ny2.onRelease,
        c = _Ny2.onDrag,
        u = _Ny2.dismissible,
        d = _Ny2.keyboardIsOpen,
        f = _Ny2.snapPointsOffset,
        p = _Ny2.visible,
        h = _Ny2.closeDrawer,
        m = _Ny2.modal,
        g = _Ny2.openProp,
        y = _Ny2.onOpenChange,
        b = _Ny2.setVisible,
        v = _Ny2.direction,
        x = Qy(i, a);

    return S["default"].useEffect(function () {
      b(!0);
    }, []), S["default"].createElement(wy, _objectSpread(_objectSpread({
      onOpenAutoFocus: function onOpenAutoFocus(t) {
        var n;
        e ? e(t) : (t.preventDefault(), null == (n = a.current) || n.focus());
      },
      onPointerDown: s,
      onPointerDownOutside: function onPointerDownOutside(e) {
        null == t || t(e), m && !e.defaultPrevented ? (d.current && (d.current = !1), e.preventDefault(), null == y || y(!1), u && void 0 === g && h()) : e.preventDefault();
      },
      onPointerMove: c,
      onPointerUp: l,
      ref: x,
      style: f && f.length > 0 ? _objectSpread({
        "--snap-point-height": "".concat(f[0], "px")
      }, r) : r
    }, o), {}, {
      "vaul-drawer": "",
      "vaul-drawer-direction": v,
      "vaul-drawer-visible": p ? "true" : "false"
    }));
  });
  ub.displayName = "Drawer.Content";
  var db = {
    Root: lb,
    NestedRoot: function NestedRoot(_ref65) {
      var e = _ref65.onDrag,
          t = _ref65.onOpenChange,
          n = _objectWithoutProperties(_ref65, _excluded88);

      var _Ny3 = Ny(),
          r = _Ny3.onNestedDrag,
          o = _Ny3.onNestedOpenChange,
          i = _Ny3.onNestedRelease;

      if (!r) throw new Error("Drawer.NestedRoot must be placed in another drawer");
      return S["default"].createElement(lb, _objectSpread({
        nested: !0,
        onClose: function onClose() {
          o(!1);
        },
        onDrag: function onDrag(t, n) {
          r(t, n), null == e || e(t, n);
        },
        onOpenChange: function onOpenChange(e) {
          e && o(e), null == t || t(e);
        },
        onRelease: i
      }, n));
    },
    Content: ub,
    Overlay: cb,
    Trigger: by,
    Portal: vy,
    Close: My,
    Title: ky,
    Description: Cy
  };

  var fb = t.css(["", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], n.border, n.bottom, n.color, n.layout, n.left, n.position, n.right, n.shadow, n.space, n.top, n.typography, n.verticalAlign, n.zIndex, n.flexbox),
      pb = _["default"](db.Root).withConfig({
    displayName: "Drawer__StyledRoot",
    componentId: "sc-1npczsm-0"
  })(["&:focus-visible,&:focus{outline:none;}"]),
      hb = o.forwardRef(function (e, t) {
    var n = e.shouldScaleBackground,
        r = _objectWithoutProperties(e, _excluded89);

    return s.jsx(pb, _objectSpread({
      ref: t,
      shouldScaleBackground: n
    }, r));
  });

  hb.defaultProps = {
    shouldScaleBackground: !0
  }, hb.propTypes = {
    children: T["default"].node.isRequired,
    shouldScaleBackground: T["default"].bool
  }, hb.displayName = "Drawer";

  var mb = db.Trigger,
      gb = db.Portal,
      yb = db.Close,
      bb = _["default"](db.Overlay).withConfig({
    displayName: "Drawer__DrawerOverlay",
    componentId: "sc-1npczsm-1"
  })(["background:rgba(0,0,0,0.5);position:fixed;inset:0;z-index:", ";", ""], function (e) {
    return e.$zIndex || 6;
  }, fb),
      vb = _["default"](db.Content).withConfig({
    shouldForwardProp: se
  }).withConfig({
    displayName: "Drawer__StyledContent",
    componentId: "sc-1npczsm-2"
  })(["position:fixed;display:flex;height:auto;box-shadow:", ";background:", ";z-index:", ";&:focus-visible,&:focus{outline:none;}", ""], function (e) {
    return e.boxShadow || e.theme.shadows[3];
  }, function (e) {
    return e.bg || e.background || e.theme.colors.white;
  }, function (e) {
    return e.zIndex || 6;
  }, fb),
      xb = o.forwardRef(function (e, t) {
    var n = e.children,
        r = e.direction,
        o = _objectWithoutProperties(e, _excluded90);

    var _ref66 = function (e) {
      return "left" === e ? {
        maxWidth: "95%",
        left: 0,
        bottom: 0,
        top: 0,
        borderTopRightRadius: "medium",
        borderBottomRightRadius: "medium",
        flexDirection: "row-reverse",
        dragIndicator: {
          my: "auto",
          mr: 3,
          ml: 2,
          width: "0.5rem",
          height: "100px"
        }
      } : "right" === e ? {
        maxWidth: "95%",
        right: 0,
        bottom: 0,
        top: 0,
        borderTopLeftRadius: "medium",
        borderBottomLeftRadius: "medium",
        flexDirection: "row",
        dragIndicator: {
          my: "auto",
          ml: 3,
          mr: 2,
          width: "0.5rem",
          height: "100px"
        }
      } : "bottom" === e ? {
        maxHeight: "95%",
        left: 0,
        bottom: 0,
        right: 0,
        borderTopLeftRadius: "medium",
        borderTopRightRadius: "medium",
        flexDirection: "column",
        dragIndicator: {
          mx: "auto",
          mt: 3,
          mb: 2,
          height: "0.5rem",
          width: "100px"
        }
      } : "top" === e ? {
        maxHeight: "95%",
        left: 0,
        top: 0,
        right: 0,
        borderBottomLeftRadius: "medium",
        borderBottomRightRadius: "medium",
        flexDirection: "column-reverse",
        dragIndicator: {
          mx: "auto",
          mb: 3,
          mt: 2,
          height: "0.5rem",
          width: "100px"
        }
      } : void 0;
    }(r),
        i = _ref66.dragIndicator,
        a = _objectWithoutProperties(_ref66, _excluded91);

    return s.jsxs(gb, {
      children: [s.jsx(bb, {}), s.jsxs(vb, _objectSpread(_objectSpread(_objectSpread({
        className: "DrawerContent",
        direction: r,
        ref: t
      }, a), o), {}, {
        children: [s.jsx(fe, _objectSpread({
          borderRadius: "9999px",
          bg: "gray700",
          cursor: "grab"
        }, i)), n]
      }))]
    });
  });

  xb.defaultProps = {
    direction: "bottom"
  }, xb.propTypes = {
    children: T["default"].node.isRequired,
    direction: T["default"].oneOf(["bottom", "left", "right", "top"])
  };

  var wb = _["default"](fe).attrs({
    display: "grid",
    padding: 3,
    textAlign: ["left", null, "center"]
  }).withConfig({
    displayName: "Drawer__DrawerHeader",
    componentId: "sc-1npczsm-3"
  })(["gap:0.375rem;"]);

  wb.displayName = "DrawerHeader";

  var kb = _["default"](fe).attrs({
    display: "flex",
    flexDirection: "column",
    padding: 3,
    mt: "auto"
  }).withConfig({
    displayName: "Drawer__DrawerFooter",
    componentId: "sc-1npczsm-4"
  })(["gap:0.375rem;"]);

  kb.displayName = "DrawerFooter";

  var Cb = _["default"](db.Title).withConfig({
    displayName: "Drawer__StyledTitle",
    componentId: "sc-1npczsm-5"
  })(["font-size:", ";font-weight:600;line-height:1;"], function (e) {
    return e.theme.fontSizes[3];
  }),
      Mb = o.forwardRef(function (e, t) {
    return s.jsx(Cb, _objectSpread({
      ref: t
    }, e));
  });

  Mb.displayName = db.Title.displayName;

  var jb = _["default"](db.Description).withConfig({
    displayName: "Drawer__StyledDescription",
    componentId: "sc-1npczsm-6"
  })(["font-size:", ";background:", ";"], function (e) {
    return e.theme.fontSizes[0];
  }, function (e) {
    return e.bg || e.background || e.theme.colors.black;
  }),
      Eb = o.forwardRef(function (e, t) {
    return s.jsx(jb, _objectSpread({
      ref: t
    }, e));
  });

  Eb.displayName = db.Description.displayName;
  var _b = {
    Root: hb,
    Trigger: mb,
    Portal: gb,
    Overlay: bb,
    Content: xb,
    Close: yb,
    ContentPrimitive: db.Content,
    DrawerHeader: wb,
    DrawerFooter: kb,
    DrawerTitle: Mb,
    DrawerDescription: Eb
  };

  var Tb = Boolean(null === globalThis || void 0 === globalThis ? void 0 : globalThis.document) ? L.useLayoutEffect : function () {},
      Sb = L["useId".toString()] || function () {};

  var Lb = 0;

  function Db(e) {
    var _L$useState7 = L.useState(Sb()),
        _L$useState8 = _slicedToArray(_L$useState7, 2),
        t = _L$useState8[0],
        n = _L$useState8[1];

    return Tb(function () {
      e || n(function (e) {
        return null != e ? e : String(Lb++);
      });
    }, [e]), e || (t ? "radix-".concat(t) : "");
  }

  var Ab = 0;

  function Nb() {
    L.useEffect(function () {
      var e, t;
      var n = document.querySelectorAll("[data-radix-focus-guard]");
      return document.body.insertAdjacentElement("afterbegin", null !== (e = n[0]) && void 0 !== e ? e : Ib()), document.body.insertAdjacentElement("beforeend", null !== (t = n[1]) && void 0 !== t ? t : Ib()), Ab++, function () {
        1 === Ab && document.querySelectorAll("[data-radix-focus-guard]").forEach(function (e) {
          return e.remove();
        }), Ab--;
      };
    }, []);
  }

  function Ib() {
    var e = document.createElement("span");
    return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
  }

  function zb(e) {
    var t = L.useRef(e);
    return L.useEffect(function () {
      t.current = e;
    }), L.useMemo(function () {
      return function () {
        var _n39;

        var n;

        for (var _len20 = arguments.length, e = new Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
          e[_key20] = arguments[_key20];
        }

        return null === (n = t.current) || void 0 === n ? void 0 : (_n39 = n).call.apply(_n39, [t].concat(e));
      };
    }, []);
  }

  function Ob(_ref67) {
    var e = _ref67.prop,
        t = _ref67.defaultProp,
        _ref67$onChange = _ref67.onChange,
        n = _ref67$onChange === void 0 ? function () {} : _ref67$onChange;

    var _ref68 = function (_ref70) {
      var e = _ref70.defaultProp,
          t = _ref70.onChange;

      var n = L.useState(e),
          _n40 = _slicedToArray(n, 1),
          r = _n40[0],
          o = L.useRef(r),
          i = zb(t);

      return L.useEffect(function () {
        o.current !== r && (i(r), o.current = r);
      }, [r, o, i]), n;
    }({
      defaultProp: t,
      onChange: n
    }),
        _ref69 = _slicedToArray(_ref68, 2),
        r = _ref69[0],
        o = _ref69[1],
        i = void 0 !== e,
        a = i ? e : r,
        s = zb(n);

    return [a, L.useCallback(function (t) {
      if (i) {
        var _n41 = t,
            _r25 = "function" == typeof t ? _n41(e) : t;

        _r25 !== e && s(_r25);
      } else o(t);
    }, [i, e, o, s])];
  }

  function Rb() {
    for (var _len21 = arguments.length, e = new Array(_len21), _key21 = 0; _key21 < _len21; _key21++) {
      e[_key21] = arguments[_key21];
    }

    return function (t) {
      return e.forEach(function (e) {
        return function (e, t) {
          "function" == typeof e ? e(t) : null != e && (e.current = t);
        }(e, t);
      });
    };
  }

  function Pb() {
    for (var _len22 = arguments.length, e = new Array(_len22), _key22 = 0; _key22 < _len22; _key22++) {
      e[_key22] = arguments[_key22];
    }

    return L.useCallback(Rb.apply(void 0, e), e);
  }

  var Fb = L.forwardRef(function (e, t) {
    var n = e.children,
        r = _objectWithoutProperties(e, _excluded92);

    return L.Children.toArray(n).some(Ub) ? L.createElement(L.Fragment, null, L.Children.map(n, function (e) {
      return Ub(e) ? L.createElement(Bb, Fd({}, r, {
        ref: t
      }), e.props.children) : e;
    })) : L.createElement(Bb, Fd({}, r, {
      ref: t
    }), n);
  });
  Fb.displayName = "Slot";
  var Bb = L.forwardRef(function (e, t) {
    var n = e.children,
        r = _objectWithoutProperties(e, _excluded93);

    return L.isValidElement(n) ? L.cloneElement(n, _objectSpread(_objectSpread({}, Vb(r, n.props)), {}, {
      ref: Rb(t, n.ref)
    })) : L.Children.count(n) > 1 ? L.Children.only(null) : null;
  });
  Bb.displayName = "SlotClone";

  var qb = function qb(_ref71) {
    var e = _ref71.children;
    return L.createElement(L.Fragment, null, e);
  };

  function Ub(e) {
    return L.isValidElement(e) && e.type === qb;
  }

  function Vb(e, t) {
    var n = _objectSpread({}, t);

    var _loop4 = function _loop4(_r26) {
      var o = e[_r26],
          i = t[_r26];
      /^on[A-Z]/.test(_r26) ? n[_r26] = function () {
        null == i || i.apply(void 0, arguments), null == o || o.apply(void 0, arguments);
      } : "style" === _r26 ? n[_r26] = _objectSpread(_objectSpread({}, o), i) : "className" === _r26 && (n[_r26] = [o, i].filter(Boolean).join(" "));
    };

    for (var _r26 in t) {
      _loop4(_r26);
    }

    return _objectSpread(_objectSpread({}, e), n);
  }

  var Hb = ["a", "button", "div", "h2", "h3", "img", "li", "nav", "ol", "p", "span", "svg", "ul"].reduce(function (e, t) {
    return _objectSpread(_objectSpread({}, e), {}, _defineProperty({}, t, L.forwardRef(function (e, n) {
      var r = e.asChild,
          o = _objectWithoutProperties(e, _excluded94),
          i = r ? Fb : t;

      return L.useEffect(function () {
        window[Symbol["for"]("radix-ui")] = !0;
      }, []), L.createElement(i, Fd({}, o, {
        ref: n
      }));
    })));
  }, {});

  function Zb(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var n = [];

    var r = function r() {
      var t = n.map(function (e) {
        return L.createContext(e);
      });
      return function (n) {
        var r = (null == n ? void 0 : n[e]) || t;
        return L.useMemo(function () {
          return _defineProperty({}, "__scope".concat(e), _objectSpread(_objectSpread({}, n), {}, _defineProperty({}, e, r)));
        }, [n, r]);
      };
    };

    return r.scopeName = e, [function (t, r) {
      var o = L.createContext(r),
          i = n.length;

      function a(t) {
        var n = t.scope,
            r = t.children,
            a = _objectWithoutProperties(t, _excluded95),
            s = (null == n ? void 0 : n[e][i]) || o,
            l = L.useMemo(function () {
          return a;
        }, Object.values(a));

        return L.createElement(s.Provider, {
          value: l
        }, r);
      }

      return n = [].concat(_toConsumableArray(n), [r]), a.displayName = t + "Provider", [a, function (n, a) {
        var s = (null == a ? void 0 : a[e][i]) || o,
            l = L.useContext(s);
        if (l) return l;
        if (void 0 !== r) return r;
        throw new Error("`".concat(n, "` must be used within `").concat(t, "`"));
      }];
    }, Wb.apply(void 0, [r].concat(_toConsumableArray(t)))];
  }

  function Wb() {
    for (var _len23 = arguments.length, e = new Array(_len23), _key23 = 0; _key23 < _len23; _key23++) {
      e[_key23] = arguments[_key23];
    }

    var t = e[0];
    if (1 === e.length) return t;

    var n = function n() {
      var n = e.map(function (e) {
        return {
          useScope: e(),
          scopeName: e.scopeName
        };
      });
      return function (e) {
        var r = n.reduce(function (t, _ref73) {
          var n = _ref73.useScope,
              r = _ref73.scopeName;
          return _objectSpread(_objectSpread({}, t), n(e)["__scope".concat(r)]);
        }, {});
        return L.useMemo(function () {
          return _defineProperty({}, "__scope".concat(t.scopeName), r);
        }, [r]);
      };
    };

    return n.scopeName = t.scopeName, n;
  }

  function $b(e) {
    var t = e + "CollectionProvider",
        _Zb = Zb(t),
        _Zb2 = _slicedToArray(_Zb, 2),
        n = _Zb2[0],
        r = _Zb2[1],
        _n42 = n(t, {
      collectionRef: {
        current: null
      },
      itemMap: new Map()
    }),
        _n43 = _slicedToArray(_n42, 2),
        o = _n43[0],
        i = _n43[1],
        a = e + "CollectionSlot",
        s = S["default"].forwardRef(function (e, t) {
      var n = e.scope,
          r = e.children,
          o = Pb(t, i(a, n).collectionRef);
      return S["default"].createElement(Fb, {
        ref: o
      }, r);
    }),
        l = e + "CollectionItemSlot",
        c = "data-radix-collection-item",
        u = S["default"].forwardRef(function (e, t) {
      var _S$default$createElem2;

      var n = e.scope,
          r = e.children,
          o = _objectWithoutProperties(e, _excluded96),
          a = S["default"].useRef(null),
          s = Pb(t, a),
          u = i(l, n);

      return S["default"].useEffect(function () {
        return u.itemMap.set(a, _objectSpread({
          ref: a
        }, o)), function () {
          u.itemMap["delete"](a);
        };
      }), S["default"].createElement(Fb, (_S$default$createElem2 = {}, _defineProperty(_S$default$createElem2, c, ""), _defineProperty(_S$default$createElem2, "ref", s), _S$default$createElem2), r);
    });

    return [{
      Provider: function Provider(e) {
        var t = e.scope,
            n = e.children,
            r = S["default"].useRef(null),
            i = S["default"].useRef(new Map()).current;
        return S["default"].createElement(o, {
          scope: t,
          itemMap: i,
          collectionRef: r
        }, n);
      },
      Slot: s,
      ItemSlot: u
    }, function (t) {
      var n = i(e + "CollectionConsumer", t);
      return S["default"].useCallback(function () {
        var e = n.collectionRef.current;
        if (!e) return [];
        var t = Array.from(e.querySelectorAll("[".concat(c, "]")));
        return Array.from(n.itemMap.values()).sort(function (e, n) {
          return t.indexOf(e.ref.current) - t.indexOf(n.ref.current);
        });
      }, [n.collectionRef, n.itemMap]);
    }, r];
  }

  function Gb(e, t) {
    var _ref75 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref75$checkForDefaul = _ref75.checkForDefaultPrevented,
        n = _ref75$checkForDefaul === void 0 ? !0 : _ref75$checkForDefaul;

    return function (r) {
      if (null == e || e(r), !1 === n || !r.defaultPrevented) return null == t ? void 0 : t(r);
    };
  }

  var Yb = {
    bubbles: !1,
    cancelable: !0
  },
      _$b = $b("RovingFocusGroup"),
      _$b2 = _slicedToArray(_$b, 3),
      Qb = _$b2[0],
      Xb = _$b2[1],
      Kb = _$b2[2],
      _Zb3 = Zb("RovingFocusGroup", [Kb]),
      _Zb4 = _slicedToArray(_Zb3, 2),
      Jb = _Zb4[0],
      ev = _Zb4[1],
      _Jb = Jb("RovingFocusGroup"),
      _Jb2 = _slicedToArray(_Jb, 2),
      tv = _Jb2[0],
      nv = _Jb2[1],
      rv = L.forwardRef(function (e, t) {
    return L.createElement(Qb.Provider, {
      scope: e.__scopeRovingFocusGroup
    }, L.createElement(Qb.Slot, {
      scope: e.__scopeRovingFocusGroup
    }, L.createElement(ov, Fd({}, e, {
      ref: t
    }))));
  }),
      ov = L.forwardRef(function (e, t) {
    var n = e.__scopeRovingFocusGroup,
        r = e.orientation,
        _e$dir = e.dir,
        o = _e$dir === void 0 ? "ltr" : _e$dir,
        _e$loop2 = e.loop,
        i = _e$loop2 === void 0 ? !1 : _e$loop2,
        a = e.currentTabStopId,
        s = e.defaultCurrentTabStopId,
        l = e.onCurrentTabStopIdChange,
        c = e.onEntryFocus,
        u = _objectWithoutProperties(e, _excluded97),
        d = L.useRef(null),
        f = Pb(t, d),
        _Ob = Ob({
      prop: a,
      defaultProp: s,
      onChange: l
    }),
        _Ob2 = _slicedToArray(_Ob, 2),
        _Ob2$ = _Ob2[0],
        p = _Ob2$ === void 0 ? null : _Ob2$,
        h = _Ob2[1],
        _L$useState9 = L.useState(!1),
        _L$useState10 = _slicedToArray(_L$useState9, 2),
        m = _L$useState10[0],
        g = _L$useState10[1],
        y = zb(c),
        b = Xb(n),
        v = L.useRef(!1);

    return L.useEffect(function () {
      var e = d.current;
      if (e) return e.addEventListener("rovingFocusGroup.onEntryFocus", y), function () {
        return e.removeEventListener("rovingFocusGroup.onEntryFocus", y);
      };
    }, [y]), L.createElement(tv, {
      scope: n,
      orientation: r,
      dir: o,
      loop: i,
      currentTabStopId: p,
      onItemFocus: L.useCallback(function (e) {
        return h(e);
      }, [h]),
      onItemShiftTab: L.useCallback(function () {
        return g(!0);
      }, [])
    }, L.createElement(Hb.div, Fd({
      tabIndex: m ? -1 : 0,
      "data-orientation": r
    }, u, {
      ref: f,
      style: _objectSpread({
        outline: "none"
      }, e.style),
      onMouseDown: Gb(e.onMouseDown, function () {
        v.current = !0;
      }),
      onFocus: Gb(e.onFocus, function (e) {
        var t = !v.current;

        if (e.target === e.currentTarget && t && !m) {
          var _t27 = new Event("rovingFocusGroup.onEntryFocus", Yb);

          if (e.currentTarget.dispatchEvent(_t27), !_t27.defaultPrevented) {
            var _e35 = b().filter(function (e) {
              return e.focusable;
            });

            sv([_e35.find(function (e) {
              return e.active;
            }), _e35.find(function (e) {
              return e.id === p;
            })].concat(_toConsumableArray(_e35)).filter(Boolean).map(function (e) {
              return e.ref.current;
            }));
          }
        }

        v.current = !1;
      }),
      onBlur: Gb(e.onBlur, function () {
        return g(!1);
      })
    })));
  }),
      iv = L.forwardRef(function (e, t) {
    var n = e.__scopeRovingFocusGroup,
        _e$focusable = e.focusable,
        r = _e$focusable === void 0 ? !0 : _e$focusable,
        _e$active = e.active,
        o = _e$active === void 0 ? !1 : _e$active,
        i = _objectWithoutProperties(e, _excluded98),
        a = Db(),
        s = nv("RovingFocusGroupItem", n),
        l = s.currentTabStopId === a,
        c = Xb(n);

    return L.createElement(Qb.ItemSlot, {
      scope: n,
      id: a,
      focusable: r,
      active: o
    }, L.createElement(Hb.span, Fd({
      tabIndex: l ? 0 : -1,
      "data-orientation": s.orientation
    }, i, {
      ref: t,
      onMouseDown: Gb(e.onMouseDown, function (e) {
        r ? s.onItemFocus(a) : e.preventDefault();
      }),
      onFocus: Gb(e.onFocus, function () {
        return s.onItemFocus(a);
      }),
      onKeyDown: Gb(e.onKeyDown, function (e) {
        if ("Tab" === e.key && e.shiftKey) return void s.onItemShiftTab();
        if (e.target !== e.currentTarget) return;

        var t = function (e, t, n) {
          var r = function (e, t) {
            return "rtl" !== t ? e : "ArrowLeft" === e ? "ArrowRight" : "ArrowRight" === e ? "ArrowLeft" : e;
          }(e.key, n);

          return "vertical" === t && ["ArrowLeft", "ArrowRight"].includes(r) || "horizontal" === t && ["ArrowUp", "ArrowDown"].includes(r) ? void 0 : av[r];
        }(e, s.orientation, s.dir);

        if (void 0 !== t) {
          e.preventDefault();

          var _o13 = c().filter(function (e) {
            return e.focusable;
          }).map(function (e) {
            return e.ref.current;
          });

          if ("last" === t) _o13.reverse();else if ("prev" === t || "next" === t) {
            "prev" === t && _o13.reverse();

            var _i11 = _o13.indexOf(e.currentTarget);

            _o13 = s.loop ? ((_i11 + 1, _readOnlyError("r")), (_o13, _readOnlyError("n")).map(function (e, t) {
              return n[(r + t) % n.length];
            })) : _o13.slice(_i11 + 1);
          }
          setTimeout(function () {
            return sv(_o13);
          });
        }

        var n, r;
      })
    })));
  }),
      av = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
  };

  function sv(e) {
    var t = document.activeElement;

    var _iterator7 = _createForOfIteratorHelper(e),
        _step7;

    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var _n44 = _step7.value;
        if (_n44 === t) return;
        if (_n44.focus(), document.activeElement !== t) return;
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }
  }

  var lv = rv,
      cv = iv,
      uv = L.forwardRef(function (e, t) {
    var n, r;

    var o = e.containerRef,
        i = e.style,
        a = _objectWithoutProperties(e, _excluded99),
        s = null !== (n = null == o ? void 0 : o.current) && void 0 !== n ? n : null === globalThis || void 0 === globalThis || null === (r = globalThis.document) || void 0 === r ? void 0 : r.body,
        _L$useState11 = L.useState({}),
        _L$useState12 = _slicedToArray(_L$useState11, 2),
        l = _L$useState12[1];

    return Tb(function () {
      l({});
    }, []), s ? I["default"].createPortal(L.createElement(Hb.div, Fd({
      "data-radix-portal": ""
    }, a, {
      ref: t,
      style: s === document.body ? _objectSpread({
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: 2147483647
      }, i) : void 0
    })), s) : null;
  }),
      dv = L.forwardRef(function (e, t) {
    var n = e.children,
        _e$width = e.width,
        r = _e$width === void 0 ? 10 : _e$width,
        _e$height = e.height,
        o = _e$height === void 0 ? 5 : _e$height,
        i = _objectWithoutProperties(e, _excluded100);

    return L.createElement(Hb.svg, Fd({}, i, {
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none"
    }), e.asChild ? n : L.createElement("polygon", {
      points: "0,0 30,0 15,10"
    }));
  }),
      fv = dv;

  function pv(e) {
    var _L$useState13 = L.useState(void 0),
        _L$useState14 = _slicedToArray(_L$useState13, 2),
        t = _L$useState14[0],
        n = _L$useState14[1];

    return L.useEffect(function () {
      if (e) {
        var _t28 = new ResizeObserver(function (t) {
          if (!Array.isArray(t)) return;
          if (!t.length) return;
          var r = t[0];
          var o, i;

          if ("borderBoxSize" in r) {
            var _e36 = r.borderBoxSize,
                _t29 = Array.isArray(_e36) ? _e36[0] : _e36;

            o = _t29.inlineSize, i = _t29.blockSize;
          } else {
            var _t30 = e.getBoundingClientRect();

            o = _t30.width, i = _t30.height;
          }

          n({
            width: o,
            height: i
          });
        });

        return _t28.observe(e, {
          box: "border-box"
        }), function () {
          return _t28.unobserve(e);
        };
      }

      n(void 0);
    }, [e]), t;
  }

  var hv;
  var mv = new Map();

  function gv() {
    var e = [];
    mv.forEach(function (t, n) {
      var r = n.getBoundingClientRect();
      var o, i;
      i = r, ((o = t.rect).width !== i.width || o.height !== i.height || o.top !== i.top || o.right !== i.right || o.bottom !== i.bottom || o.left !== i.left) && (t.rect = r, e.push(t));
    }), e.forEach(function (e) {
      e.callbacks.forEach(function (t) {
        return t(e.rect);
      });
    }), hv = requestAnimationFrame(gv);
  }

  function yv(e) {
    var _L$useState15 = L.useState(),
        _L$useState16 = _slicedToArray(_L$useState15, 2),
        t = _L$useState16[0],
        n = _L$useState16[1];

    return L.useEffect(function () {
      if (e) {
        var _t31 = function (e, t) {
          var n = mv.get(e);
          return void 0 === n ? (mv.set(e, {
            rect: {},
            callbacks: [t]
          }), 1 === mv.size && (hv = requestAnimationFrame(gv))) : (n.callbacks.push(t), t(e.getBoundingClientRect())), function () {
            var n = mv.get(e);
            if (void 0 === n) return;
            var r = n.callbacks.indexOf(t);
            r > -1 && n.callbacks.splice(r, 1), 0 === n.callbacks.length && (mv["delete"](e), 0 === mv.size && cancelAnimationFrame(hv));
          };
        }(e, n);

        return function () {
          n(void 0), _t31();
        };
      }
    }, [e]), t;
  }

  function bv(_ref76) {
    var e = _ref76.anchorRect,
        t = _ref76.popperSize,
        n = _ref76.arrowSize,
        _ref76$arrowOffset = _ref76.arrowOffset,
        r = _ref76$arrowOffset === void 0 ? 0 : _ref76$arrowOffset,
        o = _ref76.side,
        _ref76$sideOffset = _ref76.sideOffset,
        i = _ref76$sideOffset === void 0 ? 0 : _ref76$sideOffset,
        a = _ref76.align,
        _ref76$alignOffset = _ref76.alignOffset,
        s = _ref76$alignOffset === void 0 ? 0 : _ref76$alignOffset,
        _ref76$shouldAvoidCol = _ref76.shouldAvoidCollisions,
        l = _ref76$shouldAvoidCol === void 0 ? !0 : _ref76$shouldAvoidCol,
        c = _ref76.collisionBoundariesRect,
        _ref76$collisionToler = _ref76.collisionTolerance,
        u = _ref76$collisionToler === void 0 ? 0 : _ref76$collisionToler;
    if (!e || !t || !c) return {
      popperStyles: kv,
      arrowStyles: Cv
    };

    var d = function (e, t) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var o = arguments.length > 4 ? arguments[4] : undefined;
      var i = o ? o.height : 0,
          a = vv(t, e, "x"),
          s = vv(t, e, "y"),
          l = s.before - n - i,
          c = s.after + n + i,
          u = a.before - n - i,
          d = a.after + n + i;
      return {
        top: {
          start: {
            x: a.start + r,
            y: l
          },
          center: {
            x: a.center,
            y: l
          },
          end: {
            x: a.end - r,
            y: l
          }
        },
        right: {
          start: {
            x: d,
            y: s.start + r
          },
          center: {
            x: d,
            y: s.center
          },
          end: {
            x: d,
            y: s.end - r
          }
        },
        bottom: {
          start: {
            x: a.start + r,
            y: c
          },
          center: {
            x: a.center,
            y: c
          },
          end: {
            x: a.end - r,
            y: c
          }
        },
        left: {
          start: {
            x: u,
            y: s.start + r
          },
          center: {
            x: u,
            y: s.center
          },
          end: {
            x: u,
            y: s.end - r
          }
        }
      };
    }(t, e, i, s, n),
        f = d[o][a];

    if (!1 === l) {
      var _e37 = xv(f);

      var _i12 = Cv;
      return n && (_i12 = Mv({
        popperSize: t,
        arrowSize: n,
        arrowOffset: r,
        side: o,
        align: a
      })), {
        popperStyles: _objectSpread(_objectSpread({}, _e37), {}, {
          "--radix-popper-transform-origin": wv(t, o, a, r, n)
        }),
        arrowStyles: _i12,
        placedSide: o,
        placedAlign: a
      };
    }

    var p = DOMRect.fromRect(_objectSpread(_objectSpread({}, t), f)),
        h = (m = c, g = u, DOMRect.fromRect({
      width: m.width - 2 * g,
      height: m.height - 2 * g,
      x: m.left + g,
      y: m.top + g
    }));
    var m, g;

    var y = _v(p, h),
        b = d[Ev(o)][a],
        v = function (e, t, n) {
      var r = Ev(e);
      return t[e] && !n[r] ? r : e;
    }(o, y, _v(DOMRect.fromRect(_objectSpread(_objectSpread({}, t), b)), h)),
        x = function (e, t, n, r, o) {
      var i = "top" === n || "bottom" === n,
          a = i ? "left" : "top",
          s = i ? "right" : "bottom",
          l = i ? "width" : "height",
          c = t[l] > e[l];
      return "start" !== r && "center" !== r || !(o[a] && c || o[s] && !c) ? "end" !== r && "center" !== r || !(o[s] && c || o[a] && !c) ? r : "start" : "end";
    }(t, e, o, a, y),
        w = xv(d[v][x]);

    var k = Cv;
    return n && (k = Mv({
      popperSize: t,
      arrowSize: n,
      arrowOffset: r,
      side: v,
      align: x
    })), {
      popperStyles: _objectSpread(_objectSpread({}, w), {}, {
        "--radix-popper-transform-origin": wv(t, v, x, r, n)
      }),
      arrowStyles: k,
      placedSide: v,
      placedAlign: x
    };
  }

  function vv(e, t, n) {
    var r = e["x" === n ? "left" : "top"],
        o = "x" === n ? "width" : "height",
        i = e[o],
        a = t[o];
    return {
      before: r - a,
      start: r,
      center: r + (i - a) / 2,
      end: r + i - a,
      after: r + i
    };
  }

  function xv(e) {
    return {
      position: "absolute",
      top: 0,
      left: 0,
      minWidth: "max-content",
      willChange: "transform",
      transform: "translate3d(".concat(Math.round(e.x + window.scrollX), "px, ").concat(Math.round(e.y + window.scrollY), "px, 0)")
    };
  }

  function wv(e, t, n, r, o) {
    var i = "top" === t || "bottom" === t,
        a = o ? o.width : 0,
        s = o ? o.height : 0,
        l = a / 2 + r;
    var c = "",
        u = "";
    return i ? (c = {
      start: "".concat(l, "px"),
      center: "center",
      end: e.width - l + "px"
    }[n], u = "top" === t ? "".concat(e.height + s, "px") : -s + "px") : (c = "left" === t ? "".concat(e.width + s, "px") : -s + "px", u = {
      start: "".concat(l, "px"),
      center: "center",
      end: e.height - l + "px"
    }[n]), "".concat(c, " ").concat(u);
  }

  var kv = {
    position: "fixed",
    top: 0,
    left: 0,
    opacity: 0,
    transform: "translate3d(0, -200%, 0)"
  },
      Cv = {
    position: "absolute",
    opacity: 0
  };

  function Mv(_ref77) {
    var _c3;

    var e = _ref77.popperSize,
        t = _ref77.arrowSize,
        n = _ref77.arrowOffset,
        r = _ref77.side,
        o = _ref77.align;
    var i = (e.width - t.width) / 2,
        a = (e.height - t.width) / 2,
        s = {
      top: 0,
      right: 90,
      bottom: 180,
      left: -90
    }[r],
        l = Math.max(t.width, t.height),
        c = (_c3 = {
      width: "".concat(l, "px"),
      height: "".concat(l, "px"),
      transform: "rotate(".concat(s, "deg)"),
      willChange: "transform",
      position: "absolute"
    }, _defineProperty(_c3, r, "100%"), _defineProperty(_c3, "direction", jv(r, o)), _c3);
    return "top" !== r && "bottom" !== r || ("start" === o && (c.left = "".concat(n, "px")), "center" === o && (c.left = "".concat(i, "px")), "end" === o && (c.right = "".concat(n, "px"))), "left" !== r && "right" !== r || ("start" === o && (c.top = "".concat(n, "px")), "center" === o && (c.top = "".concat(a, "px")), "end" === o && (c.bottom = "".concat(n, "px"))), c;
  }

  function jv(e, t) {
    return ("top" !== e && "right" !== e || "end" !== t) && ("bottom" !== e && "left" !== e || "end" === t) ? "ltr" : "rtl";
  }

  function Ev(e) {
    return {
      top: "bottom",
      right: "left",
      bottom: "top",
      left: "right"
    }[e];
  }

  function _v(e, t) {
    return {
      top: e.top < t.top,
      right: e.right > t.right,
      bottom: e.bottom > t.bottom,
      left: e.left < t.left
    };
  }

  var _Zb5 = Zb("Popper"),
      _Zb6 = _slicedToArray(_Zb5, 2),
      Tv = _Zb6[0],
      Sv = _Zb6[1],
      _Tv = Tv("Popper"),
      _Tv2 = _slicedToArray(_Tv, 2),
      Lv = _Tv2[0],
      Dv = _Tv2[1],
      Av = L.forwardRef(function (e, t) {
    var n = e.__scopePopper,
        r = e.virtualRef,
        o = _objectWithoutProperties(e, _excluded101),
        i = Dv("PopperAnchor", n),
        a = L.useRef(null),
        s = Pb(t, a);

    return L.useEffect(function () {
      i.onAnchorChange((null == r ? void 0 : r.current) || a.current);
    }), r ? null : L.createElement(Hb.div, Fd({}, o, {
      ref: s
    }));
  }),
      _Tv3 = Tv("PopperContent"),
      _Tv4 = _slicedToArray(_Tv3, 2),
      Nv = _Tv4[0],
      Iv = _Tv4[1],
      zv = L.forwardRef(function (e, t) {
    var n = e.__scopePopper,
        _e$side = e.side,
        r = _e$side === void 0 ? "bottom" : _e$side,
        o = e.sideOffset,
        _e$align = e.align,
        i = _e$align === void 0 ? "center" : _e$align,
        a = e.alignOffset,
        s = e.collisionTolerance,
        _e$avoidCollisions = e.avoidCollisions,
        l = _e$avoidCollisions === void 0 ? !0 : _e$avoidCollisions,
        c = _objectWithoutProperties(e, _excluded102),
        u = Dv("PopperContent", n),
        _L$useState17 = L.useState(),
        _L$useState18 = _slicedToArray(_L$useState17, 2),
        d = _L$useState18[0],
        f = _L$useState18[1],
        p = yv(u.anchor),
        _L$useState19 = L.useState(null),
        _L$useState20 = _slicedToArray(_L$useState19, 2),
        h = _L$useState20[0],
        m = _L$useState20[1],
        g = pv(h),
        _L$useState21 = L.useState(null),
        _L$useState22 = _slicedToArray(_L$useState21, 2),
        y = _L$useState22[0],
        b = _L$useState22[1],
        v = pv(y),
        x = Pb(t, function (e) {
      return m(e);
    }),
        w = function () {
      var _L$useState23 = L.useState(void 0),
          _L$useState24 = _slicedToArray(_L$useState23, 2),
          e = _L$useState24[0],
          t = _L$useState24[1];

      return L.useEffect(function () {
        var e;

        function n() {
          t({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }

        function r() {
          window.clearTimeout(e), e = window.setTimeout(n, 100);
        }

        return n(), window.addEventListener("resize", r), function () {
          return window.removeEventListener("resize", r);
        };
      }, []), e;
    }(),
        k = w ? DOMRect.fromRect(_objectSpread(_objectSpread({}, w), {}, {
      x: 0,
      y: 0
    })) : void 0,
        _bv = bv({
      anchorRect: p,
      popperSize: g,
      arrowSize: v,
      arrowOffset: d,
      side: r,
      sideOffset: o,
      align: i,
      alignOffset: a,
      shouldAvoidCollisions: l,
      collisionBoundariesRect: k,
      collisionTolerance: s
    }),
        C = _bv.popperStyles,
        M = _bv.arrowStyles,
        j = _bv.placedSide,
        E = _bv.placedAlign,
        _ = void 0 !== j;

    return L.createElement("div", {
      style: C,
      "data-radix-popper-content-wrapper": ""
    }, L.createElement(Nv, {
      scope: n,
      arrowStyles: M,
      onArrowChange: b,
      onArrowOffsetChange: f
    }, L.createElement(Hb.div, Fd({
      "data-side": j,
      "data-align": E
    }, c, {
      style: _objectSpread(_objectSpread({}, c.style), {}, {
        animation: _ ? void 0 : "none"
      }),
      ref: x
    }))));
  }),
      Ov = L.forwardRef(function (e, t) {
    var n = e.__scopePopper,
        r = e.offset,
        o = _objectWithoutProperties(e, _excluded103),
        i = Iv("PopperArrow", n),
        a = i.onArrowOffsetChange;

    return L.useEffect(function () {
      return a(r);
    }, [a, r]), L.createElement("span", {
      style: _objectSpread(_objectSpread({}, i.arrowStyles), {}, {
        pointerEvents: "none"
      })
    }, L.createElement("span", {
      ref: i.onArrowChange,
      style: {
        display: "inline-block",
        verticalAlign: "top",
        pointerEvents: "auto"
      }
    }, L.createElement(fv, Fd({}, o, {
      ref: t,
      style: _objectSpread(_objectSpread({}, o.style), {}, {
        display: "block"
      })
    }))));
  }),
      Rv = function Rv(e) {
    var t = e.__scopePopper,
        n = e.children,
        _L$useState25 = L.useState(null),
        _L$useState26 = _slicedToArray(_L$useState25, 2),
        r = _L$useState26[0],
        o = _L$useState26[1];

    return L.createElement(Lv, {
      scope: t,
      anchor: r,
      onAnchorChange: o
    }, n);
  },
      Pv = Av,
      Fv = zv,
      Bv = Ov,
      qv = function qv(e) {
    var t = e.present,
        n = e.children,
        r = function (e) {
      var _L$useState27 = L.useState(),
          _L$useState28 = _slicedToArray(_L$useState27, 2),
          t = _L$useState28[0],
          n = _L$useState28[1],
          r = L.useRef({}),
          o = L.useRef(e),
          i = L.useRef("none"),
          a = e ? "mounted" : "unmounted",
          _ref78 = function (e, t) {
        return L.useReducer(function (e, n) {
          var r = t[e][n];
          return null != r ? r : e;
        }, e);
      }(a, {
        mounted: {
          UNMOUNT: "unmounted",
          ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
          MOUNT: "mounted",
          ANIMATION_END: "unmounted"
        },
        unmounted: {
          MOUNT: "mounted"
        }
      }),
          _ref79 = _slicedToArray(_ref78, 2),
          s = _ref79[0],
          l = _ref79[1];

      return L.useEffect(function () {
        var e = Uv(r.current);
        i.current = "mounted" === s ? e : "none";
      }, [s]), Tb(function () {
        var t = r.current,
            n = o.current;

        if (n !== e) {
          var _r27 = i.current,
              _a5 = Uv(t);

          if (e) l("MOUNT");else if ("none" === _a5 || "none" === (null == t ? void 0 : t.display)) l("UNMOUNT");else {
            var _e38 = _r27 !== _a5;

            l(n && _e38 ? "ANIMATION_OUT" : "UNMOUNT");
          }
          o.current = e;
        }
      }, [e, l]), Tb(function () {
        if (t) {
          var _e39 = function _e39(e) {
            var n = Uv(r.current).includes(e.animationName);
            e.target === t && n && l("ANIMATION_END");
          },
              _n45 = function _n45(e) {
            e.target === t && (i.current = Uv(r.current));
          };

          return t.addEventListener("animationstart", _n45), t.addEventListener("animationcancel", _e39), t.addEventListener("animationend", _e39), function () {
            t.removeEventListener("animationstart", _n45), t.removeEventListener("animationcancel", _e39), t.removeEventListener("animationend", _e39);
          };
        }

        l("ANIMATION_END");
      }, [t, l]), {
        isPresent: ["mounted", "unmountSuspended"].includes(s),
        ref: L.useCallback(function (e) {
          e && (r.current = getComputedStyle(e)), n(e);
        }, [])
      };
    }(t),
        o = "function" == typeof n ? n({
      present: r.isPresent
    }) : L.Children.only(n),
        i = Pb(r.ref, o.ref);

    return "function" == typeof n || r.isPresent ? L.cloneElement(o, {
      ref: i
    }) : null;
  };

  function Uv(e) {
    return (null == e ? void 0 : e.animationName) || "none";
  }

  qv.displayName = "Presence";
  var Vv = {
    bubbles: !1,
    cancelable: !0
  },
      Hv = L.forwardRef(function (e, t) {
    var _e$loop3 = e.loop,
        n = _e$loop3 === void 0 ? !1 : _e$loop3,
        _e$trapped2 = e.trapped,
        r = _e$trapped2 === void 0 ? !1 : _e$trapped2,
        o = e.onMountAutoFocus,
        i = e.onUnmountAutoFocus,
        a = _objectWithoutProperties(e, _excluded104),
        _L$useState29 = L.useState(null),
        _L$useState30 = _slicedToArray(_L$useState29, 2),
        s = _L$useState30[0],
        l = _L$useState30[1],
        c = zb(o),
        u = zb(i),
        d = L.useRef(null),
        f = Pb(t, function (e) {
      return l(e);
    }),
        p = L.useRef({
      paused: !1,
      pause: function pause() {
        this.paused = !0;
      },
      resume: function resume() {
        this.paused = !1;
      }
    }).current;

    L.useEffect(function () {
      if (r) {
        var _e40 = function _e40(e) {
          if (p.paused || !s) return;
          var t = e.target;
          s.contains(t) ? d.current = t : Gv(d.current, {
            select: !0
          });
        };

        var _t32 = function _t32(e) {
          !p.paused && s && (s.contains(e.relatedTarget) || Gv(d.current, {
            select: !0
          }));
        };

        return document.addEventListener("focusin", _e40), document.addEventListener("focusout", _t32), function () {
          document.removeEventListener("focusin", _e40), document.removeEventListener("focusout", _t32);
        };
      }
    }, [r, s, p.paused]), L.useEffect(function () {
      if (s) {
        Yv.add(p);
        var _e41 = document.activeElement;

        if (!s.contains(_e41)) {
          var _t33 = new Event("focusScope.autoFocusOnMount", Vv);

          s.addEventListener("focusScope.autoFocusOnMount", c), s.dispatchEvent(_t33), _t33.defaultPrevented || (function (e) {
            var _ref80 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                _ref80$select = _ref80.select,
                t = _ref80$select === void 0 ? !1 : _ref80$select;

            var n = document.activeElement;

            var _iterator8 = _createForOfIteratorHelper(e),
                _step8;

            try {
              for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                var _r28 = _step8.value;
                if (Gv(_r28, {
                  select: t
                }), document.activeElement !== n) return;
              }
            } catch (err) {
              _iterator8.e(err);
            } finally {
              _iterator8.f();
            }
          }(Zv(s).filter(function (e) {
            return "A" !== e.tagName;
          }), {
            select: !0
          }), document.activeElement === _e41 && Gv(s));
        }

        return function () {
          s.removeEventListener("focusScope.autoFocusOnMount", c), setTimeout(function () {
            var t = new Event("focusScope.autoFocusOnUnmount", Vv);
            s.addEventListener("focusScope.autoFocusOnUnmount", u), s.dispatchEvent(t), t.defaultPrevented || Gv(null != _e41 ? _e41 : document.body, {
              select: !0
            }), s.removeEventListener("focusScope.autoFocusOnUnmount", u), Yv.remove(p);
          }, 0);
        };
      }
    }, [s, c, u, p]);
    var h = L.useCallback(function (e) {
      if (!n && !r) return;
      if (p.paused) return;
      var t = "Tab" === e.key && !e.altKey && !e.ctrlKey && !e.metaKey,
          o = document.activeElement;

      if (t && o) {
        var _t34 = e.currentTarget,
            _ref81 = function (e) {
          var t = Zv(e);
          return [Wv(t, e), Wv(t.reverse(), e)];
        }(_t34),
            _ref82 = _slicedToArray(_ref81, 2),
            _r29 = _ref82[0],
            _i13 = _ref82[1];

        _r29 && _i13 ? e.shiftKey || o !== _i13 ? e.shiftKey && o === _r29 && (e.preventDefault(), n && Gv(_i13, {
          select: !0
        })) : (e.preventDefault(), n && Gv(_r29, {
          select: !0
        })) : o === _t34 && e.preventDefault();
      }
    }, [n, r, p.paused]);
    return L.createElement(Hb.div, Fd({
      tabIndex: -1
    }, a, {
      ref: f,
      onKeyDown: h
    }));
  });

  function Zv(e) {
    var t = [],
        n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
      acceptNode: function acceptNode(e) {
        var t = "INPUT" === e.tagName && "hidden" === e.type;
        return e.disabled || e.hidden || t ? NodeFilter.FILTER_SKIP : e.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });

    for (; n.nextNode();) {
      t.push(n.currentNode);
    }

    return t;
  }

  function Wv(e, t) {
    var _iterator9 = _createForOfIteratorHelper(e),
        _step9;

    try {
      for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
        var _n46 = _step9.value;
        if (!$v(_n46, {
          upTo: t
        })) return _n46;
      }
    } catch (err) {
      _iterator9.e(err);
    } finally {
      _iterator9.f();
    }
  }

  function $v(e, _ref83) {
    var t = _ref83.upTo;
    if ("hidden" === getComputedStyle(e).visibility) return !0;

    for (; e;) {
      if (void 0 !== t && e === t) return !1;
      if ("none" === getComputedStyle(e).display) return !0;
      e = e.parentElement;
    }

    return !1;
  }

  function Gv(e) {
    var _ref84 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref84$select = _ref84.select,
        t = _ref84$select === void 0 ? !1 : _ref84$select;

    if (e && e.focus) {
      var _n47 = document.activeElement;
      e.focus({
        preventScroll: !0
      }), e !== _n47 && function (e) {
        return e instanceof HTMLInputElement && "select" in e;
      }(e) && t && e.select();
    }
  }

  var Yv = function () {
    var e = [];
    return {
      add: function add(t) {
        var n = e[0];
        t !== n && (null == n || n.pause()), e = Qv(e, t), e.unshift(t);
      },
      remove: function remove(t) {
        var n;
        e = Qv(e, t), null === (n = e[0]) || void 0 === n || n.resume();
      }
    };
  }();

  function Qv(e, t) {
    var n = _toConsumableArray(e),
        r = n.indexOf(t);

    return -1 !== r && n.splice(r, 1), n;
  }

  function Xv(e) {
    var t = zb(e);
    L.useEffect(function () {
      var e = function e(_e42) {
        "Escape" === _e42.key && t(_e42);
      };

      return document.addEventListener("keydown", e), function () {
        return document.removeEventListener("keydown", e);
      };
    }, [t]);
  }

  var Kv,
      Jv = 0;
  var ex = L.createContext({
    layers: new Set(),
    layersWithOutsidePointerEventsDisabled: new Set(),
    branches: new Set()
  }),
      tx = L.forwardRef(function (e, t) {
    var _e$disableOutsidePoin2 = e.disableOutsidePointerEvents,
        n = _e$disableOutsidePoin2 === void 0 ? !1 : _e$disableOutsidePoin2,
        r = e.onEscapeKeyDown,
        o = e.onPointerDownOutside,
        i = e.onFocusOutside,
        a = e.onInteractOutside,
        s = e.onDismiss,
        l = _objectWithoutProperties(e, _excluded105),
        c = L.useContext(ex),
        _L$useState31 = L.useState(null),
        _L$useState32 = _slicedToArray(_L$useState31, 2),
        u = _L$useState32[0],
        d = _L$useState32[1],
        _L$useState33 = L.useState({}),
        _L$useState34 = _slicedToArray(_L$useState33, 2),
        f = _L$useState34[1],
        p = Pb(t, function (e) {
      return d(e);
    }),
        h = Array.from(c.layers),
        _slice3 = _toConsumableArray(c.layersWithOutsidePointerEventsDisabled).slice(-1),
        _slice4 = _slicedToArray(_slice3, 1),
        m = _slice4[0],
        g = h.indexOf(m),
        y = u ? h.indexOf(u) : -1,
        b = c.layersWithOutsidePointerEventsDisabled.size > 0,
        v = y >= g,
        x = function (e) {
      var t = zb(function (e) {
        var t = e.target,
            n = _toConsumableArray(c.branches).some(function (e) {
          return e.contains(t);
        });

        v && !n && (null == o || o(e), null == a || a(e), e.defaultPrevented || null == s || s());
      }),
          n = L.useRef(!1);
      return L.useEffect(function () {
        var e = function e(_e43) {
          _e43.target && !n.current && rx("dismissableLayer.pointerDownOutside", t, {
            originalEvent: _e43
          }), n.current = !1;
        },
            r = window.setTimeout(function () {
          document.addEventListener("pointerdown", e);
        }, 0);

        return function () {
          window.clearTimeout(r), document.removeEventListener("pointerdown", e);
        };
      }, [t]), {
        onPointerDownCapture: function onPointerDownCapture() {
          return n.current = !0;
        }
      };
    }(),
        w = function (e) {
      var t = zb(function (e) {
        var t = e.target;
        _toConsumableArray(c.branches).some(function (e) {
          return e.contains(t);
        }) || (null == i || i(e), null == a || a(e), e.defaultPrevented || null == s || s());
      }),
          n = L.useRef(!1);
      return L.useEffect(function () {
        var e = function e(_e44) {
          _e44.target && !n.current && rx("dismissableLayer.focusOutside", t, {
            originalEvent: _e44
          });
        };

        return document.addEventListener("focusin", e), function () {
          return document.removeEventListener("focusin", e);
        };
      }, [t]), {
        onFocusCapture: function onFocusCapture() {
          return n.current = !0;
        },
        onBlurCapture: function onBlurCapture() {
          return n.current = !1;
        }
      };
    }();

    return Xv(function (e) {
      y === c.layers.size - 1 && (null == r || r(e), e.defaultPrevented || null == s || s());
    }), function (_ref85) {
      var e = _ref85.disabled;
      var t = L.useRef(!1);
      Tb(function () {
        if (e) {
          var _n48 = function _n48() {
            Jv--, 0 === Jv && (document.body.style.pointerEvents = Kv);
          };

          var _r30 = function _r30(e) {
            t.current = "mouse" !== e.pointerType;
          };

          return 0 === Jv && (Kv = document.body.style.pointerEvents), document.body.style.pointerEvents = "none", Jv++, document.addEventListener("pointerup", _r30), function () {
            t.current ? document.addEventListener("click", _n48, {
              once: !0
            }) : _n48(), document.removeEventListener("pointerup", _r30);
          };
        }
      }, [e]);
    }({
      disabled: n
    }), L.useEffect(function () {
      u && (n && c.layersWithOutsidePointerEventsDisabled.add(u), c.layers.add(u), nx());
    }, [u, n, c]), L.useEffect(function () {
      return function () {
        u && (c.layers["delete"](u), c.layersWithOutsidePointerEventsDisabled["delete"](u), nx());
      };
    }, [u, c]), L.useEffect(function () {
      var e = function e() {
        return f({});
      };

      return document.addEventListener("dismissableLayer.update", e), function () {
        return document.removeEventListener("dismissableLayer.update", e);
      };
    }, []), L.createElement(Hb.div, Fd({}, l, {
      ref: p,
      style: _objectSpread({
        pointerEvents: b ? v ? "auto" : "none" : void 0
      }, e.style),
      onFocusCapture: Gb(e.onFocusCapture, w.onFocusCapture),
      onBlurCapture: Gb(e.onBlurCapture, w.onBlurCapture),
      onPointerDownCapture: Gb(e.onPointerDownCapture, x.onPointerDownCapture)
    }));
  });

  function nx() {
    var e = new Event("dismissableLayer.update");
    document.dispatchEvent(e);
  }

  function rx(e, t, n) {
    var r = n.originalEvent.target,
        o = new CustomEvent(e, {
      bubbles: !1,
      cancelable: !0,
      detail: n
    });
    return t && r.addEventListener(e, t, {
      once: !0
    }), !r.dispatchEvent(o);
  }

  var ox = ["Enter", " "],
      ix = ["ArrowUp", "PageDown", "End"],
      ax = ["ArrowDown", "PageUp", "Home"].concat(ix),
      sx = {
    ltr: ["ArrowLeft"],
    rtl: ["ArrowRight"]
  },
      _$b3 = $b("Menu"),
      _$b4 = _slicedToArray(_$b3, 3),
      lx = _$b4[0],
      cx = _$b4[1],
      ux = _$b4[2],
      _Zb7 = Zb("Menu", [ux, Sv, ev]),
      _Zb8 = _slicedToArray(_Zb7, 2),
      dx = _Zb8[0],
      fx = _Zb8[1],
      px = Sv(),
      hx = ev(),
      _dx = dx("Menu"),
      _dx2 = _slicedToArray(_dx, 2),
      mx = _dx2[0],
      gx = _dx2[1],
      yx = L.forwardRef(function (e, t) {
    var n = e.__scopeMenu,
        r = _objectWithoutProperties(e, _excluded106),
        o = px(n);

    return L.createElement(Pv, Fd({}, o, r, {
      ref: t
    }));
  }),
      _dx3 = dx("MenuContent"),
      _dx4 = _slicedToArray(_dx3, 2),
      bx = _dx4[0],
      vx = _dx4[1],
      xx = L.forwardRef(function (e, t) {
    var n = e.forceMount,
        r = _objectWithoutProperties(e, _excluded107),
        o = gx("MenuContent", e.__scopeMenu);

    return L.createElement(lx.Provider, {
      scope: e.__scopeMenu
    }, L.createElement(qv, {
      present: n || o.open
    }, L.createElement(lx.Slot, {
      scope: e.__scopeMenu
    }, o.isSubmenu ? L.createElement(Mx, Fd({}, r, {
      ref: t
    })) : L.createElement(wx, Fd({}, r, {
      ref: t
    })))));
  }),
      wx = L.forwardRef(function (e, t) {
    return gx("MenuContent", e.__scopeMenu).modal ? L.createElement(kx, Fd({}, e, {
      ref: t
    })) : L.createElement(Cx, Fd({}, e, {
      ref: t
    }));
  }),
      kx = L.forwardRef(function (e, t) {
    var n = gx("MenuContent", e.__scopeMenu),
        r = L.useRef(null),
        o = Pb(t, r);
    return L.useEffect(function () {
      var e = r.current;
      if (e) return Yg(e);
    }, []), L.createElement(jx, Fd({}, e, {
      ref: o,
      trapFocus: n.open,
      disableOutsidePointerEvents: n.open,
      disableOutsideScroll: !0,
      onFocusOutside: Gb(e.onFocusOutside, function (e) {
        return e.preventDefault();
      }, {
        checkForDefaultPrevented: !1
      }),
      onDismiss: function onDismiss() {
        return n.onOpenChange(!1);
      }
    }));
  }),
      Cx = L.forwardRef(function (e, t) {
    var n = gx("MenuContent", e.__scopeMenu);
    return L.createElement(jx, Fd({}, e, {
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: function onDismiss() {
        return n.onOpenChange(!1);
      }
    }));
  }),
      Mx = L.forwardRef(function (e, t) {
    var n = gx("MenuContent", e.__scopeMenu),
        r = L.useRef(null),
        o = Pb(t, r);
    return n.isSubmenu ? L.createElement(jx, Fd({
      id: n.contentId,
      "aria-labelledby": n.triggerId
    }, e, {
      ref: o,
      align: "start",
      side: "rtl" === n.dir ? "left" : "right",
      portalled: !0,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      trapFocus: !1,
      onOpenAutoFocus: function onOpenAutoFocus(e) {
        var t;
        n.isUsingKeyboardRef.current && (null === (t = r.current) || void 0 === t || t.focus()), e.preventDefault();
      },
      onCloseAutoFocus: function onCloseAutoFocus(e) {
        return e.preventDefault();
      },
      onFocusOutside: Gb(e.onFocusOutside, function (e) {
        e.target !== n.trigger && n.onOpenChange(!1);
      }),
      onEscapeKeyDown: Gb(e.onEscapeKeyDown, n.onRootClose),
      onKeyDown: Gb(e.onKeyDown, function (e) {
        var t = e.currentTarget.contains(e.target),
            r = sx[n.dir].includes(e.key);
        var o;
        t && r && (n.onOpenChange(!1), null === (o = n.trigger) || void 0 === o || o.focus(), e.preventDefault());
      })
    })) : null;
  }),
      jx = L.forwardRef(function (e, t) {
    var n = e.__scopeMenu,
        _e$loop4 = e.loop,
        r = _e$loop4 === void 0 ? !1 : _e$loop4,
        o = e.trapFocus,
        i = e.onOpenAutoFocus,
        a = e.onCloseAutoFocus,
        s = e.disableOutsidePointerEvents,
        l = e.onEscapeKeyDown,
        c = e.onPointerDownOutside,
        u = e.onFocusOutside,
        d = e.onInteractOutside,
        f = e.onDismiss,
        p = e.disableOutsideScroll,
        h = e.allowPinchZoom,
        m = e.portalled,
        g = _objectWithoutProperties(e, _excluded108),
        y = gx("MenuContent", n),
        b = px(n),
        v = hx(n),
        x = cx(n),
        _L$useState35 = L.useState(null),
        _L$useState36 = _slicedToArray(_L$useState35, 2),
        w = _L$useState36[0],
        k = _L$useState36[1],
        C = L.useRef(null),
        M = Pb(t, C, y.onContentChange),
        j = L.useRef(0),
        E = L.useRef(""),
        _ = L.useRef(0),
        T = L.useRef(null),
        S = L.useRef("right"),
        D = L.useRef(0),
        A = m ? uv : L.Fragment,
        N = p ? Hg : L.Fragment,
        I = p ? {
      allowPinchZoom: h
    } : void 0;

    L.useEffect(function () {
      return function () {
        return window.clearTimeout(j.current);
      };
    }, []), Nb();
    var z = L.useCallback(function (e) {
      var t, n;
      return S.current === (null === (t = T.current) || void 0 === t ? void 0 : t.side) && function (e, t) {
        return !!t && function (e, t) {
          var n = e.x,
              r = e.y;
          var o = !1;

          for (var _e45 = 0, _i14 = t.length - 1; _e45 < t.length; _i14 = _e45++) {
            var _a6 = t[_e45].x,
                _s3 = t[_e45].y,
                _l3 = t[_i14].x,
                _c4 = t[_i14].y;
            _s3 > r != _c4 > r && n < (_l3 - _a6) * (r - _s3) / (_c4 - _s3) + _a6 && (o = !o);
          }

          return o;
        }({
          x: e.clientX,
          y: e.clientY
        }, t);
      }(e, null === (n = T.current) || void 0 === n ? void 0 : n.area);
    }, []);
    return L.createElement(A, null, L.createElement(N, I, L.createElement(bx, {
      scope: n,
      searchRef: E,
      onItemEnter: L.useCallback(function (e) {
        z(e) && e.preventDefault();
      }, [z]),
      onItemLeave: L.useCallback(function (e) {
        var t;
        z(e) || (null === (t = C.current) || void 0 === t || t.focus(), k(null));
      }, [z]),
      onTriggerLeave: L.useCallback(function (e) {
        z(e) && e.preventDefault();
      }, [z]),
      pointerGraceTimerRef: _,
      onPointerGraceIntentChange: L.useCallback(function (e) {
        T.current = e;
      }, [])
    }, L.createElement(Hv, {
      asChild: !0,
      trapped: o,
      onMountAutoFocus: Gb(i, function (e) {
        var t;
        e.preventDefault(), null === (t = C.current) || void 0 === t || t.focus();
      }),
      onUnmountAutoFocus: a
    }, L.createElement(tx, {
      asChild: !0,
      disableOutsidePointerEvents: s,
      onEscapeKeyDown: l,
      onPointerDownOutside: c,
      onFocusOutside: u,
      onInteractOutside: d,
      onDismiss: f
    }, L.createElement(lv, Fd({
      asChild: !0
    }, v, {
      dir: y.dir,
      orientation: "vertical",
      loop: r,
      currentTabStopId: w,
      onCurrentTabStopIdChange: k,
      onEntryFocus: function onEntryFocus(e) {
        y.isUsingKeyboardRef.current || e.preventDefault();
      }
    }), L.createElement(Fv, Fd({
      role: "menu",
      "aria-orientation": "vertical",
      "data-state": Tx(y.open),
      dir: y.dir
    }, b, g, {
      ref: M,
      style: _objectSpread({
        outline: "none"
      }, g.style),
      onKeyDown: Gb(g.onKeyDown, function (e) {
        var t = e.target,
            n = e.currentTarget.contains(t),
            r = e.ctrlKey || e.altKey || e.metaKey,
            o = 1 === e.key.length;
        n && ("Tab" === e.key && e.preventDefault(), !r && o && function (e) {
          var t, n;

          var r = E.current + e,
              o = x().filter(function (e) {
            return !e.disabled;
          }),
              i = document.activeElement,
              a = null === (t = o.find(function (e) {
            return e.ref.current === i;
          })) || void 0 === t ? void 0 : t.textValue,
              s = function (e, t, n) {
            var r = t.length > 1 && Array.from(t).every(function (e) {
              return e === t[0];
            }) ? t[0] : t,
                o = n ? e.indexOf(n) : -1;
            var i = (a = e, s = Math.max(o, 0), a.map(function (e, t) {
              return a[(s + t) % a.length];
            }));
            var a, s;
            1 === r.length && (i = i.filter(function (e) {
              return e !== n;
            }));
            var l = i.find(function (e) {
              return e.toLowerCase().startsWith(r.toLowerCase());
            });
            return l !== n ? l : void 0;
          }(o.map(function (e) {
            return e.textValue;
          }), r, a),
              l = null === (n = o.find(function (e) {
            return e.textValue === s;
          })) || void 0 === n ? void 0 : n.ref.current;

          !function e(t) {
            E.current = t, window.clearTimeout(j.current), "" !== t && (j.current = window.setTimeout(function () {
              return e("");
            }, 1e3));
          }(r), l && setTimeout(function () {
            return l.focus();
          });
        }(e.key));
        var i = C.current;
        if (e.target !== i) return;
        if (!ax.includes(e.key)) return;
        e.preventDefault();
        var a = x().filter(function (e) {
          return !e.disabled;
        }).map(function (e) {
          return e.ref.current;
        });
        ix.includes(e.key) && a.reverse(), function (e) {
          var t = document.activeElement;

          var _iterator10 = _createForOfIteratorHelper(e),
              _step10;

          try {
            for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
              var _n49 = _step10.value;
              if (_n49 === t) return;
              if (_n49.focus(), document.activeElement !== t) return;
            }
          } catch (err) {
            _iterator10.e(err);
          } finally {
            _iterator10.f();
          }
        }(a);
      }),
      onBlur: Gb(e.onBlur, function (e) {
        e.currentTarget.contains(e.target) || (window.clearTimeout(j.current), E.current = "");
      }),
      onPointerMove: Gb(e.onPointerMove, Sx(function (e) {
        var t = e.target,
            n = D.current !== e.clientX;

        if (e.currentTarget.contains(t) && n) {
          var _t35 = e.clientX > D.current ? "right" : "left";

          S.current = _t35, D.current = e.clientX;
        }
      }))
    }))))))));
  }),
      Ex = L.forwardRef(function (e, t) {
    var _e$disabled2 = e.disabled,
        n = _e$disabled2 === void 0 ? !1 : _e$disabled2,
        r = e.onSelect,
        o = _objectWithoutProperties(e, _excluded109),
        i = L.useRef(null),
        a = gx("MenuItem", e.__scopeMenu),
        s = vx("MenuItem", e.__scopeMenu),
        l = Pb(t, i),
        c = L.useRef(!1);

    return L.createElement(_x, Fd({}, o, {
      ref: l,
      disabled: n,
      onClick: Gb(e.onClick, function () {
        var e = i.current;

        if (!n && e) {
          var _t36 = new Event("menu.itemSelect", {
            bubbles: !0,
            cancelable: !0
          });

          e.addEventListener("menu.itemSelect", function (e) {
            return null == r ? void 0 : r(e);
          }, {
            once: !0
          }), e.dispatchEvent(_t36), _t36.defaultPrevented ? c.current = !1 : a.onRootClose();
        }
      }),
      onPointerDown: function onPointerDown(t) {
        var n;
        null === (n = e.onPointerDown) || void 0 === n || n.call(e, t), c.current = !0;
      },
      onPointerUp: Gb(e.onPointerUp, function (e) {
        var t;
        c.current || null === (t = e.currentTarget) || void 0 === t || t.click();
      }),
      onKeyDown: Gb(e.onKeyDown, function (e) {
        var t = "" !== s.searchRef.current;
        n || t && " " === e.key || ox.includes(e.key) && (e.currentTarget.click(), e.preventDefault());
      })
    }));
  }),
      _x = L.forwardRef(function (e, t) {
    var n = e.__scopeMenu,
        _e$disabled3 = e.disabled,
        r = _e$disabled3 === void 0 ? !1 : _e$disabled3,
        o = e.textValue,
        i = _objectWithoutProperties(e, _excluded110),
        a = vx("MenuItem", n),
        s = hx(n),
        l = L.useRef(null),
        c = Pb(t, l),
        _L$useState37 = L.useState(""),
        _L$useState38 = _slicedToArray(_L$useState37, 2),
        u = _L$useState38[0],
        d = _L$useState38[1];

    return L.useEffect(function () {
      var e = l.current;
      var t;
      e && d((null !== (t = e.textContent) && void 0 !== t ? t : "").trim());
    }, [i.children]), L.createElement(lx.ItemSlot, {
      scope: n,
      disabled: r,
      textValue: null != o ? o : u
    }, L.createElement(cv, Fd({
      asChild: !0
    }, s, {
      focusable: !r
    }), L.createElement(Hb.div, Fd({
      role: "menuitem",
      "aria-disabled": r || void 0,
      "data-disabled": r ? "" : void 0
    }, i, {
      ref: c,
      onPointerMove: Gb(e.onPointerMove, Sx(function (e) {
        r ? a.onItemLeave(e) : (a.onItemEnter(e), e.defaultPrevented || e.currentTarget.focus());
      })),
      onPointerLeave: Gb(e.onPointerLeave, Sx(function (e) {
        return a.onItemLeave(e);
      }))
    }))));
  });

  function Tx(e) {
    return e ? "open" : "closed";
  }

  function Sx(e) {
    return function (t) {
      return "mouse" === t.pointerType ? e(t) : void 0;
    };
  }

  dx("MenuRadioGroup", {
    value: void 0,
    onValueChange: function onValueChange() {}
  }), dx("MenuItemIndicator", {
    checked: !1
  });

  var Lx = function Lx(e) {
    var t = e.__scopeMenu,
        _e$open = e.open,
        n = _e$open === void 0 ? !1 : _e$open,
        r = e.children,
        o = e.onOpenChange,
        _e$modal2 = e.modal,
        i = _e$modal2 === void 0 ? !0 : _e$modal2,
        a = px(t),
        _L$useState39 = L.useState(null),
        _L$useState40 = _slicedToArray(_L$useState39, 2),
        s = _L$useState40[0],
        l = _L$useState40[1],
        c = L.useRef(!1),
        u = zb(o),
        d = function (e, t) {
      var _L$useState41 = L.useState("ltr"),
          _L$useState42 = _slicedToArray(_L$useState41, 2),
          n = _L$useState42[0],
          r = _L$useState42[1],
          _L$useState43 = L.useState(),
          _L$useState44 = _slicedToArray(_L$useState43, 2),
          o = _L$useState44[0],
          i = _L$useState44[1],
          a = L.useRef(0);

      return L.useEffect(function () {
        if (void 0 === t && null != e && e.parentElement) {
          var _t37 = getComputedStyle(e.parentElement);

          i(_t37);
        }
      }, [e, t]), L.useEffect(function () {
        return void 0 === t && function e() {
          a.current = requestAnimationFrame(function () {
            var t = null == o ? void 0 : o.direction;
            t && r(t), e();
          });
        }(), function () {
          return cancelAnimationFrame(a.current);
        };
      }, [o, t, r]), t || n;
    }(s, e.dir);

    return L.useEffect(function () {
      var e = function e() {
        c.current = !0, document.addEventListener("pointerdown", t, {
          capture: !0,
          once: !0
        }), document.addEventListener("pointermove", t, {
          capture: !0,
          once: !0
        });
      },
          t = function t() {
        return c.current = !1;
      };

      return document.addEventListener("keydown", e, {
        capture: !0
      }), function () {
        document.removeEventListener("keydown", e, {
          capture: !0
        }), document.removeEventListener("pointerdown", t, {
          capture: !0
        }), document.removeEventListener("pointermove", t, {
          capture: !0
        });
      };
    }, []), L.createElement(Rv, a, L.createElement(mx, {
      scope: t,
      isSubmenu: !1,
      isUsingKeyboardRef: c,
      dir: d,
      open: n,
      onOpenChange: u,
      content: s,
      onContentChange: l,
      onRootClose: L.useCallback(function () {
        return u(!1);
      }, [u]),
      modal: i
    }, r));
  },
      Dx = function Dx(e) {
    var t = e.__scopeMenu,
        n = e.children,
        _e$open2 = e.open,
        r = _e$open2 === void 0 ? !1 : _e$open2,
        o = e.onOpenChange,
        i = gx("MenuSub", t),
        a = px(t),
        _L$useState45 = L.useState(null),
        _L$useState46 = _slicedToArray(_L$useState45, 2),
        s = _L$useState46[0],
        l = _L$useState46[1],
        _L$useState47 = L.useState(null),
        _L$useState48 = _slicedToArray(_L$useState47, 2),
        c = _L$useState48[0],
        u = _L$useState48[1],
        d = zb(o);

    return L.useEffect(function () {
      return !1 === i.open && d(!1), function () {
        return d(!1);
      };
    }, [i.open, d]), L.createElement(Rv, a, L.createElement(mx, {
      scope: t,
      isSubmenu: !0,
      isUsingKeyboardRef: i.isUsingKeyboardRef,
      dir: i.dir,
      open: r,
      onOpenChange: d,
      content: c,
      onContentChange: u,
      onRootClose: i.onRootClose,
      contentId: Db(),
      trigger: s,
      onTriggerChange: l,
      triggerId: Db(),
      modal: !1
    }, n));
  },
      Ax = yx,
      Nx = xx,
      Ix = Ex,
      _Zb9 = Zb("DropdownMenu", [fx]),
      _Zb10 = _slicedToArray(_Zb9, 2),
      zx = _Zb10[0],
      Ox = _Zb10[1],
      Rx = fx(),
      _zx = zx("DropdownMenu"),
      _zx2 = _slicedToArray(_zx, 2),
      Px = _zx2[0],
      Fx = _zx2[1],
      Bx = function Bx(e) {
    var t = e.__scopeDropdownMenu,
        n = e.children,
        r = e.dir,
        o = e.open,
        i = e.onOpenChange,
        a = e.onOpenToggle,
        _e$modal3 = e.modal,
        s = _e$modal3 === void 0 ? !0 : _e$modal3,
        l = Rx(t),
        c = L.useRef(null);
    return L.createElement(Px, {
      scope: t,
      isRootMenu: !0,
      triggerId: Db(),
      triggerRef: c,
      contentId: Db(),
      open: o,
      onOpenChange: i,
      onOpenToggle: a,
      modal: s
    }, L.createElement(Lx, Fd({}, l, {
      open: o,
      onOpenChange: i,
      dir: r,
      modal: s
    }), n));
  },
      qx = L.forwardRef(function (e, t) {
    var n = e.__scopeDropdownMenu,
        _e$disabled4 = e.disabled,
        r = _e$disabled4 === void 0 ? !1 : _e$disabled4,
        o = _objectWithoutProperties(e, _excluded111),
        i = Fx("DropdownMenuTrigger", n),
        a = Rx(n);

    return i.isRootMenu ? L.createElement(Ax, Fd({
      asChild: !0
    }, a), L.createElement(Hb.button, Fd({
      type: "button",
      id: i.triggerId,
      "aria-haspopup": "menu",
      "aria-expanded": !!i.open || void 0,
      "aria-controls": i.open ? i.contentId : void 0,
      "data-state": i.open ? "open" : "closed",
      "data-disabled": r ? "" : void 0,
      disabled: r
    }, o, {
      ref: Rb(t, i.triggerRef),
      onPointerDown: Gb(e.onPointerDown, function (e) {
        r || 0 !== e.button || !1 !== e.ctrlKey || (i.open || e.preventDefault(), i.onOpenToggle());
      }),
      onKeyDown: Gb(e.onKeyDown, function (e) {
        r || (["Enter", " "].includes(e.key) && i.onOpenToggle(), "ArrowDown" === e.key && i.onOpenChange(!0), [" ", "ArrowDown"].includes(e.key) && e.preventDefault());
      })
    }))) : null;
  }),
      _zx3 = zx("DropdownMenuContent", {
    isInsideContent: !1
  }),
      _zx4 = _slicedToArray(_zx3, 2),
      Ux = _zx4[0],
      Vx = _zx4[1],
      Hx = L.forwardRef(function (e, t) {
    var n = e.__scopeDropdownMenu,
        r = _objectWithoutProperties(e, _excluded112),
        o = Fx("DropdownMenuContent", n),
        i = Rx(n),
        a = _objectSpread(_objectSpread({}, r), {}, {
      style: _objectSpread(_objectSpread({}, e.style), {}, {
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)"
      })
    });

    return L.createElement(Ux, {
      scope: n,
      isInsideContent: !0
    }, o.isRootMenu ? L.createElement(Zx, Fd({
      __scopeDropdownMenu: n
    }, a, {
      ref: t
    })) : L.createElement(Nx, Fd({}, i, a, {
      ref: t
    })));
  }),
      Zx = L.forwardRef(function (e, t) {
    var n = e.__scopeDropdownMenu,
        _e$portalled = e.portalled,
        r = _e$portalled === void 0 ? !0 : _e$portalled,
        o = _objectWithoutProperties(e, _excluded113),
        i = Fx("DropdownMenuContent", n),
        a = Rx(n),
        s = L.useRef(!1);

    return i.isRootMenu ? L.createElement(Nx, Fd({
      id: i.contentId,
      "aria-labelledby": i.triggerId
    }, a, o, {
      ref: t,
      portalled: r,
      onCloseAutoFocus: Gb(e.onCloseAutoFocus, function (e) {
        var t;
        s.current || null === (t = i.triggerRef.current) || void 0 === t || t.focus(), s.current = !1, e.preventDefault();
      }),
      onInteractOutside: Gb(e.onInteractOutside, function (e) {
        var t = e.detail.originalEvent,
            n = 0 === t.button && !0 === t.ctrlKey,
            r = 2 === t.button || n;
        i.modal && !r || (s.current = !0);
      })
    })) : null;
  }),
      Wx = L.forwardRef(function (e, t) {
    var n = e.__scopeDropdownMenu,
        r = _objectWithoutProperties(e, _excluded114),
        o = Rx(n);

    return L.createElement(Ix, Fd({}, o, r, {
      ref: t
    }));
  }),
      $x = function $x(e) {
    var t = e.__scopeDropdownMenu,
        n = e.children,
        r = e.open,
        o = e.defaultOpen,
        i = e.onOpenChange,
        a = Vx("DropdownMenu", t),
        s = Rx(t),
        _Ob3 = Ob({
      prop: r,
      defaultProp: o,
      onChange: i
    }),
        _Ob4 = _slicedToArray(_Ob3, 2),
        _Ob4$ = _Ob4[0],
        l = _Ob4$ === void 0 ? !1 : _Ob4$,
        c = _Ob4[1],
        u = L.useCallback(function () {
      return c(function (e) {
        return !e;
      });
    }, [c]);

    return a.isInsideContent ? L.createElement(Px, {
      scope: t,
      isRootMenu: !1,
      open: l,
      onOpenChange: c,
      onOpenToggle: u
    }, L.createElement(Dx, Fd({}, s, {
      open: l,
      onOpenChange: c
    }), n)) : L.createElement(Bx, Fd({}, e, {
      open: l,
      onOpenChange: c,
      onOpenToggle: u
    }), n);
  },
      Gx = qx,
      Yx = Hx,
      Qx = Wx,
      Xx = _["default"](Yx).withConfig({
    displayName: "DropdownMenu__StyledContent",
    componentId: "sc-1t1t5ya-0"
  })(["background:", ";padding:", ";box-shadow:", ";border-radius:", ";font-weight:600;"], function (e) {
    return e.theme.colors.white;
  }, function (e) {
    return e.theme.space[1];
  }, function (e) {
    return e.theme.shadows[2];
  }, function (e) {
    return e.theme.radii.small;
  });

  Xx.displayName = "Dropdown.StyledContent";

  var Kx = _["default"](Ss).withConfig({
    shouldForwardProp: se
  }).attrs(function (e) {
    return {
      borderRadius: "rounded",
      color: "black",
      display: "block",
      fontSize: 0,
      fontWeight: 600,
      py: 2,
      px: ["0.75rem", null, 3],
      textAlign: "left",
      width: 1,
      as: e.as || (e.href ? "a" : "button")
    };
  }).withConfig({
    displayName: "DropdownMenu__MenuItem",
    componentId: "sc-1t1t5ya-1"
  })(["transition:unset;&:focus{background:", ";color:", ";outline:none;}"], function (e) {
    return e.disabled ? "transparent" : e.theme.colors.blue500;
  }, function (e) {
    return e.disabled ? "currentColor" : e.theme.colors.white;
  });

  function Jx(e) {
    var t = e.disabled,
        n = e.icon,
        r = e.iconWeight,
        o = e.label,
        i = e.onClick;
    return s.jsx(Qx, {
      asChild: !0,
      disabled: t,
      children: s.jsxs(Kx, {
        disabled: t,
        onClick: i,
        children: [n && s.jsx(fe, {
          display: "inline-block",
          width: "1.5rem",
          pr: 2,
          textAlign: "center",
          children: s.jsx(mc, {
            icon: n,
            weight: r
          })
        }), o]
      })
    });
  }

  function ew(e) {
    var t = e.disabled,
        n = e.href,
        r = e.icon,
        o = e.iconWeight,
        i = e.label;
    return s.jsx(Qx, {
      asChild: !0,
      disabled: t,
      children: s.jsxs(Kx, {
        disabled: t,
        href: t ? null : n,
        children: [r && s.jsx(fe, {
          display: "inline-block",
          width: "1.5rem",
          pr: 2,
          textAlign: "center",
          children: s.jsx(mc, {
            icon: r,
            weight: o
          })
        }), i]
      })
    });
  }

  Kx.displayName = "DropdownMenu.Item", Jx.defaultProps = {
    disabled: !1,
    icon: null,
    iconWeight: "light"
  }, Jx.propTypes = {
    disabled: T["default"].bool,
    icon: T["default"].string,
    iconWeight: T["default"].oneOf(["light", "regular", "solid", "brands"]),
    label: T["default"].oneOfType([T["default"].string, T["default"].node]).isRequired,
    onClick: T["default"].func.isRequired
  }, Jx.displayName = "DropdownMenu.Button", ew.defaultProps = {
    disabled: !1,
    icon: null,
    iconWeight: "light"
  }, ew.propTypes = {
    disabled: T["default"].bool,
    href: T["default"].string.isRequired,
    icon: T["default"].string,
    iconWeight: T["default"].oneOf(["light", "regular", "solid", "brands"]),
    label: T["default"].oneOfType([T["default"].string, T["default"].node]).isRequired
  }, ew.displayName = "DropdownMenu.Link";
  var tw = {
    Root: $x,
    Trigger: Gx,
    Content: Yx,
    StyledContent: Xx,
    ButtonItem: Jx,
    LinkItem: ew
  };

  var _Zb11 = Zb("HoverCard", [Sv]),
      _Zb12 = _slicedToArray(_Zb11, 2),
      nw = _Zb12[0],
      rw = _Zb12[1],
      ow = Sv(),
      _nw = nw("HoverCard"),
      _nw2 = _slicedToArray(_nw, 2),
      iw = _nw2[0],
      aw = _nw2[1],
      sw = L.forwardRef(function (e, t) {
    var n = e.__scopeHoverCard,
        r = _objectWithoutProperties(e, _excluded115),
        o = aw("HoverCardTrigger", n),
        i = ow(n);

    return L.createElement(Pv, Fd({
      asChild: !0
    }, i), L.createElement(Hb.a, Fd({
      "data-state": o.open ? "open" : "closed"
    }, r, {
      ref: t,
      onPointerEnter: Gb(e.onPointerEnter, dw(o.onOpen)),
      onPointerLeave: Gb(e.onPointerLeave, dw(o.onClose)),
      onFocus: Gb(e.onFocus, o.onOpen),
      onBlur: Gb(e.onBlur, o.onClose),
      onTouchStart: Gb(e.onTouchStart, function (e) {
        return e.preventDefault();
      })
    })));
  }),
      lw = L.forwardRef(function (e, t) {
    var n = e.forceMount,
        r = _objectWithoutProperties(e, _excluded116),
        o = aw("HoverCardContent", e.__scopeHoverCard);

    return L.createElement(qv, {
      present: n || o.open
    }, L.createElement(cw, Fd({
      "data-state": o.open ? "open" : "closed"
    }, r, {
      onPointerEnter: Gb(e.onPointerEnter, dw(o.onOpen)),
      onPointerLeave: Gb(e.onPointerLeave, dw(o.onClose)),
      ref: t
    })));
  }),
      cw = L.forwardRef(function (e, t) {
    var n = e.__scopeHoverCard,
        _e$portalled2 = e.portalled,
        r = _e$portalled2 === void 0 ? !0 : _e$portalled2,
        o = e.onEscapeKeyDown,
        i = e.onPointerDownOutside,
        a = e.onFocusOutside,
        s = e.onInteractOutside,
        l = _objectWithoutProperties(e, _excluded117),
        c = aw("HoverCardContent", n),
        u = ow(n),
        d = L.useRef(null),
        f = Pb(t, d),
        p = r ? uv : L.Fragment;

    return L.useEffect(function () {
      d.current && function (e) {
        var t = [],
            n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
          acceptNode: function acceptNode(e) {
            return e.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
          }
        });

        for (; n.nextNode();) {
          t.push(n.currentNode);
        }

        return t;
      }(d.current).forEach(function (e) {
        return e.setAttribute("tabindex", "-1");
      });
    }), L.createElement(p, null, L.createElement(tx, {
      asChild: !0,
      disableOutsidePointerEvents: !1,
      onInteractOutside: s,
      onEscapeKeyDown: o,
      onPointerDownOutside: i,
      onFocusOutside: a,
      onDismiss: c.onDismiss
    }, L.createElement(Fv, Fd({}, u, l, {
      ref: f,
      style: _objectSpread(_objectSpread({}, l.style), {}, {
        "--radix-hover-card-content-transform-origin": "var(--radix-popper-transform-origin)"
      })
    }))));
  }),
      uw = L.forwardRef(function (e, t) {
    var n = e.__scopeHoverCard,
        r = _objectWithoutProperties(e, _excluded118),
        o = ow(n);

    return L.createElement(Bv, Fd({}, o, r, {
      ref: t
    }));
  });

  function dw(e) {
    return function (t) {
      return "touch" === t.pointerType ? void 0 : e();
    };
  }

  var fw = function fw(e) {
    var t = e.__scopeHoverCard,
        n = e.children,
        r = e.open,
        o = e.defaultOpen,
        i = e.onOpenChange,
        _e$openDelay = e.openDelay,
        a = _e$openDelay === void 0 ? 700 : _e$openDelay,
        _e$closeDelay = e.closeDelay,
        s = _e$closeDelay === void 0 ? 300 : _e$closeDelay,
        l = ow(t),
        c = L.useRef(0),
        u = L.useRef(0),
        _Ob5 = Ob({
      prop: r,
      defaultProp: o,
      onChange: i
    }),
        _Ob6 = _slicedToArray(_Ob5, 2),
        _Ob6$ = _Ob6[0],
        d = _Ob6$ === void 0 ? !1 : _Ob6$,
        f = _Ob6[1],
        p = L.useCallback(function () {
      clearTimeout(u.current), c.current = window.setTimeout(function () {
        return f(!0);
      }, a);
    }, [a, f]),
        h = L.useCallback(function () {
      clearTimeout(c.current), u.current = window.setTimeout(function () {
        return f(!1);
      }, s);
    }, [s, f]),
        m = L.useCallback(function () {
      return f(!1);
    }, [f]);

    return L.useEffect(function () {
      return function () {
        clearTimeout(c.current), clearTimeout(u.current);
      };
    }, []), L.createElement(iw, {
      scope: t,
      open: d,
      onOpenChange: f,
      onOpen: p,
      onClose: h,
      onDismiss: m
    }, L.createElement(Rv, l, n));
  },
      pw = sw,
      hw = lw,
      mw = uw;

  function gw(e) {
    var t = e.background;
    return s.jsx(mw, {
      asChild: !0,
      children: s.jsx("svg", {
        width: "28",
        height: "9",
        viewBox: "0 0 28 9",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: s.jsx("path", {
          d: "M8.5 4C6.5 0.799997 5.65 -1.0258e-06 4 -9.53674e-07L24 -1.8279e-06C22.5 -1.76234e-06 21.5 1 19.5 4C16.8835 7.92477 16 9 14 9C12 9 11 8 8.5 4Z",
          fill: gc.colors[t]
        })
      })
    });
  }

  gw.defaultProps = {
    background: "black"
  }, gw.propTypes = {
    background: T["default"].string
  };

  var yw = _["default"](hw).attrs(function (e) {
    return {
      sideOffset: e.sideOffset || 2
    };
  }).withConfig({
    displayName: "Hovercard__StyledContent",
    componentId: "sc-rme6tg-0"
  })(["border-radius:", ";background-color:", ";box-shadow:", ";color:", ";max-width:calc(100vw - 2rem);padding:", " ", ";font-size:", ";"], function (e) {
    return e.theme.radii.rounded;
  }, function (e) {
    return e.background ? e.theme.colors[e.background] : e.theme.colors.black;
  }, function (e) {
    return e.theme.shadows[3];
  }, function (e) {
    return e.color ? e.theme.colors[e.color] : e.theme.colors.white;
  }, function (e) {
    return e.theme.space[2];
  }, function (e) {
    return e.theme.space[3];
  }, function (e) {
    return e.theme.fontSizes[0];
  });

  var bw = {
    Root: fw,
    Trigger: pw,
    Content: yw,
    Arrow: gw
  };
  var vw = {
    medium: {
      gap: "2px",
      height: "4px",
      firstBarWidth: "14px",
      secondBarWidth: "12px",
      thridBarWidth: "10px"
    },
    large: {
      gap: "4px",
      height: "6px",
      firstBarWidth: "24px",
      secondBarWidth: "20px",
      thridBarWidth: "15px"
    }
  };

  function xw(e) {
    var t = e.level,
        n = e.activeColor,
        r = e.inactiveColor,
        o = e.outline,
        i = e.size,
        a = _objectWithoutProperties(e, _excluded119);

    var _ref86 = function () {
      var e = o ? "transparent" : r,
          i = o ? n : r;
      return "3" === t ? {
        firstBar: {
          bg: n,
          borderColor: n
        },
        secondBar: {
          bg: n,
          borderColor: n
        },
        thridBar: {
          bg: n,
          borderColor: n
        }
      } : "2" === t ? {
        firstBar: {
          bg: n,
          borderColor: n
        },
        secondBar: {
          bg: n,
          borderColor: n
        },
        thridBar: {
          bg: e,
          borderColor: i
        }
      } : "0" === t ? {
        firstBar: {
          bg: e,
          borderColor: i
        },
        secondBar: {
          bg: e,
          borderColor: i
        },
        thridBar: {
          bg: e,
          borderColor: i
        }
      } : {
        firstBar: {
          bg: n,
          borderColor: n
        },
        secondBar: {
          bg: e,
          borderColor: i
        },
        thridBar: {
          bg: e,
          borderColor: i
        }
      };
    }(),
        l = _ref86.firstBar,
        c = _ref86.secondBar,
        u = _ref86.thridBar,
        _vw$i = vw[i],
        d = _vw$i.gap,
        f = _vw$i.height,
        p = _vw$i.firstBarWidth,
        h = _vw$i.secondBarWidth,
        m = _vw$i.thridBarWidth;

    return s.jsxs(fe, _objectSpread(_objectSpread({
      display: "inline-flex",
      flexDirection: "column",
      alignItems: "flex-end",
      style: {
        gap: d
      }
    }, a), {}, {
      children: [s.jsx(fe, {
        width: m,
        height: f,
        borderRadius: "medium",
        border: "1px solid",
        bg: u.bg,
        borderColor: u.borderColor
      }), s.jsx(fe, {
        width: h,
        height: f,
        borderRadius: "medium",
        border: "1px solid",
        bg: c.bg,
        borderColor: c.borderColor
      }), s.jsx(fe, {
        width: p,
        height: f,
        borderRadius: "medium",
        border: "1px solid",
        bg: l.bg,
        borderColor: l.borderColor
      })]
    }));
  }

  function ww(e) {
    var t = e.height;
    return s.jsx(fe, {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: t,
      children: s.jsx(Pc, {
        fontSize: 5,
        color: "blue500"
      })
    });
  }

  function kw(e) {
    var t = e.zIndex;
    return s.jsx(fe, {
      position: "fixed",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      bg: "rgba(0,0,0,0.5)",
      zIndex: t,
      children: s.jsx(Pc, {
        color: "white",
        weight: "solid",
        fontSize: 3
      })
    });
  }

  xw.defaultProps = {
    activeColor: "blue600",
    inactiveColor: "blue300",
    outline: !1,
    size: "medium",
    level: null
  }, xw.propTypes = {
    activeColor: T["default"].string,
    inactiveColor: T["default"].string,
    level: T["default"].string,
    outline: T["default"].bool,
    size: T["default"].oneOf(["medium", "large"])
  }, ww.defaultProps = {
    height: "50vh"
  }, ww.propTypes = {
    height: T["default"].string
  }, kw.defaultProps = {
    zIndex: "50"
  }, kw.propTypes = {
    zIndex: T["default"].oneOfType([T["default"].string, T["default"].number])
  };
  var Cw = gc.colors,
      Mw = Ja(ms);

  function jw(e) {
    var t = e.size,
        n = _objectWithoutProperties(e, _excluded120);

    return s.jsxs(Mw, _objectSpread(_objectSpread({
      width: t,
      height: gu(t, 94, 87),
      display: "inline-block",
      version: "1.1",
      viewBox: "0 0 87 94",
      xmlns: "http://www.w3.org/2000/svg",
      animate: {
        rotate: 360
      },
      preserveAspectRatio: "xMidYMid",
      style: {
        originX: "50%",
        originY: "54.25%"
      },
      transition: {
        repeat: 1 / 0,
        repeatType: "loop",
        ease: "linear",
        duration: 2
      }
    }, n), {}, {
      children: [s.jsx("title", {
        children: "A spinning paper plane"
      }), s.jsxs("g", {
        children: [s.jsxs("g", {
          children: [s.jsx("path", {
            fill: "none",
            stroke: Cw.black,
            strokeLinecap: "round",
            strokeMiterlimit: "10",
            d: "M52.8,10.7c-0.2,0-0.3-0.1-0.5-0.1"
          }), s.jsx("g", {
            children: s.jsx("path", {
              fill: Cw.black,
              d: "M2,56.8c0-0.3-0.1-0.7-0.1-1c0-0.3,0.2-0.5,0.4-0.6c0.3,0,0.5,0.2,0.6,0.4c0,0.3,0.1,0.7,0.1,1 c0,0.3-0.2,0.5-0.4,0.6c0,0,0,0-0.1,0C2.3,57.2,2,57,2,56.8z M1.7,52.8c0-0.3,0-0.7,0-1c0-0.3,0.2-0.5,0.5-0.5 c0.3,0,0.5,0.2,0.5,0.5c0,0.3,0,0.7,0,1c0,0.3-0.2,0.5-0.5,0.5c0,0,0,0,0,0C1.9,53.2,1.7,53,1.7,52.8z M2.2,49.3 c-0.3,0-0.5-0.3-0.5-0.5c0-0.3,0-0.7,0.1-1c0-0.3,0.3-0.5,0.5-0.5c0.3,0,0.5,0.3,0.5,0.5c0,0.3,0,0.7-0.1,1 C2.7,49.1,2.4,49.3,2.2,49.3C2.2,49.3,2.2,49.3,2.2,49.3z M2.5,45.3c-0.3,0-0.5-0.3-0.4-0.6c0-0.3,0.1-0.7,0.2-1 c0-0.3,0.3-0.5,0.6-0.4c0.3,0,0.5,0.3,0.4,0.6c-0.1,0.3-0.1,0.6-0.2,1C3,45.1,2.8,45.3,2.5,45.3C2.6,45.3,2.5,45.3,2.5,45.3z M3.2,41.4c-0.3-0.1-0.4-0.3-0.4-0.6c0.1-0.3,0.2-0.7,0.3-1c0.1-0.3,0.3-0.4,0.6-0.3c0.3,0.1,0.4,0.3,0.3,0.6 C4,40.4,3.9,40.7,3.8,41c-0.1,0.2-0.3,0.4-0.5,0.4C3.3,41.4,3.3,41.4,3.2,41.4z M4.4,37.6C4.1,37.5,4,37.2,4,37 c0.1-0.3,0.2-0.6,0.3-0.9c0.1-0.3,0.4-0.4,0.6-0.3c0.3,0.1,0.4,0.4,0.3,0.6C5.2,36.7,5.1,37,5,37.3c-0.1,0.2-0.3,0.3-0.5,0.3 C4.5,37.6,4.4,37.6,4.4,37.6z M5.8,33.9c-0.2-0.1-0.4-0.4-0.2-0.7c0.1-0.3,0.3-0.6,0.4-0.9c0.1-0.2,0.4-0.3,0.7-0.2 c0.2,0.1,0.3,0.4,0.2,0.7c-0.1,0.3-0.3,0.6-0.4,0.9c-0.1,0.2-0.3,0.3-0.5,0.3C6,33.9,5.9,33.9,5.8,33.9z M7.6,30.4 c-0.2-0.1-0.3-0.4-0.2-0.7c0.2-0.3,0.3-0.6,0.5-0.9c0.1-0.2,0.5-0.3,0.7-0.2c0.2,0.1,0.3,0.5,0.2,0.7c-0.2,0.3-0.3,0.6-0.5,0.8 c-0.1,0.2-0.3,0.2-0.4,0.2C7.8,30.4,7.7,30.4,7.6,30.4z M9.8,27c-0.2-0.2-0.3-0.5-0.1-0.7c0.2-0.3,0.4-0.5,0.6-0.8 c0.2-0.2,0.5-0.3,0.7-0.1c0.2,0.2,0.3,0.5,0.1,0.7c-0.2,0.3-0.4,0.5-0.6,0.8c-0.1,0.1-0.2,0.2-0.4,0.2C10,27.1,9.9,27.1,9.8,27z M12.3,23.9c-0.2-0.2-0.2-0.5,0-0.7c0.2-0.3,0.4-0.5,0.7-0.7c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7 c-0.2,0.2-0.4,0.5-0.7,0.7C12.9,24,12.7,24,12.6,24C12.5,24,12.3,24,12.3,23.9z M15,21c-0.2-0.2-0.2-0.5,0-0.7 c0.2-0.2,0.5-0.5,0.7-0.7c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7c-0.2,0.2-0.5,0.4-0.7,0.7c-0.1,0.1-0.2,0.1-0.3,0.1 C15.2,21.2,15.1,21.1,15,21z M18,18.4c-0.2-0.2-0.1-0.5,0.1-0.7c0.3-0.2,0.5-0.4,0.8-0.6c0.2-0.2,0.5-0.1,0.7,0.1 c0.2,0.2,0.1,0.5-0.1,0.7c-0.3,0.2-0.5,0.4-0.8,0.6c-0.1,0.1-0.2,0.1-0.3,0.1C18.3,18.6,18.1,18.6,18,18.4z M21.3,16.1 c-0.1-0.2-0.1-0.5,0.2-0.7c0.3-0.2,0.6-0.4,0.9-0.5c0.2-0.1,0.5-0.1,0.7,0.2c0.1,0.2,0.1,0.5-0.2,0.7c-0.3,0.2-0.6,0.3-0.8,0.5 c-0.1,0.1-0.2,0.1-0.3,0.1C21.5,16.4,21.3,16.3,21.3,16.1z M24.7,14.2c-0.1-0.2,0-0.5,0.2-0.7c0.3-0.1,0.6-0.3,0.9-0.4 c0.2-0.1,0.5,0,0.7,0.2c0.1,0.3,0,0.5-0.2,0.7c-0.3,0.1-0.6,0.3-0.9,0.4c-0.1,0-0.1,0.1-0.2,0.1C25,14.4,24.8,14.3,24.7,14.2z M28.3,12.5c-0.1-0.3,0-0.5,0.3-0.6c0.3-0.1,0.6-0.2,0.9-0.3c0.3-0.1,0.5,0,0.6,0.3c0.1,0.3,0,0.5-0.3,0.6 c-0.3,0.1-0.6,0.2-0.9,0.3c-0.1,0-0.1,0-0.2,0C28.6,12.8,28.4,12.7,28.3,12.5z M32.1,11.2c-0.1-0.3,0.1-0.5,0.4-0.6 c0.3-0.1,0.6-0.2,1-0.3c0.3-0.1,0.5,0.1,0.6,0.4c0.1,0.3-0.1,0.5-0.4,0.6c-0.3,0.1-0.6,0.2-1,0.2c0,0-0.1,0-0.1,0 C32.4,11.6,32.2,11.5,32.1,11.2z M36,10.3c0-0.3,0.1-0.5,0.4-0.6c0.3-0.1,0.7-0.1,1-0.2c0.3,0,0.5,0.1,0.6,0.4 c0,0.3-0.1,0.5-0.4,0.6c-0.3,0-0.6,0.1-1,0.2c0,0-0.1,0-0.1,0C36.2,10.8,36,10.6,36,10.3z M49.3,10.6c-0.3,0-0.6-0.1-1-0.1 c-0.3,0-0.5-0.3-0.4-0.6c0-0.3,0.3-0.5,0.6-0.4c0.3,0,0.7,0.1,1,0.1c0.3,0,0.5,0.3,0.4,0.6C49.8,10.4,49.6,10.6,49.3,10.6 C49.3,10.6,49.3,10.6,49.3,10.6z M39.9,9.8c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.7,0,1-0.1c0.3,0,0.5,0.2,0.5,0.5 c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.7,0-1,0.1c0,0,0,0,0,0C40.1,10.3,39.9,10.1,39.9,9.8z M45.4,10.2c-0.3,0-0.7,0-1,0 c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5c0,0,0,0,0,0c0.3,0,0.7,0,1,0c0.3,0,0.5,0.2,0.5,0.5C45.9,10,45.6,10.2,45.4,10.2 C45.4,10.2,45.4,10.2,45.4,10.2z"
            })
          })]
        }), s.jsxs("g", {
          children: [s.jsx("polygon", {
            fill: Cw.yellow500,
            points: "57.8,11.9 26.4,23.4 28,14.3 \t\t"
          }), s.jsx("polygon", {
            fill: Cw.yellow500,
            points: "28,9.4 57.8,11.9 26.5,1.1 \t\t"
          }), s.jsx("polygon", {
            fill: Cw.black,
            points: "57.8,11.9 28,14.3 32.7,11.9 \t\t"
          }), s.jsx("line", {
            fill: "none",
            stroke: Cw.black,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            x1: "36.3",
            y1: "13.4",
            x2: "26.4",
            y2: "23.5"
          }), s.jsx("polygon", {
            fill: Cw.gray900,
            points: "28,9.4 32.7,11.9 57.8,11.9 \t\t"
          }), s.jsx("line", {
            fill: "none",
            stroke: Cw.black,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            x1: "36.5",
            y1: "10",
            x2: "26.3",
            y2: "1.1"
          })]
        }), s.jsxs("g", {
          opacity: "0.1",
          children: [s.jsx("path", {
            fill: Cw.black,
            d: "M78.9,30.5c-0.2-0.3-0.3-0.6-0.5-0.8c-0.1-0.2-0.1-0.5,0.2-0.7c0.2-0.1,0.5-0.1,0.7,0.2 c0.2,0.3,0.3,0.6,0.5,0.9c0.1,0.2,0.1,0.5-0.2,0.7c-0.1,0-0.2,0.1-0.3,0.1C79.1,30.8,79,30.7,78.9,30.5z"
          }), s.jsx("path", {
            fill: Cw.black,
            d: "M76.7,27.2c-0.2-0.3-0.4-0.5-0.6-0.8c-0.2-0.2-0.1-0.5,0.1-0.7c0.2-0.2,0.5-0.1,0.7,0.1 c0.2,0.3,0.4,0.5,0.6,0.8c0.2,0.2,0.1,0.5-0.1,0.7c-0.1,0.1-0.2,0.1-0.3,0.1C77,27.4,76.8,27.3,76.7,27.2z"
          }), s.jsx("path", {
            fill: Cw.black,
            d: "M74.3,24.1c-0.2-0.2-0.4-0.5-0.7-0.7c-0.2-0.2-0.2-0.5,0-0.7c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.5,0.5,0.7,0.8 c0.2,0.2,0.2,0.5,0,0.7c-0.1,0.1-0.2,0.1-0.3,0.1C74.5,24.3,74.4,24.2,74.3,24.1z"
          }), s.jsx("path", {
            fill: "none",
            stroke: Cw.black,
            strokeLinecap: "round",
            strokeMiterlimit: "10",
            d: "M71.8,20.8c-0.1-0.1-0.2-0.2-0.4-0.3"
          })]
        }), s.jsxs("g", {
          opacity: "0.2",
          children: [s.jsx("path", {
            fill: Cw.black,
            d: "M84.3,49.2c0-0.3,0-0.7-0.1-1c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5c0,0.3,0,0.7,0.1,1 c0,0.3-0.2,0.5-0.5,0.5c0,0,0,0,0,0C84.6,49.7,84.4,49.4,84.3,49.2z"
          }), s.jsx("path", {
            fill: Cw.black,
            d: "M84,45.3c0-0.3-0.1-0.6-0.1-1c0-0.3,0.1-0.5,0.4-0.6c0.3-0.1,0.5,0.1,0.6,0.4c0.1,0.3,0.1,0.7,0.2,1 c0,0.3-0.2,0.5-0.4,0.6c0,0,0,0-0.1,0C84.2,45.7,84,45.5,84,45.3z"
          }), s.jsx("path", {
            fill: Cw.black,
            d: "M83.2,41.4c-0.1-0.3-0.2-0.6-0.2-1c-0.1-0.3,0.1-0.5,0.4-0.6c0.3-0.1,0.5,0.1,0.6,0.4c0.1,0.3,0.2,0.6,0.2,1 c0.1,0.3-0.1,0.5-0.4,0.6c0,0-0.1,0-0.1,0C83.5,41.8,83.3,41.6,83.2,41.4z"
          }), s.jsx("path", {
            fill: Cw.black,
            d: "M82.1,37.6c-0.1-0.3-0.2-0.6-0.3-0.9c-0.1-0.3,0-0.5,0.3-0.6c0.3-0.1,0.5,0,0.6,0.3c0.1,0.3,0.2,0.6,0.3,0.9 c0.1,0.3,0,0.5-0.3,0.6c-0.1,0-0.1,0-0.2,0C82.4,38,82.2,37.8,82.1,37.6z"
          }), s.jsx("path", {
            fill: Cw.black,
            d: "M80.7,34c-0.1-0.3-0.3-0.6-0.4-0.9c-0.1-0.2,0-0.5,0.2-0.7c0.2-0.1,0.5,0,0.7,0.2c0.1,0.3,0.3,0.6,0.4,0.9 c0.1,0.3,0,0.5-0.2,0.7c-0.1,0-0.1,0-0.2,0C80.9,34.3,80.8,34.2,80.7,34z"
          })]
        }), s.jsxs("g", {
          opacity: "0.3",
          children: [s.jsx("path", {
            fill: Cw.black,
            d: "M82.4,65.3c-0.3-0.1-0.4-0.4-0.3-0.6c0.1-0.3,0.2-0.6,0.3-0.9c0.1-0.3,0.4-0.4,0.6-0.3 c0.3,0.1,0.4,0.4,0.3,0.6c-0.1,0.3-0.2,0.6-0.3,1c-0.1,0.2-0.3,0.3-0.5,0.3C82.5,65.3,82.4,65.3,82.4,65.3z"
          }), s.jsx("path", {
            fill: Cw.black,
            d: "M83.6,61.5c-0.3-0.1-0.4-0.3-0.4-0.6c0.1-0.3,0.2-0.6,0.2-1c0.1-0.3,0.3-0.4,0.6-0.4c0.3,0.1,0.4,0.3,0.4,0.6 c-0.1,0.3-0.1,0.7-0.2,1c-0.1,0.2-0.3,0.4-0.5,0.4C83.6,61.5,83.6,61.5,83.6,61.5z"
          }), s.jsx("path", {
            fill: Cw.black,
            d: "M84.4,57.6c-0.3,0-0.5-0.3-0.4-0.6c0-0.3,0.1-0.6,0.1-1c0-0.3,0.3-0.5,0.6-0.4c0.3,0,0.5,0.3,0.4,0.6 c0,0.3-0.1,0.7-0.1,1C84.9,57.4,84.7,57.6,84.4,57.6C84.4,57.6,84.4,57.6,84.4,57.6z"
          }), s.jsx("path", {
            fill: Cw.black,
            d: "M84.8,53.6c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0-0.7,0-1c0-0.3,0.2-0.5,0.5-0.5c0,0,0,0,0,0c0.3,0,0.5,0.2,0.5,0.5 c0,0.3,0,0.7,0,1C85.3,53.4,85.1,53.6,84.8,53.6C84.8,53.6,84.8,53.6,84.8,53.6z"
          })]
        }), s.jsxs("g", {
          opacity: "0.4",
          children: [s.jsx("path", {
            fill: Cw.black,
            d: "M71.4,81.6c-0.2-0.2-0.2-0.5,0-0.7c0.2-0.2,0.5-0.5,0.7-0.7c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7 c-0.2,0.2-0.5,0.5-0.7,0.7c-0.1,0.1-0.2,0.1-0.3,0.1C71.7,81.8,71.5,81.7,71.4,81.6z"
          }), s.jsx("path", {
            fill: Cw.black,
            d: "M74.2,78.8c-0.2-0.2-0.2-0.5,0-0.7c0.2-0.2,0.4-0.5,0.6-0.7c0.2-0.2,0.5-0.2,0.7-0.1c0.2,0.2,0.2,0.5,0.1,0.7 c-0.2,0.3-0.4,0.5-0.7,0.8c-0.1,0.1-0.2,0.2-0.4,0.2C74.4,78.9,74.3,78.9,74.2,78.8z"
          }), s.jsx("path", {
            fill: Cw.black,
            d: "M76.7,75.7c-0.2-0.2-0.3-0.5-0.1-0.7c0.2-0.3,0.4-0.5,0.6-0.8c0.2-0.2,0.5-0.3,0.7-0.1 c0.2,0.2,0.3,0.5,0.1,0.7c-0.2,0.3-0.4,0.5-0.6,0.8c-0.1,0.1-0.3,0.2-0.4,0.2C76.9,75.8,76.8,75.8,76.7,75.7z"
          }), s.jsx("path", {
            fill: Cw.black,
            d: "M79,72.4c-0.2-0.1-0.3-0.4-0.2-0.7c0.2-0.3,0.3-0.6,0.5-0.9c0.1-0.2,0.4-0.3,0.7-0.2s0.3,0.4,0.2,0.7 c-0.2,0.3-0.3,0.6-0.5,0.9c-0.1,0.2-0.3,0.2-0.4,0.2C79.1,72.5,79,72.5,79,72.4z"
          }), s.jsx("path", {
            fill: Cw.black,
            d: "M80.8,68.9c-0.3-0.1-0.4-0.4-0.2-0.7c0.1-0.3,0.3-0.6,0.4-0.9c0.1-0.3,0.4-0.4,0.7-0.3 c0.3,0.1,0.4,0.4,0.3,0.7c-0.1,0.3-0.3,0.6-0.4,0.9c-0.1,0.2-0.3,0.3-0.5,0.3C81,69,80.9,69,80.8,68.9z"
          })]
        }), s.jsxs("g", {
          opacity: "0.5",
          children: [s.jsx("path", {
            fill: Cw.black,
            d: "M57.9,89.9c-0.1-0.3,0-0.5,0.3-0.6c0.3-0.1,0.6-0.2,0.9-0.4c0.3-0.1,0.5,0,0.7,0.3c0.1,0.3,0,0.5-0.3,0.7 c-0.3,0.1-0.6,0.3-0.9,0.4c-0.1,0-0.1,0-0.2,0C58.2,90.2,58,90.1,57.9,89.9z"
          }), s.jsx("path", {
            fill: Cw.black,
            d: "M61.6,88.3c-0.1-0.2,0-0.5,0.2-0.7c0.3-0.1,0.6-0.3,0.9-0.5c0.2-0.1,0.5,0,0.7,0.2c0.1,0.2,0,0.5-0.2,0.7 c-0.3,0.2-0.6,0.3-0.9,0.5c-0.1,0-0.1,0.1-0.2,0.1C61.8,88.6,61.7,88.5,61.6,88.3z"
          }), s.jsx("path", {
            fill: Cw.black,
            d: "M65.1,86.4c-0.1-0.2-0.1-0.5,0.2-0.7c0.3-0.2,0.6-0.4,0.8-0.5c0.2-0.2,0.5-0.1,0.7,0.1 c0.2,0.2,0.1,0.5-0.1,0.7c-0.3,0.2-0.6,0.4-0.8,0.5c-0.1,0.1-0.2,0.1-0.3,0.1C65.3,86.6,65.2,86.5,65.1,86.4z"
          }), s.jsx("path", {
            fill: Cw.black,
            d: "M68.4,84.1c-0.2-0.2-0.1-0.5,0.1-0.7c0.3-0.2,0.5-0.4,0.8-0.6c0.2-0.2,0.5-0.1,0.7,0.1 c0.2,0.2,0.1,0.5-0.1,0.7c-0.3,0.2-0.5,0.4-0.8,0.6c-0.1,0.1-0.2,0.1-0.3,0.1C68.6,84.3,68.5,84.3,68.4,84.1z"
          })]
        }), s.jsxs("g", {
          opacity: "0.6",
          children: [s.jsx("path", {
            fill: Cw.black,
            d: "M42.8,92.9c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5c0.2,0,0.5,0,0.7,0l0.3,0c0.3,0,0.5,0.2,0.5,0.5 s-0.2,0.5-0.5,0.5l-0.3,0C43.3,92.9,43,92.9,42.8,92.9z"
          }), s.jsx("path", {
            fill: Cw.black,
            d: "M46.3,92.3c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.7-0.1,1-0.1c0.3,0,0.5,0.2,0.5,0.4c0,0.3-0.2,0.5-0.4,0.5 c-0.3,0-0.7,0.1-1,0.1c0,0,0,0,0,0C46.5,92.8,46.3,92.6,46.3,92.3z"
          }), s.jsx("path", {
            fill: Cw.black,
            d: "M50.2,91.9c0-0.3,0.1-0.5,0.4-0.6c0.3-0.1,0.6-0.1,1-0.2c0.3-0.1,0.5,0.1,0.6,0.4c0.1,0.3-0.1,0.5-0.4,0.6 c-0.3,0.1-0.7,0.1-1,0.2c0,0-0.1,0-0.1,0C50.5,92.3,50.3,92.1,50.2,91.9z"
          }), s.jsx("path", {
            fill: Cw.black,
            d: "M54.1,91.1c-0.1-0.3,0.1-0.5,0.3-0.6c0.3-0.1,0.6-0.2,0.9-0.3c0.3-0.1,0.5,0.1,0.6,0.3S56,91,55.7,91.1 c-0.3,0.1-0.6,0.2-1,0.3c0,0-0.1,0-0.1,0C54.4,91.4,54.2,91.3,54.1,91.1z"
          })]
        }), s.jsxs("g", {
          opacity: "0.7",
          children: [s.jsx("path", {
            fill: Cw.black,
            d: "M39.8,92.8c-0.3,0-0.7-0.1-1-0.1c-0.3,0-0.5-0.3-0.4-0.6c0-0.3,0.3-0.5,0.6-0.4c0.3,0,0.6,0.1,1,0.1 c0.3,0,0.5,0.3,0.5,0.5C40.3,92.6,40.1,92.8,39.8,92.8C39.8,92.8,39.8,92.8,39.8,92.8z"
          }), s.jsx("path", {
            fill: Cw.black,
            d: "M35.8,92.2c-0.3-0.1-0.7-0.1-1-0.2c-0.3-0.1-0.4-0.3-0.4-0.6c0.1-0.3,0.3-0.4,0.6-0.4c0.3,0.1,0.6,0.1,1,0.2 c0.3,0,0.5,0.3,0.4,0.6C36.3,92.1,36.1,92.2,35.8,92.2C35.9,92.2,35.8,92.2,35.8,92.2z"
          }), s.jsx("path", {
            fill: Cw.black,
            d: "M31.9,91.3c-0.3-0.1-0.6-0.2-1-0.3c-0.3-0.1-0.4-0.4-0.3-0.6c0.1-0.3,0.4-0.4,0.6-0.3 c0.3,0.1,0.6,0.2,0.9,0.3c0.3,0.1,0.4,0.4,0.3,0.6c-0.1,0.2-0.3,0.4-0.5,0.4C32,91.3,31.9,91.3,31.9,91.3z"
          }), s.jsx("path", {
            fill: Cw.black,
            d: "M28.1,90c-0.3-0.1-0.6-0.2-0.9-0.4c-0.3-0.1-0.4-0.4-0.3-0.7c0.1-0.3,0.4-0.4,0.7-0.3 c0.3,0.1,0.6,0.3,0.9,0.4c0.3,0.1,0.4,0.4,0.3,0.6c-0.1,0.2-0.3,0.3-0.5,0.3C28.2,90,28.1,90,28.1,90z"
          })]
        }), s.jsxs("g", {
          opacity: "0.8",
          children: [s.jsx("path", {
            fill: Cw.black,
            d: "M24.4,88.3c-0.3-0.2-0.6-0.3-0.9-0.5c-0.2-0.1-0.3-0.4-0.2-0.7c0.1-0.2,0.4-0.3,0.7-0.2 c0.3,0.2,0.6,0.3,0.9,0.5c0.2,0.1,0.3,0.4,0.2,0.7c-0.1,0.2-0.3,0.3-0.4,0.3C24.6,88.4,24.5,88.4,24.4,88.3z"
          }), s.jsx("path", {
            fill: Cw.black,
            d: "M20.9,86.3c-0.3-0.2-0.6-0.4-0.8-0.6c-0.2-0.2-0.3-0.5-0.1-0.7c0.2-0.2,0.5-0.3,0.7-0.1 c0.3,0.2,0.5,0.4,0.8,0.5c0.2,0.1,0.3,0.5,0.2,0.7c-0.1,0.1-0.3,0.2-0.4,0.2C21.1,86.4,21,86.4,20.9,86.3z"
          }), s.jsx("path", {
            fill: Cw.black,
            d: "M17.7,84c-0.3-0.2-0.5-0.4-0.8-0.6c-0.2-0.2-0.2-0.5-0.1-0.7c0.2-0.2,0.5-0.2,0.7-0.1 c0.3,0.2,0.5,0.4,0.8,0.6c0.2,0.2,0.3,0.5,0.1,0.7c-0.1,0.1-0.2,0.2-0.4,0.2C17.9,84.1,17.8,84.1,17.7,84z"
          }), s.jsx("path", {
            fill: Cw.black,
            d: "M14.6,81.4c-0.2-0.2-0.5-0.5-0.7-0.7c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0c0.2,0.2,0.5,0.5,0.7,0.7 c0.2,0.2,0.2,0.5,0,0.7c-0.1,0.1-0.2,0.2-0.4,0.2C14.8,81.5,14.7,81.5,14.6,81.4z"
          }), s.jsx("path", {
            fill: Cw.black,
            d: "M11.8,78.5c-0.2-0.3-0.4-0.5-0.7-0.8c-0.2-0.2-0.1-0.5,0.1-0.7c0.2-0.2,0.5-0.1,0.7,0.1 c0.2,0.3,0.4,0.5,0.6,0.7c0.2,0.2,0.2,0.5,0,0.7c-0.1,0.1-0.2,0.1-0.3,0.1C12.1,78.6,11.9,78.6,11.8,78.5z"
          })]
        }), s.jsxs("g", {
          opacity: "0.9",
          children: [s.jsx("path", {
            fill: Cw.black,
            d: "M9.4,75.3C9.2,75,9,74.8,8.8,74.5c-0.2-0.2-0.1-0.5,0.1-0.7c0.2-0.2,0.5-0.1,0.7,0.1c0.2,0.3,0.4,0.5,0.6,0.8 c0.2,0.2,0.1,0.5-0.1,0.7c-0.1,0.1-0.2,0.1-0.3,0.1C9.6,75.5,9.5,75.5,9.4,75.3z"
          }), s.jsx("path", {
            fill: Cw.black,
            d: "M7.2,71.9C7,71.6,6.9,71.3,6.7,71c-0.1-0.2,0-0.5,0.2-0.7c0.2-0.1,0.5,0,0.7,0.2c0.2,0.3,0.3,0.6,0.5,0.9 c0.1,0.2,0.1,0.5-0.2,0.7c-0.1,0-0.2,0.1-0.2,0.1C7.4,72.2,7.3,72.1,7.2,71.9z"
          }), s.jsx("path", {
            fill: Cw.black,
            d: "M5.3,68.3c-0.1-0.3-0.3-0.6-0.4-0.9c-0.1-0.3,0-0.5,0.3-0.7c0.3-0.1,0.5,0,0.7,0.3c0.1,0.3,0.3,0.6,0.4,0.9 c0.1,0.3,0,0.5-0.2,0.7c-0.1,0-0.1,0-0.2,0C5.6,68.6,5.4,68.5,5.3,68.3z"
          }), s.jsx("path", {
            fill: Cw.black,
            d: "M3.9,64.6c-0.1-0.3-0.2-0.6-0.3-1c-0.1-0.3,0.1-0.5,0.3-0.6c0.3-0.1,0.5,0.1,0.6,0.3c0.1,0.3,0.2,0.6,0.3,0.9 c0.1,0.3-0.1,0.5-0.3,0.6c-0.1,0-0.1,0-0.2,0C4.1,64.9,3.9,64.8,3.9,64.6z"
          }), s.jsx("path", {
            fill: Cw.black,
            d: "M2.7,60.7c-0.1-0.3-0.2-0.7-0.2-1c-0.1-0.3,0.1-0.5,0.4-0.6c0.3-0.1,0.5,0.1,0.6,0.4c0.1,0.3,0.1,0.6,0.2,1 c0.1,0.3-0.1,0.5-0.4,0.6c0,0-0.1,0-0.1,0C3,61.1,2.8,61,2.7,60.7z"
          })]
        })]
      })]
    }));
  }

  function Ew(e) {
    var t = e.component,
        n = _objectWithoutProperties(e, _excluded121);

    var r = t;
    return s.jsx(o.Suspense, {
      fallback: s.jsx(ww, {}),
      children: s.jsx(r, _objectSpread({}, n))
    });
  }

  jw.defaultProps = {
    size: 100
  }, jw.propTypes = {
    size: T["default"].number
  }, Ew.propTypes = {
    component: T["default"].object.isRequired
  };

  var _w = _["default"](Ss).attrs(function () {
    return {
      bg: "white",
      borderRadius: "rounded",
      fontSize: 3,
      lineHeight: 1,
      p: 2,
      "aria-label": "More options"
    };
  }).withConfig({
    displayName: "MoreOptions__Trigger",
    componentId: "sc-vucxo3-0"
  })(["&:hover,&:active,&[data-state='open']{box-shadow:", ";}&:focus{outline:none;box-shadow:0 0 0 2px ", ";}"], function (e) {
    return e.theme.shadows[2];
  }, function (e) {
    return e.theme.colors.blue500;
  });

  function Tw(e) {
    var t = e.children;
    return s.jsxs(tw.Root, {
      children: [s.jsx(tw.Trigger, {
        asChild: !0,
        children: s.jsx(_w, {
          children: s.jsx(mc, {
            weight: "regular",
            icon: "ellipsis-h",
            color: "blue500"
          })
        })
      }), s.jsx(tw.StyledContent, {
        align: "end",
        sideOffset: 4,
        children: t
      })]
    });
  }

  _w.displayName = "MoreOptions.Trigger", Tw.propTypes = {
    children: T["default"].node.isRequired
  }, Tw.Button = tw.ButtonItem, Tw.Link = tw.LinkItem;

  function Sw(e) {
    var t = e.currentPage,
        n = e.totalPages,
        r = e.onPageButtonClicked,
        i = _objectWithoutProperties(e, _excluded122);

    var _o$useState57 = o.useState(!1),
        _o$useState58 = _slicedToArray(_o$useState57, 2),
        a = _o$useState58[0],
        l = _o$useState58[1],
        c = function c() {
      var e;
      return l((null === (e = window) || void 0 === e ? void 0 : e.innerWidth) < 640);
    };

    return o.useLayoutEffect(function () {
      var e = null;
      c();

      var t = function t() {
        clearTimeout(e), e = setTimeout(c(), 200);
      };

      return window && window.addEventListener("resize", t), function () {
        window && window.removeEventListener("resize", t);
      };
    }, []), n <= 1 ? "" : s.jsxs(Zc, _objectSpread(_objectSpread({
      display: "flex",
      justifyContent: "center"
    }, i), {}, {
      children: [s.jsx(Ss, {
        bg: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "2.5rem",
        height: "2.5rem",
        p: 2,
        boxShadow: 3,
        borderRadius: "circular",
        disabled: 1 === t,
        onClick: function onClick() {
          return r(t - 1);
        },
        mr: 2,
        "aria-label": "Previous page",
        secondary: !0,
        small: !0,
        children: s.jsx(mc, {
          icon: "arrow-left"
        })
      }), _toConsumableArray(Array(n)).map(function (e, o) {
        var i = o + 1;
        if (i === t) return s.jsx(fe, {
          p: 2,
          mx: 2,
          borderRadius: "rounded",
          bg: "gray150",
          fontWeight: "600",
          children: i
        }, "page".concat(i));
        if (function (e) {
          return n >= 9 && e > 1 && e < n || a;
        }(i)) switch (i) {
          case t - 2:
          case t + 2:
            return s.jsx(fe, {
              py: 2,
              children: "..."
            }, "page".concat(i));

          case t + 1:
          case t - 1:
            break;

          default:
            return "";
        }
        return s.jsx(Ss, {
          p: 2,
          mx: 2,
          borderRadius: "rounded",
          onClick: function onClick() {
            return r(i);
          },
          children: i
        }, "page".concat(i));
      }), s.jsx(Ss, {
        bg: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "2.5rem",
        height: "2.5rem",
        p: 2,
        boxShadow: 3,
        borderRadius: "circular",
        disabled: t === n,
        onClick: function onClick() {
          return r(t + 1);
        },
        ml: 2,
        "aria-label": "Next page",
        secondary: !0,
        small: !0,
        children: s.jsx(mc, {
          icon: "arrow-right"
        })
      })]
    }));
  }

  Sw.displayName = "Pagination", Sw.propTypes = {
    currentPage: T["default"].number.isRequired,
    onPageButtonClicked: T["default"].func.isRequired,
    totalPages: T["default"].number.isRequired
  };

  var Lw = _["default"](fe).withConfig({
    displayName: "PieChart__Pie",
    componentId: "sc-1ayz145-0"
  })(["@property --percentage{syntax:'<number>';inherits:true;initial-value:0;}--width:", ";--percentage:", ";--border-thickness:", ";--path-color:", ";--path-background:", ";width:", ";aspect-ratio:1;position:relative;display:inline-grid;place-content:center;margin:4px;font-size:25px;font-weight:bold;font-family:sans-serif;&:before{content:'';position:absolute;border-radius:50%;inset:0;background:radial-gradient(farthest-side,var(--path-color) 98%,#0000) top/var(--border-thickness) var(--border-thickness) no-repeat,conic-gradient( var(--path-color) calc(var(--percentage) * 1%),var(--path-background) 0 );-webkit-mask:radial-gradient( farthest-side,#0000 calc(99% - var(--border-thickness)),#000 calc(100% - var(--border-thickness)) );mask:radial-gradient( farthest-side,#0000 calc(99% - var(--border-thickness)),#000 calc(100% - var(--border-thickness)) );}:after{content:'';position:absolute;border-radius:50%;inset:calc(50% - var(--border-thickness) / 2);background:var(--path-color);transform:rotate(calc(var(--percentage) * 3.6deg)) translateY(calc(50% - var(--width) / 2));}@keyframes stuffpie{from{--percentage:0;}}animation:stuffpie 1s 0.5s both;"], function (e) {
    return e.width;
  }, function (e) {
    return e.$percentage;
  }, function (e) {
    return e.$borderThickness;
  }, function (e) {
    return e.theme.colors[e.$pathColor];
  }, function (e) {
    return e.theme.colors[e.$pathBackground];
  }, function (e) {
    return e.width;
  });

  function Dw(e) {
    var t = e.percentage,
        n = e.borderThickness,
        r = e.width,
        o = e.pathColor,
        i = e.pathBackground,
        a = e.chartBackground,
        l = e.showLabel;
    return s.jsx(fe, {
      display: "flex",
      width: "fit-content",
      borderRadius: "circular",
      background: a,
      children: s.jsx(Lw, {
        $percentage: t,
        $borderThickness: n,
        width: r,
        $pathColor: o,
        $pathBackground: i,
        children: l && s.jsxs(ys, {
          children: [t, "%"]
        })
      })
    });
  }

  Dw.defaultProps = {
    percentage: 75,
    borderThickness: "20px",
    width: "100px",
    pathColor: "blue600",
    pathBackground: "gray200",
    chartBackground: "white",
    showLabel: !1
  }, Dw.propTypes = {
    percentage: T["default"].number,
    borderThickness: T["default"].string,
    width: T["default"].string,
    pathColor: T["default"].string,
    pathBackground: T["default"].string,
    chartBackground: T["default"].string,
    showLabel: T["default"].bool
  };

  var _Zb13 = Zb("Popover", [Sv]),
      _Zb14 = _slicedToArray(_Zb13, 2),
      Aw = _Zb14[0],
      Nw = _Zb14[1],
      Iw = Sv(),
      _Aw = Aw("Popover"),
      _Aw2 = _slicedToArray(_Aw, 2),
      zw = _Aw2[0],
      Ow = _Aw2[1],
      Rw = L.forwardRef(function (e, t) {
    var n = e.__scopePopover,
        r = _objectWithoutProperties(e, _excluded123),
        o = Ow("PopoverAnchor", n),
        i = Iw(n),
        a = o.onCustomAnchorAdd,
        s = o.onCustomAnchorRemove;

    return L.useEffect(function () {
      return a(), function () {
        return s();
      };
    }, [a, s]), L.createElement(Pv, Fd({}, i, r, {
      ref: t
    }));
  }),
      Pw = L.forwardRef(function (e, t) {
    var n = e.__scopePopover,
        r = _objectWithoutProperties(e, _excluded124),
        o = Ow("PopoverTrigger", n),
        i = Iw(n),
        a = Pb(t, o.triggerRef),
        s = L.createElement(Hb.button, Fd({
      type: "button",
      "aria-haspopup": "dialog",
      "aria-expanded": o.open,
      "aria-controls": o.contentId,
      "data-state": Hw(o.open)
    }, r, {
      ref: a,
      onClick: Gb(e.onClick, o.onOpenToggle)
    }));

    return o.hasCustomAnchor ? s : L.createElement(Pv, Fd({
      asChild: !0
    }, i), s);
  }),
      Fw = L.forwardRef(function (e, t) {
    var n = e.forceMount,
        r = _objectWithoutProperties(e, _excluded125),
        o = Ow("PopoverContent", e.__scopePopover);

    return L.createElement(qv, {
      present: n || o.open
    }, o.modal ? L.createElement(Bw, Fd({}, r, {
      ref: t
    })) : L.createElement(qw, Fd({}, r, {
      ref: t
    })));
  }),
      Bw = L.forwardRef(function (e, t) {
    var n = e.allowPinchZoom,
        _e$portalled3 = e.portalled,
        r = _e$portalled3 === void 0 ? !0 : _e$portalled3,
        o = _objectWithoutProperties(e, _excluded126),
        i = Ow("PopoverContent", e.__scopePopover),
        a = L.useRef(null),
        s = Pb(t, a),
        l = L.useRef(!1);

    L.useEffect(function () {
      var e = a.current;
      if (e) return Yg(e);
    }, []);
    var c = r ? uv : L.Fragment;
    return L.createElement(c, null, L.createElement(Hg, {
      allowPinchZoom: n
    }, L.createElement(Uw, Fd({}, o, {
      ref: s,
      trapFocus: i.open,
      disableOutsidePointerEvents: !0,
      onCloseAutoFocus: Gb(e.onCloseAutoFocus, function (e) {
        var t;
        e.preventDefault(), l.current || null === (t = i.triggerRef.current) || void 0 === t || t.focus();
      }),
      onPointerDownOutside: Gb(e.onPointerDownOutside, function (e) {
        var t = e.detail.originalEvent,
            n = 0 === t.button && !0 === t.ctrlKey,
            r = 2 === t.button || n;
        l.current = r;
      }, {
        checkForDefaultPrevented: !1
      }),
      onFocusOutside: Gb(e.onFocusOutside, function (e) {
        return e.preventDefault();
      }, {
        checkForDefaultPrevented: !1
      })
    }))));
  }),
      qw = L.forwardRef(function (e, t) {
    var _e$portalled4 = e.portalled,
        n = _e$portalled4 === void 0 ? !0 : _e$portalled4,
        r = _objectWithoutProperties(e, _excluded127),
        o = Ow("PopoverContent", e.__scopePopover),
        i = L.useRef(!1),
        a = n ? uv : L.Fragment;

    return L.createElement(a, null, L.createElement(Uw, Fd({}, r, {
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      onCloseAutoFocus: function onCloseAutoFocus(t) {
        var n, r;
        null === (n = e.onCloseAutoFocus) || void 0 === n || n.call(e, t), t.defaultPrevented || (i.current || null === (r = o.triggerRef.current) || void 0 === r || r.focus(), t.preventDefault()), i.current = !1;
      },
      onInteractOutside: function onInteractOutside(t) {
        var n, r;
        null === (n = e.onInteractOutside) || void 0 === n || n.call(e, t), t.defaultPrevented || (i.current = !0);
        var a = t.target;
        (null === (r = o.triggerRef.current) || void 0 === r ? void 0 : r.contains(a)) && t.preventDefault();
      }
    })));
  }),
      Uw = L.forwardRef(function (e, t) {
    var n = e.__scopePopover,
        r = e.trapFocus,
        o = e.onOpenAutoFocus,
        i = e.onCloseAutoFocus,
        a = e.disableOutsidePointerEvents,
        s = e.onEscapeKeyDown,
        l = e.onPointerDownOutside,
        c = e.onFocusOutside,
        u = e.onInteractOutside,
        d = _objectWithoutProperties(e, _excluded128),
        f = Ow("PopoverContent", n),
        p = Iw(n);

    return Nb(), L.createElement(Hv, {
      asChild: !0,
      loop: !0,
      trapped: r,
      onMountAutoFocus: o,
      onUnmountAutoFocus: i
    }, L.createElement(tx, {
      asChild: !0,
      disableOutsidePointerEvents: a,
      onInteractOutside: u,
      onEscapeKeyDown: s,
      onPointerDownOutside: l,
      onFocusOutside: c,
      onDismiss: function onDismiss() {
        return f.onOpenChange(!1);
      }
    }, L.createElement(Fv, Fd({
      "data-state": Hw(f.open),
      role: "dialog",
      id: f.contentId
    }, p, d, {
      ref: t,
      style: _objectSpread(_objectSpread({}, d.style), {}, {
        "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)"
      })
    }))));
  }),
      Vw = L.forwardRef(function (e, t) {
    var n = e.__scopePopover,
        r = _objectWithoutProperties(e, _excluded129),
        o = Iw(n);

    return L.createElement(Bv, Fd({}, o, r, {
      ref: t
    }));
  });

  function Hw(e) {
    return e ? "open" : "closed";
  }

  var Zw = function Zw(e) {
    var t = e.__scopePopover,
        n = e.children,
        r = e.open,
        o = e.defaultOpen,
        i = e.onOpenChange,
        _e$modal4 = e.modal,
        a = _e$modal4 === void 0 ? !1 : _e$modal4,
        s = Iw(t),
        l = L.useRef(null),
        _L$useState49 = L.useState(!1),
        _L$useState50 = _slicedToArray(_L$useState49, 2),
        c = _L$useState50[0],
        u = _L$useState50[1],
        _Ob7 = Ob({
      prop: r,
      defaultProp: o,
      onChange: i
    }),
        _Ob8 = _slicedToArray(_Ob7, 2),
        _Ob8$ = _Ob8[0],
        d = _Ob8$ === void 0 ? !1 : _Ob8$,
        f = _Ob8[1];

    return L.createElement(Rv, s, L.createElement(zw, {
      scope: t,
      contentId: Db(),
      triggerRef: l,
      open: d,
      onOpenChange: f,
      onOpenToggle: L.useCallback(function () {
        return f(function (e) {
          return !e;
        });
      }, [f]),
      hasCustomAnchor: c,
      onCustomAnchorAdd: L.useCallback(function () {
        return u(!0);
      }, []),
      onCustomAnchorRemove: L.useCallback(function () {
        return u(!1);
      }, []),
      modal: a
    }, n));
  },
      Ww = Rw,
      $w = Pw,
      Gw = Fw,
      Yw = Vw,
      Qw = _["default"](Gw).withConfig({
    displayName: "Popover__StyledContent",
    componentId: "sc-15hbvn8-0"
  })(["border-radius:", ";background-color:", ";box-shadow:", ";color:", ";max-width:calc(100vw - 2rem);padding:", ";"], function (e) {
    return e.theme.radii.rounded;
  }, function (e) {
    return e.theme.colors.black;
  }, function (e) {
    return e.theme.shadows[3];
  }, function (e) {
    return e.theme.colors.white;
  }, function (e) {
    return e.theme.space[3];
  }),
      Xw = _["default"](Yw).withConfig({
    displayName: "Popover__StyledArrow",
    componentId: "sc-15hbvn8-1"
  })(["fill:", ";"], function (e) {
    return e.theme.colors.black;
  });

  var Kw = {
    Anchor: Ww,
    Arrow: Xw,
    Content: Qw,
    Root: Zw,
    Trigger: $w
  };

  function Jw(e) {
    var t = e.progress,
        n = e.total,
        r = _objectWithoutProperties(e, _excluded130);

    return s.jsxs(fe, _objectSpread(_objectSpread({
      height: "0.75rem",
      display: "inline-flex",
      position: "relative"
    }, r), {}, {
      children: [s.jsx(fe, {
        bg: "gray200",
        borderRadius: "8px",
        flex: "1"
      }), s.jsx(hs, {
        position: "absolute",
        bg: "blue400",
        borderRadius: "8px",
        height: "0.75rem",
        initial: {
          width: "0%"
        },
        animate: {
          width: t / (n || 1) * 100 + "%"
        },
        exit: {
          width: "0%"
        },
        transition: {
          duration: .7
        }
      })]
    }));
  }

  function ek() {
    for (var _len24 = arguments.length, e = new Array(_len24), _key24 = 0; _key24 < _len24; _key24++) {
      e[_key24] = arguments[_key24];
    }

    return function (t) {
      return e.forEach(function (e) {
        return function (e, t) {
          "function" == typeof e ? e(t) : null != e && (e.current = t);
        }(e, t);
      });
    };
  }

  Jw.propTypes = {
    progress: T["default"].number.isRequired,
    total: T["default"].number.isRequired
  };
  var tk = o.forwardRef(function (e, t) {
    var n = e.children,
        r = _objectWithoutProperties(e, _excluded131),
        i = o.Children.toArray(n),
        a = i.find(ok);

    if (a) {
      var _e46 = a.props.children,
          _n50 = i.map(function (t) {
        return t === a ? o.Children.count(_e46) > 1 ? o.Children.only(null) : o.isValidElement(_e46) ? _e46.props.children : null : t;
      });

      return o.createElement(nk, Fd({}, r, {
        ref: t
      }), o.isValidElement(_e46) ? o.cloneElement(_e46, void 0, _n50) : null);
    }

    return o.createElement(nk, Fd({}, r, {
      ref: t
    }), n);
  });
  tk.displayName = "Slot";
  var nk = o.forwardRef(function (e, t) {
    var n = e.children,
        r = _objectWithoutProperties(e, _excluded132);

    return o.isValidElement(n) ? o.cloneElement(n, _objectSpread(_objectSpread({}, ik(r, n.props)), {}, {
      ref: ek(t, n.ref)
    })) : o.Children.count(n) > 1 ? o.Children.only(null) : null;
  });
  nk.displayName = "SlotClone";

  var rk = function rk(_ref87) {
    var e = _ref87.children;
    return o.createElement(o.Fragment, null, e);
  };

  function ok(e) {
    return o.isValidElement(e) && e.type === rk;
  }

  function ik(e, t) {
    var n = _objectSpread({}, t);

    var _loop5 = function _loop5(_r31) {
      var o = e[_r31],
          i = t[_r31];
      /^on[A-Z]/.test(_r31) ? o && i ? n[_r31] = function () {
        i.apply(void 0, arguments), o.apply(void 0, arguments);
      } : o && (n[_r31] = o) : "style" === _r31 ? n[_r31] = _objectSpread(_objectSpread({}, o), i) : "className" === _r31 && (n[_r31] = [o, i].filter(Boolean).join(" "));
    };

    for (var _r31 in t) {
      _loop5(_r31);
    }

    return _objectSpread(_objectSpread({}, e), n);
  }

  var ak = ["a", "button", "div", "h2", "h3", "img", "label", "li", "nav", "ol", "p", "span", "svg", "ul"].reduce(function (e, t) {
    var n = o.forwardRef(function (e, n) {
      var r = e.asChild,
          i = _objectWithoutProperties(e, _excluded133),
          a = r ? tk : t;

      return o.useEffect(function () {
        window[Symbol["for"]("radix-ui")] = !0;
      }, []), o.createElement(a, Fd({}, i, {
        ref: n
      }));
    });
    return n.displayName = "Primitive.".concat(t), _objectSpread(_objectSpread({}, e), {}, _defineProperty({}, t, n));
  }, {}),
      sk = "horizontal",
      lk = ["horizontal", "vertical"],
      ck = o.forwardRef(function (e, t) {
    var n = e.decorative,
        _e$orientation2 = e.orientation,
        r = _e$orientation2 === void 0 ? sk : _e$orientation2,
        i = _objectWithoutProperties(e, _excluded134),
        a = uk(r) ? r : sk,
        s = n ? {
      role: "none"
    } : {
      "aria-orientation": "vertical" === a ? a : void 0,
      role: "separator"
    };

    return o.createElement(ak.div, Fd({
      "data-orientation": a
    }, s, i, {
      ref: t
    }));
  });

  function uk(e) {
    return lk.includes(e);
  }

  ck.propTypes = {
    orientation: function orientation(e, t, n) {
      var r = e[t],
          o = String(r);
      return r && !uk(r) ? new Error(function (e, t) {
        return "Invalid prop `orientation` of value `".concat(e, "` supplied to `").concat(t, "`, expected one of:\n  - horizontal\n  - vertical\n\nDefaulting to `").concat(sk, "`.");
      }(o, n)) : null;
    }
  };
  var dk = {
    Root: ck
  };

  function fk(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var n = [];

    var r = function r() {
      var t = n.map(function (e) {
        return o.createContext(e);
      });
      return function (n) {
        var r = (null == n ? void 0 : n[e]) || t;
        return o.useMemo(function () {
          return _defineProperty({}, "__scope".concat(e), _objectSpread(_objectSpread({}, n), {}, _defineProperty({}, e, r)));
        }, [n, r]);
      };
    };

    return r.scopeName = e, [function (t, r) {
      var i = o.createContext(r),
          a = n.length;

      function s(t) {
        var n = t.scope,
            r = t.children,
            s = _objectWithoutProperties(t, _excluded135),
            l = (null == n ? void 0 : n[e][a]) || i,
            c = o.useMemo(function () {
          return s;
        }, Object.values(s));

        return o.createElement(l.Provider, {
          value: c
        }, r);
      }

      return n = [].concat(_toConsumableArray(n), [r]), s.displayName = t + "Provider", [s, function (n, s) {
        var l = (null == s ? void 0 : s[e][a]) || i,
            c = o.useContext(l);
        if (c) return c;
        if (void 0 !== r) return r;
        throw new Error("`".concat(n, "` must be used within `").concat(t, "`"));
      }];
    }, pk.apply(void 0, [r].concat(_toConsumableArray(t)))];
  }

  function pk() {
    for (var _len25 = arguments.length, e = new Array(_len25), _key25 = 0; _key25 < _len25; _key25++) {
      e[_key25] = arguments[_key25];
    }

    var t = e[0];
    if (1 === e.length) return t;

    var n = function n() {
      var n = e.map(function (e) {
        return {
          useScope: e(),
          scopeName: e.scopeName
        };
      });
      return function (e) {
        var r = n.reduce(function (t, _ref89) {
          var n = _ref89.useScope,
              r = _ref89.scopeName;
          return _objectSpread(_objectSpread({}, t), n(e)["__scope".concat(r)]);
        }, {});
        return o.useMemo(function () {
          return _defineProperty({}, "__scope".concat(t.scopeName), r);
        }, [r]);
      };
    };

    return n.scopeName = t.scopeName, n;
  }

  function hk() {
    for (var _len26 = arguments.length, e = new Array(_len26), _key26 = 0; _key26 < _len26; _key26++) {
      e[_key26] = arguments[_key26];
    }

    return function (t) {
      return e.forEach(function (e) {
        return function (e, t) {
          "function" == typeof e ? e(t) : null != e && (e.current = t);
        }(e, t);
      });
    };
  }

  function mk() {
    for (var _len27 = arguments.length, e = new Array(_len27), _key27 = 0; _key27 < _len27; _key27++) {
      e[_key27] = arguments[_key27];
    }

    return o.useCallback(hk.apply(void 0, e), e);
  }

  var gk = o.forwardRef(function (e, t) {
    var n = e.children,
        r = _objectWithoutProperties(e, _excluded136),
        i = o.Children.toArray(n),
        a = i.find(vk);

    if (a) {
      var _e47 = a.props.children,
          _n51 = i.map(function (t) {
        return t === a ? o.Children.count(_e47) > 1 ? o.Children.only(null) : o.isValidElement(_e47) ? _e47.props.children : null : t;
      });

      return o.createElement(yk, Fd({}, r, {
        ref: t
      }), o.isValidElement(_e47) ? o.cloneElement(_e47, void 0, _n51) : null);
    }

    return o.createElement(yk, Fd({}, r, {
      ref: t
    }), n);
  });
  gk.displayName = "Slot";
  var yk = o.forwardRef(function (e, t) {
    var n = e.children,
        r = _objectWithoutProperties(e, _excluded137);

    return o.isValidElement(n) ? o.cloneElement(n, _objectSpread(_objectSpread({}, xk(r, n.props)), {}, {
      ref: hk(t, n.ref)
    })) : o.Children.count(n) > 1 ? o.Children.only(null) : null;
  });
  yk.displayName = "SlotClone";

  var bk = function bk(_ref91) {
    var e = _ref91.children;
    return o.createElement(o.Fragment, null, e);
  };

  function vk(e) {
    return o.isValidElement(e) && e.type === bk;
  }

  function xk(e, t) {
    var n = _objectSpread({}, t);

    var _loop6 = function _loop6(_r32) {
      var o = e[_r32],
          i = t[_r32];
      /^on[A-Z]/.test(_r32) ? o && i ? n[_r32] = function () {
        i.apply(void 0, arguments), o.apply(void 0, arguments);
      } : o && (n[_r32] = o) : "style" === _r32 ? n[_r32] = _objectSpread(_objectSpread({}, o), i) : "className" === _r32 && (n[_r32] = [o, i].filter(Boolean).join(" "));
    };

    for (var _r32 in t) {
      _loop6(_r32);
    }

    return _objectSpread(_objectSpread({}, e), n);
  }

  var wk = ["a", "button", "div", "h2", "h3", "img", "label", "li", "nav", "ol", "p", "span", "svg", "ul"].reduce(function (e, t) {
    var n = o.forwardRef(function (e, n) {
      var r = e.asChild,
          i = _objectWithoutProperties(e, _excluded138),
          a = r ? gk : t;

      return o.useEffect(function () {
        window[Symbol["for"]("radix-ui")] = !0;
      }, []), o.createElement(a, Fd({}, i, {
        ref: n
      }));
    });
    return n.displayName = "Primitive.".concat(t), _objectSpread(_objectSpread({}, e), {}, _defineProperty({}, t, n));
  }, {});

  function kk(e, t) {
    var _ref92 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref92$checkForDefaul = _ref92.checkForDefaultPrevented,
        n = _ref92$checkForDefaul === void 0 ? !0 : _ref92$checkForDefaul;

    return function (r) {
      if (null == e || e(r), !1 === n || !r.defaultPrevented) return null == t ? void 0 : t(r);
    };
  }

  var Ck = Boolean(null === globalThis || void 0 === globalThis ? void 0 : globalThis.document) ? o.useLayoutEffect : function () {},
      Mk = L["useId".toString()] || function () {};

  var jk = 0;

  function Ek(e) {
    var t = o.useRef(e);
    return o.useEffect(function () {
      t.current = e;
    }), o.useMemo(function () {
      return function () {
        var _n52;

        var n;

        for (var _len28 = arguments.length, e = new Array(_len28), _key28 = 0; _key28 < _len28; _key28++) {
          e[_key28] = arguments[_key28];
        }

        return null === (n = t.current) || void 0 === n ? void 0 : (_n52 = n).call.apply(_n52, [t].concat(e));
      };
    }, []);
  }

  function _k(_ref93) {
    var e = _ref93.prop,
        t = _ref93.defaultProp,
        _ref93$onChange = _ref93.onChange,
        n = _ref93$onChange === void 0 ? function () {} : _ref93$onChange;

    var _ref94 = function (_ref96) {
      var e = _ref96.defaultProp,
          t = _ref96.onChange;

      var n = o.useState(e),
          _n53 = _slicedToArray(n, 1),
          r = _n53[0],
          i = o.useRef(r),
          a = Ek(t);

      return o.useEffect(function () {
        i.current !== r && (a(r), i.current = r);
      }, [r, i, a]), n;
    }({
      defaultProp: t,
      onChange: n
    }),
        _ref95 = _slicedToArray(_ref94, 2),
        r = _ref95[0],
        i = _ref95[1],
        a = void 0 !== e,
        s = a ? e : r,
        l = Ek(n);

    return [s, o.useCallback(function (t) {
      if (a) {
        var _n54 = t,
            _r33 = "function" == typeof t ? _n54(e) : t;

        _r33 !== e && l(_r33);
      } else i(t);
    }, [a, e, i, l])];
  }

  var Tk = "rovingFocusGroup.onEntryFocus",
      Sk = {
    bubbles: !1,
    cancelable: !0
  },
      Lk = "RovingFocusGroup",
      _ref97 = function (e) {
    var t = e + "CollectionProvider",
        _fk3 = fk(t),
        _fk4 = _slicedToArray(_fk3, 2),
        n = _fk4[0],
        r = _fk4[1],
        _n55 = n(t, {
      collectionRef: {
        current: null
      },
      itemMap: new Map()
    }),
        _n56 = _slicedToArray(_n55, 2),
        o = _n56[0],
        i = _n56[1],
        a = e + "CollectionSlot",
        s = S["default"].forwardRef(function (e, t) {
      var n = e.scope,
          r = e.children,
          o = mk(t, i(a, n).collectionRef);
      return S["default"].createElement(gk, {
        ref: o
      }, r);
    }),
        l = e + "CollectionItemSlot",
        c = "data-radix-collection-item",
        u = S["default"].forwardRef(function (e, t) {
      var _S$default$createElem3;

      var n = e.scope,
          r = e.children,
          o = _objectWithoutProperties(e, _excluded139),
          a = S["default"].useRef(null),
          s = mk(t, a),
          u = i(l, n);

      return S["default"].useEffect(function () {
        return u.itemMap.set(a, _objectSpread({
          ref: a
        }, o)), function () {
          u.itemMap["delete"](a);
        };
      }), S["default"].createElement(gk, (_S$default$createElem3 = {}, _defineProperty(_S$default$createElem3, c, ""), _defineProperty(_S$default$createElem3, "ref", s), _S$default$createElem3), r);
    });

    return [{
      Provider: function Provider(e) {
        var t = e.scope,
            n = e.children,
            r = S["default"].useRef(null),
            i = S["default"].useRef(new Map()).current;
        return S["default"].createElement(o, {
          scope: t,
          itemMap: i,
          collectionRef: r
        }, n);
      },
      Slot: s,
      ItemSlot: u
    }, function (t) {
      var n = i(e + "CollectionConsumer", t),
          r = S["default"].useCallback(function () {
        var e = n.collectionRef.current;
        if (!e) return [];
        var t = Array.from(e.querySelectorAll("[".concat(c, "]"))),
            r = Array.from(n.itemMap.values()).sort(function (e, n) {
          return t.indexOf(e.ref.current) - t.indexOf(n.ref.current);
        });
        return r;
      }, [n.collectionRef, n.itemMap]);
      return r;
    }, r];
  }(Lk),
      _ref98 = _slicedToArray(_ref97, 3),
      Dk = _ref98[0],
      Ak = _ref98[1],
      Nk = _ref98[2],
      _fk = fk(Lk, [Nk]),
      _fk2 = _slicedToArray(_fk, 2),
      Ik = _fk2[0],
      zk = _fk2[1],
      _Ik = Ik(Lk),
      _Ik2 = _slicedToArray(_Ik, 2),
      Ok = _Ik2[0],
      Rk = _Ik2[1],
      Pk = o.forwardRef(function (e, t) {
    return o.createElement(Dk.Provider, {
      scope: e.__scopeRovingFocusGroup
    }, o.createElement(Dk.Slot, {
      scope: e.__scopeRovingFocusGroup
    }, o.createElement(Fk, Fd({}, e, {
      ref: t
    }))));
  }),
      Fk = o.forwardRef(function (e, t) {
    var n = e.__scopeRovingFocusGroup,
        r = e.orientation,
        _e$loop5 = e.loop,
        i = _e$loop5 === void 0 ? !1 : _e$loop5,
        a = e.dir,
        s = e.currentTabStopId,
        l = e.defaultCurrentTabStopId,
        c = e.onCurrentTabStopIdChange,
        u = e.onEntryFocus,
        d = _objectWithoutProperties(e, _excluded140),
        f = o.useRef(null),
        p = mk(t, f),
        h = Gd(a),
        _k2 = _k({
      prop: s,
      defaultProp: l,
      onChange: c
    }),
        _k3 = _slicedToArray(_k2, 2),
        _k3$ = _k3[0],
        m = _k3$ === void 0 ? null : _k3$,
        g = _k3[1],
        _o$useState59 = o.useState(!1),
        _o$useState60 = _slicedToArray(_o$useState59, 2),
        y = _o$useState60[0],
        b = _o$useState60[1],
        v = Ek(u),
        x = Ak(n),
        w = o.useRef(!1),
        _o$useState61 = o.useState(0),
        _o$useState62 = _slicedToArray(_o$useState61, 2),
        k = _o$useState62[0],
        C = _o$useState62[1];

    return o.useEffect(function () {
      var e = f.current;
      if (e) return e.addEventListener(Tk, v), function () {
        return e.removeEventListener(Tk, v);
      };
    }, [v]), o.createElement(Ok, {
      scope: n,
      orientation: r,
      dir: h,
      loop: i,
      currentTabStopId: m,
      onItemFocus: o.useCallback(function (e) {
        return g(e);
      }, [g]),
      onItemShiftTab: o.useCallback(function () {
        return b(!0);
      }, []),
      onFocusableItemAdd: o.useCallback(function () {
        return C(function (e) {
          return e + 1;
        });
      }, []),
      onFocusableItemRemove: o.useCallback(function () {
        return C(function (e) {
          return e - 1;
        });
      }, [])
    }, o.createElement(wk.div, Fd({
      tabIndex: y || 0 === k ? -1 : 0,
      "data-orientation": r
    }, d, {
      ref: p,
      style: _objectSpread({
        outline: "none"
      }, e.style),
      onMouseDown: kk(e.onMouseDown, function () {
        w.current = !0;
      }),
      onFocus: kk(e.onFocus, function (e) {
        var t = !w.current;

        if (e.target === e.currentTarget && t && !y) {
          var _t38 = new CustomEvent(Tk, Sk);

          if (e.currentTarget.dispatchEvent(_t38), !_t38.defaultPrevented) {
            var _e48 = x().filter(function (e) {
              return e.focusable;
            });

            Uk([_e48.find(function (e) {
              return e.active;
            }), _e48.find(function (e) {
              return e.id === m;
            })].concat(_toConsumableArray(_e48)).filter(Boolean).map(function (e) {
              return e.ref.current;
            }));
          }
        }

        w.current = !1;
      }),
      onBlur: kk(e.onBlur, function () {
        return b(!1);
      })
    })));
  }),
      Bk = o.forwardRef(function (e, t) {
    var n = e.__scopeRovingFocusGroup,
        _e$focusable2 = e.focusable,
        r = _e$focusable2 === void 0 ? !0 : _e$focusable2,
        _e$active2 = e.active,
        i = _e$active2 === void 0 ? !1 : _e$active2,
        a = e.tabStopId,
        s = _objectWithoutProperties(e, _excluded141),
        l = function (e) {
      var _L$useState51 = L.useState(Mk()),
          _L$useState52 = _slicedToArray(_L$useState51, 2),
          t = _L$useState52[0],
          n = _L$useState52[1];

      return Ck(function () {
        e || n(function (e) {
          return null != e ? e : String(jk++);
        });
      }, [e]), e || (t ? "radix-".concat(t) : "");
    }(),
        c = a || l,
        u = Rk("RovingFocusGroupItem", n),
        d = u.currentTabStopId === c,
        f = Ak(n),
        p = u.onFocusableItemAdd,
        h = u.onFocusableItemRemove;

    return o.useEffect(function () {
      if (r) return p(), function () {
        return h();
      };
    }, [r, p, h]), o.createElement(Dk.ItemSlot, {
      scope: n,
      id: c,
      focusable: r,
      active: i
    }, o.createElement(wk.span, Fd({
      tabIndex: d ? 0 : -1,
      "data-orientation": u.orientation
    }, s, {
      ref: t,
      onMouseDown: kk(e.onMouseDown, function (e) {
        r ? u.onItemFocus(c) : e.preventDefault();
      }),
      onFocus: kk(e.onFocus, function () {
        return u.onItemFocus(c);
      }),
      onKeyDown: kk(e.onKeyDown, function (e) {
        if ("Tab" === e.key && e.shiftKey) return void u.onItemShiftTab();
        if (e.target !== e.currentTarget) return;

        var t = function (e, t, n) {
          var r = function (e, t) {
            return "rtl" !== t ? e : "ArrowLeft" === e ? "ArrowRight" : "ArrowRight" === e ? "ArrowLeft" : e;
          }(e.key, n);

          return "vertical" === t && ["ArrowLeft", "ArrowRight"].includes(r) || "horizontal" === t && ["ArrowUp", "ArrowDown"].includes(r) ? void 0 : qk[r];
        }(e, u.orientation, u.dir);

        if (void 0 !== t) {
          e.preventDefault();

          var _o14 = f().filter(function (e) {
            return e.focusable;
          }).map(function (e) {
            return e.ref.current;
          });

          if ("last" === t) _o14.reverse();else if ("prev" === t || "next" === t) {
            "prev" === t && _o14.reverse();

            var _i15 = _o14.indexOf(e.currentTarget);

            _o14 = u.loop ? ((_i15 + 1, _readOnlyError("r")), (_o14, _readOnlyError("n")).map(function (e, t) {
              return n[(r + t) % n.length];
            })) : _o14.slice(_i15 + 1);
          }
          setTimeout(function () {
            return Uk(_o14);
          });
        }

        var n, r;
      })
    })));
  }),
      qk = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
  };

  function Uk(e) {
    var t = document.activeElement;

    var _iterator11 = _createForOfIteratorHelper(e),
        _step11;

    try {
      for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
        var _n57 = _step11.value;
        if (_n57 === t) return;
        if (_n57.focus(), document.activeElement !== t) return;
      }
    } catch (err) {
      _iterator11.e(err);
    } finally {
      _iterator11.f();
    }
  }

  var Vk = Pk,
      Hk = Bk;

  function Zk(e, t) {
    var _ref99 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref99$checkForDefaul = _ref99.checkForDefaultPrevented,
        n = _ref99$checkForDefaul === void 0 ? !0 : _ref99$checkForDefaul;

    return function (r) {
      if (null == e || e(r), !1 === n || !r.defaultPrevented) return null == t ? void 0 : t(r);
    };
  }

  function Wk(e) {
    var t = o.useRef(e);
    return o.useEffect(function () {
      t.current = e;
    }), o.useMemo(function () {
      return function () {
        var _n58;

        var n;

        for (var _len29 = arguments.length, e = new Array(_len29), _key29 = 0; _key29 < _len29; _key29++) {
          e[_key29] = arguments[_key29];
        }

        return null === (n = t.current) || void 0 === n ? void 0 : (_n58 = n).call.apply(_n58, [t].concat(e));
      };
    }, []);
  }

  function $k(_ref100) {
    var e = _ref100.prop,
        t = _ref100.defaultProp,
        _ref100$onChange = _ref100.onChange,
        n = _ref100$onChange === void 0 ? function () {} : _ref100$onChange;

    var _ref101 = function (_ref103) {
      var e = _ref103.defaultProp,
          t = _ref103.onChange;

      var n = o.useState(e),
          _n59 = _slicedToArray(n, 1),
          r = _n59[0],
          i = o.useRef(r),
          a = Wk(t);

      return o.useEffect(function () {
        i.current !== r && (a(r), i.current = r);
      }, [r, i, a]), n;
    }({
      defaultProp: t,
      onChange: n
    }),
        _ref102 = _slicedToArray(_ref101, 2),
        r = _ref102[0],
        i = _ref102[1],
        a = void 0 !== e,
        s = a ? e : r,
        l = Wk(n);

    return [s, o.useCallback(function (t) {
      if (a) {
        var _n60 = t,
            _r34 = "function" == typeof t ? _n60(e) : t;

        _r34 !== e && l(_r34);
      } else i(t);
    }, [a, e, i, l])];
  }

  function Gk() {
    for (var _len30 = arguments.length, e = new Array(_len30), _key30 = 0; _key30 < _len30; _key30++) {
      e[_key30] = arguments[_key30];
    }

    return function (t) {
      return e.forEach(function (e) {
        return function (e, t) {
          "function" == typeof e ? e(t) : null != e && (e.current = t);
        }(e, t);
      });
    };
  }

  var Yk = o.forwardRef(function (e, t) {
    var n = e.children,
        r = _objectWithoutProperties(e, _excluded142),
        i = o.Children.toArray(n),
        a = i.find(Kk);

    if (a) {
      var _e49 = a.props.children,
          _n61 = i.map(function (t) {
        return t === a ? o.Children.count(_e49) > 1 ? o.Children.only(null) : o.isValidElement(_e49) ? _e49.props.children : null : t;
      });

      return o.createElement(Qk, Fd({}, r, {
        ref: t
      }), o.isValidElement(_e49) ? o.cloneElement(_e49, void 0, _n61) : null);
    }

    return o.createElement(Qk, Fd({}, r, {
      ref: t
    }), n);
  });
  Yk.displayName = "Slot";
  var Qk = o.forwardRef(function (e, t) {
    var n = e.children,
        r = _objectWithoutProperties(e, _excluded143);

    return o.isValidElement(n) ? o.cloneElement(n, _objectSpread(_objectSpread({}, Jk(r, n.props)), {}, {
      ref: Gk(t, n.ref)
    })) : o.Children.count(n) > 1 ? o.Children.only(null) : null;
  });
  Qk.displayName = "SlotClone";

  var Xk = function Xk(_ref104) {
    var e = _ref104.children;
    return o.createElement(o.Fragment, null, e);
  };

  function Kk(e) {
    return o.isValidElement(e) && e.type === Xk;
  }

  function Jk(e, t) {
    var n = _objectSpread({}, t);

    var _loop7 = function _loop7(_r35) {
      var o = e[_r35],
          i = t[_r35];
      /^on[A-Z]/.test(_r35) ? o && i ? n[_r35] = function () {
        i.apply(void 0, arguments), o.apply(void 0, arguments);
      } : o && (n[_r35] = o) : "style" === _r35 ? n[_r35] = _objectSpread(_objectSpread({}, o), i) : "className" === _r35 && (n[_r35] = [o, i].filter(Boolean).join(" "));
    };

    for (var _r35 in t) {
      _loop7(_r35);
    }

    return _objectSpread(_objectSpread({}, e), n);
  }

  var eC = ["a", "button", "div", "h2", "h3", "img", "label", "li", "nav", "ol", "p", "span", "svg", "ul"].reduce(function (e, t) {
    var n = o.forwardRef(function (e, n) {
      var r = e.asChild,
          i = _objectWithoutProperties(e, _excluded144),
          a = r ? Yk : t;

      return o.useEffect(function () {
        window[Symbol["for"]("radix-ui")] = !0;
      }, []), o.createElement(a, Fd({}, i, {
        ref: n
      }));
    });
    return n.displayName = "Primitive.".concat(t), _objectSpread(_objectSpread({}, e), {}, _defineProperty({}, t, n));
  }, {}),
      tC = o.forwardRef(function (e, t) {
    var n = e.pressed,
        _e$defaultPressed = e.defaultPressed,
        r = _e$defaultPressed === void 0 ? !1 : _e$defaultPressed,
        i = e.onPressedChange,
        a = _objectWithoutProperties(e, _excluded145),
        _$k = $k({
      prop: n,
      onChange: i,
      defaultProp: r
    }),
        _$k2 = _slicedToArray(_$k, 2),
        _$k2$ = _$k2[0],
        s = _$k2$ === void 0 ? !1 : _$k2$,
        l = _$k2[1];

    return o.createElement(eC.button, Fd({
      type: "button",
      "aria-pressed": s,
      "data-state": s ? "on" : "off",
      "data-disabled": e.disabled ? "" : void 0
    }, a, {
      ref: t,
      onClick: Zk(e.onClick, function () {
        e.disabled || l(!s);
      })
    }));
  }),
      nC = "ToggleGroup",
      _fk5 = fk(nC, [zk]),
      _fk6 = _slicedToArray(_fk5, 2),
      rC = _fk6[0],
      oC = _fk6[1],
      iC = zk(),
      aC = S["default"].forwardRef(function (e, t) {
    var n = e.type,
        r = _objectWithoutProperties(e, _excluded146);

    if ("single" === n) {
      var _e50 = r;
      return S["default"].createElement(cC, Fd({}, _e50, {
        ref: t
      }));
    }

    if ("multiple" === n) {
      var _e51 = r;
      return S["default"].createElement(uC, Fd({}, _e51, {
        ref: t
      }));
    }

    throw new Error("Missing prop `type` expected on `ToggleGroup`");
  }),
      _rC = rC(nC),
      _rC2 = _slicedToArray(_rC, 2),
      sC = _rC2[0],
      lC = _rC2[1],
      cC = S["default"].forwardRef(function (e, t) {
    var n = e.value,
        r = e.defaultValue,
        _e$onValueChange2 = e.onValueChange,
        o = _e$onValueChange2 === void 0 ? function () {} : _e$onValueChange2,
        i = _objectWithoutProperties(e, _excluded147),
        _k4 = _k({
      prop: n,
      defaultProp: r,
      onChange: o
    }),
        _k5 = _slicedToArray(_k4, 2),
        a = _k5[0],
        s = _k5[1];

    return S["default"].createElement(sC, {
      scope: e.__scopeToggleGroup,
      type: "single",
      value: a ? [a] : [],
      onItemActivate: s,
      onItemDeactivate: S["default"].useCallback(function () {
        return s("");
      }, [s])
    }, S["default"].createElement(pC, Fd({}, i, {
      ref: t
    })));
  }),
      uC = S["default"].forwardRef(function (e, t) {
    var n = e.value,
        r = e.defaultValue,
        _e$onValueChange3 = e.onValueChange,
        o = _e$onValueChange3 === void 0 ? function () {} : _e$onValueChange3,
        i = _objectWithoutProperties(e, _excluded148),
        _k6 = _k({
      prop: n,
      defaultProp: r,
      onChange: o
    }),
        _k7 = _slicedToArray(_k6, 2),
        _k7$ = _k7[0],
        a = _k7$ === void 0 ? [] : _k7$,
        s = _k7[1],
        l = S["default"].useCallback(function (e) {
      return s(function () {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return [].concat(_toConsumableArray(t), [e]);
      });
    }, [s]),
        c = S["default"].useCallback(function (e) {
      return s(function () {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return t.filter(function (t) {
          return t !== e;
        });
      });
    }, [s]);

    return S["default"].createElement(sC, {
      scope: e.__scopeToggleGroup,
      type: "multiple",
      value: a,
      onItemActivate: l,
      onItemDeactivate: c
    }, S["default"].createElement(pC, Fd({}, i, {
      ref: t
    })));
  }),
      _rC3 = rC(nC),
      _rC4 = _slicedToArray(_rC3, 2),
      dC = _rC4[0],
      fC = _rC4[1],
      pC = S["default"].forwardRef(function (e, t) {
    var n = e.__scopeToggleGroup,
        _e$disabled5 = e.disabled,
        r = _e$disabled5 === void 0 ? !1 : _e$disabled5,
        _e$rovingFocus = e.rovingFocus,
        o = _e$rovingFocus === void 0 ? !0 : _e$rovingFocus,
        i = e.orientation,
        a = e.dir,
        _e$loop6 = e.loop,
        s = _e$loop6 === void 0 ? !0 : _e$loop6,
        l = _objectWithoutProperties(e, _excluded149),
        c = iC(n),
        u = Gd(a),
        d = _objectSpread({
      role: "group",
      dir: u
    }, l);

    return S["default"].createElement(dC, {
      scope: n,
      rovingFocus: o,
      disabled: r
    }, o ? S["default"].createElement(Vk, Fd({
      asChild: !0
    }, c, {
      orientation: i,
      dir: u,
      loop: s
    }), S["default"].createElement(wk.div, Fd({}, d, {
      ref: t
    }))) : S["default"].createElement(wk.div, Fd({}, d, {
      ref: t
    })));
  }),
      hC = "ToggleGroupItem",
      mC = S["default"].forwardRef(function (e, t) {
    var n = lC(hC, e.__scopeToggleGroup),
        r = fC(hC, e.__scopeToggleGroup),
        o = iC(e.__scopeToggleGroup),
        i = n.value.includes(e.value),
        a = r.disabled || e.disabled,
        s = _objectSpread(_objectSpread({}, e), {}, {
      pressed: i,
      disabled: a
    }),
        l = S["default"].useRef(null);

    return r.rovingFocus ? S["default"].createElement(Hk, Fd({
      asChild: !0
    }, o, {
      focusable: !a,
      active: i,
      ref: l
    }), S["default"].createElement(gC, Fd({}, s, {
      ref: t
    }))) : S["default"].createElement(gC, Fd({}, s, {
      ref: t
    }));
  }),
      gC = S["default"].forwardRef(function (e, t) {
    var n = e.__scopeToggleGroup,
        r = e.value,
        o = _objectWithoutProperties(e, _excluded150),
        i = lC(hC, n),
        a = {
      role: "radio",
      "aria-checked": e.pressed,
      "aria-pressed": void 0
    },
        s = "single" === i.type ? a : void 0;

    return S["default"].createElement(tC, Fd({}, s, o, {
      ref: t,
      onPressedChange: function onPressedChange(e) {
        e ? i.onItemActivate(r) : i.onItemDeactivate(r);
      }
    }));
  }),
      yC = aC,
      bC = mC,
      vC = _["default"](yC).withConfig({
    displayName: "TogglePillsGroup__StyledRoot",
    componentId: "sc-sl6vcd-0"
  })(["display:inline-flex;background-color:", ";border-radius:", ";"], function (e) {
    return e.theme.colors.white;
  }, function (e) {
    return e.theme.radii.large;
  });

  vC.displayName = "ToggleGroup.StyledRoot";

  var xC = _["default"](bC).withConfig({
    displayName: "TogglePillsGroup__ToggleItemWrapper",
    componentId: "sc-sl6vcd-1"
  })(["padding:0;"]);

  xC.displayName = "ToggleGroup.ItemWrapper";

  var wC = _["default"](fe).attrs(function (e) {
    return {
      bg: e.$isSelected ? "blue500" : "white",
      color: e.$isSelected ? "white" : "black",
      fontSize: 0,
      fontWeight: "600",
      borderRadius: "large",
      width: e.width || "150px"
    };
  }).withConfig({
    displayName: "TogglePillsGroup__ToggleItem",
    componentId: "sc-sl6vcd-2"
  })(["cursor:pointer;display:flex;align-items:center;justify-content:center;"]);

  function kC(e) {
    var t = e.disabled,
        n = e.label,
        r = e.onClick,
        o = e.value,
        i = e.isSelected,
        a = _objectWithoutProperties(e, _excluded151);

    return s.jsx(xC, {
      disabled: t,
      onClick: r,
      value: o,
      children: s.jsx(wC, _objectSpread(_objectSpread({
        py: 2,
        $isSelected: i
      }, a), {}, {
        children: n
      }))
    });
  }

  function CC(e) {
    var t = e.defaultValue,
        n = e.children;
    return s.jsx(vC, {
      type: "single",
      defaultValue: t,
      children: n
    });
  }

  wC.displayName = "ToggleGroup.Item", kC.displayName = "ToggleGroup.Button", kC.defaultProps = {
    disabled: !1
  }, kC.propTypes = {
    disabled: T["default"].bool,
    label: T["default"].string.isRequired,
    onClick: T["default"].func.isRequired,
    value: T["default"].oneOfType([T["default"].number, T["default"].string]).isRequired,
    isSelected: T["default"].bool.isRequired
  }, CC.propTypes = {
    children: T["default"].node.isRequired,
    defaultValue: T["default"].oneOfType([T["default"].number, T["default"].string]).isRequired
  };
  var MC = {
    ToggleGroup: CC,
    Pill: kC
  };

  function jC(e) {
    var t = e.onClose,
        n = e.onInfo,
        r = e.showInfo,
        o = e.children,
        i = _objectWithoutProperties(e, _excluded152);

    return s.jsx(fe, _objectSpread(_objectSpread({
      bg: "gray50",
      py: [2, null, 3],
      boxShadow: 1,
      as: "header",
      position: "relative",
      zIndex: 2
    }, i), {}, {
      children: s.jsxs(fe, {
        position: "relative",
        display: "flex",
        alignItems: "center",
        px: 3,
        mx: "auto",
        children: [s.jsx(fe, {
          ml: [-3, null, null, 0],
          children: s.jsx(Tc, {
            mr: 1,
            icon: "times",
            fontSize: 0,
            onClick: t
          })
        }), o, r && s.jsx(fe, {
          ml: "auto",
          mr: [-2, null, null, 0],
          children: s.jsx(Tc, {
            title: "Instructions",
            fontSize: 2,
            icon: "info-circle",
            weight: "regular",
            onClick: n
          })
        })]
      })
    }));
  }

  jC.defaultProps = {
    showInfo: !0,
    onInfo: function onInfo() {}
  }, jC.propTypes = {
    onClose: T["default"].func.isRequired,
    onInfo: T["default"].func,
    showInfo: T["default"].bool,
    children: T["default"].node.isRequired
  };
  var EC = L.forwardRef(function (e, t) {
    return L.createElement(Hb.span, Fd({}, e, {
      ref: t,
      style: _objectSpread({
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal"
      }, e.style)
    }));
  }),
      _C = EC;

  function TC(e) {
    var t = L.useRef({
      value: e,
      previous: e
    });
    return L.useMemo(function () {
      return t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous;
    }, [e]);
  }

  var _Zb15 = Zb("Tooltip", [Sv]),
      _Zb16 = _slicedToArray(_Zb15, 2),
      SC = _Zb16[0],
      LC = _Zb16[1],
      DC = Sv(),
      AC = 700,
      _SC = SC("TooltipProvider", {
    isOpenDelayed: !0,
    delayDuration: AC,
    onOpen: function onOpen() {},
    onClose: function onClose() {}
  }),
      _SC2 = _slicedToArray(_SC, 2),
      NC = _SC2[0],
      IC = _SC2[1],
      _SC3 = SC("Tooltip"),
      _SC4 = _slicedToArray(_SC3, 2),
      zC = _SC4[0],
      OC = _SC4[1],
      RC = L.forwardRef(function (e, t) {
    var n = e.__scopeTooltip,
        r = _objectWithoutProperties(e, _excluded153),
        o = OC("TooltipTrigger", n),
        i = DC(n),
        a = Pb(t, o.onTriggerChange),
        s = L.useRef(!1),
        l = L.useCallback(function () {
      return s.current = !1;
    }, []);

    return L.useEffect(function () {
      return function () {
        return document.removeEventListener("mouseup", l);
      };
    }, [l]), L.createElement(Pv, Fd({
      asChild: !0
    }, i), L.createElement(Hb.button, Fd({
      "aria-describedby": o.open ? o.contentId : void 0,
      "data-state": o.stateAttribute
    }, r, {
      ref: a,
      onMouseEnter: Gb(e.onMouseEnter, o.onTriggerEnter),
      onMouseLeave: Gb(e.onMouseLeave, o.onClose),
      onMouseDown: Gb(e.onMouseDown, function () {
        o.onClose(), s.current = !0, document.addEventListener("mouseup", l, {
          once: !0
        });
      }),
      onFocus: Gb(e.onFocus, function () {
        s.current || o.onOpen();
      }),
      onBlur: Gb(e.onBlur, o.onClose),
      onClick: Gb(e.onClick, function (e) {
        0 === e.detail && o.onClose();
      })
    })));
  }),
      PC = L.forwardRef(function (e, t) {
    var n = e.forceMount,
        r = _objectWithoutProperties(e, _excluded154),
        o = OC("TooltipContent", e.__scopeTooltip);

    return L.createElement(qv, {
      present: n || o.open
    }, L.createElement(FC, Fd({
      ref: t
    }, r)));
  }),
      FC = L.forwardRef(function (e, t) {
    var n = e.__scopeTooltip,
        r = e.children,
        o = e["aria-label"],
        _e$portalled5 = e.portalled,
        i = _e$portalled5 === void 0 ? !0 : _e$portalled5,
        a = _objectWithoutProperties(e, _excluded155),
        s = OC("TooltipContent", n),
        l = DC(n),
        c = i ? uv : L.Fragment,
        u = s.onClose;

    return Xv(function () {
      return u();
    }), L.useEffect(function () {
      return document.addEventListener("tooltip.open", u), function () {
        return document.removeEventListener("tooltip.open", u);
      };
    }, [u]), L.createElement(c, null, L.createElement(qC, {
      __scopeTooltip: n
    }), L.createElement(Fv, Fd({
      "data-state": s.stateAttribute
    }, l, a, {
      ref: t,
      style: _objectSpread(_objectSpread({}, a.style), {}, {
        "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)"
      })
    }), L.createElement(qb, null, r), L.createElement(_C, {
      id: s.contentId,
      role: "tooltip"
    }, o || r)));
  }),
      BC = L.forwardRef(function (e, t) {
    var n = e.__scopeTooltip,
        r = _objectWithoutProperties(e, _excluded156),
        o = DC(n);

    return L.createElement(Bv, Fd({}, o, r, {
      ref: t
    }));
  });

  function qC(e) {
    var t = e.__scopeTooltip,
        n = OC("CheckTriggerMoved", t),
        r = yv(n.trigger),
        o = null == r ? void 0 : r.left,
        i = TC(o),
        a = null == r ? void 0 : r.top,
        s = TC(a),
        l = n.onClose;
    return L.useEffect(function () {
      (void 0 !== i && i !== o || void 0 !== s && s !== a) && l();
    }, [l, i, s, o, a]), null;
  }

  var UC = function UC(e) {
    var t = e.__scopeTooltip,
        _e$delayDuration = e.delayDuration,
        n = _e$delayDuration === void 0 ? AC : _e$delayDuration,
        _e$skipDelayDuration = e.skipDelayDuration,
        r = _e$skipDelayDuration === void 0 ? 300 : _e$skipDelayDuration,
        o = e.children,
        _L$useState53 = L.useState(!0),
        _L$useState54 = _slicedToArray(_L$useState53, 2),
        i = _L$useState54[0],
        a = _L$useState54[1],
        s = L.useRef(0);

    return L.useEffect(function () {
      var e = s.current;
      return function () {
        return window.clearTimeout(e);
      };
    }, []), L.createElement(NC, {
      scope: t,
      isOpenDelayed: i,
      delayDuration: n,
      onOpen: L.useCallback(function () {
        window.clearTimeout(s.current), a(!1);
      }, []),
      onClose: L.useCallback(function () {
        window.clearTimeout(s.current), s.current = window.setTimeout(function () {
          return a(!0);
        }, r);
      }, [r])
    }, o);
  },
      VC = function VC(e) {
    var t = e.__scopeTooltip,
        n = e.children,
        r = e.open,
        _e$defaultOpen = e.defaultOpen,
        o = _e$defaultOpen === void 0 ? !1 : _e$defaultOpen,
        i = e.onOpenChange,
        a = e.delayDuration,
        s = IC("Tooltip", t),
        l = DC(t),
        _L$useState55 = L.useState(null),
        _L$useState56 = _slicedToArray(_L$useState55, 2),
        c = _L$useState56[0],
        u = _L$useState56[1],
        d = Db(),
        f = L.useRef(0),
        p = null != a ? a : s.delayDuration,
        h = L.useRef(!1),
        m = s.onOpen,
        g = s.onClose,
        _Ob9 = Ob({
      prop: r,
      defaultProp: o,
      onChange: function onChange(e) {
        e && (document.dispatchEvent(new CustomEvent("tooltip.open")), m()), null == i || i(e);
      }
    }),
        _Ob10 = _slicedToArray(_Ob9, 2),
        _Ob10$ = _Ob10[0],
        y = _Ob10$ === void 0 ? !1 : _Ob10$,
        b = _Ob10[1],
        v = L.useMemo(function () {
      return y ? h.current ? "delayed-open" : "instant-open" : "closed";
    }, [y]),
        x = L.useCallback(function () {
      window.clearTimeout(f.current), h.current = !1, b(!0);
    }, [b]),
        w = L.useCallback(function () {
      window.clearTimeout(f.current), f.current = window.setTimeout(function () {
        h.current = !0, b(!0);
      }, p);
    }, [p, b]);

    return L.useEffect(function () {
      return function () {
        return window.clearTimeout(f.current);
      };
    }, []), L.createElement(Rv, l, L.createElement(zC, {
      scope: t,
      contentId: d,
      open: y,
      stateAttribute: v,
      trigger: c,
      onTriggerChange: u,
      onTriggerEnter: L.useCallback(function () {
        s.isOpenDelayed ? w() : x();
      }, [s.isOpenDelayed, w, x]),
      onOpen: L.useCallback(x, [x]),
      onClose: L.useCallback(function () {
        window.clearTimeout(f.current), b(!1), g();
      }, [b, g])
    }, n));
  },
      HC = RC,
      ZC = PC,
      WC = BC;

  function $C(e) {
    var t = e.background;
    return s.jsx(WC, {
      asChild: !0,
      children: s.jsx("svg", {
        width: "28",
        height: "9",
        viewBox: "0 0 28 9",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: s.jsx("path", {
          d: "M8.5 4C6.5 0.799997 5.65 -1.0258e-06 4 -9.53674e-07L24 -1.8279e-06C22.5 -1.76234e-06 21.5 1 19.5 4C16.8835 7.92477 16 9 14 9C12 9 11 8 8.5 4Z",
          fill: gc.colors[t]
        })
      })
    });
  }

  $C.defaultProps = {
    background: "black"
  }, $C.propTypes = {
    background: T["default"].string
  };

  var GC = _["default"](ZC).attrs(function (e) {
    return {
      sideOffset: e.sideOffset || 2
    };
  }).withConfig({
    displayName: "Tooltip__StyledContent",
    componentId: "sc-o2k1se-0"
  })(["border-radius:", ";background-color:", ";box-shadow:", ";color:", ";max-width:calc(100vw - 2rem);padding:", " ", ";font-size:", ";"], function (e) {
    return e.theme.radii.rounded;
  }, function (e) {
    return e.background ? e.theme.colors[e.background] : e.theme.colors.black;
  }, function (e) {
    return e.theme.shadows[3];
  }, function (e) {
    return e.color ? e.theme.colors[e.color] : e.theme.colors.white;
  }, function (e) {
    return e.theme.space[2];
  }, function (e) {
    return e.theme.space[3];
  }, function (e) {
    return e.theme.fontSizes[0];
  });

  var YC = {
    Provider: UC,
    Root: VC,
    Trigger: HC,
    Content: GC,
    Arrow: $C
  };

  var QC = _["default"].button.withConfig({
    displayName: "TransportButton",
    componentId: "sc-1h8eo7s-0"
  })(["appearance:none;background:", ";border:none;border-radius:50%;color:", ";cursor:pointer;display:inline-flex;align-items:center;justify-content:center;flex-shrink:0;height:2.5rem;width:2.5rem;transition:background 0.3s;", " &:hover{background:", ";}&:focus{outline:none;}", ""], function (e) {
    return e.theme.colors.yellow500;
  }, function (e) {
    return e.theme.colors.black;
  }, wc.lg(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    height: 3rem;\n    width: 3rem;\n  "]))), function (e) {
    return Ip(e.theme.colors.yellow500, .75);
  }, function (e) {
    return e.disabled && "pointer-events: none; opacity: 0.333;";
  });

  function XC(e) {
    var t = e.limit,
        n = e.onNext,
        r = e.onPrev,
        o = e.position,
        i = e.total,
        a = e.unit;
    var l = 0 === o,
        c = !1 !== t && o + 2 > t;
    return s.jsxs(fe, {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-around",
      children: [s.jsx(QC, {
        onClick: r,
        disabled: l,
        "data-testid": "paginationPrev",
        title: "Go to previous page",
        children: s.jsx(mc, {
          icon: "chevron-left",
          weight: "regular",
          position: "relative",
          left: "-1px",
          top: "1px"
        })
      }), s.jsxs(ys, {
        color: "black",
        fontSize: 0,
        textAlign: "center",
        "data-testid": "pagecount",
        children: [a && s.jsx(ys, {
          as: "span",
          display: ["block", null, "inline"],
          children: a
        }), " ", R["default"](o), " of ", i]
      }), s.jsx(QC, {
        title: "Go to next page",
        "data-testid": "paginationNext",
        disabled: c,
        onClick: n,
        children: s.jsx(mc, {
          icon: "chevron-right",
          weight: "regular",
          position: "relative",
          right: "-1px",
          top: "1px"
        })
      })]
    });
  }

  QC.displayName = "TransportButton", XC.defaultProps = {
    limit: !1,
    unit: null
  }, XC.propTypes = {
    limit: T["default"].oneOfType([T["default"].number, T["default"].bool]),
    onPrev: T["default"].func.isRequired,
    onNext: T["default"].func.isRequired,
    position: T["default"].number.isRequired,
    total: T["default"].number.isRequired,
    unit: T["default"].string
  };
  var KC = t.createGlobalStyle(["/*! normalize.css v8.0.0 | MIT License | github.com/necolas/normalize.css */html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}h1{font-size:2em;margin:.67em 0}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details{display:block}summary{display:list-item}template{display:none}[hidden]{display:none}html{color:", ";font-family:BlinkMacSystemFont,-apple-system,Roboto,'Segoe UI',sans-serif;font-size:100%;", " &.wf-active{font-family:'Open Sans',BlinkMacSystemFont,-apple-system,Roboto,'Segoe UI',sans-serif;}}body{font-size:", ";line-height:", ";transition:background-color 0.3s ease-out;}abbr[title]{text-decoration:none;}p{margin:0;}p + p{margin-top:1.6em;}strong,b{font-weight:600;}ul{list-style-position:inside;}dd{margin-left:0;}code,pre{font-family:'IBM Plex Mono','SF Mono','Fira Mono','Roboto Mono','Source Code Pro',Menlo,monospace;color:palevioletred;}label{-webkit-tap-highlight-color:transparent;}pre{font-size:", ";}@-moz-document url-prefix(){select{text-indent:-0.125rem;background:transparent;}option{text-shadow:none;color:", ";}}select:-moz-focusring{color:transparent;text-shadow:0 0 0 ", ';}html,body,div,article,aside,section,main,nav,footer,header,hgroup,form,fieldset,legend,pre,code,a,h1,h2,h3,h4,h5,h6,p,ul,ol,li,dl,dt,dd,blockquote,figcaption,figure,textarea,table,td,th,tr,input[type="email"],input[type="number"],input[type="password"],input[type="tel"],input[type="text"],input[type="url"]{box-sizing:border-box;}.rdt{position:relative;}.rdtPicker{left:0;top:0;width:100%;display:none;position:fixed;padding:', " ", ";margin-top:1px;z-index:99999 !important;background:#fff;box-shadow:0 1px 3px rgba(0,0,0,0.1);border:2px solid ", ";border-radius:", ";}", " .rdtOpen .rdtPicker{display:block !important;}.rdtStatic .rdtPicker{box-shadow:none;position:static;}.rdtPicker .rdtTimeToggle{text-align:center;}.rdtPicker table{width:100%;margin:0;}.rdtPicker td,.rdtPicker th{text-align:center;padding:", " ", ";border-radius:", ";line-height:28px;}.rdtPicker td{cursor:pointer;}.rdtPicker td.rdtDay:hover,.rdtPicker td.rdtHour:hover,.rdtPicker td.rdtMinute:hover,.rdtPicker td.rdtSecond:hover,.rdtPicker .rdtTimeToggle:hover{background:", ";cursor:pointer;}.rdtPicker td.rdtOld,.rdtPicker td.rdtNew{color:#999999;}.rdtPicker td.rdtToday{position:relative;}.rdtPicker td.rdtToday:before{content:'';display:inline-block;border-left:7px solid transparent;border-bottom:7px solid #428bca;border-top-color:rgba(0,0,0,0.2);position:absolute;bottom:4px;right:4px;}.rdtPicker td.rdtActive,.rdtPicker td.rdtActive:hover{background-color:", ";color:", ";text-shadow:none !important;font-weight:700;border-radius:", ";}.rdtPicker td.rdtActive.rdtToday:before{border-bottom-color:#fff;}.rdtPicker td.rdtDisabled,.rdtPicker td.rdtDisabled:hover{background:none;color:#999999;cursor:not-allowed;}.rdtPicker td span.rdtOld{color:#999999;}.rdtPicker td span.rdtDisabled,.rdtPicker td span.rdtDisabled:hover{background:none;color:#999999;cursor:not-allowed;}.rdtPicker th{border-bottom:1px solid #f9f9f9;border-radius:", ";}.rdtPicker .dow{width:14.2857%;border-bottom:none;cursor:default;font-size:12px;}.rdtPicker th.rdtSwitch{width:100px;font-size:", ";font-weight:300;padding:", ";}.rdtPicker th.rdtNext,.rdtPicker th.rdtPrev{font-size:21px;vertical-align:middle;}.rdtPrev span,.rdtNext span{display:block;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}.rdtPicker th.rdtDisabled,.rdtPicker th.rdtDisabled:hover{background:none;color:#999999;cursor:not-allowed;}.rdtPicker thead tr:first-child th{cursor:pointer;}.rdtPicker thead tr:first-child th:hover{background:", ";}.rdtPicker tfoot{border-top:1px solid #f9f9f9;}.rdtPicker button{border:none;background:none;cursor:pointer;}.rdtPicker button:hover{background-color:", ";}.rdtPicker thead button{width:100%;height:100%;}td.rdtMonth,td.rdtYear{padding:", ";font-size:", ";cursor:pointer;}td.rdtMonth:hover,td.rdtYear:hover{background:", ";}.rdtCounters{display:flex;align-items:center;}.rdtCounterSeparator{padding:", ";}.rdtCounter .rdtBtn{padding:", ";cursor:pointer;display:block;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}.rdtCounter .rdtBtn:hover{background:", ";}.rdtCounter .rdtCount{font-size:", ";padding:", ";font-weight:300;}.rdtMilli{vertical-align:middle;padding-left:8px;width:48px;}.rdtMilli input{width:100%;font-size:1.2em;margin-top:37px;}.rdtTime td{cursor:default;}"], function (e) {
    return e.theme.colors.black;
  }, wc.xl(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n      font-size: 112.5%;\n    "]))), function (e) {
    return e.theme.fontSizes[1];
  }, function (e) {
    return e.theme.lineHeights.body;
  }, function (e) {
    return e.theme.fontSizes[0];
  }, function (e) {
    return e.theme.colors.black;
  }, function (e) {
    return e.theme.colors.black;
  }, function (e) {
    return e.theme.space[3];
  }, function (e) {
    return e.theme.space[2];
  }, function (e) {
    return e.theme.colors.blue500;
  }, function (e) {
    return e.theme.radii.rounded;
  }, wc.md(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n    .rdtPicker {\n      position: absolute;\n      left: auto;\n      top: auto;\n      width: auto;\n    }\n  "]))), function (e) {
    return e.theme.space[1];
  }, function (e) {
    return e.theme.space[2];
  }, function (e) {
    return e.theme.radii.rounded;
  }, function (e) {
    return e.theme.colors.blue100;
  }, function (e) {
    return e.theme.colors.blue500;
  }, function (e) {
    return e.theme.colors.white;
  }, function (e) {
    return e.theme.radii.rounded;
  }, function (e) {
    return e.theme.radii.rounded;
  }, function (e) {
    return e.theme.fontSizes[3];
  }, function (e) {
    return e.theme.space[2];
  }, function (e) {
    return e.theme.colors.blue100;
  }, function (e) {
    return e.theme.colors.blue100;
  }, function (e) {
    return e.theme.space[3];
  }, function (e) {
    return e.theme.fontSizes[0];
  }, function (e) {
    return e.theme.colors.blue100;
  }, function (e) {
    return e.theme.space[3];
  }, function (e) {
    return e.theme.space[3];
  }, function (e) {
    return e.theme.colors.blue100;
  }, function (e) {
    return e.theme.fontSizes[5];
  }, function (e) {
    return e.theme.space[4];
  }),
      JC = "Dialogue",
      eM = "ReadWatchListen",
      tM = "ReadWatchListen2",
      nM = [JC, "FlashcardSet", "ImageMatching", "ListenAndType", "Matching", "MultipleChoice", "OpenEndedQuestions", "PutInOrder", eM, tM, "SeeAndSpell", "Sequencing", "Speaking", "TrueOrFalse"],
      rM = [JC, eM, tM];
  P["default"](rM, nM);
  var oM = {
    active: T["default"].bool,
    display_type: T["default"].string,
    id: T["default"].number.isRequired,
    instructions: T["default"].string.isRequired,
    subtitle: T["default"].string,
    title: T["default"].string.isRequired,
    type: T["default"].oneOf(nM)
  };
  T["default"].number.isRequired, T["default"].string.isRequired, T["default"].string, T["default"].number, T["default"].string, T["default"].string, T["default"].string, T["default"].string, T["default"].arrayOf(T["default"].shape({
    id: T["default"].number,
    content: T["default"].string,
    headshot: T["default"].shape({
      id: T["default"].number,
      name: T["default"].string,
      icon_url: T["default"].string
    })
  })), T["default"].string, T["default"].string, T["default"].arrayOf(T["default"].shape({
    id: T["default"].number,
    title: T["default"].string,
    image: T["default"].string,
    thumbnail: T["default"].string
  })).isRequired;

  var iM = _objectSpread(_objectSpread({}, oM), {}, {
    images: T["default"].arrayOf(T["default"].shape({
      id: T["default"].number,
      content: T["default"].string,
      image_url: T["default"].string
    })).isRequired
  }),
      aM = _objectSpread(_objectSpread({}, oM), {}, {
    words: T["default"].arrayOf(T["default"].shape({
      id: T["default"].number,
      content: T["default"].string,
      definition: T["default"].string,
      image_url: T["default"].string
    })).isRequired
  }),
      sM = _objectSpread(_objectSpread({}, oM), {}, {
    tts_token: T["default"].string,
    tts_url: T["default"].string,
    images: T["default"].arrayOf(T["default"].shape({
      id: T["default"].number,
      content: T["default"].string,
      definition: T["default"].string,
      image_url: T["default"].string
    })).isRequired
  }),
      lM = _objectSpread(_objectSpread({}, oM), {}, {
    tts_token: T["default"].string,
    tts_url: T["default"].string,
    questions: T["default"].arrayOf(T["default"].shape({
      id: T["default"].number.isRequired,
      content: T["default"].string.isRequired,
      answer_form: T["default"].string,
      reference_task: T["default"].shape(oM),
      image_url: T["default"].string,
      image_caption: T["default"].string,
      image_alt_text: T["default"].string
    }))
  }),
      cM = _objectSpread(_objectSpread({}, oM), {}, {
    statements: T["default"].arrayOf(T["default"].shape({
      content: T["default"].string,
      correct: T["default"].bool,
      id: T["default"].number,
      reference_task: T["default"].object
    })).isRequired
  });

  T["default"].string, T["default"].string, T["default"].string, T["default"].arrayOf(T["default"].string), T["default"].bool, T["default"].string, T["default"].string, T["default"].string, T["default"].string, T["default"].bool;

  var uM = _objectSpread(_objectSpread({}, oM), {}, {
    sentences: T["default"].arrayOf(T["default"].shape({
      id: T["default"].number.isRequired,
      content: T["default"].string.isRequired
    }))
  }),
      dM = _objectSpread(_objectSpread({}, oM), {}, {
    audio_url: T["default"].string,
    bubbles: T["default"].arrayOf(T["default"].shape({
      id: T["default"].number,
      content: T["default"].string,
      headshot: T["default"].shape({
        id: T["default"].number,
        name: T["default"].string,
        icon_url: T["default"].string
      })
    }))
  });

  T["default"].string, T["default"].oneOf(["definition", "hint", "none"]), T["default"].arrayOf(T["default"].string), T["default"].shape({
    id: T["default"].number.isRequired,
    elements: T["default"].arrayOf(T["default"].shape({
      id: T["default"].string.isRequired,
      content: T["default"].string.isRequired,
      type: T["default"].oneOf(["blank", "text"]).isRequired
    })).isRequired,
    audio_url: T["default"].string,
    image_url: T["default"].string,
    image_type: T["default"].oneOf(["no_image", "use_lesson", "use_uploaded"])
  });

  var fM = _objectSpread(_objectSpread({}, oM), {}, {
    questions: T["default"].arrayOf({
      id: T["default"].number.isRequired,
      content: T["default"].string.isRequired,
      answer_form: T["default"].string,
      reference_task: T["default"].shape(oM),
      audio_url: T["default"].string,
      image_url: T["default"].string,
      image_caption: T["default"].string,
      image_alt_text: T["default"].string
    })
  });

  function pM(e) {
    var t = e.src,
        n = e.content,
        r = e.correct;
    return s.jsx(fe, {
      display: "inline-block",
      width: "8rem",
      children: s.jsxs(fe, {
        bg: r ? "green50" : "red50",
        borderRadius: "rounded",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
        pt: 2,
        pb: 3,
        px: "1ch",
        children: [s.jsx(fe, {
          position: "absolute",
          top: "-0.75rem",
          right: "-0.75rem",
          bg: r ? "green500" : "red500",
          size: "1.5rem",
          borderRadius: "circular",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          children: s.jsx(mc, {
            icon: r ? "check" : "times",
            color: "white",
            weight: "regular",
            fontSize: 0,
            position: "relative",
            top: "1px"
          })
        }), s.jsx(he, {
          border: "2px solid",
          borderColor: r ? "green500" : "red500",
          borderRadius: "rounded",
          m: 1,
          size: "3.75rem",
          alt: "Image of ".concat(n),
          src: t
        }), s.jsx(ys, {
          fontWeight: "600",
          fontSize: 0,
          mt: 2,
          textAlign: "center",
          children: n
        })]
      })
    });
  }

  function hM(e) {
    var t = e.task;
    var n = t.images;
    return s.jsx(vh, {
      as: "ol",
      m: 0,
      reset: !0,
      children: n.map(function (e, t, n) {
        return s.jsx(fe, {
          mb: [3, null, 4],
          pb: [3, null, 4],
          borderBottom: "2px solid",
          borderColor: t === n.length - 1 ? "transparent" : "gray200",
          children: s.jsxs(ys, {
            as: "li",
            display: "flex",
            children: [s.jsx(fe, {
              mr: 2,
              width: ["1rem", null, "1.5rem"],
              children: s.jsxs(ys, {
                fontWeight: "700",
                fontSize: [0, null, 1],
                children: [t + 1, "."]
              })
            }), s.jsx(fe, {
              flex: "1",
              children: s.jsx(pM, {
                correct: !0,
                src: e.image_url,
                content: e.content
              })
            })]
          })
        }, e.id);
      })
    });
  }

  function mM(e) {
    var t = e.images,
        n = e.answers;

    var r = function r(e) {
      return F["default"](z["default"]("id", e), t);
    };

    return s.jsx(vh, {
      as: "ol",
      m: 0,
      reset: !0,
      children: n.map(function (e, t, n) {
        var o = e.is_correct,
            i = r(e.image_id),
            a = o ? i : r(e.matched_image_id);
        return s.jsx(fe, {
          mb: [3, null, 4],
          pb: [3, null, 4],
          borderBottom: "2px solid",
          borderColor: t === n.length - 1 ? "transparent" : "gray200",
          children: s.jsxs(ys, {
            as: "li",
            display: "flex",
            children: [s.jsx(fe, {
              mr: 2,
              width: ["1rem", null, "1.5rem"],
              children: s.jsxs(ys, {
                fontWeight: "700",
                fontSize: [0, null, 1],
                children: [t + 1, "."]
              })
            }), s.jsxs(fe, {
              flex: "1",
              children: [s.jsx(pM, {
                src: i.image_url,
                content: a.content,
                correct: o
              }), !o && s.jsxs(ys, {
                fontSize: 0,
                mt: 3,
                children: ["Correct answer:", " ", s.jsx(ys, {
                  as: "span",
                  color: "green700",
                  fontWeight: "600",
                  children: i.content
                })]
              })]
            })]
          })
        }, e.id);
      })
    });
  }
  /*! @license DOMPurify 2.4.5 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.4.5/LICENSE */


  function gM(e) {
    return gM = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
      return _typeof(e);
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
    }, gM(e);
  }

  function yM(e, t) {
    return yM = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    }, yM(e, t);
  }

  function bM() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }

  function vM(e, t, n) {
    return vM = bM() ? Reflect.construct : function (e, t, n) {
      var r = [null];
      r.push.apply(r, t);
      var o = new (Function.bind.apply(e, r))();
      return n && yM(o, n.prototype), o;
    }, vM.apply(null, arguments);
  }

  function xM(e) {
    return function (e) {
      if (Array.isArray(e)) return wM(e);
    }(e) || function (e) {
      if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
    }(e) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return wM(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === n && e.constructor && (n = e.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(e);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return wM(e, t);
    }(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function wM(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }

    return r;
  }

  T["default"].arrayOf({
    id: T["default"].number.isRequired,
    content: T["default"].string.isRequired,
    answers: T["default"].array,
    reference_task: T["default"].shape(oM),
    audio_url: T["default"].string,
    image_url: T["default"].string,
    image_caption: T["default"].string,
    image_alt_text: T["default"].string
  }), pM.propTypes = {
    content: T["default"].string.isRequired,
    correct: T["default"].bool.isRequired,
    src: T["default"].string.isRequired
  }, hM.propTypes = {
    task: T["default"].shape(iM).isRequired
  }, mM.propTypes = {
    images: iM.images.isRequired,
    answers: T["default"].arrayOf({
      id: T["default"].number,
      content: T["default"].string,
      matchedId: T["default"].number,
      matchedContent: T["default"].string
    }).isRequired
  };
  var kM = Object.hasOwnProperty,
      CM = Object.setPrototypeOf,
      MM = Object.isFrozen,
      jM = Object.getPrototypeOf,
      EM = Object.getOwnPropertyDescriptor,
      _M = Object.freeze,
      TM = Object.seal,
      SM = Object.create,
      LM = "undefined" != typeof Reflect && Reflect,
      DM = LM.apply,
      AM = LM.construct;
  DM || (DM = function DM(e, t, n) {
    return e.apply(t, n);
  }), _M || (_M = function _M(e) {
    return e;
  }), TM || (TM = function TM(e) {
    return e;
  }), AM || (AM = function AM(e, t) {
    return vM(e, xM(t));
  });
  var NM,
      IM = ZM(Array.prototype.forEach),
      zM = ZM(Array.prototype.pop),
      OM = ZM(Array.prototype.push),
      RM = ZM(String.prototype.toLowerCase),
      PM = ZM(String.prototype.toString),
      FM = ZM(String.prototype.match),
      BM = ZM(String.prototype.replace),
      qM = ZM(String.prototype.indexOf),
      UM = ZM(String.prototype.trim),
      VM = ZM(RegExp.prototype.test),
      HM = (NM = TypeError, function () {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
      t[n] = arguments[n];
    }

    return AM(NM, t);
  });

  function ZM(e) {
    return function (t) {
      for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++) {
        r[o - 1] = arguments[o];
      }

      return DM(e, t, r);
    };
  }

  function WM(e, t, n) {
    n = n || RM, CM && CM(e, null);

    for (var r = t.length; r--;) {
      var o = t[r];

      if ("string" == typeof o) {
        var i = n(o);
        i !== o && (MM(t) || (t[r] = i), o = i);
      }

      e[o] = !0;
    }

    return e;
  }

  function $M(e) {
    var t,
        n = SM(null);

    for (t in e) {
      !0 === DM(kM, e, [t]) && (n[t] = e[t]);
    }

    return n;
  }

  function GM(e, t) {
    for (; null !== e;) {
      var n = EM(e, t);

      if (n) {
        if (n.get) return ZM(n.get);
        if ("function" == typeof n.value) return ZM(n.value);
      }

      e = jM(e);
    }

    return function (e) {
      return console.warn("fallback value for", e), null;
    };
  }

  var YM = _M(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]),
      QM = _M(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]),
      XM = _M(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]),
      KM = _M(["animate", "color-profile", "cursor", "discard", "fedropshadow", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]),
      JM = _M(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover"]),
      ej = _M(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]),
      tj = _M(["#text"]),
      nj = _M(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "xmlns", "slot"]),
      rj = _M(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]),
      oj = _M(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]),
      ij = _M(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]),
      aj = TM(/\{\{[\w\W]*|[\w\W]*\}\}/gm),
      sj = TM(/<%[\w\W]*|[\w\W]*%>/gm),
      lj = TM(/\${[\w\W]*}/gm),
      cj = TM(/^data-[\-\w.\u00B7-\uFFFF]/),
      uj = TM(/^aria-[\-\w]+$/),
      dj = TM(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i),
      fj = TM(/^(?:\w+script|data):/i),
      pj = TM(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g),
      hj = TM(/^html$/i),
      mj = function mj() {
    return "undefined" == typeof window ? null : window;
  },
      gj = function gj(e, t) {
    if ("object" !== gM(e) || "function" != typeof e.createPolicy) return null;
    var n = null,
        r = "data-tt-policy-suffix";
    t.currentScript && t.currentScript.hasAttribute(r) && (n = t.currentScript.getAttribute(r));
    var o = "dompurify" + (n ? "#" + n : "");

    try {
      return e.createPolicy(o, {
        createHTML: function createHTML(e) {
          return e;
        },
        createScriptURL: function createScriptURL(e) {
          return e;
        }
      });
    } catch (e) {
      return console.warn("TrustedTypes policy " + o + " could not be created."), null;
    }
  };

  var yj = function e() {
    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : mj(),
        n = function n(t) {
      return e(t);
    };

    if (n.version = "2.4.5", n.removed = [], !t || !t.document || 9 !== t.document.nodeType) return n.isSupported = !1, n;
    var r = t.document,
        o = t.document,
        i = t.DocumentFragment,
        a = t.HTMLTemplateElement,
        s = t.Node,
        l = t.Element,
        c = t.NodeFilter,
        u = t.NamedNodeMap,
        d = void 0 === u ? t.NamedNodeMap || t.MozNamedAttrMap : u,
        f = t.HTMLFormElement,
        p = t.DOMParser,
        h = t.trustedTypes,
        m = l.prototype,
        g = GM(m, "cloneNode"),
        y = GM(m, "nextSibling"),
        b = GM(m, "childNodes"),
        v = GM(m, "parentNode");

    if ("function" == typeof a) {
      var x = o.createElement("template");
      x.content && x.content.ownerDocument && (o = x.content.ownerDocument);
    }

    var w = gj(h, r),
        k = w ? w.createHTML("") : "",
        C = o,
        M = C.implementation,
        j = C.createNodeIterator,
        E = C.createDocumentFragment,
        _ = C.getElementsByTagName,
        T = r.importNode,
        S = {};

    try {
      S = $M(o).documentMode ? o.documentMode : {};
    } catch (e) {}

    var L = {};
    n.isSupported = "function" == typeof v && M && void 0 !== M.createHTMLDocument && 9 !== S;

    var D,
        A,
        N = aj,
        I = sj,
        z = lj,
        O = cj,
        R = uj,
        P = fj,
        F = pj,
        B = dj,
        q = null,
        U = WM({}, [].concat(xM(YM), xM(QM), xM(XM), xM(JM), xM(tj))),
        V = null,
        H = WM({}, [].concat(xM(nj), xM(rj), xM(oj), xM(ij))),
        Z = Object.seal(Object.create(null, {
      tagNameCheck: {
        writable: !0,
        configurable: !1,
        enumerable: !0,
        value: null
      },
      attributeNameCheck: {
        writable: !0,
        configurable: !1,
        enumerable: !0,
        value: null
      },
      allowCustomizedBuiltInElements: {
        writable: !0,
        configurable: !1,
        enumerable: !0,
        value: !1
      }
    })),
        W = null,
        $ = null,
        G = !0,
        Y = !0,
        Q = !1,
        X = !0,
        K = !1,
        J = !1,
        ee = !1,
        te = !1,
        ne = !1,
        re = !1,
        oe = !1,
        ie = !0,
        ae = !1,
        se = "user-content-",
        le = !0,
        ce = !1,
        ue = {},
        de = null,
        fe = WM({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]),
        pe = null,
        he = WM({}, ["audio", "video", "img", "source", "image", "track"]),
        me = null,
        ge = WM({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]),
        ye = "http://www.w3.org/1998/Math/MathML",
        be = "http://www.w3.org/2000/svg",
        ve = "http://www.w3.org/1999/xhtml",
        xe = ve,
        we = !1,
        ke = null,
        Ce = WM({}, [ye, be, ve], PM),
        Me = ["application/xhtml+xml", "text/html"],
        je = "text/html",
        Ee = null,
        _e = o.createElement("form"),
        Te = function Te(e) {
      return e instanceof RegExp || e instanceof Function;
    },
        Se = function Se(e) {
      Ee && Ee === e || (e && "object" === gM(e) || (e = {}), e = $M(e), D = D = -1 === Me.indexOf(e.PARSER_MEDIA_TYPE) ? je : e.PARSER_MEDIA_TYPE, A = "application/xhtml+xml" === D ? PM : RM, q = "ALLOWED_TAGS" in e ? WM({}, e.ALLOWED_TAGS, A) : U, V = "ALLOWED_ATTR" in e ? WM({}, e.ALLOWED_ATTR, A) : H, ke = "ALLOWED_NAMESPACES" in e ? WM({}, e.ALLOWED_NAMESPACES, PM) : Ce, me = "ADD_URI_SAFE_ATTR" in e ? WM($M(ge), e.ADD_URI_SAFE_ATTR, A) : ge, pe = "ADD_DATA_URI_TAGS" in e ? WM($M(he), e.ADD_DATA_URI_TAGS, A) : he, de = "FORBID_CONTENTS" in e ? WM({}, e.FORBID_CONTENTS, A) : fe, W = "FORBID_TAGS" in e ? WM({}, e.FORBID_TAGS, A) : {}, $ = "FORBID_ATTR" in e ? WM({}, e.FORBID_ATTR, A) : {}, ue = "USE_PROFILES" in e && e.USE_PROFILES, G = !1 !== e.ALLOW_ARIA_ATTR, Y = !1 !== e.ALLOW_DATA_ATTR, Q = e.ALLOW_UNKNOWN_PROTOCOLS || !1, X = !1 !== e.ALLOW_SELF_CLOSE_IN_ATTR, K = e.SAFE_FOR_TEMPLATES || !1, J = e.WHOLE_DOCUMENT || !1, ne = e.RETURN_DOM || !1, re = e.RETURN_DOM_FRAGMENT || !1, oe = e.RETURN_TRUSTED_TYPE || !1, te = e.FORCE_BODY || !1, ie = !1 !== e.SANITIZE_DOM, ae = e.SANITIZE_NAMED_PROPS || !1, le = !1 !== e.KEEP_CONTENT, ce = e.IN_PLACE || !1, B = e.ALLOWED_URI_REGEXP || B, xe = e.NAMESPACE || ve, Z = e.CUSTOM_ELEMENT_HANDLING || {}, e.CUSTOM_ELEMENT_HANDLING && Te(e.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (Z.tagNameCheck = e.CUSTOM_ELEMENT_HANDLING.tagNameCheck), e.CUSTOM_ELEMENT_HANDLING && Te(e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (Z.attributeNameCheck = e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), e.CUSTOM_ELEMENT_HANDLING && "boolean" == typeof e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (Z.allowCustomizedBuiltInElements = e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), K && (Y = !1), re && (ne = !0), ue && (q = WM({}, xM(tj)), V = [], !0 === ue.html && (WM(q, YM), WM(V, nj)), !0 === ue.svg && (WM(q, QM), WM(V, rj), WM(V, ij)), !0 === ue.svgFilters && (WM(q, XM), WM(V, rj), WM(V, ij)), !0 === ue.mathMl && (WM(q, JM), WM(V, oj), WM(V, ij))), e.ADD_TAGS && (q === U && (q = $M(q)), WM(q, e.ADD_TAGS, A)), e.ADD_ATTR && (V === H && (V = $M(V)), WM(V, e.ADD_ATTR, A)), e.ADD_URI_SAFE_ATTR && WM(me, e.ADD_URI_SAFE_ATTR, A), e.FORBID_CONTENTS && (de === fe && (de = $M(de)), WM(de, e.FORBID_CONTENTS, A)), le && (q["#text"] = !0), J && WM(q, ["html", "head", "body"]), q.table && (WM(q, ["tbody"]), delete W.tbody), _M && _M(e), Ee = e);
    },
        Le = WM({}, ["mi", "mo", "mn", "ms", "mtext"]),
        De = WM({}, ["foreignobject", "desc", "title", "annotation-xml"]),
        Ae = WM({}, ["title", "style", "font", "a", "script"]),
        Ne = WM({}, QM);

    WM(Ne, XM), WM(Ne, KM);
    var Ie = WM({}, JM);
    WM(Ie, ej);

    var ze = function ze(e) {
      var t = v(e);
      t && t.tagName || (t = {
        namespaceURI: xe,
        tagName: "template"
      });
      var n = RM(e.tagName),
          r = RM(t.tagName);
      return !!ke[e.namespaceURI] && (e.namespaceURI === be ? t.namespaceURI === ve ? "svg" === n : t.namespaceURI === ye ? "svg" === n && ("annotation-xml" === r || Le[r]) : Boolean(Ne[n]) : e.namespaceURI === ye ? t.namespaceURI === ve ? "math" === n : t.namespaceURI === be ? "math" === n && De[r] : Boolean(Ie[n]) : e.namespaceURI === ve ? !(t.namespaceURI === be && !De[r]) && !(t.namespaceURI === ye && !Le[r]) && !Ie[n] && (Ae[n] || !Ne[n]) : !("application/xhtml+xml" !== D || !ke[e.namespaceURI]));
    },
        Oe = function Oe(e) {
      OM(n.removed, {
        element: e
      });

      try {
        e.parentNode.removeChild(e);
      } catch (t) {
        try {
          e.outerHTML = k;
        } catch (t) {
          e.remove();
        }
      }
    },
        Re = function Re(e, t) {
      try {
        OM(n.removed, {
          attribute: t.getAttributeNode(e),
          from: t
        });
      } catch (e) {
        OM(n.removed, {
          attribute: null,
          from: t
        });
      }

      if (t.removeAttribute(e), "is" === e && !V[e]) if (ne || re) try {
        Oe(t);
      } catch (e) {} else try {
        t.setAttribute(e, "");
      } catch (e) {}
    },
        Pe = function Pe(e) {
      var t, n;
      if (te) e = "<remove></remove>" + e;else {
        var r = FM(e, /^[\r\n\t ]+/);
        n = r && r[0];
      }
      "application/xhtml+xml" === D && xe === ve && (e = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + e + "</body></html>");
      var i = w ? w.createHTML(e) : e;
      if (xe === ve) try {
        t = new p().parseFromString(i, D);
      } catch (e) {}

      if (!t || !t.documentElement) {
        t = M.createDocument(xe, "template", null);

        try {
          t.documentElement.innerHTML = we ? k : i;
        } catch (e) {}
      }

      var a = t.body || t.documentElement;
      return e && n && a.insertBefore(o.createTextNode(n), a.childNodes[0] || null), xe === ve ? _.call(t, J ? "html" : "body")[0] : J ? t.documentElement : a;
    },
        Fe = function Fe(e) {
      return j.call(e.ownerDocument || e, e, c.SHOW_ELEMENT | c.SHOW_COMMENT | c.SHOW_TEXT, null, !1);
    },
        Be = function Be(e) {
      return e instanceof f && ("string" != typeof e.nodeName || "string" != typeof e.textContent || "function" != typeof e.removeChild || !(e.attributes instanceof d) || "function" != typeof e.removeAttribute || "function" != typeof e.setAttribute || "string" != typeof e.namespaceURI || "function" != typeof e.insertBefore || "function" != typeof e.hasChildNodes);
    },
        qe = function qe(e) {
      return "object" === gM(s) ? e instanceof s : e && "object" === gM(e) && "number" == typeof e.nodeType && "string" == typeof e.nodeName;
    },
        Ue = function Ue(e, t, r) {
      L[e] && IM(L[e], function (e) {
        e.call(n, t, r, Ee);
      });
    },
        Ve = function Ve(e) {
      var t;
      if (Ue("beforeSanitizeElements", e, null), Be(e)) return Oe(e), !0;
      if (VM(/[\u0080-\uFFFF]/, e.nodeName)) return Oe(e), !0;
      var r = A(e.nodeName);
      if (Ue("uponSanitizeElement", e, {
        tagName: r,
        allowedTags: q
      }), e.hasChildNodes() && !qe(e.firstElementChild) && (!qe(e.content) || !qe(e.content.firstElementChild)) && VM(/<[/\w]/g, e.innerHTML) && VM(/<[/\w]/g, e.textContent)) return Oe(e), !0;
      if ("select" === r && VM(/<template/i, e.innerHTML)) return Oe(e), !0;

      if (!q[r] || W[r]) {
        if (!W[r] && Ze(r)) {
          if (Z.tagNameCheck instanceof RegExp && VM(Z.tagNameCheck, r)) return !1;
          if (Z.tagNameCheck instanceof Function && Z.tagNameCheck(r)) return !1;
        }

        if (le && !de[r]) {
          var o = v(e) || e.parentNode,
              i = b(e) || e.childNodes;
          if (i && o) for (var a = i.length - 1; a >= 0; --a) {
            o.insertBefore(g(i[a], !0), y(e));
          }
        }

        return Oe(e), !0;
      }

      return e instanceof l && !ze(e) ? (Oe(e), !0) : "noscript" !== r && "noembed" !== r || !VM(/<\/no(script|embed)/i, e.innerHTML) ? (K && 3 === e.nodeType && (t = e.textContent, t = BM(t, N, " "), t = BM(t, I, " "), t = BM(t, z, " "), e.textContent !== t && (OM(n.removed, {
        element: e.cloneNode()
      }), e.textContent = t)), Ue("afterSanitizeElements", e, null), !1) : (Oe(e), !0);
    },
        He = function He(e, t, n) {
      if (ie && ("id" === t || "name" === t) && (n in o || n in _e)) return !1;
      if (Y && !$[t] && VM(O, t)) ;else if (G && VM(R, t)) ;else if (!V[t] || $[t]) {
        if (!(Ze(e) && (Z.tagNameCheck instanceof RegExp && VM(Z.tagNameCheck, e) || Z.tagNameCheck instanceof Function && Z.tagNameCheck(e)) && (Z.attributeNameCheck instanceof RegExp && VM(Z.attributeNameCheck, t) || Z.attributeNameCheck instanceof Function && Z.attributeNameCheck(t)) || "is" === t && Z.allowCustomizedBuiltInElements && (Z.tagNameCheck instanceof RegExp && VM(Z.tagNameCheck, n) || Z.tagNameCheck instanceof Function && Z.tagNameCheck(n)))) return !1;
      } else if (me[t]) ;else if (VM(B, BM(n, F, ""))) ;else if ("src" !== t && "xlink:href" !== t && "href" !== t || "script" === e || 0 !== qM(n, "data:") || !pe[e]) {
        if (Q && !VM(P, BM(n, F, ""))) ;else if (n) return !1;
      } else ;
      return !0;
    },
        Ze = function Ze(e) {
      return e.indexOf("-") > 0;
    },
        We = function We(e) {
      var t, r, o, i;
      Ue("beforeSanitizeAttributes", e, null);
      var a = e.attributes;

      if (a) {
        var s = {
          attrName: "",
          attrValue: "",
          keepAttr: !0,
          allowedAttributes: V
        };

        for (i = a.length; i--;) {
          var l = t = a[i],
              c = l.name,
              u = l.namespaceURI;
          if (r = "value" === c ? t.value : UM(t.value), o = A(c), s.attrName = o, s.attrValue = r, s.keepAttr = !0, s.forceKeepAttr = void 0, Ue("uponSanitizeAttribute", e, s), r = s.attrValue, !s.forceKeepAttr && (Re(c, e), s.keepAttr)) if (X || !VM(/\/>/i, r)) {
            K && (r = BM(r, N, " "), r = BM(r, I, " "), r = BM(r, z, " "));
            var d = A(e.nodeName);

            if (He(d, o, r)) {
              if (!ae || "id" !== o && "name" !== o || (Re(c, e), r = se + r), w && "object" === gM(h) && "function" == typeof h.getAttributeType) if (u) ;else switch (h.getAttributeType(d, o)) {
                case "TrustedHTML":
                  r = w.createHTML(r);
                  break;

                case "TrustedScriptURL":
                  r = w.createScriptURL(r);
              }

              try {
                u ? e.setAttributeNS(u, c, r) : e.setAttribute(c, r), zM(n.removed);
              } catch (e) {}
            }
          } else Re(c, e);
        }

        Ue("afterSanitizeAttributes", e, null);
      }
    },
        $e = function e(t) {
      var n,
          r = Fe(t);

      for (Ue("beforeSanitizeShadowDOM", t, null); n = r.nextNode();) {
        Ue("uponSanitizeShadowNode", n, null), Ve(n) || (n.content instanceof i && e(n.content), We(n));
      }

      Ue("afterSanitizeShadowDOM", t, null);
    };

    return n.sanitize = function (e) {
      var o,
          a,
          l,
          c,
          u,
          d = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};

      if ((we = !e) && (e = "\x3c!--\x3e"), "string" != typeof e && !qe(e)) {
        if ("function" != typeof e.toString) throw HM("toString is not a function");
        if ("string" != typeof (e = e.toString())) throw HM("dirty is not a string, aborting");
      }

      if (!n.isSupported) {
        if ("object" === gM(t.toStaticHTML) || "function" == typeof t.toStaticHTML) {
          if ("string" == typeof e) return t.toStaticHTML(e);
          if (qe(e)) return t.toStaticHTML(e.outerHTML);
        }

        return e;
      }

      if (ee || Se(d), n.removed = [], "string" == typeof e && (ce = !1), ce) {
        if (e.nodeName) {
          var f = A(e.nodeName);
          if (!q[f] || W[f]) throw HM("root node is forbidden and cannot be sanitized in-place");
        }
      } else if (e instanceof s) 1 === (a = (o = Pe("\x3c!----\x3e")).ownerDocument.importNode(e, !0)).nodeType && "BODY" === a.nodeName || "HTML" === a.nodeName ? o = a : o.appendChild(a);else {
        if (!ne && !K && !J && -1 === e.indexOf("<")) return w && oe ? w.createHTML(e) : e;
        if (!(o = Pe(e))) return ne ? null : oe ? k : "";
      }

      o && te && Oe(o.firstChild);

      for (var p = Fe(ce ? e : o); l = p.nextNode();) {
        3 === l.nodeType && l === c || Ve(l) || (l.content instanceof i && $e(l.content), We(l), c = l);
      }

      if (c = null, ce) return e;

      if (ne) {
        if (re) for (u = E.call(o.ownerDocument); o.firstChild;) {
          u.appendChild(o.firstChild);
        } else u = o;
        return (V.shadowroot || V.shadowrootmod) && (u = T.call(r, u, !0)), u;
      }

      var h = J ? o.outerHTML : o.innerHTML;
      return J && q["!doctype"] && o.ownerDocument && o.ownerDocument.doctype && o.ownerDocument.doctype.name && VM(hj, o.ownerDocument.doctype.name) && (h = "<!DOCTYPE " + o.ownerDocument.doctype.name + ">\n" + h), K && (h = BM(h, N, " "), h = BM(h, I, " "), h = BM(h, z, " ")), w && oe ? w.createHTML(h) : h;
    }, n.setConfig = function (e) {
      Se(e), ee = !0;
    }, n.clearConfig = function () {
      Ee = null, ee = !1;
    }, n.isValidAttribute = function (e, t, n) {
      Ee || Se({});
      var r = A(e),
          o = A(t);
      return He(r, o, n);
    }, n.addHook = function (e, t) {
      "function" == typeof t && (L[e] = L[e] || [], OM(L[e], t));
    }, n.removeHook = function (e) {
      if (L[e]) return zM(L[e]);
    }, n.removeHooks = function (e) {
      L[e] && (L[e] = []);
    }, n.removeAllHooks = function () {
      L = {};
    }, n;
  }(),
      bj = {
    exports: {}
  },
      vj = {},
      xj = {
    exports: {}
  },
      wj = {
    Aacute: "Á",
    aacute: "á",
    Abreve: "Ă",
    abreve: "ă",
    ac: "∾",
    acd: "∿",
    acE: "∾̳",
    Acirc: "Â",
    acirc: "â",
    acute: "´",
    Acy: "А",
    acy: "а",
    AElig: "Æ",
    aelig: "æ",
    af: "⁡",
    Afr: "𝔄",
    afr: "𝔞",
    Agrave: "À",
    agrave: "à",
    alefsym: "ℵ",
    aleph: "ℵ",
    Alpha: "Α",
    alpha: "α",
    Amacr: "Ā",
    amacr: "ā",
    amalg: "⨿",
    amp: "&",
    AMP: "&",
    andand: "⩕",
    And: "⩓",
    and: "∧",
    andd: "⩜",
    andslope: "⩘",
    andv: "⩚",
    ang: "∠",
    ange: "⦤",
    angle: "∠",
    angmsdaa: "⦨",
    angmsdab: "⦩",
    angmsdac: "⦪",
    angmsdad: "⦫",
    angmsdae: "⦬",
    angmsdaf: "⦭",
    angmsdag: "⦮",
    angmsdah: "⦯",
    angmsd: "∡",
    angrt: "∟",
    angrtvb: "⊾",
    angrtvbd: "⦝",
    angsph: "∢",
    angst: "Å",
    angzarr: "⍼",
    Aogon: "Ą",
    aogon: "ą",
    Aopf: "𝔸",
    aopf: "𝕒",
    apacir: "⩯",
    ap: "≈",
    apE: "⩰",
    ape: "≊",
    apid: "≋",
    apos: "'",
    ApplyFunction: "⁡",
    approx: "≈",
    approxeq: "≊",
    Aring: "Å",
    aring: "å",
    Ascr: "𝒜",
    ascr: "𝒶",
    Assign: "≔",
    ast: "*",
    asymp: "≈",
    asympeq: "≍",
    Atilde: "Ã",
    atilde: "ã",
    Auml: "Ä",
    auml: "ä",
    awconint: "∳",
    awint: "⨑",
    backcong: "≌",
    backepsilon: "϶",
    backprime: "‵",
    backsim: "∽",
    backsimeq: "⋍",
    Backslash: "∖",
    Barv: "⫧",
    barvee: "⊽",
    barwed: "⌅",
    Barwed: "⌆",
    barwedge: "⌅",
    bbrk: "⎵",
    bbrktbrk: "⎶",
    bcong: "≌",
    Bcy: "Б",
    bcy: "б",
    bdquo: "„",
    becaus: "∵",
    because: "∵",
    Because: "∵",
    bemptyv: "⦰",
    bepsi: "϶",
    bernou: "ℬ",
    Bernoullis: "ℬ",
    Beta: "Β",
    beta: "β",
    beth: "ℶ",
    between: "≬",
    Bfr: "𝔅",
    bfr: "𝔟",
    bigcap: "⋂",
    bigcirc: "◯",
    bigcup: "⋃",
    bigodot: "⨀",
    bigoplus: "⨁",
    bigotimes: "⨂",
    bigsqcup: "⨆",
    bigstar: "★",
    bigtriangledown: "▽",
    bigtriangleup: "△",
    biguplus: "⨄",
    bigvee: "⋁",
    bigwedge: "⋀",
    bkarow: "⤍",
    blacklozenge: "⧫",
    blacksquare: "▪",
    blacktriangle: "▴",
    blacktriangledown: "▾",
    blacktriangleleft: "◂",
    blacktriangleright: "▸",
    blank: "␣",
    blk12: "▒",
    blk14: "░",
    blk34: "▓",
    block: "█",
    bne: "=⃥",
    bnequiv: "≡⃥",
    bNot: "⫭",
    bnot: "⌐",
    Bopf: "𝔹",
    bopf: "𝕓",
    bot: "⊥",
    bottom: "⊥",
    bowtie: "⋈",
    boxbox: "⧉",
    boxdl: "┐",
    boxdL: "╕",
    boxDl: "╖",
    boxDL: "╗",
    boxdr: "┌",
    boxdR: "╒",
    boxDr: "╓",
    boxDR: "╔",
    boxh: "─",
    boxH: "═",
    boxhd: "┬",
    boxHd: "╤",
    boxhD: "╥",
    boxHD: "╦",
    boxhu: "┴",
    boxHu: "╧",
    boxhU: "╨",
    boxHU: "╩",
    boxminus: "⊟",
    boxplus: "⊞",
    boxtimes: "⊠",
    boxul: "┘",
    boxuL: "╛",
    boxUl: "╜",
    boxUL: "╝",
    boxur: "└",
    boxuR: "╘",
    boxUr: "╙",
    boxUR: "╚",
    boxv: "│",
    boxV: "║",
    boxvh: "┼",
    boxvH: "╪",
    boxVh: "╫",
    boxVH: "╬",
    boxvl: "┤",
    boxvL: "╡",
    boxVl: "╢",
    boxVL: "╣",
    boxvr: "├",
    boxvR: "╞",
    boxVr: "╟",
    boxVR: "╠",
    bprime: "‵",
    breve: "˘",
    Breve: "˘",
    brvbar: "¦",
    bscr: "𝒷",
    Bscr: "ℬ",
    bsemi: "⁏",
    bsim: "∽",
    bsime: "⋍",
    bsolb: "⧅",
    bsol: "\\",
    bsolhsub: "⟈",
    bull: "•",
    bullet: "•",
    bump: "≎",
    bumpE: "⪮",
    bumpe: "≏",
    Bumpeq: "≎",
    bumpeq: "≏",
    Cacute: "Ć",
    cacute: "ć",
    capand: "⩄",
    capbrcup: "⩉",
    capcap: "⩋",
    cap: "∩",
    Cap: "⋒",
    capcup: "⩇",
    capdot: "⩀",
    CapitalDifferentialD: "ⅅ",
    caps: "∩︀",
    caret: "⁁",
    caron: "ˇ",
    Cayleys: "ℭ",
    ccaps: "⩍",
    Ccaron: "Č",
    ccaron: "č",
    Ccedil: "Ç",
    ccedil: "ç",
    Ccirc: "Ĉ",
    ccirc: "ĉ",
    Cconint: "∰",
    ccups: "⩌",
    ccupssm: "⩐",
    Cdot: "Ċ",
    cdot: "ċ",
    cedil: "¸",
    Cedilla: "¸",
    cemptyv: "⦲",
    cent: "¢",
    centerdot: "·",
    CenterDot: "·",
    cfr: "𝔠",
    Cfr: "ℭ",
    CHcy: "Ч",
    chcy: "ч",
    check: "✓",
    checkmark: "✓",
    Chi: "Χ",
    chi: "χ",
    circ: "ˆ",
    circeq: "≗",
    circlearrowleft: "↺",
    circlearrowright: "↻",
    circledast: "⊛",
    circledcirc: "⊚",
    circleddash: "⊝",
    CircleDot: "⊙",
    circledR: "®",
    circledS: "Ⓢ",
    CircleMinus: "⊖",
    CirclePlus: "⊕",
    CircleTimes: "⊗",
    cir: "○",
    cirE: "⧃",
    cire: "≗",
    cirfnint: "⨐",
    cirmid: "⫯",
    cirscir: "⧂",
    ClockwiseContourIntegral: "∲",
    CloseCurlyDoubleQuote: "”",
    CloseCurlyQuote: "’",
    clubs: "♣",
    clubsuit: "♣",
    colon: ":",
    Colon: "∷",
    Colone: "⩴",
    colone: "≔",
    coloneq: "≔",
    comma: ",",
    commat: "@",
    comp: "∁",
    compfn: "∘",
    complement: "∁",
    complexes: "ℂ",
    cong: "≅",
    congdot: "⩭",
    Congruent: "≡",
    conint: "∮",
    Conint: "∯",
    ContourIntegral: "∮",
    copf: "𝕔",
    Copf: "ℂ",
    coprod: "∐",
    Coproduct: "∐",
    copy: "©",
    COPY: "©",
    copysr: "℗",
    CounterClockwiseContourIntegral: "∳",
    crarr: "↵",
    cross: "✗",
    Cross: "⨯",
    Cscr: "𝒞",
    cscr: "𝒸",
    csub: "⫏",
    csube: "⫑",
    csup: "⫐",
    csupe: "⫒",
    ctdot: "⋯",
    cudarrl: "⤸",
    cudarrr: "⤵",
    cuepr: "⋞",
    cuesc: "⋟",
    cularr: "↶",
    cularrp: "⤽",
    cupbrcap: "⩈",
    cupcap: "⩆",
    CupCap: "≍",
    cup: "∪",
    Cup: "⋓",
    cupcup: "⩊",
    cupdot: "⊍",
    cupor: "⩅",
    cups: "∪︀",
    curarr: "↷",
    curarrm: "⤼",
    curlyeqprec: "⋞",
    curlyeqsucc: "⋟",
    curlyvee: "⋎",
    curlywedge: "⋏",
    curren: "¤",
    curvearrowleft: "↶",
    curvearrowright: "↷",
    cuvee: "⋎",
    cuwed: "⋏",
    cwconint: "∲",
    cwint: "∱",
    cylcty: "⌭",
    dagger: "†",
    Dagger: "‡",
    daleth: "ℸ",
    darr: "↓",
    Darr: "↡",
    dArr: "⇓",
    dash: "‐",
    Dashv: "⫤",
    dashv: "⊣",
    dbkarow: "⤏",
    dblac: "˝",
    Dcaron: "Ď",
    dcaron: "ď",
    Dcy: "Д",
    dcy: "д",
    ddagger: "‡",
    ddarr: "⇊",
    DD: "ⅅ",
    dd: "ⅆ",
    DDotrahd: "⤑",
    ddotseq: "⩷",
    deg: "°",
    Del: "∇",
    Delta: "Δ",
    delta: "δ",
    demptyv: "⦱",
    dfisht: "⥿",
    Dfr: "𝔇",
    dfr: "𝔡",
    dHar: "⥥",
    dharl: "⇃",
    dharr: "⇂",
    DiacriticalAcute: "´",
    DiacriticalDot: "˙",
    DiacriticalDoubleAcute: "˝",
    DiacriticalGrave: "`",
    DiacriticalTilde: "˜",
    diam: "⋄",
    diamond: "⋄",
    Diamond: "⋄",
    diamondsuit: "♦",
    diams: "♦",
    die: "¨",
    DifferentialD: "ⅆ",
    digamma: "ϝ",
    disin: "⋲",
    div: "÷",
    divide: "÷",
    divideontimes: "⋇",
    divonx: "⋇",
    DJcy: "Ђ",
    djcy: "ђ",
    dlcorn: "⌞",
    dlcrop: "⌍",
    dollar: "$",
    Dopf: "𝔻",
    dopf: "𝕕",
    Dot: "¨",
    dot: "˙",
    DotDot: "⃜",
    doteq: "≐",
    doteqdot: "≑",
    DotEqual: "≐",
    dotminus: "∸",
    dotplus: "∔",
    dotsquare: "⊡",
    doublebarwedge: "⌆",
    DoubleContourIntegral: "∯",
    DoubleDot: "¨",
    DoubleDownArrow: "⇓",
    DoubleLeftArrow: "⇐",
    DoubleLeftRightArrow: "⇔",
    DoubleLeftTee: "⫤",
    DoubleLongLeftArrow: "⟸",
    DoubleLongLeftRightArrow: "⟺",
    DoubleLongRightArrow: "⟹",
    DoubleRightArrow: "⇒",
    DoubleRightTee: "⊨",
    DoubleUpArrow: "⇑",
    DoubleUpDownArrow: "⇕",
    DoubleVerticalBar: "∥",
    DownArrowBar: "⤓",
    downarrow: "↓",
    DownArrow: "↓",
    Downarrow: "⇓",
    DownArrowUpArrow: "⇵",
    DownBreve: "̑",
    downdownarrows: "⇊",
    downharpoonleft: "⇃",
    downharpoonright: "⇂",
    DownLeftRightVector: "⥐",
    DownLeftTeeVector: "⥞",
    DownLeftVectorBar: "⥖",
    DownLeftVector: "↽",
    DownRightTeeVector: "⥟",
    DownRightVectorBar: "⥗",
    DownRightVector: "⇁",
    DownTeeArrow: "↧",
    DownTee: "⊤",
    drbkarow: "⤐",
    drcorn: "⌟",
    drcrop: "⌌",
    Dscr: "𝒟",
    dscr: "𝒹",
    DScy: "Ѕ",
    dscy: "ѕ",
    dsol: "⧶",
    Dstrok: "Đ",
    dstrok: "đ",
    dtdot: "⋱",
    dtri: "▿",
    dtrif: "▾",
    duarr: "⇵",
    duhar: "⥯",
    dwangle: "⦦",
    DZcy: "Џ",
    dzcy: "џ",
    dzigrarr: "⟿",
    Eacute: "É",
    eacute: "é",
    easter: "⩮",
    Ecaron: "Ě",
    ecaron: "ě",
    Ecirc: "Ê",
    ecirc: "ê",
    ecir: "≖",
    ecolon: "≕",
    Ecy: "Э",
    ecy: "э",
    eDDot: "⩷",
    Edot: "Ė",
    edot: "ė",
    eDot: "≑",
    ee: "ⅇ",
    efDot: "≒",
    Efr: "𝔈",
    efr: "𝔢",
    eg: "⪚",
    Egrave: "È",
    egrave: "è",
    egs: "⪖",
    egsdot: "⪘",
    el: "⪙",
    Element: "∈",
    elinters: "⏧",
    ell: "ℓ",
    els: "⪕",
    elsdot: "⪗",
    Emacr: "Ē",
    emacr: "ē",
    empty: "∅",
    emptyset: "∅",
    EmptySmallSquare: "◻",
    emptyv: "∅",
    EmptyVerySmallSquare: "▫",
    emsp13: " ",
    emsp14: " ",
    emsp: " ",
    ENG: "Ŋ",
    eng: "ŋ",
    ensp: " ",
    Eogon: "Ę",
    eogon: "ę",
    Eopf: "𝔼",
    eopf: "𝕖",
    epar: "⋕",
    eparsl: "⧣",
    eplus: "⩱",
    epsi: "ε",
    Epsilon: "Ε",
    epsilon: "ε",
    epsiv: "ϵ",
    eqcirc: "≖",
    eqcolon: "≕",
    eqsim: "≂",
    eqslantgtr: "⪖",
    eqslantless: "⪕",
    Equal: "⩵",
    equals: "=",
    EqualTilde: "≂",
    equest: "≟",
    Equilibrium: "⇌",
    equiv: "≡",
    equivDD: "⩸",
    eqvparsl: "⧥",
    erarr: "⥱",
    erDot: "≓",
    escr: "ℯ",
    Escr: "ℰ",
    esdot: "≐",
    Esim: "⩳",
    esim: "≂",
    Eta: "Η",
    eta: "η",
    ETH: "Ð",
    eth: "ð",
    Euml: "Ë",
    euml: "ë",
    euro: "€",
    excl: "!",
    exist: "∃",
    Exists: "∃",
    expectation: "ℰ",
    exponentiale: "ⅇ",
    ExponentialE: "ⅇ",
    fallingdotseq: "≒",
    Fcy: "Ф",
    fcy: "ф",
    female: "♀",
    ffilig: "ﬃ",
    fflig: "ﬀ",
    ffllig: "ﬄ",
    Ffr: "𝔉",
    ffr: "𝔣",
    filig: "ﬁ",
    FilledSmallSquare: "◼",
    FilledVerySmallSquare: "▪",
    fjlig: "fj",
    flat: "♭",
    fllig: "ﬂ",
    fltns: "▱",
    fnof: "ƒ",
    Fopf: "𝔽",
    fopf: "𝕗",
    forall: "∀",
    ForAll: "∀",
    fork: "⋔",
    forkv: "⫙",
    Fouriertrf: "ℱ",
    fpartint: "⨍",
    frac12: "½",
    frac13: "⅓",
    frac14: "¼",
    frac15: "⅕",
    frac16: "⅙",
    frac18: "⅛",
    frac23: "⅔",
    frac25: "⅖",
    frac34: "¾",
    frac35: "⅗",
    frac38: "⅜",
    frac45: "⅘",
    frac56: "⅚",
    frac58: "⅝",
    frac78: "⅞",
    frasl: "⁄",
    frown: "⌢",
    fscr: "𝒻",
    Fscr: "ℱ",
    gacute: "ǵ",
    Gamma: "Γ",
    gamma: "γ",
    Gammad: "Ϝ",
    gammad: "ϝ",
    gap: "⪆",
    Gbreve: "Ğ",
    gbreve: "ğ",
    Gcedil: "Ģ",
    Gcirc: "Ĝ",
    gcirc: "ĝ",
    Gcy: "Г",
    gcy: "г",
    Gdot: "Ġ",
    gdot: "ġ",
    ge: "≥",
    gE: "≧",
    gEl: "⪌",
    gel: "⋛",
    geq: "≥",
    geqq: "≧",
    geqslant: "⩾",
    gescc: "⪩",
    ges: "⩾",
    gesdot: "⪀",
    gesdoto: "⪂",
    gesdotol: "⪄",
    gesl: "⋛︀",
    gesles: "⪔",
    Gfr: "𝔊",
    gfr: "𝔤",
    gg: "≫",
    Gg: "⋙",
    ggg: "⋙",
    gimel: "ℷ",
    GJcy: "Ѓ",
    gjcy: "ѓ",
    gla: "⪥",
    gl: "≷",
    glE: "⪒",
    glj: "⪤",
    gnap: "⪊",
    gnapprox: "⪊",
    gne: "⪈",
    gnE: "≩",
    gneq: "⪈",
    gneqq: "≩",
    gnsim: "⋧",
    Gopf: "𝔾",
    gopf: "𝕘",
    grave: "`",
    GreaterEqual: "≥",
    GreaterEqualLess: "⋛",
    GreaterFullEqual: "≧",
    GreaterGreater: "⪢",
    GreaterLess: "≷",
    GreaterSlantEqual: "⩾",
    GreaterTilde: "≳",
    Gscr: "𝒢",
    gscr: "ℊ",
    gsim: "≳",
    gsime: "⪎",
    gsiml: "⪐",
    gtcc: "⪧",
    gtcir: "⩺",
    gt: ">",
    GT: ">",
    Gt: "≫",
    gtdot: "⋗",
    gtlPar: "⦕",
    gtquest: "⩼",
    gtrapprox: "⪆",
    gtrarr: "⥸",
    gtrdot: "⋗",
    gtreqless: "⋛",
    gtreqqless: "⪌",
    gtrless: "≷",
    gtrsim: "≳",
    gvertneqq: "≩︀",
    gvnE: "≩︀",
    Hacek: "ˇ",
    hairsp: " ",
    half: "½",
    hamilt: "ℋ",
    HARDcy: "Ъ",
    hardcy: "ъ",
    harrcir: "⥈",
    harr: "↔",
    hArr: "⇔",
    harrw: "↭",
    Hat: "^",
    hbar: "ℏ",
    Hcirc: "Ĥ",
    hcirc: "ĥ",
    hearts: "♥",
    heartsuit: "♥",
    hellip: "…",
    hercon: "⊹",
    hfr: "𝔥",
    Hfr: "ℌ",
    HilbertSpace: "ℋ",
    hksearow: "⤥",
    hkswarow: "⤦",
    hoarr: "⇿",
    homtht: "∻",
    hookleftarrow: "↩",
    hookrightarrow: "↪",
    hopf: "𝕙",
    Hopf: "ℍ",
    horbar: "―",
    HorizontalLine: "─",
    hscr: "𝒽",
    Hscr: "ℋ",
    hslash: "ℏ",
    Hstrok: "Ħ",
    hstrok: "ħ",
    HumpDownHump: "≎",
    HumpEqual: "≏",
    hybull: "⁃",
    hyphen: "‐",
    Iacute: "Í",
    iacute: "í",
    ic: "⁣",
    Icirc: "Î",
    icirc: "î",
    Icy: "И",
    icy: "и",
    Idot: "İ",
    IEcy: "Е",
    iecy: "е",
    iexcl: "¡",
    iff: "⇔",
    ifr: "𝔦",
    Ifr: "ℑ",
    Igrave: "Ì",
    igrave: "ì",
    ii: "ⅈ",
    iiiint: "⨌",
    iiint: "∭",
    iinfin: "⧜",
    iiota: "℩",
    IJlig: "Ĳ",
    ijlig: "ĳ",
    Imacr: "Ī",
    imacr: "ī",
    image: "ℑ",
    ImaginaryI: "ⅈ",
    imagline: "ℐ",
    imagpart: "ℑ",
    imath: "ı",
    Im: "ℑ",
    imof: "⊷",
    imped: "Ƶ",
    Implies: "⇒",
    incare: "℅",
    "in": "∈",
    infin: "∞",
    infintie: "⧝",
    inodot: "ı",
    intcal: "⊺",
    "int": "∫",
    Int: "∬",
    integers: "ℤ",
    Integral: "∫",
    intercal: "⊺",
    Intersection: "⋂",
    intlarhk: "⨗",
    intprod: "⨼",
    InvisibleComma: "⁣",
    InvisibleTimes: "⁢",
    IOcy: "Ё",
    iocy: "ё",
    Iogon: "Į",
    iogon: "į",
    Iopf: "𝕀",
    iopf: "𝕚",
    Iota: "Ι",
    iota: "ι",
    iprod: "⨼",
    iquest: "¿",
    iscr: "𝒾",
    Iscr: "ℐ",
    isin: "∈",
    isindot: "⋵",
    isinE: "⋹",
    isins: "⋴",
    isinsv: "⋳",
    isinv: "∈",
    it: "⁢",
    Itilde: "Ĩ",
    itilde: "ĩ",
    Iukcy: "І",
    iukcy: "і",
    Iuml: "Ï",
    iuml: "ï",
    Jcirc: "Ĵ",
    jcirc: "ĵ",
    Jcy: "Й",
    jcy: "й",
    Jfr: "𝔍",
    jfr: "𝔧",
    jmath: "ȷ",
    Jopf: "𝕁",
    jopf: "𝕛",
    Jscr: "𝒥",
    jscr: "𝒿",
    Jsercy: "Ј",
    jsercy: "ј",
    Jukcy: "Є",
    jukcy: "є",
    Kappa: "Κ",
    kappa: "κ",
    kappav: "ϰ",
    Kcedil: "Ķ",
    kcedil: "ķ",
    Kcy: "К",
    kcy: "к",
    Kfr: "𝔎",
    kfr: "𝔨",
    kgreen: "ĸ",
    KHcy: "Х",
    khcy: "х",
    KJcy: "Ќ",
    kjcy: "ќ",
    Kopf: "𝕂",
    kopf: "𝕜",
    Kscr: "𝒦",
    kscr: "𝓀",
    lAarr: "⇚",
    Lacute: "Ĺ",
    lacute: "ĺ",
    laemptyv: "⦴",
    lagran: "ℒ",
    Lambda: "Λ",
    lambda: "λ",
    lang: "⟨",
    Lang: "⟪",
    langd: "⦑",
    langle: "⟨",
    lap: "⪅",
    Laplacetrf: "ℒ",
    laquo: "«",
    larrb: "⇤",
    larrbfs: "⤟",
    larr: "←",
    Larr: "↞",
    lArr: "⇐",
    larrfs: "⤝",
    larrhk: "↩",
    larrlp: "↫",
    larrpl: "⤹",
    larrsim: "⥳",
    larrtl: "↢",
    latail: "⤙",
    lAtail: "⤛",
    lat: "⪫",
    late: "⪭",
    lates: "⪭︀",
    lbarr: "⤌",
    lBarr: "⤎",
    lbbrk: "❲",
    lbrace: "{",
    lbrack: "[",
    lbrke: "⦋",
    lbrksld: "⦏",
    lbrkslu: "⦍",
    Lcaron: "Ľ",
    lcaron: "ľ",
    Lcedil: "Ļ",
    lcedil: "ļ",
    lceil: "⌈",
    lcub: "{",
    Lcy: "Л",
    lcy: "л",
    ldca: "⤶",
    ldquo: "“",
    ldquor: "„",
    ldrdhar: "⥧",
    ldrushar: "⥋",
    ldsh: "↲",
    le: "≤",
    lE: "≦",
    LeftAngleBracket: "⟨",
    LeftArrowBar: "⇤",
    leftarrow: "←",
    LeftArrow: "←",
    Leftarrow: "⇐",
    LeftArrowRightArrow: "⇆",
    leftarrowtail: "↢",
    LeftCeiling: "⌈",
    LeftDoubleBracket: "⟦",
    LeftDownTeeVector: "⥡",
    LeftDownVectorBar: "⥙",
    LeftDownVector: "⇃",
    LeftFloor: "⌊",
    leftharpoondown: "↽",
    leftharpoonup: "↼",
    leftleftarrows: "⇇",
    leftrightarrow: "↔",
    LeftRightArrow: "↔",
    Leftrightarrow: "⇔",
    leftrightarrows: "⇆",
    leftrightharpoons: "⇋",
    leftrightsquigarrow: "↭",
    LeftRightVector: "⥎",
    LeftTeeArrow: "↤",
    LeftTee: "⊣",
    LeftTeeVector: "⥚",
    leftthreetimes: "⋋",
    LeftTriangleBar: "⧏",
    LeftTriangle: "⊲",
    LeftTriangleEqual: "⊴",
    LeftUpDownVector: "⥑",
    LeftUpTeeVector: "⥠",
    LeftUpVectorBar: "⥘",
    LeftUpVector: "↿",
    LeftVectorBar: "⥒",
    LeftVector: "↼",
    lEg: "⪋",
    leg: "⋚",
    leq: "≤",
    leqq: "≦",
    leqslant: "⩽",
    lescc: "⪨",
    les: "⩽",
    lesdot: "⩿",
    lesdoto: "⪁",
    lesdotor: "⪃",
    lesg: "⋚︀",
    lesges: "⪓",
    lessapprox: "⪅",
    lessdot: "⋖",
    lesseqgtr: "⋚",
    lesseqqgtr: "⪋",
    LessEqualGreater: "⋚",
    LessFullEqual: "≦",
    LessGreater: "≶",
    lessgtr: "≶",
    LessLess: "⪡",
    lesssim: "≲",
    LessSlantEqual: "⩽",
    LessTilde: "≲",
    lfisht: "⥼",
    lfloor: "⌊",
    Lfr: "𝔏",
    lfr: "𝔩",
    lg: "≶",
    lgE: "⪑",
    lHar: "⥢",
    lhard: "↽",
    lharu: "↼",
    lharul: "⥪",
    lhblk: "▄",
    LJcy: "Љ",
    ljcy: "љ",
    llarr: "⇇",
    ll: "≪",
    Ll: "⋘",
    llcorner: "⌞",
    Lleftarrow: "⇚",
    llhard: "⥫",
    lltri: "◺",
    Lmidot: "Ŀ",
    lmidot: "ŀ",
    lmoustache: "⎰",
    lmoust: "⎰",
    lnap: "⪉",
    lnapprox: "⪉",
    lne: "⪇",
    lnE: "≨",
    lneq: "⪇",
    lneqq: "≨",
    lnsim: "⋦",
    loang: "⟬",
    loarr: "⇽",
    lobrk: "⟦",
    longleftarrow: "⟵",
    LongLeftArrow: "⟵",
    Longleftarrow: "⟸",
    longleftrightarrow: "⟷",
    LongLeftRightArrow: "⟷",
    Longleftrightarrow: "⟺",
    longmapsto: "⟼",
    longrightarrow: "⟶",
    LongRightArrow: "⟶",
    Longrightarrow: "⟹",
    looparrowleft: "↫",
    looparrowright: "↬",
    lopar: "⦅",
    Lopf: "𝕃",
    lopf: "𝕝",
    loplus: "⨭",
    lotimes: "⨴",
    lowast: "∗",
    lowbar: "_",
    LowerLeftArrow: "↙",
    LowerRightArrow: "↘",
    loz: "◊",
    lozenge: "◊",
    lozf: "⧫",
    lpar: "(",
    lparlt: "⦓",
    lrarr: "⇆",
    lrcorner: "⌟",
    lrhar: "⇋",
    lrhard: "⥭",
    lrm: "‎",
    lrtri: "⊿",
    lsaquo: "‹",
    lscr: "𝓁",
    Lscr: "ℒ",
    lsh: "↰",
    Lsh: "↰",
    lsim: "≲",
    lsime: "⪍",
    lsimg: "⪏",
    lsqb: "[",
    lsquo: "‘",
    lsquor: "‚",
    Lstrok: "Ł",
    lstrok: "ł",
    ltcc: "⪦",
    ltcir: "⩹",
    lt: "<",
    LT: "<",
    Lt: "≪",
    ltdot: "⋖",
    lthree: "⋋",
    ltimes: "⋉",
    ltlarr: "⥶",
    ltquest: "⩻",
    ltri: "◃",
    ltrie: "⊴",
    ltrif: "◂",
    ltrPar: "⦖",
    lurdshar: "⥊",
    luruhar: "⥦",
    lvertneqq: "≨︀",
    lvnE: "≨︀",
    macr: "¯",
    male: "♂",
    malt: "✠",
    maltese: "✠",
    Map: "⤅",
    map: "↦",
    mapsto: "↦",
    mapstodown: "↧",
    mapstoleft: "↤",
    mapstoup: "↥",
    marker: "▮",
    mcomma: "⨩",
    Mcy: "М",
    mcy: "м",
    mdash: "—",
    mDDot: "∺",
    measuredangle: "∡",
    MediumSpace: " ",
    Mellintrf: "ℳ",
    Mfr: "𝔐",
    mfr: "𝔪",
    mho: "℧",
    micro: "µ",
    midast: "*",
    midcir: "⫰",
    mid: "∣",
    middot: "·",
    minusb: "⊟",
    minus: "−",
    minusd: "∸",
    minusdu: "⨪",
    MinusPlus: "∓",
    mlcp: "⫛",
    mldr: "…",
    mnplus: "∓",
    models: "⊧",
    Mopf: "𝕄",
    mopf: "𝕞",
    mp: "∓",
    mscr: "𝓂",
    Mscr: "ℳ",
    mstpos: "∾",
    Mu: "Μ",
    mu: "μ",
    multimap: "⊸",
    mumap: "⊸",
    nabla: "∇",
    Nacute: "Ń",
    nacute: "ń",
    nang: "∠⃒",
    nap: "≉",
    napE: "⩰̸",
    napid: "≋̸",
    napos: "ŉ",
    napprox: "≉",
    natural: "♮",
    naturals: "ℕ",
    natur: "♮",
    nbsp: " ",
    nbump: "≎̸",
    nbumpe: "≏̸",
    ncap: "⩃",
    Ncaron: "Ň",
    ncaron: "ň",
    Ncedil: "Ņ",
    ncedil: "ņ",
    ncong: "≇",
    ncongdot: "⩭̸",
    ncup: "⩂",
    Ncy: "Н",
    ncy: "н",
    ndash: "–",
    nearhk: "⤤",
    nearr: "↗",
    neArr: "⇗",
    nearrow: "↗",
    ne: "≠",
    nedot: "≐̸",
    NegativeMediumSpace: "​",
    NegativeThickSpace: "​",
    NegativeThinSpace: "​",
    NegativeVeryThinSpace: "​",
    nequiv: "≢",
    nesear: "⤨",
    nesim: "≂̸",
    NestedGreaterGreater: "≫",
    NestedLessLess: "≪",
    NewLine: "\n",
    nexist: "∄",
    nexists: "∄",
    Nfr: "𝔑",
    nfr: "𝔫",
    ngE: "≧̸",
    nge: "≱",
    ngeq: "≱",
    ngeqq: "≧̸",
    ngeqslant: "⩾̸",
    nges: "⩾̸",
    nGg: "⋙̸",
    ngsim: "≵",
    nGt: "≫⃒",
    ngt: "≯",
    ngtr: "≯",
    nGtv: "≫̸",
    nharr: "↮",
    nhArr: "⇎",
    nhpar: "⫲",
    ni: "∋",
    nis: "⋼",
    nisd: "⋺",
    niv: "∋",
    NJcy: "Њ",
    njcy: "њ",
    nlarr: "↚",
    nlArr: "⇍",
    nldr: "‥",
    nlE: "≦̸",
    nle: "≰",
    nleftarrow: "↚",
    nLeftarrow: "⇍",
    nleftrightarrow: "↮",
    nLeftrightarrow: "⇎",
    nleq: "≰",
    nleqq: "≦̸",
    nleqslant: "⩽̸",
    nles: "⩽̸",
    nless: "≮",
    nLl: "⋘̸",
    nlsim: "≴",
    nLt: "≪⃒",
    nlt: "≮",
    nltri: "⋪",
    nltrie: "⋬",
    nLtv: "≪̸",
    nmid: "∤",
    NoBreak: "⁠",
    NonBreakingSpace: " ",
    nopf: "𝕟",
    Nopf: "ℕ",
    Not: "⫬",
    not: "¬",
    NotCongruent: "≢",
    NotCupCap: "≭",
    NotDoubleVerticalBar: "∦",
    NotElement: "∉",
    NotEqual: "≠",
    NotEqualTilde: "≂̸",
    NotExists: "∄",
    NotGreater: "≯",
    NotGreaterEqual: "≱",
    NotGreaterFullEqual: "≧̸",
    NotGreaterGreater: "≫̸",
    NotGreaterLess: "≹",
    NotGreaterSlantEqual: "⩾̸",
    NotGreaterTilde: "≵",
    NotHumpDownHump: "≎̸",
    NotHumpEqual: "≏̸",
    notin: "∉",
    notindot: "⋵̸",
    notinE: "⋹̸",
    notinva: "∉",
    notinvb: "⋷",
    notinvc: "⋶",
    NotLeftTriangleBar: "⧏̸",
    NotLeftTriangle: "⋪",
    NotLeftTriangleEqual: "⋬",
    NotLess: "≮",
    NotLessEqual: "≰",
    NotLessGreater: "≸",
    NotLessLess: "≪̸",
    NotLessSlantEqual: "⩽̸",
    NotLessTilde: "≴",
    NotNestedGreaterGreater: "⪢̸",
    NotNestedLessLess: "⪡̸",
    notni: "∌",
    notniva: "∌",
    notnivb: "⋾",
    notnivc: "⋽",
    NotPrecedes: "⊀",
    NotPrecedesEqual: "⪯̸",
    NotPrecedesSlantEqual: "⋠",
    NotReverseElement: "∌",
    NotRightTriangleBar: "⧐̸",
    NotRightTriangle: "⋫",
    NotRightTriangleEqual: "⋭",
    NotSquareSubset: "⊏̸",
    NotSquareSubsetEqual: "⋢",
    NotSquareSuperset: "⊐̸",
    NotSquareSupersetEqual: "⋣",
    NotSubset: "⊂⃒",
    NotSubsetEqual: "⊈",
    NotSucceeds: "⊁",
    NotSucceedsEqual: "⪰̸",
    NotSucceedsSlantEqual: "⋡",
    NotSucceedsTilde: "≿̸",
    NotSuperset: "⊃⃒",
    NotSupersetEqual: "⊉",
    NotTilde: "≁",
    NotTildeEqual: "≄",
    NotTildeFullEqual: "≇",
    NotTildeTilde: "≉",
    NotVerticalBar: "∤",
    nparallel: "∦",
    npar: "∦",
    nparsl: "⫽⃥",
    npart: "∂̸",
    npolint: "⨔",
    npr: "⊀",
    nprcue: "⋠",
    nprec: "⊀",
    npreceq: "⪯̸",
    npre: "⪯̸",
    nrarrc: "⤳̸",
    nrarr: "↛",
    nrArr: "⇏",
    nrarrw: "↝̸",
    nrightarrow: "↛",
    nRightarrow: "⇏",
    nrtri: "⋫",
    nrtrie: "⋭",
    nsc: "⊁",
    nsccue: "⋡",
    nsce: "⪰̸",
    Nscr: "𝒩",
    nscr: "𝓃",
    nshortmid: "∤",
    nshortparallel: "∦",
    nsim: "≁",
    nsime: "≄",
    nsimeq: "≄",
    nsmid: "∤",
    nspar: "∦",
    nsqsube: "⋢",
    nsqsupe: "⋣",
    nsub: "⊄",
    nsubE: "⫅̸",
    nsube: "⊈",
    nsubset: "⊂⃒",
    nsubseteq: "⊈",
    nsubseteqq: "⫅̸",
    nsucc: "⊁",
    nsucceq: "⪰̸",
    nsup: "⊅",
    nsupE: "⫆̸",
    nsupe: "⊉",
    nsupset: "⊃⃒",
    nsupseteq: "⊉",
    nsupseteqq: "⫆̸",
    ntgl: "≹",
    Ntilde: "Ñ",
    ntilde: "ñ",
    ntlg: "≸",
    ntriangleleft: "⋪",
    ntrianglelefteq: "⋬",
    ntriangleright: "⋫",
    ntrianglerighteq: "⋭",
    Nu: "Ν",
    nu: "ν",
    num: "#",
    numero: "№",
    numsp: " ",
    nvap: "≍⃒",
    nvdash: "⊬",
    nvDash: "⊭",
    nVdash: "⊮",
    nVDash: "⊯",
    nvge: "≥⃒",
    nvgt: ">⃒",
    nvHarr: "⤄",
    nvinfin: "⧞",
    nvlArr: "⤂",
    nvle: "≤⃒",
    nvlt: "<⃒",
    nvltrie: "⊴⃒",
    nvrArr: "⤃",
    nvrtrie: "⊵⃒",
    nvsim: "∼⃒",
    nwarhk: "⤣",
    nwarr: "↖",
    nwArr: "⇖",
    nwarrow: "↖",
    nwnear: "⤧",
    Oacute: "Ó",
    oacute: "ó",
    oast: "⊛",
    Ocirc: "Ô",
    ocirc: "ô",
    ocir: "⊚",
    Ocy: "О",
    ocy: "о",
    odash: "⊝",
    Odblac: "Ő",
    odblac: "ő",
    odiv: "⨸",
    odot: "⊙",
    odsold: "⦼",
    OElig: "Œ",
    oelig: "œ",
    ofcir: "⦿",
    Ofr: "𝔒",
    ofr: "𝔬",
    ogon: "˛",
    Ograve: "Ò",
    ograve: "ò",
    ogt: "⧁",
    ohbar: "⦵",
    ohm: "Ω",
    oint: "∮",
    olarr: "↺",
    olcir: "⦾",
    olcross: "⦻",
    oline: "‾",
    olt: "⧀",
    Omacr: "Ō",
    omacr: "ō",
    Omega: "Ω",
    omega: "ω",
    Omicron: "Ο",
    omicron: "ο",
    omid: "⦶",
    ominus: "⊖",
    Oopf: "𝕆",
    oopf: "𝕠",
    opar: "⦷",
    OpenCurlyDoubleQuote: "“",
    OpenCurlyQuote: "‘",
    operp: "⦹",
    oplus: "⊕",
    orarr: "↻",
    Or: "⩔",
    or: "∨",
    ord: "⩝",
    order: "ℴ",
    orderof: "ℴ",
    ordf: "ª",
    ordm: "º",
    origof: "⊶",
    oror: "⩖",
    orslope: "⩗",
    orv: "⩛",
    oS: "Ⓢ",
    Oscr: "𝒪",
    oscr: "ℴ",
    Oslash: "Ø",
    oslash: "ø",
    osol: "⊘",
    Otilde: "Õ",
    otilde: "õ",
    otimesas: "⨶",
    Otimes: "⨷",
    otimes: "⊗",
    Ouml: "Ö",
    ouml: "ö",
    ovbar: "⌽",
    OverBar: "‾",
    OverBrace: "⏞",
    OverBracket: "⎴",
    OverParenthesis: "⏜",
    para: "¶",
    parallel: "∥",
    par: "∥",
    parsim: "⫳",
    parsl: "⫽",
    part: "∂",
    PartialD: "∂",
    Pcy: "П",
    pcy: "п",
    percnt: "%",
    period: ".",
    permil: "‰",
    perp: "⊥",
    pertenk: "‱",
    Pfr: "𝔓",
    pfr: "𝔭",
    Phi: "Φ",
    phi: "φ",
    phiv: "ϕ",
    phmmat: "ℳ",
    phone: "☎",
    Pi: "Π",
    pi: "π",
    pitchfork: "⋔",
    piv: "ϖ",
    planck: "ℏ",
    planckh: "ℎ",
    plankv: "ℏ",
    plusacir: "⨣",
    plusb: "⊞",
    pluscir: "⨢",
    plus: "+",
    plusdo: "∔",
    plusdu: "⨥",
    pluse: "⩲",
    PlusMinus: "±",
    plusmn: "±",
    plussim: "⨦",
    plustwo: "⨧",
    pm: "±",
    Poincareplane: "ℌ",
    pointint: "⨕",
    popf: "𝕡",
    Popf: "ℙ",
    pound: "£",
    prap: "⪷",
    Pr: "⪻",
    pr: "≺",
    prcue: "≼",
    precapprox: "⪷",
    prec: "≺",
    preccurlyeq: "≼",
    Precedes: "≺",
    PrecedesEqual: "⪯",
    PrecedesSlantEqual: "≼",
    PrecedesTilde: "≾",
    preceq: "⪯",
    precnapprox: "⪹",
    precneqq: "⪵",
    precnsim: "⋨",
    pre: "⪯",
    prE: "⪳",
    precsim: "≾",
    prime: "′",
    Prime: "″",
    primes: "ℙ",
    prnap: "⪹",
    prnE: "⪵",
    prnsim: "⋨",
    prod: "∏",
    Product: "∏",
    profalar: "⌮",
    profline: "⌒",
    profsurf: "⌓",
    prop: "∝",
    Proportional: "∝",
    Proportion: "∷",
    propto: "∝",
    prsim: "≾",
    prurel: "⊰",
    Pscr: "𝒫",
    pscr: "𝓅",
    Psi: "Ψ",
    psi: "ψ",
    puncsp: " ",
    Qfr: "𝔔",
    qfr: "𝔮",
    qint: "⨌",
    qopf: "𝕢",
    Qopf: "ℚ",
    qprime: "⁗",
    Qscr: "𝒬",
    qscr: "𝓆",
    quaternions: "ℍ",
    quatint: "⨖",
    quest: "?",
    questeq: "≟",
    quot: '"',
    QUOT: '"',
    rAarr: "⇛",
    race: "∽̱",
    Racute: "Ŕ",
    racute: "ŕ",
    radic: "√",
    raemptyv: "⦳",
    rang: "⟩",
    Rang: "⟫",
    rangd: "⦒",
    range: "⦥",
    rangle: "⟩",
    raquo: "»",
    rarrap: "⥵",
    rarrb: "⇥",
    rarrbfs: "⤠",
    rarrc: "⤳",
    rarr: "→",
    Rarr: "↠",
    rArr: "⇒",
    rarrfs: "⤞",
    rarrhk: "↪",
    rarrlp: "↬",
    rarrpl: "⥅",
    rarrsim: "⥴",
    Rarrtl: "⤖",
    rarrtl: "↣",
    rarrw: "↝",
    ratail: "⤚",
    rAtail: "⤜",
    ratio: "∶",
    rationals: "ℚ",
    rbarr: "⤍",
    rBarr: "⤏",
    RBarr: "⤐",
    rbbrk: "❳",
    rbrace: "}",
    rbrack: "]",
    rbrke: "⦌",
    rbrksld: "⦎",
    rbrkslu: "⦐",
    Rcaron: "Ř",
    rcaron: "ř",
    Rcedil: "Ŗ",
    rcedil: "ŗ",
    rceil: "⌉",
    rcub: "}",
    Rcy: "Р",
    rcy: "р",
    rdca: "⤷",
    rdldhar: "⥩",
    rdquo: "”",
    rdquor: "”",
    rdsh: "↳",
    real: "ℜ",
    realine: "ℛ",
    realpart: "ℜ",
    reals: "ℝ",
    Re: "ℜ",
    rect: "▭",
    reg: "®",
    REG: "®",
    ReverseElement: "∋",
    ReverseEquilibrium: "⇋",
    ReverseUpEquilibrium: "⥯",
    rfisht: "⥽",
    rfloor: "⌋",
    rfr: "𝔯",
    Rfr: "ℜ",
    rHar: "⥤",
    rhard: "⇁",
    rharu: "⇀",
    rharul: "⥬",
    Rho: "Ρ",
    rho: "ρ",
    rhov: "ϱ",
    RightAngleBracket: "⟩",
    RightArrowBar: "⇥",
    rightarrow: "→",
    RightArrow: "→",
    Rightarrow: "⇒",
    RightArrowLeftArrow: "⇄",
    rightarrowtail: "↣",
    RightCeiling: "⌉",
    RightDoubleBracket: "⟧",
    RightDownTeeVector: "⥝",
    RightDownVectorBar: "⥕",
    RightDownVector: "⇂",
    RightFloor: "⌋",
    rightharpoondown: "⇁",
    rightharpoonup: "⇀",
    rightleftarrows: "⇄",
    rightleftharpoons: "⇌",
    rightrightarrows: "⇉",
    rightsquigarrow: "↝",
    RightTeeArrow: "↦",
    RightTee: "⊢",
    RightTeeVector: "⥛",
    rightthreetimes: "⋌",
    RightTriangleBar: "⧐",
    RightTriangle: "⊳",
    RightTriangleEqual: "⊵",
    RightUpDownVector: "⥏",
    RightUpTeeVector: "⥜",
    RightUpVectorBar: "⥔",
    RightUpVector: "↾",
    RightVectorBar: "⥓",
    RightVector: "⇀",
    ring: "˚",
    risingdotseq: "≓",
    rlarr: "⇄",
    rlhar: "⇌",
    rlm: "‏",
    rmoustache: "⎱",
    rmoust: "⎱",
    rnmid: "⫮",
    roang: "⟭",
    roarr: "⇾",
    robrk: "⟧",
    ropar: "⦆",
    ropf: "𝕣",
    Ropf: "ℝ",
    roplus: "⨮",
    rotimes: "⨵",
    RoundImplies: "⥰",
    rpar: ")",
    rpargt: "⦔",
    rppolint: "⨒",
    rrarr: "⇉",
    Rrightarrow: "⇛",
    rsaquo: "›",
    rscr: "𝓇",
    Rscr: "ℛ",
    rsh: "↱",
    Rsh: "↱",
    rsqb: "]",
    rsquo: "’",
    rsquor: "’",
    rthree: "⋌",
    rtimes: "⋊",
    rtri: "▹",
    rtrie: "⊵",
    rtrif: "▸",
    rtriltri: "⧎",
    RuleDelayed: "⧴",
    ruluhar: "⥨",
    rx: "℞",
    Sacute: "Ś",
    sacute: "ś",
    sbquo: "‚",
    scap: "⪸",
    Scaron: "Š",
    scaron: "š",
    Sc: "⪼",
    sc: "≻",
    sccue: "≽",
    sce: "⪰",
    scE: "⪴",
    Scedil: "Ş",
    scedil: "ş",
    Scirc: "Ŝ",
    scirc: "ŝ",
    scnap: "⪺",
    scnE: "⪶",
    scnsim: "⋩",
    scpolint: "⨓",
    scsim: "≿",
    Scy: "С",
    scy: "с",
    sdotb: "⊡",
    sdot: "⋅",
    sdote: "⩦",
    searhk: "⤥",
    searr: "↘",
    seArr: "⇘",
    searrow: "↘",
    sect: "§",
    semi: ";",
    seswar: "⤩",
    setminus: "∖",
    setmn: "∖",
    sext: "✶",
    Sfr: "𝔖",
    sfr: "𝔰",
    sfrown: "⌢",
    sharp: "♯",
    SHCHcy: "Щ",
    shchcy: "щ",
    SHcy: "Ш",
    shcy: "ш",
    ShortDownArrow: "↓",
    ShortLeftArrow: "←",
    shortmid: "∣",
    shortparallel: "∥",
    ShortRightArrow: "→",
    ShortUpArrow: "↑",
    shy: "­",
    Sigma: "Σ",
    sigma: "σ",
    sigmaf: "ς",
    sigmav: "ς",
    sim: "∼",
    simdot: "⩪",
    sime: "≃",
    simeq: "≃",
    simg: "⪞",
    simgE: "⪠",
    siml: "⪝",
    simlE: "⪟",
    simne: "≆",
    simplus: "⨤",
    simrarr: "⥲",
    slarr: "←",
    SmallCircle: "∘",
    smallsetminus: "∖",
    smashp: "⨳",
    smeparsl: "⧤",
    smid: "∣",
    smile: "⌣",
    smt: "⪪",
    smte: "⪬",
    smtes: "⪬︀",
    SOFTcy: "Ь",
    softcy: "ь",
    solbar: "⌿",
    solb: "⧄",
    sol: "/",
    Sopf: "𝕊",
    sopf: "𝕤",
    spades: "♠",
    spadesuit: "♠",
    spar: "∥",
    sqcap: "⊓",
    sqcaps: "⊓︀",
    sqcup: "⊔",
    sqcups: "⊔︀",
    Sqrt: "√",
    sqsub: "⊏",
    sqsube: "⊑",
    sqsubset: "⊏",
    sqsubseteq: "⊑",
    sqsup: "⊐",
    sqsupe: "⊒",
    sqsupset: "⊐",
    sqsupseteq: "⊒",
    square: "□",
    Square: "□",
    SquareIntersection: "⊓",
    SquareSubset: "⊏",
    SquareSubsetEqual: "⊑",
    SquareSuperset: "⊐",
    SquareSupersetEqual: "⊒",
    SquareUnion: "⊔",
    squarf: "▪",
    squ: "□",
    squf: "▪",
    srarr: "→",
    Sscr: "𝒮",
    sscr: "𝓈",
    ssetmn: "∖",
    ssmile: "⌣",
    sstarf: "⋆",
    Star: "⋆",
    star: "☆",
    starf: "★",
    straightepsilon: "ϵ",
    straightphi: "ϕ",
    strns: "¯",
    sub: "⊂",
    Sub: "⋐",
    subdot: "⪽",
    subE: "⫅",
    sube: "⊆",
    subedot: "⫃",
    submult: "⫁",
    subnE: "⫋",
    subne: "⊊",
    subplus: "⪿",
    subrarr: "⥹",
    subset: "⊂",
    Subset: "⋐",
    subseteq: "⊆",
    subseteqq: "⫅",
    SubsetEqual: "⊆",
    subsetneq: "⊊",
    subsetneqq: "⫋",
    subsim: "⫇",
    subsub: "⫕",
    subsup: "⫓",
    succapprox: "⪸",
    succ: "≻",
    succcurlyeq: "≽",
    Succeeds: "≻",
    SucceedsEqual: "⪰",
    SucceedsSlantEqual: "≽",
    SucceedsTilde: "≿",
    succeq: "⪰",
    succnapprox: "⪺",
    succneqq: "⪶",
    succnsim: "⋩",
    succsim: "≿",
    SuchThat: "∋",
    sum: "∑",
    Sum: "∑",
    sung: "♪",
    sup1: "¹",
    sup2: "²",
    sup3: "³",
    sup: "⊃",
    Sup: "⋑",
    supdot: "⪾",
    supdsub: "⫘",
    supE: "⫆",
    supe: "⊇",
    supedot: "⫄",
    Superset: "⊃",
    SupersetEqual: "⊇",
    suphsol: "⟉",
    suphsub: "⫗",
    suplarr: "⥻",
    supmult: "⫂",
    supnE: "⫌",
    supne: "⊋",
    supplus: "⫀",
    supset: "⊃",
    Supset: "⋑",
    supseteq: "⊇",
    supseteqq: "⫆",
    supsetneq: "⊋",
    supsetneqq: "⫌",
    supsim: "⫈",
    supsub: "⫔",
    supsup: "⫖",
    swarhk: "⤦",
    swarr: "↙",
    swArr: "⇙",
    swarrow: "↙",
    swnwar: "⤪",
    szlig: "ß",
    Tab: "\t",
    target: "⌖",
    Tau: "Τ",
    tau: "τ",
    tbrk: "⎴",
    Tcaron: "Ť",
    tcaron: "ť",
    Tcedil: "Ţ",
    tcedil: "ţ",
    Tcy: "Т",
    tcy: "т",
    tdot: "⃛",
    telrec: "⌕",
    Tfr: "𝔗",
    tfr: "𝔱",
    there4: "∴",
    therefore: "∴",
    Therefore: "∴",
    Theta: "Θ",
    theta: "θ",
    thetasym: "ϑ",
    thetav: "ϑ",
    thickapprox: "≈",
    thicksim: "∼",
    ThickSpace: "  ",
    ThinSpace: " ",
    thinsp: " ",
    thkap: "≈",
    thksim: "∼",
    THORN: "Þ",
    thorn: "þ",
    tilde: "˜",
    Tilde: "∼",
    TildeEqual: "≃",
    TildeFullEqual: "≅",
    TildeTilde: "≈",
    timesbar: "⨱",
    timesb: "⊠",
    times: "×",
    timesd: "⨰",
    tint: "∭",
    toea: "⤨",
    topbot: "⌶",
    topcir: "⫱",
    top: "⊤",
    Topf: "𝕋",
    topf: "𝕥",
    topfork: "⫚",
    tosa: "⤩",
    tprime: "‴",
    trade: "™",
    TRADE: "™",
    triangle: "▵",
    triangledown: "▿",
    triangleleft: "◃",
    trianglelefteq: "⊴",
    triangleq: "≜",
    triangleright: "▹",
    trianglerighteq: "⊵",
    tridot: "◬",
    trie: "≜",
    triminus: "⨺",
    TripleDot: "⃛",
    triplus: "⨹",
    trisb: "⧍",
    tritime: "⨻",
    trpezium: "⏢",
    Tscr: "𝒯",
    tscr: "𝓉",
    TScy: "Ц",
    tscy: "ц",
    TSHcy: "Ћ",
    tshcy: "ћ",
    Tstrok: "Ŧ",
    tstrok: "ŧ",
    twixt: "≬",
    twoheadleftarrow: "↞",
    twoheadrightarrow: "↠",
    Uacute: "Ú",
    uacute: "ú",
    uarr: "↑",
    Uarr: "↟",
    uArr: "⇑",
    Uarrocir: "⥉",
    Ubrcy: "Ў",
    ubrcy: "ў",
    Ubreve: "Ŭ",
    ubreve: "ŭ",
    Ucirc: "Û",
    ucirc: "û",
    Ucy: "У",
    ucy: "у",
    udarr: "⇅",
    Udblac: "Ű",
    udblac: "ű",
    udhar: "⥮",
    ufisht: "⥾",
    Ufr: "𝔘",
    ufr: "𝔲",
    Ugrave: "Ù",
    ugrave: "ù",
    uHar: "⥣",
    uharl: "↿",
    uharr: "↾",
    uhblk: "▀",
    ulcorn: "⌜",
    ulcorner: "⌜",
    ulcrop: "⌏",
    ultri: "◸",
    Umacr: "Ū",
    umacr: "ū",
    uml: "¨",
    UnderBar: "_",
    UnderBrace: "⏟",
    UnderBracket: "⎵",
    UnderParenthesis: "⏝",
    Union: "⋃",
    UnionPlus: "⊎",
    Uogon: "Ų",
    uogon: "ų",
    Uopf: "𝕌",
    uopf: "𝕦",
    UpArrowBar: "⤒",
    uparrow: "↑",
    UpArrow: "↑",
    Uparrow: "⇑",
    UpArrowDownArrow: "⇅",
    updownarrow: "↕",
    UpDownArrow: "↕",
    Updownarrow: "⇕",
    UpEquilibrium: "⥮",
    upharpoonleft: "↿",
    upharpoonright: "↾",
    uplus: "⊎",
    UpperLeftArrow: "↖",
    UpperRightArrow: "↗",
    upsi: "υ",
    Upsi: "ϒ",
    upsih: "ϒ",
    Upsilon: "Υ",
    upsilon: "υ",
    UpTeeArrow: "↥",
    UpTee: "⊥",
    upuparrows: "⇈",
    urcorn: "⌝",
    urcorner: "⌝",
    urcrop: "⌎",
    Uring: "Ů",
    uring: "ů",
    urtri: "◹",
    Uscr: "𝒰",
    uscr: "𝓊",
    utdot: "⋰",
    Utilde: "Ũ",
    utilde: "ũ",
    utri: "▵",
    utrif: "▴",
    uuarr: "⇈",
    Uuml: "Ü",
    uuml: "ü",
    uwangle: "⦧",
    vangrt: "⦜",
    varepsilon: "ϵ",
    varkappa: "ϰ",
    varnothing: "∅",
    varphi: "ϕ",
    varpi: "ϖ",
    varpropto: "∝",
    varr: "↕",
    vArr: "⇕",
    varrho: "ϱ",
    varsigma: "ς",
    varsubsetneq: "⊊︀",
    varsubsetneqq: "⫋︀",
    varsupsetneq: "⊋︀",
    varsupsetneqq: "⫌︀",
    vartheta: "ϑ",
    vartriangleleft: "⊲",
    vartriangleright: "⊳",
    vBar: "⫨",
    Vbar: "⫫",
    vBarv: "⫩",
    Vcy: "В",
    vcy: "в",
    vdash: "⊢",
    vDash: "⊨",
    Vdash: "⊩",
    VDash: "⊫",
    Vdashl: "⫦",
    veebar: "⊻",
    vee: "∨",
    Vee: "⋁",
    veeeq: "≚",
    vellip: "⋮",
    verbar: "|",
    Verbar: "‖",
    vert: "|",
    Vert: "‖",
    VerticalBar: "∣",
    VerticalLine: "|",
    VerticalSeparator: "❘",
    VerticalTilde: "≀",
    VeryThinSpace: " ",
    Vfr: "𝔙",
    vfr: "𝔳",
    vltri: "⊲",
    vnsub: "⊂⃒",
    vnsup: "⊃⃒",
    Vopf: "𝕍",
    vopf: "𝕧",
    vprop: "∝",
    vrtri: "⊳",
    Vscr: "𝒱",
    vscr: "𝓋",
    vsubnE: "⫋︀",
    vsubne: "⊊︀",
    vsupnE: "⫌︀",
    vsupne: "⊋︀",
    Vvdash: "⊪",
    vzigzag: "⦚",
    Wcirc: "Ŵ",
    wcirc: "ŵ",
    wedbar: "⩟",
    wedge: "∧",
    Wedge: "⋀",
    wedgeq: "≙",
    weierp: "℘",
    Wfr: "𝔚",
    wfr: "𝔴",
    Wopf: "𝕎",
    wopf: "𝕨",
    wp: "℘",
    wr: "≀",
    wreath: "≀",
    Wscr: "𝒲",
    wscr: "𝓌",
    xcap: "⋂",
    xcirc: "◯",
    xcup: "⋃",
    xdtri: "▽",
    Xfr: "𝔛",
    xfr: "𝔵",
    xharr: "⟷",
    xhArr: "⟺",
    Xi: "Ξ",
    xi: "ξ",
    xlarr: "⟵",
    xlArr: "⟸",
    xmap: "⟼",
    xnis: "⋻",
    xodot: "⨀",
    Xopf: "𝕏",
    xopf: "𝕩",
    xoplus: "⨁",
    xotime: "⨂",
    xrarr: "⟶",
    xrArr: "⟹",
    Xscr: "𝒳",
    xscr: "𝓍",
    xsqcup: "⨆",
    xuplus: "⨄",
    xutri: "△",
    xvee: "⋁",
    xwedge: "⋀",
    Yacute: "Ý",
    yacute: "ý",
    YAcy: "Я",
    yacy: "я",
    Ycirc: "Ŷ",
    ycirc: "ŷ",
    Ycy: "Ы",
    ycy: "ы",
    yen: "¥",
    Yfr: "𝔜",
    yfr: "𝔶",
    YIcy: "Ї",
    yicy: "ї",
    Yopf: "𝕐",
    yopf: "𝕪",
    Yscr: "𝒴",
    yscr: "𝓎",
    YUcy: "Ю",
    yucy: "ю",
    yuml: "ÿ",
    Yuml: "Ÿ",
    Zacute: "Ź",
    zacute: "ź",
    Zcaron: "Ž",
    zcaron: "ž",
    Zcy: "З",
    zcy: "з",
    Zdot: "Ż",
    zdot: "ż",
    zeetrf: "ℨ",
    ZeroWidthSpace: "​",
    Zeta: "Ζ",
    zeta: "ζ",
    zfr: "𝔷",
    Zfr: "ℨ",
    ZHcy: "Ж",
    zhcy: "ж",
    zigrarr: "⇝",
    zopf: "𝕫",
    Zopf: "ℤ",
    Zscr: "𝒵",
    zscr: "𝓏",
    zwj: "‍",
    zwnj: "‌"
  };

  !function (e) {
    e.exports = wj;
  }(xj);
  var kj = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/,
      Cj = {},
      Mj = {};

  function jj(e, t, n) {
    var r,
        o,
        i,
        a,
        s,
        l = "";

    for ("string" != typeof t && (n = t, t = jj.defaultChars), void 0 === n && (n = !0), s = function (e) {
      var t,
          n,
          r = Mj[e];
      if (r) return r;

      for (r = Mj[e] = [], t = 0; t < 128; t++) {
        n = String.fromCharCode(t), /^[0-9a-z]$/i.test(n) ? r.push(n) : r.push("%" + ("0" + t.toString(16).toUpperCase()).slice(-2));
      }

      for (t = 0; t < e.length; t++) {
        r[e.charCodeAt(t)] = e[t];
      }

      return r;
    }(t), r = 0, o = e.length; r < o; r++) {
      if (i = e.charCodeAt(r), n && 37 === i && r + 2 < o && /^[0-9a-f]{2}$/i.test(e.slice(r + 1, r + 3))) l += e.slice(r, r + 3), r += 2;else if (i < 128) l += s[i];else if (i >= 55296 && i <= 57343) {
        if (i >= 55296 && i <= 56319 && r + 1 < o && (a = e.charCodeAt(r + 1)) >= 56320 && a <= 57343) {
          l += encodeURIComponent(e[r] + e[r + 1]), r++;
          continue;
        }

        l += "%EF%BF%BD";
      } else l += encodeURIComponent(e[r]);
    }

    return l;
  }

  jj.defaultChars = ";/?:@&=+$,-_.!~*'()#", jj.componentChars = "-_.!~*'()";
  var Ej = jj,
      _j = {};

  function Tj(e, t) {
    var n;
    return "string" != typeof t && (t = Tj.defaultChars), n = function (e) {
      var t,
          n,
          r = _j[e];
      if (r) return r;

      for (r = _j[e] = [], t = 0; t < 128; t++) {
        n = String.fromCharCode(t), r.push(n);
      }

      for (t = 0; t < e.length; t++) {
        r[n = e.charCodeAt(t)] = "%" + ("0" + n.toString(16).toUpperCase()).slice(-2);
      }

      return r;
    }(t), e.replace(/(%[a-f0-9]{2})+/gi, function (e) {
      var t,
          r,
          o,
          i,
          a,
          s,
          l,
          c = "";

      for (t = 0, r = e.length; t < r; t += 3) {
        (o = parseInt(e.slice(t + 1, t + 3), 16)) < 128 ? c += n[o] : 192 == (224 & o) && t + 3 < r && 128 == (192 & (i = parseInt(e.slice(t + 4, t + 6), 16))) ? (c += (l = o << 6 & 1984 | 63 & i) < 128 ? "��" : String.fromCharCode(l), t += 3) : 224 == (240 & o) && t + 6 < r && (i = parseInt(e.slice(t + 4, t + 6), 16), a = parseInt(e.slice(t + 7, t + 9), 16), 128 == (192 & i) && 128 == (192 & a)) ? (c += (l = o << 12 & 61440 | i << 6 & 4032 | 63 & a) < 2048 || l >= 55296 && l <= 57343 ? "���" : String.fromCharCode(l), t += 6) : 240 == (248 & o) && t + 9 < r && (i = parseInt(e.slice(t + 4, t + 6), 16), a = parseInt(e.slice(t + 7, t + 9), 16), s = parseInt(e.slice(t + 10, t + 12), 16), 128 == (192 & i) && 128 == (192 & a) && 128 == (192 & s)) ? ((l = o << 18 & 1835008 | i << 12 & 258048 | a << 6 & 4032 | 63 & s) < 65536 || l > 1114111 ? c += "����" : (l -= 65536, c += String.fromCharCode(55296 + (l >> 10), 56320 + (1023 & l))), t += 9) : c += "�";
      }

      return c;
    });
  }

  Tj.defaultChars = ";/?:@&=+$,#", Tj.componentChars = "";
  var Sj = Tj;

  function Lj() {
    this.protocol = null, this.slashes = null, this.auth = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.pathname = null;
  }

  var Dj = /^([a-z0-9.+-]+:)/i,
      Aj = /:[0-9]*$/,
      Nj = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,
      Ij = ["{", "}", "|", "\\", "^", "`"].concat(["<", ">", '"', "`", " ", "\r", "\n", "\t"]),
      zj = ["'"].concat(Ij),
      Oj = ["%", "/", "?", ";", "#"].concat(zj),
      Rj = ["/", "?", "#"],
      Pj = /^[+a-z0-9A-Z_-]{0,63}$/,
      Fj = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
      Bj = {
    javascript: !0,
    "javascript:": !0
  },
      qj = {
    http: !0,
    https: !0,
    ftp: !0,
    gopher: !0,
    file: !0,
    "http:": !0,
    "https:": !0,
    "ftp:": !0,
    "gopher:": !0,
    "file:": !0
  };
  Lj.prototype.parse = function (e, t) {
    var n,
        r,
        o,
        i,
        a,
        s = e;

    if (s = s.trim(), !t && 1 === e.split("#").length) {
      var l = Nj.exec(s);
      if (l) return this.pathname = l[1], l[2] && (this.search = l[2]), this;
    }

    var c = Dj.exec(s);

    if (c && (o = (c = c[0]).toLowerCase(), this.protocol = c, s = s.substr(c.length)), (t || c || s.match(/^\/\/[^@\/]+@[^@\/]+/)) && (!(a = "//" === s.substr(0, 2)) || c && Bj[c] || (s = s.substr(2), this.slashes = !0)), !Bj[c] && (a || c && !qj[c])) {
      var u,
          d,
          f = -1;

      for (n = 0; n < Rj.length; n++) {
        -1 !== (i = s.indexOf(Rj[n])) && (-1 === f || i < f) && (f = i);
      }

      for (-1 !== (d = -1 === f ? s.lastIndexOf("@") : s.lastIndexOf("@", f)) && (u = s.slice(0, d), s = s.slice(d + 1), this.auth = u), f = -1, n = 0; n < Oj.length; n++) {
        -1 !== (i = s.indexOf(Oj[n])) && (-1 === f || i < f) && (f = i);
      }

      -1 === f && (f = s.length), ":" === s[f - 1] && f--;
      var p = s.slice(0, f);
      s = s.slice(f), this.parseHost(p), this.hostname = this.hostname || "";
      var h = "[" === this.hostname[0] && "]" === this.hostname[this.hostname.length - 1];

      if (!h) {
        var m = this.hostname.split(/\./);

        for (n = 0, r = m.length; n < r; n++) {
          var g = m[n];

          if (g && !g.match(Pj)) {
            for (var y = "", b = 0, v = g.length; b < v; b++) {
              g.charCodeAt(b) > 127 ? y += "x" : y += g[b];
            }

            if (!y.match(Pj)) {
              var x = m.slice(0, n),
                  w = m.slice(n + 1),
                  k = g.match(Fj);
              k && (x.push(k[1]), w.unshift(k[2])), w.length && (s = w.join(".") + s), this.hostname = x.join(".");
              break;
            }
          }
        }
      }

      this.hostname.length > 255 && (this.hostname = ""), h && (this.hostname = this.hostname.substr(1, this.hostname.length - 2));
    }

    var C = s.indexOf("#");
    -1 !== C && (this.hash = s.substr(C), s = s.slice(0, C));
    var M = s.indexOf("?");
    return -1 !== M && (this.search = s.substr(M), s = s.slice(0, M)), s && (this.pathname = s), qj[o] && this.hostname && !this.pathname && (this.pathname = ""), this;
  }, Lj.prototype.parseHost = function (e) {
    var t = Aj.exec(e);
    t && (":" !== (t = t[0]) && (this.port = t.substr(1)), e = e.substr(0, e.length - t.length)), e && (this.hostname = e);
  };

  var Uj = function Uj(e, t) {
    if (e && e instanceof Lj) return e;
    var n = new Lj();
    return n.parse(e, t), n;
  };

  Cj.encode = Ej, Cj.decode = Sj, Cj.format = function (e) {
    var t = "";
    return t += e.protocol || "", t += e.slashes ? "//" : "", t += e.auth ? e.auth + "@" : "", e.hostname && -1 !== e.hostname.indexOf(":") ? t += "[" + e.hostname + "]" : t += e.hostname || "", t += e.port ? ":" + e.port : "", t += e.pathname || "", t += e.search || "", t += e.hash || "";
  }, Cj.parse = Uj;
  var Vj,
      Hj,
      Zj,
      Wj,
      $j,
      Gj,
      Yj,
      Qj,
      Xj,
      Kj = {};

  function Jj() {
    return Hj ? Vj : (Hj = 1, Vj = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/);
  }

  function eE() {
    return Wj ? Zj : (Wj = 1, Zj = /[\0-\x1F\x7F-\x9F]/);
  }

  function tE() {
    return Qj ? Yj : (Qj = 1, Yj = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/);
  }

  function nE() {
    return Xj || (Xj = 1, Kj.Any = Jj(), Kj.Cc = eE(), Kj.Cf = Gj ? $j : (Gj = 1, $j = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/), Kj.P = kj, Kj.Z = tE()), Kj;
  }

  !function (e) {
    var t = Object.prototype.hasOwnProperty;

    function n(e, n) {
      return t.call(e, n);
    }

    function r(e) {
      return !(e >= 55296 && e <= 57343) && !(e >= 64976 && e <= 65007) && 65535 != (65535 & e) && 65534 != (65535 & e) && !(e >= 0 && e <= 8) && 11 !== e && !(e >= 14 && e <= 31) && !(e >= 127 && e <= 159) && !(e > 1114111);
    }

    function o(e) {
      if (e > 65535) {
        var t = 55296 + ((e -= 65536) >> 10),
            n = 56320 + (1023 & e);
        return String.fromCharCode(t, n);
      }

      return String.fromCharCode(e);
    }

    var i = /\\([!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])/g,
        a = new RegExp(i.source + "|" + /&([a-z#][a-z0-9]{1,31});/gi.source, "gi"),
        s = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))/i,
        l = xj.exports;
    var c = /[&<>"]/,
        u = /[&<>"]/g,
        d = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;"
    };

    function f(e) {
      return d[e];
    }

    var p = /[.?*+^$[\]\\(){}|-]/g;
    var h = kj;
    e.lib = {}, e.lib.mdurl = Cj, e.lib.ucmicro = nE(), e.assign = function (e) {
      var t = Array.prototype.slice.call(arguments, 1);
      return t.forEach(function (t) {
        if (t) {
          if ("object" != _typeof(t)) throw new TypeError(t + "must be object");
          Object.keys(t).forEach(function (n) {
            e[n] = t[n];
          });
        }
      }), e;
    }, e.isString = function (e) {
      return "[object String]" === function (e) {
        return Object.prototype.toString.call(e);
      }(e);
    }, e.has = n, e.unescapeMd = function (e) {
      return e.indexOf("\\") < 0 ? e : e.replace(i, "$1");
    }, e.unescapeAll = function (e) {
      return e.indexOf("\\") < 0 && e.indexOf("&") < 0 ? e : e.replace(a, function (e, t, i) {
        return t || function (e, t) {
          var i = 0;
          return n(l, t) ? l[t] : 35 === t.charCodeAt(0) && s.test(t) && r(i = "x" === t[1].toLowerCase() ? parseInt(t.slice(2), 16) : parseInt(t.slice(1), 10)) ? o(i) : e;
        }(e, i);
      });
    }, e.isValidEntityCode = r, e.fromCodePoint = o, e.escapeHtml = function (e) {
      return c.test(e) ? e.replace(u, f) : e;
    }, e.arrayReplaceAt = function (e, t, n) {
      return [].concat(e.slice(0, t), n, e.slice(t + 1));
    }, e.isSpace = function (e) {
      switch (e) {
        case 9:
        case 32:
          return !0;
      }

      return !1;
    }, e.isWhiteSpace = function (e) {
      if (e >= 8192 && e <= 8202) return !0;

      switch (e) {
        case 9:
        case 10:
        case 11:
        case 12:
        case 13:
        case 32:
        case 160:
        case 5760:
        case 8239:
        case 8287:
        case 12288:
          return !0;
      }

      return !1;
    }, e.isMdAsciiPunct = function (e) {
      switch (e) {
        case 33:
        case 34:
        case 35:
        case 36:
        case 37:
        case 38:
        case 39:
        case 40:
        case 41:
        case 42:
        case 43:
        case 44:
        case 45:
        case 46:
        case 47:
        case 58:
        case 59:
        case 60:
        case 61:
        case 62:
        case 63:
        case 64:
        case 91:
        case 92:
        case 93:
        case 94:
        case 95:
        case 96:
        case 123:
        case 124:
        case 125:
        case 126:
          return !0;

        default:
          return !1;
      }
    }, e.isPunctChar = function (e) {
      return h.test(e);
    }, e.escapeRE = function (e) {
      return e.replace(p, "\\$&");
    }, e.normalizeReference = function (e) {
      return e = e.trim().replace(/\s+/g, " "), "Ṿ" === "ẞ".toLowerCase() && (e = e.replace(/ẞ/g, "ß")), e.toLowerCase().toUpperCase();
    };
  }(vj);
  var rE = {},
      oE = vj.unescapeAll,
      iE = vj.unescapeAll;
  rE.parseLinkLabel = function (e, t, n) {
    var r,
        o,
        i,
        a,
        s = -1,
        l = e.posMax,
        c = e.pos;

    for (e.pos = t + 1, r = 1; e.pos < l;) {
      if (93 === (i = e.src.charCodeAt(e.pos)) && 0 === --r) {
        o = !0;
        break;
      }

      if (a = e.pos, e.md.inline.skipToken(e), 91 === i) if (a === e.pos - 1) r++;else if (n) return e.pos = c, -1;
    }

    return o && (s = e.pos), e.pos = c, s;
  }, rE.parseLinkDestination = function (e, t, n) {
    var r,
        o,
        i = t,
        a = {
      ok: !1,
      pos: 0,
      lines: 0,
      str: ""
    };

    if (60 === e.charCodeAt(t)) {
      for (t++; t < n;) {
        if (10 === (r = e.charCodeAt(t))) return a;
        if (60 === r) return a;
        if (62 === r) return a.pos = t + 1, a.str = oE(e.slice(i + 1, t)), a.ok = !0, a;
        92 === r && t + 1 < n ? t += 2 : t++;
      }

      return a;
    }

    for (o = 0; t < n && 32 !== (r = e.charCodeAt(t)) && !(r < 32 || 127 === r);) {
      if (92 === r && t + 1 < n) {
        if (32 === e.charCodeAt(t + 1)) break;
        t += 2;
      } else {
        if (40 === r && ++o > 32) return a;

        if (41 === r) {
          if (0 === o) break;
          o--;
        }

        t++;
      }
    }

    return i === t || 0 !== o || (a.str = oE(e.slice(i, t)), a.lines = 0, a.pos = t, a.ok = !0), a;
  }, rE.parseLinkTitle = function (e, t, n) {
    var r,
        o,
        i = 0,
        a = t,
        s = {
      ok: !1,
      pos: 0,
      lines: 0,
      str: ""
    };
    if (t >= n) return s;
    if (34 !== (o = e.charCodeAt(t)) && 39 !== o && 40 !== o) return s;

    for (t++, 40 === o && (o = 41); t < n;) {
      if ((r = e.charCodeAt(t)) === o) return s.pos = t + 1, s.lines = i, s.str = iE(e.slice(a + 1, t)), s.ok = !0, s;
      if (40 === r && 41 === o) return s;
      10 === r ? i++ : 92 === r && t + 1 < n && (t++, 10 === e.charCodeAt(t) && i++), t++;
    }

    return s;
  };
  var aE = vj.assign,
      sE = vj.unescapeAll,
      lE = vj.escapeHtml,
      cE = {};

  function uE() {
    this.rules = aE({}, cE);
  }

  cE.code_inline = function (e, t, n, r, o) {
    var i = e[t];
    return "<code" + o.renderAttrs(i) + ">" + lE(e[t].content) + "</code>";
  }, cE.code_block = function (e, t, n, r, o) {
    var i = e[t];
    return "<pre" + o.renderAttrs(i) + "><code>" + lE(e[t].content) + "</code></pre>\n";
  }, cE.fence = function (e, t, n, r, o) {
    var i,
        a,
        s,
        l,
        c,
        u = e[t],
        d = u.info ? sE(u.info).trim() : "",
        f = "",
        p = "";
    return d && (f = (s = d.split(/(\s+)/g))[0], p = s.slice(2).join("")), 0 === (i = n.highlight && n.highlight(u.content, f, p) || lE(u.content)).indexOf("<pre") ? i + "\n" : d ? (a = u.attrIndex("class"), l = u.attrs ? u.attrs.slice() : [], a < 0 ? l.push(["class", n.langPrefix + f]) : (l[a] = l[a].slice(), l[a][1] += " " + n.langPrefix + f), c = {
      attrs: l
    }, "<pre><code" + o.renderAttrs(c) + ">" + i + "</code></pre>\n") : "<pre><code" + o.renderAttrs(u) + ">" + i + "</code></pre>\n";
  }, cE.image = function (e, t, n, r, o) {
    var i = e[t];
    return i.attrs[i.attrIndex("alt")][1] = o.renderInlineAsText(i.children, n, r), o.renderToken(e, t, n);
  }, cE.hardbreak = function (e, t, n) {
    return n.xhtmlOut ? "<br />\n" : "<br>\n";
  }, cE.softbreak = function (e, t, n) {
    return n.breaks ? n.xhtmlOut ? "<br />\n" : "<br>\n" : "\n";
  }, cE.text = function (e, t) {
    return lE(e[t].content);
  }, cE.html_block = function (e, t) {
    return e[t].content;
  }, cE.html_inline = function (e, t) {
    return e[t].content;
  }, uE.prototype.renderAttrs = function (e) {
    var t, n, r;
    if (!e.attrs) return "";

    for (r = "", t = 0, n = e.attrs.length; t < n; t++) {
      r += " " + lE(e.attrs[t][0]) + '="' + lE(e.attrs[t][1]) + '"';
    }

    return r;
  }, uE.prototype.renderToken = function (e, t, n) {
    var r,
        o = "",
        i = !1,
        a = e[t];
    return a.hidden ? "" : (a.block && -1 !== a.nesting && t && e[t - 1].hidden && (o += "\n"), o += (-1 === a.nesting ? "</" : "<") + a.tag, o += this.renderAttrs(a), 0 === a.nesting && n.xhtmlOut && (o += " /"), a.block && (i = !0, 1 === a.nesting && t + 1 < e.length && ("inline" === (r = e[t + 1]).type || r.hidden || -1 === r.nesting && r.tag === a.tag) && (i = !1)), o += i ? ">\n" : ">");
  }, uE.prototype.renderInline = function (e, t, n) {
    for (var r, o = "", i = this.rules, a = 0, s = e.length; a < s; a++) {
      void 0 !== i[r = e[a].type] ? o += i[r](e, a, t, n, this) : o += this.renderToken(e, a, t);
    }

    return o;
  }, uE.prototype.renderInlineAsText = function (e, t, n) {
    for (var r = "", o = 0, i = e.length; o < i; o++) {
      "text" === e[o].type ? r += e[o].content : "image" === e[o].type ? r += this.renderInlineAsText(e[o].children, t, n) : "softbreak" === e[o].type && (r += "\n");
    }

    return r;
  }, uE.prototype.render = function (e, t, n) {
    var r,
        o,
        i,
        a = "",
        s = this.rules;

    for (r = 0, o = e.length; r < o; r++) {
      "inline" === (i = e[r].type) ? a += this.renderInline(e[r].children, t, n) : void 0 !== s[i] ? a += s[e[r].type](e, r, t, n, this) : a += this.renderToken(e, r, t, n);
    }

    return a;
  };
  var dE = uE;

  function fE() {
    this.__rules__ = [], this.__cache__ = null;
  }

  fE.prototype.__find__ = function (e) {
    for (var t = 0; t < this.__rules__.length; t++) {
      if (this.__rules__[t].name === e) return t;
    }

    return -1;
  }, fE.prototype.__compile__ = function () {
    var e = this,
        t = [""];
    e.__rules__.forEach(function (e) {
      e.enabled && e.alt.forEach(function (e) {
        t.indexOf(e) < 0 && t.push(e);
      });
    }), e.__cache__ = {}, t.forEach(function (t) {
      e.__cache__[t] = [], e.__rules__.forEach(function (n) {
        n.enabled && (t && n.alt.indexOf(t) < 0 || e.__cache__[t].push(n.fn));
      });
    });
  }, fE.prototype.at = function (e, t, n) {
    var r = this.__find__(e),
        o = n || {};

    if (-1 === r) throw new Error("Parser rule not found: " + e);
    this.__rules__[r].fn = t, this.__rules__[r].alt = o.alt || [], this.__cache__ = null;
  }, fE.prototype.before = function (e, t, n, r) {
    var o = this.__find__(e),
        i = r || {};

    if (-1 === o) throw new Error("Parser rule not found: " + e);
    this.__rules__.splice(o, 0, {
      name: t,
      enabled: !0,
      fn: n,
      alt: i.alt || []
    }), this.__cache__ = null;
  }, fE.prototype.after = function (e, t, n, r) {
    var o = this.__find__(e),
        i = r || {};

    if (-1 === o) throw new Error("Parser rule not found: " + e);
    this.__rules__.splice(o + 1, 0, {
      name: t,
      enabled: !0,
      fn: n,
      alt: i.alt || []
    }), this.__cache__ = null;
  }, fE.prototype.push = function (e, t, n) {
    var r = n || {};
    this.__rules__.push({
      name: e,
      enabled: !0,
      fn: t,
      alt: r.alt || []
    }), this.__cache__ = null;
  }, fE.prototype.enable = function (e, t) {
    Array.isArray(e) || (e = [e]);
    var n = [];
    return e.forEach(function (e) {
      var r = this.__find__(e);

      if (r < 0) {
        if (t) return;
        throw new Error("Rules manager: invalid rule name " + e);
      }

      this.__rules__[r].enabled = !0, n.push(e);
    }, this), this.__cache__ = null, n;
  }, fE.prototype.enableOnly = function (e, t) {
    Array.isArray(e) || (e = [e]), this.__rules__.forEach(function (e) {
      e.enabled = !1;
    }), this.enable(e, t);
  }, fE.prototype.disable = function (e, t) {
    Array.isArray(e) || (e = [e]);
    var n = [];
    return e.forEach(function (e) {
      var r = this.__find__(e);

      if (r < 0) {
        if (t) return;
        throw new Error("Rules manager: invalid rule name " + e);
      }

      this.__rules__[r].enabled = !1, n.push(e);
    }, this), this.__cache__ = null, n;
  }, fE.prototype.getRules = function (e) {
    return null === this.__cache__ && this.__compile__(), this.__cache__[e] || [];
  };
  var pE = fE,
      hE = /\r\n?|\n/g,
      mE = /\0/g,
      gE = vj.arrayReplaceAt;

  function yE(e) {
    return /^<\/a\s*>/i.test(e);
  }

  var bE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/,
      vE = /\((c|tm|r)\)/i,
      xE = /\((c|tm|r)\)/gi,
      wE = {
    c: "©",
    r: "®",
    tm: "™"
  };

  function kE(e, t) {
    return wE[t.toLowerCase()];
  }

  function CE(e) {
    var t,
        n,
        r = 0;

    for (t = e.length - 1; t >= 0; t--) {
      "text" !== (n = e[t]).type || r || (n.content = n.content.replace(xE, kE)), "link_open" === n.type && "auto" === n.info && r--, "link_close" === n.type && "auto" === n.info && r++;
    }
  }

  function ME(e) {
    var t,
        n,
        r = 0;

    for (t = e.length - 1; t >= 0; t--) {
      "text" !== (n = e[t]).type || r || bE.test(n.content) && (n.content = n.content.replace(/\+-/g, "±").replace(/\.{2,}/g, "…").replace(/([?!])…/g, "$1..").replace(/([?!]){4,}/g, "$1$1$1").replace(/,{2,}/g, ",").replace(/(^|[^-])---(?=[^-]|$)/gm, "$1—").replace(/(^|\s)--(?=\s|$)/gm, "$1–").replace(/(^|[^-\s])--(?=[^-\s]|$)/gm, "$1–")), "link_open" === n.type && "auto" === n.info && r--, "link_close" === n.type && "auto" === n.info && r++;
    }
  }

  var jE = vj.isWhiteSpace,
      EE = vj.isPunctChar,
      _E = vj.isMdAsciiPunct,
      TE = /['"]/,
      SE = /['"]/g;

  function LE(e, t, n) {
    return e.slice(0, t) + n + e.slice(t + 1);
  }

  function DE(e, t) {
    var n, r, o, i, a, s, l, c, u, d, f, p, h, m, g, y, b, v, x, w, k;

    for (x = [], n = 0; n < e.length; n++) {
      for (r = e[n], l = e[n].level, b = x.length - 1; b >= 0 && !(x[b].level <= l); b--) {
        ;
      }

      if (x.length = b + 1, "text" === r.type) {
        a = 0, s = (o = r.content).length;

        e: for (; a < s && (SE.lastIndex = a, i = SE.exec(o));) {
          if (g = y = !0, a = i.index + 1, v = "'" === i[0], u = 32, i.index - 1 >= 0) u = o.charCodeAt(i.index - 1);else for (b = n - 1; b >= 0 && "softbreak" !== e[b].type && "hardbreak" !== e[b].type; b--) {
            if (e[b].content) {
              u = e[b].content.charCodeAt(e[b].content.length - 1);
              break;
            }
          }
          if (d = 32, a < s) d = o.charCodeAt(a);else for (b = n + 1; b < e.length && "softbreak" !== e[b].type && "hardbreak" !== e[b].type; b++) {
            if (e[b].content) {
              d = e[b].content.charCodeAt(0);
              break;
            }
          }

          if (f = _E(u) || EE(String.fromCharCode(u)), p = _E(d) || EE(String.fromCharCode(d)), h = jE(u), (m = jE(d)) ? g = !1 : p && (h || f || (g = !1)), h ? y = !1 : f && (m || p || (y = !1)), 34 === d && '"' === i[0] && u >= 48 && u <= 57 && (y = g = !1), g && y && (g = f, y = p), g || y) {
            if (y) for (b = x.length - 1; b >= 0 && (c = x[b], !(x[b].level < l)); b--) {
              if (c.single === v && x[b].level === l) {
                c = x[b], v ? (w = t.md.options.quotes[2], k = t.md.options.quotes[3]) : (w = t.md.options.quotes[0], k = t.md.options.quotes[1]), r.content = LE(r.content, i.index, k), e[c.token].content = LE(e[c.token].content, c.pos, w), a += k.length - 1, c.token === n && (a += w.length - 1), s = (o = r.content).length, x.length = b;
                continue e;
              }
            }
            g ? x.push({
              token: n,
              pos: i.index,
              single: v,
              level: l
            }) : y && v && (r.content = LE(r.content, i.index, "’"));
          } else v && (r.content = LE(r.content, i.index, "’"));
        }
      }
    }
  }

  function AE(e, t, n) {
    this.type = e, this.tag = t, this.attrs = null, this.map = null, this.nesting = n, this.level = 0, this.children = null, this.content = "", this.markup = "", this.info = "", this.meta = null, this.block = !1, this.hidden = !1;
  }

  AE.prototype.attrIndex = function (e) {
    var t, n, r;
    if (!this.attrs) return -1;

    for (n = 0, r = (t = this.attrs).length; n < r; n++) {
      if (t[n][0] === e) return n;
    }

    return -1;
  }, AE.prototype.attrPush = function (e) {
    this.attrs ? this.attrs.push(e) : this.attrs = [e];
  }, AE.prototype.attrSet = function (e, t) {
    var n = this.attrIndex(e),
        r = [e, t];
    n < 0 ? this.attrPush(r) : this.attrs[n] = r;
  }, AE.prototype.attrGet = function (e) {
    var t = this.attrIndex(e),
        n = null;
    return t >= 0 && (n = this.attrs[t][1]), n;
  }, AE.prototype.attrJoin = function (e, t) {
    var n = this.attrIndex(e);
    n < 0 ? this.attrPush([e, t]) : this.attrs[n][1] = this.attrs[n][1] + " " + t;
  };
  var NE = AE,
      IE = NE;

  function zE(e, t, n) {
    this.src = e, this.env = n, this.tokens = [], this.inlineMode = !1, this.md = t;
  }

  zE.prototype.Token = IE;
  var OE = zE,
      RE = pE,
      PE = [["normalize", function (e) {
    var t;
    t = (t = e.src.replace(hE, "\n")).replace(mE, "�"), e.src = t;
  }], ["block", function (e) {
    var t;
    e.inlineMode ? ((t = new e.Token("inline", "", 0)).content = e.src, t.map = [0, 1], t.children = [], e.tokens.push(t)) : e.md.block.parse(e.src, e.md, e.env, e.tokens);
  }], ["inline", function (e) {
    var t,
        n,
        r,
        o = e.tokens;

    for (n = 0, r = o.length; n < r; n++) {
      "inline" === (t = o[n]).type && e.md.inline.parse(t.content, e.md, e.env, t.children);
    }
  }], ["linkify", function (e) {
    var t,
        n,
        r,
        o,
        i,
        a,
        s,
        l,
        c,
        u,
        d,
        f,
        p,
        h,
        m,
        g,
        y,
        b,
        v = e.tokens;
    if (e.md.options.linkify) for (n = 0, r = v.length; n < r; n++) {
      if ("inline" === v[n].type && e.md.linkify.pretest(v[n].content)) for (p = 0, t = (o = v[n].children).length - 1; t >= 0; t--) {
        if ("link_close" !== (a = o[t]).type) {
          if ("html_inline" === a.type && (b = a.content, /^<a[>\s]/i.test(b) && p > 0 && p--, yE(a.content) && p++), !(p > 0) && "text" === a.type && e.md.linkify.test(a.content)) {
            for (c = a.content, y = e.md.linkify.match(c), s = [], f = a.level, d = 0, y.length > 0 && 0 === y[0].index && t > 0 && "text_special" === o[t - 1].type && (y = y.slice(1)), l = 0; l < y.length; l++) {
              h = y[l].url, m = e.md.normalizeLink(h), e.md.validateLink(m) && (g = y[l].text, g = y[l].schema ? "mailto:" !== y[l].schema || /^mailto:/i.test(g) ? e.md.normalizeLinkText(g) : e.md.normalizeLinkText("mailto:" + g).replace(/^mailto:/, "") : e.md.normalizeLinkText("http://" + g).replace(/^http:\/\//, ""), (u = y[l].index) > d && ((i = new e.Token("text", "", 0)).content = c.slice(d, u), i.level = f, s.push(i)), (i = new e.Token("link_open", "a", 1)).attrs = [["href", m]], i.level = f++, i.markup = "linkify", i.info = "auto", s.push(i), (i = new e.Token("text", "", 0)).content = g, i.level = f, s.push(i), (i = new e.Token("link_close", "a", -1)).level = --f, i.markup = "linkify", i.info = "auto", s.push(i), d = y[l].lastIndex);
            }

            d < c.length && ((i = new e.Token("text", "", 0)).content = c.slice(d), i.level = f, s.push(i)), v[n].children = o = gE(o, t, s);
          }
        } else for (t--; o[t].level !== a.level && "link_open" !== o[t].type;) {
          t--;
        }
      }
    }
  }], ["replacements", function (e) {
    var t;
    if (e.md.options.typographer) for (t = e.tokens.length - 1; t >= 0; t--) {
      "inline" === e.tokens[t].type && (vE.test(e.tokens[t].content) && CE(e.tokens[t].children), bE.test(e.tokens[t].content) && ME(e.tokens[t].children));
    }
  }], ["smartquotes", function (e) {
    var t;
    if (e.md.options.typographer) for (t = e.tokens.length - 1; t >= 0; t--) {
      "inline" === e.tokens[t].type && TE.test(e.tokens[t].content) && DE(e.tokens[t].children, e);
    }
  }], ["text_join", function (e) {
    var t,
        n,
        r,
        o,
        i,
        a,
        s = e.tokens;

    for (t = 0, n = s.length; t < n; t++) {
      if ("inline" === s[t].type) {
        for (i = (r = s[t].children).length, o = 0; o < i; o++) {
          "text_special" === r[o].type && (r[o].type = "text");
        }

        for (o = a = 0; o < i; o++) {
          "text" === r[o].type && o + 1 < i && "text" === r[o + 1].type ? r[o + 1].content = r[o].content + r[o + 1].content : (o !== a && (r[a] = r[o]), a++);
        }

        o !== a && (r.length = a);
      }
    }
  }]];

  function FE() {
    this.ruler = new RE();

    for (var e = 0; e < PE.length; e++) {
      this.ruler.push(PE[e][0], PE[e][1]);
    }
  }

  FE.prototype.process = function (e) {
    var t, n, r;

    for (t = 0, n = (r = this.ruler.getRules("")).length; t < n; t++) {
      r[t](e);
    }
  }, FE.prototype.State = OE;
  var BE = FE,
      qE = vj.isSpace;

  function UE(e, t) {
    var n = e.bMarks[t] + e.tShift[t],
        r = e.eMarks[t];
    return e.src.slice(n, r);
  }

  function VE(e) {
    var t,
        n = [],
        r = 0,
        o = e.length,
        i = !1,
        a = 0,
        s = "";

    for (t = e.charCodeAt(r); r < o;) {
      124 === t && (i ? (s += e.substring(a, r - 1), a = r) : (n.push(s + e.substring(a, r)), s = "", a = r + 1)), i = 92 === t, r++, t = e.charCodeAt(r);
    }

    return n.push(s + e.substring(a)), n;
  }

  var HE = vj.isSpace,
      ZE = vj.isSpace,
      WE = vj.isSpace;

  function $E(e, t) {
    var n, r, o, i;
    return r = e.bMarks[t] + e.tShift[t], o = e.eMarks[t], 42 !== (n = e.src.charCodeAt(r++)) && 45 !== n && 43 !== n || r < o && (i = e.src.charCodeAt(r), !WE(i)) ? -1 : r;
  }

  function GE(e, t) {
    var n,
        r = e.bMarks[t] + e.tShift[t],
        o = r,
        i = e.eMarks[t];
    if (o + 1 >= i) return -1;
    if ((n = e.src.charCodeAt(o++)) < 48 || n > 57) return -1;

    for (;;) {
      if (o >= i) return -1;

      if (!((n = e.src.charCodeAt(o++)) >= 48 && n <= 57)) {
        if (41 === n || 46 === n) break;
        return -1;
      }

      if (o - r >= 10) return -1;
    }

    return o < i && (n = e.src.charCodeAt(o), !WE(n)) ? -1 : o;
  }

  var YE = vj.normalizeReference,
      QE = vj.isSpace,
      XE = {},
      KE = "<[A-Za-z][A-Za-z0-9\\-]*(?:\\s+[a-zA-Z_:][a-zA-Z0-9:._-]*(?:\\s*=\\s*(?:[^\"'=<>`\\x00-\\x20]+|'[^']*'|\"[^\"]*\"))?)*\\s*\\/?>",
      JE = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>",
      e_ = new RegExp("^(?:" + KE + "|" + JE + "|\x3c!----\x3e|\x3c!--(?:-?[^>-])(?:-?[^-])*--\x3e|<[?][\\s\\S]*?[?]>|<![A-Z]+\\s+[^>]*>|<!\\[CDATA\\[[\\s\\S]*?\\]\\]>)"),
      t_ = new RegExp("^(?:" + KE + "|" + JE + ")");
  XE.HTML_TAG_RE = e_, XE.HTML_OPEN_CLOSE_TAG_RE = t_;
  var n_ = ["address", "article", "aside", "base", "basefont", "blockquote", "body", "caption", "center", "col", "colgroup", "dd", "details", "dialog", "dir", "div", "dl", "dt", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hr", "html", "iframe", "legend", "li", "link", "main", "menu", "menuitem", "nav", "noframes", "ol", "optgroup", "option", "p", "param", "section", "source", "summary", "table", "tbody", "td", "tfoot", "th", "thead", "title", "tr", "track", "ul"],
      r_ = XE.HTML_OPEN_CLOSE_TAG_RE,
      o_ = [[/^<(script|pre|style|textarea)(?=(\s|>|$))/i, /<\/(script|pre|style|textarea)>/i, !0], [/^<!--/, /-->/, !0], [/^<\?/, /\?>/, !0], [/^<![A-Z]/, />/, !0], [/^<!\[CDATA\[/, /\]\]>/, !0], [new RegExp("^</?(" + n_.join("|") + ")(?=(\\s|/?>|$))", "i"), /^$/, !0], [new RegExp(r_.source + "\\s*$"), /^$/, !1]],
      i_ = vj.isSpace,
      a_ = NE,
      s_ = vj.isSpace;

  function l_(e, t, n, r) {
    var o, i, a, s, l, c, u, d;

    for (this.src = e, this.md = t, this.env = n, this.tokens = r, this.bMarks = [], this.eMarks = [], this.tShift = [], this.sCount = [], this.bsCount = [], this.blkIndent = 0, this.line = 0, this.lineMax = 0, this.tight = !1, this.ddIndent = -1, this.listIndent = -1, this.parentType = "root", this.level = 0, this.result = "", d = !1, a = s = c = u = 0, l = (i = this.src).length; s < l; s++) {
      if (o = i.charCodeAt(s), !d) {
        if (s_(o)) {
          c++, 9 === o ? u += 4 - u % 4 : u++;
          continue;
        }

        d = !0;
      }

      10 !== o && s !== l - 1 || (10 !== o && s++, this.bMarks.push(a), this.eMarks.push(s), this.tShift.push(c), this.sCount.push(u), this.bsCount.push(0), d = !1, c = 0, u = 0, a = s + 1);
    }

    this.bMarks.push(i.length), this.eMarks.push(i.length), this.tShift.push(0), this.sCount.push(0), this.bsCount.push(0), this.lineMax = this.bMarks.length - 1;
  }

  l_.prototype.push = function (e, t, n) {
    var r = new a_(e, t, n);
    return r.block = !0, n < 0 && this.level--, r.level = this.level, n > 0 && this.level++, this.tokens.push(r), r;
  }, l_.prototype.isEmpty = function (e) {
    return this.bMarks[e] + this.tShift[e] >= this.eMarks[e];
  }, l_.prototype.skipEmptyLines = function (e) {
    for (var t = this.lineMax; e < t && !(this.bMarks[e] + this.tShift[e] < this.eMarks[e]); e++) {
      ;
    }

    return e;
  }, l_.prototype.skipSpaces = function (e) {
    for (var t, n = this.src.length; e < n && (t = this.src.charCodeAt(e), s_(t)); e++) {
      ;
    }

    return e;
  }, l_.prototype.skipSpacesBack = function (e, t) {
    if (e <= t) return e;

    for (; e > t;) {
      if (!s_(this.src.charCodeAt(--e))) return e + 1;
    }

    return e;
  }, l_.prototype.skipChars = function (e, t) {
    for (var n = this.src.length; e < n && this.src.charCodeAt(e) === t; e++) {
      ;
    }

    return e;
  }, l_.prototype.skipCharsBack = function (e, t, n) {
    if (e <= n) return e;

    for (; e > n;) {
      if (t !== this.src.charCodeAt(--e)) return e + 1;
    }

    return e;
  }, l_.prototype.getLines = function (e, t, n, r) {
    var o,
        i,
        a,
        s,
        l,
        c,
        u,
        d = e;
    if (e >= t) return "";

    for (c = new Array(t - e), o = 0; d < t; d++, o++) {
      for (i = 0, u = s = this.bMarks[d], l = d + 1 < t || r ? this.eMarks[d] + 1 : this.eMarks[d]; s < l && i < n;) {
        if (a = this.src.charCodeAt(s), s_(a)) 9 === a ? i += 4 - (i + this.bsCount[d]) % 4 : i++;else {
          if (!(s - u < this.tShift[d])) break;
          i++;
        }
        s++;
      }

      c[o] = i > n ? new Array(i - n + 1).join(" ") + this.src.slice(s, l) : this.src.slice(s, l);
    }

    return c.join("");
  }, l_.prototype.Token = a_;
  var c_ = l_,
      u_ = pE,
      d_ = [["table", function (e, t, n, r) {
    var o, i, a, s, l, c, u, d, f, p, h, m, g, y, b, v, x, w;
    if (t + 2 > n) return !1;
    if (c = t + 1, e.sCount[c] < e.blkIndent) return !1;
    if (e.sCount[c] - e.blkIndent >= 4) return !1;
    if ((a = e.bMarks[c] + e.tShift[c]) >= e.eMarks[c]) return !1;
    if (124 !== (x = e.src.charCodeAt(a++)) && 45 !== x && 58 !== x) return !1;
    if (a >= e.eMarks[c]) return !1;
    if (124 !== (w = e.src.charCodeAt(a++)) && 45 !== w && 58 !== w && !qE(w)) return !1;
    if (45 === x && qE(w)) return !1;

    for (; a < e.eMarks[c];) {
      if (124 !== (o = e.src.charCodeAt(a)) && 45 !== o && 58 !== o && !qE(o)) return !1;
      a++;
    }

    for (u = (i = UE(e, t + 1)).split("|"), p = [], s = 0; s < u.length; s++) {
      if (!(h = u[s].trim())) {
        if (0 === s || s === u.length - 1) continue;
        return !1;
      }

      if (!/^:?-+:?$/.test(h)) return !1;
      58 === h.charCodeAt(h.length - 1) ? p.push(58 === h.charCodeAt(0) ? "center" : "right") : 58 === h.charCodeAt(0) ? p.push("left") : p.push("");
    }

    if (-1 === (i = UE(e, t).trim()).indexOf("|")) return !1;
    if (e.sCount[t] - e.blkIndent >= 4) return !1;
    if ((u = VE(i)).length && "" === u[0] && u.shift(), u.length && "" === u[u.length - 1] && u.pop(), 0 === (d = u.length) || d !== p.length) return !1;
    if (r) return !0;

    for (y = e.parentType, e.parentType = "table", v = e.md.block.ruler.getRules("blockquote"), (f = e.push("table_open", "table", 1)).map = m = [t, 0], (f = e.push("thead_open", "thead", 1)).map = [t, t + 1], (f = e.push("tr_open", "tr", 1)).map = [t, t + 1], s = 0; s < u.length; s++) {
      f = e.push("th_open", "th", 1), p[s] && (f.attrs = [["style", "text-align:" + p[s]]]), (f = e.push("inline", "", 0)).content = u[s].trim(), f.children = [], f = e.push("th_close", "th", -1);
    }

    for (f = e.push("tr_close", "tr", -1), f = e.push("thead_close", "thead", -1), c = t + 2; c < n && !(e.sCount[c] < e.blkIndent); c++) {
      for (b = !1, s = 0, l = v.length; s < l; s++) {
        if (v[s](e, c, n, !0)) {
          b = !0;
          break;
        }
      }

      if (b) break;
      if (!(i = UE(e, c).trim())) break;
      if (e.sCount[c] - e.blkIndent >= 4) break;

      for ((u = VE(i)).length && "" === u[0] && u.shift(), u.length && "" === u[u.length - 1] && u.pop(), c === t + 2 && ((f = e.push("tbody_open", "tbody", 1)).map = g = [t + 2, 0]), (f = e.push("tr_open", "tr", 1)).map = [c, c + 1], s = 0; s < d; s++) {
        f = e.push("td_open", "td", 1), p[s] && (f.attrs = [["style", "text-align:" + p[s]]]), (f = e.push("inline", "", 0)).content = u[s] ? u[s].trim() : "", f.children = [], f = e.push("td_close", "td", -1);
      }

      f = e.push("tr_close", "tr", -1);
    }

    return g && (f = e.push("tbody_close", "tbody", -1), g[1] = c), f = e.push("table_close", "table", -1), m[1] = c, e.parentType = y, e.line = c, !0;
  }, ["paragraph", "reference"]], ["code", function (e, t, n) {
    var r, o, i;
    if (e.sCount[t] - e.blkIndent < 4) return !1;

    for (o = r = t + 1; r < n;) {
      if (e.isEmpty(r)) r++;else {
        if (!(e.sCount[r] - e.blkIndent >= 4)) break;
        o = ++r;
      }
    }

    return e.line = o, (i = e.push("code_block", "code", 0)).content = e.getLines(t, o, 4 + e.blkIndent, !1) + "\n", i.map = [t, e.line], !0;
  }], ["fence", function (e, t, n, r) {
    var o,
        i,
        a,
        s,
        l,
        c,
        u,
        d = !1,
        f = e.bMarks[t] + e.tShift[t],
        p = e.eMarks[t];
    if (e.sCount[t] - e.blkIndent >= 4) return !1;
    if (f + 3 > p) return !1;
    if (126 !== (o = e.src.charCodeAt(f)) && 96 !== o) return !1;
    if (l = f, (i = (f = e.skipChars(f, o)) - l) < 3) return !1;
    if (u = e.src.slice(l, f), a = e.src.slice(f, p), 96 === o && a.indexOf(String.fromCharCode(o)) >= 0) return !1;
    if (r) return !0;

    for (s = t; !(++s >= n) && !((f = l = e.bMarks[s] + e.tShift[s]) < (p = e.eMarks[s]) && e.sCount[s] < e.blkIndent);) {
      if (e.src.charCodeAt(f) === o && !(e.sCount[s] - e.blkIndent >= 4 || (f = e.skipChars(f, o)) - l < i || (f = e.skipSpaces(f)) < p)) {
        d = !0;
        break;
      }
    }

    return i = e.sCount[t], e.line = s + (d ? 1 : 0), (c = e.push("fence", "code", 0)).info = a, c.content = e.getLines(t + 1, s, i, !0), c.markup = u, c.map = [t, e.line], !0;
  }, ["paragraph", "reference", "blockquote", "list"]], ["blockquote", function (e, t, n, r) {
    var o,
        i,
        a,
        s,
        l,
        c,
        u,
        d,
        f,
        p,
        h,
        m,
        g,
        y,
        b,
        v,
        x,
        w,
        k,
        C,
        M = e.lineMax,
        j = e.bMarks[t] + e.tShift[t],
        E = e.eMarks[t];
    if (e.sCount[t] - e.blkIndent >= 4) return !1;
    if (62 !== e.src.charCodeAt(j++)) return !1;
    if (r) return !0;

    for (s = f = e.sCount[t] + 1, 32 === e.src.charCodeAt(j) ? (j++, s++, f++, o = !1, v = !0) : 9 === e.src.charCodeAt(j) ? (v = !0, (e.bsCount[t] + f) % 4 == 3 ? (j++, s++, f++, o = !1) : o = !0) : v = !1, p = [e.bMarks[t]], e.bMarks[t] = j; j < E && (i = e.src.charCodeAt(j), HE(i));) {
      9 === i ? f += 4 - (f + e.bsCount[t] + (o ? 1 : 0)) % 4 : f++, j++;
    }

    for (h = [e.bsCount[t]], e.bsCount[t] = e.sCount[t] + 1 + (v ? 1 : 0), c = j >= E, y = [e.sCount[t]], e.sCount[t] = f - s, b = [e.tShift[t]], e.tShift[t] = j - e.bMarks[t], w = e.md.block.ruler.getRules("blockquote"), g = e.parentType, e.parentType = "blockquote", d = t + 1; d < n && (C = e.sCount[d] < e.blkIndent, !((j = e.bMarks[d] + e.tShift[d]) >= (E = e.eMarks[d]))); d++) {
      if (62 !== e.src.charCodeAt(j++) || C) {
        if (c) break;

        for (x = !1, a = 0, l = w.length; a < l; a++) {
          if (w[a](e, d, n, !0)) {
            x = !0;
            break;
          }
        }

        if (x) {
          e.lineMax = d, 0 !== e.blkIndent && (p.push(e.bMarks[d]), h.push(e.bsCount[d]), b.push(e.tShift[d]), y.push(e.sCount[d]), e.sCount[d] -= e.blkIndent);
          break;
        }

        p.push(e.bMarks[d]), h.push(e.bsCount[d]), b.push(e.tShift[d]), y.push(e.sCount[d]), e.sCount[d] = -1;
      } else {
        for (s = f = e.sCount[d] + 1, 32 === e.src.charCodeAt(j) ? (j++, s++, f++, o = !1, v = !0) : 9 === e.src.charCodeAt(j) ? (v = !0, (e.bsCount[d] + f) % 4 == 3 ? (j++, s++, f++, o = !1) : o = !0) : v = !1, p.push(e.bMarks[d]), e.bMarks[d] = j; j < E && (i = e.src.charCodeAt(j), HE(i));) {
          9 === i ? f += 4 - (f + e.bsCount[d] + (o ? 1 : 0)) % 4 : f++, j++;
        }

        c = j >= E, h.push(e.bsCount[d]), e.bsCount[d] = e.sCount[d] + 1 + (v ? 1 : 0), y.push(e.sCount[d]), e.sCount[d] = f - s, b.push(e.tShift[d]), e.tShift[d] = j - e.bMarks[d];
      }
    }

    for (m = e.blkIndent, e.blkIndent = 0, (k = e.push("blockquote_open", "blockquote", 1)).markup = ">", k.map = u = [t, 0], e.md.block.tokenize(e, t, d), (k = e.push("blockquote_close", "blockquote", -1)).markup = ">", e.lineMax = M, e.parentType = g, u[1] = e.line, a = 0; a < b.length; a++) {
      e.bMarks[a + t] = p[a], e.tShift[a + t] = b[a], e.sCount[a + t] = y[a], e.bsCount[a + t] = h[a];
    }

    return e.blkIndent = m, !0;
  }, ["paragraph", "reference", "blockquote", "list"]], ["hr", function (e, t, n, r) {
    var o,
        i,
        a,
        s,
        l = e.bMarks[t] + e.tShift[t],
        c = e.eMarks[t];
    if (e.sCount[t] - e.blkIndent >= 4) return !1;
    if (42 !== (o = e.src.charCodeAt(l++)) && 45 !== o && 95 !== o) return !1;

    for (i = 1; l < c;) {
      if ((a = e.src.charCodeAt(l++)) !== o && !ZE(a)) return !1;
      a === o && i++;
    }

    return !(i < 3) && (r || (e.line = t + 1, (s = e.push("hr", "hr", 0)).map = [t, e.line], s.markup = Array(i + 1).join(String.fromCharCode(o))), !0);
  }, ["paragraph", "reference", "blockquote", "list"]], ["list", function (e, t, n, r) {
    var o,
        i,
        a,
        s,
        l,
        c,
        u,
        d,
        f,
        p,
        h,
        m,
        g,
        y,
        b,
        v,
        x,
        w,
        k,
        C,
        M,
        j,
        E,
        _,
        T,
        S,
        L,
        D,
        A = !1,
        N = !0;

    if (e.sCount[t] - e.blkIndent >= 4) return !1;
    if (e.listIndent >= 0 && e.sCount[t] - e.listIndent >= 4 && e.sCount[t] < e.blkIndent) return !1;

    if (r && "paragraph" === e.parentType && e.sCount[t] >= e.blkIndent && (A = !0), (E = GE(e, t)) >= 0) {
      if (u = !0, T = e.bMarks[t] + e.tShift[t], g = Number(e.src.slice(T, E - 1)), A && 1 !== g) return !1;
    } else {
      if (!((E = $E(e, t)) >= 0)) return !1;
      u = !1;
    }

    if (A && e.skipSpaces(E) >= e.eMarks[t]) return !1;
    if (m = e.src.charCodeAt(E - 1), r) return !0;

    for (h = e.tokens.length, u ? (D = e.push("ordered_list_open", "ol", 1), 1 !== g && (D.attrs = [["start", g]])) : D = e.push("bullet_list_open", "ul", 1), D.map = p = [t, 0], D.markup = String.fromCharCode(m), b = t, _ = !1, L = e.md.block.ruler.getRules("list"), w = e.parentType, e.parentType = "list"; b < n;) {
      for (j = E, y = e.eMarks[b], c = v = e.sCount[b] + E - (e.bMarks[t] + e.tShift[t]); j < y;) {
        if (9 === (o = e.src.charCodeAt(j))) v += 4 - (v + e.bsCount[b]) % 4;else {
          if (32 !== o) break;
          v++;
        }
        j++;
      }

      if ((l = (i = j) >= y ? 1 : v - c) > 4 && (l = 1), s = c + l, (D = e.push("list_item_open", "li", 1)).markup = String.fromCharCode(m), D.map = d = [t, 0], u && (D.info = e.src.slice(T, E - 1)), M = e.tight, C = e.tShift[t], k = e.sCount[t], x = e.listIndent, e.listIndent = e.blkIndent, e.blkIndent = s, e.tight = !0, e.tShift[t] = i - e.bMarks[t], e.sCount[t] = v, i >= y && e.isEmpty(t + 1) ? e.line = Math.min(e.line + 2, n) : e.md.block.tokenize(e, t, n, !0), e.tight && !_ || (N = !1), _ = e.line - t > 1 && e.isEmpty(e.line - 1), e.blkIndent = e.listIndent, e.listIndent = x, e.tShift[t] = C, e.sCount[t] = k, e.tight = M, (D = e.push("list_item_close", "li", -1)).markup = String.fromCharCode(m), b = t = e.line, d[1] = b, i = e.bMarks[t], b >= n) break;
      if (e.sCount[b] < e.blkIndent) break;
      if (e.sCount[t] - e.blkIndent >= 4) break;

      for (S = !1, a = 0, f = L.length; a < f; a++) {
        if (L[a](e, b, n, !0)) {
          S = !0;
          break;
        }
      }

      if (S) break;

      if (u) {
        if ((E = GE(e, b)) < 0) break;
        T = e.bMarks[b] + e.tShift[b];
      } else if ((E = $E(e, b)) < 0) break;

      if (m !== e.src.charCodeAt(E - 1)) break;
    }

    return (D = u ? e.push("ordered_list_close", "ol", -1) : e.push("bullet_list_close", "ul", -1)).markup = String.fromCharCode(m), p[1] = b, e.line = b, e.parentType = w, N && function (e, t) {
      var n,
          r,
          o = e.level + 2;

      for (n = t + 2, r = e.tokens.length - 2; n < r; n++) {
        e.tokens[n].level === o && "paragraph_open" === e.tokens[n].type && (e.tokens[n + 2].hidden = !0, e.tokens[n].hidden = !0, n += 2);
      }
    }(e, h), !0;
  }, ["paragraph", "reference", "blockquote"]], ["reference", function (e, t, n, r) {
    var o,
        i,
        a,
        s,
        l,
        c,
        u,
        d,
        f,
        p,
        h,
        m,
        g,
        y,
        b,
        v,
        x = 0,
        w = e.bMarks[t] + e.tShift[t],
        k = e.eMarks[t],
        C = t + 1;
    if (e.sCount[t] - e.blkIndent >= 4) return !1;
    if (91 !== e.src.charCodeAt(w)) return !1;

    for (; ++w < k;) {
      if (93 === e.src.charCodeAt(w) && 92 !== e.src.charCodeAt(w - 1)) {
        if (w + 1 === k) return !1;
        if (58 !== e.src.charCodeAt(w + 1)) return !1;
        break;
      }
    }

    for (s = e.lineMax, b = e.md.block.ruler.getRules("reference"), p = e.parentType, e.parentType = "reference"; C < s && !e.isEmpty(C); C++) {
      if (!(e.sCount[C] - e.blkIndent > 3 || e.sCount[C] < 0)) {
        for (y = !1, c = 0, u = b.length; c < u; c++) {
          if (b[c](e, C, s, !0)) {
            y = !0;
            break;
          }
        }

        if (y) break;
      }
    }

    for (k = (g = e.getLines(t, C, e.blkIndent, !1).trim()).length, w = 1; w < k; w++) {
      if (91 === (o = g.charCodeAt(w))) return !1;

      if (93 === o) {
        f = w;
        break;
      }

      (10 === o || 92 === o && ++w < k && 10 === g.charCodeAt(w)) && x++;
    }

    if (f < 0 || 58 !== g.charCodeAt(f + 1)) return !1;

    for (w = f + 2; w < k; w++) {
      if (10 === (o = g.charCodeAt(w))) x++;else if (!QE(o)) break;
    }

    if (!(h = e.md.helpers.parseLinkDestination(g, w, k)).ok) return !1;
    if (l = e.md.normalizeLink(h.str), !e.md.validateLink(l)) return !1;

    for (i = w = h.pos, a = x += h.lines, m = w; w < k; w++) {
      if (10 === (o = g.charCodeAt(w))) x++;else if (!QE(o)) break;
    }

    for (h = e.md.helpers.parseLinkTitle(g, w, k), w < k && m !== w && h.ok ? (v = h.str, w = h.pos, x += h.lines) : (v = "", w = i, x = a); w < k && (o = g.charCodeAt(w), QE(o));) {
      w++;
    }

    if (w < k && 10 !== g.charCodeAt(w) && v) for (v = "", w = i, x = a; w < k && (o = g.charCodeAt(w), QE(o));) {
      w++;
    }
    return !(w < k && 10 !== g.charCodeAt(w)) && !!(d = YE(g.slice(1, f))) && (r || (void 0 === e.env.references && (e.env.references = {}), void 0 === e.env.references[d] && (e.env.references[d] = {
      title: v,
      href: l
    }), e.parentType = p, e.line = t + x + 1), !0);
  }], ["html_block", function (e, t, n, r) {
    var o,
        i,
        a,
        s,
        l = e.bMarks[t] + e.tShift[t],
        c = e.eMarks[t];
    if (e.sCount[t] - e.blkIndent >= 4) return !1;
    if (!e.md.options.html) return !1;
    if (60 !== e.src.charCodeAt(l)) return !1;

    for (s = e.src.slice(l, c), o = 0; o < o_.length && !o_[o][0].test(s); o++) {
      ;
    }

    if (o === o_.length) return !1;
    if (r) return o_[o][2];
    if (i = t + 1, !o_[o][1].test(s)) for (; i < n && !(e.sCount[i] < e.blkIndent); i++) {
      if (l = e.bMarks[i] + e.tShift[i], c = e.eMarks[i], s = e.src.slice(l, c), o_[o][1].test(s)) {
        0 !== s.length && i++;
        break;
      }
    }
    return e.line = i, (a = e.push("html_block", "", 0)).map = [t, i], a.content = e.getLines(t, i, e.blkIndent, !0), !0;
  }, ["paragraph", "reference", "blockquote"]], ["heading", function (e, t, n, r) {
    var o,
        i,
        a,
        s,
        l = e.bMarks[t] + e.tShift[t],
        c = e.eMarks[t];
    if (e.sCount[t] - e.blkIndent >= 4) return !1;
    if (35 !== (o = e.src.charCodeAt(l)) || l >= c) return !1;

    for (i = 1, o = e.src.charCodeAt(++l); 35 === o && l < c && i <= 6;) {
      i++, o = e.src.charCodeAt(++l);
    }

    return !(i > 6 || l < c && !i_(o)) && (r || (c = e.skipSpacesBack(c, l), (a = e.skipCharsBack(c, 35, l)) > l && i_(e.src.charCodeAt(a - 1)) && (c = a), e.line = t + 1, (s = e.push("heading_open", "h" + String(i), 1)).markup = "########".slice(0, i), s.map = [t, e.line], (s = e.push("inline", "", 0)).content = e.src.slice(l, c).trim(), s.map = [t, e.line], s.children = [], (s = e.push("heading_close", "h" + String(i), -1)).markup = "########".slice(0, i)), !0);
  }, ["paragraph", "reference", "blockquote"]], ["lheading", function (e, t, n) {
    var r,
        o,
        i,
        a,
        s,
        l,
        c,
        u,
        d,
        f,
        p = t + 1,
        h = e.md.block.ruler.getRules("paragraph");
    if (e.sCount[t] - e.blkIndent >= 4) return !1;

    for (f = e.parentType, e.parentType = "paragraph"; p < n && !e.isEmpty(p); p++) {
      if (!(e.sCount[p] - e.blkIndent > 3)) {
        if (e.sCount[p] >= e.blkIndent && (l = e.bMarks[p] + e.tShift[p]) < (c = e.eMarks[p]) && (45 === (d = e.src.charCodeAt(l)) || 61 === d) && (l = e.skipChars(l, d), (l = e.skipSpaces(l)) >= c)) {
          u = 61 === d ? 1 : 2;
          break;
        }

        if (!(e.sCount[p] < 0)) {
          for (o = !1, i = 0, a = h.length; i < a; i++) {
            if (h[i](e, p, n, !0)) {
              o = !0;
              break;
            }
          }

          if (o) break;
        }
      }
    }

    return !!u && (r = e.getLines(t, p, e.blkIndent, !1).trim(), e.line = p + 1, (s = e.push("heading_open", "h" + String(u), 1)).markup = String.fromCharCode(d), s.map = [t, e.line], (s = e.push("inline", "", 0)).content = r, s.map = [t, e.line - 1], s.children = [], (s = e.push("heading_close", "h" + String(u), -1)).markup = String.fromCharCode(d), e.parentType = f, !0);
  }], ["paragraph", function (e, t) {
    var n,
        r,
        o,
        i,
        a,
        s,
        l = t + 1,
        c = e.md.block.ruler.getRules("paragraph"),
        u = e.lineMax;

    for (s = e.parentType, e.parentType = "paragraph"; l < u && !e.isEmpty(l); l++) {
      if (!(e.sCount[l] - e.blkIndent > 3 || e.sCount[l] < 0)) {
        for (r = !1, o = 0, i = c.length; o < i; o++) {
          if (c[o](e, l, u, !0)) {
            r = !0;
            break;
          }
        }

        if (r) break;
      }
    }

    return n = e.getLines(t, l, e.blkIndent, !1).trim(), e.line = l, (a = e.push("paragraph_open", "p", 1)).map = [t, e.line], (a = e.push("inline", "", 0)).content = n, a.map = [t, e.line], a.children = [], a = e.push("paragraph_close", "p", -1), e.parentType = s, !0;
  }]];

  function f_() {
    this.ruler = new u_();

    for (var e = 0; e < d_.length; e++) {
      this.ruler.push(d_[e][0], d_[e][1], {
        alt: (d_[e][2] || []).slice()
      });
    }
  }

  f_.prototype.tokenize = function (e, t, n) {
    for (var r, o = this.ruler.getRules(""), i = o.length, a = t, s = !1, l = e.md.options.maxNesting; a < n && (e.line = a = e.skipEmptyLines(a), !(a >= n)) && !(e.sCount[a] < e.blkIndent);) {
      if (e.level >= l) {
        e.line = n;
        break;
      }

      for (r = 0; r < i && !o[r](e, a, n, !1); r++) {
        ;
      }

      e.tight = !s, e.isEmpty(e.line - 1) && (s = !0), (a = e.line) < n && e.isEmpty(a) && (s = !0, a++, e.line = a);
    }
  }, f_.prototype.parse = function (e, t, n, r) {
    var o;
    e && (o = new this.State(e, t, n, r), this.tokenize(o, o.line, o.lineMax));
  }, f_.prototype.State = c_;
  var p_ = f_;

  function h_(e) {
    switch (e) {
      case 10:
      case 33:
      case 35:
      case 36:
      case 37:
      case 38:
      case 42:
      case 43:
      case 45:
      case 58:
      case 60:
      case 61:
      case 62:
      case 64:
      case 91:
      case 92:
      case 93:
      case 94:
      case 95:
      case 96:
      case 123:
      case 125:
      case 126:
        return !0;

      default:
        return !1;
    }
  }

  for (var m_ = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i, g_ = vj.isSpace, y_ = vj.isSpace, b_ = [], v_ = 0; v_ < 256; v_++) {
    b_.push(0);
  }

  "\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function (e) {
    b_[e.charCodeAt(0)] = 1;
  });
  var x_ = {};

  function w_(e, t) {
    var n,
        r,
        o,
        i,
        a,
        s = [],
        l = t.length;

    for (n = 0; n < l; n++) {
      126 === (o = t[n]).marker && -1 !== o.end && (i = t[o.end], (a = e.tokens[o.token]).type = "s_open", a.tag = "s", a.nesting = 1, a.markup = "~~", a.content = "", (a = e.tokens[i.token]).type = "s_close", a.tag = "s", a.nesting = -1, a.markup = "~~", a.content = "", "text" === e.tokens[i.token - 1].type && "~" === e.tokens[i.token - 1].content && s.push(i.token - 1));
    }

    for (; s.length;) {
      for (r = (n = s.pop()) + 1; r < e.tokens.length && "s_close" === e.tokens[r].type;) {
        r++;
      }

      n !== --r && (a = e.tokens[r], e.tokens[r] = e.tokens[n], e.tokens[n] = a);
    }
  }

  x_.tokenize = function (e, t) {
    var n,
        r,
        o,
        i,
        a = e.pos,
        s = e.src.charCodeAt(a);
    if (t) return !1;
    if (126 !== s) return !1;
    if (o = (r = e.scanDelims(e.pos, !0)).length, i = String.fromCharCode(s), o < 2) return !1;

    for (o % 2 && (e.push("text", "", 0).content = i, o--), n = 0; n < o; n += 2) {
      e.push("text", "", 0).content = i + i, e.delimiters.push({
        marker: s,
        length: 0,
        token: e.tokens.length - 1,
        end: -1,
        open: r.can_open,
        close: r.can_close
      });
    }

    return e.pos += r.length, !0;
  }, x_.postProcess = function (e) {
    var t,
        n = e.tokens_meta,
        r = e.tokens_meta.length;

    for (w_(e, e.delimiters), t = 0; t < r; t++) {
      n[t] && n[t].delimiters && w_(e, n[t].delimiters);
    }
  };
  var k_ = {};

  function C_(e, t) {
    var n, r, o, i, a, s;

    for (n = t.length - 1; n >= 0; n--) {
      95 !== (r = t[n]).marker && 42 !== r.marker || -1 !== r.end && (o = t[r.end], s = n > 0 && t[n - 1].end === r.end + 1 && t[n - 1].marker === r.marker && t[n - 1].token === r.token - 1 && t[r.end + 1].token === o.token + 1, a = String.fromCharCode(r.marker), (i = e.tokens[r.token]).type = s ? "strong_open" : "em_open", i.tag = s ? "strong" : "em", i.nesting = 1, i.markup = s ? a + a : a, i.content = "", (i = e.tokens[o.token]).type = s ? "strong_close" : "em_close", i.tag = s ? "strong" : "em", i.nesting = -1, i.markup = s ? a + a : a, i.content = "", s && (e.tokens[t[n - 1].token].content = "", e.tokens[t[r.end + 1].token].content = "", n--));
    }
  }

  k_.tokenize = function (e, t) {
    var n,
        r,
        o = e.pos,
        i = e.src.charCodeAt(o);
    if (t) return !1;
    if (95 !== i && 42 !== i) return !1;

    for (r = e.scanDelims(e.pos, 42 === i), n = 0; n < r.length; n++) {
      e.push("text", "", 0).content = String.fromCharCode(i), e.delimiters.push({
        marker: i,
        length: r.length,
        token: e.tokens.length - 1,
        end: -1,
        open: r.can_open,
        close: r.can_close
      });
    }

    return e.pos += r.length, !0;
  }, k_.postProcess = function (e) {
    var t,
        n = e.tokens_meta,
        r = e.tokens_meta.length;

    for (C_(e, e.delimiters), t = 0; t < r; t++) {
      n[t] && n[t].delimiters && C_(e, n[t].delimiters);
    }
  };
  var M_ = vj.normalizeReference,
      j_ = vj.isSpace,
      E_ = vj.normalizeReference,
      __ = vj.isSpace,
      T_ = /^([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/,
      S_ = /^([a-zA-Z][a-zA-Z0-9+.\-]{1,31}):([^<>\x00-\x20]*)$/,
      L_ = XE.HTML_TAG_RE;
  var D_ = xj.exports,
      A_ = vj.has,
      N_ = vj.isValidEntityCode,
      I_ = vj.fromCodePoint,
      z_ = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i,
      O_ = /^&([a-z][a-z0-9]{1,31});/i;

  function R_(e, t) {
    var n,
        r,
        o,
        i,
        a,
        s,
        l,
        c,
        u = {},
        d = t.length;

    if (d) {
      var f = 0,
          p = -2,
          h = [];

      for (n = 0; n < d; n++) {
        if (o = t[n], h.push(0), t[f].marker === o.marker && p === o.token - 1 || (f = n), p = o.token, o.length = o.length || 0, o.close) {
          for (u.hasOwnProperty(o.marker) || (u[o.marker] = [-1, -1, -1, -1, -1, -1]), a = u[o.marker][(o.open ? 3 : 0) + o.length % 3], s = r = f - h[f] - 1; r > a; r -= h[r] + 1) {
            if ((i = t[r]).marker === o.marker && i.open && i.end < 0 && (l = !1, (i.close || o.open) && (i.length + o.length) % 3 == 0 && (i.length % 3 == 0 && o.length % 3 == 0 || (l = !0)), !l)) {
              c = r > 0 && !t[r - 1].open ? h[r - 1] + 1 : 0, h[n] = n - r + c, h[r] = c, o.open = !1, i.end = n, i.close = !1, s = -1, p = -2;
              break;
            }
          }

          -1 !== s && (u[o.marker][(o.open ? 3 : 0) + (o.length || 0) % 3] = s);
        }
      }
    }
  }

  var P_ = NE,
      F_ = vj.isWhiteSpace,
      B_ = vj.isPunctChar,
      q_ = vj.isMdAsciiPunct;

  function U_(e, t, n, r) {
    this.src = e, this.env = n, this.md = t, this.tokens = r, this.tokens_meta = Array(r.length), this.pos = 0, this.posMax = this.src.length, this.level = 0, this.pending = "", this.pendingLevel = 0, this.cache = {}, this.delimiters = [], this._prev_delimiters = [], this.backticks = {}, this.backticksScanned = !1, this.linkLevel = 0;
  }

  U_.prototype.pushPending = function () {
    var e = new P_("text", "", 0);
    return e.content = this.pending, e.level = this.pendingLevel, this.tokens.push(e), this.pending = "", e;
  }, U_.prototype.push = function (e, t, n) {
    this.pending && this.pushPending();
    var r = new P_(e, t, n),
        o = null;
    return n < 0 && (this.level--, this.delimiters = this._prev_delimiters.pop()), r.level = this.level, n > 0 && (this.level++, this._prev_delimiters.push(this.delimiters), this.delimiters = [], o = {
      delimiters: this.delimiters
    }), this.pendingLevel = this.level, this.tokens.push(r), this.tokens_meta.push(o), r;
  }, U_.prototype.scanDelims = function (e, t) {
    var n,
        r,
        o,
        i,
        a,
        s,
        l,
        c,
        u,
        d = e,
        f = !0,
        p = !0,
        h = this.posMax,
        m = this.src.charCodeAt(e);

    for (n = e > 0 ? this.src.charCodeAt(e - 1) : 32; d < h && this.src.charCodeAt(d) === m;) {
      d++;
    }

    return o = d - e, r = d < h ? this.src.charCodeAt(d) : 32, l = q_(n) || B_(String.fromCharCode(n)), u = q_(r) || B_(String.fromCharCode(r)), s = F_(n), (c = F_(r)) ? f = !1 : u && (s || l || (f = !1)), s ? p = !1 : l && (c || u || (p = !1)), t ? (i = f, a = p) : (i = f && (!p || l), a = p && (!f || u)), {
      can_open: i,
      can_close: a,
      length: o
    };
  }, U_.prototype.Token = P_;
  var V_ = U_,
      H_ = pE,
      Z_ = [["text", function (e, t) {
    for (var n = e.pos; n < e.posMax && !h_(e.src.charCodeAt(n));) {
      n++;
    }

    return n !== e.pos && (t || (e.pending += e.src.slice(e.pos, n)), e.pos = n, !0);
  }], ["linkify", function (e, t) {
    var n, r, o, i, a, s, l;
    return !!e.md.options.linkify && !(e.linkLevel > 0) && !((n = e.pos) + 3 > e.posMax) && 58 === e.src.charCodeAt(n) && 47 === e.src.charCodeAt(n + 1) && 47 === e.src.charCodeAt(n + 2) && !!(r = e.pending.match(m_)) && (o = r[1], !!(i = e.md.linkify.matchAtStart(e.src.slice(n - o.length))) && (a = (a = i.url).replace(/\*+$/, ""), s = e.md.normalizeLink(a), !!e.md.validateLink(s) && (t || (e.pending = e.pending.slice(0, -o.length), (l = e.push("link_open", "a", 1)).attrs = [["href", s]], l.markup = "linkify", l.info = "auto", (l = e.push("text", "", 0)).content = e.md.normalizeLinkText(a), (l = e.push("link_close", "a", -1)).markup = "linkify", l.info = "auto"), e.pos += a.length - o.length, !0)));
  }], ["newline", function (e, t) {
    var n,
        r,
        o,
        i = e.pos;
    if (10 !== e.src.charCodeAt(i)) return !1;
    if (n = e.pending.length - 1, r = e.posMax, !t) if (n >= 0 && 32 === e.pending.charCodeAt(n)) {
      if (n >= 1 && 32 === e.pending.charCodeAt(n - 1)) {
        for (o = n - 1; o >= 1 && 32 === e.pending.charCodeAt(o - 1);) {
          o--;
        }

        e.pending = e.pending.slice(0, o), e.push("hardbreak", "br", 0);
      } else e.pending = e.pending.slice(0, -1), e.push("softbreak", "br", 0);
    } else e.push("softbreak", "br", 0);

    for (i++; i < r && g_(e.src.charCodeAt(i));) {
      i++;
    }

    return e.pos = i, !0;
  }], ["escape", function (e, t) {
    var n,
        r,
        o,
        i,
        a,
        s = e.pos,
        l = e.posMax;
    if (92 !== e.src.charCodeAt(s)) return !1;
    if (++s >= l) return !1;

    if (10 === (n = e.src.charCodeAt(s))) {
      for (t || e.push("hardbreak", "br", 0), s++; s < l && (n = e.src.charCodeAt(s), y_(n));) {
        s++;
      }

      return e.pos = s, !0;
    }

    return i = e.src[s], n >= 55296 && n <= 56319 && s + 1 < l && (r = e.src.charCodeAt(s + 1)) >= 56320 && r <= 57343 && (i += e.src[s + 1], s++), o = "\\" + i, t || (a = e.push("text_special", "", 0), n < 256 && 0 !== b_[n] ? a.content = i : a.content = o, a.markup = o, a.info = "escape"), e.pos = s + 1, !0;
  }], ["backticks", function (e, t) {
    var n,
        r,
        o,
        i,
        a,
        s,
        l,
        c,
        u = e.pos;
    if (96 !== e.src.charCodeAt(u)) return !1;

    for (n = u, u++, r = e.posMax; u < r && 96 === e.src.charCodeAt(u);) {
      u++;
    }

    if (l = (o = e.src.slice(n, u)).length, e.backticksScanned && (e.backticks[l] || 0) <= n) return t || (e.pending += o), e.pos += l, !0;

    for (a = s = u; -1 !== (a = e.src.indexOf("`", s));) {
      for (s = a + 1; s < r && 96 === e.src.charCodeAt(s);) {
        s++;
      }

      if ((c = s - a) === l) return t || ((i = e.push("code_inline", "code", 0)).markup = o, i.content = e.src.slice(u, a).replace(/\n/g, " ").replace(/^ (.+) $/, "$1")), e.pos = s, !0;
      e.backticks[c] = a;
    }

    return e.backticksScanned = !0, t || (e.pending += o), e.pos += l, !0;
  }], ["strikethrough", x_.tokenize], ["emphasis", k_.tokenize], ["link", function (e, t) {
    var n,
        r,
        o,
        i,
        a,
        s,
        l,
        c,
        u = "",
        d = "",
        f = e.pos,
        p = e.posMax,
        h = e.pos,
        m = !0;
    if (91 !== e.src.charCodeAt(e.pos)) return !1;
    if (a = e.pos + 1, (i = e.md.helpers.parseLinkLabel(e, e.pos, !0)) < 0) return !1;

    if ((s = i + 1) < p && 40 === e.src.charCodeAt(s)) {
      for (m = !1, s++; s < p && (r = e.src.charCodeAt(s), j_(r) || 10 === r); s++) {
        ;
      }

      if (s >= p) return !1;

      if (h = s, (l = e.md.helpers.parseLinkDestination(e.src, s, e.posMax)).ok) {
        for (u = e.md.normalizeLink(l.str), e.md.validateLink(u) ? s = l.pos : u = "", h = s; s < p && (r = e.src.charCodeAt(s), j_(r) || 10 === r); s++) {
          ;
        }

        if (l = e.md.helpers.parseLinkTitle(e.src, s, e.posMax), s < p && h !== s && l.ok) for (d = l.str, s = l.pos; s < p && (r = e.src.charCodeAt(s), j_(r) || 10 === r); s++) {
          ;
        }
      }

      (s >= p || 41 !== e.src.charCodeAt(s)) && (m = !0), s++;
    }

    if (m) {
      if (void 0 === e.env.references) return !1;
      if (s < p && 91 === e.src.charCodeAt(s) ? (h = s + 1, (s = e.md.helpers.parseLinkLabel(e, s)) >= 0 ? o = e.src.slice(h, s++) : s = i + 1) : s = i + 1, o || (o = e.src.slice(a, i)), !(c = e.env.references[M_(o)])) return e.pos = f, !1;
      u = c.href, d = c.title;
    }

    return t || (e.pos = a, e.posMax = i, e.push("link_open", "a", 1).attrs = n = [["href", u]], d && n.push(["title", d]), e.linkLevel++, e.md.inline.tokenize(e), e.linkLevel--, e.push("link_close", "a", -1)), e.pos = s, e.posMax = p, !0;
  }], ["image", function (e, t) {
    var n,
        r,
        o,
        i,
        a,
        s,
        l,
        c,
        u,
        d,
        f,
        p,
        h,
        m = "",
        g = e.pos,
        y = e.posMax;
    if (33 !== e.src.charCodeAt(e.pos)) return !1;
    if (91 !== e.src.charCodeAt(e.pos + 1)) return !1;
    if (s = e.pos + 2, (a = e.md.helpers.parseLinkLabel(e, e.pos + 1, !1)) < 0) return !1;

    if ((l = a + 1) < y && 40 === e.src.charCodeAt(l)) {
      for (l++; l < y && (r = e.src.charCodeAt(l), __(r) || 10 === r); l++) {
        ;
      }

      if (l >= y) return !1;

      for (h = l, (u = e.md.helpers.parseLinkDestination(e.src, l, e.posMax)).ok && (m = e.md.normalizeLink(u.str), e.md.validateLink(m) ? l = u.pos : m = ""), h = l; l < y && (r = e.src.charCodeAt(l), __(r) || 10 === r); l++) {
        ;
      }

      if (u = e.md.helpers.parseLinkTitle(e.src, l, e.posMax), l < y && h !== l && u.ok) for (d = u.str, l = u.pos; l < y && (r = e.src.charCodeAt(l), __(r) || 10 === r); l++) {
        ;
      } else d = "";
      if (l >= y || 41 !== e.src.charCodeAt(l)) return e.pos = g, !1;
      l++;
    } else {
      if (void 0 === e.env.references) return !1;
      if (l < y && 91 === e.src.charCodeAt(l) ? (h = l + 1, (l = e.md.helpers.parseLinkLabel(e, l)) >= 0 ? i = e.src.slice(h, l++) : l = a + 1) : l = a + 1, i || (i = e.src.slice(s, a)), !(c = e.env.references[E_(i)])) return e.pos = g, !1;
      m = c.href, d = c.title;
    }

    return t || (o = e.src.slice(s, a), e.md.inline.parse(o, e.md, e.env, p = []), (f = e.push("image", "img", 0)).attrs = n = [["src", m], ["alt", ""]], f.children = p, f.content = o, d && n.push(["title", d])), e.pos = l, e.posMax = y, !0;
  }], ["autolink", function (e, t) {
    var n,
        r,
        o,
        i,
        a,
        s,
        l = e.pos;
    if (60 !== e.src.charCodeAt(l)) return !1;

    for (a = e.pos, s = e.posMax;;) {
      if (++l >= s) return !1;
      if (60 === (i = e.src.charCodeAt(l))) return !1;
      if (62 === i) break;
    }

    return n = e.src.slice(a + 1, l), S_.test(n) ? (r = e.md.normalizeLink(n), !!e.md.validateLink(r) && (t || ((o = e.push("link_open", "a", 1)).attrs = [["href", r]], o.markup = "autolink", o.info = "auto", (o = e.push("text", "", 0)).content = e.md.normalizeLinkText(n), (o = e.push("link_close", "a", -1)).markup = "autolink", o.info = "auto"), e.pos += n.length + 2, !0)) : !!T_.test(n) && (r = e.md.normalizeLink("mailto:" + n), !!e.md.validateLink(r) && (t || ((o = e.push("link_open", "a", 1)).attrs = [["href", r]], o.markup = "autolink", o.info = "auto", (o = e.push("text", "", 0)).content = e.md.normalizeLinkText(n), (o = e.push("link_close", "a", -1)).markup = "autolink", o.info = "auto"), e.pos += n.length + 2, !0));
  }], ["html_inline", function (e, t) {
    var n,
        r,
        o,
        i,
        a,
        s = e.pos;
    return !!e.md.options.html && (o = e.posMax, !(60 !== e.src.charCodeAt(s) || s + 2 >= o) && !(33 !== (n = e.src.charCodeAt(s + 1)) && 63 !== n && 47 !== n && !function (e) {
      var t = 32 | e;
      return t >= 97 && t <= 122;
    }(n)) && !!(r = e.src.slice(s).match(L_)) && (t || ((i = e.push("html_inline", "", 0)).content = e.src.slice(s, s + r[0].length), a = i.content, /^<a[>\s]/i.test(a) && e.linkLevel++, function (e) {
      return /^<\/a\s*>/i.test(e);
    }(i.content) && e.linkLevel--), e.pos += r[0].length, !0));
  }], ["entity", function (e, t) {
    var n,
        r,
        o,
        i = e.pos,
        a = e.posMax;
    if (38 !== e.src.charCodeAt(i)) return !1;
    if (i + 1 >= a) return !1;

    if (35 === e.src.charCodeAt(i + 1)) {
      if (r = e.src.slice(i).match(z_)) return t || (n = "x" === r[1][0].toLowerCase() ? parseInt(r[1].slice(1), 16) : parseInt(r[1], 10), (o = e.push("text_special", "", 0)).content = N_(n) ? I_(n) : I_(65533), o.markup = r[0], o.info = "entity"), e.pos += r[0].length, !0;
    } else if ((r = e.src.slice(i).match(O_)) && A_(D_, r[1])) return t || ((o = e.push("text_special", "", 0)).content = D_[r[1]], o.markup = r[0], o.info = "entity"), e.pos += r[0].length, !0;

    return !1;
  }]],
      W_ = [["balance_pairs", function (e) {
    var t,
        n = e.tokens_meta,
        r = e.tokens_meta.length;

    for (R_(0, e.delimiters), t = 0; t < r; t++) {
      n[t] && n[t].delimiters && R_(0, n[t].delimiters);
    }
  }], ["strikethrough", x_.postProcess], ["emphasis", k_.postProcess], ["fragments_join", function (e) {
    var t,
        n,
        r = 0,
        o = e.tokens,
        i = e.tokens.length;

    for (t = n = 0; t < i; t++) {
      o[t].nesting < 0 && r--, o[t].level = r, o[t].nesting > 0 && r++, "text" === o[t].type && t + 1 < i && "text" === o[t + 1].type ? o[t + 1].content = o[t].content + o[t + 1].content : (t !== n && (o[n] = o[t]), n++);
    }

    t !== n && (o.length = n);
  }]];

  function $_() {
    var e;

    for (this.ruler = new H_(), e = 0; e < Z_.length; e++) {
      this.ruler.push(Z_[e][0], Z_[e][1]);
    }

    for (this.ruler2 = new H_(), e = 0; e < W_.length; e++) {
      this.ruler2.push(W_[e][0], W_[e][1]);
    }
  }

  $_.prototype.skipToken = function (e) {
    var t,
        n,
        r = e.pos,
        o = this.ruler.getRules(""),
        i = o.length,
        a = e.md.options.maxNesting,
        s = e.cache;

    if (void 0 === s[r]) {
      if (e.level < a) for (n = 0; n < i && (e.level++, t = o[n](e, !0), e.level--, !t); n++) {
        ;
      } else e.pos = e.posMax;
      t || e.pos++, s[r] = e.pos;
    } else e.pos = s[r];
  }, $_.prototype.tokenize = function (e) {
    for (var t, n, r = this.ruler.getRules(""), o = r.length, i = e.posMax, a = e.md.options.maxNesting; e.pos < i;) {
      if (e.level < a) for (n = 0; n < o && !(t = r[n](e, !1)); n++) {
        ;
      }

      if (t) {
        if (e.pos >= i) break;
      } else e.pending += e.src[e.pos++];
    }

    e.pending && e.pushPending();
  }, $_.prototype.parse = function (e, t, n, r) {
    var o,
        i,
        a,
        s = new this.State(e, t, n, r);

    for (this.tokenize(s), a = (i = this.ruler2.getRules("")).length, o = 0; o < a; o++) {
      i[o](s);
    }
  }, $_.prototype.State = V_;
  var G_,
      Y_,
      Q_ = $_;

  function X_() {
    return Y_ ? G_ : (Y_ = 1, G_ = function G_(e) {
      var t = {};
      e = e || {}, t.src_Any = Jj().source, t.src_Cc = eE().source, t.src_Z = tE().source, t.src_P = kj.source, t.src_ZPCc = [t.src_Z, t.src_P, t.src_Cc].join("|"), t.src_ZCc = [t.src_Z, t.src_Cc].join("|");
      return t.src_pseudo_letter = "(?:(?![><｜]|" + t.src_ZPCc + ")" + t.src_Any + ")", t.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)", t.src_auth = "(?:(?:(?!" + t.src_ZCc + "|[@/\\[\\]()]).)+@)?", t.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?", t.src_host_terminator = "(?=$|[><｜]|" + t.src_ZPCc + ")(?!" + (e["---"] ? "-(?!--)|" : "-|") + "_|:\\d|\\.-|\\.(?!$|" + t.src_ZPCc + "))", t.src_path = "(?:[/?#](?:(?!" + t.src_ZCc + "|" + "[><｜]|[()[\\]{}.,\"'?!\\-;]).|\\[(?:(?!" + t.src_ZCc + "|\\]).)*\\]|\\((?:(?!" + t.src_ZCc + "|[)]).)*\\)|\\{(?:(?!" + t.src_ZCc + '|[}]).)*\\}|\\"(?:(?!' + t.src_ZCc + '|["]).)+\\"|\\\'(?:(?!' + t.src_ZCc + "|[']).)+\\'|\\'(?=" + t.src_pseudo_letter + "|[-])|\\.{2,}[a-zA-Z0-9%/&]|\\.(?!" + t.src_ZCc + "|[.]|$)|" + (e["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" : "\\-+|") + ",(?!" + t.src_ZCc + "|$)|;(?!" + t.src_ZCc + "|$)|\\!+(?!" + t.src_ZCc + "|[!]|$)|\\?(?!" + t.src_ZCc + "|[?]|$))+|\\/)?", t.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*', t.src_xn = "xn--[a-z0-9\\-]{1,59}", t.src_domain_root = "(?:" + t.src_xn + "|" + t.src_pseudo_letter + "{1,63})", t.src_domain = "(?:" + t.src_xn + "|(?:" + t.src_pseudo_letter + ")|(?:" + t.src_pseudo_letter + "(?:-|" + t.src_pseudo_letter + "){0,61}" + t.src_pseudo_letter + "))", t.src_host = "(?:(?:(?:(?:" + t.src_domain + ")\\.)*" + t.src_domain + "))", t.tpl_host_fuzzy = "(?:" + t.src_ip4 + "|(?:(?:(?:" + t.src_domain + ")\\.)+(?:%TLDS%)))", t.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + t.src_domain + ")\\.)+(?:%TLDS%))", t.src_host_strict = t.src_host + t.src_host_terminator, t.tpl_host_fuzzy_strict = t.tpl_host_fuzzy + t.src_host_terminator, t.src_host_port_strict = t.src_host + t.src_port + t.src_host_terminator, t.tpl_host_port_fuzzy_strict = t.tpl_host_fuzzy + t.src_port + t.src_host_terminator, t.tpl_host_port_no_ip_fuzzy_strict = t.tpl_host_no_ip_fuzzy + t.src_port + t.src_host_terminator, t.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + t.src_ZPCc + "|>|$))", t.tpl_email_fuzzy = '(^|[><｜]|"|\\(|' + t.src_ZCc + ")(" + t.src_email_name + "@" + t.tpl_host_fuzzy_strict + ")", t.tpl_link_fuzzy = "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + t.src_ZPCc + "))((?![$+<=>^`|｜])" + t.tpl_host_port_fuzzy_strict + t.src_path + ")", t.tpl_link_no_ip_fuzzy = "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + t.src_ZPCc + "))((?![$+<=>^`|｜])" + t.tpl_host_port_no_ip_fuzzy_strict + t.src_path + ")", t;
    });
  }

  function K_(e) {
    var t = Array.prototype.slice.call(arguments, 1);
    return t.forEach(function (t) {
      t && Object.keys(t).forEach(function (n) {
        e[n] = t[n];
      });
    }), e;
  }

  function J_(e) {
    return Object.prototype.toString.call(e);
  }

  function eT(e) {
    return "[object Function]" === J_(e);
  }

  function tT(e) {
    return e.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
  }

  var nT = {
    fuzzyLink: !0,
    fuzzyEmail: !0,
    fuzzyIP: !1
  };
  var rT = {
    "http:": {
      validate: function validate(e, t, n) {
        var r = e.slice(t);
        return n.re.http || (n.re.http = new RegExp("^\\/\\/" + n.re.src_auth + n.re.src_host_port_strict + n.re.src_path, "i")), n.re.http.test(r) ? r.match(n.re.http)[0].length : 0;
      }
    },
    "https:": "http:",
    "ftp:": "http:",
    "//": {
      validate: function validate(e, t, n) {
        var r = e.slice(t);
        return n.re.no_http || (n.re.no_http = new RegExp("^" + n.re.src_auth + "(?:localhost|(?:(?:" + n.re.src_domain + ")\\.)+" + n.re.src_domain_root + ")" + n.re.src_port + n.re.src_host_terminator + n.re.src_path, "i")), n.re.no_http.test(r) ? t >= 3 && ":" === e[t - 3] || t >= 3 && "/" === e[t - 3] ? 0 : r.match(n.re.no_http)[0].length : 0;
      }
    },
    "mailto:": {
      validate: function validate(e, t, n) {
        var r = e.slice(t);
        return n.re.mailto || (n.re.mailto = new RegExp("^" + n.re.src_email_name + "@" + n.re.src_host_strict, "i")), n.re.mailto.test(r) ? r.match(n.re.mailto)[0].length : 0;
      }
    }
  },
      oT = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф".split("|");

  function iT(e) {
    var t = e.re = X_()(e.__opts__),
        n = e.__tlds__.slice();

    function r(e) {
      return e.replace("%TLDS%", t.src_tlds);
    }

    e.onCompile(), e.__tlds_replaced__ || n.push("a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]"), n.push(t.src_xn), t.src_tlds = n.join("|"), t.email_fuzzy = RegExp(r(t.tpl_email_fuzzy), "i"), t.link_fuzzy = RegExp(r(t.tpl_link_fuzzy), "i"), t.link_no_ip_fuzzy = RegExp(r(t.tpl_link_no_ip_fuzzy), "i"), t.host_fuzzy_test = RegExp(r(t.tpl_host_fuzzy_test), "i");
    var o = [];

    function i(e, t) {
      throw new Error('(LinkifyIt) Invalid schema "' + e + '": ' + t);
    }

    e.__compiled__ = {}, Object.keys(e.__schemas__).forEach(function (t) {
      var n = e.__schemas__[t];

      if (null !== n) {
        var r = {
          validate: null,
          link: null
        };
        if (e.__compiled__[t] = r, "[object Object]" === J_(n)) return !function (e) {
          return "[object RegExp]" === J_(e);
        }(n.validate) ? eT(n.validate) ? r.validate = n.validate : i(t, n) : r.validate = function (e) {
          return function (t, n) {
            var r = t.slice(n);
            return e.test(r) ? r.match(e)[0].length : 0;
          };
        }(n.validate), void (eT(n.normalize) ? r.normalize = n.normalize : n.normalize ? i(t, n) : r.normalize = function (e, t) {
          t.normalize(e);
        });
        !function (e) {
          return "[object String]" === J_(e);
        }(n) ? i(t, n) : o.push(t);
      }
    }), o.forEach(function (t) {
      e.__compiled__[e.__schemas__[t]] && (e.__compiled__[t].validate = e.__compiled__[e.__schemas__[t]].validate, e.__compiled__[t].normalize = e.__compiled__[e.__schemas__[t]].normalize);
    }), e.__compiled__[""] = {
      validate: null,
      normalize: function normalize(e, t) {
        t.normalize(e);
      }
    };
    var a = Object.keys(e.__compiled__).filter(function (t) {
      return t.length > 0 && e.__compiled__[t];
    }).map(tT).join("|");
    e.re.schema_test = RegExp("(^|(?!_)(?:[><｜]|" + t.src_ZPCc + "))(" + a + ")", "i"), e.re.schema_search = RegExp("(^|(?!_)(?:[><｜]|" + t.src_ZPCc + "))(" + a + ")", "ig"), e.re.schema_at_start = RegExp("^" + e.re.schema_search.source, "i"), e.re.pretest = RegExp("(" + e.re.schema_test.source + ")|(" + e.re.host_fuzzy_test.source + ")|@", "i"), function (e) {
      e.__index__ = -1, e.__text_cache__ = "";
    }(e);
  }

  function aT(e, t) {
    var n = e.__index__,
        r = e.__last_index__,
        o = e.__text_cache__.slice(n, r);

    this.schema = e.__schema__.toLowerCase(), this.index = n + t, this.lastIndex = r + t, this.raw = o, this.text = o, this.url = o;
  }

  function sT(e, t) {
    var n = new aT(e, t);
    return e.__compiled__[n.schema].normalize(n, e), n;
  }

  function lT(e, t) {
    if (!(this instanceof lT)) return new lT(e, t);
    var n;
    t || (n = e, Object.keys(n || {}).reduce(function (e, t) {
      return e || nT.hasOwnProperty(t);
    }, !1) && (t = e, e = {})), this.__opts__ = K_({}, nT, t), this.__index__ = -1, this.__last_index__ = -1, this.__schema__ = "", this.__text_cache__ = "", this.__schemas__ = K_({}, rT, e), this.__compiled__ = {}, this.__tlds__ = oT, this.__tlds_replaced__ = !1, this.re = {}, iT(this);
  }

  lT.prototype.add = function (e, t) {
    return this.__schemas__[e] = t, iT(this), this;
  }, lT.prototype.set = function (e) {
    return this.__opts__ = K_(this.__opts__, e), this;
  }, lT.prototype.test = function (e) {
    if (this.__text_cache__ = e, this.__index__ = -1, !e.length) return !1;
    var t, n, r, o, i, a, s, l;
    if (this.re.schema_test.test(e)) for ((s = this.re.schema_search).lastIndex = 0; null !== (t = s.exec(e));) {
      if (o = this.testSchemaAt(e, t[2], s.lastIndex)) {
        this.__schema__ = t[2], this.__index__ = t.index + t[1].length, this.__last_index__ = t.index + t[0].length + o;
        break;
      }
    }
    return this.__opts__.fuzzyLink && this.__compiled__["http:"] && (l = e.search(this.re.host_fuzzy_test)) >= 0 && (this.__index__ < 0 || l < this.__index__) && null !== (n = e.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) && (i = n.index + n[1].length, (this.__index__ < 0 || i < this.__index__) && (this.__schema__ = "", this.__index__ = i, this.__last_index__ = n.index + n[0].length)), this.__opts__.fuzzyEmail && this.__compiled__["mailto:"] && e.indexOf("@") >= 0 && null !== (r = e.match(this.re.email_fuzzy)) && (i = r.index + r[1].length, a = r.index + r[0].length, (this.__index__ < 0 || i < this.__index__ || i === this.__index__ && a > this.__last_index__) && (this.__schema__ = "mailto:", this.__index__ = i, this.__last_index__ = a)), this.__index__ >= 0;
  }, lT.prototype.pretest = function (e) {
    return this.re.pretest.test(e);
  }, lT.prototype.testSchemaAt = function (e, t, n) {
    return this.__compiled__[t.toLowerCase()] ? this.__compiled__[t.toLowerCase()].validate(e, n, this) : 0;
  }, lT.prototype.match = function (e) {
    var t = 0,
        n = [];
    this.__index__ >= 0 && this.__text_cache__ === e && (n.push(sT(this, t)), t = this.__last_index__);

    for (var r = t ? e.slice(t) : e; this.test(r);) {
      n.push(sT(this, t)), r = r.slice(this.__last_index__), t += this.__last_index__;
    }

    return n.length ? n : null;
  }, lT.prototype.matchAtStart = function (e) {
    if (this.__text_cache__ = e, this.__index__ = -1, !e.length) return null;
    var t = this.re.schema_at_start.exec(e);
    if (!t) return null;
    var n = this.testSchemaAt(e, t[2], t[0].length);
    return n ? (this.__schema__ = t[2], this.__index__ = t.index + t[1].length, this.__last_index__ = t.index + t[0].length + n, sT(this, 0)) : null;
  }, lT.prototype.tlds = function (e, t) {
    return e = Array.isArray(e) ? e : [e], t ? (this.__tlds__ = this.__tlds__.concat(e).sort().filter(function (e, t, n) {
      return e !== n[t - 1];
    }).reverse(), iT(this), this) : (this.__tlds__ = e.slice(), this.__tlds_replaced__ = !0, iT(this), this);
  }, lT.prototype.normalize = function (e) {
    e.schema || (e.url = "http://" + e.url), "mailto:" !== e.schema || /^mailto:/i.test(e.url) || (e.url = "mailto:" + e.url);
  }, lT.prototype.onCompile = function () {};
  var cT = vj,
      uT = rE,
      dT = dE,
      fT = BE,
      pT = p_,
      hT = Q_,
      mT = lT,
      gT = Cj,
      yT = B["default"],
      bT = {
    "default": {
      options: {
        html: !1,
        xhtmlOut: !1,
        breaks: !1,
        langPrefix: "language-",
        linkify: !1,
        typographer: !1,
        quotes: "“”‘’",
        highlight: null,
        maxNesting: 100
      },
      components: {
        core: {},
        block: {},
        inline: {}
      }
    },
    zero: {
      options: {
        html: !1,
        xhtmlOut: !1,
        breaks: !1,
        langPrefix: "language-",
        linkify: !1,
        typographer: !1,
        quotes: "“”‘’",
        highlight: null,
        maxNesting: 20
      },
      components: {
        core: {
          rules: ["normalize", "block", "inline", "text_join"]
        },
        block: {
          rules: ["paragraph"]
        },
        inline: {
          rules: ["text"],
          rules2: ["balance_pairs", "fragments_join"]
        }
      }
    },
    commonmark: {
      options: {
        html: !0,
        xhtmlOut: !0,
        breaks: !1,
        langPrefix: "language-",
        linkify: !1,
        typographer: !1,
        quotes: "“”‘’",
        highlight: null,
        maxNesting: 20
      },
      components: {
        core: {
          rules: ["normalize", "block", "inline", "text_join"]
        },
        block: {
          rules: ["blockquote", "code", "fence", "heading", "hr", "html_block", "lheading", "list", "reference", "paragraph"]
        },
        inline: {
          rules: ["autolink", "backticks", "emphasis", "entity", "escape", "html_inline", "image", "link", "newline", "text"],
          rules2: ["balance_pairs", "emphasis", "fragments_join"]
        }
      }
    }
  },
      vT = /^(vbscript|javascript|file|data):/,
      xT = /^data:image\/(gif|png|jpeg|webp);/;

  function wT(e) {
    var t = e.trim().toLowerCase();
    return !vT.test(t) || !!xT.test(t);
  }

  var kT = ["http:", "https:", "mailto:"];

  function CT(e) {
    var t = gT.parse(e, !0);
    if (t.hostname && (!t.protocol || kT.indexOf(t.protocol) >= 0)) try {
      t.hostname = yT.toASCII(t.hostname);
    } catch (e) {}
    return gT.encode(gT.format(t));
  }

  function MT(e) {
    var t = gT.parse(e, !0);
    if (t.hostname && (!t.protocol || kT.indexOf(t.protocol) >= 0)) try {
      t.hostname = yT.toUnicode(t.hostname);
    } catch (e) {}
    return gT.decode(gT.format(t), gT.decode.defaultChars + "%");
  }

  function jT(e, t) {
    if (!(this instanceof jT)) return new jT(e, t);
    t || cT.isString(e) || (t = e || {}, e = "default"), this.inline = new hT(), this.block = new pT(), this.core = new fT(), this.renderer = new dT(), this.linkify = new mT(), this.validateLink = wT, this.normalizeLink = CT, this.normalizeLinkText = MT, this.utils = cT, this.helpers = cT.assign({}, uT), this.options = {}, this.configure(e), t && this.set(t);
  }

  jT.prototype.set = function (e) {
    return cT.assign(this.options, e), this;
  }, jT.prototype.configure = function (e) {
    var t,
        n = this;
    if (cT.isString(e) && !(e = bT[t = e])) throw new Error('Wrong `markdown-it` preset "' + t + '", check name');
    if (!e) throw new Error("Wrong `markdown-it` preset, can't be empty");
    return e.options && n.set(e.options), e.components && Object.keys(e.components).forEach(function (t) {
      e.components[t].rules && n[t].ruler.enableOnly(e.components[t].rules), e.components[t].rules2 && n[t].ruler2.enableOnly(e.components[t].rules2);
    }), this;
  }, jT.prototype.enable = function (e, t) {
    var n = [];
    Array.isArray(e) || (e = [e]), ["core", "block", "inline"].forEach(function (t) {
      n = n.concat(this[t].ruler.enable(e, !0));
    }, this), n = n.concat(this.inline.ruler2.enable(e, !0));
    var r = e.filter(function (e) {
      return n.indexOf(e) < 0;
    });
    if (r.length && !t) throw new Error("MarkdownIt. Failed to enable unknown rule(s): " + r);
    return this;
  }, jT.prototype.disable = function (e, t) {
    var n = [];
    Array.isArray(e) || (e = [e]), ["core", "block", "inline"].forEach(function (t) {
      n = n.concat(this[t].ruler.disable(e, !0));
    }, this), n = n.concat(this.inline.ruler2.disable(e, !0));
    var r = e.filter(function (e) {
      return n.indexOf(e) < 0;
    });
    if (r.length && !t) throw new Error("MarkdownIt. Failed to disable unknown rule(s): " + r);
    return this;
  }, jT.prototype.use = function (e) {
    var t = [this].concat(Array.prototype.slice.call(arguments, 1));
    return e.apply(e, t), this;
  }, jT.prototype.parse = function (e, t) {
    if ("string" != typeof e) throw new Error("Input data should be a String");
    var n = new this.core.State(e, this, t);
    return this.core.process(n), n.tokens;
  }, jT.prototype.render = function (e, t) {
    return t = t || {}, this.renderer.render(this.parse(e, t), this.options, t);
  }, jT.prototype.parseInline = function (e, t) {
    var n = new this.core.State(e, this, t);
    return n.inlineMode = !0, this.core.process(n), n.tokens;
  }, jT.prototype.renderInline = function (e, t) {
    return t = t || {}, this.renderer.render(this.parseInline(e, t), this.options, t);
  };
  var ET = jT;
  !function (e) {
    e.exports = ET;
  }(bj);

  var _T = new (Gf(bj.exports))({
    html: !0
  });

  function TT(e) {
    return yj.sanitize(_T.renderInline(e));
  }

  function ST(e) {
    var t = e.words,
        n = e.answers;

    var r = function r(e) {
      return F["default"](z["default"]("id", e), t);
    };

    return s.jsx(vh, {
      as: "ol",
      m: 0,
      reset: !0,
      children: n.map(function (e, t, n) {
        var o = e.is_correct,
            i = r(e.word_id),
            a = o ? i : r(e.matched_word_id);
        return s.jsx(fe, {
          mb: [3, null, 4],
          pb: [3, null, 4],
          borderBottom: "2px solid",
          borderColor: t === n.length - 1 ? "transparent" : "gray200",
          children: s.jsxs(ys, {
            as: "li",
            display: "flex",
            children: [s.jsx(fe, {
              mr: 2,
              width: ["1rem", null, "1.5rem"],
              children: s.jsxs(ys, {
                fontWeight: "700",
                fontSize: [0, null, 1],
                children: [t + 1, "."]
              })
            }), s.jsxs(fe, {
              flex: "1",
              children: [s.jsx(ys, {
                dangerouslySetInnerHTML: {
                  __html: TT(i.definition)
                }
              }), s.jsxs(fe, {
                bg: o ? "green50" : "red100",
                borderRadius: "rounded",
                display: "inline-block",
                mt: 3,
                mr: 3,
                py: 2,
                px: 3,
                children: [s.jsx(ys, {
                  as: "span",
                  fontWeight: "600",
                  pr: 2,
                  children: a.content
                }), s.jsx(mc, {
                  weight: "regular",
                  color: o ? "green700" : "red500",
                  icon: o ? "check" : "times"
                })]
              }), !o && s.jsxs(ys, {
                mt: 3,
                children: ["Correct answer:", " ", s.jsx(ys, {
                  as: "span",
                  fontWeight: "600",
                  color: "green700",
                  children: i.content
                })]
              })]
            })]
          })
        }, e.id);
      })
    });
  }

  function LT(e) {
    var t = e.task;
    var n = t.words;
    return s.jsx(vh, {
      as: "ol",
      m: 0,
      reset: !0,
      children: n.map(function (e, t, n) {
        return s.jsx(fe, {
          mb: [3, null, 4],
          pb: [3, null, 4],
          borderBottom: "2px solid",
          borderColor: t === n.length - 1 ? "transparent" : "gray200",
          children: s.jsxs(ys, {
            as: "li",
            display: "flex",
            children: [s.jsx(fe, {
              mr: 2,
              width: ["1rem", null, "1.5rem"],
              children: s.jsxs(ys, {
                fontWeight: "700",
                fontSize: [0, null, 1],
                children: [t + 1, "."]
              })
            }), s.jsxs(fe, {
              flex: "1",
              children: [s.jsx(ys, {
                dangerouslySetInnerHTML: {
                  __html: TT(e.definition)
                }
              }), s.jsxs(fe, {
                bg: "green50",
                borderRadius: "rounded",
                display: "inline-block",
                mt: 3,
                mr: 3,
                py: 2,
                px: 3,
                children: [s.jsx(ys, {
                  as: "span",
                  fontWeight: "600",
                  pr: 2,
                  children: e.content
                }), s.jsx(mc, {
                  weight: "regular",
                  color: "green700",
                  icon: "check"
                })]
              })]
            })]
          })
        }, e.id);
      })
    });
  }

  ST.propTypes = {
    words: aM.words.isRequired,
    answers: T["default"].arrayOf(T["default"].shape({
      word_id: T["default"].number,
      matched_word_id: T["default"].number,
      is_correct: T["default"].bool
    })).isRequired
  }, LT.propTypes = {
    task: T["default"].shape(aM).isRequired
  };

  var DT = function DT(e) {
    var t = e.children;
    return s.jsxs(fe, {
      as: "span",
      bg: "green50",
      display: "inline-block",
      px: 2,
      borderRadius: "rounded",
      children: [t, s.jsx(mc, {
        icon: "check",
        color: "green700",
        display: "inline-block",
        ml: 2
      })]
    });
  };

  DT.propTypes = {
    children: T["default"].node.isRequired
  };

  var AT = function AT(e) {
    var t = e.children;
    return s.jsxs(fe, {
      as: "span",
      bg: "red50",
      display: "inline-block",
      px: 2,
      mr: 2,
      borderRadius: "rounded",
      children: [t, s.jsx(mc, {
        icon: "times",
        color: "red500",
        display: "inline-block",
        ml: 2
      })]
    });
  };

  AT.propTypes = {
    children: T["default"].node.isRequired
  };

  var NT = [".", ",", "?", "!", ":", ";", "…"],
      IT = function IT(e) {
    return G["default"](e, NT);
  },
      zT = function zT(e) {
    return G["default"](e.substring(0, 1), NT);
  },
      OT = $["default"]("type", "fragment"),
      RT = W["default"]({
    content: function content(e) {
      return TT(e);
    }
  }),
      PT = W["default"]({
    type: Z["default"]("fragment"),
    content: function content(e) {
      return e.substring(0, 1);
    }
  }),
      FT = W["default"]({
    type: Z["default"]("text"),
    content: function content(e) {
      return TT(e.substring(1));
    }
  }),
      BT = function BT(e) {
    return A["default"]([[IT, function () {
      return OT(e);
    }], [zT, function () {
      return function (e) {
        return [PT(e), FT(e)];
      }(e);
    }], [H["default"], function () {
      return RT(e);
    }]])(e.content);
  },
      qT = /(\r\n|\n)/gm,
      UT = function UT(e) {
    return e.map(function (e) {
      return e.content.includes("\n") ? e.content.split(qT).filter(Boolean).map(function (e) {
        return e.includes("\n") ? {
          type: "lineBreak"
        } : {
          type: "text",
          content: e
        };
      }) : e;
    }).flat();
  };

  function VT(e) {
    var t = e.paragraphs,
        n = e.blankRenderer;

    function r(e, t) {
      switch (e.type) {
        case "text":
          return function (e, t) {
            return s.jsx(o.Fragment, {
              children: s.jsx(ys, {
                as: "span",
                dangerouslySetInnerHTML: {
                  __html: e.content
                }
              })
            }, t);
          }(e, t);

        case "blank":
          return n(e, t);

        case "lineBreak":
          return function (e, t) {
            return s.jsx(o.Fragment, {
              children: s.jsx("br", {})
            }, t);
          }(0, t);
      }

      return !0;
    }

    return t.map(function (e, t, n) {
      return s.jsx(fe, {
        mb: t === q["default"](n.length) ? [0, 0, 0] : [3, null, 4],
        pb: [3, null, 4],
        borderBottom: "2px solid",
        borderColor: t === q["default"](n.length) ? "transparent" : "gray300",
        children: s.jsx(ys, {
          as: "li",
          children: s.jsxs(fe, {
            display: "flex",
            children: [n.length > 1 && s.jsxs(ys, {
              as: "span",
              fontWeight: "700",
              mr: 2,
              children: [R["default"](t), "."]
            }), s.jsxs(fe, {
              as: "span",
              width: "100%",
              children: [(o = e.elements, UT(o).map(function (e) {
                return "text" === e.type ? BT(e) : e;
              }).flat().reduce(function (e, t, n, r) {
                return "blank" === t.type && r[R["default"](n)] && "fragment" === r[R["default"](n)].type ? V["default"](U["default"](t, {
                  id: t.id,
                  fragment: r[R["default"](n)].content
                }), e) : "fragment" === t.type ? e : V["default"](t, e);
              }, [])).map(r), e.audio_url && s.jsx(fe, {
                mt: 4,
                mb: 2,
                p: 2,
                pr: 3,
                borderRadius: "10rem",
                bg: "gray100",
                children: s.jsx(Jp, {
                  src: e.audio_url
                })
              })]
            })]
          })
        })
      }, e.id);
      var o;
    });
  }

  function HT(e) {
    var t = e.task;
    var n = t.paragraphs;
    return s.jsx(vh, {
      as: "ol",
      m: 0,
      lineHeight: "double",
      reset: !0,
      children: VT({
        paragraphs: n,
        blankRenderer: function blankRenderer(e, t) {
          var n = e.content,
              r = e.fragment;
          return s.jsxs(o.Fragment, {
            children: [s.jsx(DT, {
              children: n
            }), r && r]
          }, t);
        }
      })
    });
  }

  function ZT(e) {
    var t = e.paragraphs,
        n = e.answers;
    return s.jsx(vh, {
      as: "ol",
      m: 0,
      lineHeight: "double",
      reset: !0,
      children: VT({
        paragraphs: t,
        blankRenderer: function blankRenderer(e) {
          var _F$default = F["default"](z["default"]("element_id", e.id), n),
              t = _F$default.id,
              r = _F$default.content,
              i = _F$default.is_correct,
              a = _F$default.correct_answer,
              l = e.fragment;

          return i ? s.jsxs(o.Fragment, {
            children: [s.jsx(DT, {
              children: a
            }), l && l]
          }, t) : s.jsxs(ys, {
            as: "span",
            children: [s.jsx(AT, {
              children: r
            }), s.jsx(ys, {
              as: "span",
              color: "green700",
              children: s.jsx("em", {
                children: a
              })
            }), l]
          }, t);
        }
      })
    });
  }

  HT.propTypes = {
    task: T["default"].shape({
      paragraphs: T["default"].arrayOf(T["default"].shape({
        content: T["default"].string.isRequired,
        type: T["default"].string.isRequired
      })).isRequired
    }).isRequired
  }, ZT.propTypes = {
    paragraphs: T["default"].arrayOf(T["default"].shape({
      id: T["default"].number,
      audio_url: T["default"].string,
      image_url: T["default"].string,
      image_type: T["default"].string,
      elements: T["default"].arrayOf(T["default"].shape({
        id: T["default"].string,
        previous_answer: T["default"].string,
        correct: T["default"].bool,
        content: T["default"].string,
        type: T["default"].string
      }))
    })).isRequired,
    answers: T["default"].arrayOf(T["default"].shape({
      id: T["default"].string,
      givenAnswer: T["default"].string,
      isCorrect: T["default"].bool,
      correctAnswer: T["default"].string
    })).isRequired
  };

  var WT = _["default"](fe).withConfig({
    displayName: "Results__SetBold700",
    componentId: "sc-1rncxpd-0"
  })(["strong{font-weight:700;}"]);

  function $T(e) {
    var t = e.answers;
    return s.jsx(o.Fragment, {
      children: s.jsx(vh, {
        as: "ol",
        m: 0,
        reset: !0,
        children: t.map(function (e, t, n) {
          var r = e.is_correct,
              o = e.correct_answer,
              i = e.given_answer,
              a = e.question;
          return s.jsx(fe, {
            mb: [3, null, 4],
            pb: [3, null, 4],
            borderBottom: "2px solid",
            borderColor: t === n.length - 1 ? "transparent" : "gray200",
            children: s.jsxs(ys, {
              as: "li",
              display: "flex",
              children: [s.jsx(fe, {
                mr: 2,
                width: ["1rem", null, "1.5rem"],
                children: s.jsxs(ys, {
                  fontWeight: "700",
                  fontSize: [0, null, 1],
                  children: [t + 1, "."]
                })
              }), s.jsxs(fe, {
                flex: "1",
                children: [a.image_url && !a.audio_url && s.jsx(he, {
                  src: a.image_url,
                  alt: "",
                  maxWidth: "100%",
                  maxHeight: "10rem",
                  borderRadius: "rounded",
                  display: "block",
                  mb: 3
                }), a.audio_url && !a.image_url && s.jsx(fe, {
                  mb: 3,
                  children: s.jsx(Kp, {
                    src: a.audio_url
                  })
                }), a.content && s.jsx(WT, {
                  children: s.jsx(ys, {
                    fontSize: [0, null, 1],
                    mb: 3,
                    dangerouslySetInnerHTML: {
                      __html: TT(a.content)
                    }
                  })
                }), s.jsxs(fe, {
                  mt: 3,
                  display: "flex",
                  alignItems: "center",
                  children: [s.jsx(fe, {
                    size: "1.5rem",
                    borderRadius: "circular",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bg: r ? "green500" : "red500",
                    mr: 2,
                    children: s.jsx(mc, {
                      icon: r ? "check" : "times",
                      color: "white",
                      position: "relative",
                      top: "1px"
                    })
                  }), s.jsx(ys, {
                    fontSize: [0, null, 1],
                    width: "calc(100% - 2rem)",
                    display: "inline-block",
                    dangerouslySetInnerHTML: {
                      __html: TT(i.content)
                    }
                  })]
                }), !r && s.jsxs(fe, {
                  mt: 2,
                  display: "flex",
                  children: [s.jsx(fe, {
                    size: "1.5rem",
                    borderRadius: "circular",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bg: "green500",
                    mr: 2,
                    children: s.jsx(mc, {
                      icon: "check",
                      color: "white",
                      position: "relative",
                      top: "1px"
                    })
                  }), s.jsx(ys, {
                    fontSize: [0, null, 1],
                    color: "green700",
                    fontWeight: "600",
                    display: "inline-block",
                    width: "calc(100% - 2rem)",
                    dangerouslySetInnerHTML: {
                      __html: TT(o.content)
                    }
                  })]
                })]
              })]
            })
          }, o.id);
        })
      })
    });
  }

  $T.propTypes = {
    answers: T["default"].arrayOf(T["default"].shape({
      is_correct: T["default"].bool,
      correct_answer: T["default"].shape({
        id: T["default"].number,
        content: T["default"].string
      }),
      given_answer: T["default"].shape({
        id: T["default"].number,
        content: T["default"].string
      }),
      question: T["default"].shape({
        id: T["default"].number.isRequired,
        content: T["default"].string.isRequired,
        answer_form: T["default"].string,
        reference_task: T["default"].shape(oM),
        image_url: T["default"].string,
        image_caption: T["default"].string,
        image_alt_text: T["default"].string
      })
    })).isRequired
  };

  var GT = _["default"](fe).withConfig({
    displayName: "AnswerKey__SetBold700",
    componentId: "sc-f8iobl-0"
  })(["strong{font-weight:700;}"]);

  function YT(e) {
    var t = e.task;
    var n = t.questions;
    return s.jsx(o.Fragment, {
      children: s.jsx(vh, {
        as: "ol",
        m: 0,
        reset: !0,
        children: n.map(function (e, t, n) {
          var r = e.answers.filter(function (e) {
            return e.correct;
          })[0];
          return s.jsx(fe, {
            mb: [3, null, 4],
            pb: [3, null, 4],
            borderBottom: "2px solid",
            borderColor: t === n.length - 1 ? "transparent" : "gray200",
            children: s.jsxs(ys, {
              as: "li",
              display: "flex",
              children: [s.jsx(fe, {
                mr: 2,
                width: ["1rem", null, "1.5rem"],
                children: s.jsxs(ys, {
                  fontWeight: "700",
                  fontSize: [0, null, 1],
                  children: [t + 1, "."]
                })
              }), s.jsxs(fe, {
                flex: "1",
                children: [e.image_url && !e.audio_url && s.jsx(he, {
                  src: e.image_url,
                  alt: "",
                  maxWidth: "100%",
                  maxHeight: "10rem",
                  borderRadius: "rounded",
                  display: "block",
                  mb: 3
                }), e.audio_url && !e.image_url && s.jsx(fe, {
                  mb: 3,
                  children: s.jsx(Kp, {
                    src: e.audio_url
                  })
                }), e.content && s.jsx(GT, {
                  children: s.jsx(ys, {
                    fontSize: [0, null, 1],
                    mb: 3,
                    dangerouslySetInnerHTML: {
                      __html: TT(e.content)
                    }
                  })
                }), s.jsxs(fe, {
                  mt: 3,
                  display: "flex",
                  children: [s.jsx(fe, {
                    size: "1.5rem",
                    borderRadius: "circular",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bg: "green500",
                    mr: 2,
                    children: s.jsx(mc, {
                      icon: "check",
                      color: "white",
                      position: "relative",
                      top: "1px"
                    })
                  }), s.jsx(ys, {
                    fontSize: [0, null, 1],
                    width: "calc(100% - 2rem)",
                    display: "inline-block",
                    dangerouslySetInnerHTML: {
                      __html: TT(r.content)
                    }
                  })]
                })]
              })]
            })
          }, e.id);
        })
      })
    });
  }

  YT.propTypes = {
    task: T["default"].shape(lM).isRequired
  };

  var QT = n.variant({
    variants: {
      success: {
        bg: "green50",
        borderColor: "green50"
      },
      danger: {
        bg: "red50",
        borderColor: "red50"
      }
    }
  }),
      XT = _["default"](fe).attrs(function () {
    return {
      bg: "gray150",
      borderColor: "gray150",
      borderRadius: "rounded",
      flex: 1,
      px: [2, null, 3],
      py: [1, null, 2],
      position: "relative"
    };
  }).withConfig({
    displayName: "Bubble",
    componentId: "sc-1i8l78i-0"
  })(["", " .drag-helper &{background-color:", ";border-color:", ";}&:after{content:'';position:absolute;top:0.5rem;left:-0.5rem;width:0;height:0;border-top:0.5rem solid transparent;border-bottom:0.5rem solid transparent;border-right:0.5rem solid;border-right-color:inherit;}", ""], QT, function (e) {
    var t = e.theme;
    return t.colors.yellow500;
  }, function (e) {
    var t = e.theme;
    return t.colors.yellow500;
  }, wc.md(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n    &:after {\n      top: 1rem;\n    }\n  "])))),
      KT = _["default"](Jh).withConfig({
    displayName: "Headshot__StyledCoverImage",
    componentId: "sc-1jh9zau-0"
  })([".drag-helper &{box-shadow:", ";}"], function (e) {
    var t = e.theme;
    return "0 0 0 3px ".concat(t.colors.white, ", 0 0 0 6px ").concat(t.colors.yellow500, ";");
  });

  function JT(e) {
    var t = e.src,
        n = e.name,
        r = e.withName,
        o = e.size,
        i = _objectWithoutProperties(e, _excluded157);

    return s.jsxs(fe, _objectSpread(_objectSpread({
      textAlign: "center"
    }, i), {}, {
      children: [s.jsx(KT, {
        src: t,
        alt: "Avatar for ".concat(n),
        size: o,
        display: "inline-block"
      }), r && s.jsx(ys, {
        mt: 2,
        fontWeight: "600",
        textAlign: "center",
        children: n
      })]
    }));
  }

  function eS(e) {
    var t = e.correct;
    var n = t ? "green500" : "red500",
        r = t ? "check" : "times";
    return s.jsx(fe, {
      position: "absolute",
      right: "-0.35rem",
      top: "-0.65rem",
      bg: n,
      color: "white",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "circular",
      height: "1.25rem",
      width: "1.25rem",
      fontSize: 0,
      children: s.jsx(mc, {
        icon: r,
        display: "inline-block",
        mt: "2px"
      })
    });
  }

  function tS(e) {
    var t = e.answers,
        n = e.bubbles;
    return s.jsx(o.Fragment, {
      children: s.jsx(vh, {
        as: "ol",
        m: 0,
        reset: !0,
        children: t.map(function (e, t) {
          var r = e.given_answer,
              o = e.correct_answer,
              i = e.is_correct,
              a = (l = r.id, F["default"](z["default"]("id", l), n));
          var l;
          return s.jsx(fe, {
            pb: [3, null, 4],
            children: s.jsxs(ys, {
              as: "li",
              display: "flex",
              children: [s.jsx(fe, {
                mr: 2,
                width: ["1rem", null, "1.5rem"],
                children: s.jsxs(ys, {
                  fontWeight: "700",
                  fontSize: [0, null, 1],
                  children: [t + 1, "."]
                })
              }), s.jsx(JT, {
                src: a.headshot.icon_url,
                name: a.headshot.name,
                size: ["2.25rem", null, "3rem"],
                mr: 3
              }), s.jsxs(fe, {
                children: [s.jsxs(XT, {
                  variant: i ? "success" : "danger",
                  children: [s.jsx(eS, {
                    correct: i
                  }), s.jsx(ys, {
                    fontWeight: "600",
                    fontSize: [0, 1],
                    children: a.headshot.name
                  }), s.jsx(ys, {
                    fontSize: [0, 1],
                    mt: 0,
                    dangerouslySetInnerHTML: {
                      __html: TT(a.content)
                    }
                  })]
                }), !i && s.jsxs(fe, {
                  pt: [2, null, 3],
                  children: ["Correct position:", " ", s.jsxs(ys, {
                    fontWeight: "600",
                    color: "green700",
                    display: "inline-block",
                    children: ["#", o.position]
                  })]
                })]
              })]
            })
          }, a.id);
        })
      })
    });
  }

  function nS(e) {
    var t = e.task;
    var n = t.bubbles;
    return s.jsx(vh, {
      as: "ol",
      m: 0,
      reset: !0,
      children: n.map(function (e, t) {
        return s.jsx(fe, {
          pb: [3, null, 4],
          children: s.jsxs(ys, {
            as: "li",
            display: "flex",
            children: [s.jsx(fe, {
              mr: 2,
              width: ["1rem", null, "1.5rem"],
              children: s.jsxs(ys, {
                fontWeight: "700",
                fontSize: [0, null, 1],
                children: [t + 1, "."]
              })
            }), s.jsx(JT, {
              src: e.headshot.icon_url,
              name: e.headshot.name,
              size: ["2.25rem", null, "3rem"],
              mr: 3
            }), s.jsx(fe, {
              children: s.jsxs(XT, {
                variant: "success",
                children: [s.jsx(eS, {
                  correct: !0
                }), s.jsx(ys, {
                  fontWeight: "600",
                  fontSize: [0, 1],
                  children: e.headshot.name
                }), s.jsx(ys, {
                  fontSize: [0, 1],
                  mt: 0,
                  dangerouslySetInnerHTML: {
                    __html: TT(e.content)
                  }
                })]
              })
            })]
          })
        }, e.id);
      })
    });
  }

  function rS(e) {
    var t = e.audioURL,
        n = e.borderColor,
        r = e.index,
        o = e.imageURL,
        i = e.correct,
        a = e.givenAnswer,
        l = e.correctAnswer;
    return s.jsx(fe, {
      mb: [3, null, 4],
      pb: [3, null, 4],
      borderBottom: "2px solid",
      borderColor: n,
      children: s.jsxs(ys, {
        as: "li",
        display: "flex",
        children: [s.jsx(fe, {
          mr: 2,
          width: ["1rem", null, "1.5rem"],
          children: s.jsxs(ys, {
            fontWeight: "700",
            fontSize: [0, null, 1],
            children: [r + 1, "."]
          })
        }), s.jsxs(fe, {
          flex: "1",
          position: "relative",
          children: [t && s.jsx(fe, {
            position: "absolute",
            right: 0,
            children: s.jsx(Kp, {
              src: t
            })
          }), o && s.jsx(he, {
            src: o,
            alt: "",
            maxWidth: "100%",
            maxHeight: "10rem",
            borderRadius: "rounded",
            display: "block",
            mb: 4
          }), s.jsxs(fe, {
            mt: 3,
            display: "flex",
            children: [s.jsx(fe, {
              size: "1.5rem",
              borderRadius: "circular",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              bg: i ? "green500" : "red500",
              mr: 2,
              children: s.jsx(mc, {
                icon: i ? "check" : "times",
                color: "white",
                position: "relative",
                top: "1px"
              })
            }), s.jsx(ys, {
              fontSize: [0, null, 1],
              width: "calc(100% - 2rem)",
              display: "inline-block",
              children: "".concat(a)
            })]
          }), !i && s.jsxs(fe, {
            mt: 2,
            display: "flex",
            children: [s.jsx(fe, {
              size: "1.5rem",
              borderRadius: "circular",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              bg: "green500",
              mr: 2,
              children: s.jsx(mc, {
                icon: "check",
                color: "white",
                position: "relative",
                top: "1px"
              })
            }), s.jsx(ys, {
              fontSize: [0, null, 1],
              color: "green700",
              fontWeight: "600",
              display: "inline-block",
              width: "calc(100% - 2rem)",
              children: "".concat(l)
            })]
          })]
        })]
      })
    });
  }

  function oS(e) {
    var t = e.answers,
        n = e.images;
    return s.jsx(vh, {
      as: "ol",
      m: 0,
      reset: !0,
      children: t.map(function (e, t, r) {
        var o = e.word_id,
            i = e.given_answer,
            a = e.correct_answer,
            l = e.is_correct,
            c = F["default"](z["default"]("id", o), n);
        return s.jsx(rS, {
          borderColor: t === r.length - 1 ? "transparent" : "gray200",
          index: t,
          correct: l,
          givenAnswer: i,
          correctAnswer: a,
          imageURL: c.image_url,
          audioURL: c.audio_url
        }, c.id);
      })
    });
  }

  function iS(e) {
    var t = e.borderColor,
        n = e.index,
        r = e.image;
    return s.jsx(fe, {
      mb: [3, null, 4],
      pb: [3, null, 4],
      borderBottom: "2px solid",
      borderColor: t,
      children: s.jsxs(ys, {
        as: "li",
        display: "flex",
        children: [s.jsx(fe, {
          mr: 2,
          width: ["1rem", null, "1.5rem"],
          children: s.jsxs(ys, {
            fontWeight: "700",
            fontSize: [0, null, 1],
            children: [n + 1, "."]
          })
        }), s.jsxs(fe, {
          flex: "1",
          position: "relative",
          children: [r.audio_url && s.jsx(fe, {
            position: "absolute",
            right: 0,
            children: s.jsx(Kp, {
              src: r.audio_url
            })
          }), r.image_url && s.jsx(he, {
            src: r.image_url,
            alt: "",
            maxWidth: "100%",
            maxHeight: "10rem",
            borderRadius: "rounded",
            display: "block",
            mb: 4
          }), s.jsxs(fe, {
            mt: 3,
            display: "flex",
            children: [s.jsx(fe, {
              size: "1.5rem",
              borderRadius: "circular",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              bg: "green500",
              mr: 2,
              children: s.jsx(mc, {
                icon: "check",
                color: "white",
                position: "relative",
                top: "1px"
              })
            }), s.jsx(ys, {
              fontSize: [0, null, 1],
              width: "calc(100% - 2rem)",
              display: "inline-block",
              children: r.content
            })]
          })]
        })]
      })
    });
  }

  function aS(e) {
    var t = e.task;
    var n = t.images;
    return s.jsx(o.Fragment, {
      children: s.jsx(vh, {
        as: "ol",
        m: 0,
        reset: !0,
        children: n.map(function (e, t, n) {
          return s.jsx(iS, {
            borderColor: t === n.length - 1 ? "transparent" : "gray200",
            index: t,
            image: e
          }, e.id);
        })
      })
    });
  }

  JT.defaultProps = {
    withName: !1
  }, JT.propTypes = {
    src: T["default"].string.isRequired,
    name: T["default"].string.isRequired,
    withName: T["default"].bool,
    size: T["default"].arrayOf(T["default"].string).isRequired
  }, eS.propTypes = {
    correct: T["default"].bool.isRequired
  }, tS.propTypes = {
    answers: T["default"].arrayOf(T["default"].shape({
      is_correct: T["default"].bool,
      correct_answer: T["default"].shape({
        id: T["default"].number,
        position: T["default"].number
      }),
      given_answer: T["default"].shape({
        id: T["default"].number,
        position: T["default"].number
      })
    })).isRequired,
    bubbles: dM.bubbles.isRequired
  }, nS.propTypes = {
    task: T["default"].shape(dM).isRequired
  }, rS.propTypes = {
    index: T["default"].number.isRequired,
    borderColor: T["default"].string,
    word: T["default"].shape({
      audio_url: T["default"].string,
      image_url: T["default"].string,
      content: T["default"].string.isRequired
    }).isRequired,
    correct: T["default"].bool.isRequired,
    givenAnswer: T["default"].string.isRequired,
    audioURL: T["default"].string.isRequired,
    imageURL: T["default"].string.isRequired,
    correctAnswer: T["default"].string.isRequired
  }, rS.defaultProps = {
    borderColor: "gray200"
  }, oS.propTypes = {
    answers: T["default"].arrayOf(T["default"].shape({
      word_id: T["default"].number,
      is_correct: T["default"].bool,
      correct_answer: T["default"].string,
      given_answer: T["default"].string
    })).isRequired,
    images: sM.images.isRequired
  }, iS.propTypes = {
    index: T["default"].number.isRequired,
    borderColor: T["default"].string,
    image: T["default"].shape({
      audio_url: T["default"].string,
      image_url: T["default"].string,
      content: T["default"].string.isRequired
    }).isRequired
  }, iS.defaultProps = {
    borderColor: "gray200"
  }, aS.propTypes = {
    task: T["default"].shape(sM).isRequired
  };

  var sS = n.variant({
    variants: {
      success: {
        bg: "green50",
        borderColor: "green50"
      },
      danger: {
        bg: "red50",
        borderColor: "red50"
      }
    }
  }),
      lS = _["default"](fe).attrs(function () {
    return {
      bg: "gray150",
      borderColor: "gray150",
      borderRadius: "rounded",
      flex: 1,
      px: [2, null, 3],
      py: [1, null, 2],
      position: "relative"
    };
  }).withConfig({
    displayName: "Sentence",
    componentId: "sc-n2fm59-0"
  })(["", " .drag-helper &{background-color:", ";border-color:", ";}"], sS, function (e) {
    var t = e.theme;
    return t.colors.yellow500;
  }, function (e) {
    var t = e.theme;
    return t.colors.yellow500;
  });

  function cS(e) {
    var t = e.answers,
        n = e.sentences;
    return s.jsx(vh, {
      as: "ol",
      m: 0,
      reset: !0,
      children: t.map(function (e, t) {
        var r = e.given_answer,
            o = e.correct_answer,
            i = e.is_correct;
        return s.jsx(fe, {
          pb: [3, null, 4],
          children: s.jsxs(ys, {
            as: "li",
            display: "flex",
            children: [s.jsx(fe, {
              mr: 2,
              width: ["1rem", null, "1.5rem"],
              children: s.jsxs(ys, {
                fontWeight: "700",
                fontSize: [0, null, 1],
                children: [t + 1, "."]
              })
            }), s.jsxs(fe, {
              children: [s.jsxs(lS, {
                variant: i ? "success" : "danger",
                children: [s.jsx(eS, {
                  correct: i
                }), s.jsx(ys, {
                  fontSize: [0, 1],
                  mt: 0,
                  dangerouslySetInnerHTML: {
                    __html: TT((a = r.id, F["default"](z["default"]("id", a), n).content))
                  }
                })]
              }), !i && s.jsxs(fe, {
                pt: [2, null, 3],
                children: ["Correct position:", " ", s.jsxs(ys, {
                  fontWeight: "600",
                  color: "green700",
                  display: "inline-block",
                  children: ["#", o.position]
                })]
              })]
            })]
          })
        }, o.id);
        var a;
      })
    });
  }

  function uS(e) {
    var t = e.task;
    var n = t.sentences;
    return s.jsx(vh, {
      as: "ol",
      m: 0,
      reset: !0,
      children: n.map(function (e, t) {
        return s.jsx(fe, {
          pb: [3, null, 4],
          children: s.jsxs(ys, {
            as: "li",
            display: "flex",
            children: [s.jsx(fe, {
              mr: 2,
              width: ["1rem", null, "1.5rem"],
              children: s.jsxs(ys, {
                fontWeight: "700",
                fontSize: [0, null, 1],
                children: [t + 1, "."]
              })
            }), s.jsx(fe, {
              children: s.jsxs(lS, {
                variant: "correct",
                children: [s.jsx(eS, {
                  correct: !0
                }), s.jsx(ys, {
                  fontSize: [0, 1],
                  mt: 0,
                  dangerouslySetInnerHTML: {
                    __html: TT(e.content)
                  }
                })]
              })
            })]
          })
        }, e.id);
      })
    });
  }

  function dS(e) {
    var t = e.task;
    var n = t.statements;
    return s.jsx(vh, {
      as: "ol",
      m: 0,
      reset: !0,
      children: n.map(function (e, t, n) {
        return s.jsx(fe, {
          mb: [3, null, 4],
          pb: [3, null, 4],
          borderBottom: "2px solid",
          borderColor: t === n.length + 1 ? "transparent" : "gray200",
          children: s.jsxs(ys, {
            as: "li",
            display: "flex",
            children: [s.jsx(fe, {
              mr: 2,
              width: ["1rem", null, "1.5rem"],
              children: s.jsxs(ys, {
                fontWeight: "700",
                fontSize: [0, null, 1],
                children: [t + 1, "."]
              })
            }), s.jsxs(fe, {
              flex: "1",
              children: [s.jsx(ys, {
                fontSize: [0, null, 1],
                dangerouslySetInnerHTML: {
                  __html: TT(e.content)
                }
              }), s.jsxs(fe, {
                mt: 3,
                children: [s.jsx(fe, {
                  size: "1.5rem",
                  borderRadius: "circular",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  bg: e.correct ? "green500" : "red500",
                  mr: 2,
                  children: s.jsx(mc, {
                    icon: e.correct ? "check" : "times",
                    color: "white"
                  })
                }), s.jsx(ys, {
                  fontSize: [0, null, 1],
                  width: "calc(100% - 2rem)",
                  display: "inline-block",
                  children: s.jsx(ys, {
                    as: "span",
                    fontWeight: "600",
                    children: e.correct ? "True" : "False"
                  })
                })]
              })]
            })]
          })
        }, e.id);
      })
    });
  }

  function fS(e) {
    var t = e.answers,
        n = e.statements;
    return s.jsx(o.Fragment, {
      children: s.jsx(vh, {
        as: "ol",
        m: 0,
        reset: !0,
        children: n.map(function (e, n, r) {
          var o = e.correct,
              _ref105 = F["default"](z["default"]("statement_id", e.id), t) || {},
              i = _ref105.assertion,
              a = e.content,
              l = o === i,
              c = void 0 === i;

          return s.jsx(fe, {
            mb: [3, null, 4],
            pb: [3, null, 4],
            borderBottom: "2px solid",
            borderColor: n === r.length - 1 ? "transparent" : "gray200",
            children: s.jsxs(ys, {
              as: "li",
              display: "flex",
              children: [s.jsx(fe, {
                mr: 2,
                width: ["1rem", null, "1.5rem"],
                children: s.jsxs(ys, {
                  fontWeight: "700",
                  fontSize: [0, null, 1],
                  children: [n + 1, "."]
                })
              }), s.jsxs(fe, {
                flex: "1",
                children: [s.jsx(ys, {
                  fontSize: [0, null, 1],
                  dangerouslySetInnerHTML: {
                    __html: TT(a)
                  }
                }), s.jsxs(fe, {
                  mt: 3,
                  display: "flex",
                  alignItems: "center",
                  children: [s.jsx(fe, {
                    size: "1.5rem",
                    borderRadius: "circular",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bg: l ? "green500" : "red500",
                    mr: 2,
                    children: s.jsx(mc, {
                      icon: l ? "check" : "times",
                      color: "white"
                    })
                  }), s.jsx(ys, {
                    fontSize: [0, null, 1],
                    width: "calc(100% - 2rem)",
                    display: "inline-block",
                    children: c ? "Answer not found" : s.jsxs(s.Fragment, {
                      children: ["You answered:", " ", s.jsx(ys, {
                        as: "span",
                        fontWeight: "600",
                        dangerouslySetInnerHTML: {
                          __html: TT(String(i))
                        }
                      })]
                    })
                  })]
                }), !l && s.jsxs(fe, {
                  mt: 2,
                  display: "flex",
                  alignItems: "center",
                  children: [s.jsx(fe, {
                    size: "1.5rem",
                    borderRadius: "circular",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bg: "green500",
                    mr: 2,
                    children: s.jsx(mc, {
                      icon: "check",
                      color: "white"
                    })
                  }), s.jsxs(ys, {
                    fontSize: [0, null, 1],
                    width: "calc(100% - 2rem)",
                    display: "inline-block",
                    children: ["Correct answer:", " ", s.jsx(ys, {
                      as: "span",
                      fontWeight: "600",
                      dangerouslySetInnerHTML: {
                        __html: TT(String(o))
                      }
                    })]
                  })]
                })]
              })]
            })
          }, e.id);
        })
      })
    });
  }

  function pS(e) {
    var t = e.answers;
    return s.jsxs(fe, {
      mt: 3,
      p: 3,
      bg: "gray100",
      borderRadius: "rounded",
      children: [s.jsx(mc, {
        icon: "lightbulb",
        pr: 2
      }), s.jsx(ys, {
        fontSize: [0, null, 1],
        width: "calc(100% - 2rem)",
        fontWeight: "600",
        display: "inline-block",
        children: 1 === t.length ? "Suggested Answer" : "Suggested Answers"
      }), t.map(function (e) {
        return s.jsx(ys, {
          mt: 3,
          fontSize: 0,
          width: "calc(100% - 2rem)",
          display: "inline-block",
          dangerouslySetInnerHTML: {
            __html: TT(e.content)
          }
        }, e.id);
      })]
    });
  }

  cS.propTypes = {
    answers: T["default"].arrayOf(T["default"].shape({
      word_id: T["default"].number,
      is_correct: T["default"].bool,
      correct_answer: T["default"].shape({
        id: T["default"].number,
        position: T["default"].number
      }),
      given_answer: T["default"].shape({
        id: T["default"].number,
        position: T["default"].number
      })
    })).isRequired,
    sentences: uM.sentences.isRequired
  }, uS.propTypes = {
    task: T["default"].shape(uM).isRequired
  }, dS.propTypes = {
    task: T["default"].shape(cM).isRequired
  }, fS.propTypes = {
    answers: T["default"].arrayOf(T["default"].shape({
      id: T["default"].number,
      assertion: T["default"].oneOfType([T["default"].string, T["default"].bool])
    })).isRequired,
    statements: T["default"].arrayOf(T["default"].shape({
      content: T["default"].string,
      correct: T["default"].bool,
      id: T["default"].number,
      reference_task: T["default"].object
    })).isRequired
  };
  var hS = T["default"].shape({
    content: T["default"].string.isRequired,
    created_at: T["default"].string,
    id: T["default"].number,
    question_id: T["default"].number,
    updated_at: T["default"].string
  });

  function mS(e) {
    var t = e.task;
    var n = t.questions;
    return s.jsx(s.Fragment, {
      children: s.jsx(vh, {
        as: "ol",
        m: 0,
        reset: !0,
        children: n.map(function (e, t, n) {
          return s.jsx(fe, {
            mb: [3, null, 4],
            pb: [3, null, 4],
            borderBottom: "2px solid",
            borderColor: t === n.length - 1 ? "transparent" : "gray200",
            children: s.jsxs(ys, {
              as: "li",
              display: "flex",
              children: [s.jsx(fe, {
                mr: 2,
                width: ["1rem", null, "1.5rem"],
                children: s.jsxs(ys, {
                  fontWeight: "700",
                  fontSize: [0, null, 1],
                  children: [t + 1, "."]
                })
              }), s.jsxs(fe, {
                flex: "1",
                children: [s.jsx(ys, {
                  fontSize: [0, null, 1],
                  mb: 3,
                  dangerouslySetInnerHTML: {
                    __html: TT(e.content)
                  }
                }), !Y["default"](e.suggested_answers) && s.jsx(pS, {
                  answers: e.suggested_answers
                })]
              })]
            })
          }, e.id);
        })
      })
    });
  }

  function gS(e) {
    var t = e.task;
    var n = t.questions;
    return s.jsx(vh, {
      as: "ol",
      m: 0,
      reset: !0,
      children: n.map(function (e, t, n) {
        return s.jsx(fe, {
          mb: [3, null, 4],
          pb: [3, null, 4],
          borderBottom: "2px solid",
          borderColor: t === n.length - 1 ? "transparent" : "gray200",
          children: s.jsxs(ys, {
            as: "li",
            display: "flex",
            children: [s.jsx(fe, {
              mr: 2,
              width: ["1rem", null, "1.5rem"],
              children: s.jsxs(ys, {
                fontWeight: "600",
                fontSize: [0, null, 1],
                children: [t + 1, "."]
              })
            }), s.jsxs(fe, {
              flex: "1",
              children: [s.jsx(ys, {
                fontSize: [0, null, 1],
                mb: 3,
                dangerouslySetInnerHTML: {
                  __html: TT(e.content)
                }
              }), !Y["default"](e.suggested_answers) && s.jsx(pS, {
                answers: e.suggested_answers
              })]
            })]
          })
        }, e.id);
      })
    });
  }

  pS.propTypes = {
    answers: T["default"].arrayOf(hS).isRequired
  }, mS.propTypes = {
    task: T["default"].shape(fM).isRequired
  }, gS.propTypes = {
    task: T["default"].shape({
      questions: T["default"].arrayOf(T["default"].shape({
        content: T["default"].string.isRequired,
        id: T["default"].number.isRequired,
        suggested_answers: T["default"].arrayOf(T["default"].shape({
          content: T["default"].string.isRequired,
          id: T["default"].number.isRequired
        })).isRequired
      }).isRequired).isRequired
    }).isRequired
  }, e.AnimatedColumns = Qc, e.AnimatedColumnsContainer = Gc, e.Audio = Wp, e.BR = ee, e.BaseChip = Vh, e.BlockClicks = Ah, e.Book = cu, e.Box = fe, e.Bubble = XT, e.Button = js, e.Carousel = Fh, e.Checkbox = sd, e.CheckboxControl = ad, e.Chip = Hh, e.ChoiceChips = Zh, e.Col = $c, e.Collapsible = km, e.Columns = Wc, e.Computer = Gu, e.Container = Zc, e.ContextualActionBar = Kh, e.CorrectWrapper = DT, e.CoverImage = Jh, e.Dialog = Dy, e.Drawer = _b, e.DropdownMenu = tw, e.Ear = du, e.Eye = pu, e.FA = dh, e.FatLoadingSpinner = Hf, e.FatSpinner = iu, e.FlashcardSetTaskIcon = mu, e.FlashcardsIcon = bu, e.GlobalStyle = KC, e.HR = pe, e.Heading = gh, e.Headshot = JT, e.HiddenInput = td, e.Hovercard = bw, e.Icon = mc, e.IconButton = Tc, e.Image = he, e.ImageMatchingAnswerKey = hM, e.ImageMatchingCard = xu, e.ImageMatchingResults = mM, e.IncorrectWrapper = AT, e.Input = gd, e.InputWrapper = pd, e.Keyboard = ku, e.Label = Dh, e.LevelBars = xw, e.Link = bh, e.List = vh, e.ListenAndTypeAnswerKey = HT, e.ListenAndTypeResults = ZT, e.LoadWithSuspense = Ew, e.Loading = ww, e.LoadingButton = Fc, e.LoadingOverlay = kw, e.LoadingPlane = jw, e.LoadingSpinner = Pc, e.MatchingAnswerKey = LT, e.MatchingCard = Cu, e.MatchingResults = ST, e.MonoButton = Ts, e.MoreOptions = Tw, e.MotionBox = hs, e.MultipleChoiceAnswerKey = YT, e.MultipleChoiceResults = $T, e.MultipleHands = Ku, e.NumberPicker = xd, e.NumberedList = ju, e.OpenEndedQuestionsAnswerKey = mS, e.Options = Eu, e.Pagination = Sw, e.PaperPlane = Tu, e.PaperPlaneAlt = Lu, e.PaperPlaneVertical = Au, e.Pause = au, e.Pencil = Iu, e.PieChart = Dw, e.Play = su, e.Popover = Kw, e.Presentation = Ou, e.ProgressBar = Jw, e.PutInOrder = Pu, e.PutInOrderAnswerKey = nS, e.PutInOrderResults = tS, e.Radio = Md, e.RadioControl = Cd, e.Range = _d, e.ResultsImage = pM, e.SSOButton = Dc, e.SSOButtonLight = zc, e.SeeAndSpellAnswerKey = aS, e.SeeAndSpellResults = oS, e.Select = Ld, e.SelectUI = Sd, e.Sentence = lS, e.Separator = dk, e.SequencingAnswerKey = uS, e.SequencingResults = cS, e.SidebarBody = eu, e.SidebarButton = Xc, e.SidebarGrid = tu, e.SidebarItem = ou, e.SidebarWrapper = Jc, e.SimpleAudio = Kp, e.SimpleInput = Dd, e.Skeleton = nh, e.SliderInput = Pf, e.SoloSpeechBubble = Uu, e.SpeakingAnswerKey = gS, e.SpeechBubbles = Bu, e.StarsRating = Uf, e.Sun = Hu, e.Svg = ms, e.SwitchInput = Rd, e.TaskAudio = Jp, e.TaskAudioConsumer = function (e) {
    var t = o.useContext(eh);
    return t ? I["default"].createPortal(s.jsx(Jp, _objectSpread({}, e)), t) : null;
  }, e.TaskAudioProvider = th, e.Text = ys, e.Textarea = Id, e.TitleBar = jC, e.Toaster = ch, e.TogglePillsGroup = MC, e.Tooltip = YC, e.TransparentButton = Ss, e.Transport = XC, e.TrueOrFalseAnswerKey = dS, e.TrueOrFalseResults = fS, e.TwoHands = ed, e.Video = bs, e.WritingPencil = Qu, e.YesNo = Wu, e.YumiBasic = Vc, e.checkIfIOS = Zf, e.disabledOpacity = vs, e.fadeIn = function (e) {
    return t.css(["animation:", " ", " forwards 1 linear;"], e, Q);
  }, e.getColorWithOpacity = Ip, e.getSizeByAspectRatio = gu, e.highlight = function (e, n) {
    return t.css(["animation:", " 1s ease-out;"], function (e, n) {
      return t.keyframes(["0%{background-color:", ";}100{background-color:", ";}"], e || "red", n || "white");
    }(e, n));
  }, e.inputIconWidth = ld, e.inputStyles = cd, e.linearSpin = K, e.media = wc, e.mediaQueries = kc, e.pulse = function (e) {
    return t.css(["animation:", " ", " infinite;"], J, e);
  }, e.rawBreakpoints = Cc, e.renderAnswerParagraphs = VT, e.shouldForwardProp = se, e.theme = gc, e.tooltipDelayDuration = 200, e.useToast = function () {
    return o.useContext(lh);
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});